import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Custom scalar for exact decimal values
   * Maps to DECIMAL(14,10) in the database
   */
  Decimal: { input: string; output: string; }
  /** Int64 represents a 64-bit integer */
  Int64: { input: number; output: number; }
  /** Custom scalar for raw JSON values */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /**
   * Custom scalar a type that can either be a string containing an integer or an integer.
   * Empty strings are treated as zero.
   */
  StringInt: { input: number; output: number; }
  /** Time represents a timestamp */
  Time: { input: Date; output: Date; }
  /** Upload represents a file upload request */
  Upload: { input: globalThis.File; output: globalThis.File; }
};

/**
 * The categories of referenced pages that may be automatically appended to a
 * generated ACORD form's PDF.
 */
export enum AcordAppendType {
  /** Additional insured endorsement pages. */
  AdditionalInsuredEndorsements = 'ADDITIONAL_INSURED_ENDORSEMENTS',
  /** Additional interest and loss payee pages. */
  AdditionalInterestsLossPayees = 'ADDITIONAL_INTERESTS_LOSS_PAYEES',
  /** Declaration pages and schedules. */
  DeclarationPagesAndSchedules = 'DECLARATION_PAGES_AND_SCHEDULES',
  /** Never append any referenced pages. */
  NeverAppend = 'NEVER_APPEND',
  /** Other referenced endorsement pages. */
  OtherReferencedEndorsements = 'OTHER_REFERENCED_ENDORSEMENTS',
  /** Waiver of subrogation endorsement pages. */
  WaiverOfSubrogation = 'WAIVER_OF_SUBROGATION'
}

/** The set of append categories enabled for a single ACORD form. */
export type AcordFormAppendRule = {
  __typename?: 'ACORDFormAppendRule';
  /** The categories of pages to automatically append for this form. */
  appendTypes: Array<AcordAppendType>;
  /** The ACORD form these append categories apply to. */
  formType: AcordFormType;
};

/** Input for the set of append categories enabled for a single ACORD form. */
export type AcordFormAppendRuleInput = {
  /** The categories of pages to automatically append for this form. */
  appendTypes: Array<AcordAppendType>;
  /** The ACORD form these append categories apply to. */
  formType: AcordFormType;
};

/**
 * Agency-level configuration governing ACORD COI/EOI/ID-card generation.
 *
 * Each agency is seeded with the current default configuration. Scalar fields may
 * be null and then resolve to Cara's current default; null or empty list fields
 * mean the agency has configured no append rules or prompt rules. Use the
 * descriptionOfOperationsMode EMPTY enum value (not null) to intentionally leave
 * the DOO box blank.
 */
export type AcordFormConfiguration = {
  __typename?: 'ACORDFormConfiguration';
  /**
   * Per-form automatic PDF page-append rules. Null or an empty list means the
   * agency has configured no append rules.
   */
  appendRules?: Maybe<Array<AcordFormAppendRule>>;
  /**
   * How the Description of Operations box on ACORD 25 and ACORD 30 is populated.
   * Null means use the Cara default.
   */
  descriptionOfOperationsMode?: Maybe<DescriptionOfOperationsMode>;
  /** Base64-encoded agency logo stamped on ACORD 50 ID cards, if any. */
  idCardLogoBase64Data?: Maybe<Scalars['String']['output']>;
  /** How limit-box numbers are formatted. Null means use the Cara default. */
  numberFormat?: Maybe<AcordNumberFormat>;
  /**
   * Where producer person/contact fields on model-filled ACORD forms come from.
   * Null means use the Cara default (configured Producer Information).
   */
  producerInformationSource?: Maybe<AcordProducerInformationSource>;
  /**
   *   Ordered, section-scoped rules injected into ACORD prompts at generation time.
   * Null or an empty list means the agency has configured no rules.
   */
  rules?: Maybe<Array<AcordFormRule>>;
};

/**
 * Input for an agency's ACORD COI/EOI configuration overrides. Scalar fields are
 * overrides: a null scalar resets that setting to the Cara default rather than
 * clearing it. The list fields are agency-owned and are written in full
 * (replace-all); ordering is taken from array position. Send null for
 * descriptionOfOperationsMode or numberFormat to revert to the default, EMPTY
 * (for DOO) to intentionally leave the box blank, or null/an empty list for
 * rules/appendRules to configure no rules. Preset list values are copied to each
 * agency when it is created and are not re-injected.
 */
export type AcordFormConfigurationInput = {
  /**
   * Per-form automatic PDF page-append rules. Null or an empty list configures no
   * append rules. Preset rules are seeded when the agency is created and are not
   * re-injected.
   */
  appendRules?: InputMaybe<Array<AcordFormAppendRuleInput>>;
  /**
   * How the Description of Operations box on ACORD 25 and ACORD 30 is populated.
   * Null reverts to the Cara default.
   */
  descriptionOfOperationsMode?: InputMaybe<DescriptionOfOperationsMode>;
  /** Base64-encoded agency logo stamped on ACORD 50 ID cards, if any. */
  idCardLogoBase64Data?: InputMaybe<Scalars['String']['input']>;
  /** How limit-box numbers are formatted. Null reverts to the Cara default. */
  numberFormat?: InputMaybe<AcordNumberFormat>;
  /**
   * Where producer person/contact fields on model-filled ACORD forms come from.
   * Null reverts to the Cara default (configured Producer Information).
   */
  producerInformationSource?: InputMaybe<AcordProducerInformationSource>;
  /**
   * Ordered, section-scoped rules injected into ACORD prompts at generation time.
   * Null or an empty list configures no rules. Preset rules are seeded when the
   * agency is created and are not re-injected.
   */
  rules?: InputMaybe<Array<AcordFormRuleInput>>;
};

/**
 * A single section-scoped rule in the rules engine. The condition describes when
 * the rule applies; the phrasing is the exact text Cara injects, supporting
 * [[placeholder]]-style interpolation for values the model fills in.
 */
export type AcordFormRule = {
  __typename?: 'ACORDFormRule';
  /** Plain-language description of when the rule applies. */
  condition: Scalars['String']['output'];
  /** The ACORD form this rule applies to. */
  formType: AcordFormType;
  /** Unique identifier for the rule. */
  id: Scalars['ID']['output'];
  /** Whether this rule was pre-populated from current prompt language. */
  isPreset: Scalars['Boolean']['output'];
  /** The exact phrasing Cara injects, with optional [[placeholder]] slots. */
  phrasing: Scalars['String']['output'];
  /**
   * The section of the form this rule is scoped to. Null for a form-level rule on
   * a form that has no scoped sections (e.g. ACORD 28). When present, the section
   * must belong to formType.
   */
  section?: Maybe<AcordFormSection>;
};

/**
 * Input for a single section-scoped rule. Omit id to create a new rule; the
 * server assigns one. The isPreset flag is server-owned and preserved by id.
 */
export type AcordFormRuleInput = {
  /** Plain-language description of when the rule applies. */
  condition: Scalars['String']['input'];
  /** The ACORD form this rule applies to. */
  formType: AcordFormType;
  /** Unique identifier for the rule. Omit to create a new rule. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The exact phrasing Cara injects, with optional [[placeholder]] slots. */
  phrasing: Scalars['String']['input'];
  /**
   * The section of the form this rule is scoped to. Omit for a form-level rule on
   * a form that has no scoped sections (e.g. ACORD 28). When present, the section
   * must belong to formType.
   */
  section?: InputMaybe<AcordFormSection>;
};

/**
 * A section of an ACORD form that a rule can be scoped to. ACORD 28 has no
 * scoped sections in this release.
 */
export enum AcordFormSection {
  /** The location description box on ACORD 24. */
  Acord_24LocationDescription = 'ACORD_24_LOCATION_DESCRIPTION',
  /** The special conditions box on ACORD 24. */
  Acord_24SpecialConditions = 'ACORD_24_SPECIAL_CONDITIONS',
  /** The Description of Operations box on ACORD 25. */
  Acord_25DescriptionOfOperations = 'ACORD_25_DESCRIPTION_OF_OPERATIONS',
  /** The coverage information box on ACORD 27. */
  Acord_27CoverageInformation = 'ACORD_27_COVERAGE_INFORMATION',
  /** The property information box on ACORD 27. */
  Acord_27PropertyInformation = 'ACORD_27_PROPERTY_INFORMATION',
  /** The remarks box on ACORD 27. */
  Acord_27Remarks = 'ACORD_27_REMARKS',
  /**
   * The Description of Operations box on ACORD 30. Governed by the same
   * descriptionOfOperationsMode as ACORD 25.
   */
  Acord_30DescriptionOfOperations = 'ACORD_30_DESCRIPTION_OF_OPERATIONS'
}

/** The ACORD forms that the agency-level COI/EOI configuration applies to. */
export enum AcordFormType {
  /** ACORD 24 - Certificate of Property Insurance */
  Acord_24 = 'ACORD_24',
  /** ACORD 25 - Certificate of Liability Insurance */
  Acord_25 = 'ACORD_25',
  /** ACORD 27 - Evidence of Property Insurance */
  Acord_27 = 'ACORD_27',
  /** ACORD 28 - Evidence of Commercial Property Insurance */
  Acord_28 = 'ACORD_28',
  /** ACORD 30 - Certificate of Insurance for garage businesses */
  Acord_30 = 'ACORD_30'
}

/** How numbers are formatted inside limit boxes on ACORD 24, 25, 27, and 28. */
export enum AcordNumberFormat {
  /** Format limit amounts with comma thousands separators (e.g. 1,000,000). */
  Commas = 'COMMAS',
  /** Format limit amounts without separators (e.g. 1000000). */
  NoCommas = 'NO_COMMAS'
}

/** Where producer person/contact fields on model-filled ACORD forms come from. */
export enum AcordProducerInformationSource {
  /**
   * Allow Cara to fill the producer/authorized-representative name and producer
   * contact fields from workspace instructions. The agency firm name and address
   * always come from configured Producer Information. When instructions omit a
   * producer field, the current workspace user is the name/email fallback.
   */
  CaraFromInstructions = 'CARA_FROM_INSTRUCTIONS',
  /**
   * Use the applicable agency- or user-level configured Producer Information (or
   * liability COI fallback).
   */
  ConfiguredDefault = 'CONFIGURED_DEFAULT'
}

/** AMS360Configuration contains configuration for the AMS360 integration */
export type Ams360Configuration = {
  __typename?: 'AMS360Configuration';
  /** AMS360 Agency Number */
  agencyNo: Scalars['String']['output'];
  /** AMS360 App Access to Agency Key for authentication */
  appAccessToAgencyKey: Scalars['String']['output'];
  /** AMS360 App Key for authentication */
  appKey: Scalars['String']['output'];
  /**
   * When a synced task has no due date, the suspense due date is this many business days
   * after the sync time (weekends skipped). Defaults to 3 when unset.
   */
  defaultTaskDueBusinessDays?: Maybe<Scalars['Int']['output']>;
  /**
   * If enabled, will sync accounts from Cara to AMS360. When disabled, Cara will not create
   * tasks or notes for clients that don't already exist in AMS360.
   */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync calls from Cara to AMS360 as activities. */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to AMS360 as suspenses. */
  enableSyncTasks: Scalars['Boolean']['output'];
  /**
   * Determines who suspenses (tasks) created from calls are assigned to. Defaults to
   * ACCOUNT_EXECUTIVE (the historical behavior) when unset.
   */
  taskAssignmentMethod?: Maybe<Ams360TaskAssignmentMethod>;
};

/** The method to use to assign suspenses (tasks) created in AMS360 from calls */
export enum Ams360TaskAssignmentMethod {
  /**
   * Assign to the account CSR (the policy's CSR), i.e. the account manager shown at the
   * top of the AMS360 account summary.
   */
  AccountCsr = 'ACCOUNT_CSR',
  /**
   * Assign to the account executive (the policy's executive code). This is the default
   * and matches the historical behavior.
   */
  AccountExecutive = 'ACCOUNT_EXECUTIVE'
}

/**
 * An account represents a customer of an agency. They represent either an individual or a business.
 * An agency can have a contact with multiple accounts.
 */
export type Account = {
  __typename?: 'Account';
  /** Businesses owned or operated by this account. */
  account: AccountDetails;
  /** The agency that manages this account. */
  agency: Agency;
  /** Active insurance policies held by this account. */
  businessPolicies: Array<BusinessPolicy>;
  /** Certificates of liability insurance held by this account. */
  certificatesOfLiabilityInsurance: Array<CertificateOfLiabilityInsurance>;
  /** Contacts associated with this account. */
  contacts: Array<AccountContact>;
  /** When the account record was created. */
  createdAt: Scalars['Time']['output'];
  /** Files associated with this account. */
  files: Array<File>;
  /** Unique identifier for the account. */
  id: Scalars['ID']['output'];
  /** Service requests submitted by this account. */
  serviceRequests: Array<ServiceRequest>;
  /** The type of account - either a business or individual account. */
  type: AccountType;
  /** When the account record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type AccountContact = {
  __typename?: 'AccountContact';
  /** Accounts associated with this contact */
  accounts: Array<Account>;
  /** When the contact record was created. */
  createdAt: Scalars['Time']['output'];
  /** The contact's email address */
  email: Scalars['String']['output'];
  /** Unique identifier for the contact */
  id: Scalars['ID']['output'];
  /** The contact's name */
  name: Scalars['String']['output'];
  /** The contact's phone number */
  phone: Scalars['String']['output'];
  /** When the contact record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

/** Interface defining the common fields required for both business and individual accounts */
export type AccountDetails = {
  /** Primary email address for contacting the account holder */
  email: Scalars['String']['output'];
  /** Mailing address for the account holder */
  mailingAddress: Address;
  /** The full name of the account holder - either legal business name or individual's name */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the account holder */
  phone: Scalars['String']['output'];
};

/** The type of account - either a business or individual account. */
export enum AccountType {
  /** Account represents a business entity */
  Business = 'BUSINESS',
  /** Account represents an individual person */
  Individual = 'INDIVIDUAL'
}

/** Account user represents an authenticated user of an account */
export type AccountUser = {
  __typename?: 'AccountUser';
  /** The account this user is associated with */
  accounts: Array<Account>;
  /** When the account user was created */
  createdAt: Scalars['Time']['output'];
  /** Email of the account user */
  email: Scalars['String']['output'];
  /** Unique identifier for the account user */
  id: Scalars['ID']['output'];
  /** Name of the account user */
  name: Scalars['String']['output'];
  /** When the account user was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Response from the account user sign in mutation */
export type AccountUserSignInResponse = {
  __typename?: 'AccountUserSignInResponse';
  /** The account user that was signed in */
  accountUser: AccountUser;
};

/**
 * Actions that can be performed on resources.
 * These are the operations that can be permitted or restricted. These must be combined with a resource
 * to form a valid permission (and only certain combinations are validated, documented in api/auth/permissions.go).
 */
export enum Action {
  /** Assign a resource to a user */
  Assign = 'ASSIGN',
  /** Cancel an operation or policy */
  Cancel = 'CANCEL',
  /** Create a new resource */
  Create = 'CREATE',
  /** Delete a resource */
  Delete = 'DELETE',
  /** Disable an active resource */
  Disable = 'DISABLE',
  /** Enable a disabled resource */
  Enable = 'ENABLE',
  /** List multiple resources */
  List = 'LIST',
  /** Read/view a resource */
  Read = 'READ',
  /** Reinstate a canceled policy */
  Reinstate = 'REINSTATE',
  /** Renew a policy or subscription */
  Renew = 'RENEW',
  /** Resolve a request or issue */
  Resolve = 'RESOLVE',
  /** Send mail through a resource */
  Send = 'SEND',
  /** Share a resource with another agency */
  Share = 'SHARE',
  /** Sign in to a system */
  SignIn = 'SIGN_IN',
  /** Sign out of a system */
  SignOut = 'SIGN_OUT',
  /** Synchronize with external system */
  Sync = 'SYNC',
  /** Update an existing resource */
  Update = 'UPDATE',
  /** Upload a file or data */
  Upload = 'UPLOAD'
}

/** Details for a request to add an additional insured to a policy */
export type AddAdditionalInsuredRequest = {
  __typename?: 'AddAdditionalInsuredRequest';
  /** Address of the additional insured */
  address: Address;
  /** Name of the additional insured */
  name: Scalars['String']['output'];
  /** Relationship between the policyholder and additional insured */
  relationship: Scalars['String']['output'];
};

/** Input type for adding an additional insured request */
export type AddAdditionalInsuredRequestInput = {
  /** Address of the additional insured */
  address: AddressInput;
  /** Name of the additional insured */
  name: Scalars['String']['input'];
  /** Relationship between the policyholder and additional insured */
  relationship: Scalars['String']['input'];
};

/** Input type for adding a comment to a service request */
export type AddServiceRequestCommentInput = {
  /** The content of the comment */
  content: Scalars['String']['input'];
};

/** Describes an address that can be accepted as input */
export type Address = {
  __typename?: 'Address';
  /**
   *  Level 3 administrative division depending on country. For example, this is
   * the city in the U.S., a muncipality in Austria, a ward in Singapore, etc.
   */
  city: Scalars['String']['output'];
  /** First line of the address. */
  line1: Scalars['String']['output'];
  /** Optional second line of the address. */
  line2?: Maybe<Scalars['String']['output']>;
  /**
   *  Country-specific mailing identifier, e.g. ZIP Code in the U.S., Post Code
   * in the U.K., etc.
   */
  postalCode: Scalars['String']['output'];
  /**
   *  Level 2 administrative division depending on country. For example, this is
   * the county in the U.S., prefectural city in China, division in India, etc.
   */
  subZone?: Maybe<Scalars['String']['output']>;
  /**
   *  Level 1 administrative division depending on country. For example, this is
   * the state in the U.S., the province in Canada, etc.
   */
  zone: Scalars['String']['output'];
};

/** Describes an address that can be accepted as input */
export type AddressInput = {
  /**
   *  Level 3 administrative division depending on country. For example, this is
   * the city in the U.S., a muncipality in Austria, a ward in Singapore, etc.
   */
  city: Scalars['String']['input'];
  /** First line of the address. */
  line1: Scalars['String']['input'];
  /** Optional second line of the address. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /**
   *  Country-specific mailing identifier, e.g. ZIP Code in the U.S., Post Code
   * in the U.K., etc.
   */
  postalCode: Scalars['String']['input'];
  /**
   *  Level 2 administrative division depending on country. For example, this is
   * the county in the U.S., prefectural city in China, division in India, etc.
   */
  subZone?: InputMaybe<Scalars['String']['input']>;
  /**
   *  Level 1 administrative division depending on country. For example, this is
   * the state in the U.S., the province in Canada, etc.
   */
  zone: Scalars['String']['input'];
};

/** Input for creating a new version of a workflow execution with adjusted inputs */
export type AdjustWorkflowInputsInput = {
  /** The inputs to replace in the new version */
  inputs: Array<CreateWorkflowInputEntry>;
};

/**
 * One non-disabled seat with binary outcomes for whether they performed each
 * tracked action within the fixed active window (see AdminAnalyticsTotals.activeDefinition).
 * Note: createdArtifact implies usedWorkspace, since artifacts are produced inside
 * workspaces and keyed on the workspace creation time.
 */
export type AdminAnalyticsActiveUser = {
  __typename?: 'AdminAnalyticsActiveUser';
  /** Uploaded at least one document to the knowledge base in the active window. */
  addedToKnowledgeBase: Scalars['Boolean']['output'];
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  /** Produced a tracked artifact (filled template / generated form or doc) in the active window. */
  createdArtifact: Scalars['Boolean']['output'];
  /** True when the user performed any activating action (workspace or email). */
  isActive: Scalars['Boolean']['output'];
  lastActivityAt?: Maybe<Scalars['Time']['output']>;
  /** Had a sign-in code generated within the active window (self-service or admin-generated). */
  loggedIn: Scalars['Boolean']['output'];
  /** Sent inbound email to Cara in the active window. */
  usedEmail: Scalars['Boolean']['output'];
  /** Created or used a workspace in the active window. */
  usedWorkspace: Scalars['Boolean']['output'];
};

export type AdminAnalyticsActivityBucket = {
  __typename?: 'AdminAnalyticsActivityBucket';
  activityType: AdminAnalyticsActivityType;
  count: Scalars['Int']['output'];
  periodStart: Scalars['Time']['output'];
};

export type AdminAnalyticsActivityLeader = {
  __typename?: 'AdminAnalyticsActivityLeader';
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type AdminAnalyticsActivityLeaderboard = {
  __typename?: 'AdminAnalyticsActivityLeaderboard';
  activity: AdminAnalyticsActivityType;
  leaders: Array<AdminAnalyticsActivityLeader>;
  /**
   * Optional finer-grained breakdown of this activity (e.g. workspace types for
   * the WORKSPACE activity). Empty for activities without sub-types. Sorted by
   * total descending so the UI can offer a "filter by type" dropdown.
   */
  segments: Array<AdminAnalyticsActivityLeaderboardSegment>;
  total: Scalars['Int']['output'];
};

/**
 * One sub-type slice of an activity leaderboard (e.g. a single workspace type),
 * with its own per-user top list.
 */
export type AdminAnalyticsActivityLeaderboardSegment = {
  __typename?: 'AdminAnalyticsActivityLeaderboardSegment';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  leaders: Array<AdminAnalyticsActivityLeader>;
  total: Scalars['Int']['output'];
};

/**
 * Two-dimensional activity matrix: users (rows) × workspace presets and
 * template types (columns). Powers the per-user usage heatmap below the
 * "Active users" section.
 */
export type AdminAnalyticsActivityMatrix = {
  __typename?: 'AdminAnalyticsActivityMatrix';
  /**
   * Percentage change in total matrix activity (all users) for the second half of
   * the filtered range vs the first half. Same semantics as row activityDeltaPct.
   */
  activityDeltaPct?: Maybe<Scalars['Int']['output']>;
  /** One row per user with non-zero activity, sorted by descending totalActivities. */
  rows: Array<AdminAnalyticsActivityMatrixRow>;
  /** Template/form-type columns in display order. */
  templateTypes: Array<AdminAnalyticsActivityMatrixDimension>;
  /** Workspace-preset columns in display order. */
  workspacePresets: Array<AdminAnalyticsActivityMatrixDimension>;
};

export type AdminAnalyticsActivityMatrixDimension = {
  __typename?: 'AdminAnalyticsActivityMatrixDimension';
  /** Stable enum-style key (e.g. workspace preset code, template type). */
  key: Scalars['String']['output'];
  /** Human-readable label for the column header. */
  label: Scalars['String']['output'];
};

export type AdminAnalyticsActivityMatrixRow = {
  __typename?: 'AdminAnalyticsActivityMatrixRow';
  /** Percentage change in activities compared to the prior half of the filtered range, if any. */
  activityDeltaPct?: Maybe<Scalars['Int']['output']>;
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  /**
   * Average number of USER-role messages per workspace for this team member
   * across workspaces created in the filter window. 0 when the user has no
   * workspaces in the window or when WORKSPACE activity is masked.
   */
  avgUserMessagesPerWorkspace: Scalars['Float']['output'];
  /** Counts parallel to AdminAnalyticsActivityMatrix.templateTypes. */
  templateTypeCounts: Array<Scalars['Int']['output']>;
  /** Sum of all workspace-preset and template-type counts for this user. */
  totalActivities: Scalars['Int']['output'];
  /** Counts parallel to AdminAnalyticsActivityMatrix.workspacePresets. */
  workspacePresetCounts: Array<Scalars['Int']['output']>;
};

/** Activity categories shown in the admin analytics dashboard. */
export enum AdminAnalyticsActivityType {
  Call = 'CALL',
  Email = 'EMAIL',
  KnowledgeBaseUpload = 'KNOWLEDGE_BASE_UPLOAD',
  Workspace = 'WORKSPACE'
}

export type AdminAnalyticsDateRange = {
  __typename?: 'AdminAnalyticsDateRange';
  after?: Maybe<Scalars['Time']['output']>;
  before?: Maybe<Scalars['Time']['output']>;
};

export type AdminAnalyticsFilterInput = {
  /** Filter activity charts to selected activity categories. */
  activityTypes?: InputMaybe<Array<AdminAnalyticsActivityType>>;
  /** Filter user-attributed activity to a single agency user. */
  agencyUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Group activity over time by day or week. Defaults to WEEK. */
  granularity?: InputMaybe<AdminAnalyticsGranularity>;
  /**
   * When true, aggregate the parent organization and all direct child subagencies.
   * Defaults to false (parent-only). Ignored when subagencyId is set.
   */
  includeAllSubagencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter analytics to activities that occurred in this range. */
  occurredAt?: InputMaybe<DateFilter>;
  /**
   * When set, scope analytics to this direct child subagency.
   * Must be a child of the caller's organization (from_agency_id = org, to_agency_id = this id).
   * Mutually exclusive with includeAllSubagencies.
   */
  subagencyId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter workspace analytics to a workspace preset. */
  workspacePreset?: InputMaybe<Scalars['String']['input']>;
};

/** Time grouping used for activity charts. */
export enum AdminAnalyticsGranularity {
  Day = 'DAY',
  Week = 'WEEK'
}

/** A labelled histogram bucket (e.g. "1-5 tool calls" → 12 workspaces). */
export type AdminAnalyticsHistogramBucket = {
  __typename?: 'AdminAnalyticsHistogramBucket';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/**
 * Illustrative incremental revenue attributable to Cara above baseline close rate.
 * Per-client logistic close likelihood is computed server-side; multiply
 * expectedIncrementalAccounts by avg account premium and commissionRate on the
 * client to convert into agency revenue dollars.
 */
export type AdminAnalyticsIncrementalRevenue = {
  __typename?: 'AdminAnalyticsIncrementalRevenue';
  /** Average incremental close likelihood across workspace clients (excludes tickets). */
  avgCloseLikelihood: Scalars['Float']['output'];
  /**
   * Distinct clients (normalized client tag) with positive quote/renewal engagement
   * in the filter window. Null-tagged workspaces each count as their own client.
   */
  clientsConsidered: Scalars['Int']['output'];
  /**
   * Share of policy premium booked as agency revenue (commission). Fixed backend
   * assumption used to convert modeled incremental premium into revenue; not
   * user-configurable.
   */
  commissionRate: Scalars['Float']['output'];
  /**
   * Sum of modeled incremental close probabilities across clients and unlinked
   * quote-request tickets (fractional accounts, e.g. 2.4 = ~2–3 expected new accounts).
   * Premium and commission assumptions are per account, not per underlying policy.
   */
  expectedIncrementalAccounts: Scalars['Float']['output'];
};

export type AdminAnalyticsKbSearchPerUser = {
  __typename?: 'AdminAnalyticsKBSearchPerUser';
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  searchCount: Scalars['Int']['output'];
};

/**
 * Knowledge-base search-tool usage in the filter window. Surfaces how often
 * the team actually queries the KB, not just how often they upload to it.
 */
export type AdminAnalyticsKbSearchUsage = {
  __typename?: 'AdminAnalyticsKBSearchUsage';
  /** Per-user breakdown sorted by descending search count. */
  perUser: Array<AdminAnalyticsKbSearchPerUser>;
  /** Distinct users who ran at least one KB search. */
  searcherCount: Scalars['Int']['output'];
  /** Total number of SEARCH_KNOWLEDGE_BASE tool invocations. */
  totalSearches: Scalars['Int']['output'];
};

/**
 * Net knowledge base document count at the end of each reporting period,
 * computed using created_at / deleted_at so the line decreases when docs are removed.
 */
export type AdminAnalyticsKbSnapshot = {
  __typename?: 'AdminAnalyticsKBSnapshot';
  documentCount: Scalars['Int']['output'];
  periodStart: Scalars['Time']['output'];
};

export type AdminAnalyticsKnowledgeBaseUpload = {
  __typename?: 'AdminAnalyticsKnowledgeBaseUpload';
  agencyUserId?: Maybe<Scalars['ID']['output']>;
  agencyUserName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  documentTitle: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
};

export type AdminAnalyticsReport = {
  __typename?: 'AdminAnalyticsReport';
  activeUsers: Array<AdminAnalyticsActiveUser>;
  /** Per-activity totals and top users for the filter window (workspaces, emails, KB uploads). */
  activityLeaderboards: Array<AdminAnalyticsActivityLeaderboard>;
  activityMatrix: AdminAnalyticsActivityMatrix;
  activityOverTime: Array<AdminAnalyticsActivityBucket>;
  dateRange: AdminAnalyticsDateRange;
  generatedAt: Scalars['Time']['output'];
  incrementalRevenue: AdminAnalyticsIncrementalRevenue;
  kbDocumentHistory: Array<AdminAnalyticsKbSnapshot>;
  kbSearchUsage: AdminAnalyticsKbSearchUsage;
  knowledgeBaseUploads: Array<AdminAnalyticsKnowledgeBaseUpload>;
  templateBreakdown: Array<AdminAnalyticsTemplateBreakdown>;
  templateLibrary: AdminAnalyticsTemplateLibrary;
  timeSavings: AdminAnalyticsTimeSavings;
  toolBreakdown: Array<AdminAnalyticsToolBreakdown>;
  totals: AdminAnalyticsTotals;
  userUsage: Array<AdminAnalyticsUserUsage>;
  workspaceBreakdown: Array<AdminAnalyticsWorkspaceBreakdown>;
  workspaceStats: AdminAnalyticsWorkspaceStats;
};

export type AdminAnalyticsTemplateBreakdown = {
  __typename?: 'AdminAnalyticsTemplateBreakdown';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
};

/** Counts of active (non-archived) templates saved in the agency library. */
export type AdminAnalyticsTemplateLibrary = {
  __typename?: 'AdminAnalyticsTemplateLibrary';
  customFormCount: Scalars['Int']['output'];
  htmlTemplateCount: Scalars['Int']['output'];
  wordTemplateCount: Scalars['Int']['output'];
};

/** Server-computed estimated time saved for the filter window. */
export type AdminAnalyticsTimeSavings = {
  __typename?: 'AdminAnalyticsTimeSavings';
  breakdown: Array<AdminAnalyticsTimeSavingsBreakdown>;
  totalMinutes: Scalars['Int']['output'];
};

export type AdminAnalyticsTimeSavingsBreakdown = {
  __typename?: 'AdminAnalyticsTimeSavingsBreakdown';
  activityCount: Scalars['Int']['output'];
  category: AdminAnalyticsTimeSavingsCategory;
  label: Scalars['String']['output'];
  minutes: Scalars['Int']['output'];
};

/** Category used in the estimated time-saved breakdown. */
export enum AdminAnalyticsTimeSavingsCategory {
  Call = 'CALL',
  Email = 'EMAIL',
  Workspace = 'WORKSPACE'
}

/** Workspace tool invocation counts aggregated from plan stage events. */
export type AdminAnalyticsToolBreakdown = {
  __typename?: 'AdminAnalyticsToolBreakdown';
  count: Scalars['Int']['output'];
  /** Human-readable label for display in the admin dashboard. */
  label: Scalars['String']['output'];
  /**
   * CaraWorkspaceTool enum string when known, otherwise the raw typeString
   * recorded by the LLM (e.g. dynamic FILL_TEMPLATE_* names).
   */
  toolType: Scalars['String']['output'];
};

export type AdminAnalyticsTotals = {
  __typename?: 'AdminAnalyticsTotals';
  /**
   * Human-readable description of what "active" means for this report, e.g.
   * "workspace or email in the last 14 days".
   */
  activeDefinition: Scalars['String']['output'];
  activeUsers: Scalars['Int']['output'];
  inactiveUsers: Scalars['Int']['output'];
  totalActivities: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  totalEmails: Scalars['Int']['output'];
  totalKnowledgeBasePages: Scalars['Int']['output'];
  totalKnowledgeBaseUploads: Scalars['Int']['output'];
  /**
   * Total indexed pages Cara reviewed in the filter window: workspace-attached
   * file pages plus knowledge base document pages.
   */
  totalPagesReviewed: Scalars['Int']['output'];
  totalTemplateReferences: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  totalWorkspaces: Scalars['Int']['output'];
};

export type AdminAnalyticsUserUsage = {
  __typename?: 'AdminAnalyticsUserUsage';
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  emailCount: Scalars['Int']['output'];
  knowledgeBaseUploadCount: Scalars['Int']['output'];
  lastActivityAt?: Maybe<Scalars['Time']['output']>;
  totalActivities: Scalars['Int']['output'];
  workspaceCount: Scalars['Int']['output'];
};

export type AdminAnalyticsWorkspaceBreakdown = {
  __typename?: 'AdminAnalyticsWorkspaceBreakdown';
  count: Scalars['Int']['output'];
  customPreset?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  preset?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * Aggregate complexity / output statistics across workspaces in the filter window.
 * Powers the "Workspace insights" card.
 */
export type AdminAnalyticsWorkspaceStats = {
  __typename?: 'AdminAnalyticsWorkspaceStats';
  /** Average number of generated artifacts (forms / templates / docs) per workspace. */
  avgArtifactsPerWorkspace: Scalars['Float']['output'];
  /** Average indexed file pages among workspaces with at least one attached file page. */
  avgPagesPerWorkspace: Scalars['Float']['output'];
  /** Average number of tool invocations per workspace. */
  avgToolCallsPerWorkspace: Scalars['Float']['output'];
  /** Maximum artifacts produced in any single workspace. */
  maxArtifactsPerWorkspace: Scalars['Int']['output'];
  /** Maximum file pages in a workspace that has at least one attached file page. */
  maxPagesPerWorkspace: Scalars['Int']['output'];
  /** Maximum tool invocations recorded in any single workspace. */
  maxToolCallsPerWorkspace: Scalars['Int']['output'];
  /** 50th-percentile artifacts produced per workspace. */
  medianArtifactsPerWorkspace: Scalars['Int']['output'];
  /** 50th-percentile file pages among workspaces with at least one attached file page. */
  medianPagesPerWorkspace: Scalars['Int']['output'];
  /** 50th-percentile tool invocations per workspace. */
  medianToolCallsPerWorkspace: Scalars['Int']['output'];
  /** 90th-percentile artifacts produced per workspace. */
  p90ArtifactsPerWorkspace: Scalars['Int']['output'];
  /** 90th-percentile file pages among workspaces with at least one attached file page. */
  p90PagesPerWorkspace: Scalars['Int']['output'];
  /** 90th-percentile tool invocations per workspace. */
  p90ToolCallsPerWorkspace: Scalars['Int']['output'];
  /**
   * Distribution of workspaces by tool-call count, bucketed for charting.
   * Buckets are in ascending order; sum of counts == totalWorkspaces.
   */
  toolCallDistribution: Array<AdminAnalyticsHistogramBucket>;
  totalWorkspaces: Scalars['Int']['output'];
};

/** Result from generating an admin sign-in code or URL for a given agency */
export type AdminSignInCode = {
  __typename?: 'AdminSignInCode';
  /**
   * The raw sign-in code. For external agency users this is what the user enters; for internal
   * sessions it is the code embedded in loginUrl.
   */
  code: Scalars['String']['output'];
  /** When the code expires */
  expiresAt: Scalars['Time']['output'];
  /** Whether this is an internal (Oyster employee) session */
  isInternal: Scalars['Boolean']['output'];
  /** The full sign-in URL (only set for internal Oyster employee sessions). */
  loginUrl?: Maybe<Scalars['String']['output']>;
};

/** Agency represents an insurance agency that works with Oyster. */
export type Agency = {
  __typename?: 'Agency';
  /** The child agencies of the agency, if any */
  childAgencies: Array<Agency>;
  /** Agency-wide configuration and settings */
  configuration: AgencyConfiguration;
  /** Timestamp the agency was created */
  createdAt: Scalars['Time']['output'];
  /** Display name of the agency */
  displayName: Scalars['String']['output'];
  /** The entitlements for the agency */
  entitlements: Array<SubscriptionEntitlement>;
  /**
   * Agency-wide Florida producer license number.
   * Used only as a backup when the selected default Producer Information has none.
   * Printed onto ACORD forms when the risk is in Florida (or the form is Florida-specific).
   */
  floridaLicenseNumber: Scalars['String']['output'];
  /** Unique identifier for the agency */
  id: Scalars['ID']['output'];
  /** URL of the agency's logo */
  logoUrl: Scalars['String']['output'];
  /** Mailing address of the agency */
  mailingAddress: Address;
  /** Legal name of the agency */
  name: Scalars['String']['output'];
  /**
   * Agency-wide National Producer Number (NPN).
   * Used only as a backup when the selected default Producer Information has none.
   */
  nationalProducerNumber: Scalars['String']['output'];
  /** The initially selected onboarding date for the agency based on when they created their account */
  onboardingDate?: Maybe<Scalars['Time']['output']>;
  /**
   * Whether creating an outbound voice agent requires acknowledging the current
   * compliance disclosure (no acknowledgment yet, or an older disclosure version).
   */
  outboundVoiceComplianceAcknowledgmentRequired: Scalars['Boolean']['output'];
  /** Current outbound voice compliance disclosure to present when acknowledgment is required. */
  outboundVoiceComplianceDisclosure: OutboundVoiceComplianceDisclosure;
  /** The parent agency of the agency, if any */
  parentAgency?: Maybe<Agency>;
  /** Phone number of the agency */
  phone: Scalars['String']['output'];
  /** All producer information for this agency scope. */
  producerInformations: Array<ProducerInformation>;
  /** The Stripe customer ID for the agency */
  stripeCustomerId: Scalars['String']['output'];
  /** The Stripe subscription ID for the agency, if they have one */
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  /** The subscription information for the agency user */
  subscription?: Maybe<AgencySubscription>;
  /** Timestamp the agency was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The users associated with this agency */
  users: Array<AgencyUser>;
  /** The voice agents associated with this agency */
  voiceAgents: Array<VoiceAgent>;
  /** URL of the agency's wordmark */
  wordmarkUrl: Scalars['String']['output'];
};

/** Association between two agencies */
export type AgencyAssociation = {
  __typename?: 'AgencyAssociation';
  /** When the association was created */
  createdAt: Scalars['Time']['output'];
  /** The relationship between the two agencies */
  relationship: AgencyAssociationRelationship;
  /** When the association was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Relationship between two agencies */
export type AgencyAssociationRelationship = {
  __typename?: 'AgencyAssociationRelationship';
  /** Attributes of the relationship */
  attributes: Array<AgencyAssociationRelationshipAttribute>;
  /** Type of the relationship */
  type: AgencyAssociationRelationshipType;
};

export enum AgencyAssociationRelationshipAttribute {
  /**
   * Indicates that the parent agency is billed for usage of the child agency, and is delegated
   * the abilities to assign and manage seats and voice agents for the child agency.
   */
  FederatedBilling = 'FEDERATED_BILLING'
}

export enum AgencyAssociationRelationshipType {
  /** The "from" agency is a parent of the "to" agency */
  Parent = 'PARENT'
}

/** Agency-wide configuration and settings */
export type AgencyConfiguration = {
  __typename?: 'AgencyConfiguration';
  /**
   * Agency-level configuration governing ACORD COI/EOI/ID-card generation. Always
   * present; its fields hold only the agency's overrides, with null fields meaning
   * "use the Cara default" (see ACORDFormConfiguration).
   */
  acordFormConfiguration: AcordFormConfiguration;
  /** The default COI configuration for the agency */
  liabilityCOIConfiguration: CertificateOfLiabilityAgencyConfiguration;
  /** Notification settings for the agency */
  notifications: NotificationSettings;
  /**
   * Record that an agency user acknowledged the outbound voice compliance disclosure.
   * Null until the first outbound voice agent create that requires acknowledgment.
   * Not writable via updateAgency — only set when creating an outbound voice agent.
   */
  outboundVoiceComplianceAcknowledgment?: Maybe<OutboundVoiceComplianceAcknowledgment>;
  /**
   * Visibility policy for objects (workspaces, presets, templates, forms) within
   * the agency. Currently only controls whether PRIVATE visibility is allowed for
   * members; agency admins always retain read access regardless.
   */
  visibility: AgencyVisibilityPolicy;
};

/** Input for Agency-wide configuration and settings */
export type AgencyConfigurationInput = {
  /** The default COI configuration for the agency */
  liabilityCOIConfiguration: CertificateOfLiabilityAgencyConfigurationInput;
};

/**
 * AgencyDeletionLog records a permanent audit entry each time an agency is deleted.
 * This record is never cascade-deleted so it survives after the agency row is gone.
 */
export type AgencyDeletionLog = {
  __typename?: 'AgencyDeletionLog';
  /** Identifier of the agency that was deleted */
  agencyId: Scalars['ID']['output'];
  /** Display name of the agency at the time of deletion */
  agencyName: Scalars['String']['output'];
  /** Timestamp when the agency was deleted */
  deletedAt: Scalars['Time']['output'];
  /** Identifier of the user who performed the deletion */
  deletedByUserId: Scalars['ID']['output'];
  /** Display name of the user who performed the deletion */
  deletedByUserName: Scalars['String']['output'];
  /** Unique identifier for the deletion log entry */
  id: Scalars['ID']['output'];
};

/** Input for filtering agencies */
export type AgencyFilterInput = {
  /** The name of the agency */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new agency */
export type AgencyInput = {
  /** Agency-wide configuration and settings */
  configuration: AgencyConfigurationInput;
  /** Display name of the agency */
  displayName: Scalars['String']['input'];
  /** URL of the agency's logo */
  logoUrl: Scalars['String']['input'];
  /** Mailing address of the agency */
  mailingAddress: AddressInput;
  /** Legal name of the agency */
  name: Scalars['String']['input'];
  /** Phone number of the agency */
  phone: Scalars['String']['input'];
  /** URL of the agency's wordmark */
  wordmarkUrl: Scalars['String']['input'];
};

/**
 * A profile is the app an agency hands to a group of its users: which presets
 * greet them on the home screen, which pages appear in their sidebar, and what
 * they are allowed to do. Admins author profiles and assign them to teams and
 * individual users.
 *
 * Every agency user resolves to exactly one profile. A direct assignment wins
 * over a team assignment; a user matched by nothing falls back to the agency's
 * default profile; an agency with no default leaves its users on the permissions
 * their role already grants.
 *
 * Profiles govern users with the USER role. Agency admins are never subject to
 * one, not even the default: they author profiles and have to be able to repair a
 * bad one, so they cannot be assigned and no profile narrows what they see.
 *
 * Agency profiles are gated behind the AGENCY_PROFILE_MANAGEMENT subscription
 * entitlement (Enterprise plan). Without it, profiles cannot be created and
 * existing ones stop restricting anything.
 */
export type AgencyProfile = {
  __typename?: 'AgencyProfile';
  /** Timestamp when the profile was archived (soft delete). Null for active profiles. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * How many distinct people use this profile, counting both team-assigned and
   * individually-assigned users. Someone on two of its teams counts once.
   * Admin-only, as with `teams`.
   */
  assignedUserCount: Scalars['Int']['output'];
  /** The configuration of the profile. */
  configuration: AgencyProfileConfiguration;
  /** Timestamp when the profile was created */
  createdAt: Scalars['Time']['output'];
  /** Agency user that created this profile */
  createdBy: AgencyUser;
  /** What this profile is for. Shown to admins only. */
  description: Scalars['String']['output'];
  /** Unique identifier for the profile */
  id: Scalars['ID']['output'];
  /**
   * Whether users with no assignment of their own land on this profile. At most
   * one profile per agency is the default, and promoting one demotes the other.
   */
  isDefault: Scalars['Boolean']['output'];
  /** Name of the profile. Unique within an agency (case-insensitive). */
  name: Scalars['String']['output'];
  /**
   * Teams assigned to this profile. A team grants exactly one profile, so
   * assigning a team here removes it from the profile it was on.
   *
   * Admin-only, unlike the rest of the profile: a user reaches their own profile
   * through `AgencyUser.profile` to render their app, and who else is on it is
   * not part of that.
   */
  teams: Array<Team>;
  /** Timestamp when the profile was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Users assigned to this profile individually, not counting those who reach it
   * through one of its teams. Admin-only, as with `teams`.
   */
  users: Array<AgencyUser>;
  /** The current version number of this profile, incremented on each update. */
  version: Scalars['Int64']['output'];
};

/**
 * Where the profile governing a user came from. A user can sit under more than
 * one rule at once — assigned directly and a member of an assigned team — so the
 * source names which one won rather than which ones exist.
 */
export enum AgencyProfileAssignmentSource {
  /** The agency default, which covers every user no other rule reaches. */
  Default = 'DEFAULT',
  /** Assigned to the user by name. Outranks any team the user belongs to. */
  Direct = 'DIRECT',
  /**
   * Inherited from one of the user's teams, none of them assigning the user
   * directly.
   */
  Team = 'TEAM'
}

/**
 * One thing an agency can let a group of its users do.
 *
 * Capabilities, not raw permissions, are what an admin grants. A permission like
 * FILE:UPLOAD is not a decision anybody makes on its own — it is what "run
 * workspaces" and "upload a Word template" both happen to need — so the editor
 * offers the product surface and the server works out the permissions behind it.
 *
 * Three rules make that safe:
 *
 * - Granting a capability grants everything it needs, including the capabilities
 *   it lists as prerequisites. Nothing has to be ticked twice.
 * - A profile only ever narrows. Expanding a capability can hand out a permission
 *   the user's role does not have, and the intersection at sign-in drops it, so
 *   the catalog is deliberately generous rather than exact.
 * - Every action the API enforces on a governed resource is reachable from some
 *   capability. An action no capability grants would be denied to every profiled
 *   user with no way to turn it back on, so
 *   TestCatalogGrantsEveryEnforcedAction fails if one appears.
 */
export enum AgencyProfileCapability {
  /** Edit inbound call details */
  CallsInboundManage = 'CALLS_INBOUND_MANAGE',
  /** Open the inbound call log, recordings, and transcripts */
  CallsInboundView = 'CALLS_INBOUND_VIEW',
  /** Schedule, dial, and cancel outbound calls */
  CallsOutboundManage = 'CALLS_OUTBOUND_MANAGE',
  /** Open the outbound call queue */
  CallsOutboundView = 'CALLS_OUTBOUND_VIEW',
  /** See the call report */
  CallsReportView = 'CALLS_REPORT_VIEW',
  /** Delete a client */
  ClientsDelete = 'CLIENTS_DELETE',
  /** Add and edit clients and their contacts */
  ClientsManage = 'CLIENTS_MANAGE',
  /** Open the client list and client records */
  ClientsView = 'CLIENTS_VIEW',
  /** Write, edit, and delete notes on a client */
  ClientNotesWrite = 'CLIENT_NOTES_WRITE',
  /** Read email threads Cara drafts and triages */
  EmailsView = 'EMAILS_VIEW',
  /** Connect systems, edit connections, and trigger syncs */
  IntegrationsManage = 'INTEGRATIONS_MANAGE',
  /** See connected AMS and CRM systems */
  IntegrationsView = 'INTEGRATIONS_VIEW',
  /** Delete documents from a knowledge base */
  KnowledgeBaseDocumentsDelete = 'KNOWLEDGE_BASE_DOCUMENTS_DELETE',
  /** Add and update documents: uploads, pasted text, and web pages */
  KnowledgeBaseDocumentsWrite = 'KNOWLEDGE_BASE_DOCUMENTS_WRITE',
  /** Organize folders and who can see them */
  KnowledgeBaseOrganize = 'KNOWLEDGE_BASE_ORGANIZE',
  /** Search knowledge bases and open their documents */
  KnowledgeBaseUse = 'KNOWLEDGE_BASE_USE',
  /** Upload and edit Excel templates */
  LibraryExcelManage = 'LIBRARY_EXCEL_MANAGE',
  /** Use Excel templates */
  LibraryExcelUse = 'LIBRARY_EXCEL_USE',
  /** Add custom forms and edit their field mappings */
  LibraryFormsManage = 'LIBRARY_FORMS_MANAGE',
  /** Use custom forms */
  LibraryFormsUse = 'LIBRARY_FORMS_USE',
  /** Use the agency's branding styles */
  LibraryStylesUse = 'LIBRARY_STYLES_USE',
  /** Create and edit styles and letter templates */
  LibraryTemplatesManage = 'LIBRARY_TEMPLATES_MANAGE',
  /** Use letter and document templates */
  LibraryTemplatesUse = 'LIBRARY_TEMPLATES_USE',
  /** Upload and edit Word templates */
  LibraryWordManage = 'LIBRARY_WORD_MANAGE',
  /** Use Word templates */
  LibraryWordUse = 'LIBRARY_WORD_USE',
  /** Connect a mailbox and choose who else may send as it */
  MailboxConnect = 'MAILBOX_CONNECT',
  /** Send mail through a connected mailbox and manage their own signatures */
  MailboxSend = 'MAILBOX_SEND',
  /** See connected mailboxes and disconnect their own */
  MailboxView = 'MAILBOX_VIEW',
  /** Save, edit, and delete memories */
  MemoryManage = 'MEMORY_MANAGE',
  /** See saved memories */
  MemoryView = 'MEMORY_VIEW',
  /** Build and edit presets */
  PresetsAuthor = 'PRESETS_AUTHOR',
  /** Run the agency's presets */
  PresetsRun = 'PRESETS_RUN',
  /** Share presets with other agencies */
  PresetsShare = 'PRESETS_SHARE',
  /** Open the servicing queue */
  ServicingView = 'SERVICING_VIEW',
  /** Open, edit, and resolve service requests */
  ServicingWork = 'SERVICING_WORK',
  /** Create teams and change their membership */
  TeamsManage = 'TEAMS_MANAGE',
  /** See teams and who belongs to them */
  TeamsView = 'TEAMS_VIEW',
  /** Create a voice agent */
  VoiceAgentsCreate = 'VOICE_AGENTS_CREATE',
  /** Change how an existing voice agent answers */
  VoiceAgentsUpdate = 'VOICE_AGENTS_UPDATE',
  /** See the agency's voice agents */
  VoiceAgentsView = 'VOICE_AGENTS_VIEW',
  /** Start workspaces, chat in them, and attach files */
  WorkspacesRun = 'WORKSPACES_RUN',
  /** Open workspaces and the documents they produce */
  WorkspacesView = 'WORKSPACES_VIEW'
}

/**
 * Everything an admin can grant, grouped the way the settings page draws it:
 * modules, the surfaces inside each, and the capabilities on offer for each
 * surface. The three levels are the app's own shape, not the permission model's.
 */
export type AgencyProfileCapabilityCatalog = {
  __typename?: 'AgencyProfileCapabilityCatalog';
  groups: Array<AgencyProfileCapabilityGroup>;
};

/**
 * One module in the capability editor — a group of related surfaces an agency
 * would name as one thing, e.g. \"Copilot\" or \"Calls\".
 */
export type AgencyProfileCapabilityGroup = {
  __typename?: 'AgencyProfileCapabilityGroup';
  /** One line on what this module is, shown under the heading. */
  hint: Scalars['String']['output'];
  /** The surfaces inside it, in display order. */
  sections: Array<AgencyProfileCapabilitySection>;
  /** Heading, e.g. "Library". */
  title: Scalars['String']['output'];
};

/** One capability as the editor draws it, with everything granting it pulls in. */
export type AgencyProfileCapabilityOption = {
  __typename?: 'AgencyProfileCapabilityOption';
  /** The capability granted. */
  capability: AgencyProfileCapability;
  /** The permissions this capability confers, for admins who want the detail. */
  grants: Array<AgencyProfilePermission>;
  /** Why it exists, or what it does not cover. */
  hint: Scalars['String']['output'];
  /** What ticking it lets someone do, e.g. "Run the agency's presets". */
  label: Scalars['String']['output'];
  /** Sidebar entries this capability makes reachable. */
  navigation: Array<AgencyProfileNavigationOption>;
  /**
   * Capabilities granted along with this one. Ticking a capability ticks these,
   * and unticking one of these unticks whatever required it, so the stored set is
   * always closed under this relation.
   */
  requires: Array<AgencyProfileCapability>;
};

/**
 * One surface inside a module: a page, or a tab within one. Settings is one
 * section per settings page, since those pages have nothing in common beyond
 * living behind the same gear.
 */
export type AgencyProfileCapabilitySection = {
  __typename?: 'AgencyProfileCapabilitySection';
  /** The capabilities on offer, in display order. */
  capabilities: Array<AgencyProfileCapabilityOption>;
  /** One line on what this surface is, shown beside the heading. */
  hint: Scalars['String']['output'];
  /** Heading, e.g. "Word templates". */
  title: Scalars['String']['output'];
};

/** The configuration of a profile. */
export type AgencyProfileConfiguration = {
  __typename?: 'AgencyProfileConfiguration';
  /**
   * What this profile lets its users do. Closed under the `requires` relation:
   * every prerequisite of a capability here is here too.
   */
  capabilities: Array<AgencyProfileCapability>;
  /** The home screen configuration of the profile. */
  homeScreen: AgencyProfileHomeScreen;
  /** The navigation configuration of the profile. */
  navigation: Array<NavigationItem>;
  /**
   * The permissions `capabilities` works out to, deduplicated and sorted. Derived
   * on read, never stored and never accepted as input — an admin grants product
   * surface and the server decides which permissions that needs.
   */
  permissions: Array<AgencyProfilePermission>;
};

/** Home screen configuration for a profile. */
export type AgencyProfileHomeScreen = {
  __typename?: 'AgencyProfileHomeScreen';
  /**
   * Whether users may pin, unpin, and reorder presets for themselves. Off locks
   * the home screen to `pins` and stops the client from writing home pins back
   * to the user's own preferences.
   */
  allowUserCustomization: Scalars['Boolean']['output'];
  /**
   * Whether the free-form Ask Cara input appears above the presets. Off leaves
   * users with the pinned presets and nothing else to type into.
   */
  askCaraEnabled: Scalars['Boolean']['output'];
  /**
   * Presets on the home screen, in display order. When customization is allowed
   * these are the starting set for a user who has pinned nothing; when it is not,
   * they are the whole home screen.
   */
  pins: Array<AgencyUserHomePin>;
};

/** Input for a profile's home screen configuration. */
export type AgencyProfileHomeScreenInput = {
  /** Whether users may rearrange their own home screen. */
  allowUserCustomization: Scalars['Boolean']['input'];
  /** Whether the free-form Ask Cara input appears. */
  askCaraEnabled: Scalars['Boolean']['input'];
  /** Presets on the home screen, in display order. */
  pins: Array<AgencyUserHomePinInput>;
};

/**
 * Input for updating a profile. Every field replaces its stored counterpart
 * wholesale, because each is edited as a whole on the settings page and a partial
 * list has no meaning.
 */
export type AgencyProfileInput = {
  /**
   * What these users can do. Prerequisites are filled in server-side, so a client
   * may send only the capabilities an admin ticked; a capability naming one this
   * list omits is added rather than rejected.
   */
  capabilities: Array<AgencyProfileCapability>;
  /** What this profile is for. */
  description: Scalars['String']['input'];
  /** Home screen configuration. */
  homeScreen: AgencyProfileHomeScreenInput;
  /**
   * Whether this profile catches users with no assignment of their own. Setting
   * it demotes whichever profile was the default. Clearing it on the current
   * default leaves the agency with none, and its unassigned users keep whatever
   * their role grants.
   */
  isDefault: Scalars['Boolean']['input'];
  /** Name of the profile. Must be unique within the agency (case-insensitive). */
  name: Scalars['String']['input'];
  /** Sidebar entries these users can see. */
  navigation: Array<NavigationItem>;
  /**
   * Teams assigned to this profile, replacing the current list. Each team named
   * here is removed from the profile it was on.
   */
  teamIds: Array<Scalars['String']['input']>;
  /**
   * Users assigned individually, replacing the current list. Each user named here
   * is removed from the profile they were on. Users who reach this profile
   * through one of `teamIds` do not need an entry.
   */
  userIds: Array<Scalars['String']['input']>;
};

/** A sidebar entry a profile can show or hide, as offered in the capability editor. */
export type AgencyProfileNavigationOption = {
  __typename?: 'AgencyProfileNavigationOption';
  /** Tabs within this page. Hiding the page hides them with it. */
  children: Array<AgencyProfileNavigationOption>;
  /** The sidebar entry. */
  item: NavigationItem;
  /**
   * How the entry reads in the sidebar, e.g. "Library › Word Templates". Tabs
   * carry their own name alone, since the page above them supplies the path.
   */
  label: Scalars['String']['output'];
};

/** The actions a profile grants on one resource. */
export type AgencyProfilePermission = {
  __typename?: 'AgencyProfilePermission';
  /** The actions granted. Empty is equivalent to omitting the resource entirely. */
  actions: Array<Action>;
  /** The resource these actions apply to. */
  resource: Resource;
};

/** Describes the type of update that occurred to an agency profile */
export enum AgencyProfileUpdateType {
  /** The profile was archived */
  ArchiveAgencyProfile = 'ARCHIVE_AGENCY_PROFILE',
  /** The profile was created */
  CreateAgencyProfile = 'CREATE_AGENCY_PROFILE',
  /** The profile was updated */
  UpdateAgencyProfile = 'UPDATE_AGENCY_PROFILE'
}

/** Describes a particular version of an agency profile (internal use for DB versioning) */
export type AgencyProfileVersion = {
  __typename?: 'AgencyProfileVersion';
  /** The full agency profile object for this version */
  agencyProfile: AgencyProfile;
  /**
   * Teams assigned to this profile as of this version. Written for history only;
   * reads take assignments from the assignment tables.
   */
  assignedTeamIds: Array<Scalars['String']['output']>;
  /**
   * Users assigned directly to this profile as of this version. Written for
   * history only; reads take assignments from the assignment tables.
   */
  assignedUserIds: Array<Scalars['String']['output']>;
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is private */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<Scalars['String']['output']>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<AgencyProfileUpdateType>;
  /** The version number of this agency profile version */
  version: Scalars['Int64']['output'];
};

/**
 * Per-agency override for converting raw usage into billable quantities at confirmation time.
 * Optional match dimensions (costEventType, modelId) are null on the override to match any value.
 */
export type AgencyRateOverride = {
  __typename?: 'AgencyRateOverride';
  /** Replacement conversion rule (ABSOLUTE strategy only) */
  conversionRule?: Maybe<Scalars['JSON']['output']>;
  /** Raw cost event type filter; null matches any type */
  costEventType?: Maybe<CostEventType>;
  createdAt: Scalars['Time']['output'];
  /** Human-readable description for admin/support */
  description?: Maybe<Scalars['String']['output']>;
  /** When this override becomes effective */
  effectiveAt: Scalars['Time']['output'];
  /** When this override expires; null means no expiry */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  /** Customer-facing meter this override applies to */
  meterCode: ConsumptionMeterCode;
  /** Model filter; null matches any model */
  modelId?: Maybe<Scalars['String']['output']>;
  /** Multiplier applied to default converted quantity (MULTIPLIER strategy only) */
  multiplier?: Maybe<Scalars['Decimal']['output']>;
  /** Raw unit being converted (mirrors consumption_event.raw_unit) */
  rawUnit: CostEventUnit;
  /** How this override adjusts conversion */
  strategy: AgencyRateOverrideStrategy;
  updatedAt: Scalars['Time']['output'];
};

/** How an agency rate override adjusts billable quantity conversion. */
export enum AgencyRateOverrideStrategy {
  /** Replace the default conversion rule with conversionRule. */
  Absolute = 'ABSOLUTE',
  /** Apply multiplier to the default converted quantity. */
  Multiplier = 'MULTIPLIER'
}

/** Response from the agency sign in mutation */
export type AgencySignInResponse = {
  __typename?: 'AgencySignInResponse';
  /** The agency user that was signed in */
  agencyUser: AgencyUser;
};

/** Subscription information for the agency */
export type AgencySubscription = {
  __typename?: 'AgencySubscription';
  /** The agency that owns this subscription. */
  agencyId: Scalars['ID']['output'];
  /**
   * Live estimate of overage charges for the current (not yet invoiced) usage period.
   * Same aggregation as period-close billing; labeled an estimate until the period closes.
   * Agency users with subscription update permission only. Null when the subscription
   * is unmetered or the period is unavailable.
   */
  currentOverageBillEstimate?: Maybe<OverageBillEstimate>;
  /** Current-period agency-wide platform-unit overage vs the org overage budget. */
  currentOverageSpendStatus?: Maybe<OverageSpendStatus>;
  /**
   * Included usage allowances for the current usage period per meter.
   * Null when the subscription or period is unavailable, or platform overrides
   * are incomplete.
   */
  currentUsageAllowances?: Maybe<AgencyUsageAllowances>;
  /**
   * The active usage metering period for allotments and consumption totals.
   * Windows are computed from usageBillingAnchor (or nextBillingDate fallback)
   * and usageCycle (monthly when unset). Day progress (daysTotal/elapsed/remaining)
   * uses timezone when provided; otherwise UTC.
   */
  currentUsagePeriod?: Maybe<AgencyUsagePeriod>;
  /**
   * Billable usage consumed in the current usage period per meter.
   * Agency users with subscription update permission only. Daily buckets use timezone when provided; otherwise UTC.
   * Null when the subscription or period is unavailable.
   */
  currentUsageReport?: Maybe<AgencyUsageReport>;
  /**
   * The entitlements for the subscription
   * @deprecated Use the entitlements field on the agency instead. This field will be removed in a future version.
   */
  entitlements: Array<SubscriptionEntitlement>;
  /**
   * Max knowledge-base page overage spend (USD) for the billing period above the
   * included allotment. Null / 0 / >0 semantics match platformUnitOverageLimitDollars.
   */
  kbPageOverageLimitDollars?: Maybe<Scalars['Float']['output']>;
  /** The amount due for the next billing period */
  nextBillingAmount?: Maybe<Scalars['Float']['output']>;
  /** The date the next billing period for the subscription will start */
  nextBillingDate?: Maybe<Scalars['Time']['output']>;
  /** The number of seats purchased for the agency */
  numSeats: Scalars['Int']['output'];
  /** The number of seats currently in use for the agency */
  numSeatsActive: Scalars['Int']['output'];
  /** The minimum number of seats allowed for the subscription */
  numSeatsMinimum: Scalars['Int']['output'];
  /** The number of voice agents currently in use for the agency */
  numVoiceAgents: Scalars['Int']['output'];
  /** The number of voice agents currently in use for the agency */
  numVoiceAgentsActive: Scalars['Int']['output'];
  /** The period of the subscription */
  period?: Maybe<SubscriptionPeriod>;
  /** The plan that the agency is subscribed to */
  plan?: Maybe<SubscriptionPlan>;
  /**
   * How included usage allotments are determined.
   * PER_SEAT / PLATFORM = metered usage billing.
   * UNMETERED = unlimited capacity (no allotments, limits, or customer-facing usage UI).
   * Null = legacy unmetered (same as UNMETERED). New subscriptions always write an
   * explicit value; Stripe sync preserves null so no backfill is required.
   */
  planBillingType?: Maybe<PlanBillingType>;
  /**
   * Max platform-unit overage spend (USD) the agency may incur in a billing
   * period above the shared included allotment.
   * Null or 0 = no overage allowed (hard stop at included).
   * >0 = dollar cap. Unlimited usage requires an unmetered subscription
   * (planBillingType unset / not PER_SEAT or PLATFORM). Stored on the agency
   * subscription JSONB; Stripe sync must not wipe this field. UI may display this
   * as units at the platform overage rate.
   */
  platformUnitOverageLimitDollars?: Maybe<Scalars['Float']['output']>;
  /** When the agency dismissed the post-confirmation sunset renewal banner. */
  standardSunsetRenewalBannerDismissedAt?: Maybe<Scalars['Time']['output']>;
  /** When the agency confirmed their legacy Standard sunset renewal selection. */
  standardSunsetRenewalConfirmedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The date the subscription started, straight from Stripe. Unlike trialEndDate
   * this is set for every subscription, so it is the reliable basis for deriving
   * renewal dates.
   */
  startDate?: Maybe<Scalars['Time']['output']>;
  /** The state of the subscription for the agency */
  state: SubscriptionState;
  /** The date the trial period for the subscription will end */
  trialEndDate?: Maybe<Scalars['Time']['output']>;
  /**
   * Negotiated included amounts per meter for platform contracts. Stored on the
   * agency subscription; used when planBillingType is PLATFORM.
   */
  usageAllotmentOverrides?: Maybe<UsageAllotmentOverrides>;
  /**
   * Stripe billing_cycle_anchor (or start_date) used as the calendar basis for
   * usage metering windows with usageCycle. Persisted on Stripe sync so
   * currentUsagePeriod does not Retrieve from Stripe on every Usage page load.
   * Null until the first sync after this field existed; then nextBillingDate is
   * used as a best-effort fallback.
   */
  usageBillingAnchor?: Maybe<Scalars['Time']['output']>;
  /**
   * Usage metering cadence for allotments. When unset (null), metering defaults
   * to monthly regardless of subscription payment period.
   */
  usageCycle?: Maybe<UsageCycle>;
  /**
   * Billable usage for a selectable historical window. Requires subscription update permission.
   * Returns agency-wide KB/voice totals and per-user platform units.
   * CUSTOM requires inclusive startDay and endDay calendar dates; timezone
   * determines their midnight boundaries.
   */
  usageHistory?: Maybe<AgencyUsageHistory>;
  /**
   * Paginated overage settlement history for closed periods. Returns PENDING, PAID,
   * and FAILED by default; excludes PROCESSING (Stripe delivery in progress) and
   * SKIPPED unless includeSkipped is true.
   * Agency users with subscription update permission only.
   */
  usageOverageInvoices: UsageOverageInvoiceConnection;
  /**
   * Max voice-minute overage spend (USD) for the billing period above the included
   * allotment. Null / 0 / >0 semantics match platformUnitOverageLimitDollars.
   */
  voiceMinuteOverageLimitDollars?: Maybe<Scalars['Float']['output']>;
};


/** Subscription information for the agency */
export type AgencySubscriptionCurrentOverageBillEstimateArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription information for the agency */
export type AgencySubscriptionCurrentUsagePeriodArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription information for the agency */
export type AgencySubscriptionCurrentUsageReportArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription information for the agency */
export type AgencySubscriptionUsageHistoryArgs = {
  endDay?: InputMaybe<Scalars['Time']['input']>;
  startDay?: InputMaybe<Scalars['Time']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  window: AgencyUsageWindow;
};


/** Subscription information for the agency */
export type AgencySubscriptionUsageOverageInvoicesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  includeSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<UsageOverageInvoiceStatus>;
};

/** Included usage allowances for the active billing period across all meters. */
export type AgencyUsageAllowances = {
  __typename?: 'AgencyUsageAllowances';
  kbPages: UsageMeterAllowance;
  platformUnits: UsageMeterAllowance;
  voiceMinutes: UsageMeterAllowance;
};

/** Historical usage scoped to the requesting agency user. End is exclusive. */
export type AgencyUsageHistory = {
  __typename?: 'AgencyUsageHistory';
  /** Agency-wide totals. Available only to agency admins. */
  agencyTotals?: Maybe<AgencyUsageHistoryTotals>;
  end: Scalars['Time']['output'];
  /**
   * Platform units by user, highest first. Admins receive all attributed users;
   * non-admins receive only their own row.
   */
  platformUnitsByUser: Array<AgencyUsageUserAmount>;
  start: Scalars['Time']['output'];
  timezone: Scalars['String']['output'];
};

/** Agency-wide billable totals for a historical usage window. */
export type AgencyUsageHistoryTotals = {
  __typename?: 'AgencyUsageHistoryTotals';
  kbPages: Scalars['Int']['output'];
  voiceMinutes: Scalars['Int']['output'];
};

/**
 * The agency's active usage metering period. Period end is exclusive: usage
 * queries use occurred_at >= start AND occurred_at < end.
 */
export type AgencyUsagePeriod = {
  __typename?: 'AgencyUsagePeriod';
  /**
   * Calendar days elapsed in the period in the requested timezone (UTC when unset),
   * counting the start day as day 1. Aligns with daily chart recorded/projected cutover.
   */
  daysElapsed: Scalars['Int']['output'];
  /**
   * Calendar days remaining before the period ends, in the requested timezone
   * (UTC when unset).
   */
  daysRemaining: Scalars['Int']['output'];
  /**
   * Total calendar days in the usage period, counted in the requested timezone
   * (UTC when unset). Matches the length of daily buckets on currentUsageReport.
   */
  daysTotal: Scalars['Int']['output'];
  /** When the current usage period ends (exclusive) */
  end: Scalars['Time']['output'];
  /** When the current usage period started */
  start: Scalars['Time']['output'];
  /** Usage metering cadence for this period */
  usageCycle: UsageCycle;
};

/** Billable usage consumed in the current billing period per meter. */
export type AgencyUsageReport = {
  __typename?: 'AgencyUsageReport';
  kbPages: UsageMeterAmount;
  platformUnits: UsageMeterAmount;
  /**
   * Platform units used per agency user in this billing period, highest first.
   * Users with zero usage are omitted.
   */
  platformUnitsByUser: Array<AgencyUsageUserAmount>;
  /**
   * IANA timezone used for daily bucket boundaries. Echoes the resolved timezone
   * from the currentUsageReport(timezone:) argument (UTC when unset/invalid).
   */
  timezone: Scalars['String']['output'];
  voiceMinutes: UsageMeterAmount;
};

/** Platform-unit consumption attributed to one agency user in the current period. */
export type AgencyUsageUserAmount = {
  __typename?: 'AgencyUsageUserAmount';
  agencyUserId: Scalars['ID']['output'];
  used: Scalars['Decimal']['output'];
};

/** Preset calendar or usage-period window for usage history. */
export enum AgencyUsageWindow {
  CurrentUsagePeriod = 'CURRENT_USAGE_PERIOD',
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  LastDay = 'LAST_DAY',
  PreviousUsagePeriod = 'PREVIOUS_USAGE_PERIOD'
}

export type AgencyUser = {
  __typename?: 'AgencyUser';
  /**
   * Whether the legacy Accounts and Policies sidebar tabs are hidden for this
   * user's agency. Resolves off the same gate as frontendFlags, so the two can
   * never disagree.
   * @deprecated Use frontendFlags and test for hide_accounts_policies_tabs. Retained so AIS bundles already running in browsers keep resolving; safe to remove once those have cycled.
   */
  accountsPoliciesTabsHidden: Scalars['Boolean']['output'];
  /** Agency the user is associated with */
  agency: Agency;
  /** Attributes of the agency user */
  attributes: AgencyUserAttributes;
  /** Timestamp the agency user was created */
  createdAt: Scalars['Time']['output'];
  /**
   * Current-period platform-unit overage for this user vs their dollar budget.
   * Null when the agency subscription/period is unavailable.
   */
  currentOverageSpendStatus?: Maybe<OverageSpendStatus>;
  /** Email of the user */
  email: Scalars['String']['output'];
  /**
   * Names of the Statsig gates enabled for this caller, from the registry in
   * pkg/core/statsig/frontend_flags.go. An absent name is off. Flags go here rather
   * than in a Boolean field per flag -- see the Feature Flags section of CLAUDE.md.
   */
  frontendFlags: Array<Scalars['String']['output']>;
  /** ID of the user */
  id: Scalars['ID']['output'];
  /** Timestamp the agency user was last viewed new features */
  lastViewedNewFeatures?: Maybe<Scalars['Time']['output']>;
  /** Name of the user */
  name: Scalars['String']['output'];
  /**
   * Whether outbound calling UI (Calls → Outbound) is enabled for this user/org.
   * Backed by the cara_outbound_calls_enabled Statsig gate.
   */
  outboundCallsEnabled: Scalars['Boolean']['output'];
  /** Permissions the agency user has */
  permissions: Array<Permission>;
  /**
   * Max spend (USD) this user may incur on platform-unit overage in a billing
   * period, priced at the published overage rate.
   * Null or 0 = this user may not incur overage.
   * >0 = dollar cap. Counts only this user's units after the shared included
   * allotment is exhausted (phased). Minutes and KB pages have no per-user limit.
   */
  platformUnitOverageLimitDollars?: Maybe<Scalars['Float']['output']>;
  /** Preferences for the agency user */
  preferences: AgencyUserPreferences;
  /** All producer information for this agency user scope. */
  producerInformations: Array<ProducerInformation>;
  /**
   * The profile that applies to this user, or null when their agency has no
   * profile that reaches them. Read it for the home screen and sidebar; the
   * permissions it implies are already folded into `permissions`.
   *
   * Anyone may read their own. Reading another user's needs profile-management
   * access, and returns null rather than an error for callers without it, so a
   * colleague's configuration is not enumerable.
   */
  profile?: Maybe<AgencyProfile>;
  /** Roles of the agency user */
  roles: Array<Role>;
  /**
   * Whether customer-facing usage-based billing is enabled for this user/org
   * (Usage/Limits settings, overage enforcement, spend emails). True only when
   * the Statsig usage_dashboard gate is on and the agency subscription has an
   * explicit PER_SEAT or PLATFORM planBillingType (null/UNMETERED stay hidden).
   */
  settingsUsageTabEnabled: Scalars['Boolean']['output'];
  /** State of the agency user */
  state: AgencyUserState;
  /**
   * Returns all teams this agency user is a member of. For the current agency
   * user the resolver short-circuits on the principal's already-loaded team
   * membership; for other agency users it queries the database. Available to
   * any agency user with read access to teams (the @authorize check runs
   * against the *caller's* permissions, not the targeted user's).
   */
  teams: Array<Team>;
  /** Timestamp the agency user was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Additional attributes for the agency user */
export type AgencyUserAttributes = {
  __typename?: 'AgencyUserAttributes';
  /** Go-to-market attributes for the agency user */
  gtm: AgencyUserGtmAttributes;
};

/** Input for updating the attributes of an agency user */
export type AgencyUserAttributesInput = {
  /** The go-to-market attributes of the agency user */
  gtm?: InputMaybe<AgencyUserGtmAttributesInput>;
};

/** Desktop notification preferences for workspace completion */
export type AgencyUserDesktopNotificationPreferences = {
  __typename?: 'AgencyUserDesktopNotificationPreferences';
  /** Whether desktop notifications for workspace completion are enabled */
  enabled: Scalars['Boolean']['output'];
  /**
   * The minimum number of minutes a workspace must be working before a completion
   * notification is sent. One of: 1, 2, 5, 10.
   */
  workspaceCompletionIntervalMinutes: Scalars['Int']['output'];
};

/** Input for desktop notification preferences for workspace completion */
export type AgencyUserDesktopNotificationPreferencesInput = {
  /** Whether desktop notifications for workspace completion are enabled */
  enabled: Scalars['Boolean']['input'];
  /**
   * The minimum number of minutes a workspace must be working before a completion
   * notification is sent. One of: 1, 2, 5, 10.
   */
  workspaceCompletionIntervalMinutes: Scalars['Int']['input'];
};

export type AgencyUserGtmAttributes = {
  __typename?: 'AgencyUserGTMAttributes';
  /** Whether the agency user is a billing contact for the agency */
  billingContact: Scalars['Boolean']['output'];
  /** Whether the agency user is a primary contact for the agency */
  primaryContact: Scalars['Boolean']['output'];
};

/** Input for updating the go-to-market attributes of an agency user */
export type AgencyUserGtmAttributesInput = {
  /** Whether the agency user is a billing contact for the agency */
  billingContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the agency user is the primary contact for the agency */
  primaryContact?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * One pin in the home-page tray: either a built-in use case or a custom
 * preset. The preset is stored as an id and joined on the client against
 * the presets the user may run; an archived or unshared pin fails to join
 * and is dropped on the next save.
 */
export type AgencyUserHomePin = {
  __typename?: 'AgencyUserHomePin';
  /**
   * The custom preset this pin runs. Null on a use-case pin. Resolved on the
   * client against the presets the user may run; not re-gated on read.
   */
  customPresetId?: Maybe<Scalars['ID']['output']>;
  /** The built-in use case this pin runs. Null on a custom-preset pin. */
  useCase?: Maybe<CaraWorkspaceUseCase>;
};

/**
 * One entry in a home-page pin arrangement. Exactly one of `useCase` and
 * `customPresetId` must be set. A pin with both or with neither is rejected, and the
 * whole update fails: it would render as nothing, and silently shortening someone's
 * arrangement hides the bug that sent it.
 */
export type AgencyUserHomePinInput = {
  /** The custom preset to pin. Omit on a use-case pin. */
  customPresetId?: InputMaybe<Scalars['ID']['input']>;
  /** The built-in use case to pin. Omit on a custom-preset pin. */
  useCase?: InputMaybe<CaraWorkspaceUseCase>;
};

/** Input for creating a new agency user */
export type AgencyUserInput = {
  /** Email of the agency user */
  email: Scalars['String']['input'];
  /** Name of the agency user */
  name: Scalars['String']['input'];
  /**
   * The access profile to assign the new user to. Omit it to leave them on
   * whatever their teams or the agency default provide. Rejected for a user whose
   * roles include ADMIN, since no profile governs an admin.
   */
  profileId?: InputMaybe<Scalars['String']['input']>;
  /** Roles of the agency user */
  roles: Array<Role>;
};

/** Preferences for the agency user */
export type AgencyUserPreferences = {
  __typename?: 'AgencyUserPreferences';
  /**
   * Default visibility used when creating new visibility-bearing Cara objects.
   * Existing objects keep their own visibility until explicitly changed.
   */
  defaultVisibility: VisibilityConfig;
  /** Desktop notification preferences for workspace completion */
  desktopNotifications: AgencyUserDesktopNotificationPreferences;
  /** Favorite presets for the agency user */
  favoritePresets: AgencyUserPreferencesFavoritePresets;
  /**
   * Pins on the home page, in display order. Built-in use cases and custom
   * presets share one list so they can interleave. Empty means no arrangement
   * — there is no default set. Independent of `favoritePresets`, which the
   * original home page still reads.
   */
  homePins: Array<AgencyUserHomePin>;
  /**
   * Whether the memory system is disabled for this agency user. When true, Cara
   * does not inject any extracted/saved memories into prompts for this user. The
   * default (false) is "memory enabled", so users who haven't opted out get
   * memory injection automatically.
   */
  memoryDisabled: Scalars['Boolean']['output'];
  /**
   * The mode for overriding the COI configuration for the agency user, if any. If not specified,
   * the agency's COI configuration is used.
   */
  overrideCOIConfigurationMode?: Maybe<CoiConfigurationMode>;
};

/** Favorite presets for the agency user */
export type AgencyUserPreferencesFavoritePresets = {
  __typename?: 'AgencyUserPreferencesFavoritePresets';
  /** The custom presets that the agency user has favorited */
  customPresets: Array<CustomPreset>;
  /** The custom presets that the agency user has favorited */
  presets: Array<CaraWorkspacePreset>;
};

/** Input for Favorite presets for the agency user */
export type AgencyUserPreferencesFavoritePresetsInput = {
  /** The custom presets that the agency user has favorited */
  customPresetIds: Array<Scalars['String']['input']>;
  /** The custom presets that the agency user has favorited */
  presets: Array<CaraWorkspacePreset>;
};

/** Input for preferences for the agency user */
export type AgencyUserPreferencesInput = {
  /**
   * Default visibility used when creating new visibility-bearing Cara objects.
   * If omitted, the existing preference is preserved.
   */
  defaultVisibility?: InputMaybe<VisibilityConfigInput>;
  /** Desktop notification preferences for workspace completion */
  desktopNotifications?: InputMaybe<AgencyUserDesktopNotificationPreferencesInput>;
  /** The custom presets that the agency user has favorited */
  favoritePresets?: InputMaybe<AgencyUserPreferencesFavoritePresetsInput>;
  /**
   * What is pinned to the home page, in display order. Replaces the stored list
   * wholesale, because the client owns the ordering and a partial update has no
   * meaning. Null means do not change. An empty list clears the arrangement.
   */
  homePins?: InputMaybe<Array<AgencyUserHomePinInput>>;
  /**
   * Disable the memory system for this agency user. True opts the user out of
   * memory injection; false re-enables it. Null means do not change.
   */
  memoryDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The mode for overriding the COI configuration for the agency user. If not specified,
   * the existing value is preserved.
   */
  overrideCOIConfigurationMode?: InputMaybe<CoiConfigurationMode>;
};

/**
 * The profile governing one user and the rule that put them there. Read this to
 * edit a user's assignment: `source` says whether changing it means editing the
 * user or editing a team.
 */
export type AgencyUserProfileAssignment = {
  __typename?: 'AgencyUserProfileAssignment';
  /** The profile in force for the user. */
  profile: AgencyProfile;
  /** Which rule put the user on it. */
  source: AgencyProfileAssignmentSource;
  /**
   * The team the profile came from. Set only when source is TEAM, and names the
   * team whose assignment won when the user belongs to several.
   */
  team?: Maybe<Team>;
};

export enum AgencyUserState {
  /** The user is active and can access the agency */
  Active = 'ACTIVE',
  /** The user is disabled and cannot access the agency */
  Disabled = 'DISABLED'
}

/**
 * Agency-wide policy that constrains the visibility levels available to members.
 * Updated through the existing updateAgency mutation by an agency admin.
 */
export type AgencyVisibilityPolicy = {
  __typename?: 'AgencyVisibilityPolicy';
  /**
   * When true, members may not set objects to PRIVATE — the minimum allowed
   * visibility for new or updated objects becomes SHARED. Existing PRIVATE rows
   * are not retroactively coerced; the policy applies on the next mutation only.
   */
  disallowPrivate: Scalars['Boolean']['output'];
};

/**
 * Input type for updating an agency's visibility policy. Mirrors
 * AgencyVisibilityPolicy. Used as a nested field in updateAgency input flows.
 */
export type AgencyVisibilityPolicyInput = {
  disallowPrivate: Scalars['Boolean']['input'];
};

/** AgencyZoomConfiguration contains configuration for the Agency Zoom integration */
export type AgencyZoomConfiguration = {
  __typename?: 'AgencyZoomConfiguration';
  /** If enabled, will sync accounts from Cara to Agency Zoom. */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to Agency Zoom. */
  enableSyncTasks: Scalars['Boolean']['output'];
  /** If enabled, allows users to log in to Agency Zoom via SSO. */
  isSSOLogin: Scalars['Boolean']['output'];
  /** Agency Zoom username for basic authentication */
  username: Scalars['String']['output'];
};

export type AgencyZoomContactEntry = {
  __typename?: 'AgencyZoomContactEntry';
  birthday?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomCustomerFields = {
  __typename?: 'AgencyZoomCustomerFields';
  annualRevenue?: Maybe<Scalars['StringInt']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactMiddleName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isBusinessCustomer?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['StringInt']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  tagNames?: Maybe<Scalars['String']['output']>;
  totalPayroll?: Maybe<Scalars['StringInt']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomDriverFields = {
  __typename?: 'AgencyZoomDriverFields';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomLeadFields = {
  __typename?: 'AgencyZoomLeadFields';
  agencyNumber?: Maybe<Scalars['String']['output']>;
  annualRevenue?: Maybe<Scalars['StringInt']['output']>;
  assignTo?: Maybe<Scalars['StringInt']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  businessClassification?: Maybe<Scalars['String']['output']>;
  businessEntity?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactDate?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  csrId?: Maybe<Scalars['StringInt']['output']>;
  departmentCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadId?: Maybe<Scalars['String']['output']>;
  leadSourceId?: Maybe<Scalars['StringInt']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nextExpirationDate?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['StringInt']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['StringInt']['output']>;
  quoteDate?: Maybe<Scalars['String']['output']>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  stageId?: Maybe<Scalars['StringInt']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  tagNames?: Maybe<Scalars['String']['output']>;
  totalPayroll?: Maybe<Scalars['StringInt']['output']>;
  xDate?: Maybe<Scalars['String']['output']>;
  yearBusinessStarted?: Maybe<Scalars['StringInt']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomOpportunityFields = {
  __typename?: 'AgencyZoomOpportunityFields';
  carrierId?: Maybe<Scalars['StringInt']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['StringInt']['output']>;
  leadId?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['StringInt']['output']>;
  product?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomPolicyFields = {
  __typename?: 'AgencyZoomPolicyFields';
  agencyNumber?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['StringInt']['output']>;
  bindDate?: Maybe<Scalars['String']['output']>;
  brokerFee?: Maybe<Scalars['StringInt']['output']>;
  cancellationDate?: Maybe<Scalars['String']['output']>;
  carrierId?: Maybe<Scalars['StringInt']['output']>;
  csrId?: Maybe<Scalars['StringInt']['output']>;
  customerId?: Maybe<Scalars['StringInt']['output']>;
  departmentCode?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  insuredName?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['StringInt']['output']>;
  leadSourceId?: Maybe<Scalars['StringInt']['output']>;
  lineOfBusiness?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Scalars['StringInt']['output']>;
  premium?: Maybe<Scalars['StringInt']['output']>;
  priorCarrierName?: Maybe<Scalars['String']['output']>;
  priorExpiryDate?: Maybe<Scalars['String']['output']>;
  priorPolicyNumber?: Maybe<Scalars['String']['output']>;
  renewalDate?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  standardCarrierCode?: Maybe<Scalars['String']['output']>;
  standardProductLineCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  tagNames?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomQuoteFields = {
  __typename?: 'AgencyZoomQuoteFields';
  carrierCode?: Maybe<Scalars['String']['output']>;
  carrierId?: Maybe<Scalars['StringInt']['output']>;
  items?: Maybe<Scalars['StringInt']['output']>;
  leadId?: Maybe<Scalars['StringInt']['output']>;
  premium?: Maybe<Scalars['StringInt']['output']>;
  productLineCode?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['StringInt']['output']>;
};

export type AgencyZoomTaskFields = {
  __typename?: 'AgencyZoomTaskFields';
  assigneeId?: Maybe<Scalars['StringInt']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['StringInt']['output']>;
  dueDatetime?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['StringInt']['output']>;
  invitees?: Maybe<Array<Scalars['String']['output']>>;
  leadId?: Maybe<Scalars['StringInt']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timeSpecific?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomVehicleFields = {
  __typename?: 'AgencyZoomVehicleFields';
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['StringInt']['output']>;
};

/** Represents a tool for managing all AgencyZoom entities (customers, leads, policies, tasks, etc.). */
export type AgencyZoomWriteTool = {
  __typename?: 'AgencyZoomWriteTool';
  input: AgencyZoomWriteToolInput;
  output: AgencyZoomWriteToolOutput;
};

export type AgencyZoomWriteToolInput = {
  __typename?: 'AgencyZoomWriteToolInput';
  contacts?: Maybe<Array<AgencyZoomContactEntry>>;
  customer?: Maybe<AgencyZoomCustomerFields>;
  driver?: Maybe<AgencyZoomDriverFields>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  lead?: Maybe<AgencyZoomLeadFields>;
  noteContent?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<AgencyZoomOpportunityFields>;
  policy?: Maybe<AgencyZoomPolicyFields>;
  quote?: Maybe<AgencyZoomQuoteFields>;
  task?: Maybe<AgencyZoomTaskFields>;
  vehicle?: Maybe<AgencyZoomVehicleFields>;
};

export type AgencyZoomWriteToolOutput = {
  __typename?: 'AgencyZoomWriteToolOutput';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Ams360ActivityAttachmentFields = {
  __typename?: 'Ams360ActivityAttachmentFields';
  activityId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  storageOption?: Maybe<Scalars['String']['output']>;
};

export type Ams360ActivityCommentFields = {
  __typename?: 'Ams360ActivityCommentFields';
  action?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
};

export type Ams360ActivityFields = {
  __typename?: 'Ams360ActivityFields';
  action?: Maybe<Scalars['String']['output']>;
  agencyNumber?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type Ams360CustomerContactFields = {
  __typename?: 'Ams360CustomerContactFields';
  address1?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preferredContactMethod?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Ams360CustomerFields = {
  __typename?: 'Ams360CustomerFields';
  accountExecName?: Maybe<Scalars['String']['output']>;
  accountRepName?: Maybe<Scalars['String']['output']>;
  acquisition?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  alternateBillingAddress1?: Maybe<Scalars['String']['output']>;
  alternateBillingAddress2?: Maybe<Scalars['String']['output']>;
  alternateBillingCity?: Maybe<Scalars['String']['output']>;
  alternateBillingCountry?: Maybe<Scalars['String']['output']>;
  alternateBillingCounty?: Maybe<Scalars['String']['output']>;
  alternateBillingName?: Maybe<Scalars['String']['output']>;
  alternateBillingState?: Maybe<Scalars['String']['output']>;
  alternateBillingZipCode?: Maybe<Scalars['String']['output']>;
  autoCheckActivePolicyTypes?: Maybe<Scalars['Boolean']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  brokerName?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessOrigin?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactPreferenceNotes?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  customerAddedDate?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerIsActive?: Maybe<Scalars['Boolean']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  dba?: Maybe<Scalars['String']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  divisionName?: Maybe<Scalars['String']['output']>;
  electronicDelivery?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeAccessSecured?: Maybe<Scalars['Boolean']['output']>;
  excludeFromPurge?: Maybe<Scalars['Boolean']['output']>;
  excludeFromTargetList?: Maybe<Scalars['Boolean']['output']>;
  faxPhone?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formalSalutation?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  inBusinessSince?: Maybe<Scalars['String']['output']>;
  informalSalutation?: Maybe<Scalars['String']['output']>;
  isBrokerCustomer?: Maybe<Scalars['Boolean']['output']>;
  knownByAgencySince?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  marketingSolicitation?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  multiEntityCustomerType?: Maybe<Scalars['String']['output']>;
  notation?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  otherPhone?: Maybe<Scalars['String']['output']>;
  pagerPhone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policyTypeBenefits?: Maybe<Scalars['Boolean']['output']>;
  policyTypeCommercial?: Maybe<Scalars['Boolean']['output']>;
  policyTypeFinancialServices?: Maybe<Scalars['Boolean']['output']>;
  policyTypeHealth?: Maybe<Scalars['Boolean']['output']>;
  policyTypeLife?: Maybe<Scalars['Boolean']['output']>;
  policyTypeNonPAndC?: Maybe<Scalars['Boolean']['output']>;
  policyTypePersonal?: Maybe<Scalars['Boolean']['output']>;
  preferredContactMethod?: Maybe<Scalars['String']['output']>;
  preferredDistributionMethod?: Maybe<Scalars['String']['output']>;
  referralLocation?: Maybe<Scalars['String']['output']>;
  referralName?: Maybe<Scalars['String']['output']>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  trackReceivables?: Maybe<Scalars['String']['output']>;
  useAlternateBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  useAlternateBillingName?: Maybe<Scalars['Boolean']['output']>;
  webAddress?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Ams360PolicyContactFields = {
  __typename?: 'Ams360PolicyContactFields';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxPhone?: Maybe<Scalars['String']['output']>;
  formalSalutation?: Maybe<Scalars['String']['output']>;
  informalSalutation?: Maybe<Scalars['String']['output']>;
  isForeign?: Maybe<Scalars['String']['output']>;
  lobId?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pagerPhone?: Maybe<Scalars['String']['output']>;
  policyContactId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  preferredContactMethod?: Maybe<Scalars['String']['output']>;
  residencePhone?: Maybe<Scalars['String']['output']>;
  responsibility?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Ams360PolicyFields = {
  __typename?: 'Ams360PolicyFields';
  billMethod?: Maybe<Scalars['String']['output']>;
  brokerCode?: Maybe<Scalars['String']['output']>;
  csrCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  descriptionBPol?: Maybe<Scalars['String']['output']>;
  excludeFromDownload?: Maybe<Scalars['String']['output']>;
  excludeFromPurge?: Maybe<Scalars['String']['output']>;
  execCode?: Maybe<Scalars['String']['output']>;
  isBusinessNewToAgency?: Maybe<Scalars['String']['output']>;
  isContinuous?: Maybe<Scalars['String']['output']>;
  isFilteredByBusinessType?: Maybe<Scalars['String']['output']>;
  isFinanced?: Maybe<Scalars['String']['output']>;
  isMultipleEntity?: Maybe<Scalars['String']['output']>;
  issuedState?: Maybe<Scalars['String']['output']>;
  notRenewable?: Maybe<Scalars['String']['output']>;
  parentCoCode?: Maybe<Scalars['String']['output']>;
  parentCompanyName?: Maybe<Scalars['String']['output']>;
  policyEffDate?: Maybe<Scalars['String']['output']>;
  policyExpDate?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyNo?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Scalars['String']['output']>;
  transactionDescription?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  typeOfBusiness?: Maybe<Scalars['String']['output']>;
  writingCoCode?: Maybe<Scalars['String']['output']>;
  writingCompanyName?: Maybe<Scalars['String']['output']>;
};

export type Ams360SuspenseFields = {
  __typename?: 'Ams360SuspenseFields';
  action?: Maybe<Scalars['String']['output']>;
  assignToEmployeeName?: Maybe<Scalars['String']['output']>;
  assignedByEmployeeName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  policyEffectiveDate?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
};

export type Ams360UploadDocumentFields = {
  __typename?: 'Ams360UploadDocumentFields';
  action?: Maybe<Scalars['String']['output']>;
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** Represents a tool for managing all AMS360 entities (customers/contacts/activities/policies/suspenses). */
export type Ams360WriteTool = {
  __typename?: 'Ams360WriteTool';
  input: Ams360WriteToolInput;
  output: Ams360WriteToolOutput;
};

export type Ams360WriteToolInput = {
  __typename?: 'Ams360WriteToolInput';
  activity?: Maybe<Ams360ActivityFields>;
  activityAttachment?: Maybe<Ams360ActivityAttachmentFields>;
  activityComment?: Maybe<Ams360ActivityCommentFields>;
  customer?: Maybe<Ams360CustomerFields>;
  customerContact?: Maybe<Ams360CustomerContactFields>;
  operation?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Ams360PolicyFields>;
  policyContact?: Maybe<Ams360PolicyContactFields>;
  suspense?: Maybe<Ams360SuspenseFields>;
  uploadDocument?: Maybe<Ams360UploadDocumentFields>;
};

export type Ams360WriteToolOutput = {
  __typename?: 'Ams360WriteToolOutput';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** A page of an account's documents (FILE entities), ordered most-recently-modified first. */
export type AmsAccountDocumentConnection = {
  __typename?: 'AmsAccountDocumentConnection';
  nodes: Array<KnowledgeGraphEntity>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * One account-scoped policy-number group in the document picker. Applied Epic
 * emits one POLICY entity per line, so `policyIds` can contain several entities
 * that share one policy number. `documentCount` counts distinct files across the
 * whole group.
 */
export type AmsAccountPolicyGroup = {
  __typename?: 'AmsAccountPolicyGroup';
  /** Number of distinct documents related to any policy entity in the group. */
  documentCount: Scalars['Int']['output'];
  /**
   * User-facing policy label. Usually the policy number; falls back to the
   * policy entity's display name when the AMS did not supply one.
   */
  label: Scalars['String']['output'];
  /** POLICY entity IDs included in this group. */
  policyIds: Array<Scalars['ID']['output']>;
  /** Canonical policy number for this group, when supplied by the AMS. */
  policyNumber?: Maybe<Scalars['String']['output']>;
};

export type AmsAccountSearchResult = {
  __typename?: 'AmsAccountSearchResult';
  entities: Array<KnowledgeGraphEntity>;
  noSupportedAms: Scalars['Boolean']['output'];
};

/**
 * Lightweight freshness/status snapshot for one AMS account. The picker polls
 * this (instead of the heavyweight amsAccountDocuments query) while a background
 * refresh runs, and refetches documents once syncedAt advances.
 */
export type AmsAccountSyncStatus = {
  __typename?: 'AmsAccountSyncStatus';
  /** The account entity; syncedAt is the freshness signal the client polls. */
  account: KnowledgeGraphEntity;
  /**
   * Whether a refresh workflow is currently running or recently failed.
   * Temporal is the source of truth — no status is persisted.
   */
  refreshState: AmsRefreshState;
};

/**
 * A policy matched by the top-level policy-number search, paired with its owning
 * account so the picker can load the policy's documents (which are account-scoped)
 * and freshen them via the per-account refresh.
 */
export type AmsPolicySearchResult = {
  __typename?: 'AmsPolicySearchResult';
  /**
   * The policy's owning ACCOUNT entity. Null only when the relationship can't be
   * resolved within a document-capable integration (an orphaned policy).
   */
  account?: Maybe<KnowledgeGraphEntity>;
  /** The matched POLICY entity (its searchMetadata carries policy number, carrier, dates). */
  policy: KnowledgeGraphEntity;
};

/** Whether a background AMS refresh is running for an account. */
export enum AmsRefreshState {
  /** The most recent refresh workflow failed (e.g. bad credentials, AMS outage). */
  Failed = 'FAILED',
  /** No refresh is running (includes "the last refresh completed"). */
  Idle = 'IDLE',
  /** A refresh workflow is currently fetching from the AMS. */
  Running = 'RUNNING'
}

/** Input for creating a new version of a workflow execution with appended tasks */
export type AppendWorkflowTasksInput = {
  /** The task definition keys to append to the execution */
  taskDefinitionKeys: Array<WorkflowTaskDefinitionKey>;
};

/**
 * Legacy tool for generating Excel files by executing Python scripts.
 * Kept so historical workspace events that used APPLICATION_FILE_GENERATOR continue to load.
 * New Excel work goes through XLSX_EDITOR. Each successful run stored a new downloadable file.
 * EDIT_UPLOADED read a source XLSX (user upload); the source file in storage was not modified.
 */
export type ApplicationFileGeneratorTool = {
  __typename?: 'ApplicationFileGeneratorTool';
  /** The input arguments for the file generation */
  input: ApplicationFileGeneratorToolInput;
  /** The result of the file generation operation */
  output: ApplicationFileGeneratorToolOutput;
};

/**
 * Input arguments for the ApplicationFileGeneratorTool.
 * Contains all necessary information to generate an application file.
 */
export type ApplicationFileGeneratorToolInput = {
  __typename?: 'ApplicationFileGeneratorToolInput';
  /** The ID of the file being created or updated */
  fileId: Scalars['String']['output'];
  /** The type of file to generate. Required. Valid values: "XLSX". */
  fileType: Scalars['String']['output'];
  /** The operation to perform */
  operation: Scalars['String']['output'];
  /** The requirements for the file */
  requirements: Scalars['String']['output'];
  /** The ID of a source file to use as a starting point (optional) */
  sourceFileId?: Maybe<Scalars['String']['output']>;
  /** The title of the file */
  title: Scalars['String']['output'];
};

/**
 * Result of an ApplicationFileGeneratorTool operation.
 * Contains information about the generated file.
 */
export type ApplicationFileGeneratorToolOutput = {
  __typename?: 'ApplicationFileGeneratorToolOutput';
  /** Any error message if the script failed */
  error?: Maybe<Scalars['String']['output']>;
  /** The ID of the generated file */
  fileId: Scalars['String']['output'];
  /**
   * The Python code that was used to generate the file.
   * This is returned so you can see what code was used and modify it if needed.
   */
  pythonCode?: Maybe<Scalars['String']['output']>;
  /** Any remarks or instructions for subsequent operations on this file. */
  remarks?: Maybe<Scalars['String']['output']>;
  /** The standard error from the Python script execution */
  stderr?: Maybe<Scalars['String']['output']>;
  /** The standard output from the Python script execution */
  stdout?: Maybe<Scalars['String']['output']>;
  /** Whether the Python script executed successfully */
  success: Scalars['Boolean']['output'];
  /** Any validation warnings or errors */
  validationMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the generated file passed validation */
  validationPassed?: Maybe<Scalars['Boolean']['output']>;
  /** The version of the artifact */
  version: Scalars['Int']['output'];
};

export type AppliedEpicActivityTaskInput = {
  __typename?: 'AppliedEpicActivityTaskInput';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
};

/** AppliedEpicApiCredentials contains the credentials for the Applied Epic API integration */
export type AppliedEpicApiCredentials = {
  __typename?: 'AppliedEpicApiCredentials';
  /** API key for the Applied Epic API integration */
  key: Scalars['String']['output'];
  /** API secret for the Applied Epic API integration */
  secret: Scalars['String']['output'];
};

/** AppliedEpicApiCredentials contains the credentials for the Applied Epic API integration */
export type AppliedEpicApiCredentialsInput = {
  /** API key for the Applied Epic API integration */
  key: Scalars['String']['input'];
  /** API secret for the Applied Epic API integration */
  secret: Scalars['String']['input'];
};

export type AppliedEpicCertAutoSectionFields = {
  __typename?: 'AppliedEpicCertAutoSectionFields';
  allOwnedAutos?: Maybe<Scalars['Boolean']['output']>;
  anyAuto?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hiredAutos?: Maybe<Scalars['Boolean']['output']>;
  limitsBodilyInjuryPerAccident?: Maybe<Scalars['String']['output']>;
  limitsBodilyInjuryPerPerson?: Maybe<Scalars['String']['output']>;
  limitsCombinedSingleLimitEachAccident?: Maybe<Scalars['String']['output']>;
  limitsPropertyDamagePerAccident?: Maybe<Scalars['String']['output']>;
  nonOwnedAutos?: Maybe<Scalars['Boolean']['output']>;
  scheduledAutos?: Maybe<Scalars['Boolean']['output']>;
};

export type AppliedEpicCertExcessSectionFields = {
  __typename?: 'AppliedEpicCertExcessSectionFields';
  deductibleRetention?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  limitsAggregate?: Maybe<Scalars['String']['output']>;
  limitsEachOccurrence?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicCertGlSectionFields = {
  __typename?: 'AppliedEpicCertGLSectionFields';
  commercialGeneralLiability?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  limitsDamageToRentedPremises?: Maybe<Scalars['String']['output']>;
  limitsEachOccurrence?: Maybe<Scalars['String']['output']>;
  limitsGeneralAggregate?: Maybe<Scalars['String']['output']>;
  limitsMedicalExpense?: Maybe<Scalars['String']['output']>;
  limitsPersonalAndAdvertisingInjury?: Maybe<Scalars['String']['output']>;
  limitsProductsCompletedOperationsAggregate?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicCertWcSectionFields = {
  __typename?: 'AppliedEpicCertWCSectionFields';
  description?: Maybe<Scalars['String']['output']>;
  limitsEmployersLiabilityDiseaseEachEmployee?: Maybe<Scalars['String']['output']>;
  limitsEmployersLiabilityDiseasePolicyLimit?: Maybe<Scalars['String']['output']>;
  limitsEmployersLiabilityEachAccident?: Maybe<Scalars['String']['output']>;
  workersCompensationStatutoryLimits?: Maybe<Scalars['Boolean']['output']>;
};

export type AppliedEpicCommercialBuildingInput = {
  __typename?: 'AppliedEpicCommercialBuildingInput';
  annualRevenues?: Maybe<Scalars['Int64']['output']>;
  buildingDescription?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  buildingNumber?: Maybe<Scalars['Int']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  descriptionOfOperations?: Maybe<Scalars['String']['output']>;
  interestCode?: Maybe<Scalars['String']['output']>;
  numberOfFullTimeEmployees?: Maybe<Scalars['Int']['output']>;
  numberOfPartTimeEmployees?: Maybe<Scalars['Int']['output']>;
  occupiedArea?: Maybe<Scalars['Int']['output']>;
  totalBuildingArea?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicCommercialLossHistoryItemInput = {
  __typename?: 'AppliedEpicCommercialLossHistoryItemInput';
  amountPaid?: Maybe<Scalars['Int']['output']>;
  amountReserved?: Maybe<Scalars['Int']['output']>;
  claimOpenCode?: Maybe<Scalars['String']['output']>;
  dateOfClaim?: Maybe<Scalars['String']['output']>;
  dateOfOccurrence?: Maybe<Scalars['String']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  descriptionOfOccurrenceOrClaim?: Maybe<Scalars['String']['output']>;
  lineType?: Maybe<Scalars['String']['output']>;
  lossHistoryId?: Maybe<Scalars['Int']['output']>;
  subrogationCode?: Maybe<Scalars['String']['output']>;
  typeOfLoss?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicCommercialStatusSectionInput = {
  __typename?: 'AppliedEpicCommercialStatusSectionInput';
  attached?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
};

/** AppliedEpicConfiguration contains configuration for the Applied Epic integration */
export type AppliedEpicConfiguration = {
  __typename?: 'AppliedEpicConfiguration';
  /** API credentials for Applied Epic integration */
  apiCredentials?: Maybe<AppliedEpicApiCredentials>;
  /** SDK key for Applied Epic integration */
  sdkCredentials?: Maybe<AppliedEpicSdkCredentials>;
  /** Type of Applied Epic integration */
  type: AppliedEpicIntegrationType;
};

export type AppliedEpicCreateActivityFields = {
  __typename?: 'AppliedEpicCreateActivityFields';
  activityCode?: Maybe<Scalars['String']['output']>;
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  contactVia?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<AppliedEpicActivityTaskInput>>;
};

export type AppliedEpicCreateCertificateOfInsuranceFields = {
  __typename?: 'AppliedEpicCreateCertificateOfInsuranceFields';
  automobileLiability?: Maybe<AppliedEpicCertAutoSectionFields>;
  certificateTypeDescription?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  descriptionOfOperations?: Maybe<Scalars['String']['output']>;
  excessUmbrella?: Maybe<AppliedEpicCertExcessSectionFields>;
  generalLiability?: Maybe<AppliedEpicCertGlSectionFields>;
  holderCity?: Maybe<Scalars['String']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  holderStateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  holderStreet1?: Maybe<Scalars['String']['output']>;
  holderStreet2?: Maybe<Scalars['String']['output']>;
  holderZipOrPostalCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourcePolicyId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workersComp?: Maybe<AppliedEpicCertWcSectionFields>;
};

/** AppliedEpicIntegrationType defines the type of Applied Epic integration */
export enum AppliedEpicIntegrationType {
  /** API integration */
  Api = 'API',
  /** SDK integration */
  Sdk = 'SDK'
}

export type AppliedEpicManageCommercialOtherNamedInsuredFields = {
  __typename?: 'AppliedEpicManageCommercialOtherNamedInsuredFields';
  action?: Maybe<Scalars['String']['output']>;
  businessTypeCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  glCode?: Maybe<Scalars['String']['output']>;
  naics?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameTypeCode?: Maybe<Scalars['String']['output']>;
  otherNamedInsuredId?: Maybe<Scalars['Int']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  sic?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicManageCommercialPremiseFields = {
  __typename?: 'AppliedEpicManageCommercialPremiseFields';
  action?: Maybe<Scalars['String']['output']>;
  buildings?: Maybe<Array<AppliedEpicCommercialBuildingInput>>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  isBlanketLocation?: Maybe<Scalars['Boolean']['output']>;
  locationNumber?: Maybe<Scalars['Int']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  premiseId?: Maybe<Scalars['Int']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicManageCommercialPriorCarrierFields = {
  __typename?: 'AppliedEpicManageCommercialPriorCarrierFields';
  action?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['Int']['output']>;
  inceptionYear?: Maybe<Scalars['Int']['output']>;
  lob?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  priorCarrierId?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicManageCommercialRemarkFields = {
  __typename?: 'AppliedEpicManageCommercialRemarkFields';
  action?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  printOnForm?: Maybe<Scalars['Boolean']['output']>;
  remarkId?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicManagePersonalGaragingLocationFields = {
  __typename?: 'AppliedEpicManagePersonalGaragingLocationFields';
  action?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  isPrimaryPremise?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationNumber?: Maybe<Scalars['Int']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicManagePersonalRemarkFields = {
  __typename?: 'AppliedEpicManagePersonalRemarkFields';
  action?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  printOnForm?: Maybe<Scalars['Boolean']['output']>;
  remarkId?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicPersonalLossHistoryItemInput = {
  __typename?: 'AppliedEpicPersonalLossHistoryItemInput';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  descriptionOf?: Maybe<Scalars['String']['output']>;
  lineTypeCode?: Maybe<Scalars['String']['output']>;
  lossDate?: Maybe<Scalars['String']['output']>;
  lossHistoryId?: Maybe<Scalars['Int']['output']>;
  lossType?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicPersonalPriorCoverageInput = {
  __typename?: 'AppliedEpicPersonalPriorCoverageInput';
  expirationDate?: Maybe<Scalars['String']['output']>;
  lineTypeCode?: Maybe<Scalars['String']['output']>;
  priorCarrier?: Maybe<Scalars['String']['output']>;
  priorPolicyNumber?: Maybe<Scalars['String']['output']>;
  slot?: Maybe<Scalars['Int']['output']>;
};

/** AppliedEpicSdkCredentials contains the credentials for the Applied Epic SDK integration */
export type AppliedEpicSdkCredentials = {
  __typename?: 'AppliedEpicSdkCredentials';
  /** API secret for the Applied Epic SDK integration */
  authKey: Scalars['String']['output'];
  /** Base URL for the Applied Epic SDK integration */
  baseUrl: Scalars['String']['output'];
  /** API key for the Applied Epic SDK integration */
  databaseName: Scalars['String']['output'];
};

/** AppliedEpicSdkCredentials contains the credentials for the Applied Epic SDK integration */
export type AppliedEpicSdkCredentialsInput = {
  /** Auth key for the Applied Epic SDK integration */
  authKey: Scalars['String']['input'];
  /** Base URL for the Applied Epic SDK integration */
  baseUrl: Scalars['String']['input'];
  /** Database name for the Applied Epic SDK integration */
  databaseName: Scalars['String']['input'];
};

export type AppliedEpicUnderwritingAnswerInput = {
  __typename?: 'AppliedEpicUnderwritingAnswerInput';
  answer?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  questionNumber?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdateCommercialApplicantFields = {
  __typename?: 'AppliedEpicUpdateCommercialApplicantFields';
  businessStartedDate?: Maybe<Scalars['String']['output']>;
  businessTypeCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  descriptionOfPrimaryOperations?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  glCode?: Maybe<Scalars['String']['output']>;
  naicsCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  natureOfBusinessCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdateCommercialGeneralInfoFields = {
  __typename?: 'AppliedEpicUpdateCommercialGeneralInfoFields';
  answers?: Maybe<Array<AppliedEpicUnderwritingAnswerInput>>;
  clientId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdateCommercialLossHistoryFields = {
  __typename?: 'AppliedEpicUpdateCommercialLossHistoryFields';
  checkIfNone?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<AppliedEpicCommercialLossHistoryItemInput>>;
  policyId?: Maybe<Scalars['String']['output']>;
  totalLosses?: Maybe<Scalars['Float']['output']>;
};

export type AppliedEpicUpdateCommercialStatusFields = {
  __typename?: 'AppliedEpicUpdateCommercialStatusFields';
  accountNumber?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  companyPolicyOrProgramName?: Maybe<Scalars['String']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  isRenewal?: Maybe<Scalars['Boolean']['output']>;
  methodOfPayment?: Maybe<Scalars['String']['output']>;
  minimumPremium?: Maybe<Scalars['Float']['output']>;
  paymentPlanCode?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyPremium?: Maybe<Scalars['Float']['output']>;
  programCode?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<AppliedEpicCommercialStatusSectionInput>>;
};

export type AppliedEpicUpdatePersonalApplicantFields = {
  __typename?: 'AppliedEpicUpdatePersonalApplicantFields';
  applicantName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  insuredName?: Maybe<Scalars['String']['output']>;
  maritalStatusCode?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  socialSecurityNumber?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdatePersonalGeneralInfoFields = {
  __typename?: 'AppliedEpicUpdatePersonalGeneralInfoFields';
  answers?: Maybe<Array<AppliedEpicUnderwritingAnswerInput>>;
  clientId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdatePersonalPaymentPlanFields = {
  __typename?: 'AppliedEpicUpdatePersonalPaymentPlanFields';
  billingCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  dayOfMonthDue?: Maybe<Scalars['Int']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  estimatedTotalPremium?: Maybe<Scalars['Float']['output']>;
  firstPaymentDueDate?: Maybe<Scalars['String']['output']>;
  methodCode?: Maybe<Scalars['String']['output']>;
  paymentPlanCode?: Maybe<Scalars['String']['output']>;
  payorCode?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdatePersonalPolicySectionsFields = {
  __typename?: 'AppliedEpicUpdatePersonalPolicySectionsFields';
  clientId?: Maybe<Scalars['String']['output']>;
  companyPlan?: Maybe<Scalars['String']['output']>;
  isPersonalAutoSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  isPersonalInlandMarineSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  isPersonalUmbrellaSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  isResidentialSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  isWatercraftSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  otherSection1?: Maybe<Scalars['String']['output']>;
  otherSection2?: Maybe<Scalars['String']['output']>;
  otherSection3?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdatePersonalPriorCoverageFields = {
  __typename?: 'AppliedEpicUpdatePersonalPriorCoverageFields';
  clientId?: Maybe<Scalars['String']['output']>;
  lossItems?: Maybe<Array<AppliedEpicPersonalLossHistoryItemInput>>;
  lossesAtAnyLocationYesNo?: Maybe<Scalars['String']['output']>;
  noPriorCoverage?: Maybe<Scalars['Boolean']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  priorCoverages?: Maybe<Array<AppliedEpicPersonalPriorCoverageInput>>;
  yearsLossesAtAnyLocation?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicUpdateTaskFields = {
  __typename?: 'AppliedEpicUpdateTaskFields';
  activityId?: Maybe<Scalars['String']['output']>;
  addNotes?: Maybe<Array<Scalars['String']['output']>>;
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUploadDocumentFields = {
  __typename?: 'AppliedEpicUploadDocumentFields';
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a tool for managing Applied Epic write operations: creating
 * activities (with tasks and task notes), updating a task (mark complete /
 * change status / append notes / reschedule / reassign), creating ACORD 25
 * (Liability) Certificates of Insurance, and uploading documents.
 */
export type AppliedEpicWriteTool = {
  __typename?: 'AppliedEpicWriteTool';
  input: AppliedEpicWriteToolInput;
  output: AppliedEpicWriteToolOutput;
};

export type AppliedEpicWriteToolInput = {
  __typename?: 'AppliedEpicWriteToolInput';
  createActivity?: Maybe<AppliedEpicCreateActivityFields>;
  createCertificateOfInsurance?: Maybe<AppliedEpicCreateCertificateOfInsuranceFields>;
  manageCommercialOtherNamedInsured?: Maybe<AppliedEpicManageCommercialOtherNamedInsuredFields>;
  manageCommercialPremise?: Maybe<AppliedEpicManageCommercialPremiseFields>;
  manageCommercialPriorCarrier?: Maybe<AppliedEpicManageCommercialPriorCarrierFields>;
  manageCommercialRemark?: Maybe<AppliedEpicManageCommercialRemarkFields>;
  managePersonalGaragingLocation?: Maybe<AppliedEpicManagePersonalGaragingLocationFields>;
  managePersonalRemark?: Maybe<AppliedEpicManagePersonalRemarkFields>;
  operation?: Maybe<Scalars['String']['output']>;
  updateCommercialApplicant?: Maybe<AppliedEpicUpdateCommercialApplicantFields>;
  updateCommercialGeneralInfo?: Maybe<AppliedEpicUpdateCommercialGeneralInfoFields>;
  updateCommercialLossHistory?: Maybe<AppliedEpicUpdateCommercialLossHistoryFields>;
  updateCommercialStatus?: Maybe<AppliedEpicUpdateCommercialStatusFields>;
  updatePersonalApplicant?: Maybe<AppliedEpicUpdatePersonalApplicantFields>;
  updatePersonalGeneralInfo?: Maybe<AppliedEpicUpdatePersonalGeneralInfoFields>;
  updatePersonalPaymentPlan?: Maybe<AppliedEpicUpdatePersonalPaymentPlanFields>;
  updatePersonalPolicySections?: Maybe<AppliedEpicUpdatePersonalPolicySectionsFields>;
  updatePersonalPriorCoverage?: Maybe<AppliedEpicUpdatePersonalPriorCoverageFields>;
  updateTask?: Maybe<AppliedEpicUpdateTaskFields>;
  uploadDocument?: Maybe<AppliedEpicUploadDocumentFields>;
};

export type AppliedEpicWriteToolOutput = {
  __typename?: 'AppliedEpicWriteToolOutput';
  activityId?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  automobileLiabilityId?: Maybe<Scalars['String']['output']>;
  certificateId?: Maybe<Scalars['String']['output']>;
  createdTaskIds?: Maybe<Array<Scalars['String']['output']>>;
  excessUmbrellaId?: Maybe<Scalars['String']['output']>;
  generalLiabilityId?: Maybe<Scalars['String']['output']>;
  holderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  recordId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  taskStatus?: Maybe<Scalars['String']['output']>;
  workersCompId?: Maybe<Scalars['String']['output']>;
};

/**
 * Deprecated compatibility input for archiveWordDocumentTemplates. New callers
 * should use UpdateWordDocumentTemplatesInput with updateWordDocumentTemplates.
 */
export type ArchiveWordDocumentTemplatesInput = {
  /** Whether to archive the Word document templates */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the Word document templates.
   * Existing documents generated from them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Mode for creating an Ascend program */
export enum AscendProgramCreationMode {
  /** Bundle with an existing quote */
  BundleWithExistingQuote = 'BUNDLE_WITH_EXISTING_QUOTE',
  /** Create a new program */
  CreateProgram = 'CREATE_PROGRAM',
  /** Use a specific program ID */
  UseSpecificProgramId = 'USE_SPECIFIC_PROGRAM_ID'
}

/** BasicAuth contains username/password credentials */
export type BasicAuth = {
  __typename?: 'BasicAuth';
  /** Password for basic authentication */
  password: Scalars['String']['output'];
  /** Username for basic authentication */
  username: Scalars['String']['output'];
};

/** BearerAuth contains a bearer token for authentication */
export type BearerAuth = {
  __typename?: 'BearerAuth';
  /** Bearer token for authentication */
  token: Scalars['String']['output'];
};

/** A blanket additional insured for the certificate */
export type BlanketAdditionalInsuredCertificateOption = {
  __typename?: 'BlanketAdditionalInsuredCertificateOption';
  /** The description of the blanket additional insured */
  description: Scalars['String']['output'];
  /** The ID of the blanket additional insured */
  id: Scalars['ID']['output'];
  /** The policy this blanket additional insured is associated with */
  policy: BusinessPolicy;
  /** The type of the blanket additional insured */
  type: Scalars['String']['output'];
};

/**
 * Arguments for buildHtmlDocumentRenderUrl. Grouped in one input so new fields can be added without
 * breaking existing GraphQL callers.
 */
export type BuildHtmlDocumentRenderUrlInput = {
  artifactId: Scalars['ID']['input'];
  prefixAttachments: Array<PdfRenderAttachmentInput>;
  /** ACORD template form only: producer information ID for signature stamping */
  producerInformationId?: InputMaybe<Scalars['ID']['input']>;
  skipTemplateFiles?: InputMaybe<Scalars['Boolean']['input']>;
  styleId?: InputMaybe<Scalars['String']['input']>;
  suffixAttachments: Array<PdfRenderAttachmentInput>;
  version: Scalars['Int']['input'];
  workspaceId: Scalars['ID']['input'];
};

/** Account details specific to a business account */
export type BusinessAccount = AccountDetails & {
  __typename?: 'BusinessAccount';
  /** The 'Doing Business As' (DBA) name if different from legal name */
  dba: Scalars['String']['output'];
  /** Primary email address for contacting the business */
  email: Scalars['String']['output'];
  /** Mailing address for the business */
  mailingAddress: Address;
  /** The legal name of the business */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the business */
  phone: Scalars['String']['output'];
  /** Website URL for the business */
  website: Scalars['String']['output'];
};

/** Business Policy represents the business or commercial insurance policy */
export type BusinessPolicy = {
  __typename?: 'BusinessPolicy';
  /** The account this policy is associated with */
  account: Account;
  /** The agency user that sources or owns the policy */
  agencyUser: AgencyUser;
  /** The broker providing this policy, if any */
  broker?: Maybe<InsuranceCarrier>;
  /** If the policy was canceled or nonrenewed, information about the latest instance of cancellation or nonrenewal */
  cancellation?: Maybe<BusinessPolicyCancellation>;
  /** The carrier providing this policy */
  carrier: InsuranceCarrier;
  /** The date the policy object was originally created */
  createdAt: Scalars['Time']['output'];
  /** Detailed information extracted from the policy document, if available */
  details?: Maybe<BusinessPolicyExtractedDetails>;
  /** The timestamp when this policy expires */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /** All attached files for this policy */
  files: Array<File>;
  /** The internal ID of the policy */
  id: Scalars['ID']['output'];
  /** The timestamp when this policy is inforce */
  inforceAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when this policy was issued */
  issuedAt?: Maybe<Scalars['Time']['output']>;
  /** The market this policy was written in */
  market: InsuranceMarket;
  /** The number or external identifier associated with this policy within the carrier system */
  policyNumber: Scalars['String']['output'];
  /** The pricing information for this policy */
  pricing: BusinessPolicyPricing;
  /** The number or external identifier associated with this quote within the carrier system */
  quoteNumber: Scalars['String']['output'];
  /** If the policy was reinstated, information about the latest instance of when it was reinstated */
  reinstatement?: Maybe<BusinessPolicyReinstatement>;
  /** If this policy was renewed from another policy, information about the renewal and its previous versions */
  renewal?: Maybe<BusinessPolicyRenewal>;
  /** The current state of the policy */
  state: PolicyState;
  /** The type of insurance this policy represents */
  type: InsuranceType;
  /** The date this policy object was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this policy */
  version: Scalars['Int64']['output'];
  /** The previous versions of this policy. The first version in this list will be this version (i.e. identical to the current policy), followed by the version before that, and so-forth. */
  versionHistory?: Maybe<Array<BusinessPolicyVersion>>;
};

/** Details about agency billing for a business policy */
export type BusinessPolicyAgencyBilling = {
  __typename?: 'BusinessPolicyAgencyBilling';
  /** The type of agency billing used */
  type: BusinessPolicyAgencyBillingType;
};

/** The type of agency billing used for the policy */
export enum BusinessPolicyAgencyBillingType {
  /** Billing is handled through Ascend */
  Ascend = 'ASCEND',
  /** Billing is handled manually */
  Manual = 'MANUAL'
}

/** The billing type of policy, indicating how the policy is billed */
export enum BusinessPolicyBillingType {
  /** Policy is billed by the agency and then paid to the carrier */
  Agency = 'AGENCY',
  /** Policy is billed directly by the carrier */
  Direct = 'DIRECT',
  /** Billing type is unknown or not specified */
  Unknown = 'UNKNOWN'
}

/** A blanket additional insured for the policy */
export type BusinessPolicyBlanketAdditionalInsured = {
  __typename?: 'BusinessPolicyBlanketAdditionalInsured';
  /** The description of the blanket additional insured */
  description: Scalars['String']['output'];
  /** The form numbers that reference the blanket additional insured */
  formNumbers: Array<Scalars['String']['output']>;
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the blanket additional insured is included */
  reasoning: Scalars['String']['output'];
  /** The type of the blanket additional insured */
  type: Scalars['String']['output'];
};

/** Detailed information about a policy cancellation */
export type BusinessPolicyCancellation = {
  __typename?: 'BusinessPolicyCancellation';
  /** The date and time when the cancellation was initiated */
  canceledAt: Scalars['Time']['output'];
  /** The entity that initiated the cancellation */
  canceledBy: BusinessPolicyCancellationSource;
  /** The date and time when the cancellation becomes effective */
  effectiveAt: Scalars['Time']['output'];
  /** The reason for the cancellation */
  reason: BusinessPolicyCancellationReason;
  /** A detailed description of the cancellation reason */
  reasonDescription: Scalars['String']['output'];
  /** The commission that the agency will return to the carrier or broker */
  returnCommission: Scalars['Float']['output'];
  /** The premium that the agency will return to the customer */
  returnPremium: Scalars['Float']['output'];
  /** The type of cancellation */
  type: BusinessPolicyCancellationType;
};

/** The reason for policy cancellation */
export enum BusinessPolicyCancellationReason {
  /** Agency found better coverage for the insured */
  AgencyFoundBetterCoverage = 'AGENCY_FOUND_BETTER_COVERAGE',
  /** Agency found a better price for the insured */
  AgencyFoundBetterPrice = 'AGENCY_FOUND_BETTER_PRICE',
  /** Carrier closed the insurance class */
  CarrierClosedClass = 'CARRIER_CLOSED_CLASS',
  /** Cancellation due to loss history */
  CarrierLossHistory = 'CARRIER_LOSS_HISTORY',
  /** Carrier cancelled due to non-payment */
  CarrierNonpayment = 'CARRIER_NONPAYMENT',
  /** Carrier's underwriting decision */
  CarrierUnderwritingReason = 'CARRIER_UNDERWRITING_REASON',
  /** Insured closed their business */
  InsuredClosedBusiness = 'INSURED_CLOSED_BUSINESS',
  /** Insured found better coverage elsewhere */
  InsuredFoundBetterCoverage = 'INSURED_FOUND_BETTER_COVERAGE',
  /** Insured found a better price elsewhere */
  InsuredFoundBetterPrice = 'INSURED_FOUND_BETTER_PRICE',
  /** Insured failed to make payments */
  InsuredNonpayment = 'INSURED_NONPAYMENT',
  /** Insured no longer has exposure requiring coverage */
  InsuredNoExposure = 'INSURED_NO_EXPOSURE',
  /** Other unspecified reason */
  Other = 'OTHER'
}

/** The source of the policy cancellation */
export enum BusinessPolicyCancellationSource {
  /** Cancellation initiated by the agency */
  Agency = 'AGENCY',
  /** Cancellation initiated by the carrier */
  Carrier = 'CARRIER',
  /** Cancellation initiated by the insured */
  Insured = 'INSURED'
}

/** The type of policy cancellation */
export enum BusinessPolicyCancellationType {
  /** Standard cancellation of the policy */
  Cancellation = 'CANCELLATION',
  /** Non-renewal of the policy */
  Nonrenewal = 'NONRENEWAL',
  /** Expiration of the quote without conversion to a policy */
  QuoteExpired = 'QUOTE_EXPIRED'
}

/** Description of a policy coverage or exclusion */
export type BusinessPolicyCoverageOrExclusionDescription = {
  __typename?: 'BusinessPolicyCoverageOrExclusionDescription';
  /** The description of the coverage or exclusion */
  description: Scalars['String']['output'];
  /** Supporting quotes from the policy document */
  policyQuotes: Array<Scalars['String']['output']>;
  /** The title of the coverage or exclusion */
  title: Scalars['String']['output'];
};

/** An endorsement for the policy */
export type BusinessPolicyEndorsement = {
  __typename?: 'BusinessPolicyEndorsement';
  /** The form numbers that reference the endorsement */
  formNumbers: Array<Scalars['String']['output']>;
  /** Whether the endorsement is included */
  included: Scalars['Boolean']['output'];
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the endorsement is included */
  reasoning: Scalars['String']['output'];
};

/** The endorsements for the policy */
export type BusinessPolicyEndorsements = {
  __typename?: 'BusinessPolicyEndorsements';
  /** Whether the primary and non-contributory coverage endorsement is included */
  primaryAndNonContributoryCoverage: BusinessPolicyEndorsement;
  /** Whether the waiver of subrogation endorsement is included */
  waiverOfSubrogation: BusinessPolicyEndorsement;
};

/** Entity involved in the policy */
export type BusinessPolicyEntity = {
  __typename?: 'BusinessPolicyEntity';
  /** The address of the entity */
  address: Address;
  /** The name of the entity */
  name: Scalars['String']['output'];
};

/** Extra limits for the policy, not covered by the standard limits */
export type BusinessPolicyExtraInsuranceLimit = {
  __typename?: 'BusinessPolicyExtraInsuranceLimit';
  /** The limit for the extra coverage */
  limit: Scalars['Float']['output'];
  /** The name of the limit */
  name: Scalars['String']['output'];
};

/** Policy details extracted from the policy document */
export type BusinessPolicyExtractedDetails = {
  __typename?: 'BusinessPolicyExtractedDetails';
  /** The blanket additional insureds for the policy */
  blanketAdditionalInsureds: Array<BusinessPolicyBlanketAdditionalInsured>;
  /** The carrier on the policy */
  carrier?: Maybe<BusinessPolicyEntity>;
  /** The carrier's NAIC code */
  carrierNaic?: Maybe<Scalars['String']['output']>;
  /** The coverage descriptions for the policy */
  coverageDescriptions: Array<BusinessPolicyCoverageOrExclusionDescription>;
  /** The deductible for the policy */
  deductible?: Maybe<Scalars['Float']['output']>;
  /** The endorsements for the policy */
  endorsements: BusinessPolicyEndorsements;
  /** The exclusion descriptions for the policy */
  exclusionDescriptions: Array<BusinessPolicyCoverageOrExclusionDescription>;
  /** Extra limits for the policy, not covered by the standard limits */
  extraLimits: Array<BusinessPolicyExtraInsuranceLimit>;
  /** The insured on the policy */
  insured?: Maybe<BusinessPolicyEntity>;
  /** The limits for the policy */
  limits: BusinessPolicyInsuranceLimits;
  /** The insured locations for the policy */
  locations: Array<BusinessPolicyLocation>;
  /** The named additional insureds for the policy */
  namedAdditionalInsureds: Array<BusinessPolicyNamedAdditionalInsured>;
  /** The policy number */
  policyNumber?: Maybe<Scalars['String']['output']>;
  /** A summary of the policy details */
  summary?: Maybe<Scalars['String']['output']>;
};

/** Limits for the policy. The policy has the coverage and associated limit if the value is non null or zero. */
export type BusinessPolicyInsuranceLimits = {
  __typename?: 'BusinessPolicyInsuranceLimits';
  cyberAggregateLimit?: Maybe<Scalars['Float']['output']>;
  cyberRetentionLimit?: Maybe<Scalars['Float']['output']>;
  glAggregateLimit?: Maybe<Scalars['Float']['output']>;
  glMedicalPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  glMedicalPerPersonLimit?: Maybe<Scalars['Float']['output']>;
  glPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  glPersonalAndAdvertisingInjuryLimit?: Maybe<Scalars['Float']['output']>;
  glProductsAndCompletedOperationsLimit?: Maybe<Scalars['Float']['output']>;
  glRentedPremisesDamageLimit?: Maybe<Scalars['Float']['output']>;
  propertyBuildingLimit?: Maybe<Scalars['Float']['output']>;
  propertyContentsLimit?: Maybe<Scalars['Float']['output']>;
  umbrellaOrExcessAggregateLimit?: Maybe<Scalars['Float']['output']>;
  umbrellaOrExcessPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  wcPerAccidentLimit?: Maybe<Scalars['Float']['output']>;
  wcPerDiseaseEmployeeLimit?: Maybe<Scalars['Float']['output']>;
  wcPerDiseasePolicyLimit?: Maybe<Scalars['Float']['output']>;
};

/** A location covered by the business policy */
export type BusinessPolicyLocation = {
  __typename?: 'BusinessPolicyLocation';
  /** The address of the location */
  address: Address;
  /** The limits for the location */
  limits: BusinessPolicyInsuranceLimits;
};

/** A named additional insured for the policy */
export type BusinessPolicyNamedAdditionalInsured = {
  __typename?: 'BusinessPolicyNamedAdditionalInsured';
  /** The address of the named additional insured */
  address: Address;
  /** The form numbers that reference the named additional insured */
  formNumbers: Array<Scalars['String']['output']>;
  /** The type of the named additional insured */
  name: Scalars['String']['output'];
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the named additional insured is included */
  reasoning: Scalars['String']['output'];
};

/** Represents all pricing information for a policy */
export type BusinessPolicyPricing = {
  __typename?: 'BusinessPolicyPricing';
  /** The adjusted commission that the agency will receive for this policy, which is the estimated commission minus any returns to the carrier or broker. If the policy is not canceled, this will be nil. */
  adjustedCommission?: Maybe<Scalars['Float']['output']>;
  /** The adjusted premium that the agency will receive for this policy, which is the premium minus any returns to the customer. If the policy is not canceled, this will be nil. */
  adjustedPremium?: Maybe<Scalars['Float']['output']>;
  /** The adjusted revenue that the agency will receive for this policy, which is the estimated revenue minus any returns to the customer. If the policy is not canceled, this will be the same as estimatedRevenue */
  adjustedRevenue: Scalars['Float']['output'];
  /** If billing type is AGENCY, this specifies information about the agency bill */
  agencyBilling?: Maybe<BusinessPolicyAgencyBilling>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['output'];
  /** The billing type */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['output'];
  /** Estimate of the commission the agency will receive for this policy */
  estimatedCommission: Scalars['Float']['output'];
  /** Estimate of the revenue the agency will receive for this policy */
  estimatedRevenue: Scalars['Float']['output'];
  /** The interval type of payment plan. Required if this is a direct-billed policy */
  intervalType?: Maybe<PaymentIntervalType>;
  /** The minimum premium that must be paid for policy, regardless of cancellation, if any */
  minimumEarnedPremium: Scalars['Float']['output'];
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['output'];
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['output'];
  /** The premium for this policy */
  premium: Scalars['Float']['output'];
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['output'];
  /** The total price paid for this policy */
  total: Scalars['Float']['output'];
};

/** Information about a policy reinstatement */
export type BusinessPolicyReinstatement = {
  __typename?: 'BusinessPolicyReinstatement';
  /** The date and time when the reinstatement becomes effective */
  effectiveAt: Scalars['Time']['output'];
  /** A description of the reason for reinstatement */
  reasonDescription: Scalars['String']['output'];
  /** The date and time when the reinstatement was processed */
  reinstatedAt: Scalars['Time']['output'];
};

/** Information about policy renewals */
export type BusinessPolicyRenewal = {
  __typename?: 'BusinessPolicyRenewal';
  /** List of policies that renew this policy */
  nextPolicies: Array<BusinessPolicy>;
  /** List of previous policies that this policy renews */
  previousPolicies: Array<BusinessPolicy>;
};

/** Describes the reason why an application was updated */
export enum BusinessPolicyUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a policy */
export enum BusinessPolicyUpdateType {
  /** The policy was canceled and is no longer active */
  CancelPolicy = 'CANCEL_POLICY',
  /** The policy was created */
  CreatePolicy = 'CREATE_POLICY',
  /** The policy expired and its no longer active */
  ExpirePolicy = 'EXPIRE_POLICY',
  /** The policy was set to inforce */
  InforcePolicy = 'INFORCE_POLICY',
  /** The policy was reinstated after previously being canceled */
  ReinstatePolicy = 'REINSTATE_POLICY',
  /** The policy was created as a renewal */
  RenewPolicy = 'RENEW_POLICY',
  /** The policy was updated with new details extracted from the policy document */
  UpdateExtractedDetails = 'UPDATE_EXTRACTED_DETAILS',
  /** The policy was updated. Requires manual inspection of the policy to determine the actual update */
  UpdatePolicy = 'UPDATE_POLICY'
}

/** Describes a particular version of a policy */
export type BusinessPolicyVersion = {
  __typename?: 'BusinessPolicyVersion';
  /** The full policy object that includes all of the updates made in this version and all previous versions */
  businessPolicy: BusinessPolicy;
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another policy version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous policy version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<BusinessPolicyVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<BusinessPolicyUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<BusinessPolicyUpdateType>;
  /** The version number of this policy version */
  version: Scalars['Int64']['output'];
};

export enum CoiConfigurationMode {
  /**
   * Use the agency's information as the contact information and producer name.
   * This is the default mode.
   */
  Agency = 'AGENCY',
  /** Use the user's information as the contact information and producer name */
  User = 'USER'
}

/** Represents a phone call recorded through the Retell system */
export type Call = {
  __typename?: 'Call';
  /** The account associated with this call, if any */
  account?: Maybe<Account>;
  /** The agency associated with this call */
  agency: Agency;
  /** The timestamp when this call was archived */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Whether this conversation was inbound or placed by an outbound call job.
   * Defaults to INBOUND for legacy rows.
   */
  direction: CallDirection;
  /** The reason the call was disconnected, available once the call has ended */
  disconnectionReason?: Maybe<CallDisconnectionReason>;
  /** The timestamp when the call ended, if completed */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The ID of the call in the external call system (currently this is always Retell) */
  externalId: Scalars['String']['output'];
  /**
   * The name of the other party on the call (caller for inbound, customer for outbound),
   * available once the call has ended
   */
  fromName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call was from (caller for inbound, agency line for outbound) */
  fromNumber: Scalars['String']['output'];
  /** Unique identifier for the call */
  id: Scalars['ID']['output'];
  /** The outbound call job linked to this conversation, if any. */
  outboundCall?: Maybe<OutboundCall>;
  /** The URL of the recording of the call, available once the call has ended */
  recordingUrl?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this call was marked as seen/reviewed */
  seenAt?: Maybe<Scalars['Time']['output']>;
  /** The user who marked this call as seen */
  seenByUser?: Maybe<AgencyUser>;
  /** The sentiment of the call, available once the call has ended */
  sentiment?: Maybe<CallSentiment>;
  /** The service requests associated with this call, if any */
  serviceRequests: Array<ServiceRequest>;
  /** The timestamp when the call started */
  startedAt: Scalars['Time']['output'];
  /** The status of the call */
  status: CallStatus;
  /** Whether the call was successful, available once the call has ended */
  successful?: Maybe<Scalars['Boolean']['output']>;
  /** A summary of the call, available once the call has ended */
  summary?: Maybe<Scalars['String']['output']>;
  /** The phone number the call was to (agency line for inbound, customer for outbound) */
  toNumber: Scalars['String']['output'];
  /** The transcript of the call, available once the call has ended */
  transcript: Array<CallTranscriptObject>;
  /**
   * The voice agent configuration that was active at the time this call was created.
   * Returns null only for calls that have no voice agent attached.
   */
  voiceAgentConfiguration?: Maybe<VoiceAgentConfiguration>;
};

/** A cursor-paginated connection of Call records. */
export type CallConnection = {
  __typename?: 'CallConnection';
  edges: Array<CallEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Call counts for a single day */
export type CallDailyCount = {
  __typename?: 'CallDailyCount';
  /** Number of calls that started outside business hours */
  afterHoursCalls: Scalars['Int']['output'];
  /** Number of calls that started during business hours */
  businessHoursCalls: Scalars['Int']['output'];
  /** The date (start of day in the agency's timezone) */
  date: Scalars['Time']['output'];
  /** Total number of calls on this date */
  totalCalls: Scalars['Int']['output'];
};

export enum CallDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

/** The reason why a call was disconnected */
export enum CallDisconnectionReason {
  /** Expected behavior where AI agent hangs up the call */
  AgentHangup = 'AGENT_HANGUP',
  /** Expected behavior where AI agent transferred the call */
  CallTransfer = 'CALL_TRANSFER',
  /** Error where concurrency limit reached - add a retry with exponential backoff or consider enterprise plan */
  ConcurrencyLimitReached = 'CONCURRENCY_LIMIT_REACHED',
  /** The number dialed is busy */
  DialBusy = 'DIAL_BUSY',
  /** Dialing failed, might be due to callee number being non-existent, or the agent number is marked as spam and got blocked */
  DialFailed = 'DIAL_FAILED',
  /** The number dialed did not answer */
  DialNoAnswer = 'DIAL_NO_ANSWER',
  /** Error where Retell's ASR encountered a problem */
  ErrorAsr = 'ERROR_ASR',
  /** Error where frontend audio websocket received unspecified payload */
  ErrorFrontendCorruptedPayload = 'ERROR_FRONTEND_CORRUPTED_PAYLOAD',
  /** Error where system failed to retrieve dynamic variables for inbound phone call */
  ErrorInboundWebhook = 'ERROR_INBOUND_WEBHOOK',
  /** Error where LLM websocket received unspecified payload */
  ErrorLlmWebsocketCorruptPayload = 'ERROR_LLM_WEBSOCKET_CORRUPT_PAYLOAD',
  /** Error where LLM websocket connection broke during the call */
  ErrorLlmWebsocketLostConnection = 'ERROR_LLM_WEBSOCKET_LOST_CONNECTION',
  /** Error where LLM websocket did not open between Retell server and backend, likely because the Custom LLM URL is incorrect or LLM server is not reachable */
  ErrorLlmWebsocketOpen = 'ERROR_LLM_WEBSOCKET_OPEN',
  /** Error where LLM websocket received a closing signal other than 1000 from your server */
  ErrorLlmWebsocketRuntime = 'ERROR_LLM_WEBSOCKET_RUNTIME',
  /** Error where system has not received audio from Twilio or web frontend for a while after connection has established */
  ErrorNoAudioReceived = 'ERROR_NO_AUDIO_RECEIVED',
  /** Error, unspecified Retell side problem */
  ErrorRetell = 'ERROR_RETELL',
  /** Error where Twilio websocket connection between Retell server encountered an error */
  ErrorTwilio = 'ERROR_TWILIO',
  /** Error, unknown error */
  ErrorUnknown = 'ERROR_UNKNOWN',
  /** Error where user did not join web call within 30s after calling startWebCall */
  ErrorUserNotJoined = 'ERROR_USER_NOT_JOINED',
  /** Expected behavior where call was terminated due to the "end_call_after_silence_ms" setting reached after long inactivity */
  Inactivity = 'INACTIVITY',
  /** Expected behavior where call was terminated due to the "drop_call_if_machine_detected" setting triggering when a voicemail or similar is detected */
  MachineDetected = 'MACHINE_DETECTED',
  /** Expected behavior where call was terminated due to maximum duration reached */
  MaxDurationReached = 'MAX_DURATION_REACHED',
  /** Error where no valid payment registered on file, or service shut down due to bill overdue */
  NoValidPayment = 'NO_VALID_PAYMENT',
  /** Error where phone call is 30s or more apart from registering */
  RegisteredCallTimeout = 'REGISTERED_CALL_TIMEOUT',
  /** Error where scam was detected for that particular agent */
  ScamDetected = 'SCAM_DETECTED',
  /** Expected behavior where user hangs up the call */
  UserHangup = 'USER_HANGUP',
  /** Expected behavior where AI agent reached voicemail when voicemail settings were configured */
  VoicemailReached = 'VOICEMAIL_REACHED'
}

/** Count of calls for a given disconnection reason */
export type CallDisconnectionReasonCount = {
  __typename?: 'CallDisconnectionReasonCount';
  /** Number of calls with this disconnection reason */
  count: Scalars['Int']['output'];
  /** The disconnection reason */
  reason: CallDisconnectionReason;
};

/** An edge in a paginated Call connection. */
export type CallEdge = {
  __typename?: 'CallEdge';
  cursor: Scalars['String']['output'];
  node: Call;
};

/** Call feedback details */
export type CallFeedback = {
  __typename?: 'CallFeedback';
  /** Predefined reasons for negative feedback (multiple selection allowed) */
  reasons?: Maybe<Array<CallQualityFeedbackNegativeReason>>;
};

export type CallFilterInput = {
  /** The agency ID to filter by */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the call is archived (default is false) */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by call direction. Omit to return calls of any direction. */
  direction?: InputMaybe<CallDirection>;
  /** Filter by disconnection reason */
  disconnectionReason?: InputMaybe<CallDisconnectionReason>;
  /** Filter by when the call ended */
  duration?: InputMaybe<NumericFilter>;
  /** Filter by caller phone number (partial match) */
  fromNumber?: InputMaybe<Scalars['String']['input']>;
  /** The sentiment of the call */
  sentiment?: InputMaybe<CallSentiment>;
  /** Filter by when the call started */
  startedAt?: InputMaybe<DateFilter>;
  /** The status of the call */
  status?: InputMaybe<CallStatus>;
  /** Filter by whether the call was successful */
  successful?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the phone number the call was transferred to (partial match, searches transcript) */
  transferredToNumber?: InputMaybe<Scalars['String']['input']>;
  /** The voice agent ID to filter by */
  voiceAgentId?: InputMaybe<Scalars['String']['input']>;
};

/** Summary of caller-initiated hangups */
export type CallHangupCounts = {
  __typename?: 'CallHangupCounts';
  /** Total number of calls where the caller hung up */
  total: Scalars['Int']['output'];
  /** Number of calls where the caller hung up within 20 seconds */
  underTwentySeconds: Scalars['Int']['output'];
};

/**
 * Predefined reasons for negative call feedback
 * Simple, user-friendly language
 */
export enum CallQualityFeedbackNegativeReason {
  /** Cara repeated herself too frequently */
  CaraRepeatedTooMuch = 'CARA_REPEATED_TOO_MUCH',
  /** Cara didn't understand what I was saying */
  Misunderstanding = 'MISUNDERSTANDING',
  /** Other issue (specify in comment) */
  Other = 'OTHER',
  /** Poor audio quality, hard to hear */
  PoorAudioQuality = 'POOR_AUDIO_QUALITY',
  /** Time to resolution was too long */
  ResolutionTooLong = 'RESOLUTION_TOO_LONG',
  /** slow responses */
  SlowResponses = 'SLOW_RESPONSES',
  /** Cara didn't ask the right questions */
  WrongWorkflow = 'WRONG_WORKFLOW'
}

/** Aggregated call report data */
export type CallReport = {
  __typename?: 'CallReport';
  /** Average duration of completed calls in seconds */
  averageDurationSeconds: Scalars['Float']['output'];
  /** Call counts grouped by date, with business hours breakdown */
  dailyCounts: Array<CallDailyCount>;
  /** Call counts grouped by disconnection reason */
  disconnectionReasonCounts: Array<CallDisconnectionReasonCount>;
  /** Number of calls that lasted more than 60 seconds */
  fullCallCount: Scalars['Int']['output'];
  /** Summary of caller-initiated hangups */
  hangupCounts: CallHangupCounts;
  /** Number of calls that lasted between 20 and 60 seconds */
  midCallCount: Scalars['Int']['output'];
  /** Number of calls with positive sentiment */
  positiveCalls: Scalars['Int']['output'];
  /** Counts of service requests by type across the filtered calls */
  serviceRequestTypeCounts: Array<CallServiceRequestTypeCount>;
  /** Number of calls that lasted less than 20 seconds */
  shortCallCount: Scalars['Int']['output'];
  /** Number of calls marked as successful */
  successfulCalls: Scalars['Int']['output'];
  /** Total number of calls in the report */
  totalCalls: Scalars['Int']['output'];
};

/** The sentiment analysis result for a call */
export enum CallSentiment {
  /** The call had an overall negative tone/sentiment */
  Negative = 'NEGATIVE',
  /** The call had a neutral or mixed tone/sentiment */
  Neutral = 'NEUTRAL',
  /** The call had an overall positive tone/sentiment */
  Positive = 'POSITIVE'
}

/** Count of service requests for a given type */
export type CallServiceRequestTypeCount = {
  __typename?: 'CallServiceRequestTypeCount';
  /** Number of service requests of this type */
  count: Scalars['Int']['output'];
  /** The service request type */
  type: ServiceRequestType;
};

/** Sortable fields for searchCalls */
export enum CallSortField {
  Customer = 'CUSTOMER',
  DisconnectionReason = 'DISCONNECTION_REASON',
  Duration = 'DURATION',
  FromNumber = 'FROM_NUMBER',
  Sentiment = 'SENTIMENT',
  StartedAt = 'STARTED_AT',
  Status = 'STATUS'
}

/** Sort specification for searchCalls */
export type CallSortInput = {
  direction: SortDirection;
  field: CallSortField;
};

/** The current status of a call */
export enum CallStatus {
  /** The call has ended */
  Completed = 'COMPLETED',
  /** The call has ended with an error */
  Error = 'ERROR',
  /** The call is in progress */
  InProgress = 'IN_PROGRESS',
  /** The call has been registered with Retell */
  Registered = 'REGISTERED'
}

/** Represents a single utterance or action in the call transcript */
export type CallTranscriptObject = {
  __typename?: 'CallTranscriptObject';
  /** The content of the utterance or tool result */
  content: Scalars['String']['output'];
  /** The duration in seconds of the utterance or tool result */
  durationSeconds: Scalars['Float']['output'];
  /** The role of the participant or action in the transcript */
  role: CallTranscriptRole;
  /** The offset in seconds from the start of the call when the utterance or tool result was spoken or executed */
  startTimeOffsetSeconds: Scalars['Float']['output'];
  /** The arguments passed to the tool in JSON format if this is a tool invocation */
  toolArgumentsJson?: Maybe<Scalars['String']['output']>;
  /** The ID of the tool call if this is a tool invocation or result */
  toolCallId?: Maybe<Scalars['String']['output']>;
  /** The name of the tool being called if this is a tool invocation */
  toolName?: Maybe<Scalars['String']['output']>;
};

/** The role of a participant or action in the call transcript */
export enum CallTranscriptRole {
  /** Represents speech from the AI agent */
  Agent = 'AGENT',
  /** Represents a tool being called by the agent */
  ToolInvocation = 'TOOL_INVOCATION',
  /** Represents the result returned from a tool call */
  ToolResult = 'TOOL_RESULT',
  /** Represents speech from the human user */
  User = 'USER'
}

/** Input for canceling a business policy */
export type CancelBusinessPolicyInput = {
  /** Who initiated the cancellation */
  canceledBy: BusinessPolicyCancellationSource;
  /** When the cancellation becomes effective */
  effectiveAt: Scalars['Time']['input'];
  /** The reason for cancellation */
  reason: BusinessPolicyCancellationReason;
  /** A description of the cancellation reason */
  reasonDescription: Scalars['String']['input'];
  /** The commission amount to be returned */
  returnCommission: Scalars['Float']['input'];
  /** The premium amount to be returned */
  returnPremium: Scalars['Float']['input'];
  /** The type of cancellation */
  type: BusinessPolicyCancellationType;
};

/** Details for a request to cancel a policy */
export type CancelPolicyRequest = {
  __typename?: 'CancelPolicyRequest';
  /** ID of the policy to be cancelled */
  policyId: Scalars['String']['output'];
  /** Reason for cancelling the policy */
  reason: Scalars['String']['output'];
};

/** Input type for canceling a policy request */
export type CancelPolicyRequestInput = {
  /** ID of the policy to be cancelled */
  policyId: Scalars['String']['input'];
  /** Reason for cancelling the policy */
  reason: Scalars['String']['input'];
};

/** Input for cancelling a workflow execution */
export type CancelWorkflowExecutionInput = {
  /** The ID of the execution to cancel */
  id: Scalars['ID']['input'];
  /** The version of the execution to cancel */
  version: Scalars['Int64']['input'];
};

/**
 * One materialized section instance of a sectioned DOCX artifact produced by the
 * DOCX_EDITOR tool's CREATE_FROM_TEMPLATE flow. A sectioned document is assembled by
 * generating each section as its own standalone DOCX file and then combining those files,
 * in order, into the final document. The same repeatable template section can appear as
 * multiple instances, each with its own distinct id.
 */
export type CaraDocxSection = {
  __typename?: 'CaraDocxSection';
  /**
   * A short synopsis of what was filled into this section, generated when the section was
   * created or last edited. Null when no synopsis was recorded.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The file generated for this section */
  file: File;
  /**
   * The unique ID of this section instance within the artifact. This is the id passed to
   * EDIT_SECTION / DELETE_SECTION (and ADD_SECTION's afterSectionId) to target the section.
   */
  id: Scalars['ID']['output'];
  /** The Python code that generated this section's standalone DOCX file */
  pythonCode?: Maybe<Scalars['String']['output']>;
  /** The ID of the WordDocumentTemplate section this instance was generated from. */
  templateSectionId: Scalars['String']['output'];
  /** The human-readable title of the section. */
  title: Scalars['String']['output'];
};

/** A workspace for Cara to execute tasks and produce artifacts */
export type CaraWorkspace = {
  __typename?: 'CaraWorkspace';
  /** The agency this workspace is associated with */
  agency?: Maybe<Agency>;
  /** The agency user the created this workspace */
  agencyUser?: Maybe<AgencyUser>;
  /** The timestamp when this workspace was archived */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The artifacts produced in this workspace */
  artifacts: Array<CaraWorkspaceArtifact>;
  /**
   * The clients this workspace is filed under, oldest link first.
   *
   * Plural because client_workspace is: it carries no unique constraint on
   * workspace_id. Policy currently permits at most one, enforced by
   * linkClientWorkspace rather than by the schema, so this holds zero or one today
   * and relaxing that rule needs no change here.
   *
   * suggestedClientsForWorkspace returns nothing once this is non-empty, so read it
   * first when choosing between showing an association and offering to make one.
   */
  clients: Array<Client>;
  /** The timestamp when this workspace was created */
  createdAt: Scalars['Time']['output'];
  /** The custom preset used for this workspace, if any */
  customPreset?: Maybe<CustomPreset>;
  /** The files associated with this workspace */
  files: Array<File>;
  /** The unique identifier for this workspace */
  id: Scalars['ID']['output'];
  /** The integration that initiated this workspace, if any */
  integration?: Maybe<Integration>;
  /** The messages exchanged in this workspace */
  messages: Array<CaraWorkspaceMessage>;
  /**
   * The metadata for this workspace, usable for searching and filtering. These are usually
   * automatically generated by AI, but can be overridden by the agent.
   */
  metadata: CaraWorkspaceMetadata;
  /** The plan stages in this workspace */
  planStages: Array<CaraWorkspacePlanStage>;
  /**
   * The preset for this workspace, if any. This indicates a specific task or goal for the workspace
   * and can be used to guide the AI in its execution.
   */
  preset?: Maybe<CaraWorkspacePreset>;
  /** The schema version of the Cara workspace */
  schemaVersion: CaraWorkspaceSchemaVersion;
  /** The service request this workspace is handling, if any */
  serviceRequest?: Maybe<ServiceRequest>;
  /** The current state of this workspace */
  state: CaraWorkspaceState;
  /** A brief title describing this workspace, initially set by AI but can be overridden by the agent */
  title: Scalars['String']['output'];
  /** The timestamp when this workspace was last modified */
  updatedAt: Scalars['Time']['output'];
  /**
   * The visibility configuration for this workspace (PRIVATE / SHARED / PUBLIC).
   * Stored on cara_workspace visibility columns for fast list/search filtering.
   * Defaults to PUBLIC for all rows on migration.
   */
  visibility: VisibilityConfig;
  /**
   * Total active execution time across plan stages in milliseconds: sum of (endedAt - start)
   * for each stage, where start is startedAt when set, otherwise createdAt. Omits idle
   * calendar time between stages (e.g. when a customer revisits the workspace days later).
   * Null when no stage has an endedAt after its start reference.
   */
  workDurationMs?: Maybe<Scalars['Int']['output']>;
};

/** An artifact produced during execution of a Cara workspace */
export type CaraWorkspaceArtifact = {
  __typename?: 'CaraWorkspaceArtifact';
  /** The application file details if this is an application file artifact (e.g., XLSX, DOCX) */
  applicationFile?: Maybe<CaraWorkspaceArtifactApplicationFile>;
  /** The timestamp when the artifact was created */
  createdAt: Scalars['Time']['output'];
  /** The custom form fill details if this is a custom form artifact */
  customForm?: Maybe<CaraWorkspaceArtifactCustomForm>;
  /** The document details if this is a document artifact */
  document?: Maybe<CaraWorkspaceArtifactDocument>;
  /** Whether this artifact has been edited by the user since it was generated */
  editedAt?: Maybe<Scalars['Time']['output']>;
  /** The email details if this is an email artifact */
  email?: Maybe<CaraWorkspaceArtifactEmail>;
  /** The ID of the artifact */
  id: Scalars['String']['output'];
  /** The PDF file details if this is a PDF file artifact */
  pdf?: Maybe<CaraWorkspaceArtifactPdfFile>;
  /** The ID of the stage that created this artifact */
  stageId: Scalars['String']['output'];
  /** The template form details if this is a template form artifact */
  templateForm?: Maybe<CaraWorkspaceArtifactTemplateForm>;
  /** The type of artifact (document, PDF file, or template form) */
  type: CaraWorkspaceArtifactType;
  /** The version of the artifact, monotonically increasing */
  version: Scalars['Int']['output'];
  /**
   * The visibility configuration for this artifact (PRIVATE / SHARED / PUBLIC).
   * Snapshotted from the parent workspace at creation; can be later narrowed or
   * widened independently via updateCaraWorkspaceArtifact. Effective read access
   * is the intersection: an artifact is never more visible than its workspace.
   */
  visibility: VisibilityConfig;
};

export type CaraWorkspaceArtifactApplicationFile = {
  __typename?: 'CaraWorkspaceArtifactApplicationFile';
  /**
   * The Excel spreadsheet template that was used to generate this XLSX artifact, resolved
   * from the stored (templateId, templateVersion) tuple and pinned to the exact template
   * version captured at generation time. Null when this artifact was not produced from an
   * Excel spreadsheet template. As with wordDocumentTemplate, this returns the historical
   * snapshot rather than the current latest version of the library template.
   */
  excelSpreadsheetTemplate?: Maybe<ExcelSpreadsheetTemplate>;
  /** The Python code that generates this application file */
  pythonCode?: Maybe<Scalars['String']['output']>;
  /**
   * The ordered section instances that make up a sectioned DOCX artifact produced by
   * DOCX_EDITOR CREATE_FROM_TEMPLATE. Each instance records the template section it came
   * from so the section can be regenerated, reordered, added, or deleted and the document
   * re-combined. Empty for non-sectioned DOCX artifacts (CREATE, EDIT_UPLOADED) and all
   * XLSX artifacts.
   */
  sections?: Maybe<Array<CaraDocxSection>>;
  /** The user-uploaded file that served as a starting point for this artifact, if any */
  sourceFile?: Maybe<File>;
  /**
   * The worksheets that XLSX_EDITOR filled in this workbook, in the order they were filled.
   * Each entry records the template tab it came from so the tab can be re-edited later.
   * Empty for XLSX artifacts that were not produced from a template and all DOCX artifacts.
   */
  tabs?: Maybe<Array<CaraXlsxTab>>;
  /** The title of the application file */
  title: Scalars['String']['output'];
  /** The type of application file (e.g., "XLSX", "DOCX"). */
  type: Scalars['String']['output'];
  /**
   * The Word document template that was used to generate this DOCX artifact, resolved
   * from the stored (templateId, templateVersion) tuple and pinned to the exact template
   * version captured at generation time. Null when this artifact was not produced from a
   * Word document template (e.g. CREATE from scratch, EDIT_UPLOADED from a user-uploaded
   * DOCX, any XLSX, or any artifact predating template provenance tracking). The library
   * template may have been updated or archived since this artifact was generated; this
   * resolver returns the historical snapshot rather than the current latest version.
   */
  wordDocumentTemplate?: Maybe<WordDocumentTemplate>;
};

/** Input for updating a Cara workspace artifact application file */
export type CaraWorkspaceArtifactApplicationFileInput = {
  /** The title of the application file */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A page of artifact summaries, newest-composed first. `totalCount` counts
 * artifacts rather than versions, as the edges do.
 */
export type CaraWorkspaceArtifactConnection = {
  __typename?: 'CaraWorkspaceArtifactConnection';
  edges: Array<CaraWorkspaceArtifactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * A custom PDF form fill artifact produced by Cara.
 * Stores fill data for a specific custom form template; the filled PDF is rendered on demand.
 */
export type CaraWorkspaceArtifactCustomForm = {
  __typename?: 'CaraWorkspaceArtifactCustomForm';
  /** The custom form template used to produce this fill artifact. */
  customForm: CustomForm;
  /** The human-readable title of this filled form artifact. */
  title: Scalars['String']['output'];
};

/** A document artifact generated by Cara */
export type CaraWorkspaceArtifactDocument = {
  __typename?: 'CaraWorkspaceArtifactDocument';
  /** The content of the document */
  content: Scalars['String']['output'];
  /** The ID of the HTML document template used to create this document, if any */
  htmlDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /**
   * The ID of the source this document was converted from:
   * - For CONVERT_HTML_TO_TEMPLATE: the source HTML artifact ID
   * When regenerating, use the same conversion operation with this ID.
   */
  sourceFileId?: Maybe<Scalars['String']['output']>;
  /** The title of the document */
  title: Scalars['String']['output'];
};

/** Input for updating a Cara workspace artifact document */
export type CaraWorkspaceArtifactDocumentInput = {
  /** The content of the document */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The title of the document */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CaraWorkspaceArtifactEdge = {
  __typename?: 'CaraWorkspaceArtifactEdge';
  cursor: Scalars['String']['output'];
  node: CaraWorkspaceArtifactSummary;
};

/**
 * An email composed in the workspace. Two exits: written into the agent's
 * connected mailbox as a native draft (the mailbox copy then becomes the live
 * draft and this artifact its provenance), or sent directly behind the user's
 * explicit send click. Attachments are held by reference so a send always
 * picks up the latest version of the attached artifact.
 */
export type CaraWorkspaceArtifactEmail = {
  __typename?: 'CaraWorkspaceArtifactEmail';
  /**
   * Workspace artifacts attached by reference (attach resolves the latest
   * version at send time)
   */
  attachmentArtifactIds: Array<Scalars['String']['output']>;
  /** Uploaded workspace files attached by reference */
  attachmentFileIds: Array<Scalars['String']['output']>;
  /** The BCC recipients */
  bcc: Array<CaraWorkspaceEmailRecipient>;
  /** The canonical body as a conservative, Outlook-safe HTML subset */
  bodyHtml: Scalars['String']['output'];
  /** The CC recipients */
  cc: Array<CaraWorkspaceEmailRecipient>;
  /**
   * An opaque fingerprint of the composition above, and the token a reviewer
   * carries back to sendMailboxEmail. A save rewrites a version in place, so the
   * version number alone cannot tell anyone that the words moved under them; two
   * compositions that read identically share a revision, so a save that changes
   * nothing leaves a review standing.
   */
  contentRevision: Scalars['String']['output'];
  /** The connected mailbox this email is composed to send from */
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  /** The signature appended to the body, by reference */
  signatureId?: Maybe<Scalars['String']['output']>;
  /** The message this email replies to or forwards; null for a fresh email */
  source?: Maybe<CaraWorkspaceEmailSource>;
  /** The subject line of the email */
  subject: Scalars['String']['output'];
  /** The primary recipients */
  to: Array<CaraWorkspaceEmailRecipient>;
};

/**
 * Input for updating a Cara workspace email artifact. Omitted fields are left
 * unchanged; a present empty recipient or attachment list clears it, and the
 * omittable fields below distinguish an explicit null (clear it) from absence.
 */
export type CaraWorkspaceArtifactEmailInput = {
  /** Workspace artifacts attached by reference */
  attachmentArtifactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Uploaded workspace files attached by reference */
  attachmentFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The BCC recipients */
  bcc?: InputMaybe<Array<CaraWorkspaceEmailRecipientInput>>;
  /** The body as a conservative, Outlook-safe HTML subset */
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  /** The CC recipients */
  cc?: InputMaybe<Array<CaraWorkspaceEmailRecipientInput>>;
  /**
   * The contentRevision the writer last read. Supplied, the save is refused when
   * the stored composition has moved since — a second tab or a colleague editing
   * the same draft would otherwise be overwritten without either of them seeing
   * it. Omitted, the save is unconditional.
   */
  expectedContentRevision?: InputMaybe<Scalars['String']['input']>;
  /** The connected mailbox this email is composed to send from. Null unpicks it. */
  mailboxAccountId?: InputMaybe<Scalars['String']['input']>;
  /** The signature appended to the body, by reference. Null removes it. */
  signatureId?: InputMaybe<Scalars['String']['input']>;
  /** The message this email replies to or forwards. Null detaches the reply. */
  source?: InputMaybe<CaraWorkspaceEmailSourceInput>;
  /** The subject line of the email */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** The primary recipients */
  to?: InputMaybe<Array<CaraWorkspaceEmailRecipientInput>>;
};

/**
 * Narrows caraWorkspaceArtifacts for callers that pick a single artifact out of the
 * agency's library, such as an attachment picker, rather than rendering all of it.
 */
export type CaraWorkspaceArtifactFilter = {
  /**
   * When true, returns only archived artifacts (`archivedAt` set); when false or
   * omitted, only active ones. A filter that names `ids` and omits this sees both
   * states, so an email's stored attachment ids still resolve after one is archived.
   */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Resolves specific artifacts by ID, for a caller holding IDs it stored earlier —
   * an email's attachments, say — and needing their titles back. The artifacts may
   * live in any workspace the caller can read, so this is not scoped to one workspace.
   *
   * An explicit id list defines the result set and `limit` does not truncate it: every
   * named id the caller can see comes back, whatever the limit says. At most 200 ids may
   * be named at once, and a longer list is refused rather than trimmed.
   *
   * Visibility is unchanged by naming an ID: an artifact the caller could not have
   * found by search is simply absent from the results, and an id in another agency, an
   * id the caller may not read, and an id that never existed are indistinguishable — so
   * this cannot be used to learn which IDs exist in workspaces the caller cannot open.
   *
   * Combines with `search` and `types` by intersection: an id also has to match those.
   * An empty list means no id restriction, not "match nothing". Ordering is unaffected
   * — results stay most-recently-updated first, not in the order the ids were given.
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Caps the number of artifacts returned, clamped into 1..100, so an out-of-range
   * value is silently pulled into that range rather than erroring or meaning
   * "unbounded". Omitting it returns every artifact the caller can see, which is
   * what the documents view relies on: it renders the whole list and cannot ask
   * for a second page.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Substring matched case-insensitively against the artifact title, the title of the
   * workspace that produced it, and that workspace's client name; an artifact is kept
   * when any one of the three contains it. Whitespace-only terms are ignored rather
   * than matching everything.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Keeps only artifacts of these types. An empty list means no type restriction, not
   * "match nothing".
   */
  types?: InputMaybe<Array<CaraWorkspaceArtifactType>>;
};

export type CaraWorkspaceArtifactMetadata = {
  __typename?: 'CaraWorkspaceArtifactMetadata';
  /** The user that created the workspace this artifact belongs to (resolved AgencyUser) */
  agencyUser?: Maybe<AgencyUser>;
  /** The client name from the workspace, blank if not available */
  clientName: Scalars['String']['output'];
  /** The ID of the template being filled out if this is a template form artifact */
  templateId?: Maybe<DocumentType>;
  /** The ID of the workspace this artifact belongs to */
  workspaceId: Scalars['String']['output'];
  /** The title of the workspace this artifact belongs to */
  workspaceTitle: Scalars['String']['output'];
  /**
   * The user that created the workspace this artifact belongs to
   * @deprecated Use agencyUser instead
   */
  workspaceUser?: Maybe<Scalars['String']['output']>;
};

export type CaraWorkspaceArtifactPdfFile = {
  __typename?: 'CaraWorkspaceArtifactPDFFile';
  /** The URL to download the PDF file if it is hosted externally */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the original file this artifact was created from */
  fileId?: Maybe<Scalars['String']['output']>;
  /** The title of the PDF file */
  title: Scalars['String']['output'];
};

/**
 * A lightweight artifact summary for the documents view.
 * Contains artifact information with a reference to its workspace and all versions.
 */
export type CaraWorkspaceArtifactSummary = {
  __typename?: 'CaraWorkspaceArtifactSummary';
  /**
   * When the artifact was archived out of the Documents lists, null while it is
   * active. Archiving hides the artifact from `caraWorkspaceArtifacts` and
   * `Client.artifacts` by default and changes nothing else: it stays in its
   * workspace, `caraWorkspaceArtifact` still returns it, and the statics render
   * endpoints still serve it. Set and cleared by `updateCaraWorkspaceArtifacts`.
   */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * When the artifact first existed: the creation time of the earliest version
   * the caller may read. Unlike `createdAt` it never moves, which is what makes
   * it safe to order and page a list by.
   *
   * "The caller may read" is the same qualification the rest of the summary
   * carries: visibility is stamped per version, so a reader shown only the later
   * versions of an artifact sees the earliest of those.
   */
  composedAt: Scalars['Time']['output'];
  /**
   * When the version this summary stands at was written. A summary reports the
   * artifact's latest version, so this moves forward every time Cara revises the
   * artifact; `composedAt` is the one that does not.
   */
  createdAt: Scalars['Time']['output'];
  /** The ID of the artifact */
  id: Scalars['ID']['output'];
  /** The latest version number of this artifact */
  latestVersion: Scalars['Int']['output'];
  /** The metadata for this artifact */
  metadata: CaraWorkspaceArtifactMetadata;
  /** The title of the artifact (from document.title, pdf.title, or template form type) */
  title: Scalars['String']['output'];
  /** The type of artifact (document, PDF file, or template form) */
  type: CaraWorkspaceArtifactType;
  /** The timestamp when the artifact was last updated */
  updatedAt: Scalars['Time']['output'];
  /** All versions of this artifact, ordered by version number */
  versions: Array<CaraWorkspaceArtifact>;
  /**
   * The URL to view this artifact in the statics service, null for artifact types
   * that render no file there. An EMAIL is one: it is composed in the workspace
   * and leaves through a mailbox, so it has nothing to link to.
   */
  viewUrl?: Maybe<Scalars['String']['output']>;
  /** The workspace this artifact belongs to */
  workspace: CaraWorkspace;
};

/** A template form artifact (e.g. stored ACORD data) */
export type CaraWorkspaceArtifactTemplateForm = {
  __typename?: 'CaraWorkspaceArtifactTemplateForm';
  /** The human-readable label of the template, usually indicating the named insured or the policyholder */
  label: Scalars['String']['output'];
  /** The ID of the template being filled out */
  templateId: DocumentType;
  /** The human-readable title of the template (e.g., "ACORD 25") */
  title: Scalars['String']['output'];
};

export enum CaraWorkspaceArtifactType {
  /** A custom PDF form fill artifact produced by filling a custom form template. */
  CustomForm = 'CUSTOM_FORM',
  /**
   * A legacy document type. Value kept while there are cara workspaces in the DB that have
   * created artifacts of this type. This is needed to ensure they unmarshal correctly
   * @deprecated This type is no longer used.
   */
  Document = 'DOCUMENT',
  /** A HTML document artifact */
  DocumentHtml = 'DOCUMENT_HTML',
  /** A Word document artifact (.docx) */
  DocxFile = 'DOCX_FILE',
  /**
   * An email composed in the workspace. Rows created by a retired legacy document
   * type share this value and carry no payload, so readers must tolerate a nil email.
   */
  Email = 'EMAIL',
  /**
   * A legacy document type. Value kept while there are cara workspaces in the DB that have
   * created artifacts of this type. This is needed to ensure they unmarshal correctly
   * @deprecated This type is no longer used.
   */
  HtmlDocument = 'HTML_DOCUMENT',
  /** A PDF document artifact */
  PdfFile = 'PDF_FILE',
  /** A template form artifact (e.g. stored ACORD data) */
  TemplateForm = 'TEMPLATE_FORM',
  /** An Excel spreadsheet artifact (.xlsx) */
  XlsxFile = 'XLSX_FILE'
}

/**
 * Narrows searchCaraWorkspaceArtifacts. Omitting it entirely reads every artifact
 * the caller may see, which is the same reach `caraWorkspaceArtifacts` has.
 */
export type CaraWorkspaceArtifactsFilterInput = {
  /** When true, return only artifacts from workspaces the authenticated user opened. */
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Narrows to the artifacts belonging to emails the outbox filter matches.
   *
   * The artifact library is the outbox's third source — the emails Cara composed,
   * whether or not one ever reached a mailbox — and this is how a filtered outbox
   * narrows it in step with the two mailbox ledgers.
   */
  outbox?: InputMaybe<OutboxFilterInput>;
  /**
   * Keeps only artifacts of these types. An empty list means no type restriction,
   * not "match nothing".
   */
  types?: InputMaybe<Array<CaraWorkspaceArtifactType>>;
};

/** A paginated connection of Cara workspaces */
export type CaraWorkspaceConnection = {
  __typename?: 'CaraWorkspaceConnection';
  edges: Array<CaraWorkspaceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a Cara workspace connection */
export type CaraWorkspaceEdge = {
  __typename?: 'CaraWorkspaceEdge';
  cursor: Scalars['String']['output'];
  node: CaraWorkspace;
};

/** An email recipient with an optional display name */
export type CaraWorkspaceEmailRecipient = {
  __typename?: 'CaraWorkspaceEmailRecipient';
  /** The recipient's email address */
  email: Scalars['String']['output'];
  /** The recipient's display name; empty when only an address is known */
  name: Scalars['String']['output'];
};

/** An email recipient input */
export type CaraWorkspaceEmailRecipientInput = {
  /** The recipient's email address */
  email: Scalars['String']['input'];
  /** The recipient's display name; empty when only an address is known */
  name: Scalars['String']['input'];
};

/**
 * How a composed email derives from an existing message. The provider
 * generates threading headers from the source, so replies thread correctly for
 * the recipient.
 */
export enum CaraWorkspaceEmailReplyMode {
  Forward = 'FORWARD',
  Reply = 'REPLY',
  ReplyAll = 'REPLY_ALL'
}

/** The message a composed email replies to or forwards */
export type CaraWorkspaceEmailSource = {
  __typename?: 'CaraWorkspaceEmailSource';
  /** The durable RFC 5322 Message-ID of the source */
  messageId: Scalars['String']['output'];
  /** How the composed email derives from the source */
  mode: CaraWorkspaceEmailReplyMode;
  /** The provider's ID for the source message, in the sending account */
  providerMessageId: Scalars['String']['output'];
  /** The conversation the source belongs to */
  threadId: Scalars['String']['output'];
};

/** Input for the message a composed email replies to or forwards */
export type CaraWorkspaceEmailSourceInput = {
  messageId: Scalars['String']['input'];
  mode: CaraWorkspaceEmailReplyMode;
  providerMessageId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};

/** Reference to an existing file. Mirrors SearchFileResult: { id, integrationId? }. */
export type CaraWorkspaceExistingFileInput = {
  /** The ID of the existing file */
  id: Scalars['ID']['input'];
  /** The integration ID of the existing file */
  integrationId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Represents either a new file upload or an existing file reference.
 * Exactly one of upload or fileId must be provided.
 */
export type CaraWorkspaceFileInput = {
  /**
   * Reference to an existing file result from searchFiles.
   * If integrationId is null, id refers to an uploaded agency file.
   * If integrationId is provided, id refers to a knowledge graph entity ID that must
   * be fetched from the integration and stored as an agency file.
   */
  existing?: InputMaybe<CaraWorkspaceExistingFileInput>;
  /** New file content to upload */
  upload?: InputMaybe<Scalars['Upload']['input']>;
};

export type CaraWorkspaceFilterInput = {
  /** The ID of the agency to filter by */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the agency user to filter by (workspace creator/owner) */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** The preset of the Cara workspace to filter by (exact match) */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** The state of the Cara workspace to filter by (exact match) */
  state?: InputMaybe<CaraWorkspaceState>;
  /** The title of the Cara workspace to filter by (case-insensitive contains operator) */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A message exchanged between a user and agent in a Cara workspace */
export type CaraWorkspaceMessage = {
  __typename?: 'CaraWorkspaceMessage';
  /** The content of the message */
  content: Scalars['String']['output'];
  /**
   * The IDs of the custom forms the user attached for this message. Cara uses the PDF editor
   * tool (LIST / DESCRIBE / FILL) for these forms.
   */
  customFormIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The IDs of the documents for which templates should be generated. This should only be specified
   * when the preset is GENERATE_TEMPLATE.
   */
  documentIds?: Maybe<Array<DocumentType>>;
  /**
   * The IDs of the Excel spreadsheet templates the user pre-selected. Cara will call
   * REQUEST_EXCEL_SPREADSHEET_TEMPLATES with GET_CONTENT for each ID and produce
   * a workbook using XLSX_EDITOR CREATE_FROM_TEMPLATE.
   */
  excelSpreadsheetTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the message in the external system */
  externalId: Scalars['String']['output'];
  /** The files associated with this message */
  files: Array<File>;
  /** The generated follow up options to display to the user for possible selection. */
  followUpOptions?: Maybe<CaraWorkspaceMessageFollowUpOptions>;
  /**
   * The IDs of the HTML document templates the user pre-selected. Cara will call
   * REQUEST_DOCUMENT_STYLE_TEMPLATES with GET_CONTENT for each ID and produce
   * a document using FILE_EDITOR.
   */
  htmlDocumentTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the message */
  id: Scalars['ID']['output'];
  /** The delivery format the user chose for the workspace output. Null means TEXT. */
  outputFormat?: Maybe<CaraWorkspaceOutputFormat>;
  /** The preset metadata for the message */
  presetMetadata?: Maybe<Scalars['JSON']['output']>;
  /** The role of the message sender (user or agent) */
  role: CaraWorkspaceMessageRole;
  /** The selected follow up option by the user. */
  selectedFollowUp?: Maybe<CaraWorkspaceMessageFollowUpOption>;
  /** The timestamp when the message was created */
  timestamp: Scalars['Time']['output'];
  /**
   * The use case this message was launched from, when it came from a launcher tile
   * rather than free-form chat. Narrows the preset: prompts read it to pick their
   * wording, and the home page reads it to rank what a user reaches for.
   */
  useCase?: Maybe<CaraWorkspaceUseCase>;
  /**
   * The IDs of the Word document templates the user pre-selected. Cara will call
   * REQUEST_WORD_DOCUMENT_TEMPLATES with GET_CONTENT for each ID and produce
   * a document using DOCX_EDITOR CREATE_FROM_TEMPLATE.
   */
  wordDocumentTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Ephemeral Word, Excel, or PDF file produced from a Cara agent message. Exactly one of
 * contentBase64 or downloadUrl is set, depending on where the format is rendered.
 */
export type CaraWorkspaceMessageExport = {
  __typename?: 'CaraWorkspaceMessageExport';
  /** Base64-encoded file bytes. Null for PDF, which is rendered by the statics service. */
  contentBase64?: Maybe<Scalars['String']['output']>;
  /**
   * Single-use, short-lived URL that renders and downloads the file. Set only for PDF.
   * The URL is minted after authorization and is consumed on first request.
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Suggested download filename */
  fileName: Scalars['String']['output'];
  /** MIME type of the file */
  mimeType: Scalars['String']['output'];
};

/** Export format for a Cara workspace agent message download. */
export enum CaraWorkspaceMessageExportFormat {
  Docx = 'DOCX',
  Pdf = 'PDF',
  Xlsx = 'XLSX'
}

export type CaraWorkspaceMessageFollowUpInput = {
  /** The ID of the follow up option to select. */
  id: Scalars['ID']['input'];
  /** The prompt generated by the LLM to accomplish this follow up task */
  prompt: Scalars['String']['input'];
};

/** A follow up option to display to the user for possible selection. */
export type CaraWorkspaceMessageFollowUpOption = {
  __typename?: 'CaraWorkspaceMessageFollowUpOption';
  /** The ID of the follow up option. */
  id: Scalars['ID']['output'];
  /** A prompt generated by the LLM to accomplish this follow up task */
  prompt: Scalars['String']['output'];
  /** A short title describing the follow up option to display to the user. */
  title: Scalars['String']['output'];
  /**
   * The type of the follow up option. This determines the action to take when the user selects the option
   * and what options to display on the frontend for the follow up.
   */
  type: CaraWorkspaceMessageFollowUpOptionType;
};

/** The type of follow up option to display to the user. */
export enum CaraWorkspaceMessageFollowUpOptionType {
  /** A custom follow up option that is generated by the LLM to accomplish this follow up task. */
  Custom = 'CUSTOM'
}

/** The generated follow up options to display to the user for possible selection. */
export type CaraWorkspaceMessageFollowUpOptions = {
  __typename?: 'CaraWorkspaceMessageFollowUpOptions';
  /** The timestamp when the follow up options were generated. */
  generationCompletedAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when the follow up options were generated. */
  generationStartedAt?: Maybe<Scalars['Time']['output']>;
  /** The options to display to the user for possible selection. */
  options?: Maybe<Array<CaraWorkspaceMessageFollowUpOption>>;
};

export type CaraWorkspaceMessageInput = {
  /**
   * Client to file the new workspace under. Only consulted when this message creates
   * a workspace, the same as `visibility`.
   */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The IDs of the custom forms the user attached for this message. Cara uses the PDF editor
   * tool (LIST / DESCRIBE / FILL) for these forms.
   */
  customFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The ID of the custom preset to use for this workspace */
  customPresetId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The IDs of the documents for which templates should be generated. This should only be specified
   * when the preset is GENERATE_TEMPLATE.
   */
  documentIds?: InputMaybe<Array<DocumentType>>;
  /**
   * The IDs of the Excel spreadsheet templates the user pre-selected. Cara will call
   * REQUEST_EXCEL_SPREADSHEET_TEMPLATES with GET_CONTENT for each ID and produce
   * a workbook using XLSX_EDITOR CREATE_FROM_TEMPLATE.
   */
  excelSpreadsheetTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reference to an existing file result from searchFiles. */
  existingFiles?: InputMaybe<Array<CaraWorkspaceExistingFileInput>>;
  /** Any files to add to the message */
  files: Array<Scalars['Upload']['input']>;
  /** The follow up option to select, if any. */
  followUp?: InputMaybe<CaraWorkspaceMessageFollowUpInput>;
  /**
   * The IDs of the HTML document templates the user pre-selected. Cara will call
   * REQUEST_DOCUMENT_STYLE_TEMPLATES with GET_CONTENT for each ID and produce
   * a document using FILE_EDITOR.
   */
  htmlDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The content of the message to add */
  message: Scalars['String']['input'];
  /**
   * When true, custom forms and output templates pinned on the workspace's custom preset
   * are not injected automatically. Use for launcher UIs where the user explicitly
   * chooses which library forms and templates to fill. Non-UI flows (e.g. email) omit this.
   */
  omitPresetOutputTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The delivery format for the workspace output. Defaults to TEXT when omitted.
   * HTML_TEMPLATE / WORD_TEMPLATE expect the corresponding template ID list to be set.
   */
  outputFormat?: InputMaybe<CaraWorkspaceOutputFormat>;
  /**
   * The preset for this workspace, if any. This indicates a specific task or goal for the workspace
   * and can be used to guide the AI in its execution.
   */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** Any additional preset-specific JSON content used to configure that preset. */
  presetMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The ID of the service request this workspace is associated with, if any */
  serviceRequestId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The use case the caller launched, narrowing `preset` to one errand inside it.
   * Supersedes the legacy `Use Case: <id>` line in `message`, which is still read
   * when this is omitted so older clients keep working.
   */
  useCase?: InputMaybe<CaraWorkspaceUseCase>;
  /**
   * Optional visibility configuration. Only consulted when this message creates a
   * new workspace (i.e. no existing workspace ID is supplied). Defaults to PUBLIC.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
  /**
   * The IDs of the Word document templates the user pre-selected. Cara will call
   * REQUEST_WORD_DOCUMENT_TEMPLATES with GET_CONTENT for each ID and produce
   * a document using DOCX_EDITOR CREATE_FROM_TEMPLATE.
   */
  wordDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The role of a message in a Cara workspace conversation */
export enum CaraWorkspaceMessageRole {
  /** A message from the AI agent */
  Agent = 'AGENT',
  /** A message from the human user */
  User = 'USER'
}

/** The metadata for a Cara workspace */
export type CaraWorkspaceMetadata = {
  __typename?: 'CaraWorkspaceMetadata';
  /** The name of the client that this workspace is for */
  clientName?: Maybe<Scalars['String']['output']>;
  /** Keywords that can be used to search and filter this workspace */
  keywords: Array<Scalars['String']['output']>;
};

/**
 * The delivery format for a workspace's final output. Generic across presets,
 * though currently only surfaced for Coverage Comparison (Policy Check).
 */
export enum CaraWorkspaceOutputFormat {
  /** Populate a user-selected HTML document template (via htmlDocumentTemplateIds). */
  HtmlTemplate = 'HTML_TEMPLATE',
  /** Markdown text rendered in-product (the default). */
  Text = 'TEXT',
  /** Populate a user-selected Word document template (via wordDocumentTemplateIds). */
  WordTemplate = 'WORD_TEMPLATE',
  /** A structured Excel file using a Cara-defined layout. */
  Xlsx = 'XLSX'
}

/** A stage in the execution plan of a Cara workspace task */
export type CaraWorkspacePlanStage = {
  __typename?: 'CaraWorkspacePlanStage';
  /** The timestamp when the plan stage was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp when execution of the plan stage completed */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The sequence of events that occurred during stage execution */
  events: Array<CaraWorkspacePlanStageEvent>;
  /** The ID of the plan stage */
  id: Scalars['ID']['output'];
  /** The ID of the message that initiated this plan stage */
  initiatedByMessageId: Scalars['String']['output'];
  /**
   * Confirmed billable platform units for this TASK stage's response
   * (workspace:{stageId}:response), summed from consumption_event.
   * Null for non-TASK stages or when none are recorded yet.
   */
  platformUnitsUsed?: Maybe<Scalars['Decimal']['output']>;
  /** The details of the process attachments plan stage */
  processAttachmentsDetails?: Maybe<CaraWorkspacePlanStageProcessAttachmentDetails>;
  /** The prompt that was computed to start execution of this stage (human message) */
  prompt: Scalars['String']['output'];
  /** The outcome or findings from executing this plan stage */
  result: Scalars['String']['output'];
  /** The timestamp when execution of the plan stage began */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The current execution state of the plan stage */
  state: CaraWorkspacePlanStageState;
  /** The type of plan stage */
  type: CaraWorkspacePlanStageType;
};

/** An event that occurs during the execution of a plan stage */
export type CaraWorkspacePlanStageEvent = {
  __typename?: 'CaraWorkspacePlanStageEvent';
  /** The content or description of the event */
  content?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the event ended */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The error message if the tool call failed */
  error?: Maybe<Scalars['String']['output']>;
  /** The ID of the event in the external system */
  externalId: Scalars['String']['output'];
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** The timestamp when the event was created */
  startedAt: Scalars['Time']['output'];
  /**
   * The opaque signature for native thinking blocks (required by the API for round-tripping thinking content).
   * Only set for THOUGHT events produced by adaptive/extended thinking.
   */
  thoughtSignature?: Maybe<Scalars['String']['output']>;
  /** A brief title of the event */
  title?: Maybe<Scalars['String']['output']>;
  /** The tool call details if this event is a tool invocation */
  toolCall?: Maybe<CaraWorkspaceToolCall>;
  /** The type of the event (thought or tool call) */
  type: CaraWorkspacePlanStageEventType;
};

/** The type of event that can occur during a plan stage execution */
export enum CaraWorkspacePlanStageEventType {
  /**
   * A server-generated summary that replaces older conversation history when the
   * LLM provider compacts the message history. Replayed to the LLM on subsequent
   * turns in place of the summarized history; not rendered to users.
   */
  Compaction = 'COMPACTION',
  /** An internal reasoning step by the agent */
  Thought = 'THOUGHT',
  /** An invocation of an external tool or API */
  ToolCall = 'TOOL_CALL'
}

/** The details of the process attachments plan stage */
export type CaraWorkspacePlanStageProcessAttachmentDetails = {
  __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails';
  /** The progress of each file being processed */
  progress: Array<CaraWorkspacePlanStageProcessAttachmentFileProgress>;
};

export type CaraWorkspacePlanStageProcessAttachmentFileProgress = {
  __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress';
  /** The error encountered while processing the file */
  error?: Maybe<Scalars['String']['output']>;
  /** The file being processed */
  file: File;
  /** The progress of the file being processed (as a decimal between 0 and 1) */
  progress: Scalars['Float']['output'];
};

/** The state of a plan stage in a Cara workspace */
export enum CaraWorkspacePlanStageState {
  /** The stage has failed to complete */
  Failed = 'FAILED',
  /** The stage is actively processing a task */
  InProgress = 'IN_PROGRESS',
  /** The stage is planned but not yet started */
  Planned = 'PLANNED',
  /** The stage has been completed successfully */
  Success = 'SUCCESS'
}

/** The type of plan stage in a Cara workspace */
export enum CaraWorkspacePlanStageType {
  /** A plan stage that processes attached files */
  ProcessAttachments = 'PROCESS_ATTACHMENTS',
  /** A plan stage that performs a task */
  Task = 'TASK'
}

/** A preset for Cara to execute tasks and produce artifacts */
export enum CaraWorkspacePreset {
  /** A preset for reviewing a certificate of liability insurance for correctness */
  CertificateReview = 'CERTIFICATE_REVIEW',
  /**
   * A preset for reviewing insurance claims against policy coverage, analyzing misrepresentation risk,
   * and providing E&O mitigation recommendations
   */
  ClaimsReview = 'CLAIMS_REVIEW',
  /** A preset for classifying business operations using NAICS, SIC, and GL codes */
  CommercialClassification = 'COMMERCIAL_CLASSIFICATION',
  /**
   * A preset for processing carrier commission statements across any line of business: parse every
   * statement whatever its shape into one transaction register, foot each file to its own stated total
   * before any figure is reported, map the register onto a saved destination layout, and where a
   * commission schedule or a prior period is supplied recompute each line against its agreed rate,
   * attribute period over period movement to rate, volume, and book change, and allocate to producers
   */
  CommissionProcessing = 'COMMISSION_PROCESSING',
  /** A preset for reviewing a contract and comparing its requirements to a quote or policy */
  ContractReview = 'CONTRACT_REVIEW',
  /** A preset for comparing insurance coverage between two policies or quotes */
  CoverageComparison = 'COVERAGE_COMPARISON',
  /**
   * A preset for analyzing gaps between current coverage and exposure across commercial and personal
   * lines, verifying exposure with external sources, and recommending additional lines of business
   */
  CoverageGapAnalysis = 'COVERAGE_GAP_ANALYSIS',
  /** A preset for exploring a document and asking questions about it */
  DocumentExploration = 'DOCUMENT_EXPLORATION',
  /**
   * A preset for auditing an employee benefits carrier invoice: prove the bill's own lines foot to its
   * stated total, rebuild the expected charge for every subscriber from the enrollment roster and the
   * bound rates, reconcile the difference into a subscriber level exception register that accounts for
   * the whole variance, separate timing differences from carrier errors, and draft the credit request
   * the exceptions support
   */
  EbBillingAudit = 'EB_BILLING_AUDIT',
  /**
   * A preset for normalizing an employee benefits census: parse a census from a PDF or spreadsheet
   * whatever its columns are called, derive attained ages and coverage tiers, resolve dependents and
   * duplicates, reconcile every row from input to output, and either map the result onto a saved
   * destination layout for a carrier or enrollment platform or return an exception report against the
   * census itself
   */
  EbCensusNormalization = 'EB_CENSUS_NORMALIZATION',
  /**
   * A preset for reviewing the claims experience of a self funded, level funded, or experience rated
   * employee benefits group: establish whether the report is on an incurred or a paid basis, compute
   * member months and per member per month cost with the medical and pharmacy split, trend it without
   * running the line into months the carrier has not finished paying, measure large claim
   * concentration, test which claimants pierced the specific deductible and what the stop loss
   * contract says about filing them, and separate what the documents compute from what only the
   * carrier can answer
   */
  EbClaimsReview = 'EB_CLAIMS_REVIEW',
  /**
   * A preset for employee benefits contribution analysis at renewal: reconcile the current billed
   * premium against the census, model employer/employee cost-sharing scenarios, solve a structure to
   * an employer budget target, run ACA affordability and carrier participation checks, and produce a
   * payroll-ready deduction schedule
   */
  EbContributionAnalysis = 'EB_CONTRIBUTION_ANALYSIS',
  /**
   * A preset for reviewing an employee benefits document against the carrier documents it was derived
   * from: verify an employee benefits guide or a contributions worksheet field by field against rate
   * sheets, plan documents, and contribution decisions, check the per-pay deduction math, and return
   * the corrections to make before the document is distributed
   */
  EbDocumentReview = 'EB_DOCUMENT_REVIEW',
  /**
   * A preset for building the employee facing material an employee benefits open enrollment runs on: the
   * election form, the benefits guide, or the announcement and FAQ. Selects the few figures and benefit
   * provisions an employee needs to choose a plan out of the much larger set the carrier documents
   * carry, computes the per paycheck deduction at a pay calendar established from the documents rather
   * than assumed, and holds any figure it cannot trace to a source out of the document as a labeled
   * blank so it reaches a person before it reaches an employee
   */
  EbEnrollmentMaterials = 'EB_ENROLLMENT_MATERIALS',
  /**
   * A preset for making employee benefits carrier quotes comparable: reprice every quoted option on one
   * comparison census whatever shape its rates arrived in, reconcile each option's own arithmetic before
   * it is allowed into the comparison, and return a normalized cost and benefit comparison, the funding
   * and contract differences behind it, and a shortlist with reasons
   */
  EbQuoteAnalysis = 'EB_QUOTE_ANALYSIS',
  /**
   * A preset for generating a certificate of liability insurance
   * @deprecated Use GENERATE_TEMPLATE instead
   */
  GenerateCertificateOfLiabilityInsurance = 'GENERATE_CERTIFICATE_OF_LIABILITY_INSURANCE',
  /**
   * A preset for generating evidence of property insurance
   * @deprecated Use GENERATE_TEMPLATE instead
   */
  GenerateEvidenceOfPropertyInsurance = 'GENERATE_EVIDENCE_OF_PROPERTY_INSURANCE',
  /** A preset for generating a quote proposal */
  GenerateQuoteProposal = 'GENERATE_QUOTE_PROPOSAL',
  /** A preset for generating a template for a document */
  GenerateTemplate = 'GENERATE_TEMPLATE',
  /**
   * A preset for analyzing loss runs for new business submissions, compiling claims history,
   * researching external risk signals (OSHA, news, litigation), and producing an underwriter-facing
   * risk mitigation statement to support preferred rate consideration
   */
  LossRunAnalysis = 'LOSS_RUN_ANALYSIS',
  /**
   * A preset for risk matching: extract risk details from documents, optionally enrich
   * company data via web, and query the knowledge base for market placement recommendations
   */
  RiskMatching = 'RISK_MATCHING',
  /**
   * A preset for generating a comprehensive client-facing risk management report with deep industry
   * research, regulatory and compliance analysis, company-specific risk findings, and prioritized
   * mitigation recommendations
   */
  RiskReport = 'RISK_REPORT',
  /** A preset for SOV analysis */
  SovAnalysis = 'SOV_ANALYSIS',
  /** A preset for analyzing commercial underwriting documents and providing comprehensive analysis */
  UnderwritingAnalysis = 'UNDERWRITING_ANALYSIS'
}

export enum CaraWorkspaceSchemaVersion {
  /**
   * The initial version of the Cara workspace schema, based in the Python codebase.
   * These workspaces are now deprecated.
   */
  V0 = 'V0',
  /** The next version of the Cara workspace schema, based in the Go codebase. */
  V1 = 'V1',
  /**
   * The current version of the Cara workspace schema, still based in Go, but leveraging
   * a different execution architecture. It doesn't change the data model of the workspace,
   * but it does change the way the workspace is executed.
   */
  V2 = 'V2'
}

/** Sort field for Cara workspace search */
export enum CaraWorkspaceSortField {
  AgencyUser = 'AGENCY_USER',
  ClientName = 'CLIENT_NAME',
  CreatedAt = 'CREATED_AT',
  Preset = 'PRESET',
  State = 'STATE',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

/** Sort input for Cara workspace search */
export type CaraWorkspaceSortInput = {
  direction: SortDirection;
  field: CaraWorkspaceSortField;
};

/** The state of a Cara workspace, indicating its current execution status */
export enum CaraWorkspaceState {
  /** The workspace is created but not yet started */
  Created = 'CREATED',
  /** The workspace has finished processing the task and is idle */
  Idle = 'IDLE',
  /** The workspace is waiting for user input to continue */
  WaitingForInput = 'WAITING_FOR_INPUT',
  /** The workspace is actively processing a task */
  Working = 'WORKING'
}

/** Represents the different types of tools that can be called within a Cara workspace. */
export enum CaraWorkspaceTool {
  /** Used to manage AgencyZoom entities (customers, leads, policies, tasks, etc.) with full field access. */
  AgencyzoomWrite = 'AGENCYZOOM_WRITE',
  /** Used to manage AMS360 entities (customers/contacts/activities/policies/suspenses) with full field access. */
  Ams360Write = 'AMS360_WRITE',
  /** Legacy Excel generator. Kept so historical workspace events that used this tool continue to load; new Excel work goes through XLSX_EDITOR. */
  ApplicationFileGenerator = 'APPLICATION_FILE_GENERATOR',
  /** Used to manage Applied Epic write operations: create activities with tasks and task notes, update a task (mark complete / change status / append notes / reschedule / reassign), create ACORD 25 Certificates of Insurance, and upload documents. */
  AppliedEpicWrite = 'APPLIED_EPIC_WRITE',
  /** Used to execute Python scripts in a sandbox environment. */
  CodeExecution = 'CODE_EXECUTION',
  /** Used to mark a task as completed and record its outcome. */
  CompleteTask = 'COMPLETE_TASK',
  /** Used to create or edit Word (.docx) documents. */
  DocxEditor = 'DOCX_EDITOR',
  /** Used to create document drafts like reports, proposals, or other written content. */
  DraftDocument = 'DRAFT_DOCUMENT',
  /**
   * Used to compose an email as a workspace draft, to revise that draft, and to copy it
   * into the agent's connected mailbox. None of its operations sends.
   */
  DraftEmail = 'DRAFT_EMAIL',
  /** Used to draft an outbound call for scheduling. The user reviews and confirms the draft before the call is placed. */
  DraftOutboundCall = 'DRAFT_OUTBOUND_CALL',
  /** Used to manage EZLynx entities (notes/calls/policies) with full field access. */
  EzlynxWrite = 'EZLYNX_WRITE',
  /** Used to create or edit a file. */
  FileEditor = 'FILE_EDITOR',
  /** Used to fill out a template such as an ACORD form. */
  FillTemplate = 'FILL_TEMPLATE',
  /** Used to retrieve one client's profile, linked AMS accounts, and owner. */
  GetClient = 'GET_CLIENT',
  /** Used to manage HawkSoft log entries and receipts with full field access. */
  HawksoftWrite = 'HAWKSOFT_WRITE',
  /** Used to list the artifacts and uploaded files attached to a client, across every workspace linked to it. */
  ListClientDocuments = 'LIST_CLIENT_DOCUMENTS',
  /** Used to look up integration metadata such as employee lists / pipeline IDs / lead sources. */
  ListIntegrationObjects = 'LIST_INTEGRATION_OBJECTS',
  /** Used to list the mailboxes the agent may send email from. It reads only. */
  ListMailboxes = 'LIST_MAILBOXES',
  /** Used to save a memory the user has explicitly asked Cara to remember. */
  MemoryCreate = 'MEMORY_CREATE',
  /** Used to re-rank the active memory context when the conversation topic shifts. */
  MemoryRefresh = 'MEMORY_REFRESH',
  /** Used to manage NowCerts entities (insureds, prospects, policies, tasks, notes, etc.) with full field access. */
  NowcertsWrite = 'NOWCERTS_WRITE',
  /** Used to organize the knowledge base by creating folders and moving documents into them. */
  OrganizeKnowledgeBase = 'ORGANIZE_KNOWLEDGE_BASE',
  /** Used to edit and manipulate PDF documents specifically. */
  PdfEditor = 'PDF_EDITOR',
  /** Use to peek at files to get a sense for their content textually or visually */
  PeekFile = 'PEEK_FILE',
  /** Fetch HTML document templates ONLY when the user explicitly requested one, asked what templates exist, or pre-selected one. Do not use for generic document requests. */
  RequestDocumentStyleTemplates = 'REQUEST_DOCUMENT_STYLE_TEMPLATES',
  /** Used to request a list of available Excel (.xlsx) spreadsheet templates for filling. */
  RequestExcelSpreadsheetTemplates = 'REQUEST_EXCEL_SPREADSHEET_TEMPLATES',
  /** Used to request per-integration tools to be provisioned on demand. */
  RequestIntegrationTools = 'REQUEST_INTEGRATION_TOOLS',
  /** Used to request a list of tools that can be used to fill out a template. */
  RequestTemplateTools = 'REQUEST_TEMPLATE_TOOLS',
  /** Used to request a list of available Word (.docx) document templates for filling. */
  RequestWordDocumentTemplates = 'REQUEST_WORD_DOCUMENT_TEMPLATES',
  /** Used to search the agency's AMS directly (live) for an account and its contacts, policies, notes, and files. */
  SearchAmsLive = 'SEARCH_AMS_LIVE',
  /** Used to find a client in the agency's book by name, email, or phone. */
  SearchClients = 'SEARCH_CLIENTS',
  /** Used to search through files and documents within the workspace. */
  SearchFile = 'SEARCH_FILE',
  /** Used to search through the organization's knowledge base for relevant information. */
  SearchKnowledgeBase = 'SEARCH_KNOWLEDGE_BASE',
  /** Used to search through entities stored and related to the organization, such as synced accounts and policies. */
  SearchKnowledgeGraph = 'SEARCH_KNOWLEDGE_GRAPH',
  /** Used to search the internet for relevant information. */
  SearchWeb = 'SEARCH_WEB',
  /** Used when the LLM needs to process information or make decisions by thinking through a problem. */
  Think = 'THINK',
  /**
   * A revision recorded by the standalone tool that preceded DRAFT_EMAIL's UPDATE_DRAFT
   * operation. Only stored events carry it; nothing writes it.
   */
  UpdateEmailDraft = 'UPDATE_EMAIL_DRAFT',
  /**
   * Used to add a new document to the organization's knowledge base, or replace an
   * existing document with a new version, from a file attached to the workspace.
   */
  UpdateKnowledgeBase = 'UPDATE_KNOWLEDGE_BASE',
  /** Used to write to an integration. */
  WriteIntegration = 'WRITE_INTEGRATION',
  /** Used to create, edit, and fill Excel (.xlsx) workbooks — ad-hoc, from uploads, or from agency spreadsheet templates. */
  XlsxEditor = 'XLSX_EDITOR',
  /** Used to push data to Zapier webhooks (notes/tasks/accounts/documents). */
  ZapierWrite = 'ZAPIER_WRITE'
}

/**
 * Represents a tool-shaped operation in a Cara workspace.
 * Most are invoked by the LLM. Deterministic replayable calls use ORCHESTRATED.
 */
export type CaraWorkspaceToolCall = {
  __typename?: 'CaraWorkspaceToolCall';
  agencyzoomWriteTool?: Maybe<AgencyZoomWriteTool>;
  ams360WriteTool?: Maybe<Ams360WriteTool>;
  applicationFileGeneratorTool?: Maybe<ApplicationFileGeneratorTool>;
  appliedEpicWriteTool?: Maybe<AppliedEpicWriteTool>;
  /**
   * DEPRECATED: The arguments passed to the tool in JSON format.
   * This field is deprecated in favor of strongly-typed argument fields in specific tool types.
   */
  argumentsJson: Scalars['String']['output'];
  codeExecutionTool?: Maybe<CodeExecutionTool>;
  completeTaskTool?: Maybe<CompleteTaskTool>;
  docxEditorTool?: Maybe<DocxEditorTool>;
  draftDocumentTool?: Maybe<DraftDocumentTool>;
  draftEmailTool?: Maybe<DraftEmailTool>;
  draftOutboundCallTool?: Maybe<DraftOutboundCallTool>;
  ezlynxWriteTool?: Maybe<EzlynxWriteTool>;
  fileEditorTool?: Maybe<FileEditorTool>;
  fillTemplateTool?: Maybe<FillTemplateTool>;
  getClientTool?: Maybe<GetClientTool>;
  hawksoftWriteTool?: Maybe<HawksoftWriteTool>;
  /**
   * The unique identifier for this tool call instance.
   * Used for tracking and referencing specific tool invocations.
   */
  id: Scalars['String']['output'];
  /** The serialized input parameters for this tool call, derived from the strongly-typed tool fields. */
  inputJson?: Maybe<Scalars['String']['output']>;
  /**
   * The raw JSON input provided by the LLM for this tool call. Some tools store this when
   * the input shape provided by the LLM is different from the shape that the tool schema
   * stores. This is used only to reconstruct the original tool call input when sending a
   * follow up API call to the LLM.
   */
  inputString?: Maybe<Scalars['String']['output']>;
  /**
   * Who initiated the invocation. ORCHESTRATED calls are replayed so later model
   * turns can use their outputs.
   */
  invocationSource?: Maybe<CaraWorkspaceToolInvocationSource>;
  listClientDocumentsTool?: Maybe<ListClientDocumentsTool>;
  listIntegrationObjectsTool?: Maybe<ListIntegrationObjectsTool>;
  listMailboxesTool?: Maybe<ListMailboxesTool>;
  memoryCreateTool?: Maybe<MemoryCreateTool>;
  memoryRefreshTool?: Maybe<MemoryRefreshTool>;
  /**
   * DEPRECATED: The name of the tool being called.
   * This field is deprecated in favor of using specific tool types.
   */
  name: Scalars['String']['output'];
  nowcertsWriteTool?: Maybe<NowCertsWriteTool>;
  organizeKnowledgeBaseTool?: Maybe<OrganizeKnowledgeBaseTool>;
  /** The serialized output for this tool call, derived from the strongly-typed tool fields. */
  outputJson?: Maybe<Scalars['String']['output']>;
  pdfEditorTool?: Maybe<PdfEditorTool>;
  peekFileTool?: Maybe<PeekFileTool>;
  requestDocumentStyleTemplatesTool?: Maybe<RequestDocumentStyleTemplatesTool>;
  requestExcelSpreadsheetTemplatesTool?: Maybe<RequestExcelSpreadsheetTemplatesTool>;
  requestIntegrationToolsTool?: Maybe<RequestIntegrationToolsTool>;
  requestTemplateToolsTool?: Maybe<RequestTemplateToolsTool>;
  requestWordDocumentTemplatesTool?: Maybe<RequestWordDocumentTemplatesTool>;
  /**
   * DEPRECATED: The result of the tool call in JSON format.
   * This field is deprecated in favor of strongly-typed result fields in specific tool types.
   */
  result: Scalars['String']['output'];
  searchAmsLiveTool?: Maybe<SearchAmsLiveTool>;
  searchClientsTool?: Maybe<SearchClientsTool>;
  searchFileTool?: Maybe<SearchFileTool>;
  searchKnowledgeBaseTool?: Maybe<SearchKnowledgeBaseTool>;
  searchKnowledgeGraphTool?: Maybe<SearchKnowledgeGraphTool>;
  searchWebTool?: Maybe<SearchWebTool>;
  thinkTool?: Maybe<ThinkTool>;
  /**
   * The exact timestamp when this tool call was made.
   * Used for auditing and tracking the sequence of tool calls.
   */
  timestamp: Scalars['Time']['output'];
  /** The type of tool call. */
  type?: Maybe<CaraWorkspaceTool>;
  /**
   * The string representation of the tool call type, in case it's not a valid type.
   * This happens when the type of the tool differs from the LLMs perspective (e.g. the
   * dynamic FILL_TEMPLATE_* tool names) or the LLM called a tool that is not supported.
   */
  typeString: Scalars['String']['output'];
  updateEmailDraftTool?: Maybe<UpdateEmailDraftTool>;
  updateKnowledgeBaseTool?: Maybe<UpdateKnowledgeBaseTool>;
  writeIntegrationTool?: Maybe<WriteIntegrationTool>;
  xlsxEditorTool?: Maybe<XlsxEditorTool>;
  zapierWriteTool?: Maybe<ZapierWriteTool>;
};

/**
 * Identifies who initiated a persisted workspace tool call. Legacy records omit this
 * field and are treated as MODEL calls.
 */
export enum CaraWorkspaceToolInvocationSource {
  /** The model selected and invoked the tool during its normal decision loop. */
  Model = 'MODEL',
  /**
   * Cara deterministically invoked the tool outside the model decision loop. These
   * calls are replayed to the model so later turns can use their outputs.
   */
  Orchestrated = 'ORCHESTRATED'
}

/**
 * A specific job inside a CaraWorkspacePreset. The preset picks the prompt
 * and tools; the use case picks wording, source roles, and which optional
 * fields to show. Values are the upper-cased form of the legacy
 * `Use Case: <id>` line so older clients stay interchangeable.
 */
export enum CaraWorkspaceUseCase {
  /** Compare a commission period against the prior one */
  AnalyzeCommission = 'ANALYZE_COMMISSION',
  /** Open-ended Q&A about an uploaded policy, quote, or binder */
  AskPolicyQuestion = 'ASK_POLICY_QUESTION',
  /** Build the open enrollment announcement and FAQ for employees */
  BuildAnnouncement = 'BUILD_ANNOUNCEMENT',
  /** Build the employee benefits guide for open enrollment */
  BuildBenefitsGuide = 'BUILD_BENEFITS_GUIDE',
  /**
   * Turn carrier rates into an employer and employee split per plan and tier, with several
   * employee benefits contribution structures priced side by side
   */
  BuildContributionWorksheet = 'BUILD_CONTRIBUTION_WORKSHEET',
  /**
   * Turn a chosen employee benefits contribution structure into per pay period deductions by plan,
   * tier, and class
   */
  BuildDeductionSchedule = 'BUILD_DEDUCTION_SCHEDULE',
  /** Build the employee benefits enrollment election form */
  BuildEnrollmentForm = 'BUILD_ENROLLMENT_FORM',
  /** Build the employer-facing comparison of the employee benefits finalists */
  BuildFinalistComparison = 'BUILD_FINALIST_COMPARISON',
  /** Build the internal employee benefits marketing grid across quoted options */
  BuildMarketingGrid = 'BUILD_MARKETING_GRID',
  /** Review classifications across a book of business in bulk */
  BulkClassReview = 'BULK_CLASS_REVIEW',
  /** Verify a quote or policy matches what was submitted on the application */
  CheckAgainstApplication = 'CHECK_AGAINST_APPLICATION',
  /** Assess errors and omissions exposure on a claim */
  CheckEoRisk = 'CHECK_EO_RISK',
  /** Classify business operations using ISO general liability codes */
  ClassifyIsoGl = 'CLASSIFY_ISO_GL',
  /** Classify business operations using NAICS codes */
  ClassifyNaics = 'CLASSIFY_NAICS',
  /** Classify business operations using SIC codes */
  ClassifySic = 'CLASSIFY_SIC',
  /** Normalize an employee benefits census and report its exceptions */
  CleanAndValidate = 'CLEAN_AND_VALIDATE',
  /** Pull insurance requirements from a lease and check against existing coverage */
  CompareLeaseToPolicy = 'COMPARE_LEASE_TO_POLICY',
  /** Side-by-side comparison of competing quote or policy options */
  CompareQuotes = 'COMPARE_QUOTES',
  /** Review what changed from the expiring policy to the renewal offer */
  CompareRenewal = 'COMPARE_RENEWAL',
  /** Compile claims history from loss runs */
  CompileLossHistory = 'COMPILE_LOSS_HISTORY',
  /** Convert commission statements into one register */
  ConvertStatement = 'CONVERT_STATEMENT',
  /**
   * Price the current employee benefits plan, the renewal, and any quoted options on one census,
   * split employer versus employee
   */
  CreateAnalysis = 'CREATE_ANALYSIS',
  /** Build any other client-facing document from source data */
  CreateOtherDocument = 'CREATE_OTHER_DOCUMENT',
  /** Build a competitive coverage proposal from quote options */
  CreateQuoteProposal = 'CREATE_QUOTE_PROPOSAL',
  /** Build a renewal proposal summarizing changes to an expiring policy */
  CreateRenewalProposal = 'CREATE_RENEWAL_PROPOSAL',
  /** Build a plain-language summary or client notice */
  CreateSummaryDocument = 'CREATE_SUMMARY_DOCUMENT',
  /** Comprehensive analysis of exclusions across all forms */
  ExploreExclusions = 'EXPLORE_EXCLUSIONS',
  /** Cross-fill an ACORD form from source documents */
  FillAcordForm = 'FILL_ACORD_FORM',
  /** Fill a due diligence questionnaire */
  FillDueDiligence = 'FILL_DUE_DILIGENCE',
  /** Fill a non-ACORD PDF form */
  FillOtherPdf = 'FILL_OTHER_PDF',
  /** Find alternative carriers for an existing risk */
  FindAlternativeCarriers = 'FIND_ALTERNATIVE_CARRIERS',
  /** Map an employee benefits census onto an enrollment platform or carrier layout */
  FormatForPlatform = 'FORMAT_FOR_PLATFORM',
  /** Full coverage gap analysis with recommended additional lines */
  FullGapAnalysis = 'FULL_GAP_ANALYSIS',
  /** Fill an ACORD certificate from a binder or policy */
  GenerateCertificate = 'GENERATE_CERTIFICATE',
  /** Generate auto ID cards from policy data */
  GenerateIdCards = 'GENERATE_ID_CARDS',
  /** Generate a client-facing risk management report */
  GenerateRiskReport = 'GENERATE_RISK_REPORT',
  /** Identify prioritized risk mitigations */
  IdentifyRiskMitigations = 'IDENTIFY_RISK_MITIGATIONS',
  /** Investigate a suspected material misrepresentation */
  InvestigatePotentialMisrep = 'INVESTIGATE_POTENTIAL_MISREP',
  /** Produce an underwriter-facing rate negotiation statement */
  NegotiateRenewalRate = 'NEGOTIATE_RENEWAL_RATE',
  /**
   * Reprice every quoted employee benefits option on one census and reproduce each carrier's own
   * total
   */
  NormalizeQuotes = 'NORMALIZE_QUOTES',
  /** Match a new submission to markets */
  PlaceNewSubmission = 'PLACE_NEW_SUBMISSION',
  /** Read an employee benefits group's claims experience ahead of the renewal conversation */
  PreRenewalReview = 'PRE_RENEWAL_REVIEW',
  /** Review an employee benefits group's claims experience and what is driving its cost */
  QuarterlyReview = 'QUARTERLY_REVIEW',
  /** Audit the first employee benefits carrier invoice after implementation */
  ReconcileFirstInvoice = 'RECONCILE_FIRST_INVOICE',
  /** Audit an ongoing employee benefits carrier invoice against enrollment and the bound rates */
  ReconcileMonthlyInvoice = 'RECONCILE_MONTHLY_INVOICE',
  /** Reconcile the accounting record of commission received against the management system */
  ReconcileReceipts = 'RECONCILE_RECEIPTS',
  /** Check what commission statements paid against what was owed */
  ReconcileStatement = 'RECONCILE_STATEMENT',
  /** Research alternative classifications to open up markets */
  ResearchAlternativeClassifications = 'RESEARCH_ALTERNATIVE_CLASSIFICATIONS',
  /** Research external risk signals behind a claim */
  ResearchClaimContext = 'RESEARCH_CLAIM_CONTEXT',
  /** Verify completeness and consistency of ACORD forms */
  ReviewAcords = 'REVIEW_ACORDS',
  /** Review an application for inconsistencies and underwriting issues */
  ReviewApplication = 'REVIEW_APPLICATION',
  /**
   * Check an employee benefits guide against the rate sheets, plan documents, and contributions
   * behind it
   */
  ReviewBenefitsGuide = 'REVIEW_BENEFITS_GUIDE',
  /** Plan next steps on an open claim */
  ReviewClaimPlanNextSteps = 'REVIEW_CLAIM_PLAN_NEXT_STEPS',
  /** Walk claim scenarios against current coverage */
  ReviewClaimScenarios = 'REVIEW_CLAIM_SCENARIOS',
  /** Review a claim against policy coverage to assess viability */
  ReviewClaimViability = 'REVIEW_CLAIM_VIABILITY',
  /** Check a certificate or evidence of insurance for accuracy and completeness */
  ReviewCoiEoi = 'REVIEW_COI_EOI',
  /** Compare a COI requirements list to the underlying policy documents */
  ReviewCoiRequirements = 'REVIEW_COI_REQUIREMENTS',
  /** Review current coverage against exposure */
  ReviewCurrentCoverage = 'REVIEW_CURRENT_COVERAGE',
  /** Review industry trends relevant to a risk */
  ReviewIndustryTrends = 'REVIEW_INDUSTRY_TRENDS',
  /** Check supplemental or carrier-specific forms for errors and omissions */
  ReviewSupplementals = 'REVIEW_SUPPLEMENTALS',
  /** Extract coverage requirements from a vendor or subcontractor agreement */
  ReviewVendorContract = 'REVIEW_VENDOR_CONTRACT',
  /** Solve for the employee benefits contribution structure that meets an employer's budget target */
  SolveToBudget = 'SOLVE_TO_BUDGET',
  /** Build a Statement of Values by researching a list of addresses */
  SovAddressOnly = 'SOV_ADDRESS_ONLY',
  /** Build a Statement of Values from documents, verified and enriched with public data */
  SovDocumentsAndWeb = 'SOV_DOCUMENTS_AND_WEB',
  /** Build a Statement of Values from uploaded documents alone */
  SovDocumentOnly = 'SOV_DOCUMENT_ONLY',
  /** Detailed summary of limits, sublimits, deductibles, and retentions */
  SummarizeCoverage = 'SUMMARIZE_COVERAGE',
  /** Verify an existing classification against the described operations */
  VerifyClassification = 'VERIFY_CLASSIFICATION',
  /** Check an employee benefits contributions worksheet against the carrier rate sheets */
  VerifyContributions = 'VERIFY_CONTRIBUTIONS',
  /** Verify insured details against supporting documents and public data */
  VerifyInsuredInfo = 'VERIFY_INSURED_INFO'
}

/**
 * One filled worksheet of an XLSX artifact produced by the XLSX_EDITOR tool. Unlike DOCX
 * sections, tabs are not separate files: the workbook is filled in place, one worksheet at a
 * time, so a tab records only what was written and the program that wrote it.
 */
export type CaraXlsxTab = {
  __typename?: 'CaraXlsxTab';
  /**
   * A short synopsis of what was written to this worksheet, generated when the tab was
   * filled or last edited. Null when no synopsis was recorded.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The worksheet name in the generated workbook */
  name: Scalars['String']['output'];
  /** The Python program that filled this worksheet, kept for debugging and audit */
  pythonCode?: Maybe<Scalars['String']['output']>;
  /** The ID of the template tab this worksheet was filled from */
  templateTabId: Scalars['String']['output'];
};

/**
 * Configuration for a business's auto liability policy's Certificate of Insurance (COI).
 * Contains details about auto coverage types, limits, and policy information.
 */
export type CertificateAutoLiabilitySection = {
  __typename?: 'CertificateAutoLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** Whether coverage applies to any auto */
  anyAutoLiability: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Whether coverage applies only to hired autos */
  hiredAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Coverage limit for bodily injury per accident */
  limitBodilyInjuryPerAccident: Scalars['Float']['output'];
  /** Coverage limit for bodily injury per person */
  limitBodilyInjuryPerPerson: Scalars['Float']['output'];
  /** Coverage limit for each accident */
  limitCombinedSingleLimitPerAccident: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Coverage limit for property damage per accident */
  limitPropertyDamagePerAccident: Scalars['Float']['output'];
  /** Whether coverage applies only to non-owned autos */
  nonOwnedAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Whether coverage applies only to owned autos */
  ownedAutosOnlyLiability: Scalars['Boolean']['output'];
  /** The auto liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the auto liability coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether coverage applies only to scheduled autos */
  scheduledAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/** CertificateEntity represents an entity involved in the insurance certificate. */
export type CertificateEntity = {
  __typename?: 'CertificateEntity';
  /** The address of the entity */
  address: Address;
  /** The name of the entity */
  name: Scalars['String']['output'];
};

/** Input for a certificate entity */
export type CertificateEntityInput = {
  /** The address of the entity */
  address: AddressInput;
  /** The name of the entity */
  name: Scalars['String']['input'];
};

/** Input for the holder of the certificate */
export type CertificateHolderInput = {
  /** The address of the holder */
  address: AddressInput;
  /** The name of the holder */
  name: Scalars['String']['input'];
};

/**
 * Configuration for a business's liability policy's Certificate of Insurance (COI).
 * Contains details about coverage types, limits, and policy information.
 */
export type CertificateLiabilitySection = {
  __typename?: 'CertificateLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** How the general aggregate limit applies - per policy, project, location or other */
  generalAggregateLimitAppliesPer: GeneralAggregateLimitAppliesPerType;
  /** Description of other general aggregate limit application if type is OTHER */
  generalAggregateLimitAppliesPerOther?: Maybe<Scalars['String']['output']>;
  /** Type of liability coverage - either claims made or occurrence based */
  liabilityCoverageType: LiabilityCoverageType;
  /** Coverage limit for damage to rented premises per occurrence */
  limitDamageToPremisesEachOccurrence: Scalars['Float']['output'];
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpensePerOccurrence: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpensePerPerson: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Coverage limit for personal and advertising injury */
  limitPersonalAndAdvertisingInjury: Scalars['Float']['output'];
  /** Coverage limit for products and completed operations */
  limitProductsAndCompletedOperations: Scalars['Float']['output'];
  /** The liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the liability coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/** CertificateLimit represents a limit associated with an insurance certificate. */
export type CertificateLimit = {
  __typename?: 'CertificateLimit';
  /** The amount of the limit */
  amount: Scalars['Float']['output'];
  /** The name of the limit */
  name: Scalars['String']['output'];
};

/** Configuration for an agency's Certificate of Insurance (COI) settings */
export type CertificateOfLiabilityAgencyConfiguration = {
  __typename?: 'CertificateOfLiabilityAgencyConfiguration';
  /** The name of the authorized representative */
  authorizedRepName: Scalars['String']['output'];
  /** Base64-encoded signature image data used for signing COIs */
  authorizedRepSignatureBase64Data: Scalars['String']['output'];
  /** Email address of the agency contact person for COI-related inquiries */
  contactEmail: Scalars['String']['output'];
  /** Fax number of the agency contact person for COI-related inquiries */
  contactFax: Scalars['String']['output'];
  /** Name of the agency contact person for COI-related inquiries */
  contactName: Scalars['String']['output'];
  /** Phone number of the agency contact person for COI-related inquiries */
  contactPhone: Scalars['String']['output'];
  /** The producer entity information that appears on COIs issued by this agency */
  producer: CertificateEntity;
  /** Whether to render the COI fields in all caps */
  renderAllCaps: Scalars['Boolean']['output'];
};

/** Input configuration for an agency's Certificate of Insurance (COI) settings */
export type CertificateOfLiabilityAgencyConfigurationInput = {
  /** The name of the authorized representative */
  authorizedRepName: Scalars['String']['input'];
  /** Base64-encoded signature image data used for signing COIs */
  authorizedRepSignatureBase64Data?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the agency contact person for COI-related inquiries */
  contactEmail: Scalars['String']['input'];
  /** Name of the agency contact person for COI-related inquiries */
  contactName: Scalars['String']['input'];
  /** Phone number of the agency contact person for COI-related inquiries */
  contactPhone: Scalars['String']['input'];
  /** The producer entity information that appears on COIs issued by this agency */
  producer: CertificateEntityInput;
  /** Whether to render the COI fields in all caps */
  renderAllCaps: Scalars['Boolean']['input'];
};

/** Configuration for a business's Certificate of Insurance (COI) */
export type CertificateOfLiabilityInsurance = {
  __typename?: 'CertificateOfLiabilityInsurance';
  /** Configuration for the agency that produced the COI */
  agency: CertificateOfLiabilityAgencyConfiguration;
  /** Configuration for the business's auto liability policy's Certificate of Insurance (COI) */
  autoLiability?: Maybe<CertificateAutoLiabilitySection>;
  /** The certificate number for the COI */
  certificateNumber: Scalars['String']['output'];
  /** The date the COI was created */
  createdAt: Scalars['Time']['output'];
  /** Description of the business's operations, used for generating COIs */
  descriptionOfOperations: Scalars['String']['output'];
  /** The URL that the COI can be downloaded at */
  downloadUrl: Scalars['String']['output'];
  /** The holder entity information that appears on COIs issued by this business */
  holder: CertificateEntity;
  /** The unique identifier for the certificate */
  id: Scalars['ID']['output'];
  /** The insured entity information that appears on COIs issued by this business */
  insured: CertificateEntity;
  /** Configuration for the business's liability policy's Certificate of Insurance (COI) */
  liability?: Maybe<CertificateLiabilitySection>;
  /** Configuration for the business's other policy's Certificate of Insurance (COI) */
  other?: Maybe<CertificateOtherSection>;
  /** Configuration for the business's umbrella or excess liability policy's Certificate of Insurance (COI) */
  umbrellaOrExcessLiability?: Maybe<CertificateUmbrellaOrExcessLiabilitySection>;
  /** The date the COI was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The URL that the COI can be viewed at */
  viewUrl: Scalars['String']['output'];
  /** Configuration for the business's workers' compensation policy's Certificate of Insurance (COI) */
  workersCompensation?: Maybe<CertificateWorkersCompensationSection>;
};

/**
 * Configuration for any other type of policy's Certificate of Insurance (COI).
 * Contains details about the coverage type, limits, and policy information.
 */
export type CertificateOtherSection = {
  __typename?: 'CertificateOtherSection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Description of the type of coverage */
  coverageType: Scalars['String']['output'];
  /** List of coverage limits and their amounts */
  limits: Array<CertificateLimit>;
  /** The other policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

export enum CertificateType {
  /** Certificate of Liability Insurance */
  Liability = 'LIABILITY',
  /** Certificate of Property Insurance */
  Property = 'PROPERTY'
}

/**
 * Configuration for a business's umbrella or excess liability policy's Certificate of Insurance (COI).
 * Contains details about umbrella/excess coverage, limits, and policy information.
 */
export type CertificateUmbrellaOrExcessLiabilitySection = {
  __typename?: 'CertificateUmbrellaOrExcessLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Deductible amount for the coverage */
  deductible: Scalars['Float']['output'];
  /** Whether this is excess liability coverage */
  excessLiability: Scalars['Boolean']['output'];
  /** Type of liability coverage - either claims made or occurrence based */
  liabilityCoverageType: LiabilityCoverageType;
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** The umbrella or excess liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the umbrella/excess coverage */
  policyNumber: Scalars['String']['output'];
  /** Retention limit for the coverage */
  retentionLimit: Scalars['Float']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
  /** Whether this is umbrella liability coverage */
  umbrellaLiability: Scalars['Boolean']['output'];
};

/**
 * Configuration for a business's workers' compensation policy's Certificate of Insurance (COI).
 * Contains details about workers' comp coverage, limits, and policy information.
 */
export type CertificateWorkersCompensationSection = {
  __typename?: 'CertificateWorkersCompensationSection';
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Name of any party excluded from coverage */
  excludedPartyName?: Maybe<Scalars['String']['output']>;
  /** Coverage limit per accident */
  limitPerAccident: Scalars['Float']['output'];
  /** Coverage limit per employee */
  limitPerEmployee: Scalars['Float']['output'];
  /** Coverage limit per policy */
  limitPerPolicy: Scalars['Float']['output'];
  /** Whether the coverage limits are provided per statute */
  limitsStatutory: Scalars['Boolean']['output'];
  /** The workers' compensation policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the workers' compensation coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/**
 * A business or individual the agency serves. "Client" rather than "insured"
 * because the relationship starts before any coverage does: a prospect with neither
 * a policy nor a quote is still a client. Distinct from a contact -- the humans
 * attached to a policy are not Client records.
 *
 * Address and contact fields are absent for a large share of records. The knowledge
 * graph is the only trustworthy source for them and most agencies have no synced
 * AMS data, so a client with only a name is a complete record of what is known
 * rather than a partial one.
 *
 * The rows linking a client to its workspaces, AMS accounts and agency users are
 * not modeled here and have no Go type either. They are join rows, and the reads
 * that will back those fields resolve through them to the entity on the far side,
 * so nothing needs to name the row itself.
 *
 * The two enums above stay in this schema only so their Go constants keep being
 * generated. No field is typed on either, so gqlgen validates nothing at the
 * boundary, and the columns they describe carry no CHECK constraint.
 */
export type Client = {
  __typename?: 'Client';
  /**
   * Null when nothing is known about the address. Because Address requires line1,
   * city, zone and postalCode together while the stored columns are individually
   * nullable, a partially known address reports empty strings for the parts that
   * are unknown rather than being dropped.
   */
  address?: Maybe<Address>;
  /**
   * The agency user primarily responsible for this client, if one is assigned.
   * Additional users in other roles are recorded separately.
   */
  agencyUserOwner?: Maybe<AgencyUser>;
  /**
   * Agency users associated with this client beyond agencyUserOwner, oldest link
   * first. The producer/servicer relationship on the link is not exposed: nothing
   * reads it, so an edge type in the shape of TeamMember would carry data no caller
   * wants. That remains the way to expose it if that changes.
   */
  agencyUsers: Array<AgencyUser>;
  /**
   * Artifacts Cara generated for this client, newest first by the artifact's own
   * timestamp rather than by when it was associated -- the backfill stamps every
   * association in one pass, so link order carries no meaning.
   *
   * Spans every workspace linked to the client, so an artifact here may belong to a
   * workspace other than the one being viewed. Documents a user removed from the
   * client are excluded.
   *
   * Filtered to what the caller can see, matching the caraWorkspaceArtifacts query,
   * and to active artifacts: an archived one is archived everywhere it is listed,
   * and comes back through the archived Documents view rather than here.
   *
   * Paginated by a keyset on the document's own timestamp, so a page is stable as
   * documents are added. first defaults to 50 and is capped at 200. Resolved per
   * client rather than batched, so selecting it on a list query is N+1; it is meant
   * for one client at a time.
   */
  artifacts: ClientArtifactConnection;
  /**
   * How much is attached to this client, for comparing two records -- which is how
   * the merge queue says which of a duplicate pair is the real one.
   */
  associationCounts: ClientAssociationCounts;
  createdAt: Scalars['Time']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /**
   * Files people uploaded for this client, newest first. Deleted files and files a
   * user removed from the client are excluded. Paginated like artifacts above.
   */
  files: ClientFileConnection;
  id: Scalars['ID']['output'];
  /**
   * Whether this client holds commercial lines. Independent of isPersonal -- both
   * may be true, for example a sole proprietor holding personal and commercial
   * policies.
   */
  isCommercial: Scalars['Boolean']['output'];
  /** Whether this client holds personal lines. See isCommercial. */
  isPersonal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /**
   * Unresolved pairs this client is on one side of, most alike first, so the detail
   * view can raise a possible duplicate where someone will meet it rather than only
   * in the queue. Empty for almost every client.
   */
  pendingMergeCandidates: Array<ClientMergeCandidate>;
  phone?: Maybe<Scalars['String']['output']>;
  updateInitiatorId: Scalars['String']['output'];
  /**
   * What last wrote this record. Lets a re-runnable backfill avoid overwriting
   * anything a human asserted.
   */
  updateInitiatorType: UpdateInitiatorType;
  updatedAt: Scalars['Time']['output'];
};


/**
 * A business or individual the agency serves. "Client" rather than "insured"
 * because the relationship starts before any coverage does: a prospect with neither
 * a policy nor a quote is still a client. Distinct from a contact -- the humans
 * attached to a policy are not Client records.
 *
 * Address and contact fields are absent for a large share of records. The knowledge
 * graph is the only trustworthy source for them and most agencies have no synced
 * AMS data, so a client with only a name is a complete record of what is known
 * rather than a partial one.
 *
 * The rows linking a client to its workspaces, AMS accounts and agency users are
 * not modeled here and have no Go type either. They are join rows, and the reads
 * that will back those fields resolve through them to the entity on the far side,
 * so nothing needs to name the row itself.
 *
 * The two enums above stay in this schema only so their Go constants keep being
 * generated. No field is typed on either, so gqlgen validates nothing at the
 * boundary, and the columns they describe carry no CHECK constraint.
 */
export type ClientArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A business or individual the agency serves. "Client" rather than "insured"
 * because the relationship starts before any coverage does: a prospect with neither
 * a policy nor a quote is still a client. Distinct from a contact -- the humans
 * attached to a policy are not Client records.
 *
 * Address and contact fields are absent for a large share of records. The knowledge
 * graph is the only trustworthy source for them and most agencies have no synced
 * AMS data, so a client with only a name is a complete record of what is known
 * rather than a partial one.
 *
 * The rows linking a client to its workspaces, AMS accounts and agency users are
 * not modeled here and have no Go type either. They are join rows, and the reads
 * that will back those fields resolve through them to the entity on the far side,
 * so nothing needs to name the row itself.
 *
 * The two enums above stay in this schema only so their Go constants keep being
 * generated. No field is typed on either, so gqlgen validates nothing at the
 * boundary, and the columns they describe carry no CHECK constraint.
 */
export type ClientFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The role an agency user plays on a client. Producer and Servicer are user
 * designations; automated processes only ever assign UNASSIGNED.
 */
export enum ClientAgencyUserRelationship {
  Producer = 'PRODUCER',
  Servicer = 'SERVICER',
  Unassigned = 'UNASSIGNED'
}

/**
 * A page of a client's documents.
 *
 * No totalCount: an exact total needs a count over every matching row, which is
 * the scan the page size exists to avoid, and nothing in the UI needs the number
 * badly enough to pay for it. hasNextPage answers what a "Load more" needs.
 */
export type ClientArtifactConnection = {
  __typename?: 'ClientArtifactConnection';
  edges: Array<ClientArtifactEdge>;
  pageInfo: PageInfo;
};

export type ClientArtifactEdge = {
  __typename?: 'ClientArtifactEdge';
  cursor: Scalars['String']['output'];
  node: CaraWorkspaceArtifactSummary;
};

/**
 * Counts of what hangs off a client. Each is a grouped count over one link table,
 * so unlike the document connections below this is cheap enough to select for
 * every row of a list.
 *
 * No document count, for the reason ClientArtifactConnection gives for having no
 * totalCount, and because most documents are reached through a linked workspace --
 * so workspaces already carries most of that signal.
 */
export type ClientAssociationCounts = {
  __typename?: 'ClientAssociationCounts';
  amsAccounts: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  workspaces: Scalars['Int']['output'];
};

export type ClientConnection = {
  __typename?: 'ClientConnection';
  edges: Array<ClientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Input for creating a certificate of insurance on the client side */
export type ClientCreateCertificateInput = {
  /**
   * If the holder is an additional insured, and is one of the allowed blanket or named insureds,
   * then this is the ID of the additional insured.
   */
  additionalInsuredId?: InputMaybe<Scalars['String']['input']>;
  /** The holder of the certificate. */
  holder: CertificateHolderInput;
  /** Whether the holder is an additional insured. */
  isAdditionalInsured: Scalars['Boolean']['input'];
  /** Whether the holder is an additional insured, but not an allowed blanket or named insured. */
  isOtherAdditionalInsured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any additional notes for the agency to review when creating the certificate. */
  notes: Scalars['String']['input'];
  /**
   * If the holder is an additional insured, but not an allowed blanket or named insured,
   * then this is the relationship of the additional insured to the holder.
   */
  otherAdditionalInsuredRelationship?: InputMaybe<Scalars['String']['input']>;
};

/** Result of creating a certificate of insurance on the client side */
export type ClientCreateCertificateResult = {
  __typename?: 'ClientCreateCertificateResult';
  /** The certificate of insurance that was created, if successful. */
  certificate?: Maybe<CertificateOfLiabilityInsurance>;
  /** The result code of the client create certificate result */
  code: ClientCreateCertificateResultCode;
  /** If the certificate was not created, the service request that was created for the agency to review. */
  serviceRequest?: Maybe<ServiceRequest>;
};

/** The result code of the client create certificate result */
export enum ClientCreateCertificateResultCode {
  /** There was an error creating the certificate, and a service request was created for the agency to review. */
  Error = 'ERROR',
  /** A policy may need to be endorsed prior to certificate creation, and a service request was created for the agency to handle. */
  RequiresEndorsement = 'REQUIRES_ENDORSEMENT',
  /** The certificate request needs to be reviewed prior to creation, and a service request was created for the agency to review. */
  RequiresReview = 'REQUIRES_REVIEW',
  /** The certificate was successfully created. */
  Success = 'SUCCESS'
}

export type ClientEdge = {
  __typename?: 'ClientEdge';
  cursor: Scalars['String']['output'];
  node: Client;
};

export type ClientFileConnection = {
  __typename?: 'ClientFileConnection';
  edges: Array<ClientFileEdge>;
  pageInfo: PageInfo;
};

export type ClientFileEdge = {
  __typename?: 'ClientFileEdge';
  cursor: Scalars['String']['output'];
  node: File;
};

export type ClientFilterInput = {
  agencyUserOwnerId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Restrict to clients holding commercial or personal lines. Both may be set, in
   * which case a client matching either is returned.
   */
  isCommercial?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Case-insensitive substring match on name. This is what the
   * workspace-association picker searches on.
   */
  nameQuery?: InputMaybe<Scalars['String']['input']>;
};

/** Fields a user can set when creating a client. */
export type ClientInput = {
  address?: InputMaybe<AddressInput>;
  /**
   * The agency user primarily responsible for this client. Must belong to the
   * caller's agency.
   */
  agencyUserOwnerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isCommercial: Scalars['Boolean']['input'];
  isPersonal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * How a client association was established, in descending order of confidence.
 * Stored per association, since different links for one client can be established
 * different ways.
 */
export enum ClientMatchMethod {
  /** A successful AMS write that returned an external ID. Deterministic. */
  AmsWrite = 'AMS_WRITE',
  /**
   * The name declared its own identity with "doing business as", and the legal half
   * matched another client exactly. No threshold is consulted, so this ranks with
   * the deterministic methods rather than the scored ones.
   */
  DbaDeclaration = 'DBA_DECLARATION',
  /** Exact, case-insensitive email match. */
  EmailExact = 'EMAIL_EXACT',
  /** IDF-weighted token similarity above the "likely" threshold. */
  IdfSimilarity = 'IDF_SIMILARITY',
  /**
   * Name similarity corroborated by at least one structured attribute. Name
   * similarity alone is never sufficient to establish a link.
   */
  NamePlusAttribute = 'NAME_PLUS_ATTRIBUTE',
  /** Exact match after normalization of case, punctuation, and legal suffix. */
  NormalizedName = 'NORMALIZED_NAME',
  /** Exact phone match on E.164 values. */
  PhoneExact = 'PHONE_EXACT',
  /** An AMS entity a workspace tool call already resolved. Deterministic. */
  ToolCallEntity = 'TOOL_CALL_ENTITY'
}

/**
 * How confident the matcher is that a suggested client is the workspace's client.
 *
 * Mirrors the matching library's own verdicts rather than a score band the client
 * re-derives, so the UI, the backfill and the merge queue describe a pair the same
 * way. There is no DIFFERENT: those are not suggested at all.
 */
export enum ClientMatchVerdict {
  /**
   * Close enough to show, not close enough to act on. The strings do not contain
   * enough information to decide.
   */
  Ambiguous = 'AMBIGUOUS',
  /**
   * Identical after normalization, or after word boundaries are removed. Decided by
   * key equality, with no threshold involved.
   */
  Exact = 'EXACT',
  /**
   * Scored above the auto-merge threshold. Note that threshold is provisional until
   * the matcher is calibrated, so this is a strong hint, not a fact.
   */
  Likely = 'LIKELY'
}

/**
 * One pair of clients that may or may not be the same client, awaiting a person's
 * decision.
 *
 * The pair is unordered -- clientA and clientB are stored in a fixed order so the
 * same two clients cannot be queued twice, and that order carries no meaning about
 * which should survive a merge.
 */
export type ClientMergeCandidate = {
  __typename?: 'ClientMergeCandidate';
  clientA: Client;
  clientB: Client;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  reason: ClientMergeCandidateReason;
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  /** Null while PENDING. */
  resolvedBy?: Maybe<AgencyUser>;
  /**
   * How alike the two names are, 0 to 1. Only meaningful for NAME_AMBIGUOUS; the
   * deterministic reasons report 1.
   */
  score: Scalars['Float']['output'];
  status: ClientMergeCandidateStatus;
};

export type ClientMergeCandidateConnection = {
  __typename?: 'ClientMergeCandidateConnection';
  edges: Array<ClientMergeCandidateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClientMergeCandidateEdge = {
  __typename?: 'ClientMergeCandidateEdge';
  cursor: Scalars['String']['output'];
  node: ClientMergeCandidate;
};

/**
 * Why the matcher declined to decide, which is also how much a human should trust
 * the pairing before acting on it.
 */
export enum ClientMergeCandidateReason {
  /**
   * Two clients resolved to the same AMS account. Deterministic rather than
   * scored, so these are the pairs closest to being safe to merge unattended.
   */
  AmsLinkAmbiguous = 'AMS_LINK_AMBIGUOUS',
  /**
   * The same client appears to be present in two connected AMSes. Common: 53 of
   * 196 agencies with active integrations have more than one.
   */
  CrossIntegration = 'CROSS_INTEGRATION',
  /**
   * Name scoring landed in the band no threshold separates. Weakest signal here:
   * the information that would decide it -- address, phone, FEIN -- is not in the
   * name.
   */
  NameAmbiguous = 'NAME_AMBIGUOUS'
}

/**
 * Where a pair stands. Both resolved states are permanent as far as matching is
 * concerned -- neither is re-raised by a later backfill run.
 */
export enum ClientMergeCandidateStatus {
  /**
   * A person said these are different clients. Sticky: no later run may re-queue
   * the pair or merge it automatically.
   */
  KeptSeparate = 'KEPT_SEPARATE',
  /** Merged, with clientA and clientB naming the survivor and the absorbed record. */
  Merged = 'MERGED',
  Pending = 'PENDING'
}

/**
 * A free-form note a user wrote on a client.
 *
 * Notepad-style on purpose: plain text, no formatting model, no mentions, no
 * attachments. AI-generated notes are out of scope for this phase, and client-level
 * "memories" are a separate later concept rather than a richer version of this.
 *
 * There is no edit history. An edit rewrites the body and bumps updatedAt, so
 * author plus those two timestamps is the whole provenance a note carries.
 */
export type ClientNote = {
  __typename?: 'ClientNote';
  /**
   * Who wrote the note. Stays the original author across edits, since an edit
   * rewrites the body rather than creating a new note.
   */
  author?: Maybe<AgencyUser>;
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum ClientSortField {
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/**
 * Direction defaults per field when omitted -- NAME ascending for an alphabetical
 * list, UPDATED_AT descending for most-recent-first.
 */
export type ClientSortInput = {
  direction?: InputMaybe<SortDirection>;
  field: ClientSortField;
};

/**
 * A client a workspace might belong to.
 *
 * Suggestions only. Confirming one is an explicit user action through
 * linkClientWorkspace -- nothing here links automatically, because a wrong link
 * buries a workspace under the wrong client's history and is close to invisible
 * afterwards.
 */
export type ClientSuggestion = {
  __typename?: 'ClientSuggestion';
  client: Client;
  /**
   * IDF-weighted token similarity, 0 to 1, for ordering and for showing the user
   * how strong a match is. Exact matches score 1.0.
   */
  score: Scalars['Float']['output'];
  verdict: ClientMatchVerdict;
};

export type ClientToolAmsAccount = {
  __typename?: 'ClientToolAmsAccount';
  /** The account's identifier within that AMS. */
  externalId: Scalars['String']['output'];
  /** Which AMS the account lives in, for example HAWKSOFT or APPLIED_EPIC. */
  integrationType: Scalars['String']['output'];
  /** True for the account treated as this client's primary AMS record. */
  isPrimary: Scalars['Boolean']['output'];
};

export type ClientToolArtifact = {
  __typename?: 'ClientToolArtifact';
  createdAt: Scalars['String']['output'];
  /** Artifact id. Identifies the artifact across all of its versions. */
  id: Scalars['String']['output'];
  latestVersion: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /**
   * The workspace this artifact was produced in. It may not be the current one --
   * reusing another workspace's artifact is the point of this tool.
   */
  workspaceId: Scalars['String']['output'];
  workspaceTitle: Scalars['String']['output'];
};

export type ClientToolFile = {
  __typename?: 'ClientToolFile';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * The lean client shape both SEARCH_CLIENTS and GET_CLIENT return. Kept small on
 * purpose -- these land in the agent's context, and a full profile per search hit
 * would crowd out the rest of the conversation.
 */
export type ClientToolSummary = {
  __typename?: 'ClientToolSummary';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isCommercial: Scalars['Boolean']['output'];
  isPersonal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/**
 * An output file produced by CODE_EXECUTION and stored as an agency file.
 * Today these are typically chart PNGs; the type is not limited to charts.
 */
export type CodeExecutionOutputFile = {
  __typename?: 'CodeExecutionOutputFile';
  /** Agency file id for the stored output file (S3 key and statics path segment). */
  id: Scalars['ID']['output'];
  /** MIME type of the stored output file. */
  mimeType: Scalars['String']['output'];
  /** Download filename including extension (e.g. premium_trends.png). */
  name: Scalars['String']['output'];
  /** Stable statics URL to preview or download the output file. */
  url: Scalars['String']['output'];
};

/**
 * Tool for executing Python in a secure sandbox for analysis, charts, verification, and targeted scraping.
 * This is complementary to XLSX_EDITOR and DOCX_EDITOR — do not use this tool to produce XLSX or DOCX office files.
 */
export type CodeExecutionTool = {
  __typename?: 'CodeExecutionTool';
  /** The input arguments for the code execution operation */
  input: CodeExecutionToolInput;
  /** The result of the code execution operation */
  output: CodeExecutionToolOutput;
};

/** Input arguments for the CODE_EXECUTION tool. */
export type CodeExecutionToolInput = {
  __typename?: 'CodeExecutionToolInput';
  /** Runnable Python 3 source executed as-is in the sandbox (no server-side code generation). */
  pythonScript: Scalars['String']['output'];
  /**
   * Optional workspace file IDs to stage into the sandbox before the script runs.
   * Intended for data-analysis inputs (e.g. .csv, .json, .txt, .xlsx, .pdf). Use XLSX_EDITOR / DOCX_EDITOR for creating, editing, repairing, or exporting Excel/Word files.
   * Files are written to /tmp/<file_id> in the sandbox, except a PDF, which is staged as its extracted page text at /tmp/<file_id>.txt. Omit when no staged files are required.
   */
  sourceFileIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Short human-readable label for this run shown in the workspace timeline. */
  title: Scalars['String']['output'];
};

/** Result of a CODE_EXECUTION tool invocation. */
export type CodeExecutionToolOutput = {
  __typename?: 'CodeExecutionToolOutput';
  /** Output files saved as agency files with stable statics URLs. */
  outputFiles: Array<CodeExecutionOutputFile>;
  /** Short guidance for follow-up turns e.g. retry hints. */
  remarks?: Maybe<Scalars['String']['output']>;
  /** Process exit code from the sandbox Python invocation. */
  returnCode: Scalars['Int']['output'];
  /** Captured stderr truncated when large. */
  stderr?: Maybe<Scalars['String']['output']>;
  /** Captured stdout truncated when large. */
  stdout?: Maybe<Scalars['String']['output']>;
};

/** Code block style */
export type CodeStyle = {
  __typename?: 'CodeStyle';
  /** Background color in hex format (e.g. '#f1f5f9') */
  backgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Border radius in pixels (e.g. 3.0) */
  borderRadiusPx?: Maybe<Scalars['Float']['output']>;
  /** Text color in hex format (e.g. '#1e293b') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Font family name (e.g. 'Courier New', 'Roboto Mono') */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size in points (e.g. 9.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Padding in em units (e.g. 0.2) */
  paddingEm?: Maybe<Scalars['Float']['output']>;
};

/** Input for code block style */
export type CodeStyleInput = {
  /** Code block background color as a hex string */
  backgroundColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Border radius for code block corners in pixels */
  borderRadiusPx?: InputMaybe<Scalars['Float']['input']>;
  /** Code text color as a hex string */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font family for code text */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Font size in points for code text */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Padding for the code block in em units */
  paddingEm?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Represents a tool for completing a specific task or action.
 * Used when the LLM needs to perform a concrete action based on its analysis.
 */
export type CompleteTaskTool = {
  __typename?: 'CompleteTaskTool';
  /** The input arguments for the task completion */
  input: CompleteTaskToolInput;
  /** The result of the task completion attempt */
  output: CompleteTaskToolOutput;
};

/**
 * Input arguments for the CompleteTaskTool.
 * Contains all necessary information to complete a specific task.
 */
export type CompleteTaskToolInput = {
  __typename?: 'CompleteTaskToolInput';
  /** The name of the client or entity the task is for */
  clientName: Scalars['String']['output'];
  /** Keywords associated with the task for categorization and search */
  keywords: Array<Scalars['String']['output']>;
  /** Whether the task requires additional input from a human agent */
  needsAgentInput: Scalars['Boolean']['output'];
};

/**
 * Result of a CompleteTaskTool operation.
 * Indicates whether the task was completed successfully.
 */
export type CompleteTaskToolOutput = {
  __typename?: 'CompleteTaskToolOutput';
  /** Whether the task completion was successful */
  success: Scalars['Boolean']['output'];
};

/**
 * A consumption event represents customer-facing usage tracked for billing.
 * Raw vendor/API COGS remain in cost_event; this table is the customer usage ledger.
 */
export type ConsumptionEvent = {
  __typename?: 'ConsumptionEvent';
  /** Agency rate override applied at confirmation time, if any */
  agencyRateOverrideId?: Maybe<Scalars['String']['output']>;
  /** Key identifying the billable product unit, e.g. workspace:{stageId}:response */
  billableUnitKey?: Maybe<Scalars['String']['output']>;
  /** Call context, when applicable */
  callId?: Maybe<Scalars['String']['output']>;
  /** Optional link to a related cost_event row (temporary migration aid) */
  costEventId?: Maybe<Scalars['String']['output']>;
  /** Type of underlying cost/usage (mirrors cost_event.type) */
  costEventType: CostEventType;
  /** When this record was created */
  createdAt: Scalars['Time']['output'];
  /** Custom form context, when applicable (e.g. custom PDF form fill or ingestion) */
  customFormId?: Maybe<Scalars['String']['output']>;
  /** Email thread context, when applicable */
  emailThreadId?: Maybe<Scalars['String']['output']>;
  /** Excel spreadsheet template context, when applicable (e.g. Excel template fill or ingestion) */
  excelSpreadsheetTemplateId?: Maybe<Scalars['String']['output']>;
  /** File chunk index, when applicable */
  fileChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** File context, when applicable */
  fileId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the consumption event */
  id: Scalars['ID']['output'];
  /** Idempotency key for retry-safe usage recording */
  idempotencyKey: Scalars['String']['output'];
  /** Knowledge base document chunk index, when applicable */
  knowledgeBaseDocumentChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** Knowledge base document context, when applicable */
  knowledgeBaseDocumentId?: Maybe<Scalars['String']['output']>;
  /** Provider-specific or low-volume details not modeled as columns */
  metadata: Scalars['JSON']['output'];
  /** Customer-facing meter code, set at confirmation time */
  meterCode?: Maybe<ConsumptionMeterCode>;
  /** Model identifier when applicable (e.g. LLM model ID) */
  modelId?: Maybe<Scalars['String']['output']>;
  /** When this usage occurred */
  occurredAt: Scalars['Time']['output'];
  /** Billable quantity after rate conversion, set at confirmation time */
  quantityBillable?: Maybe<Scalars['Decimal']['output']>;
  /** Raw quantity consumed before billable-unit conversion */
  quantityRaw: Scalars['Decimal']['output'];
  /** Rate line used at confirmation time */
  rateLineId?: Maybe<Scalars['String']['output']>;
  /** Rate schedule version used at confirmation time */
  rateScheduleVersionId?: Maybe<Scalars['String']['output']>;
  /** Unit for quantityRaw (mirrors cost_event.unit) */
  rawUnit: CostEventUnit;
  /** Stage event context, when applicable */
  stageEventId?: Maybe<Scalars['String']['output']>;
  /** Stage context, when applicable */
  stageId?: Maybe<Scalars['String']['output']>;
  /** Tool call context, when applicable */
  toolCallId?: Maybe<Scalars['String']['output']>;
  /** Tool call type, when applicable */
  toolCallType?: Maybe<CaraWorkspaceTool>;
  /** Total cost in dollars for this raw usage (COGS owned by this table) */
  totalCostDollars: Scalars['Decimal']['output'];
  /** Cost per raw unit in dollars (COGS owned by this table) */
  unitCostDollars: Scalars['Decimal']['output'];
  /** When this record was last updated */
  updatedAt: Scalars['Time']['output'];
  /** When usage was confirmed billable */
  usageConfirmedAt?: Maybe<Scalars['Time']['output']>;
  /** Current lifecycle status of this usage row */
  usageStatus: ConsumptionUsageStatus;
  /** Optional reason for the current usage status (e.g. void reason) */
  usageStatusReason?: Maybe<Scalars['String']['output']>;
  /** Word document template context, when applicable (e.g. Word template fill or ingestion) */
  wordDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /** Workspace context, when applicable */
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/** Customer-facing billing meter codes. */
export enum ConsumptionMeterCode {
  /** Knowledge base document pages processed */
  KbPage = 'KB_PAGE',
  /** Generic platform usage (LLM tokens, API requests, sandbox time, etc.) */
  PlatformUnit = 'PLATFORM_UNIT',
  /** Voice agent call time */
  VoiceMinute = 'VOICE_MINUTE'
}

/** Lifecycle status for a customer usage ledger row. */
export enum ConsumptionUsageStatus {
  /** Usage confirmed and counted toward billing, limits, and invoices. */
  Billable = 'BILLABLE',
  /** Internal-only usage not billed to the customer. */
  Internal = 'INTERNAL',
  /** Usage recorded but not yet confirmed billable. */
  Pending = 'PENDING',
  /** Shadow-mode usage recorded for comparison without billing impact. */
  Shadow = 'SHADOW',
  /** Usage voided (failed, cancelled, or otherwise non-billable work). */
  Void = 'VOID'
}

/** A cost event represents a single cost incurred in the system */
export type CostEvent = {
  __typename?: 'CostEvent';
  /** When this record was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the cost event */
  id: Scalars['ID']['output'];
  /**
   * Additional metadata about the cost event
   * e.g. {"workspace_id": "ws_123", "stage_id": "stage_456", "tool_call_id": "tool_789"}
   */
  metadata: CostEventMetadata;
  /** When this cost event occurred */
  occurredAt: Scalars['Time']['output'];
  /** The quantity of units consumed */
  quantity: Scalars['Int']['output'];
  /** The total cost in dollars */
  totalCostDollars: Scalars['Decimal']['output'];
  /** The type of cost event */
  type: CostEventType;
  /** The unit of the quantity (e.g. 'seconds', 'tokens', 'bytes') */
  unit: CostEventUnit;
  /** The cost per unit in dollars */
  unitCostDollars: Scalars['Decimal']['output'];
  /** When this record was last updated */
  updatedAt: Scalars['Time']['output'];
};

export type CostEventMetadata = {
  __typename?: 'CostEventMetadata';
  /** If this cost event is related to a call, the ID of the call */
  callId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a custom form, the ID of the custom form */
  customFormId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the email thread this cost event belongs to */
  emailThreadId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to an Excel spreadsheet template, the ID of the template */
  excelSpreadsheetTemplateId?: Maybe<Scalars['ID']['output']>;
  /** If this cost event is related to a file chunk, the index of the chunk */
  fileChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** If this cost event is related to a file, the ID of the file */
  fileId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a knowledge base document chunk, the index of the chunk */
  knowledgeBaseDocumentChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** If this cost event is related to a knowledge base document, the ID of the document */
  knowledgeBaseDocumentId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a knowledge base policy, the ID of the policy */
  knowledgeBasePolicyId?: Maybe<Scalars['String']['output']>;
  /** The search context size used for the perplexity search */
  perplexitySearchContextSize?: Maybe<Scalars['String']['output']>;
  /** The model used for the perplexity search */
  perplexitySearchModel?: Maybe<Scalars['String']['output']>;
  /** The ID of the stage event this cost event belongs to */
  stageEventId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the stage this cost event belongs to */
  stageId?: Maybe<Scalars['ID']['output']>;
  /** The tag for this cost event, indicating the context that the cost event was incurred in */
  tag: CostEventMetadataTag;
  /** The ID of the stage event this cost event belongs to, if specifically invoked by a tool call */
  toolCallId?: Maybe<Scalars['ID']['output']>;
  /** The type of the tool call this cost event belongs to */
  toolCallType?: Maybe<CaraWorkspaceTool>;
  /** If this cost event is related to a Word document template, the ID of the template */
  wordDocumentTemplateId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the workspace this cost event belongs to */
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

/** Tags that indicate the context in which a cost event was incurred */
export enum CostEventMetadataTag {
  /** Cost incurred while generating the base fill prompt for a custom form (Claude) */
  CustomFormIngestionBasePrompt = 'CUSTOM_FORM_INGESTION_BASE_PROMPT',
  /** Cost incurred while running per-crop Gemini vision for custom form checkbox/radio/select fields */
  CustomFormIngestionButtonVision = 'CUSTOM_FORM_INGESTION_BUTTON_VISION',
  /** Cost incurred while running batch Gemini vision for custom form field identification (text/number/date path) */
  CustomFormIngestionFieldVision = 'CUSTOM_FORM_INGESTION_FIELD_VISION',
  /** Cost incurred while running batch Gemini vision for custom form select fallback (anchor PDF path) */
  CustomFormIngestionSelectFallbackVision = 'CUSTOM_FORM_INGESTION_SELECT_FALLBACK_VISION',
  /** Cost incurred while classifying an email thread */
  EmailThreadClassify = 'EMAIL_THREAD_CLASSIFY',
  /** Cost incurred while formatting an email thread */
  EmailThreadFormat = 'EMAIL_THREAD_FORMAT',
  /** Cost incurred while generating an email response */
  EmailThreadGenerateResponse = 'EMAIL_THREAD_GENERATE_RESPONSE',
  /** Cost incurred while parsing service requests from an email thread */
  EmailThreadParseServiceRequests = 'EMAIL_THREAD_PARSE_SERVICE_REQUESTS',
  /** Cost incurred while ingesting an Excel spreadsheet template tab (extracting fields and fillGuidance via LLM) */
  ExcelSpreadsheetTemplateIngestion = 'EXCEL_SPREADSHEET_TEMPLATE_INGESTION',
  /** Cost incurred while indexing a document in a knowledge base */
  KnowledgeBaseIndexDocument = 'KNOWLEDGE_BASE_INDEX_DOCUMENT',
  /** Cost incurred while indexing a policy in the accounts and policies section of the knowlege module */
  KnowledgeBaseIndexPolicy = 'KNOWLEDGE_BASE_INDEX_POLICY',
  /** Cost attributed to the memory dream phase (synthesis, consolidation, eviction) */
  MemoryDream = 'MEMORY_DREAM',
  /** Cost attributed to the memory extraction phase (extracting candidates from workspace conversations) */
  MemoryExtraction = 'MEMORY_EXTRACTION',
  /** Cost attributed to the memory reconciliation phase (deduplicating candidates against existing memories) */
  MemoryReconciliation = 'MEMORY_RECONCILIATION',
  /** Cost incurred while searching a file in a workspace */
  PerplexityWebSearch = 'PERPLEXITY_WEB_SEARCH',
  /** Cost incurred while analyzing a phone conversation */
  PhoneCallAnalyzeConversation = 'PHONE_CALL_ANALYZE_CONVERSATION',
  /** Cost incurred while answering a question on inbound phone call */
  PhoneCallAnswerPolicyQuestion = 'PHONE_CALL_ANSWER_POLICY_QUESTION',
  /** Cost incurred while detecting which email addresses to send email notifications to */
  PhoneCallDetectEmailNotifications = 'PHONE_CALL_DETECT_EMAIL_NOTIFICATIONS',
  /** Cost incurred while enhancing a phone call transcript with Gemini */
  PhoneCallEnhanceTranscript = 'PHONE_CALL_ENHANCE_TRANSCRIPT',
  /** Cost incurred while handling an inbound phone call */
  PhoneCallHandleInbound = 'PHONE_CALL_HANDLE_INBOUND',
  /** Cost incurred while handling an outbound phone call */
  PhoneCallHandleOutbound = 'PHONE_CALL_HANDLE_OUTBOUND',
  /** Cost incurred while parsing service requests from a phone call */
  PhoneCallParseServiceRequests = 'PHONE_CALL_PARSE_SERVICE_REQUESTS',
  /** Cost incurred while generating clarifying questions for the Convert-to-Preset wizard */
  PresetGenerationClarifyingQuestions = 'PRESET_GENERATION_CLARIFYING_QUESTIONS',
  /** Cost incurred while drafting the preset prompt for the Convert-to-Preset wizard */
  PresetGenerationDrafting = 'PRESET_GENERATION_DRAFTING',
  /** Cost incurred while resolving one live form against one bucket for Smart Fill */
  SmartFillResolve = 'SMART_FILL_RESOLVE',
  /** Cost incurred while extracting a reviewed Super Copy draft from a web source */
  SmartFillSuperCopyExtract = 'SMART_FILL_SUPER_COPY_EXTRACT',
  /** Cost incurred while converting a Cara workspace into a Smart Fill client bucket */
  SmartFillWorkspaceConvert = 'SMART_FILL_WORKSPACE_CONVERT',
  /** Cost incurred while ingesting a Word document template section (extracting placeholders and fillGuidance via LLM) */
  WordDocumentTemplateIngestion = 'WORD_DOCUMENT_TEMPLATE_INGESTION',
  /** Cost incurred while generating follow up options for a message in a workspace */
  WorkspaceGenerateFollowUpOptions = 'WORKSPACE_GENERATE_FOLLOW_UP_OPTIONS',
  /** Cost incurred while generating a title for a workspace */
  WorkspaceGenerateTitle = 'WORKSPACE_GENERATE_TITLE',
  /** Cost incurred while indexing a file in a workspace */
  WorkspaceIndexFile = 'WORKSPACE_INDEX_FILE',
  /** Cost incurred while generating a response in a workspace */
  WorkspaceResponse = 'WORKSPACE_RESPONSE',
  /** Cost incurred while searching a knowledge base from a workspace */
  WorkspaceSearchKnowledgeBase = 'WORKSPACE_SEARCH_KNOWLEDGE_BASE',
  /** Cost incurred while thinking in a workspace */
  WorkspaceThought = 'WORKSPACE_THOUGHT',
  /** Cost incurred while making a tool call from a workspace */
  WorkspaceToolCall = 'WORKSPACE_TOOL_CALL'
}

/** Cost event types that can occur in the system */
export enum CostEventType {
  /** Cost event for call duration, measured in seconds */
  CallDuration = 'CALL_DURATION',
  /** Cost event for embedding input tokens */
  EmbeddingInput = 'EMBEDDING_INPUT',
  /** Cost event for HTTP requests */
  HttpRequest = 'HTTP_REQUEST',
  /** Cost event for LLM cache read operations */
  LlmCacheRead = 'LLM_CACHE_READ',
  /** Cost event for LLM cache write operations */
  LlmCacheWrite = 'LLM_CACHE_WRITE',
  /** Cost event for LLM input tokens */
  LlmInput = 'LLM_INPUT',
  /** Cost event for LLM output tokens */
  LlmOutput = 'LLM_OUTPUT',
  /** Cost event for Modal sandbox CPU core-seconds */
  ModalCpuSecond = 'MODAL_CPU_SECOND',
  /** Cost event for Modal sandbox GiB-seconds (memory time) */
  ModalGbSecond = 'MODAL_GB_SECOND',
  /** Cost event for Reducto service credit usage */
  ReductoCredit = 'REDUCTO_CREDIT',
  /** Cost event for reranking input tokens */
  RerankInput = 'RERANK_INPUT'
}

/** Units for cost events */
export enum CostEventUnit {
  /** Nominal unit, used to represent a discrete count (e.g. number of files, number of requests, etc.) */
  Nominal = 'NOMINAL',
  /** Time-based unit */
  Second = 'SECOND',
  /** Token-based unit */
  Token = 'TOKEN'
}

/** CreateAMS360IntegrationInput contains the input for creating an AMS360 integration */
export type CreateAms360IntegrationInput = {
  /** AMS360 Agency Number */
  agencyNo: Scalars['String']['input'];
  /** AMS360 App Access to Agency Key for authentication */
  appAccessToAgencyKey: Scalars['String']['input'];
  /** AMS360 App Key for authentication */
  appKey: Scalars['String']['input'];
};

/** Input for creating a new account contact */
export type CreateAccountContactInput = {
  /** The contact's email address */
  email: Scalars['String']['input'];
  /** The contact's name */
  name: Scalars['String']['input'];
  /** The contact's phone number */
  phone: Scalars['String']['input'];
};

/** Input for creating a new agency account */
export type CreateAccountInput = {
  /** If provided, ID of an existing contact to associate with the account */
  associateContactId?: InputMaybe<Scalars['String']['input']>;
  /** Business account details */
  business?: InputMaybe<CreateBusinessAccountInput>;
  /** Contact details for the account, if a new contact should be created */
  contact?: InputMaybe<CreateAccountContactInput>;
  /** Individual account details */
  individual?: InputMaybe<CreateIndividualAccountInput>;
  /** The type of account - either a business or individual account. */
  type: AccountType;
};

/** Input for creating a new agency */
export type CreateAgencyInput = {
  /** Agency details */
  agency: AgencyInput;
  /** The initially selected onboarding date for the agency based on when they created their account */
  onboardingDate?: InputMaybe<Scalars['Time']['input']>;
  /**
   * The ID of the parent agency, if the agency is a child agency. Users usually
   * have the SELF:AGENCY:CREATE permission, so that they can sign up as standalone
   * customers. However, specifying this field requires the ORGANIZATION:AGENCY:CREATE
   * permission (as is implied by the scopeResource argument). This will only be granted
   * to admins of the agency they are currently logged in for.
   */
  parentAgencyId?: InputMaybe<Scalars['String']['input']>;
  /** Users to create for the agency */
  users: Array<AgencyUserInput>;
};

/**
 * Input for creating a profile. Configuration is not accepted here: a new profile
 * starts from the full set of grants its agency's roles already allow, and the
 * admin narrows it on the detail page.
 */
export type CreateAgencyProfileInput = {
  /**
   * What this profile is for. Required — an unexplained profile is one nobody
   * else can safely assign.
   */
  description: Scalars['String']['input'];
  /** Name of the profile. Must be unique within the agency (case-insensitive). */
  name: Scalars['String']['input'];
};

/** CreateAgencyZoomIntegrationInput contains the input for creating an Agency Zoom integration */
export type CreateAgencyZoomIntegrationInput = {
  /** If enabled, allows users to log in to Agency Zoom via SSO. */
  isSSOLogin: Scalars['Boolean']['input'];
  /** Agency Zoom password for basic authentication */
  password: Scalars['String']['input'];
  /** Agency Zoom username for basic authentication */
  username: Scalars['String']['input'];
};

/** CreateAppliedEpicIntegrationInput contains the input for creating an Applied Epic integration */
export type CreateAppliedEpicIntegrationInput = {
  /** API credentials for the Applied Epic integration */
  apiCredentials?: InputMaybe<AppliedEpicApiCredentialsInput>;
  /** SDK credentials for the Applied Epic integration */
  sdkCredentials?: InputMaybe<AppliedEpicSdkCredentialsInput>;
  /** Type of Applied Epic integration */
  type: AppliedEpicIntegrationType;
};

/** Input for creating a new business record */
export type CreateBusinessAccountInput = {
  /** Doing Business As (DBA) name, if different from legal name */
  dba: Scalars['String']['input'];
  /** Primary email address for contacting the business */
  email: Scalars['String']['input'];
  /** Mailing address for the business */
  mailingAddress: AddressInput;
  /** Legal name of the business */
  name: Scalars['String']['input'];
  /** Primary phone number for contacting the business */
  phone: Scalars['String']['input'];
  /** Website URL for the business */
  website: Scalars['String']['input'];
};

/** Input for creating multiple business policies */
export type CreateBusinessPoliciesInput = {
  /** ID of the account to create policies for */
  accountId: Scalars['String']['input'];
  /** List of policies to create */
  policies: Array<CreateBusinessPolicyInput>;
};

/** Input for creating a single business policy */
export type CreateBusinessPolicyInput = {
  /** Type of agency billing */
  agencyBillingType?: InputMaybe<BusinessPolicyAgencyBillingType>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['input'];
  /** ID of the agency user who sourced the policy */
  agencyUserId: Scalars['String']['input'];
  /** Reference ID for existing Ascend quote */
  ascendExistingQuoteRefId?: InputMaybe<Scalars['String']['input']>;
  /** Mode for creating Ascend program */
  ascendProgramCreationMode?: InputMaybe<AscendProgramCreationMode>;
  /** ID of the Ascend program */
  ascendProgramId?: InputMaybe<Scalars['String']['input']>;
  /** Type of billing for the policy */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['input'];
  /** ID of the broker, if applicable */
  brokerId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the insurance carrier */
  carrierId: Scalars['String']['input'];
  /** Estimated commission percentage */
  estimatedCommission: Scalars['Float']['input'];
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** Unique identifier for the policy, used only for Ascend program referencing (an ID is actually generated by the server) */
  id: Scalars['String']['input'];
  /** When the policy goes into effect */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Insurance market the policy is written in */
  market: InsuranceMarket;
  /** Minimum earned premium for the policy */
  minimumEarnedPremium: Scalars['Float']['input'];
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['input'];
  /** Payment interval of the policy. If billed via ASCEND, leave this blank */
  paymentIntervalType?: InputMaybe<PaymentIntervalType>;
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['input'];
  /** Policy number once issued */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium: Scalars['Float']['input'];
  /** Quote number from carrier */
  quoteNumber: Scalars['String']['input'];
  /** Current state of the policy */
  state: PolicyState;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['input'];
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total: Scalars['Float']['input'];
  /** Type of insurance policy */
  type: InsuranceType;
};

/** Input for creating a certificate of insurance */
export type CreateCertificateInput = {
  /** The ID of the account this certificate is associated with */
  accountId: Scalars['ID']['input'];
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['input'];
  /** Description of the operations covered by the certificate */
  descriptionOfOperations: Scalars['String']['input'];
  /** The holder of the certificate */
  holder: CertificateHolderInput;
};

/** Options for creating a certificate of insurance on the client side */
export type CreateCertificateOptions = {
  __typename?: 'CreateCertificateOptions';
  /** The allowed blanket additional insureds for this certificate */
  allowedBlanketAdditionalInsureds: Array<BlanketAdditionalInsuredCertificateOption>;
  /** The allowed named additional insureds for this certificate */
  allowedNamedAdditionalInsureds: Array<NamedAdditionalInsuredCertificateOption>;
};

/** Details for a request to create a Certificate of Insurance */
export type CreateCertificateRequest = {
  __typename?: 'CreateCertificateRequest';
  /** Whether the certificate holder should be listed as additional insured */
  additionalInsured: Scalars['Boolean']['output'];
  /** Relationship between policyholder and additional insured, if applicable */
  additionalInsuredRelationship?: Maybe<Scalars['String']['output']>;
  /** Additional details about the relationship, if applicable */
  additionalInsuredRelationshipDescription?: Maybe<Scalars['String']['output']>;
  /** Address of the certificate holder */
  address: Address;
  /** Name of the certificate holder */
  name: Scalars['String']['output'];
};

/** Input type for creating a Certificate of Insurance request */
export type CreateCertificateRequestInput = {
  /** Whether the certificate holder should be listed as additional insured */
  additionalInsured: Scalars['Boolean']['input'];
  /** Relationship between policyholder and additional insured, if applicable */
  additionalInsuredRelationship?: InputMaybe<Scalars['String']['input']>;
  /** Additional details about the relationship, if applicable */
  additionalInsuredRelationshipDescription?: InputMaybe<Scalars['String']['input']>;
  /** Address of the certificate holder */
  address: AddressInput;
  /** Name of the certificate holder */
  name: Scalars['String']['input'];
};

/** CreateEzLynxIntegrationInput contains the input for creating an EZLynx integration */
export type CreateEzLynxIntegrationInput = {
  /** EZLynx app secret for authentication. Optional. */
  appSecret?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx client ID for authentication. Optional - required only for API mode. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx client secret for authentication. Optional - required only for API mode. */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, explicitly marks this as a CSV import-only integration (no API access), even when credentials are present.
   * When false and credentials are provided, both CSV import and API usage are allowed.
   * Defaults to false.
   */
  csvImportOnly: Scalars['Boolean']['input'];
  /** EZLynx integration group ID. Optional - required only for API mode. */
  integrationGroupId?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx password for authentication. Optional. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx username for authentication. Optional - required only for API mode. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** CreateHawksoftIntegrationInput contains the input for creating a Hawksoft integration */
export type CreateHawksoftIntegrationInput = {
  /** Hawksoft agency ID */
  agencyId: Scalars['String']['input'];
};

/** CreateHubSpotIntegrationInput contains the input for creating a HubSpot integration */
export type CreateHubSpotIntegrationInput = {
  /** Personal Access Token for HubSpot API authentication */
  accessToken: Scalars['String']['input'];
  /** Field mappings for call syncing */
  callFieldMappings?: InputMaybe<HubSpotCallFieldMappingsInput>;
  /** The pipeline ID to use when syncing calls as tickets or deals */
  callPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing calls as tickets or deals */
  callStageId?: InputMaybe<Scalars['String']['input']>;
  /** Field mappings for task syncing */
  taskFieldMappings?: InputMaybe<HubSpotTaskFieldMappingsInput>;
  /** The pipeline ID to use when syncing tasks as tickets or deals */
  taskPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing tasks as tickets or deals */
  taskStageId?: InputMaybe<Scalars['String']['input']>;
};

/** CreateImageRightIntegrationInput contains the input for creating an ImageRight integration */
export type CreateImageRightIntegrationInput = {
  /** ImageRight password for authentication */
  password: Scalars['String']['input'];
  /**
   * ImageRight server URL. ImageRight is self-hosted per-agency, so each agency
   * provides the base URL of their own ImageRight server.
   */
  serverUrl: Scalars['String']['input'];
  /** ImageRight username for authentication */
  username: Scalars['String']['input'];
};

/** Input for creating a new business record */
export type CreateIndividualAccountInput = {
  /** Primary email address for contacting the individual */
  email: Scalars['String']['input'];
  /** Mailing address for the individual */
  mailingAddress: AddressInput;
  /** Full name of the individual */
  name: Scalars['String']['input'];
  /** Primary phone number for contacting the individual */
  phone: Scalars['String']['input'];
};

/** CreateIntegrationInput contains the input for creating an integration */
export type CreateIntegrationInput = {
  /** Configuration for the Agency Zoom integration */
  agencyZoom?: InputMaybe<CreateAgencyZoomIntegrationInput>;
  /** Configuration for the AMS360 integration */
  ams360?: InputMaybe<CreateAms360IntegrationInput>;
  /** Configuration for the Applied Epic integration */
  appliedEpic?: InputMaybe<CreateAppliedEpicIntegrationInput>;
  /** Configuration for the EZLynx integration */
  ezlynx?: InputMaybe<CreateEzLynxIntegrationInput>;
  /** Configuration for the Hawksoft integration */
  hawksoft?: InputMaybe<CreateHawksoftIntegrationInput>;
  /** Configuration for the HubSpot integration */
  hubspot?: InputMaybe<CreateHubSpotIntegrationInput>;
  /** Configuration for the ImageRight integration */
  imageRight?: InputMaybe<CreateImageRightIntegrationInput>;
  /** Configuration for the NowCerts integration */
  nowcerts?: InputMaybe<CreateNowCertsIntegrationInput>;
  /** Type of integration */
  type: IntegrationType;
};

/** Input for creating a new text document in the knowledge base */
export type CreateKnowledgeBaseTextDocumentInput = {
  /** The text of the document */
  content: Scalars['String']['input'];
  /** The cosmetic folder to create the document in. Null means root. */
  folderId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the document */
  title: Scalars['String']['input'];
};

/** Input for creating a URL-sourced document in the knowledge base */
export type CreateKnowledgeBaseUrlDocumentInput = {
  /** The cosmetic folder to create the URL document in. Null means root. */
  folderId?: InputMaybe<Scalars['String']['input']>;
  /** How often to sync the content */
  frequency: UrlMonitorFrequency;
  /** How to fetch the content (download file vs screenshot webpage) */
  sourceType: UrlSourceType;
  /** The title for this document */
  title: Scalars['String']['input'];
  /** The URL to fetch content from */
  url: Scalars['String']['input'];
};

export type CreateMemoryInput = {
  category: MemoryCategory;
  content: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  scope: MemoryScope;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  surface?: InputMaybe<MemorySurface>;
  type: MemoryType;
};

/** CreateNowCertsIntegrationInput contains the input for creating a NowCerts integration */
export type CreateNowCertsIntegrationInput = {
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls: Scalars['Boolean']['input'];
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks: Scalars['Boolean']['input'];
  /** NowCerts password for basic authentication */
  password: Scalars['String']['input'];
  /**
   * The referral source value to set when creating a prospect in NowCerts.
   * If omitted or blank, no referral source will be set.
   */
  prospectReferralSource?: InputMaybe<Scalars['String']['input']>;
  /** NowCerts username for basic authentication */
  username: Scalars['String']['input'];
};

export type CreateOutboundCallInput = {
  callConfig: OutboundCallConfigInput;
  customer: OutboundCallCustomerInput;
  retryPolicy?: InputMaybe<OutboundCallRetryPolicyInput>;
  schedule: OutboundCallScheduleInput;
  /**
   * How this job was created. Defaults to MANUAL when omitted.
   * Copilot draft confirmations should pass COPILOT + workspaceId + draftArtifactId
   * so the draft tool output is updated with the created outboundCallId.
   */
  source?: InputMaybe<OutboundCallSourceInput>;
  /** Visibility is stored but not yet enforced in list queries. */
  visibility?: InputMaybe<VisibilityConfigInput>;
  voiceAgentId: Scalars['String']['input'];
};

/** Input type for creating a new service request */
export type CreateServiceRequestInput = {
  /** The ID of the account to associate this service request with */
  accountId: Scalars['String']['input'];
  /** Details specific to additional insured requests */
  addAdditionalInsured?: InputMaybe<AddAdditionalInsuredRequestInput>;
  /** Details specific to policy cancellation requests */
  cancelPolicy?: InputMaybe<CancelPolicyRequestInput>;
  /** Details specific to Certificate of Insurance requests */
  createCertificate?: InputMaybe<CreateCertificateRequestInput>;
  /** Additional details about the request */
  details: Scalars['String']['input'];
  /** Details specific to document requests */
  documentRequest?: InputMaybe<DocumentRequestInput>;
  /** Details specific to question requests */
  question?: InputMaybe<QuestionRequestInput>;
  /** Type of service request */
  type: ServiceRequestType;
};

export type CreateSmartFillBucketInput = {
  /** A complete entity-tree document. IDs must be omitted; the server mints them. */
  document: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  operationId: Scalars['ID']['input'];
  /** COPY and MANUAL are accepted; WORKSPACE is created by conversion. */
  origin: SmartFillBucketOrigin;
  visibility?: InputMaybe<SmartFillBucketVisibility>;
};

export type CreateVoiceAgentInput = {
  /** Whether this agent receives inbound calls or places outbound calls. Defaults to INBOUND. */
  direction?: InputMaybe<VoiceAgentDirection>;
  /** The name of the voice agent */
  name: Scalars['String']['input'];
  /**
   * Disclosure version the user acknowledged. Required when creating an outbound agent
   * if the agency has not acknowledged the current disclosure version.
   */
  outboundComplianceDisclosureVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new workflow definition */
export type CreateWorkflowDefinitionInput = {
  /** Explains what this workflow does */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The input slots this workflow expects */
  inputs?: InputMaybe<Array<WorkflowDefinitionInputSlotInput>>;
  /** A human-readable name for the workflow */
  label: Scalars['String']['input'];
  /** The tasks and their input bindings */
  nodes: Array<WorkflowDefinitionNodeInput>;
};

/** Input for creating a new workflow execution */
export type CreateWorkflowExecutionInput = {
  /** The ID of the workflow definition to execute */
  definitionId: Scalars['String']['input'];
  /** The version of the workflow definition to execute */
  definitionVersion: Scalars['Int64']['input'];
  /** The inputs to provide to the workflow */
  inputs: Array<CreateWorkflowInputEntry>;
  /** The ID of a parent workflow execution, if this is a chained execution */
  parentWorkflowId?: InputMaybe<Scalars['String']['input']>;
  /** The version of the parent workflow execution */
  parentWorkflowVersion?: InputMaybe<Scalars['Int64']['input']>;
};

/** An individual input entry for creating a workflow execution */
export type CreateWorkflowInputEntry = {
  /** Whether this input represents an enumerable collection */
  enumerable?: Scalars['Boolean']['input'];
  /** File input, required when type is FILE. Accepts uploads, existing file references, or integration file references. */
  file?: InputMaybe<CaraWorkspaceFileInput>;
  /** JSON input, required when type is JSON */
  json?: InputMaybe<Scalars['JSON']['input']>;
  /** A human-readable label for this input */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Text input, required when type is TEXT */
  text?: InputMaybe<Scalars['String']['input']>;
  /** The type of input */
  type: WorkflowInputType;
};

/** A custom fillable PDF form uploaded by an agency user. */
export type CustomForm = {
  __typename?: 'CustomForm';
  /** The agency that owns this custom form. Queryable as a full Agency object. */
  agency: Agency;
  /** The timestamp when this form was archived, or null if it is still active. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The base fill prompt generated by AI during ingestion. Used as the default fill
   * instructions when no custom prompt has been provided by the user.
   */
  basePrompt: Scalars['String']['output'];
  /** The timestamp when this form was first created. */
  createdAt: Scalars['Time']['output'];
  /** The agency user who uploaded this form. */
  createdBy: AgencyUser;
  /** An error message describing why processing failed. Only set when status is FAILED. */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * User-supplied fill-time instructions that supplement the base prompt.
   * Applied every time this form is filled by Cara.
   */
  fillPrompt: Scalars['String']['output'];
  /** The unique identifier for this custom form. */
  id: Scalars['ID']['output'];
  /**
   * Guidance provided at upload time to help Cara interpret ambiguous fields
   * (e.g. checkboxes, limit formats, percentages). Used during ingestion only.
   */
  ingestionGuidance: Scalars['String']['output'];
  /** The extracted field schema for this form. Null until the form has finished processing. */
  schema?: Maybe<CustomFormSchema>;
  /** The current processing status of this form. */
  status: CustomFormStatus;
  /** The original PDF file used as the template for this form. Queryable as a full File object. */
  templateFile: File;
  /** The human-readable name of this form shown in the library. */
  title: Scalars['String']['output'];
  /** The timestamp when this form was last updated. */
  updatedAt: Scalars['Time']['output'];
  /** The current version number of this form, incremented on each update. */
  version: Scalars['Int64']['output'];
  /**
   * The visibility configuration for this custom form (PRIVATE / SHARED / PUBLIC).
   * Lives on the parent row only — visibility is metadata, not part of the
   * versioned content. Defaults to PUBLIC for all rows on migration.
   */
  visibility: VisibilityConfig;
};

/** A single fillable field within a custom PDF form. */
export type CustomFormField = {
  __typename?: 'CustomFormField';
  /**
   * Options applicable to checkbox/button fields (on/off PDF values).
   * Null for non-checkbox fields. Radio and select use choiceOptions.
   */
  buttonOptions?: Maybe<CustomFormFieldButtonOptions>;
  /**
   * Ordered choice metadata for radio and select fields.
   * Each entry has the exact PDF export value and an optional human label.
   * Null for non-choice fields, or when no proven exports were available.
   */
  choiceOptions?: Maybe<Array<CustomFormFieldChoiceOption>>;
  /** The default value to use when source documents don't provide a definitive value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** A description of what value this field expects and how to fill it. */
  description: Scalars['String']['output'];
  /** The reason this field is excluded, if excluded is true. */
  excludeReason?: Maybe<Scalars['String']['output']>;
  /** Whether this field is excluded from filling (e.g. signatures, internal IDs). */
  excluded: Scalars['Boolean']['output'];
  /** The unique key identifying this field within the form schema. */
  key: Scalars['String']['output'];
  /**
   * The exact PDF AcroForm field name used by probes and fillpdf.
   * Not the human-readable label; that lives in description.
   */
  name: Scalars['String']['output'];
  /**
   * Options applicable to text-type fields (e.g. maximum length).
   * Null for non-text fields.
   */
  textOptions?: Maybe<CustomFormFieldTextOptions>;
  /** The type of this field, which determines how it should be filled. */
  type: CustomFormFieldType;
};

/**
 * Options that apply to checkbox/button custom form fields (on/off PDF values).
 * Not used for radio or select fields; those use choiceOptions.
 */
export type CustomFormFieldButtonOptions = {
  __typename?: 'CustomFormFieldButtonOptions';
  /** The PDF value written when the button is in the OFF (unchecked) state. */
  offValue?: Maybe<Scalars['String']['output']>;
  /** The PDF value written when the button is in the ON (checked/selected) state. */
  onValue?: Maybe<Scalars['String']['output']>;
};

/**
 * A single selectable choice for a radio or select custom form field.
 * exportValue is the exact PDF fill value; label is an optional human-readable
 * description of that choice (e.g. from vision or select display text).
 */
export type CustomFormFieldChoiceOption = {
  __typename?: 'CustomFormFieldChoiceOption';
  /** The exact PDF export/fill value for this choice. */
  exportValue: Scalars['String']['output'];
  /** Optional human-readable label for this choice. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Options that apply to text-type custom form fields. */
export type CustomFormFieldTextOptions = {
  __typename?: 'CustomFormFieldTextOptions';
  /** Maximum allowed character length for this field, if constrained. */
  maxLength?: Maybe<Scalars['Int']['output']>;
};

/** The type of a field in a custom form schema. */
export enum CustomFormFieldType {
  /** A boolean button (checkbox) field with distinct on/off values. */
  Button = 'BUTTON',
  /** A date input field. */
  Date = 'DATE',
  /** A numeric input field. */
  Number = 'NUMBER',
  /** A radio button field with mutually exclusive options. */
  Radio = 'RADIO',
  /** A dropdown or list-selection field with a fixed set of options. */
  Select = 'SELECT',
  /** A free-text input field. */
  Text = 'TEXT'
}

/** A summary of a custom form from the library, used in LIST and DESCRIBE operations. */
export type CustomFormListItem = {
  __typename?: 'CustomFormListItem';
  /** A brief description of this custom form's purpose. */
  description: Scalars['String']['output'];
  /** The unique identifier for this custom form. */
  id: Scalars['String']['output'];
  /**
   * The fill instructions for this form generated during ingestion.
   * Only populated for the DESCRIBE operation.
   */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The human-readable name of this custom form. */
  name: Scalars['String']['output'];
  /** The JSON field schema for this form. Only populated for the DESCRIBE operation. */
  schema?: Maybe<Scalars['JSON']['output']>;
};

/** The extracted schema describing all fields in a custom PDF form. */
export type CustomFormSchema = {
  __typename?: 'CustomFormSchema';
  /** The list of fillable fields extracted from the PDF. */
  fields: Array<CustomFormField>;
  /** A brief description of the form's purpose and typical use case. */
  purpose: Scalars['String']['output'];
  /** The human-readable title of the form. */
  title: Scalars['String']['output'];
};

/** The processing status of a custom form. */
export enum CustomFormStatus {
  /** Processing failed. See the error field for details. */
  Failed = 'FAILED',
  /** Ingestion is in progress. */
  Processing = 'PROCESSING',
  /** Ingestion is enqueued but work has not started yet. */
  Queued = 'QUEUED',
  /** The form has been processed and is ready to fill. */
  Ready = 'READY'
}

/** Identifies the artifact produced by a FILL operation on a library custom form. */
export type CustomFormToolArtifact = {
  __typename?: 'CustomFormToolArtifact';
  /** The ID of the created or updated custom form artifact. */
  id: Scalars['String']['output'];
  /** The version number of the artifact. */
  version: Scalars['Int']['output'];
};

/** Describes the type of update that occurred to a custom form */
export enum CustomFormUpdateType {
  /** The custom form was archived */
  ArchiveCustomForm = 'ARCHIVE_CUSTOM_FORM',
  /** The custom form was created */
  CreateCustomForm = 'CREATE_CUSTOM_FORM',
  /** The custom form was updated */
  UpdateCustomForm = 'UPDATE_CUSTOM_FORM'
}

/** Describes a particular version of a custom form (internal use for DB versioning) */
export type CustomFormVersion = {
  __typename?: 'CustomFormVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The full custom form object for this version */
  customForm: CustomForm;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is private */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<Scalars['String']['output']>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<CustomFormUpdateType>;
  /** The version number of this custom form version */
  version: Scalars['Int64']['output'];
};

/**
 * Filter for the customForms list query. Wraps visibility filters today; future
 * filter dimensions (search, archived inclusion, etc.) can be added here without
 * breaking the query signature.
 */
export type CustomFormsFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/** A custom preset for Cara to execute tasks and produce artifacts */
export type CustomPreset = {
  __typename?: 'CustomPreset';
  /**
   * The agencies this preset has been shared with. Owner-agency only: the
   * directive binds the scope check to the preset's owning agency, so
   * cross-agency grantees are denied (they use myAccess instead).
   */
  accessList: Array<CustomPresetAccess>;
  /** The agency this custom preset is associated with */
  agency: Agency;
  /** Whether the custom preset allows file uploads */
  allowFileUpload: Scalars['Boolean']['output'];
  /** The timestamp when this custom preset was archived (soft deleted) */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The base prompt for the custom preset */
  basePrompt: Scalars['String']['output'];
  /** The timestamp when this custom preset was created */
  createdAt: Scalars['Time']['output'];
  /**
   * The user that created this custom preset. Null for a cross-agency grantee viewing a
   * shared preset: attribution is agency-level only (see the agency field), so the author
   * is not exposed cross-agency.
   */
  createdBy?: Maybe<AgencyUser>;
  /**
   * Custom forms offered as generation-time defaults in workspaces created from
   * this preset. See wordDocumentTemplates for semantics.
   */
  customForms: Array<CustomForm>;
  /** The description of the custom preset */
  description: Scalars['String']['output'];
  /** The files that are used as context for the custom preset */
  files: Array<File>;
  /**
   * Progress and outcome of the AI run that produced this preset. Null on a preset
   * created by hand. Poll it while state is GENERATING.
   */
  generation?: Maybe<PresetGeneration>;
  /**
   * HTML document templates offered as generation-time defaults in workspaces
   * created from this preset. See wordDocumentTemplates for semantics.
   */
  htmlDocumentTemplates: Array<HtmlDocumentTemplate>;
  /** The ID of the custom preset */
  id: Scalars['ID']['output'];
  /** The preset that this custom preset inherits from, if any */
  inheritFromPreset?: Maybe<CaraWorkspacePreset>;
  /**
   * Whether the calling agency owns this preset. False when the preset is shared
   * with the agency (and always false for admins, who do not own presets).
   */
  isOwner: Scalars['Boolean']['output'];
  /**
   * The calling agency's access grant for this preset when it is shared with them.
   * Null if the calling agency owns the preset (use isOwner instead) or has no grant.
   */
  myAccess?: Maybe<CustomPresetAccess>;
  /**
   * Whether this preset is finished and usable. Only READY presets can be run,
   * shared, or offered as a choice; GENERATING and FAILED presets appear in the
   * preset list so the user can watch progress, retry, or delete them.
   *
   * Stored in the version document like the rest of the preset. Generation writes
   * its steps with updatePrivate set, so a run does not fill the preset's history
   * with versions a user did not make.
   */
  state: CustomPresetState;
  /** The title of the custom preset */
  title: Scalars['String']['output'];
  /** The timestamp when this custom preset was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this custom preset */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this custom preset. The first version in this list will be this version
   * (i.e. identical to the current custom preset), followed by the version before that, and so-forth.
   * Owner-agency only (history can contain pre-share snapshots): the directive binds the scope
   * check to the preset's owning agency, so cross-agency grantees are denied.
   */
  versionHistory?: Maybe<Array<CustomPresetVersion>>;
  /**
   * The visibility configuration for this custom preset (PRIVATE / SHARED / PUBLIC).
   * Lives on the parent row only — visibility is metadata, not part of the
   * versioned content, so changing it does not create a new version.
   * Defaults to PUBLIC for all rows on migration.
   */
  visibility: VisibilityConfig;
  /**
   * Output templates (structure Cara fills in) offered as defaults at generation
   * time in workspaces created from this preset — the same behavior as
   * pre-selecting them on a message. They are not attached to the workspace at
   * creation, and are distinct from files (context Cara reads).
   */
  wordDocumentTemplates: Array<WordDocumentTemplate>;
};

/**
 * Access control granting an agency access to a custom preset shared with it by
 * another (parent) agency. Only shared grants are stored here; ownership is
 * determined by agency_custom_preset.agency_id, not entries in this table.
 */
export type CustomPresetAccess = {
  __typename?: 'CustomPresetAccess';
  /** The agency this access grant is for (the child agency the preset is shared with). */
  agency: Agency;
  /** The timestamp when this access was granted */
  createdAt: Scalars['Time']['output'];
  /** The role this agency has for the custom preset */
  role: CustomPresetAccessRole;
  /** The timestamp when this access was last updated */
  updatedAt: Scalars['Time']['output'];
};

/**
 * The role an agency has for accessing a shared custom preset.
 * Note: Ownership is determined by agency_custom_preset.agency_id, not this table.
 */
export enum CustomPresetAccessRole {
  /** The agency can read and run this shared custom preset (read-only). */
  Viewer = 'VIEWER'
}

export type CustomPresetInput = {
  /** Whether the custom preset allows file uploads */
  allowFileUpload: Scalars['Boolean']['input'];
  /** The base prompt for the custom preset */
  basePrompt: Scalars['String']['input'];
  /**
   * The IDs of the custom forms to offer as generation-time defaults in
   * workspaces created from this preset. Replaces the existing list.
   */
  customFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The description of the custom preset */
  description: Scalars['String']['input'];
  /** The IDs of the existing files that should be kept as context for the custom preset */
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The IDs of the HTML document templates to offer as generation-time defaults
   * in workspaces created from this preset. Replaces the existing list.
   */
  htmlDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The preset that this custom preset inherits from, if any */
  inheritFromPreset?: InputMaybe<CaraWorkspacePreset>;
  /** The title of the custom preset */
  title: Scalars['String']['input'];
  /** The files to upload if an existing file is not provided */
  uploadFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /**
   * Optional visibility configuration. When omitted on create, defaults to
   * PUBLIC. When omitted on update, the existing visibility is preserved.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
  /**
   * The IDs of the Word document templates to offer as generation-time defaults
   * in workspaces created from this preset. Replaces the existing list.
   */
  wordDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Whether a custom preset is finished and usable. */
export enum CustomPresetState {
  /**
   * Generation failed. The preset stays in the list carrying generation.error so
   * the user can retry or delete it, but it cannot be run or shared.
   */
  Failed = 'FAILED',
  /**
   * GeneratePresetWorkflow is still building this preset. Its base prompt is not
   * written yet, so it cannot be run or shared.
   */
  Generating = 'GENERATING',
  /**
   * GeneratePresetWorkflow finished and wrote the whole document, but the author
   * has not looked it over yet. Usable exactly as READY is — run, edit, share —
   * and the first manual save promotes it to READY.
   */
  NeedsReview = 'NEEDS_REVIEW',
  /** Usable. Every preset created by hand is READY from the moment it exists. */
  Ready = 'READY'
}

/** Describes the reason why a custom preset was updated */
export enum CustomPresetUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a custom preset */
export enum CustomPresetUpdateType {
  /** The custom preset was archived */
  ArchiveCustomPreset = 'ARCHIVE_CUSTOM_PRESET',
  /** The custom preset was created */
  CreateCustomPreset = 'CREATE_CUSTOM_PRESET',
  /** An AI generation run wrote to the custom preset */
  GenerateCustomPreset = 'GENERATE_CUSTOM_PRESET',
  /** The custom preset was unarchived */
  UnarchiveCustomPreset = 'UNARCHIVE_CUSTOM_PRESET',
  /** The custom preset was updated */
  UpdateCustomPreset = 'UPDATE_CUSTOM_PRESET'
}

/** Describes a particular version of a custom preset */
export type CustomPresetVersion = {
  __typename?: 'CustomPresetVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The full custom preset object that includes all of the updates made in this version and all previous versions */
  customPreset: CustomPreset;
  /** Produces a human-readable string that can be used to diff against another custom preset version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous custom preset version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<CustomPresetVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<CustomPresetUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<CustomPresetUpdateType>;
  /** The version number of this custom preset version */
  version: Scalars['Int64']['output'];
};

/**
 * Filter for the customPresets list query. Wraps visibility filters today; future
 * filter dimensions (search, archived inclusion, etc.) can be added here without
 * breaking the query signature.
 */
export type CustomPresetsFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/** Custom CSS property that doesn't fit into the structured schema */
export type CustomStyle = {
  __typename?: 'CustomStyle';
  /** CSS properties to apply to the selector */
  properties: Array<CustomStyleProperty>;
  /** CSS selector (e.g. '.header', '#footer') */
  selector: Scalars['String']['output'];
};

/** Input for custom CSS block */
export type CustomStyleInput = {
  /** List of CSS properties to apply to the selector */
  properties: Array<CustomStylePropertyInput>;
  /** CSS selector string (e.g. '.my-class', 'h2.special') */
  selector: Scalars['String']['input'];
};

/** Custom CSS property */
export type CustomStyleProperty = {
  __typename?: 'CustomStyleProperty';
  /** CSS property name (e.g. 'margin', 'padding', 'border') */
  name: Scalars['String']['output'];
  /** CSS property value (e.g. '2em 0', '1px solid #cbd5e1') */
  value: Scalars['String']['output'];
};

/** Input for custom CSS property */
export type CustomStylePropertyInput = {
  /** CSS property name (e.g. 'border', 'background-color') */
  name: Scalars['String']['input'];
  /** CSS property value (e.g. '1px solid #000', '#fafafa') */
  value: Scalars['String']['input'];
};

/**
 * Database-specific details attached to a DATABASE span. Rich by design so the
 * viewer can show what ran, against what, and how it resolved.
 */
export type DbQuery = {
  __typename?: 'DBQuery';
  /**
   * Bound query arguments, sanitized for storage: truncated and with byte payloads
   * elided. Stored as text so the viewer can render them without column types.
   */
  args: Array<Scalars['String']['output']>;
  /**
   * High-level calling function (e.g. GetTraceByID), for grouping in the viewer.
   * Empty when the query was instrumented without a named caller.
   */
  function: Scalars['String']['output'];
  /** db.operation.name (SELECT, INSERT, UPDATE, ...). */
  operation: Scalars['String']['output'];
  /** Rows affected (writes) or returned (reads), when known. */
  rowsAffected?: Maybe<Scalars['Int']['output']>;
  /** The SQL statement (db.query.text). */
  statement: Scalars['String']['output'];
  /** db.system.name (e.g. postgresql). */
  system: Scalars['String']['output'];
  /** db.collection.name (the primary relation the statement targets). */
  table: Scalars['String']['output'];
};

/** Filter for date ranges */
export type DateFilter = {
  /** Filter for dates after this timestamp (inclusive) */
  after?: InputMaybe<Scalars['Time']['input']>;
  /** Filter for dates before this timestamp (exclusive) */
  before?: InputMaybe<Scalars['Time']['input']>;
};

/** Day of the week enum */
export enum DayOfWeek {
  /** Friday */
  Friday = 'FRIDAY',
  /** Monday */
  Monday = 'MONDAY',
  /** Saturday */
  Saturday = 'SATURDAY',
  /** Sunday */
  Sunday = 'SUNDAY',
  /** Thursday */
  Thursday = 'THURSDAY',
  /** Tuesday */
  Tuesday = 'TUESDAY',
  /** Wednesday */
  Wednesday = 'WEDNESDAY'
}

/**
 * How the Description of Operations (DOO) box on ACORD 25 and ACORD 30 should be
 * populated. Both carry the same box, so one mode governs both.
 */
export enum DescriptionOfOperationsMode {
  /** Strict ACORD FIG standard: locations, operations, and vehicles only. */
  AcordFigStrict = 'ACORD_FIG_STRICT',
  /** Current Cara default behavior. */
  CaraDefault = 'CARA_DEFAULT',
  /** Leave the Description of Operations blank. */
  Empty = 'EMPTY'
}

/**
 * Data used to generated the document. The fields in here must map to the fields
 * required by the document type.
 */
export type DocumentData = {
  __typename?: 'DocumentData';
  /** Placeholder required by GraphQL schema validation. ACORD form data is stored in Go-only fields above. */
  schemaPlaceholder?: Maybe<Scalars['Boolean']['output']>;
};

/** Details for a request for policy-related documents */
export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  /** Type of document being requested */
  type: DocumentRequestType;
};

/** Input type for requesting policy-related documents */
export type DocumentRequestInput = {
  /** Type of document being requested */
  type?: InputMaybe<DocumentRequestType>;
};

/** Types of documents that can be requested */
export enum DocumentRequestType {
  /** Insurance binder document */
  Binder = 'BINDER',
  /** Certificate of Insurance */
  Certificate = 'CERTIFICATE',
  /** Policy endorsement document */
  Endorsement = 'ENDORSEMENT',
  /** Other document types */
  Other = 'OTHER',
  /** Full policy documentation */
  PolicyDocument = 'POLICY_DOCUMENT'
}

/** The type of document depending on which different fields in `Document` are populated */
export enum DocumentType {
  Acord_1 = 'ACORD_1',
  Acord_2 = 'ACORD_2',
  Acord_3 = 'ACORD_3',
  Acord_4 = 'ACORD_4',
  Acord_24 = 'ACORD_24',
  Acord_25 = 'ACORD_25',
  Acord_27 = 'ACORD_27',
  Acord_28 = 'ACORD_28',
  Acord_30 = 'ACORD_30',
  Acord_35 = 'ACORD_35',
  Acord_36 = 'ACORD_36',
  Acord_37 = 'ACORD_37',
  Acord_50 = 'ACORD_50',
  Acord_50Al = 'ACORD_50_AL',
  Acord_50AnyState = 'ACORD_50_ANY_STATE',
  Acord_50Ar = 'ACORD_50_AR',
  Acord_50Az = 'ACORD_50_AZ',
  Acord_50Ca = 'ACORD_50_CA',
  Acord_50Co = 'ACORD_50_CO',
  Acord_50Ct = 'ACORD_50_CT',
  Acord_50Fl = 'ACORD_50_FL',
  Acord_50Ga = 'ACORD_50_GA',
  Acord_50Hi = 'ACORD_50_HI',
  Acord_50Ia = 'ACORD_50_IA',
  Acord_50Id = 'ACORD_50_ID',
  Acord_50Il = 'ACORD_50_IL',
  Acord_50In = 'ACORD_50_IN',
  Acord_50Ky = 'ACORD_50_KY',
  Acord_50La = 'ACORD_50_LA',
  Acord_50Md = 'ACORD_50_MD',
  Acord_50Me = 'ACORD_50_ME',
  Acord_50Mi = 'ACORD_50_MI',
  Acord_50Mo = 'ACORD_50_MO',
  Acord_50Ms = 'ACORD_50_MS',
  Acord_50Nd = 'ACORD_50_ND',
  Acord_50Ne = 'ACORD_50_NE',
  Acord_50Nj = 'ACORD_50_NJ',
  Acord_50NjSet = 'ACORD_50_NJ_SET',
  Acord_50Ok = 'ACORD_50_OK',
  Acord_50Pa = 'ACORD_50_PA',
  Acord_50PaSet = 'ACORD_50_PA_SET',
  Acord_50Ri = 'ACORD_50_RI',
  Acord_50Sc = 'ACORD_50_SC',
  Acord_50Sd = 'ACORD_50_SD',
  Acord_50Tn = 'ACORD_50_TN',
  Acord_50Tx = 'ACORD_50_TX',
  Acord_50Vt = 'ACORD_50_VT',
  Acord_50Wv = 'ACORD_50_WV',
  Acord_70 = 'ACORD_70',
  Acord_71 = 'ACORD_71',
  Acord_75 = 'ACORD_75',
  Acord_80 = 'ACORD_80',
  Acord_81 = 'ACORD_81',
  Acord_82 = 'ACORD_82',
  Acord_83 = 'ACORD_83',
  Acord_84 = 'ACORD_84',
  Acord_88 = 'ACORD_88',
  Acord_89 = 'ACORD_89',
  Acord_89AnyState = 'ACORD_89_ANY_STATE',
  Acord_89Ca = 'ACORD_89_CA',
  Acord_89Nv = 'ACORD_89_NV',
  Acord_89Ny = 'ACORD_89_NY',
  Acord_90Ak = 'ACORD_90_AK',
  Acord_90Al = 'ACORD_90_AL',
  Acord_90AnyState = 'ACORD_90_ANY_STATE',
  Acord_90Ar = 'ACORD_90_AR',
  Acord_90Az = 'ACORD_90_AZ',
  Acord_90Ca = 'ACORD_90_CA',
  Acord_90Co = 'ACORD_90_CO',
  Acord_90Ct = 'ACORD_90_CT',
  Acord_90Dc = 'ACORD_90_DC',
  Acord_90De = 'ACORD_90_DE',
  Acord_90Fl = 'ACORD_90_FL',
  Acord_90Ga = 'ACORD_90_GA',
  Acord_90Hi = 'ACORD_90_HI',
  Acord_90Ia = 'ACORD_90_IA',
  Acord_90Id = 'ACORD_90_ID',
  Acord_90Il = 'ACORD_90_IL',
  Acord_90In = 'ACORD_90_IN',
  Acord_90Ks = 'ACORD_90_KS',
  Acord_90Ky = 'ACORD_90_KY',
  Acord_90La = 'ACORD_90_LA',
  Acord_90Ma = 'ACORD_90_MA',
  Acord_90Md = 'ACORD_90_MD',
  Acord_90Me = 'ACORD_90_ME',
  Acord_90Mi = 'ACORD_90_MI',
  Acord_90Mn = 'ACORD_90_MN',
  Acord_90Mo = 'ACORD_90_MO',
  Acord_90Ms = 'ACORD_90_MS',
  Acord_90Mt = 'ACORD_90_MT',
  Acord_90Nc = 'ACORD_90_NC',
  Acord_90Nd = 'ACORD_90_ND',
  Acord_90Ne = 'ACORD_90_NE',
  Acord_90Nh = 'ACORD_90_NH',
  Acord_90Nj = 'ACORD_90_NJ',
  Acord_90Nm = 'ACORD_90_NM',
  Acord_90Nv = 'ACORD_90_NV',
  Acord_90Ny = 'ACORD_90_NY',
  Acord_90Oh = 'ACORD_90_OH',
  Acord_90Ok = 'ACORD_90_OK',
  Acord_90Or = 'ACORD_90_OR',
  Acord_90Pa = 'ACORD_90_PA',
  Acord_90Ri = 'ACORD_90_RI',
  Acord_90Sc = 'ACORD_90_SC',
  Acord_90Sd = 'ACORD_90_SD',
  Acord_90Tn = 'ACORD_90_TN',
  Acord_90Tx = 'ACORD_90_TX',
  Acord_90Ut = 'ACORD_90_UT',
  Acord_90Va = 'ACORD_90_VA',
  Acord_90Vt = 'ACORD_90_VT',
  Acord_90Wa = 'ACORD_90_WA',
  Acord_90Wi = 'ACORD_90_WI',
  Acord_90Wv = 'ACORD_90_WV',
  Acord_90Wy = 'ACORD_90_WY',
  Acord_101 = 'ACORD_101',
  Acord_125 = 'ACORD_125',
  Acord_126 = 'ACORD_126',
  Acord_127 = 'ACORD_127',
  Acord_128 = 'ACORD_128',
  Acord_129 = 'ACORD_129',
  Acord_130 = 'ACORD_130',
  Acord_131 = 'ACORD_131',
  Acord_132 = 'ACORD_132',
  Acord_133 = 'ACORD_133',
  Acord_137Al = 'ACORD_137_AL',
  Acord_137AnyState = 'ACORD_137_ANY_STATE',
  Acord_137Ar = 'ACORD_137_AR',
  Acord_137Az = 'ACORD_137_AZ',
  Acord_137Ca = 'ACORD_137_CA',
  Acord_137Co = 'ACORD_137_CO',
  Acord_137Ct = 'ACORD_137_CT',
  Acord_137De = 'ACORD_137_DE',
  Acord_137Fl = 'ACORD_137_FL',
  Acord_137Ga = 'ACORD_137_GA',
  Acord_137Ia = 'ACORD_137_IA',
  Acord_137Id = 'ACORD_137_ID',
  Acord_137Il = 'ACORD_137_IL',
  Acord_137In = 'ACORD_137_IN',
  Acord_137Ks = 'ACORD_137_KS',
  Acord_137Ky = 'ACORD_137_KY',
  Acord_137La = 'ACORD_137_LA',
  Acord_137Ma = 'ACORD_137_MA',
  Acord_137Md = 'ACORD_137_MD',
  Acord_137Me = 'ACORD_137_ME',
  Acord_137Mi = 'ACORD_137_MI',
  Acord_137Mn = 'ACORD_137_MN',
  Acord_137Mo = 'ACORD_137_MO',
  Acord_137Ms = 'ACORD_137_MS',
  Acord_137Mt = 'ACORD_137_MT',
  Acord_137Nc = 'ACORD_137_NC',
  Acord_137Nd = 'ACORD_137_ND',
  Acord_137Ne = 'ACORD_137_NE',
  Acord_137Nh = 'ACORD_137_NH',
  Acord_137Nj = 'ACORD_137_NJ',
  Acord_137Nm = 'ACORD_137_NM',
  Acord_137Nv = 'ACORD_137_NV',
  Acord_137Ny = 'ACORD_137_NY',
  Acord_137Oh = 'ACORD_137_OH',
  Acord_137Ok = 'ACORD_137_OK',
  Acord_137Or = 'ACORD_137_OR',
  Acord_137Pa = 'ACORD_137_PA',
  Acord_137Ri = 'ACORD_137_RI',
  Acord_137Sc = 'ACORD_137_SC',
  Acord_137Sd = 'ACORD_137_SD',
  Acord_137Tn = 'ACORD_137_TN',
  Acord_137Tx = 'ACORD_137_TX',
  Acord_137Ut = 'ACORD_137_UT',
  Acord_137Va = 'ACORD_137_VA',
  Acord_137Vt = 'ACORD_137_VT',
  Acord_137Wa = 'ACORD_137_WA',
  Acord_137Wi = 'ACORD_137_WI',
  Acord_137Wv = 'ACORD_137_WV',
  Acord_137Wy = 'ACORD_137_WY',
  Acord_140 = 'ACORD_140',
  Acord_141 = 'ACORD_141',
  Acord_143 = 'ACORD_143',
  Acord_144 = 'ACORD_144',
  Acord_145 = 'ACORD_145',
  Acord_146 = 'ACORD_146',
  Acord_147 = 'ACORD_147',
  Acord_148 = 'ACORD_148',
  Acord_149 = 'ACORD_149',
  Acord_152 = 'ACORD_152',
  Acord_155 = 'ACORD_155',
  Acord_160 = 'ACORD_160',
  Acord_163 = 'ACORD_163',
  Acord_175 = 'ACORD_175',
  Acord_180 = 'ACORD_180',
  Acord_185 = 'ACORD_185',
  Acord_186 = 'ACORD_186',
  Acord_187 = 'ACORD_187',
  Acord_193 = 'ACORD_193',
  Acord_195 = 'ACORD_195',
  Acord_196 = 'ACORD_196',
  Acord_210 = 'ACORD_210',
  Acord_281 = 'ACORD_281',
  Acord_282 = 'ACORD_282',
  Acord_283 = 'ACORD_283',
  Acord_285 = 'ACORD_285',
  Acord_301 = 'ACORD_301',
  Acord_302 = 'ACORD_302',
  Acord_303 = 'ACORD_303',
  Acord_304 = 'ACORD_304',
  Acord_305 = 'ACORD_305',
  Acord_306 = 'ACORD_306',
  Acord_307 = 'ACORD_307',
  Acord_308 = 'ACORD_308',
  Acord_401 = 'ACORD_401',
  Acord_402 = 'ACORD_402',
  Acord_403 = 'ACORD_403',
  Acord_404 = 'ACORD_404',
  Acord_410 = 'ACORD_410',
  Acord_501 = 'ACORD_501',
  Acord_502 = 'ACORD_502',
  Acord_503 = 'ACORD_503',
  Acord_611 = 'ACORD_611',
  Acord_801 = 'ACORD_801',
  Acord_802 = 'ACORD_802',
  Acord_803 = 'ACORD_803',
  Acord_807 = 'ACORD_807',
  Acord_825 = 'ACORD_825',
  Acord_827 = 'ACORD_827',
  Acord_828 = 'ACORD_828',
  Acord_830 = 'ACORD_830',
  Acord_832 = 'ACORD_832',
  Acord_833 = 'ACORD_833',
  Acord_834 = 'ACORD_834',
  Acord_838 = 'ACORD_838'
}

/** Represents a single documentation result. */
export type DocumentationResult = {
  __typename?: 'DocumentationResult';
  /** Snippet or content excerpt from the documentation */
  content: Scalars['String']['output'];
  /** Path or URL to the documentation */
  path: Scalars['String']['output'];
  /** Title of the documentation result */
  title: Scalars['String']['output'];
};

/**
 * Represents a tool for creating or editing Word (.docx) documents.
 * Used when the LLM needs to create or edit a Word document.
 */
export type DocxEditorTool = {
  __typename?: 'DocxEditorTool';
  /** The input arguments for the Word document creation or editing */
  input: DocxEditorToolInput;
  /** The result of the Word document creation or editing operation */
  output: DocxEditorToolOutput;
};

/**
 * Input arguments for the DocxEditorToolAddSectionInput.
 * Contains all necessary information to add a section to a Word document.
 */
export type DocxEditorToolAddSectionInput = {
  __typename?: 'DocxEditorToolAddSectionInput';
  /** The section ID to add this section after, blank if inserting at the start */
  afterSectionId?: Maybe<Scalars['String']['output']>;
  /** The requirements for the section */
  requirements: Scalars['String']['output'];
  /** The section ID */
  sectionId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolCreateFromTemplateInput.
 * Contains all necessary information to create a Word document from a template.
 */
export type DocxEditorToolCreateFromTemplateInput = {
  __typename?: 'DocxEditorToolCreateFromTemplateInput';
  /** The requirements for each section to create */
  sections: Array<DocxEditorToolCreateFromTemplateSectionInput>;
  /** The template ID */
  templateId: Scalars['String']['output'];
};

export type DocxEditorToolCreateFromTemplateSectionInput = {
  __typename?: 'DocxEditorToolCreateFromTemplateSectionInput';
  /** The requirements for the section */
  requirements: Scalars['String']['output'];
  /** The section ID */
  sectionId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolCreateInput.
 * Contains all necessary information to create a Word document.
 */
export type DocxEditorToolCreateInput = {
  __typename?: 'DocxEditorToolCreateInput';
  /** The requirements for the document */
  requirements: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolDeleteSectionInput.
 * Contains all necessary information to delete a section of a Word document.
 */
export type DocxEditorToolDeleteSectionInput = {
  __typename?: 'DocxEditorToolDeleteSectionInput';
  /** The section ID */
  sectionId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolEditInput.
 * Contains all necessary information to edit a Word document.
 */
export type DocxEditorToolEditInput = {
  __typename?: 'DocxEditorToolEditInput';
  /** The ID of the document to edit */
  artifactId: Scalars['String']['output'];
  requirements: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolEditSectionInput.
 * Contains all necessary information to edit one or more sections of a Word document in a
 * single call. Every edited section must belong to the same template-based document.
 */
export type DocxEditorToolEditSectionInput = {
  __typename?: 'DocxEditorToolEditSectionInput';
  /** The sections to edit */
  sections: Array<DocxEditorToolEditSectionItemInput>;
};

/** A single section edit within a DocxEditorToolEditSectionInput. */
export type DocxEditorToolEditSectionItemInput = {
  __typename?: 'DocxEditorToolEditSectionItemInput';
  /** The requirements for the section */
  requirements: Scalars['String']['output'];
  /** The section ID */
  sectionId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolEditUploadedInput.
 * Contains all necessary information to edit a Word document.
 */
export type DocxEditorToolEditUploadedInput = {
  __typename?: 'DocxEditorToolEditUploadedInput';
  /** The requirements for the document */
  requirements: Scalars['String']['output'];
  /** The content of the document */
  sourceFileId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorTool.
 * Contains all necessary information to create or edit a Word document.
 */
export type DocxEditorToolInput = {
  __typename?: 'DocxEditorToolInput';
  /** The input for the ADD_SECTION operation */
  addSection?: Maybe<DocxEditorToolAddSectionInput>;
  /** The input for the CREATE operation */
  create?: Maybe<DocxEditorToolCreateInput>;
  /** The input for the CREATE_FROM_TEMPLATE operation */
  createFromTemplate?: Maybe<DocxEditorToolCreateFromTemplateInput>;
  /** The input for the DELETE_SECTION operation */
  deleteSection?: Maybe<DocxEditorToolDeleteSectionInput>;
  /** The input for the EDIT_CREATED operation */
  edit?: Maybe<DocxEditorToolEditInput>;
  /** The input for the EDIT_SECTION operation */
  editSection?: Maybe<DocxEditorToolEditSectionInput>;
  /** The input for the EDIT_UPLOADED operation */
  editUploaded?: Maybe<DocxEditorToolEditUploadedInput>;
  /** The input for the INSPECT_ARTIFACT operation */
  inspectArtifact?: Maybe<DocxEditorToolInspectArtifactInput>;
  /** The input for the INSPECT_UPLOADED operation */
  inspectUploaded?: Maybe<DocxEditorToolInspectUploadedInput>;
  /** The operation to perform */
  operation: Scalars['String']['output'];
  /** Short human-readable label for this operation shown in the workspace timeline and artifact cards. */
  title: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolInspectArtifactInput.
 * Contains all necessary information to inspect a Word document.
 */
export type DocxEditorToolInspectArtifactInput = {
  __typename?: 'DocxEditorToolInspectArtifactInput';
  /** The ID of the artifact to inspect */
  artifactId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolInspectUploadedInput.
 * Contains all necessary information to inspect a Word document.
 */
export type DocxEditorToolInspectUploadedInput = {
  __typename?: 'DocxEditorToolInspectUploadedInput';
  /** The ID of the file to inspect */
  fileId: Scalars['String']['output'];
};

/**
 * Output of the DocxEditorTool.
 * Contains information about the created or edited Word document.
 */
export type DocxEditorToolOutput = {
  __typename?: 'DocxEditorToolOutput';
  /** The ID of the Word document */
  artifactId?: Maybe<Scalars['String']['output']>;
  /**
   * The DOCX inspection of the Word document if requested by the tool, and if either
   * an ad-hoc document created in the workspace or one that was created by editing
   * a user-uploaded file. Omitted if created from a template.
   */
  docxInspection?: Maybe<Scalars['String']['output']>;
  /**
   * A description of the sections created or edited. Omitted if not a sectioned document,
   * such as an ad-hoc document created in the workspace or one that was created by editing
   * a user-uploaded file.
   */
  sections?: Maybe<Array<DocxEditorToolSectionOutput>>;
  /** The version of the artifact */
  version?: Maybe<Scalars['Int']['output']>;
};

/**
 * Output of a field of a section of a Word document.
 * Contains information about the field.
 */
export type DocxEditorToolSectionFieldOutput = {
  __typename?: 'DocxEditorToolSectionFieldOutput';
  /** The ID of the field */
  id: Scalars['String']['output'];
  /** The placeholder text for the field */
  placeholder: Scalars['String']['output'];
  /** The value of the field */
  value: Scalars['String']['output'];
};

/**
 * Output of a section of a Word document.
 * Contains information about the section.
 */
export type DocxEditorToolSectionOutput = {
  __typename?: 'DocxEditorToolSectionOutput';
  /** The description of the section that was generated by the LLM */
  description?: Maybe<Scalars['String']['output']>;
  /** The fields of the section */
  fieldValues?: Maybe<Array<DocxEditorToolSectionFieldOutput>>;
  /** The ID of the section */
  id: Scalars['String']['output'];
  /** The ID of the original template section this section was generated from */
  templateSectionId: Scalars['String']['output'];
};

/**
 * Represents a tool for drafting documents.
 * Used when the LLM needs to create or modify documents.
 */
export type DraftDocumentTool = {
  __typename?: 'DraftDocumentTool';
  /** The input arguments for document drafting */
  input: DraftDocumentToolInput;
  /** The result of the document drafting operation */
  output: DraftDocumentToolOutput;
};

/**
 * Input arguments for the DraftDocumentTool.
 * Contains all necessary information to draft a document.
 */
export type DraftDocumentToolInput = {
  __typename?: 'DraftDocumentToolInput';
  /** The ID of the document artifact being created */
  artifactId: Scalars['String']['output'];
  /** The HTML content of the document */
  htmlContent: Scalars['String']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/**
 * Result of a DraftDocumentTool operation.
 * Contains information about the created document artifact.
 */
export type DraftDocumentToolOutput = {
  __typename?: 'DraftDocumentToolOutput';
  /** The ID of the created document artifact */
  artifactId: Scalars['String']['output'];
};

/**
 * Represents a tool for composing an email and saving it as a workspace draft.
 * Nothing in this tool sends it.
 */
export type DraftEmailTool = {
  __typename?: 'DraftEmailTool';
  /** The input arguments for email drafting */
  input: DraftEmailToolInput;
  /** The result of the email drafting operation */
  output: DraftEmailToolOutput;
};

/**
 * Input for the CREATE_DRAFT operation, which composes an email and saves it as a
 * workspace draft.
 */
export type DraftEmailToolCreateDraftInput = {
  __typename?: 'DraftEmailToolCreateDraftInput';
  attachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  bcc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  bodyHtml: Scalars['String']['output'];
  cc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  to: Array<DraftEmailToolRecipientInput>;
};

/**
 * Input arguments for the DraftEmailTool.
 *
 * Two shapes meet here. `operation` and the sub-object it names are what the model
 * sends and what a call is recorded as. Beneath them are the shapes DRAFT_EMAIL
 * recorded when it was three tools and one email per call: `subject`, `bodyHtml`,
 * `to`, `cc`, `bcc` and `attachmentArtifactIds`, and, older still, `artifactId`,
 * `toEmail`, `toName` and `body`. Events written then are still read back through
 * this type, so the composer card reads whichever shape is populated.
 *
 * Only the operation fields carry tool descriptions, so those four are the whole of
 * the schema the model is given.
 */
export type DraftEmailToolInput = {
  __typename?: 'DraftEmailToolInput';
  /** The ID the calling model chose for the email artifact */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** Workspace artifact IDs attached to the email */
  attachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The BCC recipients */
  bcc?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  /** The body content of the email, as plain text */
  body?: Maybe<Scalars['String']['output']>;
  /** The body as HTML */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** The CC recipients */
  cc?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  createDraft?: Maybe<DraftEmailToolCreateDraftInput>;
  operation: Scalars['String']['output'];
  placeDraftInMailbox?: Maybe<DraftEmailToolPlaceDraftInMailboxInput>;
  /** The subject line of the email */
  subject: Scalars['String']['output'];
  /** The primary recipients */
  to?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  /** The single recipient's email address */
  toEmail?: Maybe<Scalars['String']['output']>;
  /** The single recipient's name */
  toName?: Maybe<Scalars['String']['output']>;
  updateDraft?: Maybe<DraftEmailToolUpdateDraftInput>;
};

/**
 * Result of a DraftEmailTool operation, shared with UpdateEmailDraftTool because
 * both answer with the same artifact at its new version.
 *
 * `version` and `subject` are absent on events recorded before the output carried
 * them, which is why neither is required.
 */
export type DraftEmailToolOutput = {
  __typename?: 'DraftEmailToolOutput';
  /** The ID of the created email artifact */
  artifactId: Scalars['String']['output'];
  /** The mailbox PLACE_DRAFT_IN_MAILBOX wrote the draft into */
  mailboxEmail?: Maybe<Scalars['String']['output']>;
  /** The subject the draft was saved with, after trimming */
  subject?: Maybe<Scalars['String']['output']>;
  /** The version the draft was written as */
  version?: Maybe<Scalars['Int']['output']>;
  /** The provider's link to the mailbox draft, when it hands one back */
  webLink?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for the PLACE_DRAFT_IN_MAILBOX operation, which copies a draft into the
 * agent's connected mailbox as a native draft.
 */
export type DraftEmailToolPlaceDraftInMailboxInput = {
  __typename?: 'DraftEmailToolPlaceDraftInMailboxInput';
  artifactId: Scalars['String']['output'];
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
};

/** A recipient the model addresses an email to. */
export type DraftEmailToolRecipientInput = {
  __typename?: 'DraftEmailToolRecipientInput';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * Input for the UPDATE_DRAFT operation, which writes a revision of a draft as a new
 * version of the same artifact. Every editable field is optional because the call is
 * a patch: an absent field keeps its current value and an empty list clears one.
 */
export type DraftEmailToolUpdateDraftInput = {
  __typename?: 'DraftEmailToolUpdateDraftInput';
  artifactId: Scalars['String']['output'];
  attachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  attachmentFileIds?: Maybe<Array<Scalars['String']['output']>>;
  bcc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Array<DraftEmailToolRecipientInput>>;
};

/**
 * Represents a tool for drafting an outbound call proposal.
 * The LLM fills in call details from workspace context; the user reviews, edits, and confirms.
 */
export type DraftOutboundCallTool = {
  __typename?: 'DraftOutboundCallTool';
  /** The input arguments for the outbound call draft */
  input: DraftOutboundCallToolInput;
  /** The result of the draft operation (echoed artifactId) */
  output: DraftOutboundCallToolOutput;
};

/** Input arguments for the DraftOutboundCallTool. */
export type DraftOutboundCallToolInput = {
  __typename?: 'DraftOutboundCallToolInput';
  /**
   * Optional. Omit on the first draft — the server assigns a stable artifact ID.
   * When updating a prior draft, pass the artifactId from that tool's output.
   */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** What Cara should accomplish on the call. */
  callObjective: Scalars['String']['output'];
  /** Direct callback number Cara should give if the customer needs to call back. */
  callbackPhone?: Maybe<Scalars['String']['output']>;
  /** Background context about the customer to help Cara personalize the call. */
  customerContext?: Maybe<Scalars['String']['output']>;
  /** Customer's full name. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Customer's phone number in E.164 format (+12125551234). */
  customerPhone?: Maybe<Scalars['String']['output']>;
  /** Custom call guidelines or instructions for Cara. */
  guidelines?: Maybe<Scalars['String']['output']>;
  /** Whether Cara should leave a voicemail if the customer doesn't answer. */
  leaveVoicemail: Scalars['Boolean']['output'];
  /** ISO 8601 datetime for when the call should be placed. */
  scheduledAt?: Maybe<Scalars['String']['output']>;
  /** IANA timezone for the scheduled time, e.g. America/New_York. */
  timezone: Scalars['String']['output'];
};

/** Result of a DraftOutboundCallTool operation. */
export type DraftOutboundCallToolOutput = {
  __typename?: 'DraftOutboundCallToolOutput';
  /** The artifact ID echoed back from the input. */
  artifactId: Scalars['String']['output'];
  /**
   * Set after the user confirms the draft via createOutboundCall.
   * When present, the UI shows the confirmed/scheduled state instead of the editable form
   * (survives refresh). Written by the API — not by the DRAFT_OUTBOUND_CALL tool itself.
   */
  outboundCallId?: Maybe<Scalars['String']['output']>;
  /**
   * Schedule snapshot from confirmation (null when the call was queued immediately).
   * Written together with outboundCallId.
   */
  scheduledAt?: Maybe<Scalars['Time']['output']>;
};

/** Element-specific styles */
export type ElementStyles = {
  __typename?: 'ElementStyles';
  /** Code block styles */
  code: CodeStyle;
  /** Heading styles */
  headings: HeadingStyles;
  /** Image styles */
  image: ImageStyle;
  /** Link styles */
  link: LinkStyle;
  /** List styles */
  list: ListStyle;
  /** Paragraph styles */
  paragraph: ParagraphStyle;
  /** Table styles */
  table: TableStyle;
};

/** Input for element-specific styles */
export type ElementStylesInput = {
  /** Code block style settings */
  code?: InputMaybe<CodeStyleInput>;
  /** Heading styles (for h1-h6) */
  headings?: InputMaybe<HeadingStylesInput>;
  /** Image style settings */
  image?: InputMaybe<ImageStyleInput>;
  /** Link style settings */
  link?: InputMaybe<LinkStyleInput>;
  /** List style settings */
  list?: InputMaybe<ListStyleInput>;
  /** Paragraph style settings */
  paragraph?: InputMaybe<ParagraphStyleInput>;
  /** Table style settings */
  table?: InputMaybe<TableStyleInput>;
};

/** Represents an email message in a thread */
export type Email = {
  __typename?: 'Email';
  /** Body content of the email */
  body: Scalars['String']['output'];
  /** Carbon copy recipients of the email */
  cc: Array<EmailParticipant>;
  /** Timestamp when this record was created */
  createdAt: Scalars['Time']['output'];
  /** Sender of the email */
  from: EmailParticipant;
  /** Hash of the email content for deduplication */
  hash: Scalars['String']['output'];
  /** Unique identifier for the email */
  id: Scalars['ID']['output'];
  /** Message-ID this email is replying to, if any */
  inReplyToMessageId?: Maybe<Scalars['String']['output']>;
  /** Unique Message-ID header value from the email */
  messageId: Scalars['String']['output'];
  /** Role of the sender (agent, Cara, or participant) */
  senderRole: EmailSenderRole;
  /** Timestamp when the email was sent */
  sentAt: Scalars['Time']['output'];
  /** Subject line of the email */
  subject: Scalars['String']['output'];
  /** ID of the thread this email belongs to */
  threadId: Scalars['String']['output'];
  /** Primary recipients of the email */
  to: Array<EmailParticipant>;
  /** Timestamp when this record was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Represents a draft of an email message in a thread */
export type EmailDraft = {
  __typename?: 'EmailDraft';
  /** Body content of the email */
  body: Scalars['String']['output'];
  /** Sender of the email */
  from: EmailParticipant;
  /** Subject line of the email */
  subject: Scalars['String']['output'];
  /** Primary recipients of the email */
  to: Array<EmailParticipant>;
};

/** Represents a participant (sender or recipient) of an email */
export type EmailParticipant = {
  __typename?: 'EmailParticipant';
  /** Email address of the participant */
  email: Scalars['String']['output'];
  /** Display name of the participant */
  name: Scalars['String']['output'];
};

/** Role of an email sender in the context of the system */
export enum EmailSenderRole {
  /** Message sent by an agency agent */
  Agent = 'AGENT',
  /** Message sent by the Cara AI assistant */
  Cara = 'CARA',
  /** Message sent by a known client */
  Client = 'CLIENT',
  /** Message sent by any other participant */
  Participant = 'PARTICIPANT'
}

/** Represents an email thread */
export type EmailThread = {
  __typename?: 'EmailThread';
  /** The account associated with this email, if any */
  account?: Maybe<Account>;
  /** The agency associated with this email */
  agency: Agency;
  /** Attachments in the email thread */
  attachments: Array<File>;
  /** Timestamp when this record was created */
  createdAt: Scalars['Time']['output'];
  /** The email address of the participant who initiated the thread */
  fromEmail: Scalars['String']['output'];
  /** The name of the participant who initiated the thread */
  fromName: Scalars['String']['output'];
  /** Unique identifier for the thread */
  id: Scalars['ID']['output'];
  /** Emails in the thread from participants, clients, and agents */
  participantEmails: Array<Email>;
  /** Service requests associated with this thread */
  serviceRequests: Array<ServiceRequest>;
  /** State of the thread */
  state: EmailThreadState;
  /** The subject of the thread */
  subject: Scalars['String']['output'];
  /** The summary of the thread */
  summary: Scalars['String']['output'];
  /** Timestamp when this record was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The role of the participant that the email thread is waiting for in order to proceed */
  waitingFor?: Maybe<EmailSenderRole>;
  /** The Cara workspace this email thread is associated with, if any */
  workspace?: Maybe<CaraWorkspace>;
};

/** Represents the state of an email thread */
export enum EmailThreadState {
  /** The thread is active and waiting for a response */
  Active = 'ACTIVE',
  /** The invocation has ended */
  Ended = 'ENDED'
}

/**
 * Embedding-specific details attached to an EMBEDDING span. A provider-owned primitive
 * (text/content → vectors) that underlies the search and indexing paths.
 */
export type Embedding = {
  __typename?: 'Embedding';
  /** Total cost in dollars for this embedding call. */
  costDollars: Scalars['Decimal']['output'];
  /** Dimensionality of the produced vectors. */
  dimensions: Scalars['Int']['output'];
  /** Number of inputs embedded in this call. */
  inputCount: Scalars['Int']['output'];
  /** gen_ai.usage.input_tokens. */
  inputTokens: Scalars['Int']['output'];
  /**
   * Whether this was a corpus-indexing (DOCUMENT) or search-time (QUERY) embedding.
   * Null when unset.
   */
  inputType?: Maybe<EmbeddingInputType>;
  /**
   * Per-input debug payload. Never the vectors. May be omitted or truncated for very large
   * document batches (inputCount remains exact).
   */
  inputs: Array<EmbeddingInput>;
  /** Input modality. Null when unset. */
  modality?: Maybe<EmbeddingModality>;
  /** gen_ai.provider.name (e.g. voyage). */
  providerName: Scalars['String']['output'];
  /** gen_ai.request.model (e.g. voyage-multimodal-3, voyage-4-large). */
  requestModel: Scalars['String']['output'];
  /** Whether an input exceeded the model's max and was silently truncated. */
  truncated: Scalars['Boolean']['output'];
};

/**
 * A single input to an embedding call. Query embeddings carry text; document embeddings
 * carry a source reference (sourceType + sourceId) that resolves via source.
 */
export type EmbeddingInput = {
  __typename?: 'EmbeddingInput';
  /**
   * The chunk's sequence number within the source document, when the embedded item is a
   * chunk of a larger document. Together with sourceId it identifies the exact chunk.
   */
  chunkId?: Maybe<Scalars['Int']['output']>;
  /** The resolved source object, when this input references one. */
  source?: Maybe<TraceSource>;
  /** The id of the embedded object, for document embeddings. */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** The kind of object embedded, for document embeddings. */
  sourceType?: Maybe<TraceSourceType>;
  /** The embedded text for a query embedding (truncated); null for document embeddings. */
  text?: Maybe<Scalars['String']['output']>;
  /** Input tokens attributed to this item, when known. */
  tokens?: Maybe<Scalars['Int']['output']>;
  /** Whether this input was truncated to fit the model's max. */
  truncated: Scalars['Boolean']['output'];
};

/**
 * Whether an embedding was produced for corpus indexing or for a search query. Significant
 * because providers like Voyage encode the two differently.
 */
export enum EmbeddingInputType {
  Document = 'DOCUMENT',
  Query = 'QUERY'
}

/** The modality of an embedding's input. */
export enum EmbeddingModality {
  Image = 'IMAGE',
  Multimodal = 'MULTIMODAL',
  Text = 'TEXT'
}

/** Details for a request to endorse a policy */
export type EndorsePolicyRequest = {
  __typename?: 'EndorsePolicyRequest';
  /** ID of the policy to be endorsed */
  policyId: Scalars['String']['output'];
};

/** Input type for endorsing a policy request */
export type EndorsePolicyRequestInput = {
  /** ID of the policy to be endorsed */
  policyId: Scalars['String']['input'];
};

/**
 * An Excel (.xlsx) spreadsheet template stored for the agency. The uploaded workbook is the
 * unit of authoring; its worksheets become the template's tabs, which are discovered during
 * ingestion and filled independently when Cara generates a workbook from this template.
 */
export type ExcelSpreadsheetTemplate = {
  __typename?: 'ExcelSpreadsheetTemplate';
  /** The agency this Excel spreadsheet template is associated with */
  agency: Agency;
  /** The timestamp when this Excel spreadsheet template was archived (soft deleted) */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when this Excel spreadsheet template was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this Excel spreadsheet template */
  createdBy: AgencyUser;
  /** The description of the Excel spreadsheet template */
  description: Scalars['String']['output'];
  /** An error message describing why the template processing failed. Only set when state is FAILED. */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Optional guidance for Cara when filling this template. Applies to the whole workbook;
   * per-tab instructions live on the tab's fillGuidance.
   */
  fillGuidance?: Maybe<Scalars['String']['output']>;
  /** The ID of the Excel spreadsheet template */
  id: Scalars['ID']['output'];
  /** The processing status of the Excel spreadsheet template. */
  state?: Maybe<ExcelSpreadsheetTemplateState>;
  /**
   * The worksheets of the uploaded workbook, in workbook order. Discovered during ingestion;
   * callers annotate them (setup guidance, static/required flags) but never add or remove them.
   */
  tabs: Array<ExcelSpreadsheetTemplateTab>;
  /** The uploaded Excel (XLSX) workbook this template fills from */
  templateFile?: Maybe<File>;
  /** The title of the Excel spreadsheet template */
  title: Scalars['String']['output'];
  /** The timestamp when this Excel spreadsheet template was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this Excel spreadsheet template */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this Excel spreadsheet template. The first version in this list
   * will be this version (i.e. identical to the current template), followed by the version
   * before that, and so-forth.
   */
  versionHistory?: Maybe<Array<ExcelSpreadsheetTemplateVersion>>;
  /**
   * The visibility configuration for this template (PRIVATE / SHARED / PUBLIC).
   * Lives on the parent row only — visibility is metadata, not part of the
   * versioned content. Defaults to PUBLIC.
   */
  visibility: VisibilityConfig;
};

/**
 * Excel spreadsheet template info for agency library templates.
 * GET_CONTENT includes the template's tabs (with their fill guidance and fields); LIST omits them.
 */
export type ExcelSpreadsheetTemplateInfo = {
  __typename?: 'ExcelSpreadsheetTemplateInfo';
  /** The timestamp when the template was created */
  createdAt: Scalars['Time']['output'];
  /** The user who created the template */
  createdBy: Scalars['String']['output'];
  /** The description of the template */
  description: Scalars['String']['output'];
  /** Optional operator guidance for filling this template (follow when present). */
  fillGuidance?: Maybe<Scalars['String']['output']>;
  /** The ID of the template */
  id: Scalars['String']['output'];
  /** The name of the template */
  name: Scalars['String']['output'];
  /** The tabs of the template, in workbook order */
  tabs: Array<ExcelSpreadsheetTemplateTab>;
};

/** Input for creating or updating an Excel spreadsheet template */
export type ExcelSpreadsheetTemplateInput = {
  /** The description of the Excel spreadsheet template */
  description: Scalars['String']['input'];
  /**
   * Optional guidance for Cara when filling this template (shown when listing templates in
   * workspace tools).
   */
  fillGuidance?: InputMaybe<Scalars['String']['input']>;
  /**
   * The tabs of the template. Tabs are discovered from the uploaded workbook during ingestion,
   * so entries only carry the authoring metadata a user can edit and must reference an existing
   * tab by ID. Omit on create, and omit on update to leave tab metadata untouched.
   */
  tabs?: InputMaybe<Array<ExcelSpreadsheetTemplateTabInput>>;
  /** The ID of the existing workbook file to keep on update. Omit when uploading a new file. */
  templateFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the Excel spreadsheet template */
  title: Scalars['String']['input'];
  /** The XLSX workbook to upload (required on create, or to replace the workbook on update) */
  uploadTemplate?: InputMaybe<Scalars['Upload']['input']>;
  /**
   * Optional visibility configuration. When omitted on create, the template defaults to PUBLIC.
   * When omitted on update, the existing visibility is preserved.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** The processing status of an Excel spreadsheet template. */
export enum ExcelSpreadsheetTemplateState {
  /** The template processing failed. See the error field for details. */
  Failed = 'FAILED',
  /** The template is being processed. */
  Processing = 'PROCESSING',
  /** The template is queued for processing. */
  Queued = 'QUEUED',
  /** The template has been processed and is ready to fill. */
  Ready = 'READY'
}

/** One worksheet of an Excel spreadsheet template's workbook. */
export type ExcelSpreadsheetTemplateTab = {
  __typename?: 'ExcelSpreadsheetTemplateTab';
  /** The data fields to fill in this tab. These are extracted by the LLM in a pre-processing step. */
  fields: Array<ExcelSpreadsheetTemplateTabField>;
  /**
   * Description of the tab's purpose, layout, and any fill instructions to provide to the LLM.
   * This is extracted by the LLM in a pre-processing step.
   */
  fillGuidance: Scalars['String']['output'];
  /** The ID of the tab. Stable across re-ingestion as long as the worksheet keeps its name. */
  id: Scalars['ID']['output'];
  /** The worksheet name as it appears in the workbook. Unique within a template. */
  name: Scalars['String']['output'];
  /**
   * Indicates whether this tab is required (i.e. must be filled in every workbook generated
   * from this template). Optional tabs that Cara does not fill are removed from the generated
   * workbook.
   */
  required: Scalars['Boolean']['output'];
  /**
   * Optional user-provided guidance supplied when the template is created/edited. It is fed to
   * the LLM at ingestion time to help it produce a more accurate fillGuidance for this tab
   * (e.g. clarifying which cells matter, how rows repeat, or what must be left untouched).
   */
  setupGuidance?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates whether this tab is static (i.e. reference or boilerplate content that is copied
   * verbatim into every generated workbook and never filled by the LLM).
   */
  static: Scalars['Boolean']['output'];
};

/** A data field to fill in an Excel spreadsheet template tab. */
export type ExcelSpreadsheetTemplateTabField = {
  __typename?: 'ExcelSpreadsheetTemplateTabField';
  /**
   * The A1 reference (cell or range) the value belongs in, when the tab's layout pins it to a
   * fixed address (e.g. "C12" or "B4:B20"). Empty when the target must be located at fill time
   * by scanning for its label.
   */
  cell: Scalars['String']['output'];
  /** The fill guidance for the field */
  fillGuidance: Scalars['String']['output'];
  /**
   * The worksheet text that labels this field's input cell, verbatim. Used to locate the target
   * at fill time when the address is not fixed.
   */
  label: Scalars['String']['output'];
  /** The name of the field */
  name: Scalars['String']['output'];
};

/**
 * Input for the authoring metadata of an Excel spreadsheet template tab. The tab itself is
 * discovered from the workbook; only these fields are author-editable.
 */
export type ExcelSpreadsheetTemplateTabInput = {
  /** The ID of the existing tab to update. */
  id: Scalars['String']['input'];
  /** Indicates whether this tab must be filled in every workbook generated from this template. */
  required: Scalars['Boolean']['input'];
  /**
   * Optional user-provided guidance fed to the LLM at ingestion time to help it produce a more
   * accurate fillGuidance for this tab. Trimmed server-side; blank values are stored as null.
   */
  setupGuidance?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indicates whether this tab is copied verbatim into every generated workbook instead of
   * being filled by the LLM.
   */
  static: Scalars['Boolean']['input'];
};

/** Describes the reason why an Excel spreadsheet template was updated */
export enum ExcelSpreadsheetTemplateUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occurred to an Excel spreadsheet template */
export enum ExcelSpreadsheetTemplateUpdateType {
  /** The Excel spreadsheet template was archived */
  ArchiveExcelSpreadsheetTemplate = 'ARCHIVE_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template was created */
  CreateExcelSpreadsheetTemplate = 'CREATE_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template processing finished */
  FinishProcessingExcelSpreadsheetTemplate = 'FINISH_PROCESSING_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template processing was started */
  StartProcessingExcelSpreadsheetTemplate = 'START_PROCESSING_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template was unarchived */
  UnarchiveExcelSpreadsheetTemplate = 'UNARCHIVE_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template was updated */
  UpdateExcelSpreadsheetTemplate = 'UPDATE_EXCEL_SPREADSHEET_TEMPLATE'
}

/** Describes a particular version of an Excel spreadsheet template */
export type ExcelSpreadsheetTemplateVersion = {
  __typename?: 'ExcelSpreadsheetTemplateVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The full Excel spreadsheet template object that includes all of the updates made in this version and all previous versions */
  excelSpreadsheetTemplate: ExcelSpreadsheetTemplate;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<ExcelSpreadsheetTemplateUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<ExcelSpreadsheetTemplateUpdateType>;
  /** The version number of this Excel spreadsheet template version */
  version: Scalars['Int64']['output'];
};

/**
 * Filter for the excelSpreadsheetTemplates list query. Wraps visibility filters today; future
 * filter dimensions (search, archived inclusion, etc.) can be added here without breaking the
 * query signature.
 */
export type ExcelSpreadsheetTemplatesFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/** Arguments for exportCaraWorkspaceMessage. */
export type ExportCaraWorkspaceMessageInput = {
  format: CaraWorkspaceMessageExportFormat;
  messageId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type ExtractSuperCopyInput = {
  blocks: Array<SuperCopyBlockInput>;
  screenshot: Scalars['Upload']['input'];
  source: SuperCopySourceInput;
};

/** EzLynxConfiguration contains configuration for the EZLynx integration */
export type EzLynxConfiguration = {
  __typename?: 'EzLynxConfiguration';
  /** EZLynx client ID for authentication. Optional - required only for API mode. */
  clientId?: Maybe<Scalars['String']['output']>;
  /**
   * If true, this integration is configured for CSV import only (no API access).
   * When false and credentials are present, both CSV import and API modes are available.
   * Defaults to false.
   */
  csvImportOnly: Scalars['Boolean']['output'];
  /** EZLynx integration group ID. Optional - required only for API mode. */
  integrationGroupId?: Maybe<Scalars['String']['output']>;
  /** EZLynx username for authentication. Optional - required only for API mode. */
  username?: Maybe<Scalars['String']['output']>;
};

export type EzlynxCallFields = {
  __typename?: 'EzlynxCallFields';
  applicantId?: Maybe<Scalars['String']['output']>;
  callerName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type EzlynxNoteFields = {
  __typename?: 'EzlynxNoteFields';
  applicantId?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EzlynxPolicyFields = {
  __typename?: 'EzlynxPolicyFields';
  accountId?: Maybe<Scalars['String']['output']>;
  agencyCode?: Maybe<Scalars['String']['output']>;
  agencyCommission?: Maybe<Scalars['Float']['output']>;
  annualPremium?: Maybe<Scalars['Float']['output']>;
  billingCompany?: Maybe<Scalars['Int']['output']>;
  billingType?: Maybe<Scalars['Int']['output']>;
  carrierId?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  fullTermPremium?: Maybe<Scalars['Float']['output']>;
  lob?: Maybe<Scalars['String']['output']>;
  lobOriginationDate?: Maybe<Scalars['String']['output']>;
  masterCompany?: Maybe<Scalars['Int']['output']>;
  naicCode?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyStatusId?: Maybe<Scalars['Int']['output']>;
  producerCode?: Maybe<Scalars['String']['output']>;
  producerCodeOverride?: Maybe<Scalars['String']['output']>;
  ratingState?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  writingCompany?: Maybe<Scalars['String']['output']>;
  writtenPremium?: Maybe<Scalars['Float']['output']>;
};

export type EzlynxWriteTool = {
  __typename?: 'EzlynxWriteTool';
  input: EzlynxWriteToolInput;
  output: EzlynxWriteToolOutput;
};

export type EzlynxWriteToolInput = {
  __typename?: 'EzlynxWriteToolInput';
  call?: Maybe<EzlynxCallFields>;
  note?: Maybe<EzlynxNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<EzlynxPolicyFields>;
};

export type EzlynxWriteToolOutput = {
  __typename?: 'EzlynxWriteToolOutput';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Feedback record */
export type Feedback = {
  __typename?: 'Feedback';
  /** Agency this feedback belongs to */
  agency: Agency;
  /** User who submitted the feedback */
  agencyUser: AgencyUser;
  /** Call (for call feedback) */
  call?: Maybe<Call>;
  /** User-provided comment for feedback */
  comment?: Maybe<Scalars['String']['output']>;
  /** When feedback was created */
  createdAt: Scalars['Time']['output'];
  /** When feedback was soft deleted (null if not deleted) */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** User-provided feedback details (structure varies by scope) */
  feedback: FeedbackContent;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Message (for message feedback) */
  message?: Maybe<CaraWorkspaceMessage>;
  /** Rating (for message and call feedback: UP or DOWN) */
  rating?: Maybe<MessageRating>;
  /** Scope of feedback */
  scope: FeedbackScope;
  /** When feedback was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Workspace (for message feedback)
   * Note: preset and custom_preset_id can be found via workspace lookup
   */
  workspace?: Maybe<CaraWorkspace>;
};

export type FeedbackContent = {
  __typename?: 'FeedbackContent';
  call?: Maybe<CallFeedback>;
  message?: Maybe<MessageFeedback>;
};

/** Feedback scope - what entity is being rated */
export enum FeedbackScope {
  /** Call rating */
  Call = 'CALL',
  /** Message rating (thumbs up/down) */
  Message = 'MESSAGE'
}

/**
 * A file describes a document that is attached to an object, with
 * metadata and URLs to fetch it.
 */
export type File = {
  __typename?: 'File';
  /** The timestamp this file was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp this file was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The ID of the entity that this file is associated with */
  entityRefId: Scalars['String']['output'];
  /** The type of entity that this file is associated with */
  entityRefType: FileEntityRefType;
  /** The SHA256 hash of the file bytes */
  hash: Scalars['String']['output'];
  /** The unique identifier of the file */
  id: Scalars['ID']['output'];
  /** The file MIME type */
  mimeType: Scalars['String']['output'];
  /** The file name, for display and download purposes */
  name: Scalars['String']['output'];
  /** The notes associated with the file */
  notes: Scalars['String']['output'];
  /** The size of the file in bytes */
  size: Scalars['Int']['output'];
  /** The type of the file */
  type: FileType;
  /** The timestamp this file was updated */
  updatedAt: Scalars['Time']['output'];
  /** The public URL to fetch the file, if the file is visible to the user */
  url?: Maybe<Scalars['String']['output']>;
  /** Whether the file is visible to the user */
  visible: Scalars['Boolean']['output'];
};

/**
 * Represents a tool for creating or editing a file.
 * Used when the LLM needs to create or edit a file.
 */
export type FileEditorTool = {
  __typename?: 'FileEditorTool';
  /** The input arguments for the file creation or editing */
  input: FileEditorToolInput;
  /** The result of the file creation or editing operation */
  output: FileEditorToolOutput;
};

/**
 * Input arguments for the FileEditorTool.
 * Contains all necessary information to create or edit a file.
 */
export type FileEditorToolInput = {
  __typename?: 'FileEditorToolInput';
  /** The content of the file */
  content: Scalars['String']['output'];
  /** The content type of the file */
  contentType: Scalars['String']['output'];
  /** The ID of the file being created or edited. For CONVERT_PDF_TO_HTML this is the PDF file ID. For CONVERT_HTML_TO_TEMPLATE this is the source HTML artifact ID. */
  fileId: Scalars['String']['output'];
  /** The ID of the HTML document template used for this document, when applying a saved library template. */
  htmlDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /** The operation of the file editor */
  operation: Scalars['String']['output'];
  /** The text to replace */
  replaceText: Scalars['String']['output'];
  /** The title of the file */
  title: Scalars['String']['output'];
};

/**
 * Result of a FileEditorTool operation.
 * Contains information about the created or edited file.
 */
export type FileEditorToolOutput = {
  __typename?: 'FileEditorToolOutput';
  /** Content returned when the operation is READ */
  content?: Maybe<Scalars['String']['output']>;
  /** The ID of the created or edited file */
  fileId: Scalars['String']['output'];
  /**
   * The ID of the HTML document template used to create this artifact, if any.
   * Preserved automatically when regenerating an existing document.
   */
  htmlDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /** Any remarks or notes about the file */
  remarks?: Maybe<Scalars['String']['output']>;
  /**
   * The ID of the source this document was converted from:
   * - For CONVERT_HTML_TO_TEMPLATE: the source HTML artifact ID
   * When regenerating, use the same conversion operation with this ID.
   */
  sourceFileId?: Maybe<Scalars['String']['output']>;
  /** The content of the created or edited file */
  version: Scalars['Int']['output'];
};

/** FileEntityRefType describes the type of entity that a file is associated with. */
export enum FileEntityRefType {
  /** The file is associated with an account */
  Account = 'ACCOUNT',
  /** The file is associated with a Cara workspace */
  CaraWorkspace = 'CARA_WORKSPACE',
  /** The file is associated with a code execution tool call */
  CodeExecutionToolCall = 'CODE_EXECUTION_TOOL_CALL',
  /** The file is associated with a custom form */
  CustomForm = 'CUSTOM_FORM',
  /** The file is associated with a custom preset */
  CustomPreset = 'CUSTOM_PRESET',
  /** The file is associated with an email thread */
  EmailThread = 'EMAIL_THREAD',
  /** The file is associated with an Excel spreadsheet template */
  ExcelSpreadsheetTemplate = 'EXCEL_SPREADSHEET_TEMPLATE',
  /** The file is associated with an HTML document template */
  HtmlDocumentTemplate = 'HTML_DOCUMENT_TEMPLATE',
  /** The file is associated with a knowledge graph entity */
  KnowledgeGraphEntity = 'KNOWLEDGE_GRAPH_ENTITY',
  /** The file is associated with a policy */
  Policy = 'POLICY',
  /** The file is associated with a service request */
  ServiceRequest = 'SERVICE_REQUEST',
  /** The file is associated with a Word document template */
  WordDocumentTemplate = 'WORD_DOCUMENT_TEMPLATE',
  /** The file is associated with a workflow execution */
  Workflow = 'WORKFLOW'
}

/** File role describes a type of file related to an object */
export enum FileType {
  /** The file is a form generated as part of an application */
  ApplicationForm = 'APPLICATION_FORM',
  /** The file is a binder, a pre-coverage confirmation document */
  Binder = 'BINDER',
  /** The file is a certificate of insurance */
  Certificate = 'CERTIFICATE',
  /** The file is an endorsement, affixed to the policy document */
  Endorsement = 'ENDORSEMENT',
  /** The file is an invoice, generally for internal tracking purposes */
  Invoice = 'INVOICE',
  /** The file is a lost policy release, issued when a policy is canceled by the customer */
  LostPolicyRelease = 'LOST_POLICY_RELEASE',
  /** The file is a notice of cancellation, issued when a policy is being canceled or nonrenewed by the carrier */
  NoticeOfCancellation = 'NOTICE_OF_CANCELLATION',
  /** The file is of another type */
  Other = 'OTHER',
  /** The file is a policy document */
  PolicyDocument = 'POLICY_DOCUMENT',
  /** The file is a quote document */
  QuoteDocument = 'QUOTE_DOCUMENT'
}

/**
 * Represents a tool for filling out a template.
 * Used when the LLM needs to fill out a template such as an ACORD form.
 */
export type FillTemplateTool = {
  __typename?: 'FillTemplateTool';
  /** The input arguments for the template filling */
  input: FillTemplateToolInput;
  /** The result of the template filling */
  output: FillTemplateToolOutput;
};

/**
 * Input arguments for the FillTemplateTool.
 * Contains all necessary information to fill out a template.
 */
export type FillTemplateToolInput = {
  __typename?: 'FillTemplateToolInput';
  artifactId?: Maybe<Scalars['String']['output']>;
  /** The ID of the template being filled out */
  templateId: DocumentType;
};

/**
 * Result of a FillTemplateTool operation.
 * Contains information about the filled template.
 */
export type FillTemplateToolOutput = {
  __typename?: 'FillTemplateToolOutput';
  /** The ID of the filled template */
  artifactId: Scalars['String']['output'];
  /** The version of the filled template */
  version: Scalars['Int']['output'];
};

/** Result of a direct (live) AMS account search. */
export type FindAmsAccountResult = {
  __typename?: 'FindAmsAccountResult';
  /**
   * The matched account entity, possibly a just-created minimal placeholder
   * whose documents are still importing. Null when no supported AMS matched.
   */
  account?: Maybe<KnowledgeGraphEntity>;
  /**
   * All accounts matched by a multi-result live AMS name search. Exact email,
   * phone, lookup-code, and policy searches return either zero or one entry.
   */
  accounts: Array<KnowledgeGraphEntity>;
  /** Whether a background import/refresh workflow was started for the account. */
  enqueued: Scalars['Boolean']['output'];
};

/** A font to load in the HTML document template */
export type Font = {
  __typename?: 'Font';
  /** The name of the font */
  name: Scalars['String']['output'];
  /** The variants of the font */
  variants: Array<FontVariant>;
};

/** A variant of a font */
export type FontVariant = {
  __typename?: 'FontVariant';
  /** The source of the font variant */
  src: Scalars['String']['output'];
  /** The style of the font variant */
  style: Scalars['String']['output'];
  /** The weight of the font variant */
  weight: Scalars['Int']['output'];
};

/** How the general aggregate limit applies to a liability policy */
export enum GeneralAggregateLimitAppliesPerType {
  /** Limit applies in some other way */
  Other = 'OTHER',
  /** Limit applies per location */
  PerLocation = 'PER_LOCATION',
  /** Limit applies per policy */
  PerPolicy = 'PER_POLICY',
  /** Limit applies per project */
  PerProject = 'PER_PROJECT'
}

/**
 * Input for generatePresetQuestions: the source workspaces plus the wizard
 * choices already made, so generated questions do not re-ask what the user has
 * already provided.
 */
export type GeneratePresetQuestionsInput = {
  /** The base preset the user chose (or the wizard auto-detected), if any. */
  basePresetOverride?: InputMaybe<CaraWorkspacePreset>;
  /** Custom forms the user already selected for the preset, if any. */
  customFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** HTML document templates the user already selected for the preset, if any. */
  htmlDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Free-text description of the output formats the user already provided, if any. */
  outputFormatsText?: InputMaybe<Scalars['String']['input']>;
  /** The workspaces to derive clarifying questions from. At least one is required. */
  sourceWorkspaceIds: Array<Scalars['String']['input']>;
  /** Word document templates the user already selected for the preset, if any. */
  wordDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** LLM-specific details attached to a GENERATION span. */
export type Generation = {
  __typename?: 'Generation';
  /** Total cost in dollars for this generation (domain extension, not OTel). */
  costDollars: Scalars['Decimal']['output'];
  /** gen_ai.response.finish_reasons */
  finishReasons?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Opaque generation request payload (provider-specific shape).
   * Maps to gen_ai.input / cara.gen_ai.input.
   */
  input: Scalars['JSON']['output'];
  /** gen_ai.operation.name (e.g. chat, generate_content, text_completion). */
  operationName: Scalars['String']['output'];
  /**
   * Opaque generation response payload (provider-specific shape).
   * Maps to gen_ai.output / cara.gen_ai.output.
   */
  output?: Maybe<Scalars['JSON']['output']>;
  /** Latitude prompt name, if the generation used a managed prompt. */
  promptName?: Maybe<Scalars['String']['output']>;
  /** Latitude prompt version, if the generation used a managed prompt. */
  promptVersion?: Maybe<Scalars['String']['output']>;
  /** gen_ai.provider.name (e.g. anthropic, aws.bedrock, gcp.vertex_ai). */
  providerName: Scalars['String']['output'];
  /** gen_ai.request.model */
  requestModel: Scalars['String']['output'];
  /** gen_ai.response.model */
  responseModel?: Maybe<Scalars['String']['output']>;
  /** gen_ai.request.stream */
  stream: Scalars['Boolean']['output'];
  /**
   * Time to first streaming chunk in milliseconds. Maps to gen_ai.response.time_to_first_chunk
   * (convert seconds ↔ ms at the OTel boundary).
   */
  timeToFirstChunkMs?: Maybe<Scalars['Int']['output']>;
  /** Token usage for this generation. */
  usage: TokenUsage;
};

export type GetClientTool = {
  __typename?: 'GetClientTool';
  input: GetClientToolInput;
  output?: Maybe<GetClientToolOutput>;
};

export type GetClientToolInput = {
  __typename?: 'GetClientToolInput';
  /** The client id, as returned by SEARCH_CLIENTS. */
  clientId: Scalars['String']['output'];
};

export type GetClientToolOutput = {
  __typename?: 'GetClientToolOutput';
  /** Street address, when any part of it is known. */
  address?: Maybe<Scalars['String']['output']>;
  /** Accounts in the agency's management systems that this client is linked to. */
  amsAccounts: Array<ClientToolAmsAccount>;
  client: ClientToolSummary;
  /** How many workspaces are linked to this client. */
  linkedWorkspaceCount: Scalars['Int']['output'];
  /** Display name of the agency user who owns this client, when one is assigned. */
  owner?: Maybe<Scalars['String']['output']>;
};

/** Input for querying feedback with optional filters */
export type GetFeedbackInput = {
  /** Agency ID filter (admin only - automatically restricted to caller's agency for agency users) */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Agency user ID filter (for filtering by specific user) */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** Call ID filter (for call feedback) */
  callId?: InputMaybe<Scalars['String']['input']>;
  /** Message ID filter (for message feedback) */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /** Scope filter (message or call) */
  scope?: InputMaybe<FeedbackScope>;
  /** Workspace ID filter (for message feedback) */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Information about an HTML document template for use in Cara workspace. */
export type HtmlDocumentTemplateInfo = {
  __typename?: 'HTMLDocumentTemplateInfo';
  /** The HTML body template content. Only included when GET_CONTENT operation is used (HTML templates). */
  bodyHTML?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this template was created */
  createdAt: Scalars['Time']['output'];
  /** The name of the user who created this template */
  createdBy: Scalars['String']['output'];
  /** The description of the template */
  description: Scalars['String']['output'];
  /** The unique identifier for this template */
  id: Scalars['String']['output'];
  /** The title/name of the template */
  name: Scalars['String']['output'];
  /** The names of files used as prefixes (for informational context) */
  prefixFileNames: Array<Scalars['String']['output']>;
  /** The names of files used as suffixes (for informational context) */
  suffixFileNames: Array<Scalars['String']['output']>;
  /**
   * Deprecated: legacy field. Kept for backward compatibility with old clients;
   * not used by Cara when ranking templates.
   * @deprecated No longer used; legacy values may still appear for older templates.
   */
  useCase?: Maybe<HtmlDocumentTemplateUseCase>;
};

export type HawksoftAttachmentFields = {
  __typename?: 'HawksoftAttachmentFields';
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  insuredType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  logNote?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  taskAssignedToEmail?: Maybe<Scalars['String']['output']>;
  taskAssignedToRole?: Maybe<Scalars['String']['output']>;
  taskCategory?: Maybe<Scalars['String']['output']>;
  taskDescription?: Maybe<Scalars['String']['output']>;
  taskDueDate?: Maybe<Scalars['String']['output']>;
  taskTitle?: Maybe<Scalars['String']['output']>;
};

/** HawksoftConfiguration contains configuration for the Hawksoft integration */
export type HawksoftConfiguration = {
  __typename?: 'HawksoftConfiguration';
  /** Hawksoft agency ID */
  agencyId: Scalars['String']['output'];
  /** If enabled, will sync call notes to the appropriate contact based on the caller's number. */
  enableSyncCallNotes: Scalars['Boolean']['output'];
  /** If enabled, will sync service requests as tasks to the agent. */
  enableSyncServiceRequests: Scalars['Boolean']['output'];
  /**
   * If specified, and overrideTaskAssignmentMethod is SPECIFIED_EMAIL, this email will be used
   * to assign tasks in HawkSoft.
   */
  overrideTaskAssignmentEmail?: Maybe<Scalars['String']['output']>;
  /**
   * If specified, overrides the field used to determine who to assign tasks to. The default
   * is the CSR field.
   */
  overrideTaskAssignmentMethod?: Maybe<HawksoftTaskAssignmentMethod>;
};

export type HawksoftLogNoteFields = {
  __typename?: 'HawksoftLogNoteFields';
  channel?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  insuredType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  taskAssignedToEmail?: Maybe<Scalars['String']['output']>;
  taskAssignedToRole?: Maybe<Scalars['String']['output']>;
  taskCategory?: Maybe<Scalars['String']['output']>;
  taskDescription?: Maybe<Scalars['String']['output']>;
  taskDueDate?: Maybe<Scalars['String']['output']>;
  taskTitle?: Maybe<Scalars['String']['output']>;
};

export type HawksoftReceiptFields = {
  __typename?: 'HawksoftReceiptFields';
  channel?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  invoices?: Maybe<Array<HawksoftReceiptInvoice>>;
  logNote?: Maybe<Scalars['String']['output']>;
  officeId?: Maybe<Scalars['Int']['output']>;
  payMethod?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  taskAssignedToEmail?: Maybe<Scalars['String']['output']>;
  taskAssignedToRole?: Maybe<Scalars['String']['output']>;
  taskCategory?: Maybe<Scalars['String']['output']>;
  taskDescription?: Maybe<Scalars['String']['output']>;
  taskDueDate?: Maybe<Scalars['String']['output']>;
  taskTitle?: Maybe<Scalars['String']['output']>;
};

export type HawksoftReceiptInvoice = {
  __typename?: 'HawksoftReceiptInvoice';
  amount?: Maybe<Scalars['Float']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
};

/** The method to use to assign tasks in HawkSoft */
export enum HawksoftTaskAssignmentMethod {
  ClientFieldAgent1 = 'CLIENT_FIELD_AGENT1',
  ClientFieldAgent2 = 'CLIENT_FIELD_AGENT2',
  ClientFieldAgent3 = 'CLIENT_FIELD_AGENT3',
  ClientFieldCsr = 'CLIENT_FIELD_CSR',
  ClientFieldProducer = 'CLIENT_FIELD_PRODUCER',
  SpecifiedEmail = 'SPECIFIED_EMAIL'
}

/** Represents a tool for managing HawkSoft log entries and receipts. */
export type HawksoftWriteTool = {
  __typename?: 'HawksoftWriteTool';
  input: HawksoftWriteToolInput;
  output: HawksoftWriteToolOutput;
};

export type HawksoftWriteToolInput = {
  __typename?: 'HawksoftWriteToolInput';
  attachment?: Maybe<HawksoftAttachmentFields>;
  logNote?: Maybe<HawksoftLogNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  receipt?: Maybe<HawksoftReceiptFields>;
};

export type HawksoftWriteToolOutput = {
  __typename?: 'HawksoftWriteToolOutput';
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Configuration for headers and footers on document pages */
export type HeaderFooterConfig = {
  __typename?: 'HeaderFooterConfig';
  /** Footer configuration with left, center, and right slots */
  footer: HeaderFooterSlots;
  /** Header configuration with left, center, and right slots */
  header: HeaderFooterSlots;
};

/** Input for headers and footers configuration */
export type HeaderFooterConfigInput = {
  /** Footer configuration with left, center, and right slots */
  footer?: InputMaybe<HeaderFooterSlotsInput>;
  /** Header configuration with left, center, and right slots */
  header?: InputMaybe<HeaderFooterSlotsInput>;
};

/** Image configuration for a header or footer slot */
export type HeaderFooterImage = {
  __typename?: 'HeaderFooterImage';
  /** Metadata for the image file */
  file: File;
  /**
   * Optional gap between the image's inner edge and the body content area (in points).
   * When set with no paddingPt, the image is anchored flush to the page edge and this
   * space is reserved entirely on the body-content side. When both fields are unset,
   * the image is centered inside the margin zone.
   */
  innerGapPt?: Maybe<Scalars['Float']['output']>;
  /** Optional maximum height for the rendered image (in points) */
  maxHeightPt?: Maybe<Scalars['Float']['output']>;
  /** Optional vertical padding between the image and the page edge (in points) */
  paddingPt?: Maybe<Scalars['Float']['output']>;
};

/** Image input for a header or footer slot */
export type HeaderFooterImageInput = {
  /** Reference an existing uploaded file by ID */
  fileId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional gap between the image's inner edge and the body content area (in points).
   * When set with no paddingPt, the image is anchored flush to the page edge and this
   * space is reserved entirely on the body-content side. When both fields are unset,
   * the image is centered inside the margin zone.
   */
  innerGapPt?: InputMaybe<Scalars['Float']['input']>;
  /** Optional maximum height for the rendered image (in points) */
  maxHeightPt?: InputMaybe<Scalars['Float']['input']>;
  /** Optional vertical padding between the image and the page edge (in points) */
  paddingPt?: InputMaybe<Scalars['Float']['input']>;
  /** Upload a new image for this slot */
  upload?: InputMaybe<Scalars['Upload']['input']>;
};

/** Configuration for a single header or footer slot (left, center, or right) */
export type HeaderFooterSlot = {
  __typename?: 'HeaderFooterSlot';
  /** Optional image to display in this slot. Supports a single image per slot. */
  image?: Maybe<HeaderFooterImage>;
  /**
   * The text content for this slot. Supports placeholders: {page} for current page number,
   * {pages} for total page count, {date} for current date in MM/DD/YYYY format.
   */
  text?: Maybe<Scalars['String']['output']>;
};

/** Input for a single header or footer slot (left, center, or right) */
export type HeaderFooterSlotInput = {
  /** Optional image to display in this slot. Supports a single image per slot. */
  image?: InputMaybe<HeaderFooterImageInput>;
  /**
   * The text content for this slot. Supports placeholders: {page} for current page number,
   * {pages} for total page count, {date} for current date in MM/DD/YYYY format.
   */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Slots for header or footer (left, center, right) */
export type HeaderFooterSlots = {
  __typename?: 'HeaderFooterSlots';
  /** Content for the center slot */
  center?: Maybe<HeaderFooterSlot>;
  /** Content for the left slot */
  left?: Maybe<HeaderFooterSlot>;
  /** Content for the right slot */
  right?: Maybe<HeaderFooterSlot>;
};

/** Input for header or footer slots (left, center, right) */
export type HeaderFooterSlotsInput = {
  /** Content for the center slot */
  center?: InputMaybe<HeaderFooterSlotInput>;
  /** Content for the left slot */
  left?: InputMaybe<HeaderFooterSlotInput>;
  /** Content for the right slot */
  right?: InputMaybe<HeaderFooterSlotInput>;
};

/** Individual heading style */
export type HeadingStyle = {
  __typename?: 'HeadingStyle';
  /** Text color in hex format (e.g. '#0f172a') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Font family name (overrides global typography when set) */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size in points (e.g. 18.0 for h1, 15.0 for h2) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Font style (e.g. 'normal', 'italic') */
  fontStyle?: Maybe<Scalars['String']['output']>;
  /** Font weight as a number (e.g. 600 for semi-bold) */
  fontWeight?: Maybe<Scalars['Int']['output']>;
  /** Line height as a unitless multiplier (e.g. 1.4) */
  lineHeight?: Maybe<Scalars['Float']['output']>;
  /** Bottom margin in em units (e.g. 0.4) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Top margin in em units (e.g. 1.2) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
  /** When true, emit page-break-before so the heading starts on a new page */
  pageBreakBefore?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for a single heading level style */
export type HeadingStyleInput = {
  /** Text color as a CSS hex string */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font family for this heading level */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Font size in points for this heading level */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Font style for this heading level (e.g. 'italic') */
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  /** Font weight for this heading level (e.g. 700) */
  fontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Line height for this heading level (unitless multiplier) */
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Bottom margin in em units */
  marginBottomEm?: InputMaybe<Scalars['Float']['input']>;
  /** Top margin in em units */
  marginTopEm?: InputMaybe<Scalars['Float']['input']>;
  /** If true, a page break is forced before this heading */
  pageBreakBefore?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Heading styles for all levels */
export type HeadingStyles = {
  __typename?: 'HeadingStyles';
  /** H1 styles */
  h1: HeadingStyle;
  /** H2 styles */
  h2: HeadingStyle;
  /** H3 styles */
  h3: HeadingStyle;
  /** H4 styles */
  h4: HeadingStyle;
  /** H5 styles */
  h5: HeadingStyle;
  /** H6 styles */
  h6: HeadingStyle;
};

/** Input for heading styles (all levels) */
export type HeadingStylesInput = {
  /** Style settings for h1 headings */
  h1?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h2 headings */
  h2?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h3 headings */
  h3?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h4 headings */
  h4?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h5 headings */
  h5?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h6 headings */
  h6?: InputMaybe<HeadingStyleInput>;
};

/** A HTML document artifact */
export type HtmlDocument = {
  __typename?: 'HtmlDocument';
  /** The HTML content of the document */
  content: Scalars['String']['output'];
  /** The ID of the document */
  id: Scalars['ID']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/** Result of buildHtmlDocumentRenderUrl containing the fully-constructed statics URL. */
export type HtmlDocumentRenderUrl = {
  __typename?: 'HtmlDocumentRenderUrl';
  /** The statics URL to open in a new tab to render the PDF */
  url: Scalars['String']['output'];
};

/** A custom preset for Cara to execute tasks and produce artifacts */
export type HtmlDocumentTemplate = {
  __typename?: 'HtmlDocumentTemplate';
  /** The agency this HTML document template is associated with */
  agency: Agency;
  /** The timestamp when this HTML document template was archived (soft deleted) */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The base style to inherit from. Can be a built-in style or another custom style.
   * Built-in styles are prefixed with 'builtin:' (e.g. 'builtin:classic-professional')
   */
  baseStyleId?: Maybe<Scalars['String']['output']>;
  /** The HTML body template with placeholders for LLM content generation */
  bodyTemplate?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this HTML document template was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this HTML document template */
  createdBy: AgencyUser;
  /** The description of the HTML document template */
  description: Scalars['String']['output'];
  /** Configuration for headers and footers on document pages */
  headerFooter?: Maybe<HeaderFooterConfig>;
  /** The ID of the HTML document template */
  id: Scalars['ID']['output'];
  /** The files that are used as prefixes for the HTML document template */
  prefixFiles: Array<File>;
  /** The style of the HTML document template */
  style: HtmlDocumentTemplateStyle;
  /** The files that are used as suffixes for the HTML document template */
  suffixFiles: Array<File>;
  /** The title of the HTML document template */
  title: Scalars['String']['output'];
  /** The timestamp when this HTML document template was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Deprecated: legacy field. Returns null for templates created after the field was retired,
   * but may still echo a previously persisted value on older templates.
   * @deprecated No longer used; legacy values may still be returned for older templates.
   */
  useCase?: Maybe<HtmlDocumentTemplateUseCase>;
  /** The version of this HTML document template */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this HTML document template. The first version in this list will be this version
   * (i.e. identical to the current HTML document template), followed by the version before that, and so-forth.
   */
  versionHistory?: Maybe<Array<HtmlDocumentTemplateVersion>>;
  /**
   * The visibility configuration for this HTML document template
   * (PRIVATE / SHARED / PUBLIC). Lives on the parent row only — visibility is
   * metadata, not part of the versioned content. Defaults to PUBLIC for all rows
   * on migration.
   */
  visibility: VisibilityConfig;
};

export type HtmlDocumentTemplateInput = {
  /** The base style ID that should be used as fallback styles. */
  baseStyleId?: InputMaybe<Scalars['String']['input']>;
  /** The HTML body template with placeholders for LLM content generation */
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  /** The description of the HTML document template */
  description: Scalars['String']['input'];
  /** Configuration for headers and footers on document pages */
  headerFooter?: InputMaybe<HeaderFooterConfigInput>;
  /** The ID of the existing prefix file to keep */
  prefixFileId?: InputMaybe<Scalars['String']['input']>;
  /** Optional style overrides merged on top of the base style (from baseStyleId). When provided, only non-nil fields are applied. */
  style?: InputMaybe<HtmlDocumentTemplateStyleInput>;
  /** The ID of the existing suffix file to keep */
  suffixFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the HTML document template */
  title: Scalars['String']['input'];
  /** The prefix file to upload if an existing prefix file is not provided */
  uploadPrefixFile?: InputMaybe<Scalars['Upload']['input']>;
  /** The suffix file to upload if an existing suffix file is not provided */
  uploadSuffixFile?: InputMaybe<Scalars['Upload']['input']>;
  /** Deprecated: accepted for backward compatibility but silently ignored. */
  useCase?: InputMaybe<HtmlDocumentTemplateUseCase>;
  /**
   * Optional visibility configuration. When omitted on create, defaults to
   * PUBLIC. When omitted on update, the existing visibility is preserved.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** The style of a HTML document template */
export type HtmlDocumentTemplateStyle = {
  __typename?: 'HtmlDocumentTemplateStyle';
  /** Custom CSS properties that don't fit into the structured schema */
  customStyles?: Maybe<Array<CustomStyle>>;
  /** Element-specific styles */
  elements: ElementStyles;
  /** The fonts to load in the HTML document template */
  fonts: Array<Font>;
  /** Page layout settings */
  page: PageStyle;
  /** Primary brand color in hex format (e.g. '#2563eb'). Exposed as CSS variable --primary-color. */
  primaryColorHex?: Maybe<Scalars['String']['output']>;
  /**
   * Light tint of primary color for backgrounds (auto-computed at ~12% mix when null).
   * Exposed as CSS variable --primary-color-light.
   */
  primaryColorLightHex?: Maybe<Scalars['String']['output']>;
  /** Secondary brand color in hex format (e.g. '#64748b'). Exposed as CSS variable --secondary-color. */
  secondaryColorHex?: Maybe<Scalars['String']['output']>;
  /**
   * Light tint of secondary color for backgrounds (auto-computed at ~12% mix when null).
   * Exposed as CSS variable --secondary-color-light.
   */
  secondaryColorLightHex?: Maybe<Scalars['String']['output']>;
  /** Typography settings */
  typography: TypographyStyle;
};

/** Input for HTML document template style (partial override merged over base style) */
export type HtmlDocumentTemplateStyleInput = {
  /** Additional custom CSS blocks to append */
  customStyles?: InputMaybe<Array<CustomStyleInput>>;
  /** Element-specific style overrides (headings, tables, etc.) */
  elements?: InputMaybe<ElementStylesInput>;
  /** Page settings (size, margin, background color) */
  page?: InputMaybe<PageStyleInput>;
  /** Primary color for document highlights, as a CSS hex string */
  primaryColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Lighter variant of the primary color, as a hex string */
  primaryColorLightHex?: InputMaybe<Scalars['String']['input']>;
  /** Secondary color for document highlights, as a CSS hex string */
  secondaryColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Lighter variant of the secondary color, as a hex string */
  secondaryColorLightHex?: InputMaybe<Scalars['String']['input']>;
  /** Typography settings (base font, size, color) */
  typography?: InputMaybe<TypographyStyleInput>;
};

/** Describes the reason why a HTML document template was updated */
export enum HtmlDocumentTemplateUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a HTML document template */
export enum HtmlDocumentTemplateUpdateType {
  /** The HTML document template was archived */
  ArchiveHtmlDocumentTemplate = 'ARCHIVE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was created */
  CreateHtmlDocumentTemplate = 'CREATE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was unarchived */
  UnarchiveHtmlDocumentTemplate = 'UNARCHIVE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was updated */
  UpdateHtmlDocumentTemplate = 'UPDATE_HTML_DOCUMENT_TEMPLATE'
}

/**
 * Deprecated: kept for backward compatibility with older clients; no longer used by the UI.
 * Values are no longer set on new templates and never read by the backend, but legacy values
 * already persisted on existing templates may still round-trip.
 */
export enum HtmlDocumentTemplateUseCase {
  CertificateOfInsurance = 'CERTIFICATE_OF_INSURANCE',
  General = 'GENERAL',
  Letter = 'LETTER',
  None = 'NONE',
  Proposal = 'PROPOSAL',
  Report = 'REPORT'
}

/** Describes a particular version of a HTML document template */
export type HtmlDocumentTemplateVersion = {
  __typename?: 'HtmlDocumentTemplateVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another HTML document template version. */
  diffableJson: Scalars['String']['output'];
  /** The full HTML document template object that includes all of the updates made in this version and all previous versions */
  htmlDocumentTemplate: HtmlDocumentTemplate;
  /** The version number of the previous HTML document template version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<HtmlDocumentTemplateVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<HtmlDocumentTemplateUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<HtmlDocumentTemplateUpdateType>;
  /** The version number of this HTML document template version */
  version: Scalars['Int64']['output'];
};

/**
 * Filter for the htmlDocumentTemplates list query. Wraps visibility filters
 * today; future filter dimensions (search, archived inclusion, etc.) can be
 * added here without breaking the query signature.
 */
export type HtmlDocumentTemplatesFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/** HttpHeader defines a header of an HTTP request or response */
export type HttpHeader = {
  __typename?: 'HttpHeader';
  /** The name of the header */
  name: Scalars['String']['output'];
  /** The value of the header */
  value: Scalars['String']['output'];
};

/** HttpRequest defines the HTTP request that caused the error */
export type HttpRequest = {
  __typename?: 'HttpRequest';
  /** The body of the request */
  body: Scalars['String']['output'];
  /** The content type of the request body, extracted from the headers */
  contentType: Scalars['String']['output'];
  /** The headers of the request */
  headers: Array<HttpHeader>;
  /** The HTTP method of the request */
  method: Scalars['String']['output'];
  /** The URL of the request */
  url: Scalars['String']['output'];
};

/** HttpError defines the error that occurred during an HTTP request */
export type HttpRequestResponse = {
  __typename?: 'HttpRequestResponse';
  /** The HTTP request that caused the error */
  request?: Maybe<HttpRequest>;
  /** The HTTP response that caused the error */
  response?: Maybe<HttpResponse>;
};

/** HttpResponse defines the HTTP response that caused the error */
export type HttpResponse = {
  __typename?: 'HttpResponse';
  /** The body of the response */
  body: Scalars['String']['output'];
  /** The headers of the response */
  headers: Array<HttpHeader>;
  /** The HTTP status code of the response */
  statusCode: Scalars['Int']['output'];
};

/** HubSpotCallFieldMappings defines field mappings for call syncing */
export type HubSpotCallFieldMappings = {
  __typename?: 'HubSpotCallFieldMappings';
  /** Field mappings when syncing calls as deals */
  dealFields: Array<HubSpotFieldMapping>;
  /** Field mappings when syncing calls as tickets */
  ticketFields: Array<HubSpotFieldMapping>;
};

/** HubSpotCallFieldMappingsInput defines field mappings for call syncing. Only one of ticketFields or dealFields should be provided, based on callSyncType. */
export type HubSpotCallFieldMappingsInput = {
  /** Field mappings when syncing calls as deals. Required when callSyncType is DEAL, must not be provided otherwise. */
  dealFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
  /** Field mappings when syncing calls as tickets. Required when callSyncType is TICKET, must not be provided otherwise. */
  ticketFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
};

/** HubSpotCallSyncType defines how calls are synced to HubSpot */
export enum HubSpotCallSyncType {
  /** Sync calls as deals */
  Deal = 'DEAL',
  /** Sync calls as engagement calls */
  EngagementCall = 'ENGAGEMENT_CALL',
  /** Sync calls as engagement notes */
  EngagementNote = 'ENGAGEMENT_NOTE',
  /** Sync calls as tickets */
  Ticket = 'TICKET'
}

/** HubSpotConfiguration contains configuration for the HubSpot integration */
export type HubSpotConfiguration = {
  __typename?: 'HubSpotConfiguration';
  /** Personal Access Token for HubSpot API authentication */
  accessToken: Scalars['String']['output'];
  /** Field mappings for call syncing */
  callFieldMappings?: Maybe<HubSpotCallFieldMappings>;
  /** The pipeline ID to use when syncing calls as tickets or deals */
  callPipelineId?: Maybe<Scalars['String']['output']>;
  /** The stage ID to use when syncing calls as tickets or deals */
  callStageId?: Maybe<Scalars['String']['output']>;
  /** How calls should be synced to HubSpot */
  callSyncType?: Maybe<HubSpotCallSyncType>;
  /** If enabled, will sync accounts from Cara to HubSpot */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync calls from Cara to HubSpot */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to HubSpot */
  enableSyncTasks: Scalars['Boolean']['output'];
  /** Field mappings for task syncing */
  taskFieldMappings?: Maybe<HubSpotTaskFieldMappings>;
  /** The pipeline ID to use when syncing tasks as tickets or deals */
  taskPipelineId?: Maybe<Scalars['String']['output']>;
  /** The stage ID to use when syncing tasks as tickets or deals */
  taskStageId?: Maybe<Scalars['String']['output']>;
  /** How tasks should be synced to HubSpot */
  taskSyncType?: Maybe<HubSpotTaskSyncType>;
};

/** HubSpotFieldMapping defines how a Cara field maps to a HubSpot field */
export type HubSpotFieldMapping = {
  __typename?: 'HubSpotFieldMapping';
  /** The name of the field in Cara */
  caraField: Scalars['String']['output'];
  /** The name of the field in HubSpot */
  hubspotField: Scalars['String']['output'];
};

/** HubSpotFieldMappingInput defines how a Cara field maps to a HubSpot field */
export type HubSpotFieldMappingInput = {
  /** The name of the field in Cara */
  caraField: Scalars['String']['input'];
  /** The name of the field in HubSpot */
  hubspotField: Scalars['String']['input'];
};

export type HubSpotPipeline = {
  __typename?: 'HubSpotPipeline';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  stages: Array<HubSpotPipelineStage>;
  updatedAt: Scalars['String']['output'];
};

export type HubSpotPipelineStage = {
  __typename?: 'HubSpotPipelineStage';
  archived: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

/** HubSpotTaskFieldMappings defines field mappings for task syncing */
export type HubSpotTaskFieldMappings = {
  __typename?: 'HubSpotTaskFieldMappings';
  /** Field mappings when syncing tasks as deals */
  dealFields: Array<HubSpotFieldMapping>;
  /** Field mappings when syncing tasks as tickets */
  ticketFields: Array<HubSpotFieldMapping>;
};

/** HubSpotTaskFieldMappingsInput defines field mappings for task syncing. Only one of ticketFields or dealFields should be provided, based on taskSyncType. */
export type HubSpotTaskFieldMappingsInput = {
  /** Field mappings when syncing tasks as deals. Required when taskSyncType is DEAL, must not be provided otherwise. */
  dealFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
  /** Field mappings when syncing tasks as tickets. Required when taskSyncType is TICKET, must not be provided otherwise. */
  ticketFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
};

/** HubSpotTaskSyncType defines how tasks are synced to HubSpot */
export enum HubSpotTaskSyncType {
  /** Sync tasks as deals */
  Deal = 'DEAL',
  /** Sync tasks as engagement tasks */
  EngagementTask = 'ENGAGEMENT_TASK',
  /** Sync tasks as tickets */
  Ticket = 'TICKET'
}

export type HubSpotTicketPipeline = {
  __typename?: 'HubSpotTicketPipeline';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  stages: Array<HubSpotTicketPipelineStage>;
  updatedAt: Scalars['String']['output'];
};

export type HubSpotTicketPipelineStage = {
  __typename?: 'HubSpotTicketPipelineStage';
  archived: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  ticketState: Scalars['String']['output'];
};

/** Identities that a particular user can take on. These are intrinsically determined by the system and cannot be changed by the user. */
export enum Identity {
  /** Administrator access to the API, grants the GLOBAL scope. */
  Admin = 'ADMIN',
  /** Agency client access to the API, grants the SELF scope by default, and limits access to client-only resources. */
  AgencyClient = 'AGENCY_CLIENT',
  /** Agency user access to the API, grants the ORGANIZATION scope by default, and limits access to agency-only resources. */
  AgencyUser = 'AGENCY_USER',
  /** Anonymous access to the API, grants no scope and strictly limits the user to only public resources. */
  Anonymous = 'ANONYMOUS'
}

/** Represents a reference to an image stored in the cache */
export type ImageReference = {
  __typename?: 'ImageReference';
  /** The cache key for the image */
  cacheKey: Scalars['String']['output'];
  /** The MIME type of the image */
  mimeType: Scalars['String']['output'];
  /** The size of the image in bytes */
  sizeBytes?: Maybe<Scalars['Int']['output']>;
};

/**
 * ImageRightConfiguration contains configuration for the ImageRight integration.
 * The password is stored but never exposed through the API.
 */
export type ImageRightConfiguration = {
  __typename?: 'ImageRightConfiguration';
  /**
   * ImageRight server URL. ImageRight is self-hosted per-agency, so each agency
   * provides the base URL of their own ImageRight server.
   */
  serverUrl: Scalars['String']['output'];
  /** ImageRight username for authentication */
  username: Scalars['String']['output'];
};

/** Image style */
export type ImageStyle = {
  __typename?: 'ImageStyle';
  /** Whether height should be automatically calculated */
  heightAuto: Scalars['Boolean']['output'];
  /** Maximum width as a percentage (e.g. 100.0) */
  maxWidthPct?: Maybe<Scalars['Float']['output']>;
  /** Page break behavior (e.g. 'avoid') */
  pageBreakInside?: Maybe<Scalars['String']['output']>;
};

/** Input for image style */
export type ImageStyleInput = {
  /** If true, image height is automatically calculated */
  heightAuto?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum width as a percentage of the page width (0-100) */
  maxWidthPct?: InputMaybe<Scalars['Float']['input']>;
  /** CSS page-break-inside value for images (e.g. 'avoid') */
  pageBreakInside?: InputMaybe<Scalars['String']['input']>;
};

export enum IndexingStatus {
  /** The document has been indexed */
  Completed = 'COMPLETED',
  /** The document failed to index */
  Failed = 'FAILED',
  /** The document is being indexed */
  Indexing = 'INDEXING',
  /** The document has not started indexing yet */
  Unknown = 'UNKNOWN'
}

/** Account details specific to an individual account holder */
export type IndividualAccount = AccountDetails & {
  __typename?: 'IndividualAccount';
  /** Primary email address for contacting the individual */
  email: Scalars['String']['output'];
  /** Mailing address for the individual */
  mailingAddress: Address;
  /** The full name of the individual */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the individual */
  phone: Scalars['String']['output'];
};

/** Represents an insurance carrier or broker that can provide policies */
export type InsuranceCarrier = {
  __typename?: 'InsuranceCarrier';
  /** If available, the ID of this carrier in Ascend */
  ascendId?: Maybe<Scalars['String']['output']>;
  /** Human readable short identifier of this carrier */
  id: Scalars['String']['output'];
  /** True if this insurance entity is a broker which we use to access a carrier */
  isBroker: Scalars['Boolean']['output'];
  /** True if this insurance entity is a carrier with binding authority */
  isCarrier: Scalars['Boolean']['output'];
  /** Legal name of this carrier */
  name: Scalars['String']['output'];
  /** The types of insurance policies supported by this carrier */
  supportedPolicies?: Maybe<Array<InsuranceType>>;
};

/** Describes the market the insurance policy was written in. */
export enum InsuranceMarket {
  /** The admitted market */
  Admitted = 'ADMITTED',
  /** The Excess and Surplus (E&S) market */
  ExcessAndSurplus = 'EXCESS_AND_SURPLUS'
}

/** Insurance type for business insurance */
export enum InsuranceType {
  /** Insurance coverage for accidents and health-related incidents */
  AccidentAndHealth = 'ACCIDENT_AND_HEALTH',
  /** Comprehensive coverage package for business owners */
  BusinessOwners = 'BUSINESS_OWNERS',
  /** Coverage for vehicles used in commercial operations */
  CommercialAuto = 'COMMERCIAL_AUTO',
  /** Protection against cyber risks and data breaches */
  Cyber = 'CYBER',
  /** Coverage for directors and officers against liability claims */
  DirectorsAndOfficers = 'DIRECTORS_AND_OFFICERS',
  /** Protection against employment-related claims */
  EmploymentPracticesLiability = 'EMPLOYMENT_PRACTICES_LIABILITY',
  /** Coverage for professional mistakes and oversights */
  ErrorsAndOmission = 'ERRORS_AND_OMISSION',
  /** Additional liability coverage beyond standard policies */
  Excess = 'EXCESS',
  /** Basic liability coverage for business operations */
  GeneralLiability = 'GENERAL_LIABILITY',
  /** Specialized coverage for jewelry businesses */
  JewelersBlock = 'JEWELERS_BLOCK',
  /** Other types of insurance coverage not listed */
  Other = 'OTHER',
  /** Combined package of multiple insurance coverages */
  Package = 'PACKAGE',
  /** Coverage for product-related liability claims */
  ProductLiability = 'PRODUCT_LIABILITY',
  /** Coverage for professional services liability */
  ProfessionalLiability = 'PROFESSIONAL_LIABILITY',
  /** Coverage for business property and assets */
  Property = 'PROPERTY',
  /** Insurance for rental properties or equipment */
  Rental = 'RENTAL',
  /** Coverage for goods in transit and transportation risks */
  ShippingAndTransportation = 'SHIPPING_AND_TRANSPORTATION',
  /** Umbrella liability coverage */
  Umbrella = 'UMBRELLA',
  /** Coverage for employee work-related injuries */
  WorkersCompensation = 'WORKERS_COMPENSATION'
}

/** Integration represents a connection to an external system */
export type Integration = {
  __typename?: 'Integration';
  /** The agency this integration belongs to. Resolved via a batched loader. */
  agency: Agency;
  /** Authorization credentials for the integration */
  authorization?: Maybe<IntegrationAuthorization>;
  /** Configuration for the integration */
  configuration: IntegrationConfiguration;
  /** Timestamp of when the integration was created */
  createdAt: Scalars['Time']['output'];
  /** Timestamp of when the integration was deleted, if applicable */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** Unique identifier for the integration */
  id: Scalars['ID']['output'];
  /** Timestamp of when the integration last synced data */
  lastSyncedAt?: Maybe<Scalars['Time']['output']>;
  /** Current state of the integration */
  state: IntegrationState;
  /**
   * Sync logs for the integration, ordered by startedAt descending.
   * When limit is provided, at most that many of the most recent logs are returned.
   */
  syncLogs: Array<IntegrationSyncLog>;
  /** Type of integration */
  type: IntegrationType;
  /** Timestamp of when the integration was last updated */
  updatedAt: Scalars['Time']['output'];
};


/** Integration represents a connection to an external system */
export type IntegrationSyncLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** IntegrationAuthorization contains credentials for authenticating with the integration */
export type IntegrationAuthorization = {
  __typename?: 'IntegrationAuthorization';
  /** Basic authentication credentials */
  basicAuth?: Maybe<BasicAuth>;
  /** Bearer token authentication credentials */
  bearerAuth?: Maybe<BearerAuth>;
};

/**
 * Describes all actions a given integration type supports. Surfaced to the UI
 * by the `integrationCapabilities` query so that the workflow builder can
 * render context-sensitive configuration for OUTPUT_INTEGRATION and
 * INPUT_AMS_READ tasks.
 */
export type IntegrationCapability = {
  __typename?: 'IntegrationCapability';
  /** The actions this integration supports */
  actions: Array<IntegrationCapabilityAction>;
  /** A human-readable label */
  label: Scalars['String']['output'];
  /** The integration type this capability describes */
  type: IntegrationType;
};

/**
 * A specific action a particular integration supports (e.g. "create note",
 * "upload attachment", "search accounts"). Each action carries its own JSON
 * schema describing the configuration fields the UI should render.
 */
export type IntegrationCapabilityAction = {
  __typename?: 'IntegrationCapabilityAction';
  /** JSON Schema describing the per-action configuration fields */
  configSchema: Scalars['JSON']['output'];
  /** Explains what the action does */
  description: Scalars['String']['output'];
  /** JSON Schema describing the 'what to write' / inbound payload shape */
  inputSchema?: Maybe<Scalars['JSON']['output']>;
  /** A stable identifier for the action (e.g. 'create_note') */
  key: Scalars['String']['output'];
  /** READ vs WRITE classification */
  kind: IntegrationCapabilityKind;
  /** A human-readable label */
  label: Scalars['String']['output'];
};

/** Classifies what an integration capability does */
export enum IntegrationCapabilityKind {
  /** Read records from the integration */
  Read = 'READ',
  /** Write records into the integration */
  Write = 'WRITE'
}

/** IntegrationConfiguration contains configuration for the integration */
export type IntegrationConfiguration = {
  __typename?: 'IntegrationConfiguration';
  /** Configuration for the Agency Zoom integration */
  agencyZoom?: Maybe<AgencyZoomConfiguration>;
  /** Configuration for the AMS360 integration */
  ams360?: Maybe<Ams360Configuration>;
  /** Configuration for the Applied Epic integration */
  appliedEpic?: Maybe<AppliedEpicConfiguration>;
  /** Configuration for the EZLynx integration */
  ezlynx?: Maybe<EzLynxConfiguration>;
  /** Configuration for the Hawksoft integration */
  hawksoft?: Maybe<HawksoftConfiguration>;
  /** Configuration for the HubSpot integration */
  hubspot?: Maybe<HubSpotConfiguration>;
  /** Configuration for the ImageRight integration */
  imageRight?: Maybe<ImageRightConfiguration>;
  /** Configuration for the NowCerts integration */
  nowcerts?: Maybe<NowCertsConfiguration>;
  /** Configuration for the Zapier integration */
  zapier?: Maybe<ZapierConfiguration>;
};

export type IntegrationMetadataItem = {
  __typename?: 'IntegrationMetadataItem';
  children?: Maybe<Array<IntegrationMetadataItem>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** IntegrationState defines the current state of an integration */
export enum IntegrationState {
  /** Integration is active and functioning */
  Active = 'ACTIVE',
  /** Integration has been created but not yet configured */
  Created = 'CREATED',
  /** Integration has been disabled */
  Disabled = 'DISABLED',
  /** Integration is in process of being configured */
  Pending = 'PENDING'
}

/** IntegrationSyncError defines the error that occurred during a sync operation */
export type IntegrationSyncError = {
  __typename?: 'IntegrationSyncError';
  /** The error code */
  code: IntegrationSyncErrorCode;
  /** The name of the function that caused the error */
  functionName?: Maybe<Scalars['String']['output']>;
  /** The parameters passed to the function that caused the error */
  functionParams?: Maybe<Scalars['JSON']['output']>;
  /** Any HTTP request or response that is related to the error */
  http?: Maybe<HttpRequestResponse>;
  /** The unique identifier for the error */
  id: Scalars['ID']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether the error is retryable */
  retryable: Scalars['Boolean']['output'];
  /** The timestamp of the error */
  timestamp: Scalars['Time']['output'];
};

/** IntegrationSyncErrorCode defines the code of an error that occurred during a sync operation */
export enum IntegrationSyncErrorCode {
  /** The sync operation failed due to an authentication error */
  ApiAuthError = 'API_AUTH_ERROR',
  /** The sync operation failed due to a conflict error */
  ApiConflict = 'API_CONFLICT',
  /** The sync operation failed due to a rate limit exceeded error */
  ApiRateLimitExceeded = 'API_RATE_LIMIT_EXCEEDED',
  /** The sync operation failed due to a server error */
  ApiServerError = 'API_SERVER_ERROR',
  /** The sync operation failed due to a timeout error */
  ApiTimeout = 'API_TIMEOUT',
  /** The sync operation failed due to an API error */
  ApiUnknownError = 'API_UNKNOWN_ERROR',
  /** The sync operation failed due to an internal timeout */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /** The sync operation failed due to a missing call */
  MissingCall = 'MISSING_CALL',
  /** The sync operation failed due to a not found error */
  NotFound = 'NOT_FOUND',
  /** The sync operation was superseded by a new sync operation */
  Superceded = 'SUPERCEDED',
  /** The sync operation failed due to an unknown error */
  Unknown = 'UNKNOWN',
  /** The sync operation failed because of an invalid or unsupported operation */
  UnsupportedOperation = 'UNSUPPORTED_OPERATION',
  /** The sync operation failed due to a validation error */
  ValidationError = 'VALIDATION_ERROR',
  /**
   * The sync workflow aborted before normal finalization (e.g. an activity
   * exhausted its retries and bubbled an error up). Any previously recorded
   * errors on the sync log remain in place; this code is appended by the
   * workflow's cleanup path to explain why the log was force-finalized.
   */
  WorkflowAborted = 'WORKFLOW_ABORTED'
}

/** A record of a sync operation for an integration */
export type IntegrationSyncLog = {
  __typename?: 'IntegrationSyncLog';
  /** The call that is associated with this sync operation, if any. */
  associatedCall?: Maybe<Call>;
  /** Timestamp of when the sync operation completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** Progress of the sync operation */
  entitiesSynced: Scalars['Int']['output'];
  /** The integration entities that were written during this sync operation, if any. */
  entitiesWritten: Array<KnowledgeGraphEntity>;
  /** Any errors that occurred during the sync operation. */
  errors: Array<IntegrationSyncError>;
  /** Unique identifier for the sync log */
  id: Scalars['ID']['output'];
  /** The ID of the entity that initiated the sync operation */
  initiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the sync operation */
  initiatorType: UpdateInitiatorType;
  /** The integration that this sync log is associated with */
  integration: Integration;
  /**
   * Last error message from the sync operation
   * @deprecated Use errors instead. Will be removed in a future release.
   */
  lastError?: Maybe<Scalars['String']['output']>;
  /** The service requests were being synced as part of this sync operation, if any. */
  serviceRequests: Array<ServiceRequest>;
  /** Timestamp of when the sync operation started */
  startedAt: Scalars['Time']['output'];
  /** State of the sync operation */
  state: IntegrationSyncState;
  /** The type of the sync operation */
  type: IntegrationSyncType;
};

/** A cursor-paginated connection of IntegrationSyncLog records. */
export type IntegrationSyncLogConnection = {
  __typename?: 'IntegrationSyncLogConnection';
  edges: Array<IntegrationSyncLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a paginated IntegrationSyncLog connection. */
export type IntegrationSyncLogEdge = {
  __typename?: 'IntegrationSyncLogEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationSyncLog;
};

/** Sort fields for searchIntegrationSyncLogs. Only these columns are allowed. */
export enum IntegrationSyncLogSortField {
  CompletedAt = 'COMPLETED_AT',
  Duration = 'DURATION',
  EntitiesSynced = 'ENTITIES_SYNCED',
  StartedAt = 'STARTED_AT'
}

/** Sort input for searchIntegrationSyncLogs. */
export type IntegrationSyncLogSortInput = {
  direction: SortDirection;
  field: IntegrationSyncLogSortField;
};

/** IntegrationSyncState defines the current state of a sync operation */
export enum IntegrationSyncState {
  /** Sync operation has completed */
  Completed = 'COMPLETED',
  /** Sync operation has failed */
  Failed = 'FAILED',
  /** Sync operation is in progress */
  InProgress = 'IN_PROGRESS'
}

/** IntegrationSyncType defines the type of sync operation */
export enum IntegrationSyncType {
  /** Sync operation is a read operation */
  Read = 'READ',
  /** Sync operation is a write operation */
  Write = 'WRITE'
}

/** IntegrationType defines the type of integration, including AMS, CRM, and more. */
export enum IntegrationType {
  /** AMS360 agency management system integration */
  Ams_360 = 'AMS_360',
  /** Applied Epic agency management system integration */
  AmsAppliedEpic = 'AMS_APPLIED_EPIC',
  /** EZLynx agency management system integration */
  AmsEzlynx = 'AMS_EZLYNX',
  /** Hawksoft agency management system integration */
  AmsHawksoft = 'AMS_HAWKSOFT',
  /** ImageRight document management system integration. Requires an active AMS360 integration. */
  AmsImageright = 'AMS_IMAGERIGHT',
  /** NowCerts agency management system integration */
  AmsNowcerts = 'AMS_NOWCERTS',
  /** Agency Zoom CRM integration */
  CrmAgencyZoom = 'CRM_AGENCY_ZOOM',
  /** HubSpot CRM integration */
  CrmHubspot = 'CRM_HUBSPOT',
  /** Zapier integration */
  Zapier = 'ZAPIER'
}

/**
 * Filter input for the integrations query.
 *
 * In agency/organization scope, the resolver overrides agencyId with the caller's
 * principal organization ID — other values of agencyId are ignored to prevent scope
 * escape. In global (admin) scope, agencyId is honored if set and otherwise omitted.
 */
export type IntegrationsFilterInput = {
  /** Restrict to integrations for this agency. Honored in global scope; overridden in org scope. */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Only integrations with at least one sync log in state FAILED in the last 24 hours. */
  hasRecentErrors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only integrations whose lastSyncedAt is strictly after this timestamp. */
  lastSyncedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only integrations whose lastSyncedAt is strictly before this timestamp. */
  lastSyncedBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Case-insensitive match against agency name and integration ID. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to integrations in this state. */
  state?: InputMaybe<IntegrationState>;
  /** Restrict to integrations of this type. */
  type?: InputMaybe<IntegrationType>;
};

export type KnowledgeBase = {
  __typename?: 'KnowledgeBase';
  /**
   * List of agencies that have been granted access to this knowledge base.
   * Only visible to the owner agency.
   */
  accessList: Array<KnowledgeBaseAccess>;
  /** The timestamp when this knowledge base was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp when this knowledge base was deleted, if it was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The documents in this knowledge base */
  documents: Array<KnowledgeBaseDocument>;
  /**
   * Cosmetic folders used to organize documents in this knowledge base.
   * Folders do not affect retrieval or indexing.
   */
  folders: Array<KnowledgeBaseFolder>;
  /**
   * Enables owner-configured priority content matching for documents in this
   * knowledge base.
   */
  guidedRetrievalEnabled: Scalars['Boolean']['output'];
  /** The unique identifier for this knowledge base */
  id: Scalars['ID']['output'];
  /**
   * Whether this knowledge base is owned by the current user's agency.
   * If false, the KB is shared with the current agency.
   * Note: For ADMIN identities, this is always false (admins don't own KBs).
   */
  isOwner: Scalars['Boolean']['output'];
  /**
   * The current user's agency's access role for this knowledge base.
   * Null if the current agency owns this KB (use isOwner instead).
   * Note: For ADMIN identities, this is always null (admins have implicit global access).
   */
  myAccess?: Maybe<KnowledgeBaseAccess>;
  /**
   * The agency that owns this knowledge base (for shared KBs).
   * No auth directive - if you can see the KB, you can see basic owner info.
   */
  ownerAgency?: Maybe<Agency>;
  /** The title of this knowledge base */
  title: Scalars['String']['output'];
  /** The timestamp when this knowledge base was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of the knowledge base schema */
  version: KnowledgeBaseVersion;
};

/** Access control for agencies to knowledge bases */
export type KnowledgeBaseAccess = {
  __typename?: 'KnowledgeBaseAccess';
  /**
   * The agency that has been granted access.
   * No auth directive - access is already controlled at the KnowledgeBase.accessList level
   * (only owners can see the access list).
   */
  agency: Agency;
  /** The timestamp when this access was granted */
  createdAt: Scalars['Time']['output'];
  /** The role this agency has for the knowledge base */
  role: KnowledgeBaseAccessRole;
  /** The timestamp when this access was last updated */
  updatedAt: Scalars['Time']['output'];
};

/**
 * The role an agency has for accessing a shared knowledge base.
 * Note: Ownership is determined by knowledge_base.agency_id, not this table.
 */
export enum KnowledgeBaseAccessRole {
  /** The agency can read and upload documents to this knowledge base */
  Contributor = 'CONTRIBUTOR',
  /** The agency can only read from this knowledge base */
  Viewer = 'VIEWER'
}

/** A document that is part of a knowledge base */
export type KnowledgeBaseDocument = {
  __typename?: 'KnowledgeBaseDocument';
  /**
   * Instructions for how the information in this document should be used when
   * answering questions (max 500 characters). Shown to the AI alongside the
   * document content.
   */
  contextNote?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this document was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this document */
  createdBy: AgencyUser;
  /** The timestamp when this document was deleted, if it was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The description of this document */
  description: Scalars['String']['output'];
  /**
   * Preferred user-facing name for FILE documents in the knowledge base UI and
   * when Cara refers to the document. Does not alter indexed content, embeddings,
   * or semantic content retrieval. Only populated for FILE documents.
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * The ID that groups all versions of this document together.
   * For the first version, this equals the document's own ID.
   * Note: String (not ID) because multiple documents share this value.
   */
  documentGroupId: Scalars['String']['output'];
  /**
   * Example user questions that should cause Cara to include this document as
   * priority content (max 500 characters).
   */
  exampleQuestions?: Maybe<Scalars['String']['output']>;
  /** The file underlying a FILE-type document in the knowledge base */
  file?: Maybe<KnowledgeBaseDocumentFile>;
  /** The cosmetic folder containing this document. Null or empty means root. */
  folderId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for this document */
  id: Scalars['ID']['output'];
  /** The status of the document indexing */
  indexingStatus: KnowledgeBaseDocumentIndexingStatus;
  /** The metadata of the document if it has been generated */
  metadata?: Maybe<KnowledgeBaseDocumentMetadata>;
  /** The data underlying a TEXT-type document in the knowledge base */
  text?: Maybe<KnowledgeBaseDocumentText>;
  /** The title of this document */
  title: Scalars['String']['output'];
  /** The type of document in this knowledge base */
  type: KnowledgeBaseDocumentType;
  /** The timestamp when this document was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Error from the most recent failed sync, derived from sync logs.
   * Only populated when type is URL and last sync failed.
   */
  urlLastSyncError?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp of the last successful sync, derived from sync logs.
   * Only populated when type is URL.
   */
  urlLastSyncedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Configuration for URL-sourced documents.
   * Only populated when type is URL.
   */
  urlSource?: Maybe<KnowledgeBaseDocumentUrlSource>;
  /**
   * Sync logs for URL-sourced documents.
   * Only populated when type is URL. Returns most recent syncs first.
   */
  urlSyncLogs: Array<UrlDocumentSyncLog>;
  /**
   * Current sync status derived from the latest sync log.
   * Only populated when type is URL.
   */
  urlSyncStatus?: Maybe<UrlDocumentSyncState>;
  /** All versions of this document, ordered by version number descending (newest first). */
  versionHistory: Array<KnowledgeBaseDocument>;
  /** The version number of this document (1, 2, 3, etc.) */
  versionNumber: Scalars['Int']['output'];
};

/** An embedding of a document in the knowledge base */
export type KnowledgeBaseDocumentEmbedding = {
  __typename?: 'KnowledgeBaseDocumentEmbedding';
  /**
   * Block types contained in this chunk (V2 only).
   * Values like "Table", "Text", "Section Header", etc. from Reducto.
   */
  blockTypes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Claude-generated context preamble for contextual retrieval (V2 only).
   * Situates the chunk within the overall document.
   */
  chunkContext?: Maybe<Scalars['String']['output']>;
  /** The data underlying this chunk */
  chunkData: Scalars['String']['output'];
  /**
   * Combined content for embedding and BM25 search (V2 only).
   * Contains context preamble + chunk content. This is what gets embedded.
   */
  chunkEmbedContent?: Maybe<Scalars['String']['output']>;
  /** The hash of the chunk */
  chunkHash: Scalars['String']['output'];
  /** The end position of the chunk in the document */
  chunkPosEnd: Scalars['Int']['output'];
  /** The start position of the chunk in the document */
  chunkPosStart: Scalars['Int']['output'];
  /** The sequence number of the chunk in the document */
  chunkSeq: Scalars['Int']['output'];
  /** The timestamp when this chunk was created */
  createdAt: Scalars['Time']['output'];
  /** The embedding of the chunk */
  embedding?: Maybe<Array<Scalars['Float']['output']>>;
  /**
   * MIME type of the source document (V2 only).
   * E.g., "application/pdf", "text/plain"
   */
  fileType?: Maybe<Scalars['String']['output']>;
  /** The metadata of the chunk */
  metadata?: Maybe<KnowledgeBaseDocumentMetadata>;
  /** The name of the embedding model used */
  modelName: Scalars['String']['output'];
  /** The revision of the embedding model used */
  modelRevision: Scalars['String']['output'];
  /**
   * Page numbers from the source document that this chunk spans (V2 only).
   * Derived from Reducto BBox.Page data.
   */
  pageNumbers?: Maybe<Array<Scalars['Int']['output']>>;
  /** The timestamp when this chunk was updated */
  updatedAt: Scalars['Time']['output'];
};

/** File metadata underlying a FILE-type document in the knowledge base */
export type KnowledgeBaseDocumentFile = {
  __typename?: 'KnowledgeBaseDocumentFile';
  /** The timestamp this file was created */
  createdAt: Scalars['Time']['output'];
  /** The SHA256 hash of the file bytes */
  hash: Scalars['String']['output'];
  /** The MIME type of the uploaded file */
  mimeType: Scalars['String']['output'];
  /** The name of the uploaded file */
  name: Scalars['String']['output'];
  /** The size of the uploaded file in bytes */
  size: Scalars['Int']['output'];
  /** The public URL to fetch the file, if the file is visible to the user */
  url?: Maybe<Scalars['String']['output']>;
};

/** The status of the document indexing */
export type KnowledgeBaseDocumentIndexingStatus = {
  __typename?: 'KnowledgeBaseDocumentIndexingStatus';
  /** The timestamp when the indexing was completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** The error that occurred during the indexing, if any */
  error?: Maybe<Scalars['String']['output']>;
  /** The progress of the indexing */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the indexing was started */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The status of the indexing */
  status: IndexingStatus;
};

/** The metadata of a document in the knowledge base */
export type KnowledgeBaseDocumentMetadata = {
  __typename?: 'KnowledgeBaseDocumentMetadata';
  /** The keywords of the document (V1 format - flat list) */
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Structured keywords organized by category (V2 format).
   * Only populated for V2 knowledge bases.
   */
  keywordsStructured?: Maybe<KnowledgeBaseKeywords>;
  /** The purpose of the document */
  purpose: Scalars['String']['output'];
  /** The summary of the document */
  summary: Scalars['String']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/** Content underlying a TEXT-type document in the knowledge base */
export type KnowledgeBaseDocumentText = {
  __typename?: 'KnowledgeBaseDocumentText';
  /** The content of this document */
  content: Scalars['String']['output'];
};

/** The type of document in a knowledge base */
export enum KnowledgeBaseDocumentType {
  /** A file that was uploaded into the knowledge base */
  File = 'FILE',
  /** A document that was written as part of the knowledge base */
  Text = 'TEXT',
  /** A document sourced from a URL (either downloaded or captured as screenshot) */
  Url = 'URL'
}

/**
 * Configuration for a URL-sourced document.
 * Sync state (status, lastSyncedAt, errors) is derived from urlSyncLogs on KnowledgeBaseDocument.
 */
export type KnowledgeBaseDocumentUrlSource = {
  __typename?: 'KnowledgeBaseDocumentURLSource';
  /** How often to sync the content */
  frequency: UrlMonitorFrequency;
  /** Whether automatic syncing is paused */
  isPaused: Scalars['Boolean']['output'];
  /** How to fetch the content (download vs screenshot) */
  sourceType: UrlSourceType;
  /** The URL to fetch content from */
  url: Scalars['String']['output'];
};

/** Cosmetic folder metadata for organizing knowledge base documents. */
export type KnowledgeBaseFolder = {
  __typename?: 'KnowledgeBaseFolder';
  /** The timestamp when this folder was created */
  createdAt: Scalars['Time']['output'];
  /** The unique identifier for this folder */
  id: Scalars['ID']['output'];
  /** The display name of this folder */
  name: Scalars['String']['output'];
  /** The parent folder ID. Null means this folder is at the root. */
  parentFolderId?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this folder was last updated */
  updatedAt: Scalars['Time']['output'];
};

/**
 * Structured keywords organized by category for V2 knowledge bases.
 * Used for filtering and organization in the UI.
 */
export type KnowledgeBaseKeywords = {
  __typename?: 'KnowledgeBaseKeywords';
  /** Insurance carriers mentioned in the document */
  carrier?: Maybe<Array<Scalars['String']['output']>>;
  /** Document type (e.g., Appetite guide, Application, Underwriting guidelines) */
  documentType?: Maybe<Array<Scalars['String']['output']>>;
  /** Industries mentioned (e.g., Construction, Manufacturing, Restaurant) */
  industry?: Maybe<Array<Scalars['String']['output']>>;
  /** Lines of business (e.g., Workers Comp, General Liability, Commercial Auto) */
  lineOfBusiness?: Maybe<Array<Scalars['String']['output']>>;
  /** US states mentioned (2-letter codes like CA, NY, TX) */
  state?: Maybe<Array<Scalars['String']['output']>>;
  /** Other important keywords that don't fit into the above categories */
  uncategorized?: Maybe<Array<Scalars['String']['output']>>;
};

/** The version of the knowledge base schema */
export enum KnowledgeBaseVersion {
  /** Version 2 of the knowledge base */
  V2 = 'V2'
}

/** KnowledgeGraphEntity represents an entity in the knowledge graph */
export type KnowledgeGraphEntity = {
  __typename?: 'KnowledgeGraphEntity';
  /** The timestamp of when the entity was created */
  createdAt: Scalars['Time']['output'];
  /** The display name of the entity (like full name, company name, ticket title, etc.) */
  displayName: Scalars['String']['output'];
  /** The ID of the entity in the external system */
  externalId: Scalars['String']['output'];
  /** Unique identifier for the entity */
  id: Scalars['ID']['output'];
  /** The integration this entity is associated with */
  integration: Integration;
  /** The ID of the entity in the internal system */
  internalId: Scalars['String']['output'];
  /** The timestamp of when the entity was last modified */
  modifiedAt: Scalars['Time']['output'];
  /** The properties of the entity as a JSON object */
  properties: Scalars['JSON']['output'];
  /** Entities related to this entity (used by the explorer) */
  relatedEntities: Array<KnowledgeGraphRelatedEntity>;
  /** The search metadata of the entity */
  searchMetadata: KnowledgeGraphEntitySearchMetadata;
  /** The secondary information of the entity (like email, status, etc.) */
  secondaryInfo?: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the entity was last synced */
  syncedAt: Scalars['Time']['output'];
  /** The type of entity */
  type: KnowledgeGraphEntityType;
  /** The timestamp of when the entity was last modified */
  updatedAt: Scalars['Time']['output'];
};

export enum KnowledgeGraphEntityAccountType {
  /** The account is a business */
  Business = 'BUSINESS',
  /** The account is an individual */
  Individual = 'INDIVIDUAL'
}

/** KnowledgeGraphEntityConnection holds a page of knowledge graph entities */
export type KnowledgeGraphEntityConnection = {
  __typename?: 'KnowledgeGraphEntityConnection';
  /** The entities in this page */
  nodes: Array<KnowledgeGraphEntity>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Total count of matching entities */
  totalCount: Scalars['Int']['output'];
};

/** KnowledgeGraphEntityFilter is used to filter knowledge graph entities in the explorer */
export type KnowledgeGraphEntityFilter = {
  /** Cursor for pagination */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Required: the agency whose entities to browse */
  agencyId: Scalars['ID']['input'];
  /** Restrict to entities of this type */
  entityType?: InputMaybe<KnowledgeGraphEntityType>;
  /** Fetch a single entity by its internal KG ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Restrict to entities from this specific integration */
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  /** Maximum number of entities to return (default 50) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Full-text search against entity name / description */
  query?: InputMaybe<Scalars['String']['input']>;
};

/**
 * KnowledgeGraphEntitySearchMetadata represents the search metadata of the entity. It can be used to store
 * structured data that can be used to search for the entity. The metadata that is stored depends on the
 * type of the entity.
 */
export type KnowledgeGraphEntitySearchMetadata = {
  __typename?: 'KnowledgeGraphEntitySearchMetadata';
  /** The account metadata of the entity */
  account?: Maybe<KnowledgeGraphEntitySearchMetadataAccount>;
  /** The call log metadata of the entity */
  call?: Maybe<KnowledgeGraphEntitySearchMetadataCall>;
  /** The contact metadata of the entity */
  contact?: Maybe<KnowledgeGraphEntitySearchMetadataContact>;
  /**
   * The FEIN (Federal Employer Identification Number) of the entity. Typically
   * populated on commercial account entities and, for AppliedEpic, on policy
   * entities whose commercial application carries a FirstNamedInsuredFEIN.
   */
  fein?: Maybe<Scalars['String']['output']>;
  /** The file metadata of the entity */
  file?: Maybe<KnowledgeGraphEntitySearchMetadataFile>;
  /** The note metadata of the entity */
  note?: Maybe<KnowledgeGraphEntitySearchMetadataNote>;
  /** The policy metadata of the entity */
  policy?: Maybe<KnowledgeGraphEntitySearchMetadataPolicy>;
  /**
   * The SSN (Social Security Number) of the entity. Typically populated on
   * personal account entities and, for AppliedEpic, on policy entities whose
   * commercial application carries a FirstNamedInsuredSocialSecurityNumber.
   */
  ssn?: Maybe<Scalars['String']['output']>;
  /** The task metadata of the entity */
  task?: Maybe<KnowledgeGraphEntitySearchMetadataTask>;
};

/** KnowledgeGraphEntitySearchMetadataAccount represents the account metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataAccount = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataAccount';
  /** The type of the account */
  dba?: Maybe<Scalars['String']['output']>;
  /** The email of the account */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * The integration-assigned short code for the account (e.g. AppliedEpic
   * LookupCode). Unique within an agency; commonly used by AMS users to
   * disambiguate accounts that share an email or phone number.
   */
  lookupCode?: Maybe<Scalars['String']['output']>;
  /** The address of the account */
  mailingAddress?: Maybe<Address>;
  /** The NAICS code of the account */
  naics?: Maybe<Scalars['String']['output']>;
  /** The name of the account */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the account */
  phone?: Maybe<Scalars['String']['output']>;
  /** The type of the account */
  type?: Maybe<KnowledgeGraphEntityAccountType>;
  /** The website of the account */
  website?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataCall represents the call metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataCall = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataCall';
  /** The action taken during the call */
  action?: Maybe<Scalars['String']['output']>;
  /** The name of the caller */
  fromName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call is from */
  fromNumber?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the call */
  id: Scalars['String']['output'];
  /** The result of the call */
  result?: Maybe<Scalars['String']['output']>;
  /** The start date and time of the call */
  startDate?: Maybe<Scalars['Time']['output']>;
  /** The name of the recipient */
  toName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call is to */
  toNumber?: Maybe<Scalars['String']['output']>;
  /** The type of the call (e.g., inbound, outbound) */
  type?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataContact represents the contact metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataContact = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataContact';
  /** The email of the contact */
  email?: Maybe<Scalars['String']['output']>;
  /** The name of the contact */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the contact */
  phone?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataFile represents the file metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataFile = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataFile';
  /** The creation date of the file */
  createdAt?: Maybe<Scalars['Time']['output']>;
  /** The creator of the file */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The download URL of the file */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The expiration date of the download URL */
  downloadUrlExpiresAt?: Maybe<Scalars['Time']['output']>;
  /** The ID of the folder that the file is in */
  folderId?: Maybe<Scalars['String']['output']>;
  /** The name of the folder that the file is in */
  folderName?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The name of the file */
  name?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataNote represents the note metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataNote = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataNote';
  /** The create date of the note */
  createDate?: Maybe<Scalars['Time']['output']>;
  /** The created by of the note */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The subject of the note */
  subject?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataPolicy represents the policy metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataPolicy = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataPolicy';
  /** Whether the policy is currently active/in-force */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the insurance carrier (e.g. "State Farm", "Progressive") */
  carrier?: Maybe<Scalars['String']['output']>;
  /** The expiration date of the policy */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /** The inforce date of the policy */
  inforceAt?: Maybe<Scalars['Time']['output']>;
  /** The policy number of the entity */
  policyNumber?: Maybe<Scalars['String']['output']>;
  /** The total premium amount for the policy */
  premium?: Maybe<Scalars['Float']['output']>;
  /** The status of the policy as reported by the AMS (e.g. "Active", "Cancelled", "Expired") */
  status?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataTask represents the task metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataTask = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataTask';
  /** The description of the task */
  description?: Maybe<Scalars['String']['output']>;
  /** The title of the task */
  title?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntityType represents the type of entity in the knowledge graph */
export enum KnowledgeGraphEntityType {
  /** The entity represents a client or an account */
  Account = 'ACCOUNT',
  /** The entity represents an activity, or a log of something that happened */
  Activity = 'ACTIVITY',
  /** The entity represents a call with a client */
  Call = 'CALL',
  /** The entity represents a certificate of insurance issued by the agency */
  Certificate = 'CERTIFICATE',
  /** The entity represents an insurance claim, or a loss reported against a policy */
  Claim = 'CLAIM',
  /** The entity represents a contact or individual */
  Contact = 'CONTACT',
  /** The entity represents an email sent to or received from a client */
  Email = 'EMAIL',
  /** The entity represents a file */
  File = 'FILE',
  /** The entity represents a note left by a user */
  Note = 'NOTE',
  /** The entity represents a policy */
  Policy = 'POLICY',
  /** The entity represents an SMS sent to or received from a client */
  Sms = 'SMS',
  /** The entity represents a ticket or issue */
  Ticket = 'TICKET'
}

/** KnowledgeGraphRelatedEntity represents a related entity in the knowledge graph */
export type KnowledgeGraphRelatedEntity = {
  __typename?: 'KnowledgeGraphRelatedEntity';
  /** The related entity */
  entity: KnowledgeGraphEntity;
  /** The type of relationship between the entities */
  relationshipType: Scalars['String']['output'];
};

/** Type of liability coverage for a policy */
export enum LiabilityCoverageType {
  /** Claims-made coverage applies to claims made during the policy period */
  ClaimsMade = 'CLAIMS_MADE',
  /** Occurrence coverage applies to incidents that occur during the policy period */
  Occurrence = 'OCCURRENCE'
}

/** Link style */
export type LinkStyle = {
  __typename?: 'LinkStyle';
  /** Text color in hex format (e.g. '#475569') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Text decoration (e.g. 'none', 'underline') */
  textDecoration?: Maybe<Scalars['String']['output']>;
};

/** Input for link style */
export type LinkStyleInput = {
  /** Link text color as a CSS hex string */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** CSS text-decoration value (e.g. 'underline', 'none') */
  textDecoration?: InputMaybe<Scalars['String']['input']>;
};

export type ListClientDocumentsTool = {
  __typename?: 'ListClientDocumentsTool';
  input: ListClientDocumentsToolInput;
  output?: Maybe<ListClientDocumentsToolOutput>;
};

export type ListClientDocumentsToolInput = {
  __typename?: 'ListClientDocumentsToolInput';
  /** The client id, as returned by SEARCH_CLIENTS. */
  clientId: Scalars['String']['output'];
  /** Restrict to one kind of document. */
  kind?: Maybe<Scalars['String']['output']>;
  /** Cap on documents returned per kind. Defaults to 25 when omitted. */
  limit?: Maybe<Scalars['Int']['output']>;
};

export type ListClientDocumentsToolOutput = {
  __typename?: 'ListClientDocumentsToolOutput';
  /**
   * Documents Cara generated for this client, newest first. Each is the latest
   * version of its artifact.
   */
  artifacts: Array<ClientToolArtifact>;
  /** Files uploaded against this client, newest first. */
  files: Array<ClientToolFile>;
  /**
   * True when either list was cut off by the limit, so older documents exist that
   * are not shown.
   */
  truncated: Scalars['Boolean']['output'];
};

/** Represents a tool for looking up integration metadata such as employee lists / pipeline IDs / lead sources. */
export type ListIntegrationObjectsTool = {
  __typename?: 'ListIntegrationObjectsTool';
  input: ListIntegrationObjectsToolInput;
  output: ListIntegrationObjectsToolOutput;
};

export type ListIntegrationObjectsToolInput = {
  __typename?: 'ListIntegrationObjectsToolInput';
  category: Scalars['String']['output'];
  integration: Scalars['String']['output'];
  query?: Maybe<Scalars['String']['output']>;
};

export type ListIntegrationObjectsToolOutput = {
  __typename?: 'ListIntegrationObjectsToolOutput';
  items: Array<IntegrationMetadataItem>;
  success: Scalars['Boolean']['output'];
};

/**
 * Represents a tool that lists the mailboxes the agent may send email from. It
 * takes no arguments, so it carries no input: the mailboxes are the workspace
 * user's, and a filter the model could pass would only be a filter it could get
 * wrong.
 */
export type ListMailboxesTool = {
  __typename?: 'ListMailboxesTool';
  /** The mailboxes the agent may send as */
  output: ListMailboxesToolOutput;
};

/**
 * One mailbox as the model sees it. The provider, the grant, and the folder map
 * are all absent on purpose: a field the model can see is a field it will quote
 * back to the agent.
 */
export type ListMailboxesToolMailbox = {
  __typename?: 'ListMailboxesToolMailbox';
  /** The name the address shows, when the provider reports one */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The address mail from this mailbox comes from */
  email: Scalars['String']['output'];
  /** The ID to pass as mailboxAccountId to DRAFT_EMAIL */
  mailboxAccountId: Scalars['String']['output'];
  /**
   * Whether the agent connected this mailbox themselves or is one of the people
   * it is shared with
   */
  ownership: ListMailboxesToolOwnership;
  /** Whether the mailbox can be written to, or has to be reconnected first */
  status: MailboxAccountStatus;
};

/** Result of a ListMailboxesTool operation. */
export type ListMailboxesToolOutput = {
  __typename?: 'ListMailboxesToolOutput';
  /** Every mailbox the agent may send as, connected or not */
  mailboxes: Array<ListMailboxesToolMailbox>;
};

/**
 * Whose address a listed mailbox is. Sharing does not move ownership, so this is
 * the difference between the agent's own address and a colleague's or a team's.
 */
export enum ListMailboxesToolOwnership {
  Own = 'OWN',
  Shared = 'SHARED'
}

/** List style */
export type ListStyle = {
  __typename?: 'ListStyle';
  /** List item bottom margin in em units (e.g. 0.3) */
  itemMarginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Bottom margin in em units (e.g. 1.0) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Left margin in em units (e.g. 1.5) */
  marginLeftEm?: Maybe<Scalars['Float']['output']>;
};

/** Input for list style */
export type ListStyleInput = {
  /** Bottom margin for each list item in em units */
  itemMarginBottomEm?: InputMaybe<Scalars['Float']['input']>;
  /** Bottom margin after the list in em units */
  marginBottomEm?: InputMaybe<Scalars['Float']['input']>;
  /** Left margin for lists in em units */
  marginLeftEm?: InputMaybe<Scalars['Float']['input']>;
};

/** A correlated log line captured during a trace. */
export type LogRecord = {
  __typename?: 'LogRecord';
  /** Structured log fields (zap fields serialized to JSON). */
  attributes: Scalars['JSON']['output'];
  /** OTel log ID. */
  id: Scalars['ID']['output'];
  /** Log message. */
  message: Scalars['String']['output'];
  /** OTel log severity. */
  severity: LogSeverity;
  /** When the log was emitted. */
  timestamp: Scalars['Time']['output'];
  /** Workspace this log is associated with, if any. */
  workspace?: Maybe<CaraWorkspace>;
};

export type LogRecordConnection = {
  __typename?: 'LogRecordConnection';
  edges: Array<LogRecordEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LogRecordEdge = {
  __typename?: 'LogRecordEdge';
  cursor: Scalars['String']['output'];
  node: LogRecord;
};

/** Severity of a correlated log record. */
export enum LogSeverity {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

/**
 * A connected mailbox as the product API exposes it. Credentials, the
 * optimistic-concurrency version, and the sync cursor stay on the persist
 * row — they are not queryable.
 */
export type MailboxAccount = {
  __typename?: 'MailboxAccount';
  /**
   * The mailbox's folders, read from the provider on request: names change and
   * user-created folders come and go, so they are never served from the stored
   * row.
   *
   * Readable only by someone who may send as this mailbox — its owner, or a
   * person or team it was shared with.
   */
  folders: Array<MailboxFolder>;
  id: Scalars['ID']['output'];
  identity: MailboxIdentity;
  /**
   * Preselected in the composer for its owner. At most one mailbox per owner is
   * the default.
   *
   * Answered for the caller rather than from the row: sharing does not move
   * ownership, so a colleague's default is their preference and reads as false
   * here. Only the owner may set it.
   */
  isDefault: Scalars['Boolean']['output'];
  owner: MailboxOwner;
  provider: MailboxProvider;
  status: MailboxAccountStatus;
  /**
   * Who may send as this mailbox, on top of the owner, who always may. PRIVATE
   * is a personal mailbox; SHARED names the users and teams that may send from
   * it. PUBLIC is the agency-wide address (support@, hello@): everyone in the
   * agency may send as it, including people hired after the grant. The default
   * is PRIVATE — PUBLIC is a deliberate share, not an omitted one.
   *
   * Only the owner may change this, so a client should offer the editor only
   * when owner.agencyUserId is the signed-in user.
   */
  visibility: VisibilityConfig;
};

/**
 * Connection health of a connected mailbox. Closed set so a persisted row
 * cannot carry an unregistered value.
 */
export enum MailboxAccountStatus {
  /** The grant is usable. The runtime may refresh tokens behind the scenes. */
  Connected = 'CONNECTED',
  /**
   * The grant is dead (revoked, or persist failed after a token rotation).
   * The mailbox is unusable until the owner reconnects.
   */
  NeedsReconnect = 'NEEDS_RECONNECT'
}

/**
 * The ceilings a composer should refuse against before it sends anything to the
 * server. Published rather than copied into a client bundle, because a copied
 * number goes on refusing at the old value for as long as that bundle is loaded
 * in someone's tab. The server enforces each of these again on the write.
 */
export type MailboxComposeLimits = {
  __typename?: 'MailboxComposeLimits';
  /**
   * The largest total of attachment bytes the server will accept on one email.
   * The same number send and draft-write refuse against (`InternalAttachmentLimit`),
   * published so a composer can stop an oversized file before it is uploaded.
   */
  attachmentBytes: Scalars['Int']['output'];
  /**
   * The largest email body, in bytes of HTML, the server will accept. Pasted
   * images live in the body as base64 data: URIs, so this is what a screenshot
   * pasted into a draft is measured against, and it is the ceiling a body of them
   * reaches long before the attachment ceiling.
   */
  bodyBytes: Scalars['Int']['output'];
};

/**
 * A draft Cara wrote into a connected mailbox, as the product API exposes it.
 * The draft itself lives in the provider and the provider stays the source of
 * truth, so what is queryable here is what Cara stamped when it created the draft plus what
 * Cara has since done to it — never a guess at the mailbox's current contents.
 */
export type MailboxDraft = {
  __typename?: 'MailboxDraft';
  artifactVersion: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  /**
   * Who asked Cara for the email. Null once that user is offboarded; the draft
   * record stays.
   */
  createdByUserId?: Maybe<Scalars['String']['output']>;
  /**
   * The address the draft is sitting under, denormalized from the mailbox so a
   * reader can tell whose Drafts folder holds it without a second query.
   */
  fromAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * The mailbox holding the draft. The row is deleted with the account, so this
   * always names a mailbox that exists — unlike the retained IDs on OutboundEmail
   * and MailboxEvent.
   */
  mailboxAccountId: Scalars['String']['output'];
  /**
   * When the provider stopped holding the draft. Non-null makes the row a record
   * of a draft rather than a draft: nothing is waiting in the Drafts folder any
   * more.
   */
  retiredAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Why the mailbox stopped holding it: sent_via_cara, sent_externally,
   * deleted_externally, vanished, superseded, or retracted. Empty while it is
   * live. Open text for the same reason MailboxEvent.reason is — a new way for a
   * draft to leave should not need a migration.
   *
   * The three an agent's own mail client produces each say what was found, and
   * none of them is a guess. `sent_externally` is written with a copy in hand that
   * the mailbox no longer calls a draft, which is the one thing that proves a
   * send. `deleted_externally` is written with the draft found in the mailbox's
   * trash, so it is a deletion rather than a word for one. `vanished` is the
   * residual, and the only one resting on an absence: nothing carrying this
   * Message-ID is reachable in the mailbox at all, which a purge, a Message-ID the
   * provider never reported, and a copy the search cannot see produce alike.
   *
   * `retiredAt` is when Cara noticed, not when the mail went out. The send time is
   * on the `OutboundEmail` for this artifact, whose `sentExternally` marks the
   * same event from the send log's side.
   */
  retiredReason: Scalars['String']['output'];
  /**
   * Set only when the send went through Cara. An agent who pressed send in their
   * own client sent mail Cara never saw go, and this stays null.
   */
  sentViaCaraAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The subject of the artifact version the mailbox copy was written from, rather
   * than of the draft as it stands: an agent who retitled the draft in Outlook
   * changed something Cara cannot see, and reporting what Cara handed over is the
   * honest answer.
   */
  subject: Scalars['String']['output'];
  /**
   * Whether the copy in the mailbox still carries what the EMAIL artifact says,
   * answered against the artifact as it stands right now rather than as it stood
   * when the draft was written. A composer disables its "update the draft" button
   * on IN_SYNC and enables it on everything else; the other three each want
   * different wording, which is why this is not a boolean.
   *
   * Only IN_SYNC is a promise, and only about Cara's side of the exchange: an
   * agent who retitled or rewrote the draft in their own mail client changed
   * something Cara cannot see, and no value here reflects it.
   */
  syncState: MailboxDraftSyncState;
  updatedAt: Scalars['Time']['output'];
  /**
   * Opens the draft in the provider's own client. Empty when the provider handed
   * back no link, and stale once retiredAt is set, because what it addresses is
   * the provider's copy.
   */
  webLink: Scalars['String']['output'];
  /**
   * The EMAIL artifact the draft was written from, and the version the mailbox
   * copy holds. A version behind the artifact's own means the copy in the mailbox
   * is stale.
   */
  workspaceArtifactId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type MailboxDraftConnection = {
  __typename?: 'MailboxDraftConnection';
  edges: Array<MailboxDraftEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MailboxDraftEdge = {
  __typename?: 'MailboxDraftEdge';
  cursor: Scalars['String']['output'];
  node: MailboxDraft;
};

/**
 * What checking one parked draft against its mailbox came to.
 *
 * The first five are conclusions: the mailbox was asked and the ledger now agrees
 * with what it holds. `UNREACHABLE`, `MAILBOX_DISCONNECTED` and `NOT_REACHED` are
 * not conclusions, and none may be rendered as `UNCHANGED` even though all four
 * leave the row as it was: one means the draft is still sitting in the Drafts
 * folder, the others mean nobody got an answer, and those rows are worth asking
 * about again — once the mailbox is reconnected, where that is what stopped it.
 */
export enum MailboxDraftReconciliation {
  /**
   * A send Cara owns is in flight over this artifact version, so the sent copy in
   * the mailbox is that send's doing rather than anyone's hand. The draft is left
   * for the send path to retire.
   */
  Deferred = 'DEFERRED',
  /**
   * The draft is no longer somewhere it can be sent from, and nothing says it was.
   * Retired as `deleted_externally` where the mailbox is holding it in the trash,
   * and as `vanished` where nothing carrying its Message-ID could be found at all
   * — see `MailboxDraft.retiredReason`.
   *
   * A draft the agent merely moved to another folder is not this: it comes back
   * `UNCHANGED`, with the row re-pointed at where the mailbox now keeps it.
   */
  GoneUnproven = 'GONE_UNPROVEN',
  /**
   * The mailbox cannot be asked and syncing again will not get further: the
   * connection is dead, was never consented to, carries no scope for this read, or
   * has no mail account behind it. The row stands as it was — the draft is still in
   * the Drafts folder as far as anyone knows — and reconnecting the mailbox is what
   * makes it answerable again.
   */
  MailboxDisconnected = 'MAILBOX_DISCONNECTED',
  /**
   * The sync ran out of time before this draft's turn, so nothing was asked about
   * it. Syncing again is what settles it.
   */
  NotReached = 'NOT_REACHED',
  /**
   * The mailbox holds a sent copy of the mail Cara drafted, so the agent sent it
   * from their own client. The draft is retired and the send is now on the
   * outbound log marked `sentExternally`.
   */
  SentExternally = 'SENT_EXTERNALLY',
  /**
   * The mailbox holds a sent copy of mail Cara itself put on the wire — a send
   * that reached the provider and lost the answer. The send is corrected to sent
   * and the draft retires as `sent_via_cara`.
   */
  SentViaCara = 'SENT_VIA_CARA',
  /**
   * Nothing to record: the mailbox still holds the draft, or the row had already
   * been retired before this look. A draft the agent moved to another folder is
   * reported here too — the mailbox still holds it and it is still theirs to send,
   * and all that changed is where the row has to look for it next time.
   */
  Unchanged = 'UNCHANGED',
  /**
   * The mailbox was asked and would not answer: rate limited, or too slow. The row
   * stands as it was and the next sync can settle it.
   */
  Unreachable = 'UNREACHABLE'
}

/**
 * One draft's result from `reconcileMailboxDrafts`, carrying both what was
 * concluded and the row as it now stands, so a client can settle that row without
 * re-reading the list it came from.
 */
export type MailboxDraftReconciliationResult = {
  __typename?: 'MailboxDraftReconciliationResult';
  /**
   * The draft as it stands after the look: retired, with its reason, where the
   * reconciliation retired it, and unchanged otherwise. Always present, including
   * for `UNREACHABLE` and `NOT_REACHED`, so every row a client asked about has
   * something to render.
   */
  draft: MailboxDraft;
  /**
   * The draft this result is about, so a client can match results to rows without
   * selecting anything from `draft`.
   */
  mailboxDraftId: Scalars['String']['output'];
  reconciliation: MailboxDraftReconciliation;
};

/**
 * How the copy of an email sitting in a mailbox stands against the EMAIL artifact
 * it was written from. The two ways an email moves are separate values because
 * they read differently to whoever is looking at it: one is Cara's revision to
 * accept, the other is a person's edit that may be their own from another tab.
 */
export enum MailboxDraftSyncState {
  /**
   * Cara wrote a newer version of the email after this draft was pushed. The
   * mailbox holds words that were current once and are not any more.
   */
  ArtifactVersionAhead = 'ARTIFACT_VERSION_AHEAD',
  /**
   * The artifact is on the version the mailbox holds, but its words have changed
   * since — a person edited the email, which rewrites a version in place rather
   * than raising it.
   */
  ContentChanged = 'CONTENT_CHANGED',
  /**
   * The mailbox holds the artifact's current version and its current words.
   * There is nothing to push, so pushing again would only touch the draft's
   * timestamp in the provider.
   */
  InSync = 'IN_SYNC',
  /**
   * Nothing here can establish whether the copy matches: the draft has been
   * retired so there is no copy left, or it names no artifact, or it predates the
   * fingerprint being recorded. Reported as not in sync, because the alternative
   * is telling someone an email is safely parked when nothing checked.
   */
  Unknown = 'UNKNOWN'
}

export type MailboxDraftsFilterInput = {
  /**
   * When true, return only drafts written from the authenticated user's own
   * requests.
   */
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Include drafts the mailbox no longer holds. Off by default: the question the
   * list is asked is "what is waiting in the Drafts folder", and a retired row is
   * an answer to a different one.
   */
  includeRetired?: InputMaybe<Scalars['Boolean']['input']>;
  mailboxAccountId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Narrows to the drafts belonging to emails the outbox filter matches. See
   * OutboxFilterInput for why this is answered against the whole email rather
   * than against the draft row.
   */
  outbox?: InputMaybe<OutboxFilterInput>;
  workspaceArtifactId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * One entry in the mailbox audit trail: what Cara did in a connected mailbox,
 * who caused it, and when. Entries are written once and never changed or
 * removed, and they survive the mailbox they describe — disconnecting an
 * integration must not erase the record of what was done through it.
 *
 * Deliberately free of message content. There is no subject, body, or recipient
 * here, which is what makes the trail readable by the agency rather than only by
 * the mailbox's owner.
 */
export type MailboxEvent = {
  __typename?: 'MailboxEvent';
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The agency user who acted, empty when initiatorType is not AGENCY_USER. */
  initiatorId: Scalars['String']['output'];
  /**
   * Whether a person did this or Cara did. WORKFLOW means no human pressed
   * anything — a background token refresh, or a copilot tool acting inside a
   * workspace run. AGENCY_USER carries that user in `initiatorId`.
   */
  initiatorType: UpdateInitiatorType;
  /**
   * The mailbox this concerns. Retained after a disconnect, so it may name a
   * mailbox that no longer exists.
   */
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  mailboxDraftId?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['Time']['output'];
  /**
   * Why, in the vocabulary of the event type: how a grant died for
   * REAUTH_REQUIRED, how a draft left the mailbox for DRAFT_RETIRED. Empty where
   * the type needs no qualifier.
   */
  reason: Scalars['String']['output'];
  /**
   * The person whose request Cara was acting on, where Cara acted rather than
   * the person. Kept apart from initiatorId on purpose: an automated action
   * taken on someone's behalf is still an automated action.
   */
  requestedByUserId?: Maybe<Scalars['String']['output']>;
  type: MailboxEventType;
  /**
   * The EMAIL artifact the draft was written from, and the version this event
   * concerns, so the trail lines up against the artifact's own history.
   */
  workspaceArtifactId?: Maybe<Scalars['String']['output']>;
};

/**
 * What happened in a mailbox. Each value reconstructs a transition in a row that
 * records only its current state. Sends are absent: an outbound send is its own
 * record.
 */
export enum MailboxEventType {
  /** A mailbox was connected for the first time. */
  Connected = 'CONNECTED',
  /**
   * The mailbox was forgotten and its credentials deleted. The event outlives
   * the account row it names, so the ID it carries resolves to nothing.
   */
  Disconnected = 'DISCONNECTED',
  /** Cara wrote an email artifact into the mailbox as a native draft. */
  DraftCreated = 'DRAFT_CREATED',
  /**
   * The provider stopped holding the draft — sent, superseded, retracted, or
   * deleted from the mailbox by its owner. `reason` says which.
   */
  DraftRetired = 'DRAFT_RETIRED',
  /**
   * Cara pushed the artifact's current state onto a draft already in the
   * mailbox. The draft row keeps only the newest version it was synced to, so
   * this is the only record that a draft was pushed more than once.
   */
  DraftSynced = 'DRAFT_SYNCED',
  /**
   * Cara found the stored grant dead and stopped using the mailbox. Recorded
   * once per death, not once per operation that trips over it.
   */
  ReauthRequired = 'REAUTH_REQUIRED',
  /**
   * A dead grant was repaired by fresh consent for the same provider account.
   * Distinct from CONNECTED so a timeline can pair a repair with the
   * REAUTH_REQUIRED that prompted it.
   */
  Reconnected = 'RECONNECTED'
}

/**
 * Which timeline to read. At most one subject may be named, and each maps onto
 * an index the table was built with; naming none reads the agency-wide feed.
 */
export type MailboxEventsFilterInput = {
  mailboxAccountId?: InputMaybe<Scalars['String']['input']>;
  workspaceArtifactId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A folder on a connected mailbox, with its concrete provider id and the
 * standard role it plays.
 */
export type MailboxFolder = {
  __typename?: 'MailboxFolder';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: MailboxFolderRole;
};

/**
 * Standard folder roles every provider exposes, named after IMAP SPECIAL-USE
 * (RFC 6154). User-created folders are omitted from this enum.
 */
export enum MailboxFolderRole {
  Archive = 'ARCHIVE',
  Drafts = 'DRAFTS',
  Inbox = 'INBOX',
  Junk = 'JUNK',
  Sent = 'SENT',
  Trash = 'TRASH'
}

/**
 * Who the mailbox sends as, captured at connect and verified on reconnect.
 * A reconsent that signs into a different provider account must not inherit
 * this mailbox's cursor and message IDs.
 */
export type MailboxIdentity = {
  __typename?: 'MailboxIdentity';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  providerAccountId: Scalars['String']['output'];
};

/**
 * Who connected the mailbox and holds its OAuth grant. Routing does not use
 * this; product uses it for authorization and the settings UI. agencyUserId is
 * the agency employee, not a client-portal user. Sharing a mailbox does not move
 * ownership: the owner is still the only person who can reconnect it or change
 * who it is shared with.
 */
export type MailboxOwner = {
  __typename?: 'MailboxOwner';
  agencyId: Scalars['String']['output'];
  agencyUserId: Scalars['String']['output'];
};

/**
 * Which mail service a connected mailbox is authorized against. Adding a
 * provider is this enum plus an adapter; product code routes on the stored
 * value rather than on integration-specific types.
 */
export enum MailboxProvider {
  Outlook = 'OUTLOOK'
}

/**
 * An email signature authored in Cara. No provider exposes the signature a user
 * configured in its own client, so outgoing mail carries what Cara appends.
 * Visibility decides who else may pick it; the author always can.
 */
export type MailboxSignature = {
  __typename?: 'MailboxSignature';
  bodyHtml: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /**
   * Preselected in the composer for its author. At most one signature per author
   * is the default.
   */
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: MailboxOwner;
  updatedAt: Scalars['Time']['output'];
  visibility: VisibilityConfig;
};

export type MailboxSignatureInput = {
  bodyHtml: Scalars['String']['input'];
  /**
   * Omit to create. Supplying an ID edits that signature, and only its author
   * may: ownership comes from the authenticated principal, never from this ID.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Who else may pick this signature. Defaults to PRIVATE. */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Margin settings for all sides */
export type MarginStyle = {
  __typename?: 'MarginStyle';
  /** Bottom margin in inches (e.g. 0.75) */
  bottomIn?: Maybe<Scalars['Float']['output']>;
  /** Left margin in inches (e.g. 0.75) */
  leftIn?: Maybe<Scalars['Float']['output']>;
  /** Right margin in inches (e.g. 0.75) */
  rightIn?: Maybe<Scalars['Float']['output']>;
  /** Top margin in inches (e.g. 0.75) */
  topIn?: Maybe<Scalars['Float']['output']>;
};

/** Input for margin settings */
export type MarginStyleInput = {
  /** Bottom margin in inches */
  bottomIn?: InputMaybe<Scalars['Float']['input']>;
  /** Left margin in inches */
  leftIn?: InputMaybe<Scalars['Float']['input']>;
  /** Right margin in inches */
  rightIn?: InputMaybe<Scalars['Float']['input']>;
  /** Top margin in inches */
  topIn?: InputMaybe<Scalars['Float']['input']>;
};

export type MemoriesInput = {
  /** Filter by agent (for admin views) */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by category */
  category?: InputMaybe<MemoryCategory>;
  /** Maximum number of memories to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by scope */
  scope?: InputMaybe<MemoryScope>;
  /** Filter by pinned status */
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by surface */
  surface?: InputMaybe<MemorySurface>;
  /** Filter by type */
  type?: InputMaybe<MemoryType>;
};

/**
 * A single, self-contained fact or preference derived from interactions with Cara.
 * Memories are atomic (one piece of information each) and self-contained (interpretable
 * without the originating conversation).
 */
export type Memory = {
  __typename?: 'Memory';
  /** How many times this memory has been injected into a prompt. Computed from the memory_access log. */
  accessCount: Scalars['Int']['output'];
  /** The agency this memory belongs to */
  agency: Agency;
  /** The agent this memory belongs to (null for ORGANIZATION scope) */
  agencyUser?: Maybe<AgencyUser>;
  /** Topical domain of the memory (orthogonal to surface) */
  category: MemoryCategory;
  /**
   * The self-contained text of the memory. All references are resolved and
   * the text is interpretable without the originating conversation.
   */
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  /** The user who created this memory */
  createdBy?: Maybe<AgencyUser>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  /** Keywords for secondary retrieval filtering within broad categories */
  keywords: Array<Scalars['String']['output']>;
  /** When this memory was last injected into a prompt. Computed from the memory_access log. */
  lastAccessedAt?: Maybe<Scalars['Time']['output']>;
  /** How and where this memory was created */
  provenance: MemoryProvenance;
  /** Organization-wide or agent-specific */
  scope: MemoryScope;
  /** Whether this memory is always included regardless of budget pressure */
  sticky: Scalars['Boolean']['output'];
  /** Product surface this memory is scoped to. Null means cross-surface. */
  surface?: Maybe<MemorySurface>;
  /** What kind of information: preference, correction, or procedure */
  type: MemoryType;
  updatedAt: Scalars['Time']['output'];
};

/**
 * Topical domain the memory applies to. Orthogonal to MemorySurface --
 * a memory can target a specific product surface, a topic, or both.
 */
export enum MemoryCategory {
  /** Carrier preferences and relationships */
  Carrier = 'CARRIER',
  /** Communication style, tone, and formatting */
  Communication = 'COMMUNICATION',
  /** Coverage knowledge and preferences */
  Coverage = 'COVERAGE',
  /** Document formatting and templates */
  Documentation = 'DOCUMENTATION',
  /** Catch-all for memories that don't fit other categories */
  General = 'GENERAL',
  /** Process and workflow preferences */
  Workflow = 'WORKFLOW'
}

export type MemoryConnection = {
  __typename?: 'MemoryConnection';
  edges: Array<MemoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Tool for explicitly saving a memory the user has asked Cara to remember. */
export type MemoryCreateTool = {
  __typename?: 'MemoryCreateTool';
  /** The input arguments for the memory create operation */
  input: MemoryCreateToolInput;
  /** The result of the memory create operation */
  output: MemoryCreateToolOutput;
};

/**
 * Input arguments for the MEMORY_CREATE tool. Content, type, category, and
 * scope are passed as strings because the underlying tool schema (exposed to
 * the LLM) is reflection-derived; the resolver upcasts them to the typed
 * MemoryType / MemoryCategory / MemoryScope enums.
 */
export type MemoryCreateToolInput = {
  __typename?: 'MemoryCreateToolInput';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  keywords: Array<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  surface?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/**
 * Result of the MEMORY_CREATE tool. Status is 'saved' on success or 'failed'
 * on a terminal error. Scope reflects the actual scope the memory was saved
 * under (may differ from the request if the caller lacks admin permissions).
 */
export type MemoryCreateToolOutput = {
  __typename?: 'MemoryCreateToolOutput';
  memoryId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MemoryEdge = {
  __typename?: 'MemoryEdge';
  cursor: Scalars['String']['output'];
  node: Memory;
};

/** Provenance information: where and how a memory was created. */
export type MemoryProvenance = {
  __typename?: 'MemoryProvenance';
  /** Message that triggered extraction, if any */
  messageId?: Maybe<Scalars['String']['output']>;
  /** How this memory was created */
  source: MemorySource;
  /**
   * IDs of the memories this one was derived from. Populated for SYNTHESIZED
   * and MERGED sources so an admin can trace a dream-phase decision back to
   * its inputs; empty for EXTRACTED and MANUAL.
   */
  sourceIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Workspace where this memory was extracted from, if any */
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/**
 * Tool for re-ranking the cached memory context when the conversation topic
 * has shifted significantly from the original task.
 */
export type MemoryRefreshTool = {
  __typename?: 'MemoryRefreshTool';
  /** The input arguments for the memory refresh operation */
  input: MemoryRefreshToolInput;
  /** The result of the memory refresh operation */
  output: MemoryRefreshToolOutput;
};

/** Input arguments for the MEMORY_REFRESH tool. */
export type MemoryRefreshToolInput = {
  __typename?: 'MemoryRefreshToolInput';
  reason: Scalars['String']['output'];
};

/**
 * A memory entry returned by MEMORY_REFRESH. Carries just the fields the LLM
 * needs to reason over the memory and the id so the UI can deep-link or
 * attribute it. The full Memory entity is intentionally not embedded -- this
 * keeps the persisted tool-call payload small and avoids dragging
 * forceResolver fields (agency, agencyUser, accessCount, ...) into the
 * tool-call serialization path.
 */
export type MemoryRefreshToolMemory = {
  __typename?: 'MemoryRefreshToolMemory';
  category: MemoryCategory;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  scope: MemoryScope;
  surface?: Maybe<MemorySurface>;
};

/**
 * Result of the MEMORY_REFRESH tool. The refreshed memories are returned as a
 * structured list so both the LLM and the UI can consume them directly. The
 * list is persisted on the workspace tool-call history and re-rendered into
 * every subsequent LLM prompt, so the memories are visible to the model on
 * the very next turn -- no cached workspace write needed.
 */
export type MemoryRefreshToolOutput = {
  __typename?: 'MemoryRefreshToolOutput';
  /** Memories selected as relevant for the refreshed context. Empty when no memories matched. */
  memories: Array<MemoryRefreshToolMemory>;
  /**
   * Number of memories selected. Equivalent to memories.length but exposed
   * separately so tool-call event consumers that don't traverse the list
   * (logs, metrics) can read the count cheaply.
   */
  memoriesRefreshed: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/**
 * Whether a memory is scoped to the entire organization or to an individual agent.
 * Agent-scoped memories take precedence over organization-scoped memories on the same topic.
 */
export enum MemoryScope {
  /** Individual agent: communication style, output format, workflow habits */
  Agent = 'AGENT',
  /** Agency-wide: carrier preferences, compliance requirements, SOPs, terminology */
  Organization = 'ORGANIZATION'
}

/**
 * Filters for the memory-management list. Values within one field are ORed;
 * different fields are ANDed.
 */
export type MemorySearchFilterInput = {
  categories?: InputMaybe<Array<MemoryCategory>>;
  /**
   * Include memories whose surface is null. When no surfaces are supplied, true
   * selects cross-surface memories only; omitting this field leaves surface unfiltered.
   */
  includeCrossSurface?: InputMaybe<Scalars['Boolean']['input']>;
  /** True selects pinned memories; false selects unpinned memories. */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-insensitive text search across content, keywords, and memory labels. */
  query?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<MemoryScope>>;
  /** Specific product surfaces to include. */
  surfaces?: InputMaybe<Array<MemorySurface>>;
  types?: InputMaybe<Array<MemoryType>>;
};

/** How the memory was created. */
export enum MemorySource {
  /** Automatically extracted from a conversation by the async extraction loop */
  Extracted = 'EXTRACTED',
  /** Manually created by the user */
  Manual = 'MANUAL',
  /** Merged by the dream phase from two or more existing memories */
  Merged = 'MERGED',
  /** Synthesized by the dream phase from two or more existing memories */
  Synthesized = 'SYNTHESIZED'
}

/**
 * Product surface a memory is scoped to. A null surface means the memory
 * applies regardless of surface (e.g. an org-wide carrier preference).
 */
export enum MemorySurface {
  /** Applies to Copilot */
  Copilot = 'COPILOT',
  /** Applies to Email AI */
  EmailAi = 'EMAIL_AI',
  /** Applies to Voice */
  Voice = 'VOICE'
}

/** What kind of information the memory captures. */
export enum MemoryType {
  /** A correction to a previous mistake or misunderstanding */
  Correction = 'CORRECTION',
  /** How the agent or agency wants things done */
  Preference = 'PREFERENCE',
  /** A step-by-step process or standard operating procedure */
  Procedure = 'PROCEDURE'
}

/** Message feedback details */
export type MessageFeedback = {
  __typename?: 'MessageFeedback';
  /** Predefined reasons for negative feedback (multiple selection allowed) */
  reasons?: Maybe<Array<MessageFeedbackNegativeReason>>;
};

/**
 * Predefined reasons for negative message feedback
 * Simple, user-friendly language
 */
export enum MessageFeedbackNegativeReason {
  /** Missing important information */
  MissingInformation = 'MISSING_INFORMATION',
  /** Didn't understand what I was asking */
  Misunderstanding = 'MISUNDERSTANDING',
  /** Not helpful */
  NotHelpful = 'NOT_HELPFUL',
  /** Other reason (please explain) */
  Other = 'OTHER',
  /** Too slow */
  TooSlow = 'TOO_SLOW',
  /** Too verbose */
  TooVerbose = 'TOO_VERBOSE',
  /** Wrong information in the form or response */
  WrongInformation = 'WRONG_INFORMATION'
}

/** Message rating type */
export enum MessageRating {
  /** Thumbs down */
  Down = 'DOWN',
  /** Thumbs up */
  Up = 'UP'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Account user sign in to the Oyster platform */
  accountUserSignIn?: Maybe<AccountUserSignInResponse>;
  /** Account user sign out of the Oyster platform */
  accountUserSignOut: Scalars['Boolean']['output'];
  /** Update a Cara workspace */
  addCaraWorkspaceMessage: CaraWorkspace;
  /**
   * Attaches a document the read-time derivation does not supply: one whose
   * workspace is not linked to this client, or a file uploaded elsewhere.
   *
   * Idempotent, and clears a previous removal of the same document -- both states
   * are the one row.
   *
   * An artifact the caller cannot read is reported as missing rather than refused,
   * so this cannot test whether one exists. Files carry no per-user visibility, so
   * for them the client's agency is the whole check.
   */
  addClientArtifact: Client;
  /** Attaches a file to a client. See addClientArtifact. */
  addClientFile: Client;
  /** Associates an existing contact with an account */
  addContactAssociation: AccountContact;
  /** Add a comment to a service request */
  addServiceRequestComment: ServiceRequest;
  /** Adds a single user to a team. Admin-only. */
  addTeamMember: Team;
  /** Agency sign in to the Oyster platform */
  agencySignIn?: Maybe<AgencySignInResponse>;
  /** Agency sign out of the Oyster platform */
  agencySignOut: Scalars['Boolean']['output'];
  /**
   * Archives a profile (soft delete). Its users fall back to the agency default,
   * or to their role's permissions when there is none. Admin-only.
   */
  archiveAgencyProfile: AgencyProfile;
  /**
   * Soft-delete outbound calls that are not in a scheduled/pending state.
   * Scheduled calls must be cancelled first.
   */
  archiveOutboundCalls: Scalars['Boolean']['output'];
  /**
   * Archives a team (soft delete). Admin-only.
   * Archived team IDs remain in visibility access lists harmlessly — the
   * visibility filter ignores them since archived teams have no members.
   */
  archiveTeam: Team;
  /**
   * Deprecated compatibility mutation for older clients. Use
   * updateWordDocumentTemplates instead.
   * @deprecated Use updateWordDocumentTemplates instead.
   */
  archiveWordDocumentTemplates: Array<WordDocumentTemplate>;
  /**
   * Build a one-time render URL for a PDF-renderable workspace artifact with optional prefix/suffix PDFs.
   * Supports HTML documents, ACORD template forms, and custom forms. Inline Upload files are stored
   * in cache with a short TTL and are only valid for a single render. Existing file IDs (from the
   * workspace, message, or template) are passed through unchanged.
   */
  buildHtmlDocumentRenderUrl: HtmlDocumentRenderUrl;
  /** Cancel the specified business insurance policy */
  cancelBusinessPolicy: BusinessPolicy;
  cancelOutboundCall: OutboundCall;
  /**
   * Clears the calling user's rule for one destination field and records a
   * CORRECTION revocation event for future learning.
   */
  clearSmartFillOverrides: Scalars['Int']['output'];
  /** Create a certificate of insurance on the client side */
  clientCreateCertificate?: Maybe<ClientCreateCertificateResult>;
  convertWorkspaceToSmartFillBuckets: SmartFillWorkspaceConversion;
  /** Creates a new account */
  createAccount: Account;
  /**
   * Creates an admin sign-in code or URL for a given agency. For internal (Oyster employee) sessions,
   * omit agencyUserId. For external (agency user) sessions, provide the agencyUserId.
   */
  createAdminSignInCode: AdminSignInCode;
  /** Creates a new agency */
  createAgency: Agency;
  /**
   * Create a new set of producer information at the agency level.
   * Available to agency admins only.
   */
  createAgencyProducerInformation: ProducerInformation;
  /**
   * Creates a profile in the current agency. Admin-only and gated behind the
   * AGENCY_PROFILE_MANAGEMENT entitlement. The new profile grants everything the agency's
   * roles allow and shows the whole sidebar, so assigning it before it has been
   * narrowed changes nothing for its users.
   */
  createAgencyProfile: AgencyProfile;
  /** Adds an agency user to an agency */
  createAgencyUser: AgencyUser;
  /**
   * Create a new set of producer information at the agency user level.
   * Available to the specified user or an agency admin.
   */
  createAgencyUserProducerInformation: ProducerInformation;
  /** Create business insurance policies according to specification */
  createBusinessPolicies: Array<BusinessPolicy>;
  /** Create a new Cara workspace */
  createCaraWorkspace: CaraWorkspace;
  /** Create a certificate of insurance */
  createCertificate?: Maybe<CertificateOfLiabilityInsurance>;
  createClient: Client;
  createClientNote: ClientNote;
  /** Creates a new account contact */
  createContact: AccountContact;
  /** Create a new custom preset */
  createCustomPreset: CustomPreset;
  /** Create a new Excel spreadsheet template */
  createExcelSpreadsheetTemplate: ExcelSpreadsheetTemplate;
  /** Create a new HTML document template */
  createHtmlDocumentTemplate: HtmlDocumentTemplate;
  /** Create a new integration */
  createIntegration?: Maybe<Integration>;
  /** Create a cosmetic folder inside a knowledge base. */
  createKnowledgeBaseFolder: KnowledgeBase;
  /** Create a new document in the knowledge base */
  createKnowledgeBaseTextDocument: KnowledgeBaseDocument;
  /**
   * Create a new URL-sourced document in the knowledge base.
   * This will set up automatic syncing at the specified frequency.
   */
  createKnowledgeBaseURLDocument: KnowledgeBaseDocument;
  /**
   * Write an EMAIL artifact into a connected mailbox as a native draft, waiting in
   * the Drafts folder to be finished and sent from the mail client itself. This
   * does not send: a draft nobody pressed send on has not gone anywhere.
   *
   * Saving the same email again updates the copy already in the mailbox rather
   * than leaving two, so a second call is a refresh rather than a duplicate. An
   * email parks in one Drafts folder at a time, so naming a different mailbox
   * while a live draft exists is refused rather than leaving a copy in each.
   *
   * artifactVersion pins the composition the caller was looking at, and
   * contentRevision pins the words themselves — a person editing the same draft in
   * another tab rewrites the version in place, which only a fingerprint of the
   * content can catch. contentRevision is nullable because a caller that rendered
   * no composition has no revision to hold, but a client that showed this email to
   * a person must send one: what lands in the Drafts folder is one keystroke from
   * being sent by hand, so the words saved have to be the words that were read.
   *
   * The mailbox must be one the caller may send as — theirs, or shared with them —
   * decided by the mailbox's visibility for the same reason sendMailboxEmail
   * decides it there. An email that has already been sent is refused: a copy in
   * the Drafts folder would only offer it for a second send.
   */
  createMailboxDraft: MailboxDraft;
  /**
   * Create a memory. ORGANIZATION-scoped memories require ORGANIZATION:MEMORY:CREATE
   * (admins by default); AGENT-scoped memories require SELF:MEMORY:CREATE (any agent)
   * and are automatically scoped to the caller. The fine-grained scope-vs-permission
   * match is enforced in the resolver since no memory id exists yet to derive scope.
   */
  createMemory: Memory;
  createOutboundCall: OutboundCall;
  /** Create a service request */
  createServiceRequest: ServiceRequest;
  createSmartFillBucket: SmartFillBucket;
  /**
   * Creates a new team in the current agency. Admin-only and gated behind the
   * TEAM_MANAGEMENT entitlement.
   */
  createTeam: Team;
  /** Create a voice agent */
  createVoiceAgent: VoiceAgent;
  /** Create a new Word document template */
  createWordDocumentTemplate: WordDocumentTemplate;
  /**
   * Create a new workflow definition. Scoped to the caller's own agency
   * since no resource exists yet to derive scope from.
   */
  createWorkflowDefinition: WorkflowDefinition;
  /**
   * Create and start a new workflow execution. Scoped to the caller's
   * agency; the resolver performs the additional check that the requested
   * definition is reachable from this agency (or is a built-in).
   */
  createWorkflowExecution: WorkflowExecution;
  /**
   * Permanently deletes an agency and all of its data. The agency must not have an active
   * subscription. Only accessible by global admins.
   */
  deleteAgency: Scalars['Boolean']['output'];
  /** Deletes the specified business insurance policy */
  deleteBusinessPolicy?: Maybe<BusinessPolicy>;
  /**
   * Deletes the client and cascades to its workspace, AMS account and agency-user
   * links. The workspaces themselves are not touched.
   */
  deleteClient: Scalars['Boolean']['output'];
  deleteClientNote: Scalars['Boolean']['output'];
  /** Delete feedback (soft delete) */
  deleteFeedback: Feedback;
  /** Delete a file. Returns the deleted file, if successful. */
  deleteFile?: Maybe<File>;
  /** Delete a document by its ID */
  deleteKnowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Delete an empty cosmetic folder from a knowledge base. */
  deleteKnowledgeBaseFolder: KnowledgeBase;
  /**
   * Delete selected documents and cosmetic folders from a knowledge base. Folders
   * must be empty after the selected documents and folders are removed.
   */
  deleteKnowledgeBaseItems: KnowledgeBase;
  /**
   * Delete a signature the caller authored. Sharing a signature lets a colleague
   * pick it, not destroy it, so one merely shared with the caller is refused —
   * as is one that does not exist, with the same answer.
   *
   * Mail already sent keeps the signature it carried, because the body was
   * composed at send time. An unsent EMAIL artifact still naming this signature
   * is refused at send until the sender picks another.
   */
  deleteMailboxSignature: Scalars['Boolean']['output'];
  /** Soft-delete a memory. ORGANIZATION memories require admin permissions. */
  deleteMemory: Memory;
  /**
   * Delete a set of producer information.
   * Admins may delete any PI in their agency; users may only delete their own user-level PI.
   */
  deleteProducerInformation: Scalars['Boolean']['output'];
  /** Soft-delete a bucket while preserving its event history. */
  deleteSmartFillBucket: Scalars['Boolean']['output'];
  dialOutboundCall: OutboundCall;
  /** Disable an agency user from the current account */
  disableAgencyUser: AgencyUser;
  /**
   * Forget a connected mailbox: revoke the grant where the provider supports it
   * and delete the stored credentials. The send log survives.
   */
  disconnectMailbox: Scalars['Boolean']['output'];
  /** Dismisses the post-confirmation Standard sunset renewal banner for the agency. */
  dismissStandardSunsetRenewalBanner: AgencySubscription;
  /** Enable an agency user from the current account */
  enableAgencyUser: AgencyUser;
  /**
   * Convert a completed Cara agent message into an ephemeral Word, Excel, or PDF download.
   * The file is never persisted as a workspace artifact or agency file. Word and Excel are
   * returned inline as bytes; PDF returns a single-use URL rendered by the statics service.
   */
  exportCaraWorkspaceMessage: CaraWorkspaceMessageExport;
  extractSuperCopy: SuperCopyDraft;
  /**
   * Searches the agency's document-capable AMS integrations directly (live API
   * call) by account name, exact email, phone, or Applied Epic lookup code — the
   * fallback for when knowledge-graph search finds nothing. Name search returns
   * all matching candidates for explicit selection. Exact searches import the
   * single match and enqueue its background document import.
   */
  findAmsAccount: FindAmsAccountResult;
  /**
   * Live-searches the agency's document-capable AMS integrations for a policy by its
   * number (currently Applied Epic only) — the "Policies" mode fallback for when
   * knowledge-graph search finds nothing. On a hit the policy's owning account is
   * imported as a minimal entity and a background refresh is enqueued; the result is
   * that account (the picker lands on the account browse while it syncs).
   */
  findAmsPolicy: FindAmsAccountResult;
  /**
   * Generate up to 5 clarifying questions for the Convert-to-Preset wizard,
   * tailored to the selected workspaces' content. Runs one fast-model LLM call
   * synchronously and returns the questions (each with 2-4 selectable options and
   * a free-text fallback); it persists nothing. Gated by the
   * convert_workspace_to_preset_enabled Statsig flag.
   */
  generatePresetQuestions: Array<PresetClarifyingQuestion>;
  /**
   * Share a custom preset with a federated child agency (read/run only, VIEWER role).
   * Requires CUSTOM_PRESET:SHARE on the owning agency, which only agency admins (and
   * platform admins) hold. The preset must be PUBLIC and not archived. The target
   * must be a FEDERATED_BILLING child agency. Idempotent: re-sharing an already-shared
   * preset returns the existing grant without error.
   */
  grantCustomPresetAccess: CustomPresetAccess;
  /**
   * Grant access to a knowledge base for another agency.
   * Only the owner of the knowledge base can grant access.
   * The target agency must be a child agency with FEDERATED_BILLING.
   */
  grantKnowledgeBaseAccess: KnowledgeBaseAccess;
  /**
   * Records that the two clients are different, permanently. No later backfill run
   * re-raises the pair.
   */
  keepClientsSeparate: ClientMergeCandidate;
  /**
   * Links a workspace to a client, returning the updated client.
   *
   * Idempotent: linking a workspace already linked to this client succeeds and
   * changes nothing. The schema permits a workspace under more than one client and
   * the resolver rejects it, so the one-client-per-workspace rule can be relaxed
   * later without a migration.
   *
   * replaceExisting re-files a workspace another client already holds, dropping
   * that link in the same transaction. It defaults to false so a caller has to mean
   * it: the workspace disappears from the other client's history.
   */
  linkClientWorkspace: Client;
  /**
   * Merges the candidate's two clients into survivorClientId, which must be one of
   * them, and returns the survivor.
   *
   * The absorbed client keeps its row but leaves every list, pointing at the
   * survivor so a stale id still resolves. Its workspaces, AMS accounts, users,
   * notes and documents move across; where both held the same association the
   * survivor's is kept. Attributes fill in the survivor's gaps, preferring a value
   * a person asserted over one the backfill wrote.
   *
   * Authorized on the survivor alone: a candidate cannot span two agencies, so the
   * other client is necessarily in the same one.
   */
  mergeClients: Client;
  /** Move one or more documents into a cosmetic folder. Null folder means root. */
  moveKnowledgeBaseDocumentsToFolder: Array<KnowledgeBaseDocument>;
  /** Move a cosmetic folder under a new parent folder. Null parent means root. */
  moveKnowledgeBaseFolder: KnowledgeBase;
  /** Move selected documents and cosmetic folders into a cosmetic folder. Null folder means root. */
  moveKnowledgeBaseItemsToFolder: KnowledgeBase;
  /**
   * Ask the mailboxes what became of these drafts, and report what each one turned
   * out to be. This is how a draft an agent sent from their own mail client is
   * ever noticed: the provider drops it from the Drafts folder and tells nobody,
   * and only a Message-ID search against the mailbox can prove where it went.
   *
   * This writes: a draft found sent is retired and its send is filed on the
   * outbound log. It is safe to call repeatedly and from two tabs at once — a
   * repeat collides on an index rather than filing a second record.
   *
   * Read the list first, render it from what the ledger knows, then call this with
   * the ids on screen and settle each row as its result arrives.
   *
   * Name at most 50 drafts, the page size of the ledger lists. A longer list is
   * refused whole rather than truncated.
   *
   * Every draft named must be one the caller could already read through
   * `searchMailboxDrafts`. A draft that does not exist and one belonging to a
   * colleague's private workspace are refused identically, so this cannot be used
   * to test whether an id exists.
   *
   * Ordinary failure is per draft, not per call: a rate-limited mailbox comes back
   * as `UNREACHABLE` on its own rows, and a pass that runs out of time comes back
   * as `NOT_REACHED` on the rest, while every draft that was settled keeps its
   * answer.
   */
  reconcileMailboxDrafts: Array<MailboxDraftReconciliationResult>;
  recordSmartFillEvent: SmartFillEvent;
  /** Reinstate the specified business insurance policy */
  reinstateBusinessPolicy: BusinessPolicy;
  /**
   * Removes a document from a client without touching the document itself. It stays
   * in its own workspace; this records that it is not relevant to this client, which
   * has to outlast the workspace link that would otherwise keep supplying it.
   *
   * Returns the client so the caller's cache updates from the response, matching
   * linkClientWorkspace below rather than making the caller refetch.
   */
  removeClientArtifact: Client;
  /** Removes a file from a client. See removeClientArtifact. */
  removeClientFile: Client;
  /** Removes an association between an account and a contact */
  removeContactAssociation: AccountContact;
  /** Removes a single user from a team. Admin-only. */
  removeTeamMember: Team;
  /** Rename a cosmetic folder inside a knowledge base. */
  renameKnowledgeBaseFolder: KnowledgeBase;
  /** Renew the specified business insurance policy */
  renewBusinessPolicy: BusinessPolicy;
  /**
   * Replace a document with a new version.
   * Creates a new document with the same documentGroupId, incremented version number,
   * and marks the old document as not the latest version.
   */
  replaceKnowledgeBaseDocument: KnowledgeBaseDocument;
  /**
   * Requests a background refresh of an account's data from the underlying AMS
   * (via the AmsAccountRefreshWorkflow; never a full-book sync). With force=false
   * the server only enqueues when the account is stale (older than the 1h
   * staleness window); with force=true it enqueues unless the account synced
   * within the last 60 seconds. Returns immediately — poll amsAccountSyncStatus.
   */
  requestAmsAccountRefresh: RequestAmsAccountRefreshResult;
  /** Resolve a service request */
  resolveServiceRequest: ServiceRequest;
  /**
   * Resolve one live form against one bucket: user rules first, then a single
   * direct model call for the remaining destinations. Values are read from the
   * bucket and formatted server side; model-backed resolves persist the exact
   * prompt and decoded output as best-effort private evidence.
   */
  resolveSmartFill: SmartFillResolveResult;
  /**
   * Un-share a custom preset from an agency. Requires CUSTOM_PRESET:SHARE on the
   * owning agency (admin-only). Cascades removal of the preset from the child
   * agency's users' favorites. Idempotent.
   */
  revokeCustomPresetAccess: Scalars['Boolean']['output'];
  /**
   * Revoke access to a knowledge base for an agency.
   * Only the owner of the knowledge base can revoke access.
   */
  revokeKnowledgeBaseAccess: Scalars['Boolean']['output'];
  /**
   * Send an EMAIL artifact from a connected mailbox. This is the only path in
   * Cara by which email leaves the building: models draft EMAIL artifacts and
   * never send them, so an authenticated human calling this mutation is the
   * confirmation. artifactVersion and contentRevision together pin what the
   * caller was looking at — a send is refused when the artifact has been edited
   * since. Both are needed because they catch different edits: a revision from
   * Cara arrives as a new version, while a person editing the same draft in
   * another tab rewrites the version in place and only moves the content
   * revision.
   *
   * The mailbox must be one the caller may send as — theirs, or one shared with
   * them.
   */
  sendMailboxEmail: OutboundEmail;
  /**
   * Set the agency's overage dollar budget for a meter in the billing period.
   * Pass null or 0 for limitDollars to disallow overage. Takes effect immediately.
   */
  setAgencyMeterOverageLimit: AgencySubscription;
  /**
   * Set a user's platform-unit overage dollar budget for the billing period
   * (phased units after included is exhausted, at the overage rate).
   * Pass null or 0 for limitDollars to disallow per-user overage. Takes effect
   * immediately.
   */
  setAgencyUserOverageLimit: AgencyUser;
  /**
   * Make a mailbox the one the caller's composer opens on. Only the mailbox's
   * owner may call this, whatever scope the caller holds, and a mailbox merely
   * shared with them is refused with the same answer as one that does not exist.
   *
   * Marking a second mailbox clears the first, so this is how the default moves
   * as well as how it is first set.
   */
  setDefaultMailbox: MailboxAccount;
  /**
   * Change who may send as a mailbox. Only the mailbox's owner may call this,
   * whatever scope the caller holds. PUBLIC makes the mailbox an agency-wide
   * address — everyone in the agency may send as it, including future hires.
   */
  setMailboxVisibility: MailboxAccount;
  /**
   * Sets the parent agency for an existing standalone agency, converting it into a subagency.
   * The agency must have no current parent. Only accessible by global admins.
   * The child agency's subscription will be reset to ENTERPRISE/ANNUAL with no Stripe billing.
   */
  setParentAgency: Agency;
  /**
   * Start generating a custom preset from one or more source workspaces. Creates
   * the preset in state GENERATING and starts GeneratePresetWorkflow in the same
   * transaction, so a Temporal failure rolls the preset back and surfaces a server
   * error rather than leaving a preset nothing will ever finish.
   *
   * Poll the returned preset with the customPreset query to follow progress: state
   * goes GENERATING -> READY or FAILED, and generation.step names the work in
   * flight. Gated by the convert_workspace_to_preset_enabled Statsig flag.
   */
  startPresetGeneration: CustomPreset;
  /** Start a trace analysis for a given trace. */
  startTraceAnalysis: TraceAnalysis;
  /** Stop a Cara workspace that is currently working (V2 only) */
  stopCaraWorkspace: CaraWorkspace;
  /** Submit call rating */
  submitCallRating: Feedback;
  /** Submit or update message rating (thumbs up/down) */
  submitMessageRating: Feedback;
  /** Sync an integration */
  syncIntegration?: Maybe<Integration>;
  /**
   * Manually trigger a sync for a URL-sourced document.
   * This runs immediately regardless of the scheduled frequency.
   */
  syncKnowledgeBaseURLDocument: KnowledgeBaseDocument;
  /**
   * Unlinks a workspace from a client, returning the updated client. The workspace
   * itself is untouched and keeps all of its own content.
   *
   * Idempotent: unlinking a workspace that is not linked succeeds.
   */
  unlinkClientWorkspace: Client;
  /** Updates an existing account */
  updateAccount: Account;
  /** Update an existing agency */
  updateAgency: Agency;
  /** Replaces a profile's configuration and assignments. Admin-only. */
  updateAgencyProfile: AgencyProfile;
  /** Update the roles of an agency user */
  updateAgencyUser: AgencyUser;
  /** Updates the preferences for the current agency user */
  updateAgencyUserPreferences: AgencyUser;
  /** Update the specified business insurance policy */
  updateBusinessPolicy: BusinessPolicy;
  /** Update multiple calls */
  updateCalls: Array<Call>;
  updateCaraWorkspaceArtifact: CaraWorkspaceArtifact;
  /**
   * Applies one update to every named artifact, across workspaces, and returns
   * their summaries afterwards. All or nothing: an id the caller cannot read,
   * whether cross-agency, hidden by visibility, or nonexistent, fails the whole
   * call as "artifact not found". Bounded like `CaraWorkspaceArtifactFilter.ids`.
   * Agency-scoped because a selection spans workspaces; each artifact's workspace
   * is checked inside.
   */
  updateCaraWorkspaceArtifacts: Array<CaraWorkspaceArtifactSummary>;
  /** Update multiple Cara workspaces */
  updateCaraWorkspaces: Array<CaraWorkspace>;
  updateClient: Client;
  /** Rewrites the body. Only the body is mutable; author and client are fixed. */
  updateClientNote: ClientNote;
  /** Updates an existing account contact */
  updateContact: AccountContact;
  updateCustomForm: CustomForm;
  /** Update a custom preset */
  updateCustomPreset: CustomPreset;
  /** Update multiple custom presets (e.g. archiving) */
  updateCustomPresets: Array<CustomPreset>;
  /** Update an Excel spreadsheet template */
  updateExcelSpreadsheetTemplate: ExcelSpreadsheetTemplate;
  /** Update multiple Excel spreadsheet templates (e.g. archiving or changing visibility) */
  updateExcelSpreadsheetTemplates: Array<ExcelSpreadsheetTemplate>;
  /** Update a HTML document template */
  updateHtmlDocumentTemplate: HtmlDocumentTemplate;
  /** Update multiple HTML document templates (e.g. archiving) */
  updateHtmlDocumentTemplates: Array<HtmlDocumentTemplate>;
  /** Update an integration */
  updateIntegration: Integration;
  /** Update a knowledge base by its ID */
  updateKnowledgeBase?: Maybe<KnowledgeBase>;
  /**
   * Update access role for an agency on a knowledge base.
   * Only the owner of the knowledge base can update access.
   */
  updateKnowledgeBaseAccess: KnowledgeBaseAccess;
  /** Update a document by its ID */
  updateKnowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Update settings for a URL-sourced document (frequency, pause/resume). */
  updateKnowledgeBaseURLDocument: KnowledgeBaseDocument;
  /** Update the timestamp of the last viewed new features modal */
  updateLastViewedNewFeatures: Scalars['Time']['output'];
  /** Update a memory. ORGANIZATION memories require admin permissions. */
  updateMemory: Memory;
  updateOutboundCall: OutboundCall;
  /**
   * Update an existing set of producer information.
   * Admins may update any PI in their agency; users may only update their own user-level PI.
   */
  updateProducerInformation: ProducerInformation;
  /** Update a service request */
  updateServiceRequest: ServiceRequest;
  updateSmartFillBucket: SmartFillBucket;
  /** Updates the subscription for the current account */
  updateSubscription: AgencySubscription;
  /** Updates an existing team's name, description, or full member list. Admin-only. */
  updateTeam: Team;
  /** Update a voice agent */
  updateVoiceAgent: VoiceAgent;
  /** Update a Word document template */
  updateWordDocumentTemplate: WordDocumentTemplate;
  /** Update multiple Word document templates */
  updateWordDocumentTemplates: Array<WordDocumentTemplate>;
  /**
   * Update an existing workflow definition (creates a new version). Scoped
   * via the WORKFLOW_DEFINITION being updated so the directive denies
   * cross-agency edits.
   */
  updateWorkflowDefinition: WorkflowDefinition;
  /** Upload a file associated with an account */
  uploadAccountFile: File;
  uploadCustomForm: CustomForm;
  /** Upload a file associated with an HTML document template */
  uploadHtmlDocumentTemplateFile: File;
  /** Update a document by its ID */
  uploadKnowledgeBaseFileDocument: Array<KnowledgeBaseDocument>;
  /** Upload a file associated with a policy */
  uploadPolicyFile: File;
  /** Upload a file associated with a workspace */
  uploadWorkspaceFile: File;
  /** Create a signature, or edit one the caller authored. */
  upsertMailboxSignature: MailboxSignature;
  upsertSmartFillOverride: SmartFillOverride;
};


export type MutationAccountUserSignInArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type MutationAddCaraWorkspaceMessageArgs = {
  id: Scalars['ID']['input'];
  input: CaraWorkspaceMessageInput;
};


export type MutationAddClientArtifactArgs = {
  artifactId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
};


export type MutationAddClientFileArgs = {
  clientId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};


export type MutationAddContactAssociationArgs = {
  accountId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};


export type MutationAddServiceRequestCommentArgs = {
  id: Scalars['ID']['input'];
  input: AddServiceRequestCommentInput;
};


export type MutationAddTeamMemberArgs = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAgencySignInArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type MutationArchiveAgencyProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveOutboundCallsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationArchiveTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveWordDocumentTemplatesArgs = {
  input: ArchiveWordDocumentTemplatesInput;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationBuildHtmlDocumentRenderUrlArgs = {
  input: BuildHtmlDocumentRenderUrlInput;
};


export type MutationCancelBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: CancelBusinessPolicyInput;
};


export type MutationCancelOutboundCallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClearSmartFillOverridesArgs = {
  fieldKey: Scalars['String']['input'];
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
};


export type MutationClientCreateCertificateArgs = {
  accountId: Scalars['ID']['input'];
  input: ClientCreateCertificateInput;
};


export type MutationConvertWorkspaceToSmartFillBucketsArgs = {
  operationId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAdminSignInCodeArgs = {
  agencyId: Scalars['ID']['input'];
  agencyUserId?: InputMaybe<Scalars['ID']['input']>;
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateAgencyArgs = {
  input: CreateAgencyInput;
};


export type MutationCreateAgencyProducerInformationArgs = {
  agencyId: Scalars['ID']['input'];
  input: ProducerInformationInput;
};


export type MutationCreateAgencyProfileArgs = {
  input: CreateAgencyProfileInput;
};


export type MutationCreateAgencyUserArgs = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
  input: AgencyUserInput;
};


export type MutationCreateAgencyUserProducerInformationArgs = {
  agencyUserId: Scalars['ID']['input'];
  input: ProducerInformationInput;
};


export type MutationCreateBusinessPoliciesArgs = {
  req: CreateBusinessPoliciesInput;
};


export type MutationCreateCaraWorkspaceArgs = {
  input: CaraWorkspaceMessageInput;
};


export type MutationCreateCertificateArgs = {
  input: CreateCertificateInput;
};


export type MutationCreateClientArgs = {
  input: ClientInput;
};


export type MutationCreateClientNoteArgs = {
  body: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
};


export type MutationCreateContactArgs = {
  input: CreateAccountContactInput;
};


export type MutationCreateCustomPresetArgs = {
  input: CustomPresetInput;
};


export type MutationCreateExcelSpreadsheetTemplateArgs = {
  input: ExcelSpreadsheetTemplateInput;
};


export type MutationCreateHtmlDocumentTemplateArgs = {
  input: HtmlDocumentTemplateInput;
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateKnowledgeBaseFolderArgs = {
  knowledgeBaseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateKnowledgeBaseTextDocumentArgs = {
  input: CreateKnowledgeBaseTextDocumentInput;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationCreateKnowledgeBaseUrlDocumentArgs = {
  input: CreateKnowledgeBaseUrlDocumentInput;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationCreateMailboxDraftArgs = {
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  contentRevision?: InputMaybe<Scalars['String']['input']>;
  mailboxAccountId: Scalars['String']['input'];
};


export type MutationCreateMemoryArgs = {
  input: CreateMemoryInput;
};


export type MutationCreateOutboundCallArgs = {
  input: CreateOutboundCallInput;
};


export type MutationCreateServiceRequestArgs = {
  input: CreateServiceRequestInput;
};


export type MutationCreateSmartFillBucketArgs = {
  input: CreateSmartFillBucketInput;
};


export type MutationCreateTeamArgs = {
  input: TeamInput;
};


export type MutationCreateVoiceAgentArgs = {
  input: CreateVoiceAgentInput;
};


export type MutationCreateWordDocumentTemplateArgs = {
  input: WordDocumentTemplateInput;
};


export type MutationCreateWorkflowDefinitionArgs = {
  input: CreateWorkflowDefinitionInput;
};


export type MutationCreateWorkflowExecutionArgs = {
  input: CreateWorkflowExecutionInput;
};


export type MutationDeleteAgencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeBaseFolderArgs = {
  folderId: Scalars['String']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeBaseItemsArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  folderIds: Array<Scalars['String']['input']>;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationDeleteMailboxSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProducerInformationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSmartFillBucketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDialOutboundCallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableAgencyUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisconnectMailboxArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableAgencyUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportCaraWorkspaceMessageArgs = {
  input: ExportCaraWorkspaceMessageInput;
};


export type MutationExtractSuperCopyArgs = {
  input: ExtractSuperCopyInput;
};


export type MutationFindAmsAccountArgs = {
  query: Scalars['String']['input'];
};


export type MutationFindAmsPolicyArgs = {
  query: Scalars['String']['input'];
};


export type MutationGeneratePresetQuestionsArgs = {
  input: GeneratePresetQuestionsInput;
};


export type MutationGrantCustomPresetAccessArgs = {
  agencyId: Scalars['ID']['input'];
  customPresetId: Scalars['ID']['input'];
};


export type MutationGrantKnowledgeBaseAccessArgs = {
  agencyId: Scalars['ID']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  role: KnowledgeBaseAccessRole;
};


export type MutationKeepClientsSeparateArgs = {
  candidateId: Scalars['ID']['input'];
};


export type MutationLinkClientWorkspaceArgs = {
  clientId: Scalars['ID']['input'];
  replaceExisting?: Scalars['Boolean']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationMergeClientsArgs = {
  candidateId: Scalars['ID']['input'];
  survivorClientId: Scalars['ID']['input'];
};


export type MutationMoveKnowledgeBaseDocumentsToFolderArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMoveKnowledgeBaseFolderArgs = {
  folderId: Scalars['String']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMoveKnowledgeBaseItemsToFolderArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  folderIds: Array<Scalars['String']['input']>;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationReconcileMailboxDraftsArgs = {
  mailboxDraftIds: Array<Scalars['ID']['input']>;
};


export type MutationRecordSmartFillEventArgs = {
  input: RecordSmartFillEventInput;
};


export type MutationReinstateBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: ReinstateBusinessPolicyInput;
};


export type MutationRemoveClientArtifactArgs = {
  artifactId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
};


export type MutationRemoveClientFileArgs = {
  clientId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};


export type MutationRemoveContactAssociationArgs = {
  accountId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRenameKnowledgeBaseFolderArgs = {
  folderId: Scalars['String']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenewBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: RenewBusinessPolicyInput;
};


export type MutationReplaceKnowledgeBaseDocumentArgs = {
  documentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationRequestAmsAccountRefreshArgs = {
  accountId: Scalars['ID']['input'];
  force?: Scalars['Boolean']['input'];
};


export type MutationResolveServiceRequestArgs = {
  id: Scalars['ID']['input'];
  input: ResolveServiceRequestInput;
};


export type MutationResolveSmartFillArgs = {
  input: ResolveSmartFillInput;
};


export type MutationRevokeCustomPresetAccessArgs = {
  agencyId: Scalars['ID']['input'];
  customPresetId: Scalars['ID']['input'];
};


export type MutationRevokeKnowledgeBaseAccessArgs = {
  agencyId: Scalars['ID']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationSendMailboxEmailArgs = {
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  contentRevision: Scalars['String']['input'];
  mailboxAccountId: Scalars['String']['input'];
};


export type MutationSetAgencyMeterOverageLimitArgs = {
  agencyId: Scalars['ID']['input'];
  limitDollars?: InputMaybe<Scalars['Float']['input']>;
  meterCode: ConsumptionMeterCode;
};


export type MutationSetAgencyUserOverageLimitArgs = {
  agencyUserId: Scalars['ID']['input'];
  limitDollars?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationSetDefaultMailboxArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetMailboxVisibilityArgs = {
  id: Scalars['ID']['input'];
  visibility: VisibilityConfigInput;
};


export type MutationSetParentAgencyArgs = {
  agencyId: Scalars['ID']['input'];
  numSeats: Scalars['Int']['input'];
  numVoiceAgents: Scalars['Int']['input'];
  parentAgencyId: Scalars['ID']['input'];
};


export type MutationStartPresetGenerationArgs = {
  input: StartPresetGenerationInput;
};


export type MutationStartTraceAnalysisArgs = {
  traceId: Scalars['ID']['input'];
};


export type MutationStopCaraWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitCallRatingArgs = {
  input: SubmitCallRatingInput;
};


export type MutationSubmitMessageRatingArgs = {
  input: SubmitMessageRatingInput;
};


export type MutationSyncIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncKnowledgeBaseUrlDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlinkClientWorkspaceArgs = {
  clientId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
};


export type MutationUpdateAgencyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAgencyInput;
};


export type MutationUpdateAgencyProfileArgs = {
  id: Scalars['ID']['input'];
  input: AgencyProfileInput;
};


export type MutationUpdateAgencyUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAgencyUserInput;
};


export type MutationUpdateAgencyUserPreferencesArgs = {
  input: AgencyUserPreferencesInput;
};


export type MutationUpdateBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: UpdateBusinessPolicyInput;
};


export type MutationUpdateCallsArgs = {
  callIds: Array<Scalars['ID']['input']>;
  input: UpdateCallInput;
};


export type MutationUpdateCaraWorkspaceArtifactArgs = {
  artifactId: Scalars['ID']['input'];
  input: UpdateCaraWorkspaceArtifactInput;
  version: Scalars['Int']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationUpdateCaraWorkspaceArtifactsArgs = {
  artifactIds: Array<Scalars['ID']['input']>;
  input: UpdateCaraWorkspaceArtifactsInput;
};


export type MutationUpdateCaraWorkspacesArgs = {
  input: UpdateCaraWorkspaceInput;
  workspaceIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateClientArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientInput;
};


export type MutationUpdateClientNoteArgs = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateContactArgs = {
  id: Scalars['ID']['input'];
  input: CreateAccountContactInput;
};


export type MutationUpdateCustomFormArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomFormInput;
};


export type MutationUpdateCustomPresetArgs = {
  id: Scalars['ID']['input'];
  input: CustomPresetInput;
};


export type MutationUpdateCustomPresetsArgs = {
  input: UpdateCustomPresetsInput;
  presetIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateExcelSpreadsheetTemplateArgs = {
  id: Scalars['ID']['input'];
  input: ExcelSpreadsheetTemplateInput;
};


export type MutationUpdateExcelSpreadsheetTemplatesArgs = {
  input: UpdateExcelSpreadsheetTemplatesInput;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateHtmlDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
  input: HtmlDocumentTemplateInput;
};


export type MutationUpdateHtmlDocumentTemplatesArgs = {
  input: UpdateHtmlDocumentTemplatesInput;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIntegrationInput;
};


export type MutationUpdateKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseInput;
};


export type MutationUpdateKnowledgeBaseAccessArgs = {
  agencyId: Scalars['ID']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  role: KnowledgeBaseAccessRole;
};


export type MutationUpdateKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseDocumentInput;
};


export type MutationUpdateKnowledgeBaseUrlDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseUrlDocumentInput;
};


export type MutationUpdateMemoryArgs = {
  input: UpdateMemoryInput;
};


export type MutationUpdateOutboundCallArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOutboundCallInput;
};


export type MutationUpdateProducerInformationArgs = {
  id: Scalars['ID']['input'];
  input: ProducerInformationInput;
};


export type MutationUpdateServiceRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateServiceRequestInput;
};


export type MutationUpdateSmartFillBucketArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSmartFillBucketInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateTeamArgs = {
  id: Scalars['ID']['input'];
  input: TeamInput;
};


export type MutationUpdateVoiceAgentArgs = {
  id: Scalars['ID']['input'];
  input: VoiceAgentInput;
};


export type MutationUpdateWordDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
  input: WordDocumentTemplateInput;
};


export type MutationUpdateWordDocumentTemplatesArgs = {
  input: UpdateWordDocumentTemplatesInput;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateWorkflowDefinitionArgs = {
  input: UpdateWorkflowDefinitionInput;
};


export type MutationUploadAccountFileArgs = {
  accountId: Scalars['ID']['input'];
  file: UploadFileInput;
};


export type MutationUploadCustomFormArgs = {
  input: UploadCustomFormInput;
};


export type MutationUploadHtmlDocumentTemplateFileArgs = {
  file: UploadFileInput;
  templateId: Scalars['ID']['input'];
};


export type MutationUploadKnowledgeBaseFileDocumentArgs = {
  input: UploadKnowledgeBaseFileDocumentInput;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationUploadPolicyFileArgs = {
  file: UploadFileInput;
  policyId: Scalars['ID']['input'];
};


export type MutationUploadWorkspaceFileArgs = {
  file: UploadFileInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationUpsertMailboxSignatureArgs = {
  input: MailboxSignatureInput;
};


export type MutationUpsertSmartFillOverrideArgs = {
  input: UpsertSmartFillOverrideInput;
};

/** A named additional insured for the certificate */
export type NamedAdditionalInsuredCertificateOption = {
  __typename?: 'NamedAdditionalInsuredCertificateOption';
  /** The address of the named additional insured */
  address: Address;
  /** The ID of the named additional insured */
  id: Scalars['ID']['output'];
  /** The name of the named additional insured */
  name: Scalars['String']['output'];
  /** The policy this named additional insured is associated with */
  policy: BusinessPolicy;
};

/**
 * One entry in the sidebar a profile can show or hide. Values name a page, or a
 * tab within a page, and correspond one-for-one to the navigation the AIS app
 * renders — `navigation.test.tsx` fails when the two drift apart.
 */
export enum NavigationItem {
  /** Communication › Calls */
  Calls = 'CALLS',
  /** Communication › Calls › Inbound */
  CallsInbound = 'CALLS_INBOUND',
  /** Communication › Calls › Outbound */
  CallsOutbound = 'CALLS_OUTBOUND',
  /** Communication › Calls › Report */
  CallsReport = 'CALLS_REPORT',
  /** Knowledge › Clients */
  Clients = 'CLIENTS',
  /** Copilot › Documents */
  Documents = 'DOCUMENTS',
  /** Communication › Mailbox › Inbox */
  Emails = 'EMAILS',
  /** Knowledge › Knowledge Base */
  KnowledgeBase = 'KNOWLEDGE_BASE',
  /** Copilot › Library › Custom Forms */
  LibraryCustomForms = 'LIBRARY_CUSTOM_FORMS',
  /** Copilot › Library › Excel Templates */
  LibraryExcelTemplates = 'LIBRARY_EXCEL_TEMPLATES',
  /** Copilot › Library › Styles */
  LibraryStyles = 'LIBRARY_STYLES',
  /** Copilot › Library › Templates */
  LibraryTemplates = 'LIBRARY_TEMPLATES',
  /** Copilot › Library › Word Templates */
  LibraryWordTemplates = 'LIBRARY_WORD_TEMPLATES',
  /** Communication › Mailbox › Outgoing */
  MailboxOutgoing = 'MAILBOX_OUTGOING',
  /** Copilot › Presets */
  Presets = 'PRESETS',
  /** Servicing › Service Requests */
  Servicing = 'SERVICING',
  /** Settings › Integrations */
  SettingsIntegrations = 'SETTINGS_INTEGRATIONS',
  /** Settings › Mailboxes */
  SettingsMailboxes = 'SETTINGS_MAILBOXES',
  /** Settings › Memory */
  SettingsMemory = 'SETTINGS_MEMORY',
  /** Settings › Teams */
  SettingsTeams = 'SETTINGS_TEAMS',
  /** Settings › Voice AI */
  SettingsVoice = 'SETTINGS_VOICE',
  /** Copilot › Workspaces */
  Workspaces = 'WORKSPACES'
}

/** Notification settings for the agency */
export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** Whether to send notifications when a new call is created */
  enableNewCallNotifications: Scalars['Boolean']['output'];
  /** Whether to send notifications when a new service request is created */
  enableNewServiceRequestNotifications: Scalars['Boolean']['output'];
  /** Email addresses to send new call notifications to */
  newCallNotificationEmailRecipients: Array<Scalars['String']['output']>;
  /** Email addresses to send new service request notifications to */
  newServiceRequestNotificationEmailRecipients: Array<Scalars['String']['output']>;
};

export type NowCertsCallFields = {
  __typename?: 'NowCertsCallFields';
  action?: Maybe<Scalars['String']['output']>;
  callLogId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type NowCertsClaimFields = {
  __typename?: 'NowCertsClaimFields';
  additionalComments?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  claimNumber?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateAmount?: Maybe<Array<NowCertsDateAmount>>;
  dateOfLoss?: Maybe<Scalars['String']['output']>;
  describeLocation?: Maybe<Scalars['String']['output']>;
  descriptionOfLoss?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  policeOrFire?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  reportNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** NowCertsConfiguration contains configuration for the NowCerts integration */
export type NowCertsConfiguration = {
  __typename?: 'NowCertsConfiguration';
  /** If enabled, will sync accounts from Cara to NowCerts. */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks: Scalars['Boolean']['output'];
  /**
   * The referral source value to set when creating a prospect in NowCerts.
   * If omitted or blank, no referral source will be set.
   */
  prospectReferralSource?: Maybe<Scalars['String']['output']>;
  /** NowCerts username for basic authentication */
  username: Scalars['String']['output'];
};

export type NowCertsCustomFieldSimple = {
  __typename?: 'NowCertsCustomFieldSimple';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NowCertsDateAmount = {
  __typename?: 'NowCertsDateAmount';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export type NowCertsDriverFields = {
  __typename?: 'NowCertsDriverFields';
  active?: Maybe<Scalars['Boolean']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  cdlDate?: Maybe<Scalars['String']['output']>;
  cdlYear?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyDriverNumber?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  driverAddressState?: Maybe<Scalars['String']['output']>;
  driverLicenseClass?: Maybe<Scalars['String']['output']>;
  driverLicenseStatusCode?: Maybe<Scalars['String']['output']>;
  driverOccupations?: Maybe<Array<Scalars['String']['output']>>;
  driverTypeCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  excluded?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  industryName?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  licenseYear?: Maybe<Scalars['Int']['output']>;
  licensedDate?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  occupationClassCode?: Maybe<Scalars['String']['output']>;
  occupationDesc?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Array<Scalars['String']['output']>>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type NowCertsFileFields = {
  __typename?: 'NowCertsFileFields';
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  visibleToInsured?: Maybe<Scalars['Boolean']['output']>;
};

export type NowCertsInsuredFields = {
  __typename?: 'NowCertsInsuredFields';
  active?: Maybe<Scalars['Boolean']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  agents?: Maybe<Array<Scalars['String']['output']>>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coInsuredDateOfBirth?: Maybe<Scalars['String']['output']>;
  coInsuredFirstName?: Maybe<Scalars['String']['output']>;
  coInsuredLastName?: Maybe<Scalars['String']['output']>;
  coInsuredMiddleName?: Maybe<Scalars['String']['output']>;
  commercialName?: Maybe<Scalars['String']['output']>;
  csrs?: Maybe<Array<Scalars['String']['output']>>;
  customFieldsSimple?: Maybe<Array<NowCertsCustomFieldSimple>>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dba?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  email3?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  greetingName?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredId?: Maybe<Scalars['String']['output']>;
  insuredType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<Array<Scalars['String']['output']>>;
  middleName?: Maybe<Scalars['String']['output']>;
  naic?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  primaryAgencyOfficeLocationName?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  smsPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeOfBusiness?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  xDatesAndLinesOfBusiness?: Maybe<Array<NowCertsXDateAndLineOfBusiness>>;
  yearBusinessStarted?: Maybe<Scalars['StringInt']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type NowCertsNoteFields = {
  __typename?: 'NowCertsNoteFields';
  body?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  isStickyNote?: Maybe<Scalars['Boolean']['output']>;
  noteType?: Maybe<Scalars['String']['output']>;
  opportunityDatabaseId?: Maybe<Scalars['String']['output']>;
  parentNoteId?: Maybe<Scalars['String']['output']>;
  policiesDatabaseIds?: Maybe<Array<Scalars['String']['output']>>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  stickyNoteColor?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type NowCertsOpportunityFields = {
  __typename?: 'NowCertsOpportunityFields';
  agencyCommission?: Maybe<Scalars['Float']['output']>;
  assignedTo?: Maybe<Array<Scalars['String']['output']>>;
  costOfLead?: Maybe<Scalars['Float']['output']>;
  createdFromRenewal?: Maybe<Scalars['Boolean']['output']>;
  currentStageDueDate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  lineOfBusinessName?: Maybe<Scalars['String']['output']>;
  neededBy?: Maybe<Scalars['String']['output']>;
  opportunityStageName?: Maybe<Scalars['String']['output']>;
  policyDatabaseId?: Maybe<Array<Scalars['String']['output']>>;
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  referralSourceContactName?: Maybe<Scalars['String']['output']>;
  referralSourceName?: Maybe<Scalars['String']['output']>;
  winProbability?: Maybe<Scalars['String']['output']>;
};

export type NowCertsPolicyFields = {
  __typename?: 'NowCertsPolicyFields';
  agencyCommissionPercent?: Maybe<Scalars['Float']['output']>;
  agencyCommissionValue?: Maybe<Scalars['Float']['output']>;
  agencyFee?: Maybe<Scalars['Float']['output']>;
  agents?: Maybe<Array<Scalars['String']['output']>>;
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  billingType?: Maybe<Scalars['String']['output']>;
  bindDate?: Maybe<Scalars['String']['output']>;
  binderId?: Maybe<Scalars['String']['output']>;
  blanketAI?: Maybe<Scalars['Boolean']['output']>;
  blanketWS?: Maybe<Scalars['Boolean']['output']>;
  businessSubType?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  checkPolicyOnNumber?: Maybe<Scalars['Boolean']['output']>;
  csrs?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  financeCompanyName?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  isPolicyRenewal?: Maybe<Scalars['Boolean']['output']>;
  lineOfBusinessName?: Maybe<Scalars['String']['output']>;
  lineOfBusinessNames?: Maybe<Array<Scalars['String']['output']>>;
  manualStatus?: Maybe<Scalars['String']['output']>;
  mgaName?: Maybe<Scalars['String']['output']>;
  mortgageBilled?: Maybe<Scalars['Boolean']['output']>;
  nonPremium?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  parentPolicyId?: Maybe<Scalars['String']['output']>;
  policyFee?: Maybe<Scalars['Float']['output']>;
  policyTerm?: Maybe<Scalars['Int']['output']>;
  policyURL?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  premiumSent?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  referralSourceCompanyName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusChangeDate?: Maybe<Scalars['String']['output']>;
  taxes?: Maybe<Scalars['Float']['output']>;
};

export type NowCertsPrincipalFields = {
  __typename?: 'NowCertsPrincipalFields';
  birthday?: Maybe<Scalars['String']['output']>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessFax?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dlNumber?: Maybe<Scalars['String']['output']>;
  dlState?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  isDriver?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  matchRecordBaseOnName?: Maybe<Scalars['Boolean']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  officePhone?: Maybe<Scalars['String']['output']>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  personalFax?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type NowCertsPropertyFields = {
  __typename?: 'NowCertsPropertyFields';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  anyAreaLeasedToOthers?: Maybe<Scalars['String']['output']>;
  attachToPolicyNumber?: Maybe<Scalars['String']['output']>;
  buildingNumber?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionOfOperations?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  locationNumber?: Maybe<Scalars['String']['output']>;
  numStories?: Maybe<Scalars['Float']['output']>;
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  propertyUse?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type NowCertsProspectFields = {
  __typename?: 'NowCertsProspectFields';
  active?: Maybe<Scalars['Boolean']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  agents?: Maybe<Array<Scalars['String']['output']>>;
  businessType?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coInsuredDateOfBirth?: Maybe<Scalars['String']['output']>;
  coInsuredFirstName?: Maybe<Scalars['String']['output']>;
  coInsuredLastName?: Maybe<Scalars['String']['output']>;
  coInsuredMiddleName?: Maybe<Scalars['String']['output']>;
  commercialName?: Maybe<Scalars['String']['output']>;
  csrs?: Maybe<Array<Scalars['String']['output']>>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dba?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  greetingName?: Maybe<Scalars['String']['output']>;
  insuredId?: Maybe<Scalars['String']['output']>;
  insuredType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<Array<Scalars['String']['output']>>;
  middleName?: Maybe<Scalars['String']['output']>;
  naic?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  referralSourceCompanyName?: Maybe<Scalars['String']['output']>;
  smsPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  yearBusinessStarted?: Maybe<Scalars['StringInt']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type NowCertsTagFields = {
  __typename?: 'NowCertsTagFields';
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  tagNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type NowCertsTaskFields = {
  __typename?: 'NowCertsTaskFields';
  assignedTo?: Maybe<Array<Scalars['String']['output']>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  completion?: Maybe<Scalars['Int']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  opportunityDatabaseId?: Maybe<Scalars['String']['output']>;
  policiesDatabaseIds?: Maybe<Array<Scalars['String']['output']>>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  taskDatabaseId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workGroupName?: Maybe<Scalars['String']['output']>;
};

export type NowCertsVehicleFields = {
  __typename?: 'NowCertsVehicleFields';
  active?: Maybe<Scalars['Boolean']['output']>;
  deductibleCollision?: Maybe<Scalars['Int']['output']>;
  deductibleComprehensive?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drivers?: Maybe<Array<Scalars['String']['output']>>;
  estimatedAnnualDistance?: Maybe<Scalars['String']['output']>;
  hasSalvage?: Maybe<Scalars['Boolean']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  registrationExpirationDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeOfUse?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['Boolean']['output']>;
  year?: Maybe<Scalars['StringInt']['output']>;
};

/** Represents a tool for managing all NowCerts entities (insureds/prospects/policies/tasks/notes/etc.). */
export type NowCertsWriteTool = {
  __typename?: 'NowCertsWriteTool';
  input: NowCertsWriteToolInput;
  output: NowCertsWriteToolOutput;
};

export type NowCertsWriteToolInput = {
  __typename?: 'NowCertsWriteToolInput';
  call?: Maybe<NowCertsCallFields>;
  claim?: Maybe<NowCertsClaimFields>;
  driver?: Maybe<NowCertsDriverFields>;
  file?: Maybe<NowCertsFileFields>;
  insured?: Maybe<NowCertsInsuredFields>;
  note?: Maybe<NowCertsNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<NowCertsOpportunityFields>;
  policy?: Maybe<NowCertsPolicyFields>;
  principal?: Maybe<NowCertsPrincipalFields>;
  property?: Maybe<NowCertsPropertyFields>;
  prospect?: Maybe<NowCertsProspectFields>;
  tag?: Maybe<NowCertsTagFields>;
  task?: Maybe<NowCertsTaskFields>;
  vehicle?: Maybe<NowCertsVehicleFields>;
};

export type NowCertsWriteToolOutput = {
  __typename?: 'NowCertsWriteToolOutput';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type NowCertsXDateAndLineOfBusiness = {
  __typename?: 'NowCertsXDateAndLineOfBusiness';
  lineOfBusinessName?: Maybe<Scalars['String']['output']>;
  xDate?: Maybe<Scalars['String']['output']>;
};

export type NumericFilter = {
  /** Filter for numbers greater than this value */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Filter for numbers less than this value */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
};

/** A knowledge base document (latest version) in the LIST hierarchy. */
export type OrganizeKnowledgeBaseDocumentInfo = {
  __typename?: 'OrganizeKnowledgeBaseDocumentInfo';
  id: Scalars['String']['output'];
  /**
   * The user-facing name for this document: display name when set, otherwise the
   * indexed metadata title, otherwise the persisted title (typically the upload
   * filename for FILE documents).
   */
  title: Scalars['String']['output'];
};

/**
 * A folder in the LIST hierarchy, nesting its child folders and a sample of its
 * documents.
 */
export type OrganizeKnowledgeBaseFolderNode = {
  __typename?: 'OrganizeKnowledgeBaseFolderNode';
  /** Folders nested directly under this one. */
  childFolders?: Maybe<Array<OrganizeKnowledgeBaseFolderNode>>;
  /**
   * The number of documents directly in this folder (all versions counted once);
   * under a query this counts only the matching documents. May exceed
   * len(documents) when more than the per-folder sample limit are present.
   */
  docCount: Scalars['Int']['output'];
  /** A sample of the documents directly in this folder, up to a per-folder limit. */
  documents?: Maybe<Array<OrganizeKnowledgeBaseDocumentInfo>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * A knowledge base the agent can write to, returned by LIST when the agency has
 * more than one and none was specified.
 */
export type OrganizeKnowledgeBaseInfo = {
  __typename?: 'OrganizeKnowledgeBaseInfo';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OrganizeKnowledgeBaseTool = {
  __typename?: 'OrganizeKnowledgeBaseTool';
  input: OrganizeKnowledgeBaseToolInput;
  output: OrganizeKnowledgeBaseToolOutput;
};

/** Input for the CREATE_FOLDER action of the OrganizeKnowledgeBaseTool. */
export type OrganizeKnowledgeBaseToolCreateFolderInput = {
  __typename?: 'OrganizeKnowledgeBaseToolCreateFolderInput';
  folderName: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['String']['output']>;
};

/** Result of the CREATE_FOLDER action. */
export type OrganizeKnowledgeBaseToolCreateFolderOutput = {
  __typename?: 'OrganizeKnowledgeBaseToolCreateFolderOutput';
  folderId: Scalars['String']['output'];
  folderName: Scalars['String']['output'];
};

/**
 * Input for the OrganizeKnowledgeBaseTool. Set action and fill the matching
 * sub-object. Use LIST first to discover folder and document IDs (it returns a
 * nested folder tree with a document count per folder). CREATE_FOLDER makes a
 * folder. MOVE_DOCUMENTS moves documents into one.
 */
export type OrganizeKnowledgeBaseToolInput = {
  __typename?: 'OrganizeKnowledgeBaseToolInput';
  action: Scalars['String']['output'];
  createFolder?: Maybe<OrganizeKnowledgeBaseToolCreateFolderInput>;
  knowledgeBaseId?: Maybe<Scalars['String']['output']>;
  list?: Maybe<OrganizeKnowledgeBaseToolListInput>;
  moveDocuments?: Maybe<OrganizeKnowledgeBaseToolMoveDocumentsInput>;
};

/** Input for the LIST action of the OrganizeKnowledgeBaseTool. */
export type OrganizeKnowledgeBaseToolListInput = {
  __typename?: 'OrganizeKnowledgeBaseToolListInput';
  query?: Maybe<Scalars['String']['output']>;
};

/** Result of the LIST action: the knowledge base's folder tree and documents. */
export type OrganizeKnowledgeBaseToolListOutput = {
  __typename?: 'OrganizeKnowledgeBaseToolListOutput';
  /**
   * True when a query was applied so the listing contains only matching documents
   * and the folders that hold them.
   */
  filtered: Scalars['Boolean']['output'];
  /** The root-level folders. Each nests its child folders and a document sample. */
  folders?: Maybe<Array<OrganizeKnowledgeBaseFolderNode>>;
  /**
   * Populated only when the agency has multiple knowledge bases and none was
   * specified. Call LIST again with one of these IDs.
   */
  knowledgeBases?: Maybe<Array<OrganizeKnowledgeBaseInfo>>;
  /** The number of documents at the root. May exceed len(rootDocuments). */
  rootDocumentCount: Scalars['Int']['output'];
  /** Documents at the root of the knowledge base (in no folder), up to a limit. */
  rootDocuments?: Maybe<Array<OrganizeKnowledgeBaseDocumentInfo>>;
  /** The total number of documents in the knowledge base across all folders. */
  totalDocumentCount: Scalars['Int']['output'];
};

/** Input for the MOVE_DOCUMENTS action of the OrganizeKnowledgeBaseTool. */
export type OrganizeKnowledgeBaseToolMoveDocumentsInput = {
  __typename?: 'OrganizeKnowledgeBaseToolMoveDocumentsInput';
  destinationFolderId?: Maybe<Scalars['String']['output']>;
  documentIds: Array<Scalars['String']['output']>;
};

/** Result of the MOVE_DOCUMENTS action. */
export type OrganizeKnowledgeBaseToolMoveDocumentsOutput = {
  __typename?: 'OrganizeKnowledgeBaseToolMoveDocumentsOutput';
  movedDocumentIds: Array<Scalars['String']['output']>;
};

/**
 * Result of an OrganizeKnowledgeBaseTool operation. The sub-object matching the
 * requested action is populated.
 */
export type OrganizeKnowledgeBaseToolOutput = {
  __typename?: 'OrganizeKnowledgeBaseToolOutput';
  action: Scalars['String']['output'];
  /** A question to ask the user when requiresClarification is true. */
  clarificationMessage?: Maybe<Scalars['String']['output']>;
  createFolder?: Maybe<OrganizeKnowledgeBaseToolCreateFolderOutput>;
  knowledgeBaseId: Scalars['String']['output'];
  list?: Maybe<OrganizeKnowledgeBaseToolListOutput>;
  moveDocuments?: Maybe<OrganizeKnowledgeBaseToolMoveDocumentsOutput>;
  /** True when the tool needs the user to confirm which knowledge base to use. */
  requiresClarification: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * An outbound call job: schedule, dial intent, retry policy, and attempt timeline.
 * Conversation details live on the linked Call row once Retell connects.
 */
export type OutboundCall = {
  __typename?: 'OutboundCall';
  /** The agency that owns this outbound call */
  agency: Agency;
  /** Prompt and behavior configuration for the call */
  callConfig: OutboundCallConfig;
  /**
   * Phone conversations placed for this job (oldest first), resolved from Call rows
   * linked by outboundCallId. Dial attempt history is derived from these Calls —
   * not an embedded JSON array on the job.
   */
  calls: Array<Call>;
  /** When this outbound call job was created */
  createdAt: Scalars['Time']['output'];
  /** The user who created this outbound call */
  createdBy: AgencyUser;
  /** Customer contact details for this call */
  customer: OutboundCallCustomer;
  /** Unique identifier for the outbound call job */
  id: Scalars['ID']['output'];
  /** The most recent linked phone conversation, if any */
  latestCall?: Maybe<Call>;
  /** Retry behavior for this job */
  retryPolicy: OutboundCallRetryPolicy;
  /** When the call should be placed */
  schedule: OutboundCallSchedule;
  /** How this outbound call was created */
  source: OutboundCallSource;
  /** Current job status */
  status: OutboundCallStatus;
  /** When this outbound call job was last updated */
  updatedAt: Scalars['Time']['output'];
  /** Optimistic concurrency / version stamp (Unix ms) */
  version: Scalars['Int64']['output'];
  /**
   * Visibility controls for this outbound call.
   * Stored but not yet enforced in list queries — defaults to PUBLIC.
   */
  visibility: VisibilityConfig;
  /** The outbound voice agent that will place this call */
  voiceAgent: VoiceAgent;
};

export type OutboundCallConfig = {
  __typename?: 'OutboundCallConfig';
  callObjective: Scalars['String']['output'];
  /**
   * Optional direct callback number Cara should give the customer on this call.
   * When omitted, Cara uses the agency phone from voice agent settings.
   */
  callbackPhone?: Maybe<Scalars['String']['output']>;
  customerContext?: Maybe<Scalars['String']['output']>;
  /**
   * File IDs for context extraction on this call.
   * TODO: UI and ingestion deferred — field kept for forward compatibility
   * (same pattern as OutboundCall.visibility). Always empty until wired.
   */
  fileIds: Array<Scalars['String']['output']>;
  guidelines?: Maybe<Scalars['String']['output']>;
  leaveVoicemail: Scalars['Boolean']['output'];
};

export type OutboundCallConfigInput = {
  callObjective: Scalars['String']['input'];
  /** Optional direct callback number for this call. Omit to use the agency phone. */
  callbackPhone?: InputMaybe<Scalars['String']['input']>;
  customerContext?: InputMaybe<Scalars['String']['input']>;
  /**
   * TODO: UI and ingestion deferred — field kept for forward compatibility
   * (same pattern as visibility). Clients should omit or send [].
   */
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  guidelines?: InputMaybe<Scalars['String']['input']>;
  leaveVoicemail: Scalars['Boolean']['input'];
};

/** A cursor-paginated connection of OutboundCall records. */
export type OutboundCallConnection = {
  __typename?: 'OutboundCallConnection';
  edges: Array<OutboundCallEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCallCustomer = {
  __typename?: 'OutboundCallCustomer';
  /**
   * Customer's full name. Cara addresses them by first name on the call;
   * verification matches against the full name.
   */
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type OutboundCallCustomerInput = {
  /**
   * Customer's full name (required). Cara addresses them by first name on the call;
   * verification matches against the full name.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type OutboundCallDailyCount = {
  __typename?: 'OutboundCallDailyCount';
  completed: Scalars['Int']['output'];
  date: Scalars['Time']['output'];
  failed: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
};

/** An edge in a paginated OutboundCall connection. */
export type OutboundCallEdge = {
  __typename?: 'OutboundCallEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCall;
};

/**
 * Rolling-window usage of AI outbound calls to a customer phone number.
 * Count includes placed dials and in-flight scheduled jobs. Used by the
 * create/edit UI and the pre-dial gate.
 */
export type OutboundCallFrequency = {
  __typename?: 'OutboundCallFrequency';
  /** Outbound jobs toward the limit for this phone in the window. */
  count: Scalars['Int']['output'];
  /** Maximum calls allowed in the window (currently 3). */
  limit: Scalars['Int']['output'];
  /** How many additional calls may still be placed (limit - count, floored at 0). */
  remaining: Scalars['Int']['output'];
  /** Length of the rolling window in days (currently 30). */
  windowDays: Scalars['Int']['output'];
};

export type OutboundCallReport = {
  __typename?: 'OutboundCallReport';
  dailyCounts: Array<OutboundCallDailyCount>;
  statusCounts: Array<OutboundCallStatusCount>;
  totalCalls: Scalars['Int']['output'];
  voicemailEnabledCount: Scalars['Int']['output'];
};

export type OutboundCallReportFilterInput = {
  voiceAgentId?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundCallRetryPolicy = {
  __typename?: 'OutboundCallRetryPolicy';
  maxAttempts: Scalars['Int']['output'];
  retryAfterVoicemail: Scalars['Boolean']['output'];
  retryIntervalMinutes: Scalars['Int']['output'];
};

export type OutboundCallRetryPolicyInput = {
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  retryAfterVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  retryIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type OutboundCallSchedule = {
  __typename?: 'OutboundCallSchedule';
  /** When to place the call. Null means immediate once the job is started. */
  scheduledAt?: Maybe<Scalars['Time']['output']>;
  timezone: Scalars['String']['output'];
};

export type OutboundCallScheduleInput = {
  /** When true, scheduledAt is required. When false, the call is placed as soon as the job starts. */
  scheduleLater: Scalars['Boolean']['input'];
  scheduledAt?: InputMaybe<Scalars['Time']['input']>;
  timezone: Scalars['String']['input'];
};

/** Sortable fields for searchOutboundCalls */
export enum OutboundCallSortField {
  CreatedBy = 'CREATED_BY',
  Customer = 'CUSTOMER',
  Objective = 'OBJECTIVE',
  Phone = 'PHONE',
  ScheduledAt = 'SCHEDULED_AT',
  Status = 'STATUS'
}

/** Sort specification for searchOutboundCalls */
export type OutboundCallSortInput = {
  direction: SortDirection;
  field: OutboundCallSortField;
};

export type OutboundCallSource = {
  __typename?: 'OutboundCallSource';
  emailThreadId?: Maybe<Scalars['String']['output']>;
  trigger: OutboundCallSourceTrigger;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/**
 * Provenance for how an outbound call job was created.
 * Omit on CreateOutboundCallInput to default to MANUAL.
 * Not set by DRAFT_OUTBOUND_CALL — clients pass this when confirming/creating the job.
 */
export type OutboundCallSourceInput = {
  /**
   * Draft artifact ID from DRAFT_OUTBOUND_CALL. When provided with workspaceId,
   * createOutboundCall links the created job onto that draft's tool output
   * (outboundCallId) so confirmation survives refresh. Not stored on OutboundCallSource.
   */
  draftArtifactId?: InputMaybe<Scalars['String']['input']>;
  /** Required when trigger is EMAIL. Email thread that initiated the draft. */
  emailThreadId?: InputMaybe<Scalars['String']['input']>;
  trigger: OutboundCallSourceTrigger;
  /** Required when trigger is COPILOT. Workspace that produced the draft. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export enum OutboundCallSourceTrigger {
  Copilot = 'COPILOT',
  Email = 'EMAIL',
  Manual = 'MANUAL'
}

export enum OutboundCallStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Dialing = 'DIALING',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NoAnswer = 'NO_ANSWER',
  PendingConfirmation = 'PENDING_CONFIRMATION',
  Scheduled = 'SCHEDULED',
  VoicemailLeft = 'VOICEMAIL_LEFT'
}

export type OutboundCallStatusCount = {
  __typename?: 'OutboundCallStatusCount';
  count: Scalars['Int']['output'];
  status: OutboundCallStatus;
};

export enum OutboundCallUpdateType {
  CancelOutboundCall = 'CANCEL_OUTBOUND_CALL',
  CreateOutboundCall = 'CREATE_OUTBOUND_CALL',
  UpdateOutboundCall = 'UPDATE_OUTBOUND_CALL'
}

export type OutboundCallsFilterInput = {
  /** When true, return only outbound calls created by the authenticated user. */
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to outbound calls created by a specific agency user. */
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OutboundCallStatus>;
  /** Reserved for future visibility enforcement. */
  visibility?: InputMaybe<VisibilityListFilterInput>;
  voiceAgentId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One email a human committed to sending: what went out, from which connected
 * mailbox, and how it resolved. Written once when the send is claimed and once
 * more when it resolves; nothing else mutates it, so the row is its own audit
 * trail.
 */
export type OutboundEmail = {
  __typename?: 'OutboundEmail';
  artifactVersion: Scalars['Int']['output'];
  attachments: Array<OutboundEmailAttachment>;
  bcc: Array<OutboundEmailAddress>;
  cc: Array<OutboundEmailAddress>;
  createdAt: Scalars['Time']['output'];
  /**
   * How the send failed, classified rather than described. Null on any status
   * but FAILED.
   *
   * This is what a reader branches on. `failureReason` is prose, free to be
   * reworded by a later deploy, so pick your wording from this field and keep
   * the reason as detail behind it.
   */
  failureKind?: Maybe<OutboundEmailFailureKind>;
  /**
   * Why a FAILED send failed, in a sentence written for the person who clicked
   * send. Empty on every other status.
   *
   * Rows written before this field was humanized carry the provider's own error
   * text instead, which is diagnostic rather than actionable: render it as detail
   * a reader can reach for, never as the headline.
   */
  failureReason: Scalars['String']['output'];
  fromAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * The RFC 5322 Message-ID of the sent mail when the provider reported one:
   * the durable key for recognizing replies.
   */
  internetMessageId: Scalars['String']['output'];
  /**
   * The connected mailbox it was sent from, denormalized: the ID is retained
   * even after that mailbox is disconnected.
   */
  mailboxAccountId: Scalars['String']['output'];
  /**
   * True when Cara asked the provider to send and never learned the outcome, so
   * the recipient may or may not have this email. Retrying such a send can
   * deliver it twice, which is why this is a field rather than something a client
   * infers from `failureReason`: the wording of a failure may be rewritten, and a
   * reworded message must not be able to reclassify a dangerous state as a safe
   * one.
   *
   * Read as a fact about Cara's knowledge, not about the mail. True never means
   * "sent" and false never means "not sent" — it means only that nothing here can
   * answer the question.
   *
   * False on SENDING and SENT: a resolved send is confirmed by definition, and an
   * unresolved one is still expected to answer for itself. A SENDING row that has
   * stopped moving is a client-side judgement about elapsed time, which the
   * server has no business making on its behalf.
   */
  sendUnconfirmed: Scalars['Boolean']['output'];
  sentAt?: Maybe<Scalars['Time']['output']>;
  /** Who clicked send. Null once that user is offboarded; the send itself stays. */
  sentByUserId?: Maybe<Scalars['String']['output']>;
  /**
   * True when the mail left the mailbox without passing through Cara: the agent
   * opened a draft Cara had written into their Drafts folder and pressed send in
   * their own mail client. Cara reconstructed the send afterwards from the copy
   * the provider holds, which is why several fields a Cara send always carries
   * are empty here rather than missing:
   *
   * `sentByUserId` is null, because nobody clicked send in Cara. The attachment
   * manifest is empty and the body was never recorded, because the sent copy
   * reports neither without further calls the send log has no reader for.
   * `subject`, the recipients, and `sentAt` come from the provider's own record
   * of the message that went out, so they reflect any edit made in the mail
   * client rather than what Cara last handed over.
   *
   * Such a send closes its artifact version exactly as a Cara send does: the
   * recipient has the email, so sending it again takes a new draft.
   */
  sentExternally: Scalars['Boolean']['output'];
  status: OutboundEmailStatus;
  subject: Scalars['String']['output'];
  to: Array<OutboundEmailAddress>;
  updatedAt: Scalars['Time']['output'];
  /** The EMAIL artifact that was sent, and the version the click committed. */
  workspaceArtifactId: Scalars['String']['output'];
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/**
 * A recipient as recorded on the send, stamped at send time rather than
 * resolved later: the record must survive the contact changing.
 */
export type OutboundEmailAddress = {
  __typename?: 'OutboundEmailAddress';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * What rode along, by name and size. The bytes stay in artifact and file
 * storage; this is the manifest.
 */
export type OutboundEmailAttachment = {
  __typename?: 'OutboundEmailAttachment';
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export type OutboundEmailConnection = {
  __typename?: 'OutboundEmailConnection';
  edges: Array<OutboundEmailEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundEmailEdge = {
  __typename?: 'OutboundEmailEdge';
  cursor: Scalars['String']['output'];
  node: OutboundEmail;
};

/**
 * Why a send failed, in the vocabulary the mailbox provider contract classifies
 * failures with. Every value but the last two names a verdict a provider gave.
 *
 * Values exist to be branched on, so a client that meets one it does not know
 * must fall back to generic wording rather than guess — new providers can add
 * reactions this enum has to grow for.
 */
export enum OutboundEmailFailureKind {
  /** Authentication worked but there is no usable mailbox behind it. */
  AccountUnavailable = 'ACCOUNT_UNAVAILABLE',
  /** The organization requires an administrator to approve this app. */
  ConsentRequired = 'CONSENT_REQUIRED',
  /**
   * Cara's own send died before the provider gave any verdict. Not a provider
   * kind: these rows exist because the question was never answered, so the
   * `failureReason` written for them is the only account of what happened and is
   * addressed to a person.
   */
  Interrupted = 'INTERRUPTED',
  /** The item the send referred to does not resolve any more. */
  NotFound = 'NOT_FOUND',
  /** The grant is alive but lacks a scope the send needed. */
  PermissionDenied = 'PERMISSION_DENIED',
  /** The authorization grant is dead; the mailbox must be reconnected. */
  ReauthRequired = 'REAUTH_REQUIRED',
  /** The provider rate-limited the request; trying later is the remedy. */
  Throttled = 'THROTTLED',
  /** The message or an attachment exceeds a provider ceiling. */
  TooLarge = 'TOO_LARGE',
  /** The provider failed temporarily. Retrying should work. */
  Transient = 'TRANSIENT',
  /** The provider answered and the adapter could not classify the answer. */
  Unknown = 'UNKNOWN',
  /**
   * No kind was captured. Says nothing about the failure itself — only that
   * `failureReason` on this row may be raw provider text.
   */
  Unrecorded = 'UNRECORDED',
  /** The operation does not apply to this item or account. */
  Unsupported = 'UNSUPPORTED'
}

export enum OutboundEmailSortField {
  CreatedAt = 'CREATED_AT',
  SentAt = 'SENT_AT',
  Status = 'STATUS',
  Subject = 'SUBJECT'
}

export type OutboundEmailSortInput = {
  direction: SortDirection;
  field: OutboundEmailSortField;
};

/**
 * How a send resolved. There is no pending state: a row exists only because a
 * human clicked send, and it is created already SENDING. A row still SENDING
 * long after creation means the process died mid-send — outcome unknown.
 */
export enum OutboundEmailStatus {
  Failed = 'FAILED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type OutboundEmailsFilterInput = {
  mailboxAccountId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Narrows to the sends belonging to emails the outbox filter matches. See
   * OutboxFilterInput for why this is answered against the whole email rather
   * than against the send row.
   */
  outbox?: InputMaybe<OutboxFilterInput>;
  /** When true, return only sends the authenticated user committed. */
  sentByMe?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<OutboundEmailStatus>;
  workspaceArtifactId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Stored record that an agency user acknowledged a specific outbound voice compliance disclosure. */
export type OutboundVoiceComplianceAcknowledgment = {
  __typename?: 'OutboundVoiceComplianceAcknowledgment';
  /** When the acknowledgment was recorded */
  acknowledgedAt: Scalars['Time']['output'];
  /** Agency user who acknowledged the disclosure */
  acknowledgedByUserId: Scalars['ID']['output'];
  /** Disclosure text version that was shown and acknowledged */
  disclosureVersion: Scalars['String']['output'];
};

/** Versioned outbound voice compliance disclosure presented before first outbound agent creation. */
export type OutboundVoiceComplianceDisclosure = {
  __typename?: 'OutboundVoiceComplianceDisclosure';
  /** Checkbox label the user must accept before proceeding */
  acknowledgmentLabel: Scalars['String']['output'];
  /** Introductory paragraph before the sections */
  intro: Scalars['String']['output'];
  /** Body sections of the disclosure */
  sections: Array<OutboundVoiceComplianceDisclosureSection>;
  /** Dialog title */
  title: Scalars['String']['output'];
  /** Stable identifier for this disclosure text. Bumped when the text materially changes. */
  version: Scalars['String']['output'];
};

/** One headed section of the outbound voice compliance disclosure */
export type OutboundVoiceComplianceDisclosureSection = {
  __typename?: 'OutboundVoiceComplianceDisclosureSection';
  /** Section body (plain text; paragraphs separated by blank lines) */
  body: Scalars['String']['output'];
  /** Section heading */
  heading: Scalars['String']['output'];
};

/**
 * Narrows a source of the outbox by a property of the whole email rather than of
 * the record being read.
 *
 * Every field here is answered against the email -- the artifact, its draft and
 * its sends together -- and not against the row the query is walking. That is
 * what makes it safe to hand the same `OutboxFilterInput` to all three of
 * `searchCaraWorkspaceArtifacts`, `searchMailboxDrafts` and `searchOutboundEmails`
 * and merge the results: a matching email is matched in every ledger that holds a
 * record of it, so a client merging the three lists sees each matching email
 * whole, with the same status it would have had unfiltered. A filter answered
 * against one row at a time could not promise that -- it would drop the send and
 * keep the draft, and the merged row would report "waiting in Drafts" for an
 * email that had already failed to go out.
 *
 * An email with no artifact id to gather its records under is matched on the
 * record at hand, since there is nothing else it could be matched on.
 *
 * Omitting the input entirely narrows nothing.
 */
export type OutboxFilterInput = {
  /**
   * Keeps only emails this user had a hand in: they opened the workspace it was
   * composed in, asked Cara for the draft, or committed the send. One field for
   * the three, because "my email" means all of them and the ledgers name them
   * differently.
   */
  actedByUserID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Keeps only emails with activity after this instant -- composed, drafted or
   * sent since then. The outbox is ordered by last activity, so this is the lower
   * bound on the column it is already sorted by.
   */
  activeAfter?: InputMaybe<Scalars['Time']['input']>;
  /**
   * The instant before which an unresolved send counts as INTERRUPTED rather than
   * SENDING. The client that draws the badge owns this threshold. With no value,
   * SENDING and INTERRUPTED both select every unresolved send.
   */
  interruptedBefore?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Keeps only emails that reached this mailbox, as a draft or as a send. An
   * email Cara composed and never wrote into a mailbox reaches none, and is
   * therefore never a match.
   */
  mailboxAccountID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Free text over what the email is called and who it went to: the artifact's
   * title in any version, the subject stamped on any send of it, and the
   * recipients recorded on those sends.
   *
   * Drafts contribute nothing but their artifact's title. The provider owns a
   * draft's contents, so Cara stores neither the words nor the addressees of one
   * and has nothing else about it to search.
   */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Keeps only emails whose derived status is one of these. An empty list means
   * no restriction, not "match nothing".
   */
  statuses?: InputMaybe<Array<OutboxStatus>>;
};

/**
 * How far an email has got, in the vocabulary the outbox badges it with.
 *
 * Derived, never stored. One email leaves records in three ledgers -- the
 * artifact Cara composed, the draft written into a mailbox, and the send -- and
 * the furthest of those that exists decides the value: a send outranks the draft
 * it was sent from, and a draft outranks the artifact it was written from. No
 * column holds this, so every read that narrows by it derives it again.
 *
 * CHECKING has no value here. It describes a row whose provider copy is being
 * re-read at this moment, which is a fact about one open tab rather than about
 * the email, and a stored ledger has no way to answer for it.
 */
export enum OutboxStatus {
  /** Retired for a reason this build does not recognize. */
  Closed = 'CLOSED',
  /** Written in Cara and never put in a mailbox: no draft, no send. */
  Composed = 'COMPOSED',
  /** The provider refused the send, or Cara could not establish that it happened. */
  Failed = 'FAILED',
  /** Gone from the Drafts folder with nothing in the mailbox to say it was sent. */
  GoneUnproven = 'GONE_UNPROVEN',
  /**
   * Still unresolved long enough that the process handling it is presumed dead.
   * Only distinguishable from SENDING when the caller supplies
   * `interruptedBefore`; without it the two are the same set.
   */
  Interrupted = 'INTERRUPTED',
  /** Sitting in a Drafts folder, waiting for somebody to send it. */
  InMailbox = 'IN_MAILBOX',
  /** The draft was replaced by a newer draft of the same email. */
  Replaced = 'REPLACED',
  /** Handed to the provider and not yet resolved. */
  Sending = 'SENDING',
  /**
   * Sent through Cara, or sent from a draft Cara later found gone with a sent
   * copy of its own in the mailbox.
   */
  Sent = 'SENT',
  /**
   * A sent copy is in the mailbox but the send went out from the mail client, so
   * Cara has no delivery record of it.
   */
  SentFromMailClient = 'SENT_FROM_MAIL_CLIENT',
  /** Cara withdrew the draft from the mailbox. */
  Withdrawn = 'WITHDRAWN'
}

/** Live overage charge for the open usage period. Pre-tax; tax appears on the Stripe invoice. */
export type OverageBillEstimate = {
  __typename?: 'OverageBillEstimate';
  deliveryMethod: OverageDeliveryMethod;
  estimatedChargeDate: Scalars['Time']['output'];
  isEstimate: Scalars['Boolean']['output'];
  lineItems: Array<OverageBillLineItem>;
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  subtotalDollars: Scalars['Float']['output'];
  totalDollars: Scalars['Float']['output'];
};

/** Per-meter overage line shared by the live estimate and settled invoices. */
export type OverageBillLineItem = {
  __typename?: 'OverageBillLineItem';
  amountDollars: Scalars['Float']['output'];
  billableUnitsUsed: Scalars['Decimal']['output'];
  includedUnits: Scalars['Int']['output'];
  meterCode: ConsumptionMeterCode;
  overageUnits: Scalars['Decimal']['output'];
  ratePerUnit: Scalars['Float']['output'];
};

/** How an overage charge is delivered on Stripe. */
export enum OverageDeliveryMethod {
  OnNextSubscriptionInvoice = 'ON_NEXT_SUBSCRIPTION_INVOICE',
  Standalone = 'STANDALONE'
}

/**
 * Platform-unit spend vs an optional dollar overage budget.
 * Org-wide: units above the shared included allotment.
 * Per-user: that user's platform units after the shared included pool is
 * exhausted (phased overage), not all of the user's units.
 * The configured budget lives on AgencySubscription /
 * AgencyUser.platformUnitOverageLimitDollars — not duplicated here.
 */
export type OverageSpendStatus = {
  __typename?: 'OverageSpendStatus';
  /** True when overageDollars is at or above 80% of the effective budget. */
  alertThresholdReached: Scalars['Boolean']['output'];
  /**
   * Equivalent unit quantity for the configured dollar budget at the published
   * overage rate. Null when the meter has no published overage rate.
   */
  equivalentUnitsLimit?: Maybe<Scalars['Decimal']['output']>;
  /** True when overageDollars is at or above the effective budget (nil limit = 0). */
  limitReached: Scalars['Boolean']['output'];
  /** Units converted to USD at the published platform-unit overage rate. */
  overageDollars: Scalars['Float']['output'];
  /** Platform units counted toward this scope's budget. */
  overageUnits: Scalars['Decimal']['output'];
  /**
   * overageDollars / configured budget. Null when the meter has no published
   * overage rate.
   */
  percentOfLimit?: Maybe<Scalars['Float']['output']>;
};

export type PdfEditorTool = {
  __typename?: 'PDFEditorTool';
  /** The input arguments for the PDF editing */
  input: PdfEditorToolInput;
  /** The result of the PDF editing operation */
  output: PdfEditorToolOutput;
};

export type PdfEditorToolInput = {
  __typename?: 'PDFEditorToolInput';
  /** The ID of an existing custom form artifact to update with new field values. */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** A JSON object whose keys match the field keys from DESCRIBE and values are the fill data. */
  fieldsJson?: Maybe<Scalars['String']['output']>;
  /** The instructions for filling out the form */
  formFillInstructions: Scalars['String']['output'];
  /** The ID of the custom form from the library to describe or fill. */
  formId?: Maybe<Scalars['String']['output']>;
  inputFiles: Array<PdfEditorToolInputFile>;
  /** The operation to perform on the PDF editor */
  operation: Scalars['String']['output'];
};

export type PdfEditorToolInputFile = {
  __typename?: 'PDFEditorToolInputFile';
  fileIdOrArtifactId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type PdfEditorToolOutput = {
  __typename?: 'PDFEditorToolOutput';
  /** The artifact produced by a FILL operation on a library custom form. */
  artifact?: Maybe<CustomFormToolArtifact>;
  /** The ID of the artifact resulting from the PDF edit */
  artifactId?: Maybe<Scalars['String']['output']>;
  /**
   * The ID of the file resulting from the PDF edit
   * @deprecated Use artifactId instead. This field is kept for backward compatibility with existing tool calls.
   */
  fileId?: Maybe<Scalars['String']['output']>;
  /** The described custom form including schema and fill instructions (populated for DESCRIBE operation). */
  form?: Maybe<CustomFormListItem>;
  /** The list of available custom forms from the library (populated for LIST operation). */
  forms?: Maybe<Array<CustomFormListItem>>;
  /** The result of the PDF edit operation */
  result: Scalars['String']['output'];
  /** The version of the artifact resulting from the PDF edit */
  version?: Maybe<Scalars['Int']['output']>;
};

/** Page information for cursor-based pagination */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PageStyle = {
  __typename?: 'PageStyle';
  /** Page background color in hex format (e.g. '#ffffff') */
  backgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Page margins in inches */
  margin: MarginStyle;
  /** Page size in standard paper sizes (e.g. 'A4', 'Letter', 'Legal') */
  size?: Maybe<Scalars['String']['output']>;
};

/** Input for page layout settings */
export type PageStyleInput = {
  /** Background color for the page, as a CSS hex string (e.g. '#ffffff') */
  backgroundColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Margin settings for the page */
  margin?: InputMaybe<MarginStyleInput>;
  /** Page size (e.g. 'letter', 'A4', or custom) */
  size?: InputMaybe<Scalars['String']['input']>;
};

/** Paragraph style */
export type ParagraphStyle = {
  __typename?: 'ParagraphStyle';
  /** Text color in hex format (e.g. '#334155') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Font family name (overrides global typography when set) */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size in points (e.g. 11.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Font style (e.g. 'normal', 'italic') */
  fontStyle?: Maybe<Scalars['String']['output']>;
  /** Font weight as a number (e.g. 400, 600) */
  fontWeight?: Maybe<Scalars['Int']['output']>;
  /** Line height as a unitless multiplier (e.g. 1.6) */
  lineHeight?: Maybe<Scalars['Float']['output']>;
  /** Bottom margin in em units (e.g. 0.9) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Top margin in em units (e.g. 0.0) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
  /** Minimum number of lines at the bottom of a page (e.g. 3) */
  orphans?: Maybe<Scalars['Int']['output']>;
  /** When true, emit page-break-before so the paragraph starts on a new page */
  pageBreakBefore?: Maybe<Scalars['Boolean']['output']>;
  /** Minimum number of lines at the top of a page (e.g. 3) */
  widows?: Maybe<Scalars['Int']['output']>;
};

/** Input for paragraph style */
export type ParagraphStyleInput = {
  /** Text color as a CSS hex string */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font family for paragraph text */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Font size in points for paragraph text */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Font style for paragraph text (e.g. 'italic') */
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  /** Font weight for paragraph text */
  fontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Line height for paragraph text (unitless multiplier) */
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Bottom margin in em units */
  marginBottomEm?: InputMaybe<Scalars['Float']['input']>;
  /** Top margin in em units */
  marginTopEm?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum number of lines of a paragraph that must be left at the bottom of a page */
  orphans?: InputMaybe<Scalars['Int']['input']>;
  /** If true, a page break is forced before this paragraph */
  pageBreakBefore?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum number of lines of a paragraph that must be at the top of a page */
  widows?: InputMaybe<Scalars['Int']['input']>;
};

/** PaymentIntervalType enumerates the interval of a fee occurrence */
export enum PaymentIntervalType {
  /** Describes an annual payment */
  Annual = 'ANNUAL',
  /** Describes a monthly payment */
  Monthly = 'MONTHLY',
  /** Describes a non-recurring payment */
  None = 'NONE',
  /** Describes a quarterly payment */
  Quarterly = 'QUARTERLY'
}

/**
 * Input for a single prefix or suffix attachment in a PDF render request.
 * Exactly one of fileId, file, or artifactId must be set. Artifact refs render the
 * latest version of that workspace artifact as a PDF using its own styling/template.
 */
export type PdfRenderAttachmentInput = {
  /** ID of a sibling PDF-renderable workspace artifact (HTML document, ACORD form, custom form, or PDF file) to render and append */
  artifactId?: InputMaybe<Scalars['ID']['input']>;
  /** Inline upload for an ephemeral attachment (stored in cache, not persisted) */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** ID of an existing file accessible to this agency (workspace file, message file, or template prefix/suffix) */
  fileId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Represents a tool for peeking at files.
 * Used when the LLM needs to get a sense for the content of a file.
 */
export type PeekFileTool = {
  __typename?: 'PeekFileTool';
  /** The input arguments for the file peeking */
  input: PeekFileToolInput;
  /** The result of the file peeking operation */
  output: PeekFileToolOutput;
};

/**
 * Input arguments for the PeekFileTool.
 * Contains the file ID to peek at.
 */
export type PeekFileToolInput = {
  __typename?: 'PeekFileToolInput';
  /** The ID of the file to peek at */
  fileId: Scalars['String']['output'];
  /** The type of output to return */
  outputType: Scalars['String']['output'];
};

/**
 * Result of a PeekFileTool operation.
 * Contains the peeked file content.
 */
export type PeekFileToolOutput = {
  __typename?: 'PeekFileToolOutput';
  /** Any comments to the LLM about the peeked file */
  comment: Scalars['String']['output'];
  /** The peeked file content */
  content: Scalars['String']['output'];
  /** References to images stored in cache (preferred over images field) */
  imageRefs?: Maybe<Array<ImageReference>>;
  /** Reference to text content stored in cache (preferred over content field) */
  textRef?: Maybe<TextReference>;
  /** Whether the file was truncated */
  truncated: Scalars['Boolean']['output'];
};

/** Type representing a permission to access a resource */
export type Permission = {
  __typename?: 'Permission';
  /** The action that the permission allows */
  action: Action;
  /** The resource that the permission applies to */
  resource: Resource;
  /** The scope that the permission applies to */
  scope: Scope;
};

/**
 * Input type for specifying permissions in directives.
 * Either 'scopes' should be provided (Category 2: fixed scopes) OR the directive
 * should include a scopeResource (Category 1: dynamic scopes), but not both.
 */
export type PermissionInput = {
  /** The action that the permission allows. */
  action: Action;
  /** The resource that the permission applies to. */
  resource: Resource;
  /**
   * Explicit list of scopes that grant this permission (Category 2).
   * If provided, the user must have this permission at ANY of the listed scopes.
   * Mutually exclusive with scopeResource on the directive.
   */
  scopes?: InputMaybe<Array<Scope>>;
};

/** How included usage allotments are determined for a subscription. */
export enum PlanBillingType {
  /** Included usage scales with purchased seats using plan formulas. */
  PerSeat = 'PER_SEAT',
  /** Included usage is negotiated per contract via usageAllotmentOverrides. */
  Platform = 'PLATFORM',
  /**
   * No included allotments or overage budgets (unlimited capacity). Customer-facing
   * usage dashboard, limits, enforcement, and spend alerts stay hidden.
   */
  Unmetered = 'UNMETERED'
}

/** The enumeration of states for business policy */
export enum PolicyState {
  /** The policy is in the process of being bound or finalized */
  Binding = 'BINDING',
  /** The policy has been terminated or canceled before its expiration date */
  Canceled = 'CANCELED',
  /** The policy has reached its expiration date and is no longer active */
  Expired = 'EXPIRED',
  /** The policy is currently active and in force */
  Inforce = 'INFORCE',
  /** The policy is in a pending state, awaiting further action or information */
  Pending = 'PENDING',
  /** The state of the policy is unknown or not determined */
  Unknown = 'UNKNOWN'
}

/**
 * A single clarifying question generated for the Convert-to-Preset wizard
 * (EPD-2005). The wizard renders the question with its selectable options; the
 * user picks one or, when allowFreeText is true, types their own answer. The
 * chosen answers are fed back into startPresetGeneration as
 * PresetGenerationQaAnswerInput.
 */
export type PresetClarifyingQuestion = {
  __typename?: 'PresetClarifyingQuestion';
  /**
   * Whether the user may supply a free-text answer instead of choosing an option.
   * Always true today: every question offers a free-text fallback.
   */
  allowFreeText: Scalars['Boolean']['output'];
  /**
   * Stable identifier for this question, used as a client-side key. Not
   * persisted: regenerating the questions produces fresh ids.
   */
  id: Scalars['ID']['output'];
  /** Between 2 and 4 selectable answer options. */
  options: Array<Scalars['String']['output']>;
  /** The question to ask the user, specific to the selected workspaces' content. */
  question: Scalars['String']['output'];
};

/**
 * Progress and outcome of the one AI generation run that produced a custom preset.
 * Null on a preset created by hand.
 *
 * Lives on the preset's parent row, not in its versioned document: it changes
 * several times per run, and a versioned write would mint a user-visible preset
 * version per progress step.
 */
export type PresetGeneration = {
  __typename?: 'PresetGeneration';
  /** When the run finished, whether it succeeded or failed. */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Why generation failed, safe to show the user. Set only when the preset's state
   * is FAILED.
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * The wizard choices the run was started with. Null on a run started before this
   * field existed; every run since records it, so a preset can be re-generated from
   * the same inputs and a support question about why a preset came out the way it
   * did can be answered from the row.
   */
  request?: Maybe<PresetGenerationRequest>;
  /** When the workflow picked the run up. */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The step in flight. Null once the run has finished, whether it succeeded or
   * failed.
   */
  step?: Maybe<PresetGenerationStep>;
};

/**
 * A clarifying question and the answer the user gave it, as recorded on the run
 * that consumed them.
 */
export type PresetGenerationQaAnswer = {
  __typename?: 'PresetGenerationQaAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

/** Input for a single clarifying-question answer supplied to startPresetGeneration. */
export type PresetGenerationQaAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

/**
 * The wizard choices a generation run was started with, kept on the run so the
 * inputs that produced a preset can be read back from it.
 */
export type PresetGenerationRequest = {
  __typename?: 'PresetGenerationRequest';
  /** The base preset the user pinned, if they overrode auto-detection. */
  basePresetOverride?: Maybe<CaraWorkspacePreset>;
  /** Custom forms the resulting preset was asked to default to. */
  customFormIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Files supplied as additional context for the run. */
  fileIds?: Maybe<Array<Scalars['String']['output']>>;
  /** HTML document templates the resulting preset was asked to default to. */
  htmlDocumentTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Free-text description of the desired output formats. */
  outputFormatsText?: Maybe<Scalars['String']['output']>;
  /** Answers to the clarifying questions from the wizard turn before the run. */
  qaAnswers?: Maybe<Array<PresetGenerationQaAnswer>>;
  /** The workspaces the preset was generated from. */
  sourceWorkspaceIds: Array<Scalars['String']['output']>;
  /** Word document templates the resulting preset was asked to default to. */
  wordDocumentTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** The step GeneratePresetWorkflow is currently on. */
export enum PresetGenerationStep {
  /** Resolving which output templates and forms the preset should default to. */
  DetectingTemplates = 'DETECTING_TEMPLATES',
  /** Drafting the preset's base prompt. */
  DraftingPrompt = 'DRAFTING_PROMPT',
  /** Digesting the source workspaces to understand what the user was doing. */
  ReviewingWorkspaces = 'REVIEWING_WORKSPACES'
}

/** Result from previewing an update to the subscription */
export type PreviewUpdateSubscriptionResult = {
  __typename?: 'PreviewUpdateSubscriptionResult';
  /** The checkout URL to redirect the customer to, in case a new subscription needs to be created */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** Payment secret required in case a payment method is required to complete the subscription update */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Preview of the invoice that would be generated for the subscription update */
  invoicePreview?: Maybe<UpdateSubscriptionInvoicePreview>;
};

/**
 * A set of producer information and signature for use in certificates and documents.
 * Can be defined at the agency level (shared by all users) or at the individual user level.
 */
export type ProducerInformation = {
  __typename?: 'ProducerInformation';
  /** Address of the agency */
  agencyAddress: Address;
  /** Name of the agency associated with this producer information */
  agencyName: Scalars['String']['output'];
  /** Email address of the contact person */
  contactEmail: Scalars['String']['output'];
  /** Fax number of the contact person */
  contactFax: Scalars['String']['output'];
  /** Name of the contact person */
  contactName: Scalars['String']['output'];
  /** Phone number of the contact person */
  contactPhone: Scalars['String']['output'];
  /** When this producer information was created */
  createdAt: Scalars['Time']['output'];
  /**
   * Florida producer license number.
   * Printed onto ACORD forms when the risk is in Florida (or the form is Florida-specific),
   * from this Producer Information setting (or a user-selected producer profile).
   */
  floridaLicenseNumber: Scalars['String']['output'];
  /** Unique identifier for this producer information */
  id: Scalars['ID']['output'];
  /** Whether this is the default set of producer information for the scope it belongs to */
  isDefault: Scalars['Boolean']['output'];
  /**
   * National Producer Number (NPN).
   * Auto-filled onto ACORD forms that include a producer national identifier field
   * from this Producer Information setting (or a user-selected producer profile).
   */
  nationalProducerNumber: Scalars['String']['output'];
  /** Name of the producer */
  producerName: Scalars['String']['output'];
  /** Base64-encoded JPEG signature image of the producer */
  producerSignatureJpegBase64: Scalars['String']['output'];
  /** When this producer information was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Input for creating or updating producer information */
export type ProducerInformationInput = {
  /** Address of the agency */
  agencyAddress: AddressInput;
  /** Name of the agency associated with this producer information */
  agencyName: Scalars['String']['input'];
  /** Email address of the contact person */
  contactEmail: Scalars['String']['input'];
  /** Fax number of the contact person */
  contactFax: Scalars['String']['input'];
  /** Name of the contact person */
  contactName: Scalars['String']['input'];
  /** Phone number of the contact person */
  contactPhone: Scalars['String']['input'];
  /**
   * Florida producer license number.
   * Printed onto ACORD forms when the risk is in Florida (or the form is Florida-specific),
   * from this Producer Information setting (or a user-selected producer profile).
   */
  floridaLicenseNumber: Scalars['String']['input'];
  /**
   * Whether this is the default set of producer information for the scope it belongs to.
   * Setting this to true will unset the default flag on any other producer information
   * in the same scope (agency or user).
   */
  isDefault: Scalars['Boolean']['input'];
  /**
   * National Producer Number (NPN).
   * Auto-filled onto ACORD forms that include a producer national identifier field
   * from this Producer Information setting (or a user-selected producer profile).
   */
  nationalProducerNumber: Scalars['String']['input'];
  /** Name of the producer */
  producerName: Scalars['String']['input'];
  /** Base64-encoded JPEG signature image of the producer. */
  producerSignatureJpegBase64: Scalars['String']['input'];
};

/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type Query = {
  __typename?: 'Query';
  /**
   * Returns a single account by ID. This endpoint verifies that the caller is
   * associated with the requested account.
   */
  account?: Maybe<Account>;
  /** Get the current client account user */
  accountUser?: Maybe<AccountUser>;
  /**
   * Returns a list of all accounts. This endpoint returns only accounts that the
   * caller is associated with (either as an agency user or as a client user).
   */
  accounts: Array<Account>;
  /** Get agency-scoped product usage analytics for admins. */
  adminAnalyticsReport: AdminAnalyticsReport;
  /** Returns a list of all agencies in the system. Only accessible by admin users. */
  agencies: Array<Agency>;
  /** Get an agency by its unique identifier */
  agency?: Maybe<Agency>;
  /** Returns a profile by its ID. */
  agencyProfile?: Maybe<AgencyProfile>;
  /**
   * Returns everything an admin can grant in a profile, grouped for display.
   * Static reference data — the same for every agency.
   */
  agencyProfileCapabilityCatalog: AgencyProfileCapabilityCatalog;
  /**
   * Returns all active profiles in an agency, oldest first. Admin-only. Defaults
   * to the caller's own agency; naming another one is for the consoles that
   * administer an agency from outside it.
   */
  agencyProfiles: Array<AgencyProfile>;
  /** Get the current agency user */
  agencyUser?: Maybe<AgencyUser>;
  /**
   * Returns the profile in force for one user and the rule that put them there,
   * or null when no profile reaches them. Null for an admin, whom no profile
   * governs.
   */
  agencyUserProfileAssignment?: Maybe<AgencyUserProfileAssignment>;
  /** Get all agency users for the current account */
  agencyUsers: Array<AgencyUser>;
  /**
   * Returns an account's documents (FILE entities), most-recently-modified first,
   * paginated. Scope with `policyId` (documents attached to one POLICY entity),
   * `policyIds` (documents attached to any entity in a policy-number group), or
   * `looseFilesOnly: true` (documents with no policy); with none of those, returns
   * all of the account's documents. `query` filters documents by name. `accountId`
   * is the account's KnowledgeGraphEntity ID.
   */
  amsAccountDocuments: AmsAccountDocumentConnection;
  /**
   * Lists an account's policies grouped by normalized policy number. This hides
   * integration-specific line granularity (notably Applied Epic) while retaining
   * the member POLICY entity IDs needed to filter documents.
   */
  amsAccountPolicyGroups: Array<AmsAccountPolicyGroup>;
  /** Returns the freshness/status snapshot for an AMS account. */
  amsAccountSyncStatus: AmsAccountSyncStatus;
  businessPolicies: Array<BusinessPolicy>;
  /** Get a single business policy by ID */
  businessPolicy?: Maybe<BusinessPolicy>;
  /** Get a call by its ID */
  call: Call;
  /** Get aggregated call report data */
  callReport: CallReport;
  /**
   * Get a list of calls
   * @deprecated Use searchCalls for paginated results
   */
  calls: Array<Call>;
  /** Get a Cara workspace by its ID */
  caraWorkspace?: Maybe<CaraWorkspace>;
  caraWorkspaceArtifact?: Maybe<CaraWorkspaceArtifactSummary>;
  /**
   * Get a list of Cara workspace artifacts for the documents view.
   * This query returns artifacts grouped by artifact ID, with all versions included.
   * Each artifact includes a reference to its workspace.
   * This is optimized to return only the minimal data needed to render the documents view,
   * avoiding the overhead of loading full workspace data (messages, plan stages, etc.).
   */
  caraWorkspaceArtifacts: Array<CaraWorkspaceArtifactSummary>;
  /**
   * Get Cara workspaces for the agency.
   * Deprecated: use searchCaraWorkspaces for paginated, server-side filtered results.
   * @deprecated Use searchCaraWorkspaces for paginated, server-side filtered results
   */
  caraWorkspaces: Array<CaraWorkspace>;
  carriers: Array<InsuranceCarrier>;
  /** Get a certificate of insurance by its certificate number */
  certificate?: Maybe<CertificateOfLiabilityInsurance>;
  client?: Maybe<Client>;
  /**
   * The merge queue for the caller's agency, highest-scoring first.
   *
   * Defaults to PENDING. Passing a resolved status reads the history instead,
   * which is the only way to find a merge after the fact.
   */
  clientMergeCandidates: ClientMergeCandidateConnection;
  /** A client's notepad, newest first. */
  clientNotes: Array<ClientNote>;
  /**
   * The Clients list, and the search behind the workspace-association picker.
   * Scoped to the caller's agency unless the caller holds GLOBAL scope.
   */
  clients: ClientConnection;
  /** Returns a single account contact by ID. Only accessible by agency users. */
  contact?: Maybe<AccountContact>;
  /** Returns a list of all account contacts. Only accessible by agency users. */
  contacts: Array<AccountContact>;
  /** Get the options for creating a certificate of insurance */
  createCertificateOptions?: Maybe<CreateCertificateOptions>;
  customForm: CustomForm;
  customForms: Array<CustomForm>;
  /**
   * Get a custom preset by its ID. Fixed scopes (rather than a dynamic
   * CUSTOM_PRESET scope) because the resolver body is the authoritative
   * row-level gate: it enforces per-user PRIVATE/SHARED visibility for
   * own-agency presets and the cross-agency shared-preset read gate
   * (grant + PUBLIC + not archived + live federation) for foreign ones.
   */
  customPreset: CustomPreset;
  /** Get custom presets for the agency */
  customPresets: Array<CustomPreset>;
  /**
   * The Cara default ACORD COI/EOI configuration. Agencies persist only their
   * overrides (see ACORDFormConfiguration); a null override field resolves to the
   * matching value returned here. The Settings UI reads this to display effective
   * values and to pre-populate the preset rules for an agency that has not
   * customized a setting, without baking the default into the persisted object.
   */
  defaultACORDFormConfiguration: AcordFormConfiguration;
  /** Get a thread by its ID */
  emailThread: EmailThread;
  /** Get a list of threads */
  emailThreads: Array<EmailThread>;
  /** Get an Excel spreadsheet template by its ID */
  excelSpreadsheetTemplate: ExcelSpreadsheetTemplate;
  /** Get Excel spreadsheet templates for the agency */
  excelSpreadsheetTemplates: Array<ExcelSpreadsheetTemplate>;
  /**
   * Get child agencies that can be granted access to knowledge bases.
   * Returns agencies where the current agency is the parent with FEDERATED_BILLING.
   */
  federatedChildAgencies: Array<Agency>;
  /** Get feedback based on filters. */
  getFeedback: Array<Feedback>;
  /** Get a HTML document template by its ID */
  htmlDocumentTemplate: HtmlDocumentTemplate;
  /** Get HTML document templates for the agency */
  htmlDocumentTemplates: Array<HtmlDocumentTemplate>;
  /** Get all deal pipelines from HubSpot */
  hubspotDealPipelines: Array<HubSpotPipeline>;
  /** Get all ticket pipelines from HubSpot */
  hubspotTicketPipelines: Array<HubSpotTicketPipeline>;
  /** Get an integration by its ID */
  integration?: Maybe<Integration>;
  /**
   * List capabilities for all supported integrations (read + write). The
   * workflow builder uses this to render dynamic configuration UI for
   * OUTPUT_INTEGRATION and INPUT_AMS_READ tasks.
   */
  integrationCapabilities: Array<IntegrationCapability>;
  /**
   * Get an integration sync log by its ID. Used for the admin sync-log detail view
   * and deep linking into the sync-log drawer.
   */
  integrationSyncLog?: Maybe<IntegrationSyncLog>;
  /**
   * Get integrations. In agency scope, returns only integrations for the caller's agency.
   * In global (admin) scope, returns across all agencies, optionally filtered by agencyId.
   */
  integrations: Array<Integration>;
  /** Get a knowledge base by its ID */
  knowledgeBase?: Maybe<KnowledgeBase>;
  /** Get a document by its ID */
  knowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Get all knowledge bases (owned by the current agency + shared with the current agency) */
  knowledgeBases: Array<KnowledgeBase>;
  /** Browse and search knowledge graph entities for a given agency. Requires GLOBAL scope. */
  knowledgeGraphEntities: KnowledgeGraphEntityConnection;
  /**
   * The mailboxes the authenticated user may send from: the ones they connected,
   * plus any shared with them or one of their teams. A colleague's unshared
   * mailbox is never returned, and neither is one shared with someone else.
   */
  mailboxAccounts: Array<MailboxAccount>;
  /**
   * The composer's ceilings. Constant for the deployment and free to answer, so
   * it takes no arguments and reads nothing; a composer asks for it alongside the
   * mailboxes it is already loading.
   */
  mailboxComposeLimits: MailboxComposeLimits;
  /**
   * The agency's mailbox audit trail: connections made and lost, and the drafts
   * Cara wrote into them. Naming a subject in `filter` reads that one timeline
   * oldest first, the order a story is read in; naming none reads the
   * agency-wide feed newest first.
   *
   * Agency-scoped rather than owner-scoped: this is the record the agency is
   * accountable for. The entries carry no message content, so agency-wide
   * readability exposes integration metadata and never anyone's mail.
   */
  mailboxEvents: Array<MailboxEvent>;
  /**
   * The providers this deployment can actually connect a mailbox to, not the
   * ones the schema knows how to name: an adapter registers at startup only when
   * its app registration is present, so an environment without those credentials
   * answers with an empty list. A settings page offers a provider to connect only
   * if it appears here.
   */
  mailboxProviders: Array<MailboxProvider>;
  /**
   * The signatures the caller may pick in the composer: their own, the
   * agency-wide ones, and any shared with them or their teams.
   */
  mailboxSignatures: Array<MailboxSignature>;
  /**
   * List memories for the caller's agency. Agents see their own agent-scoped
   * memories plus all organization memories. Admins can filter by agencyUserId.
   */
  memories: Array<Memory>;
  /** Get a single memory by ID. */
  memory: Memory;
  outboundCall: OutboundCall;
  /**
   * Rolling 30-day AI outbound call usage for a customer phone in the caller's agency.
   * Used by the schedule dialog to show N of 3 before place/schedule.
   * Organization scope only — the count is keyed by principal.OrgID.
   */
  outboundCallFrequency: OutboundCallFrequency;
  outboundCallReport: OutboundCallReport;
  /** @deprecated Use searchOutboundCalls for paginated results */
  outboundCalls: Array<OutboundCall>;
  /**
   * Searches AMS accounts (KnowledgeGraphEntity type=ACCOUNT) across the caller's
   * agency integrations that support document browsing. Matches account name, email,
   * phone, and lookup code; a query that matches a policy number also returns the
   * policy's owning account. An empty query returns the most recently modified
   * accounts so the picker can show an initial browseable list. Returns an empty
   * list when the agency has no document-capable AMS integration.
   */
  searchAmsAccounts: AmsAccountSearchResult;
  /**
   * Searches POLICY entities by policy number across the caller's agency integrations
   * that support document browsing, returning each match with its owning account so the
   * picker's "Policies" mode can land directly on a policy's documents. Only matches
   * policies already synced to the knowledge graph (use findAmsPolicy for a live lookup
   * of an unsynced policy). Returns an empty list for a blank query or when the agency
   * has no document-capable AMS integration.
   */
  searchAmsPolicies: Array<AmsPolicySearchResult>;
  /** Search calls with cursor-based pagination */
  searchCalls: CallConnection;
  /**
   * The artifacts the caller may read, newest-composed first, one page at a time.
   *
   * Same rows and same reach as `caraWorkspaceArtifacts` — agency-scoped, then
   * filtered by each artifact's own visibility. Archive state is not applied: the
   * outbox reads this as a ledger, and an archived email still went out.
   *
   * Ordered by `composedAt` rather than by the summary's `createdAt` or
   * `updatedAt`: a revised artifact must not jump the queue, because a client
   * merging this list with another (the outbox merges it with the mailbox draft
   * and send ledgers) relies on an artifact never sorting after a record made
   * from it.
   */
  searchCaraWorkspaceArtifacts: CaraWorkspaceArtifactConnection;
  /** Search Cara workspaces with cursor-based pagination, server-side filtering and sorting */
  searchCaraWorkspaces: CaraWorkspaceConnection;
  /**
   * Searches documentation for a given query string.
   * Returns a SearchDocumentationResult containing matched documentation.
   */
  searchDocumentation: SearchDocumentationResult;
  /** Get a file by ID */
  searchFiles: Array<SearchFileResult>;
  /** Search integration sync logs with cursor-based pagination, server-side filtering and sorting. */
  searchIntegrationSyncLogs: IntegrationSyncLogConnection;
  /**
   * The drafts Cara has written into the agency's connected mailboxes, newest
   * first. There is no sort argument: the list answers "what is waiting", and
   * waiting is measured in one direction.
   *
   * Scoped like `searchOutboundEmails`: a draft is as readable as the email it
   * was written from, and an agency admin reads them all.
   */
  searchMailboxDrafts: MailboxDraftConnection;
  /**
   * Search the memories visible to the caller using stable, newest-first cursor
   * pagination. Defaults to 25 results and accepts at most 100 per page.
   */
  searchMemories: MemoryConnection;
  /** Search outbound calls with cursor-based pagination */
  searchOutboundCalls: OutboundCallConnection;
  /**
   * The outbound send log, newest first: the emails Cara sent that the caller may
   * read. Each row carries the audience of the draft it was composed from, so a
   * send from a private workspace stays as private as the draft was, and an
   * agency admin reads the whole log as the compliance record the agency is
   * accountable for.
   */
  searchOutboundEmails: OutboundEmailConnection;
  /**
   * Searches the caller's agency for parties to address an email to: CONTACT and
   * ACCOUNT entities that have an email address, across every ACTIVE AMS
   * integration the agency has connected. Unlike `searchAmsAccounts`, not
   * restricted to document-capable integrations.
   *
   * Matches contact and account name, either email address, and the entity's
   * display name; every whitespace-separated token must match at least one of
   * them. Returns an empty list until some whitespace-separated token reaches
   * three characters, and when the agency has no active AMS integration.
   *
   * Colleagues are not included: the client merges AgencyUser results in.
   */
  searchRecipients: Array<RecipientSuggestion>;
  /**
   * Search trace analyses with cursor-based pagination, server-side filtering and sorting.
   * Requires GLOBAL (admin) scope.
   */
  searchTraceAnalysis: TraceAnalysisConnection;
  /**
   * Search traces with cursor-based pagination, server-side filtering and sorting.
   * Requires GLOBAL (admin) scope.
   */
  searchTraces: TraceConnection;
  /** Get a service request by ID, if the current user is associated with the service request */
  serviceRequest?: Maybe<ServiceRequest>;
  /**
   * Get all service requests associated with any accounts that belong to the agency of the
   * currently logged in agency user, or the account ID if specified and if the user has
   * permission to view them.
   */
  serviceRequests: Array<ServiceRequest>;
  smartFillBucket: SmartFillBucket;
  smartFillBuckets: Array<SmartFillBucket>;
  /** The calling user's current correction rules for one form. */
  smartFillOverrides: Array<SmartFillOverride>;
  /**
   * Get a span by its OTel span ID, fully hydrated — including the heavy detail payloads
   * that the trace waterfall path (Trace.rootSpans / Span.children) omits. This is what
   * backs the span detail pane when a span is selected.
   * Requires GLOBAL (admin) scope.
   */
  span?: Maybe<Span>;
  /** Returns a link to the subscription management page for the current account */
  subscriptionManagementLinks?: Maybe<SubscriptionManagementLinks>;
  /**
   * Clients this workspace might belong to, best first.
   *
   * Empty until the workspace has completed a run: the name this matches on is
   * extracted from the first run's summary, so an empty list means "too early to
   * say" rather than "no candidates". Empty also for a workspace already linked to
   * a client, since there is nothing left to suggest.
   */
  suggestedClientsForWorkspace: Array<ClientSuggestion>;
  /**
   * Returns a team by its ID. Accessible to admins and members of the team.
   * Resolver enforces membership for non-admin callers.
   */
  team?: Maybe<Team>;
  /** Returns all teams within the current agency. Admin-only. */
  teams: Array<Team>;
  /**
   * Get a trace by its OTel trace ID. Used for the trace detail / waterfall view.
   * Requires GLOBAL (admin) scope.
   */
  trace?: Maybe<Trace>;
  /**
   * Get a trace analysis by its ID.
   * Requires GLOBAL (admin) scope.
   */
  traceAnalysis?: Maybe<TraceAnalysis>;
  /**
   * Get correlated log records for a trace, with optional span/severity filtering.
   * Requires GLOBAL (admin) scope.
   */
  traceLogs: LogRecordConnection;
  /** Get a voice agent by its ID */
  voiceAgent: VoiceAgent;
  /** Get the default voice agent configuration */
  voiceAgentDefaultConfiguration: VoiceAgentConfiguration;
  /** Get the provider and language capabilities used by voice-agent settings. */
  voiceAgentLanguageSupport: VoiceAgentLanguageSupport;
  /** Get a list of voice agents */
  voiceAgents: Array<VoiceAgent>;
  /** Get a Word document template by its ID */
  wordDocumentTemplate: WordDocumentTemplate;
  /** Get Word document templates for the agency */
  wordDocumentTemplates: Array<WordDocumentTemplate>;
  /**
   * Get a workflow definition by ID. Scoped via WORKFLOW_DEFINITION so the
   * directive denies access if the definition belongs to another agency.
   */
  workflowDefinition?: Maybe<WorkflowDefinition>;
  /** List workflow definitions for the current agency */
  workflowDefinitions: Array<WorkflowDefinition>;
  /**
   * Get a workflow execution by ID, returning the latest version. Scoped via
   * WORKFLOW_EXECUTION so the directive denies access if the execution
   * belongs to another agency.
   */
  workflowExecution?: Maybe<WorkflowExecution>;
  /** List workflow executions for the current agency */
  workflowExecutions: Array<WorkflowExecution>;
  /**
   * List all available task definitions from the registry. Returns the
   * definitions with their input/output schemas so the UI can build
   * workflow definitions.
   */
  workflowTaskDefinitions: Array<WorkflowTaskDefinition>;
  /** Get aggregated workspace analytics for the admin dashboard */
  workspaceReport: WorkspaceReport;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAdminAnalyticsReportArgs = {
  filter?: InputMaybe<AdminAnalyticsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgenciesArgs = {
  filter?: InputMaybe<AgencyFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgencyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgencyProfileArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgencyProfilesArgs = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgencyUserProfileAssignmentArgs = {
  agencyUserId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAccountDocumentsArgs = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  looseFilesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  policyId?: InputMaybe<Scalars['ID']['input']>;
  policyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAccountPolicyGroupsArgs = {
  accountId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAccountSyncStatusArgs = {
  accountId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCallArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCallReportArgs = {
  filter?: InputMaybe<CallFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCallsArgs = {
  filter?: InputMaybe<CallFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspaceArtifactArgs = {
  artifactId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspaceArtifactsArgs = {
  filter?: InputMaybe<CaraWorkspaceArtifactFilter>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspacesArgs = {
  filter?: InputMaybe<CaraWorkspaceFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCertificateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryClientMergeCandidatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ClientMergeCandidateStatus>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryClientNotesArgs = {
  clientId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ClientSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCreateCertificateOptionsArgs = {
  accountId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCustomFormArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCustomFormsArgs = {
  filter?: InputMaybe<CustomFormsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCustomPresetArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCustomPresetsArgs = {
  filter?: InputMaybe<CustomPresetsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryEmailThreadArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryExcelSpreadsheetTemplateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryExcelSpreadsheetTemplatesArgs = {
  filter?: InputMaybe<ExcelSpreadsheetTemplatesFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryGetFeedbackArgs = {
  input: GetFeedbackInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryHtmlDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryHtmlDocumentTemplatesArgs = {
  filter?: InputMaybe<HtmlDocumentTemplatesFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryHubspotDealPipelinesArgs = {
  integrationId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryHubspotTicketPipelinesArgs = {
  integrationId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryIntegrationArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryIntegrationSyncLogArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryIntegrationsArgs = {
  filter?: InputMaybe<IntegrationsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryKnowledgeGraphEntitiesArgs = {
  filter: KnowledgeGraphEntityFilter;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMailboxEventsArgs = {
  filter?: InputMaybe<MailboxEventsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMemoriesArgs = {
  input?: InputMaybe<MemoriesInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMemoryArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryOutboundCallArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryOutboundCallFrequencyArgs = {
  excludeOutboundCallId?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryOutboundCallReportArgs = {
  filter?: InputMaybe<OutboundCallReportFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryOutboundCallsArgs = {
  filter?: InputMaybe<OutboundCallsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchAmsAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchAmsPoliciesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CallFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CallSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchCaraWorkspaceArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CaraWorkspaceArtifactsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchCaraWorkspacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchCaraWorkspacesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CaraWorkspaceSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchDocumentationArgs = {
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchFilesArgs = {
  filters: SearchFileFilter;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchIntegrationSyncLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchIntegrationSyncLogsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<IntegrationSyncLogSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchMailboxDraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MailboxDraftsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchMemoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MemorySearchFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchOutboundCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OutboundCallsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OutboundCallSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchOutboundEmailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OutboundEmailsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OutboundEmailSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchRecipientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchTraceAnalysisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchTraceAnalysisFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TraceAnalysisSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchTracesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchTracesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TraceSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryServiceRequestArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryServiceRequestsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillBucketArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillBucketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillOverridesArgs = {
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySpanArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySuggestedClientsForWorkspaceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTraceArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTraceAnalysisArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTraceLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TraceLogsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  traceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryVoiceAgentArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryVoiceAgentsArgs = {
  filter?: InputMaybe<VoiceAgentsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWordDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWordDocumentTemplatesArgs = {
  filter?: InputMaybe<WordDocumentTemplatesFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWorkflowDefinitionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWorkflowExecutionArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int64']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWorkspaceReportArgs = {
  filter: WorkspaceReportFilter;
};

/** Details for a request for questions about policies, account, or billing, etc. */
export type QuestionRequest = {
  __typename?: 'QuestionRequest';
  /** ID of the policy related to the question, if applicable */
  policyId?: Maybe<Scalars['String']['output']>;
  /** Question from the customer */
  question: Scalars['String']['output'];
  /** Type of question */
  type: QuestionRequestType;
};

/** Input type for requesting questions */
export type QuestionRequestInput = {
  /** ID of the policy related to the question, if applicable */
  policyId?: InputMaybe<Scalars['String']['input']>;
  /** Question from the customer */
  question: Scalars['String']['input'];
  /** Type of question */
  type?: InputMaybe<QuestionRequestType>;
};

/** Types of questions that can be requested */
export enum QuestionRequestType {
  /** Question about account management */
  Account = 'ACCOUNT',
  /** Question about billing and payments */
  Billing = 'BILLING',
  /** Other questions */
  Other = 'OTHER',
  /** Question about policies */
  Policy = 'POLICY'
}

/**
 * One addressable party the mail composer can offer for a To/CC/BCC field.
 * Sourced from the agency's AMS knowledge graph; the client merges its own
 * colleague list (AgencyUser) into the same shape before rendering.
 */
export type RecipientSuggestion = {
  __typename?: 'RecipientSuggestion';
  /**
   * Secondary line in the dropdown: for a contact, the account they belong to;
   * for an account, its own name when it differs from the display name.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The email address to send to. Always present — the search never returns a
   * party without one.
   */
  email: Scalars['String']['output'];
  /** Display name for the chip, when the AMS supplied one. */
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * One observability event. FILL events carry per-field decision metadata
 * (field key, status, reason, confidence, source, property ID) and write
 * verification outcomes; COPY events record Super Copy captures; CORRECTION
 * events are written server side when override rules change.
 *
 * Requiredness is enforced server side per action: FILL requires bucketId,
 * bucketRevision, formFingerprint, formSnapshotHash, requestId, and
 * promptVersion (modelId only when a model call happened); COPY requires
 * bucketId.
 */
export type RecordSmartFillEventInput = {
  action: SmartFillEventAction;
  bucketId?: InputMaybe<Scalars['ID']['input']>;
  bucketRevision?: InputMaybe<Scalars['Int64']['input']>;
  formFingerprint?: InputMaybe<Scalars['String']['input']>;
  formSnapshotHash?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  /**
   * Optional gzip-compressed page HTML captured alongside the action, stored
   * as opaque private evidence like the screenshot.
   */
  pageHtml?: InputMaybe<Scalars['Upload']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional page screenshot captured alongside the action (PNG). Stored as
   * opaque private evidence referenced from the event row; the event metadata
   * itself stays value-free.
   */
  screenshot?: InputMaybe<Scalars['Upload']['input']>;
};

/** Input for reinstating a business policy */
export type ReinstateBusinessPolicyInput = {
  /** When the reinstatement becomes effective */
  effectiveAt: Scalars['Time']['input'];
  /** A description of why the policy is being reinstated */
  reasonDescription: Scalars['String']['input'];
};

/** Input for renewing a business policy */
export type RenewBusinessPolicyInput = {
  /** The agency billing type, if applicable */
  agencyBillingType?: InputMaybe<BusinessPolicyAgencyBillingType>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['input'];
  /** How to create the Ascend program */
  ascendProgramCreationMode?: InputMaybe<AscendProgramCreationMode>;
  /** ID of specific Ascend program to use */
  ascendProgramId?: InputMaybe<Scalars['String']['input']>;
  /** The billing type for the policy */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['input'];
  /** The estimated commission the agency earns on this policy */
  estimatedCommission: Scalars['Float']['input'];
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy goes into force */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['input'];
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['input'];
  /** The policy number, if available */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium: Scalars['Float']['input'];
  /** The quote number associated with the renewal */
  quoteNumber: Scalars['String']['input'];
  /** The state of the policy */
  state: PolicyState;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['input'];
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total: Scalars['Float']['input'];
};

/** Result of requesting a background AMS account refresh. */
export type RequestAmsAccountRefreshResult = {
  __typename?: 'RequestAmsAccountRefreshResult';
  /**
   * Whether a refresh workflow was started (or was already running). False means
   * the server's freshness policy declined: the account synced within the
   * staleness window (force=false) or within the rate limit (force=true).
   */
  enqueued: Scalars['Boolean']['output'];
  /**
   * The account's CURRENT syncedAt — the client's poll baseline. The refresh is
   * complete when amsAccountSyncStatus.account.syncedAt advances past this.
   */
  syncedAt: Scalars['Time']['output'];
};

/**
 * HTML document templates from the agency library. ONLY when the user explicitly requested a template, asked what templates exist, or pre-selected one.
 *
 * DO NOT use for generic document requests (quotes, proposals, reports, letters). Do not LIST to find a template that fits.
 *
 * Operations:
 * - LIST: ONLY to resolve a user-named template to an ID or when the user asked what templates exist.
 * - GET_CONTENT: ONLY when applying a template the user requested or pre-selected.
 */
export type RequestDocumentStyleTemplatesTool = {
  __typename?: 'RequestDocumentStyleTemplatesTool';
  /** The input arguments for requesting HTML document templates */
  input: RequestDocumentStyleTemplatesToolInput;
  /** The result containing template information (metadata for LIST or body HTML for GET_CONTENT) */
  output: RequestDocumentStyleTemplatesToolOutput;
};

/**
 * Input arguments for the RequestDocumentStyleTemplatesTool.
 * Supports two operations: LIST (returns metadata without body HTML) and GET_CONTENT (returns body HTML for a specific template).
 */
export type RequestDocumentStyleTemplatesToolInput = {
  __typename?: 'RequestDocumentStyleTemplatesToolInput';
  /** The operation to perform: LIST returns template metadata without body HTML GET_CONTENT returns the body HTML for a specific template. */
  operation: Scalars['String']['output'];
  /** The template ID to get content for. Required when operation is GET_CONTENT. */
  templateId?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of a RequestDocumentStyleTemplatesTool operation.
 * For LIST operation: contains array of templates with metadata (no bodyHTML).
 * For GET_CONTENT operation: contains array with single template including bodyHTML.
 */
export type RequestDocumentStyleTemplatesToolOutput = {
  __typename?: 'RequestDocumentStyleTemplatesToolOutput';
  /** The list of HTML document templates. For LIST contains all templates without bodyHTML. For GET_CONTENT contains single template with bodyHTML. */
  templates: Array<HtmlDocumentTemplateInfo>;
};

/** Tool for requesting Excel (.xlsx) spreadsheet templates */
export type RequestExcelSpreadsheetTemplatesTool = {
  __typename?: 'RequestExcelSpreadsheetTemplatesTool';
  /** The input arguments for the Excel spreadsheet template request */
  input: RequestExcelSpreadsheetTemplatesToolInput;
  /** The result of the Excel spreadsheet template request */
  output?: Maybe<RequestExcelSpreadsheetTemplatesToolOutput>;
};

/**
 * Input for RequestExcelSpreadsheetTemplatesTool.
 * LIST returns Excel template metadata; GET_CONTENT returns the tabs and fields of one template.
 */
export type RequestExcelSpreadsheetTemplatesToolInput = {
  __typename?: 'RequestExcelSpreadsheetTemplatesToolInput';
  /** Operation: LIST (available Excel templates) or GET_CONTENT (tabs and fields for one template by templateId). */
  operation: Scalars['String']['output'];
  /** Required when operation is GET_CONTENT. The template ID from LIST. */
  templateId?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of RequestExcelSpreadsheetTemplatesTool.
 * LIST: array of Excel templates (metadata only). GET_CONTENT: a single template including its tabs.
 */
export type RequestExcelSpreadsheetTemplatesToolOutput = {
  __typename?: 'RequestExcelSpreadsheetTemplatesToolOutput';
  /** The matching Excel spreadsheet templates */
  templates: Array<ExcelSpreadsheetTemplateInfo>;
};

/** Represents a meta-tool for requesting per-integration tools to be provisioned on demand. */
export type RequestIntegrationToolsTool = {
  __typename?: 'RequestIntegrationToolsTool';
  /** The input arguments for the integration tool request */
  input: RequestIntegrationToolsToolInput;
  /** The result of the integration tool request */
  output: RequestIntegrationToolsToolOutput;
};

/** Input arguments for the RequestIntegrationToolsTool. */
export type RequestIntegrationToolsToolInput = {
  __typename?: 'RequestIntegrationToolsToolInput';
  /** The IDs of the integration tools to provision */
  toolIds: Array<Scalars['String']['output']>;
};

/** Result of a RequestIntegrationToolsTool operation. */
export type RequestIntegrationToolsToolOutput = {
  __typename?: 'RequestIntegrationToolsToolOutput';
  /** The list of tools that are now available */
  availableTools: Array<Scalars['String']['output']>;
};

/**
 * Represents a tool for requesting a list of tools that can be used to fill out a template.
 * Used when the LLM needs to request a list of tools that can be used to fill out a template.
 */
export type RequestTemplateToolsTool = {
  __typename?: 'RequestTemplateToolsTool';
  /** The input arguments for the template tool request */
  input: RequestTemplateToolsToolInput;
  /** The result of the template tool request */
  output: RequestTemplateToolsToolOutput;
};

/**
 * Input arguments for the RequestTemplateToolsTool.
 * Contains the template ID to request tools for.
 */
export type RequestTemplateToolsToolInput = {
  __typename?: 'RequestTemplateToolsToolInput';
  /**
   * The state used to resolve template IDs that name a form published per state
   * (those ending in _ANY_STATE) to that state's edition of the form.
   */
  primaryRiskState?: Maybe<Scalars['String']['output']>;
  /** The ID of the template to request tools for */
  templateIds: Array<Scalars['String']['output']>;
};

/**
 * Result of a RequestTemplateToolsTool operation.
 * Contains the list of tools that can be used to fill out the template.
 */
export type RequestTemplateToolsToolOutput = {
  __typename?: 'RequestTemplateToolsToolOutput';
  /** The list of tools that can be used to fill out the template */
  availableTools: Array<Scalars['String']['output']>;
};

/** Tool for requesting Word (.docx) document templates */
export type RequestWordDocumentTemplatesTool = {
  __typename?: 'RequestWordDocumentTemplatesTool';
  /** The input arguments for the word document template request */
  input: RequestWordDocumentTemplatesToolInput;
  /** The result of the word document template request */
  output?: Maybe<RequestWordDocumentTemplatesToolOutput>;
};

/**
 * Input for RequestWordDocumentTemplatesTool.
 * LIST returns Word template metadata; GET_CONTENT returns detailed information for a specific template.
 */
export type RequestWordDocumentTemplatesToolInput = {
  __typename?: 'RequestWordDocumentTemplatesToolInput';
  /** Operation: LIST (available Word templates) or GET_CONTENT (wordTemplateFileId for one template by templateId). */
  operation: Scalars['String']['output'];
  /** Required when operation is GET_CONTENT. The template ID from LIST. */
  templateId?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of RequestWordDocumentTemplatesTool.
 * LIST: array of Word templates (metadata only). GET_CONTENT: single template with wordTemplateFileId and docxInspection when available.
 */
export type RequestWordDocumentTemplatesToolOutput = {
  __typename?: 'RequestWordDocumentTemplatesToolOutput';
  templates: Array<WordDocumentTemplateInfo>;
};

/**
 * Rerank-specific details attached to a RERANK span. The score distribution is the
 * high-value signal: low top scores mean the answer was synthesized from weak matches.
 */
export type Rerank = {
  __typename?: 'Rerank';
  /** Candidates actually submitted to the reranker. */
  candidateCount: Scalars['Int']['output'];
  /**
   * Candidates that existed before a cap was applied; null when no cap was hit.
   * A value greater than candidateCount means candidates were dropped pre-rerank.
   */
  candidatesAvailable?: Maybe<Scalars['Int']['output']>;
  /** Total cost in dollars for this rerank call. */
  costDollars: Scalars['Decimal']['output'];
  /**
   * Gap between the last-kept and first-cut score. A tiny margin means the cutoff was
   * near-arbitrary and a relevant result may have just missed.
   */
  cutoffMargin?: Maybe<Scalars['Float']['output']>;
  /** Whether reranking errored and the caller fell back to the input order. */
  fellBack: Scalars['Boolean']['output'];
  /** Mean relevance score across candidates. */
  meanScore?: Maybe<Scalars['Float']['output']>;
  /** Lowest relevance score. */
  minScore?: Maybe<Scalars['Float']['output']>;
  /** gen_ai.provider.name (e.g. cohere, voyage). */
  providerName: Scalars['String']['output'];
  /** What the rerank serves. Null when unset. */
  purpose?: Maybe<RerankPurpose>;
  /** What candidates were scored against (user query, conversation context, or a field name). */
  query: Scalars['String']['output'];
  /** gen_ai.request.model (e.g. rerank-v4.0-pro). */
  requestModel: Scalars['String']['output'];
  /** Number of results returned (kept). */
  resultCount: Scalars['Int']['output'];
  /**
   * The candidate funnel: scores for all candidates plus snippets for the kept set and a
   * few near-misses.
   */
  results?: Maybe<Array<RerankResult>>;
  /** The requested top-k, when applicable. */
  topK?: Maybe<Scalars['Int']['output']>;
  /** Highest relevance score (0-1). */
  topScore?: Maybe<Scalars['Float']['output']>;
};

/**
 * What a rerank call serves. KG_PROPERTY_FIELDS is schema relevance (a field name vs.
 * property keys), not content relevance, so retrieval-quality views should exclude it.
 */
export enum RerankPurpose {
  FileChunks = 'FILE_CHUNKS',
  KbChunks = 'KB_CHUNKS',
  KgPropertyFields = 'KG_PROPERTY_FIELDS',
  Memory = 'MEMORY'
}

/**
 * A single candidate in a rerank funnel: its scores, final rank, and whether it survived
 * the cut. Snippets are present for the kept set and a few near-misses (redacted/truncated).
 */
export type RerankResult = {
  __typename?: 'RerankResult';
  /**
   * The chunk's sequence number within the source document, when the candidate is a chunk
   * of a larger document (KB / file search). Null for whole-object sources (e.g. a memory).
   * Together with id it identifies the exact chunk.
   */
  chunkId?: Maybe<Scalars['Int']['output']>;
  /** Stable identifier of the candidate's source (memory id, KB document id, file id). */
  id: Scalars['String']['output'];
  /** The pre-rerank score the candidate carried in (e.g. hybrid/RRF), when supplied. */
  inputScore?: Maybe<Scalars['Float']['output']>;
  /** Whether the candidate survived the top-k / threshold cut. */
  kept: Scalars['Boolean']['output'];
  /** Final rank after reranking (0-based). */
  rank: Scalars['Int']['output'];
  /** The rerank relevance score (0-1). */
  score: Scalars['Float']['output'];
  /** A redacted, truncated preview of the candidate content. */
  snippet?: Maybe<Scalars['String']['output']>;
  /** The resolved source object (memory, KB document, file), fetched from sourceType + id. */
  source?: Maybe<TraceSource>;
  /**
   * The kind of object id refers to; null for sources with no resolvable object (e.g. KG
   * property fields).
   */
  sourceType?: Maybe<TraceSourceType>;
};

/** Input type for resolving a service request */
export type ResolveServiceRequestInput = {
  /** Files attached to the resolution */
  files: Array<Scalars['Upload']['input']>;
  /** Internal notes about the resolution */
  notes: Scalars['String']['input'];
};

export type ResolveSmartFillInput = {
  bucketId: Scalars['ID']['input'];
  expectedBucketRevision: Scalars['Int64']['input'];
  fields: Array<SmartFillResolveFieldInput>;
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
  formSnapshotHash: Scalars['String']['input'];
  groups?: InputMaybe<Array<SmartFillGroupInput>>;
  /** Idempotency and audit linkage for this resolve request. */
  requestId: Scalars['ID']['input'];
  /**
   * Optional section paste: narrows the source document to this entity's
   * subtree plus its ancestors' own properties before matching.
   */
  scopeEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional; single-page resolves omit it. */
  session?: InputMaybe<SmartFillSessionContextInput>;
  url: Scalars['String']['input'];
};

/**
 * Resource types that can be accessed in the system.
 * These represent the entities that permissions can be granted on.
 */
export enum Resource {
  /** Account belonging to an agency */
  Account = 'ACCOUNT',
  /** Account user, aka an agency client */
  AccountUser = 'ACCOUNT_USER',
  /** Insurance agency entity */
  Agency = 'AGENCY',
  /** Profile — a bundle of home screen, sidebar, and permission policy assigned to agency users */
  AgencyProfile = 'AGENCY_PROFILE',
  /** Agency user/employee entity */
  AgencyUser = 'AGENCY_USER',
  /** Agency product usage analytics (admin dashboard) */
  Analytics = 'ANALYTICS',
  /** Business insurance policy */
  BusinessPolicy = 'BUSINESS_POLICY',
  /** Phone call record */
  Call = 'CALL',
  /** Cara workspace for AI interactions */
  CaraWorkspace = 'CARA_WORKSPACE',
  /** Insurance carrier */
  Carrier = 'CARRIER',
  /** Certificate of insurance */
  Certificate = 'CERTIFICATE',
  /** A business or individual the agency serves (not the legacy ACCOUNT entity) */
  Client = 'CLIENT',
  /** A pair of clients awaiting a person's merge-or-keep-separate decision */
  ClientMergeCandidate = 'CLIENT_MERGE_CANDIDATE',
  /** Free-form note a user wrote on a client */
  ClientNote = 'CLIENT_NOTE',
  /** Contact/person entity associated with accounts */
  Contact = 'CONTACT',
  /** Custom fillable PDF forms */
  CustomForm = 'CUSTOM_FORM',
  /** Custom presets */
  CustomPreset = 'CUSTOM_PRESET',
  /** Email thread */
  EmailThread = 'EMAIL_THREAD',
  /** Excel spreadsheet template (.xlsx library templates) */
  ExcelSpreadsheetTemplate = 'EXCEL_SPREADSHEET_TEMPLATE',
  /** User feedback */
  Feedback = 'FEEDBACK',
  /** Uploaded files associated with entities */
  File = 'FILE',
  /** HTML document template (library styles and letter templates) */
  HtmlDocumentTemplate = 'HTML_DOCUMENT_TEMPLATE',
  /** Third-party integration */
  Integration = 'INTEGRATION',
  /** Knowledge base */
  KnowledgeBase = 'KNOWLEDGE_BASE',
  /** Document in knowledge base */
  KnowledgeBaseDocument = 'KNOWLEDGE_BASE_DOCUMENT',
  /** Connected mailbox and the outbound email send log */
  Mailbox = 'MAILBOX',
  /** Email signature authored in Cara and appended to outbound mail */
  MailboxSignature = 'MAILBOX_SIGNATURE',
  /** Agent or organization memory */
  Memory = 'MEMORY',
  /** Outbound call job (schedule, dial intent, retries) */
  OutboundCall = 'OUTBOUND_CALL',
  /** Producer information and signature for certificates and documents */
  ProducerInformation = 'PRODUCER_INFORMATION',
  /** Role */
  Role = 'ROLE',
  /** Service request from clients */
  ServiceRequest = 'SERVICE_REQUEST',
  /** Smart Fill form mappings, buckets, and Super Copy evidence */
  SmartFill = 'SMART_FILL',
  /** Subscription and billing settings */
  Subscription = 'SUBSCRIPTION',
  /** Team — a grouping of agency users used to scope shared visibility */
  Team = 'TEAM',
  /** Voice agent configuration */
  VoiceAgent = 'VOICE_AGENT',
  /** Word document template (.docx library templates) */
  WordDocumentTemplate = 'WORD_DOCUMENT_TEMPLATE',
  /** Workflow definition (reusable blueprint of tasks and bindings) */
  WorkflowDefinition = 'WORKFLOW_DEFINITION',
  /** Workflow execution (a single run of a workflow definition) */
  WorkflowExecution = 'WORKFLOW_EXECUTION',
  /** Workflow task (a single task instance within an execution's DAG) */
  WorkflowTask = 'WORKFLOW_TASK'
}

/**
 * Roles that a particular user can take on. These can be specified by the user to grant or revoke certain permissions.
 * Currently, these are only applicable for users whose identity is AGENCY_USER. However, the framework is general enough
 * to support internal access control and role-based permissions for other identities.
 */
export enum Role {
  /** Admin access to the API, grants all permissions within the identity's scope. */
  Admin = 'ADMIN',
  /** User access to the API, grants access to non-billing related permissions within the identity's scope. */
  User = 'USER'
}

/**
 * Sandbox-specific details attached to a SANDBOX span: one isolated code execution.
 * Resource usage is the clincher for a dedicated type, mirroring token usage on Generation.
 *
 * inputFileIds/outputFileIds are stored on the span (the surrounding tool call also holds
 * them, but the execution-level record aids debugging); the inputFiles/outputFiles fields
 * resolve them to File objects on demand.
 */
export type Sandbox = {
  __typename?: 'Sandbox';
  /** Total cost in dollars for this execution. */
  costDollars: Scalars['Decimal']['output'];
  /** Process exit code (0 = success). */
  exitCode: Scalars['Int']['output'];
  /** Files staged into the sandbox, resolved from inputFileIds. */
  inputFiles: Array<File>;
  /** Files generated by the execution, resolved from outputFileIds. */
  outputFiles: Array<File>;
  /** Runtime packages requested for the execution. */
  packages: Array<Scalars['String']['output']>;
  /** Execution provider (e.g. modal). */
  provider: Scalars['String']['output'];
  /** Billable CPU/memory usage, when Modal reported it before termination. */
  resourceUsage?: Maybe<SandboxResourceUsage>;
  /** Runtime (e.g. python3). */
  runtime: Scalars['String']['output'];
  /** The executed code, truncated to a cap at the producer. */
  script: Scalars['String']['output'];
  /** Captured stderr, truncated for storage. */
  stderr: Scalars['String']['output'];
  /** Byte size of the (stored) stderr. */
  stderrBytes: Scalars['Int']['output'];
  /** Captured stdout, truncated for storage. */
  stdout: Scalars['String']['output'];
  /** Byte size of the (stored) stdout. */
  stdoutBytes: Scalars['Int']['output'];
};

/**
 * Modal's billable sandbox resource usage. Nanosecond counters are exposed as Float
 * because they overflow a 32-bit GraphQL Int.
 */
export type SandboxResourceUsage = {
  __typename?: 'SandboxResourceUsage';
  cpuCoreNanosecs: Scalars['Float']['output'];
  memGibNanosecs: Scalars['Float']['output'];
};

/**
 * Scope that is granted based on the identity and role of a user. It impacts the breadth and depth of data that a user can access.
 * For example, an ADMIN with GLOBAL scope can access all resources across all organizations, while a USER with ORGANIZATION scope
 * can only access resources within their organization. A USER with SELF scope can only access resources that they own.
 */
export enum Scope {
  /** Global scope, grants access to all resources across all organizations. */
  Global = 'GLOBAL',
  /** Organization scope, grants access to resources within the organization. */
  Organization = 'ORGANIZATION',
  /** Self scope, grants access to resources that the user owns. */
  Self = 'SELF',
  /** Sub-organization scope, grants access to resources within related organizations. */
  SubOrganization = 'SUB_ORGANIZATION'
}

/**
 * Specifies which resource to use for deriving scope (Category 1).
 * The system determines applicable scopes by checking the principal's relationship
 * to this resource (ownership, org membership, or admin status).
 */
export type ScopeResourceInput = {
  /**
   * Field names containing the resource ID (from resolver arguments).
   * Supports hierarchical fallback: tries each field in order until a non-nil value is found.
   *
   * Three names are resolved specially: "@principalId" and "@principalOrgId" come from
   * the caller, and "@fieldValue" is the value of the field being authorized. The last
   * one is only available to @authorizeInput, where the field's value is usually the
   * resource id and the enclosing field's arguments cannot reach it.
   */
  idFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Field name containing multiple resource IDs (for batch operations). */
  multiIdField?: InputMaybe<Scalars['String']['input']>;
  /** Field name on parent object containing the resource ID. */
  parentIdField?: InputMaybe<Scalars['String']['input']>;
  /** The resource type to check the principal's relationship against. */
  resource: Resource;
};

export type SearchAmsLiveTool = {
  __typename?: 'SearchAmsLiveTool';
  input: SearchAmsLiveToolInput;
  output?: Maybe<SearchAmsLiveToolOutput>;
};

/** Input arguments for the SearchAmsLiveTool. */
export type SearchAmsLiveToolInput = {
  __typename?: 'SearchAmsLiveToolInput';
  /** The client email address to search by */
  email?: Maybe<Scalars['String']['output']>;
  /** Which data bundles to fetch live */
  include?: Maybe<Array<Scalars['String']['output']>>;
  /** Fields to include for each returned entity */
  includeFields?: Maybe<Array<Scalars['String']['output']>>;
  /** The AMS account lookup code */
  lookupCode?: Maybe<Scalars['String']['output']>;
  /** The client/business name to search by */
  name?: Maybe<Scalars['String']['output']>;
  /** The client phone number to search by */
  phone?: Maybe<Scalars['String']['output']>;
  /** Only return policies whose policy numbers match these values */
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Text filter for the notes and files bundles */
  query?: Maybe<Scalars['String']['output']>;
};

/**
 * Output of the SearchAmsLiveTool: the matched account with its contacts
 * and policies in the unified normalized shape.
 */
export type SearchAmsLiveToolOutput = {
  __typename?: 'SearchAmsLiveToolOutput';
  /**
   * The matched accounts in normalized form. Exactly one when the search was
   * unambiguous. When an email/phone/name search matches several accounts and
   * policyNumbers is provided, contains only accounts with matching policies.
   * Without policyNumbers, contains every candidate account and the per-account
   * bundles are omitted so the caller can disambiguate.
   */
  accounts?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The account's contacts in normalized form */
  contacts?: Maybe<Array<Scalars['JSON']['output']>>;
  /**
   * The account's most recent files (attachment metadata only) in normalized
   * form, filtered by query
   */
  files?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The account's most recent notes in normalized form, filtered by query */
  notes?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The account's policies (one per policy line) in normalized form */
  policies?: Maybe<Array<Scalars['JSON']['output']>>;
  /**
   * Partial-failure warnings. A data bundle named here failed to fetch — its
   * data is UNKNOWN rather than empty. Consider retrying or telling the user.
   */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** Filter input for searchCaraWorkspaces query */
export type SearchCaraWorkspacesFilterInput = {
  /** Filter by agency ID */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by agency user ID */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /**
   * When true, return ONLY archived workspaces (archived_at IS NOT NULL). When
   * false or omitted, return only active workspaces (the default, archived_at IS
   * NULL). Used to power the archived-workspaces view.
   */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restrict to workspaces linked to this client.
   *
   * Combined with the always-on visibility predicate, this is how the client detail
   * view lists a client's work without showing workspaces the caller cannot open.
   */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Exact match on custom preset ID (mutually exclusive with preset) */
  customPresetId?: InputMaybe<Scalars['String']['input']>;
  /** Exact match on built-in preset enum value */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** Free-text search across title, client name, and keywords (ILIKE with trigram index) */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Restrict to rows that are SHARED with the caller (excludes rows the caller
   * created themselves). Useful for the "Shared with me" view.
   */
  sharedWithMe?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restrict to rows that are SHARED with this specific team. The caller still
   * needs membership-based or admin access to see the row at all; this just
   * narrows the result set.
   */
  sharedWithTeamId?: InputMaybe<Scalars['String']['input']>;
  /** Exact match on workspace state */
  state?: InputMaybe<CaraWorkspaceState>;
  /** Filter workspaces updated since this timestamp */
  updatedAfter?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Restrict to a specific visibility level. Layered on top of the always-on
   * per-principal visibility filter — if you ask for PRIVATE, you only see
   * PRIVATE rows YOU can already read.
   */
  visibilityLevel?: InputMaybe<Visibility>;
};

export type SearchClientsTool = {
  __typename?: 'SearchClientsTool';
  input: SearchClientsToolInput;
  output?: Maybe<SearchClientsToolOutput>;
};

export type SearchClientsToolInput = {
  __typename?: 'SearchClientsToolInput';
  /** Cap on returned matches. Defaults to 10 when omitted. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Free-text fragment matched against client name, email, and phone. */
  query: Scalars['String']['output'];
};

export type SearchClientsToolOutput = {
  __typename?: 'SearchClientsToolOutput';
  /** Matches, best-guess order. Empty when nothing matched. */
  clients: Array<ClientToolSummary>;
  /** True when matches were cut off by the limit, so the query should be narrowed. */
  truncated: Scalars['Boolean']['output'];
};

/**
 * Result type for the searchDocumentation query,
 * containing a list of DocumentationResult objects.
 */
export type SearchDocumentationResult = {
  __typename?: 'SearchDocumentationResult';
  /** Array of matching documentation results (non-null, list of non-null items) */
  results: Array<DocumentationResult>;
};

export type SearchFileFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Restrict to files this agency uploaded. A caller that can only act on an
   * agency_file row otherwise pays a scored knowledge-graph search per integration
   * for results it discards.
   */
  uploadedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchFileResult = {
  __typename?: 'SearchFileResult';
  /** The ID of the file */
  id: Scalars['ID']['output'];
  /** The integration this file is associated with */
  integration?: Maybe<Integration>;
  /** The name of the file */
  name: Scalars['String']['output'];
};

/**
 *   Represents a tool for searching through files.
 * Used when the LLM needs to find information in specific files.
 */
export type SearchFileTool = {
  __typename?: 'SearchFileTool';
  /** The input arguments for the file search */
  input: SearchFileToolInput;
  /** The result of the file search operation */
  output: SearchFileToolOutput;
};

/**
 * Input arguments for the SearchFileTool.
 * Contains the search queries to be executed.
 */
export type SearchFileToolInput = {
  __typename?: 'SearchFileToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchFileToolQuery>;
};

/**
 * Result of a SearchFileTool operation.
 * Contains the search results and their citations.
 */
export type SearchFileToolOutput = {
  __typename?: 'SearchFileToolOutput';
  /** List of answers found in the files */
  results: Array<SearchFileToolResult>;
};

/**
 * Individual search query for the SearchFileTool.
 * Contains all parameters needed for a single file search.
 */
export type SearchFileToolQuery = {
  __typename?: 'SearchFileToolQuery';
  /** The ID of the file to search in */
  fileId: Scalars['String']['output'];
  /** Keywords to help refine the search */
  keywords: Scalars['String']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Individual answer from a file search.
 * Contains the answer and its supporting citations.
 */
export type SearchFileToolResult = {
  __typename?: 'SearchFileToolResult';
  /** The answer text found in the file */
  answer: Scalars['String']['output'];
  /** Citations supporting the answer */
  citations: Array<SearchFileToolResultCitation>;
  /** The ID of the file containing the answer */
  fileId: Scalars['String']['output'];
  /** The original query that produced this answer */
  query: Scalars['String']['output'];
};

/**
 * Citation for a file search result.
 * Provides specific location and context for the answer.
 */
export type SearchFileToolResultCitation = {
  __typename?: 'SearchFileToolResultCitation';
  /** A link to the specific location in the file */
  link: Scalars['String']['output'];
};

/**
 * Filter input for the searchIntegrationSyncLogs query.
 *
 * In organization scope, agencyId in the filter is ignored; the caller's
 * principal organization ID is always enforced.
 */
export type SearchIntegrationSyncLogsFilterInput = {
  /** Restrict to sync logs for this agency. Honored in global scope; overridden in org scope. */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to sync logs triggered by this call ID. */
  associatedCallId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to sync logs whose error list contains an error with this code. */
  errorCode?: InputMaybe<IntegrationSyncErrorCode>;
  /** Restrict to sync logs initiated by the given actor id. */
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to sync logs initiated by the given actor type. */
  initiatorType?: InputMaybe<UpdateInitiatorType>;
  /** Restrict to sync logs for this integration. */
  integrationId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to sync logs whose integration is of this type. */
  integrationType?: InputMaybe<IntegrationType>;
  /** Only sync logs whose completed_at - started_at <= this many milliseconds. */
  maxDurationMs?: InputMaybe<Scalars['Int']['input']>;
  /** Only sync logs whose completed_at - started_at >= this many milliseconds. */
  minDurationMs?: InputMaybe<Scalars['Int']['input']>;
  /** When true, only sync logs with at least one retryable error. */
  retryableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only sync logs that started strictly after this timestamp. */
  startedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only sync logs that started strictly before this timestamp. */
  startedBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Restrict to sync logs in this state. */
  state?: InputMaybe<IntegrationSyncState>;
  /** Restrict to sync logs of this type (READ or WRITE). */
  type?: InputMaybe<IntegrationSyncType>;
};

export type SearchKnowledgeBaseTool = {
  __typename?: 'SearchKnowledgeBaseTool';
  /** The input arguments for the knowledge base search */
  input: SearchKnowledgeBaseToolInput;
  /** The result of the knowledge base search operation */
  output: SearchKnowledgeBaseToolOutput;
};

/**
 * Input arguments for the SearchKnowledgeBaseTool.
 * Contains the search queries to be executed.
 */
export type SearchKnowledgeBaseToolInput = {
  __typename?: 'SearchKnowledgeBaseToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchKnowledgeBaseToolQuery>;
  userQuery: Scalars['String']['output'];
};

/**
 * Result of a SearchKnowledgeBaseTool operation.
 * Contains the search results and their citations.
 */
export type SearchKnowledgeBaseToolOutput = {
  __typename?: 'SearchKnowledgeBaseToolOutput';
  /** The answer to the user's query */
  answer: Scalars['String']['output'];
  /** List of citations actually used in the response */
  citations: Array<SearchKnowledgeBaseToolResultCitation>;
  /** List of documents found in the knowledge base */
  documents: Array<SearchKnowledgeBaseToolResultDocument>;
};

/**
 * Individual search query for the SearchKnowledgeBaseTool.
 * Contains the query to be executed against the knowledge base.
 */
export type SearchKnowledgeBaseToolQuery = {
  __typename?: 'SearchKnowledgeBaseToolQuery';
  /** Keywords to help refine the search */
  keywords: Scalars['String']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Citation for a knowledge base search result.
 * Provides specific location and context for the answer.
 */
export type SearchKnowledgeBaseToolResultCitation = {
  __typename?: 'SearchKnowledgeBaseToolResultCitation';
  /** A link to the specific location in the knowledge base */
  link: Scalars['String']['output'];
};

/**
 * Individual answer from a knowledge base search.
 * Contains the answer and its supporting citations.
 */
export type SearchKnowledgeBaseToolResultDocument = {
  __typename?: 'SearchKnowledgeBaseToolResultDocument';
  /** The ID of the document */
  id: Scalars['String']['output'];
  /** The metadata for the document */
  metadata: KnowledgeBaseDocumentMetadata;
  /** The relevant pages of the document */
  relevantPages: Array<SearchKnowledgeBaseToolResultPage>;
};

/** Represents a page from a knowledge base document. */
export type SearchKnowledgeBaseToolResultPage = {
  __typename?: 'SearchKnowledgeBaseToolResultPage';
  /** The citation for the page */
  citation: SearchKnowledgeBaseToolResultCitation;
  /** The index of the page */
  pageIndex: Scalars['Int']['output'];
};

/**
 * Represents a tool for searching the knowledge graph.
 * Used when the LLM needs to find information from the internal knowledge graph.
 */
export type SearchKnowledgeGraphTool = {
  __typename?: 'SearchKnowledgeGraphTool';
  /** The input arguments for the knowledge graph search */
  input: SearchKnowledgeGraphToolInput;
  /** The result of the knowledge graph search operation */
  output: SearchKnowledgeGraphToolOutput;
};

/**
 * Input arguments for the SearchKnowledgeGraphTool.
 * Contains the search queries to be executed.
 */
export type SearchKnowledgeGraphToolInput = {
  __typename?: 'SearchKnowledgeGraphToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchKnowledgeGraphToolQuery>;
};

/**
 * Result of a SearchKnowledgeGraphTool operation.
 * Contains the search results and their citations.
 */
export type SearchKnowledgeGraphToolOutput = {
  __typename?: 'SearchKnowledgeGraphToolOutput';
  /** List of answers found in the knowledge graph */
  entities: Array<KnowledgeGraphEntity>;
};

/**
 * Individual search query for the SearchKnowledgeGraphTool.
 * Contains the query to be executed against the knowledge graph.
 */
export type SearchKnowledgeGraphToolQuery = {
  __typename?: 'SearchKnowledgeGraphToolQuery';
  /** List of fields to include in the search */
  includeFields: Array<Scalars['String']['output']>;
  /** The search query string */
  query: Scalars['String']['output'];
};

/** Filter input for searchTraceAnalysis. */
export type SearchTraceAnalysisFilterInput = {
  /** Restrict to analyses whose trace belongs to this agency. */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to completed analyses that include this issue category. */
  category?: InputMaybe<TraceAnalysisIssueCategory>;
  /** Only analyses created strictly after this timestamp. */
  createdAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only analyses created strictly before this timestamp. */
  createdBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Restrict to completed analyses with this outcome. */
  outcome?: InputMaybe<TraceAnalysisOutcome>;
  /**
   * Free-text search. Split on whitespace into terms; an analysis matches only if
   * every term matches (AND), and a term matches when it is a case-insensitive
   * substring of the analysis id, trace id, result summary, root-cause summary, or
   * the associated trace name.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to completed analyses with this severity. */
  severity?: InputMaybe<TraceAnalysisSeverity>;
  /** Restrict to analyses whose trace belongs to this workspace stage. */
  stageId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to analyses in this lifecycle state. */
  state?: InputMaybe<TraceAnalysisState>;
  /** Restrict to analyses for this trace. */
  traceId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to analyses whose trace is in this derived status. */
  traceStatus?: InputMaybe<TraceStatus>;
  /** Restrict to analyses whose trace belongs to this workspace. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Filter input for searchTraces. */
export type SearchTracesFilterInput = {
  /** Restrict to traces for this agency. */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Only traces that ended in error. */
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only traces with duration <= this many milliseconds. */
  maxDurationMs?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces whose aggregate generation input tokens are <= this many. */
  maxInputTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces whose aggregate generation output tokens are <= this many. */
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces with total cost <= this amount in dollars. */
  maxTotalCostDollars?: InputMaybe<Scalars['Decimal']['input']>;
  /** Only traces with duration >= this many milliseconds. */
  minDurationMs?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces whose aggregate generation input tokens are >= this many. */
  minInputTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces whose aggregate generation output tokens are >= this many. */
  minOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces with total cost >= this amount in dollars. */
  minTotalCostDollars?: InputMaybe<Scalars['Decimal']['input']>;
  /** Case-insensitive substring match against gen_ai.operation.name on any span. */
  operationName?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive substring match against gen_ai.request.model on any generation span. */
  requestModel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-text search. Split on whitespace into terms; a trace matches only if every term
   * matches (AND), and a term matches when it is a case-insensitive substring of the trace
   * name, error message, trace id, or any correlated log message. So "claude error" finds
   * traces matching both "claude" and "error" across those fields.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to traces that include a span of this kind. */
  spanKind?: InputMaybe<SpanKind>;
  /** Restrict to traces for this workspace stage. */
  stageId?: InputMaybe<Scalars['String']['input']>;
  /** Only traces that started strictly after this timestamp. */
  startedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only traces that started strictly before this timestamp. */
  startedBefore?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Restrict to traces in this derived status. The resolver applies the same rules
   * as Trace.status (cancelledAt, child span endedAt/error).
   */
  status?: InputMaybe<TraceStatus>;
  /** Restrict to traces for this workspace. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a tool for searching the web.
 * Used when the LLM needs to find information from the internet.
 */
export type SearchWebTool = {
  __typename?: 'SearchWebTool';
  /** The input arguments for the web search */
  input: SearchWebToolInput;
  /** The result of the web search operation */
  output: SearchWebToolOutput;
};

/**
 * Input arguments for the SearchWebTool.
 * Contains the search queries to be executed.
 */
export type SearchWebToolInput = {
  __typename?: 'SearchWebToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchWebToolQuery>;
  /**
   * Search mode determines the depth and model used for the search.
   * Use "basic" (default) for simple lookups or when a single query is sufficient.
   * Use "pro" for complex research, multi-step verification, or comprehensive synthesis across many sources.
   */
  searchMode?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of a SearchWebTool operation.
 * Contains the search results and their citations.
 */
export type SearchWebToolOutput = {
  __typename?: 'SearchWebToolOutput';
  /** List of search results */
  results: Array<SearchWebToolResult>;
};

/**
 * Individual search query for the SearchWebTool.
 * Contains all parameters needed for a single web search.
 */
export type SearchWebToolQuery = {
  __typename?: 'SearchWebToolQuery';
  /** Keywords to help refine the search */
  keywords: Scalars['String']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Individual result from a web search.
 * Contains the answer and its supporting citations.
 */
export type SearchWebToolResult = {
  __typename?: 'SearchWebToolResult';
  /** The answer text found from web sources */
  answer: Scalars['String']['output'];
  /** Citations supporting the answer */
  citations: Array<SearchWebToolResultCitation>;
  /** The original query that produced this result */
  query: Scalars['String']['output'];
};

/**
 * Citation for a web search result.
 * Provides specific source information for the answer.
 */
export type SearchWebToolResultCitation = {
  __typename?: 'SearchWebToolResultCitation';
  /** The title of the web page */
  title: Scalars['String']['output'];
  /** The URL of the web page containing the citation */
  url: Scalars['String']['output'];
};

/** Represents a service request submitted by a merchant */
export type ServiceRequest = {
  __typename?: 'ServiceRequest';
  /** The account associated with the service request */
  account?: Maybe<Account>;
  /** Details specific to additional insured requests */
  addAdditionalInsured?: Maybe<AddAdditionalInsuredRequest>;
  /** The agency user that is assigned to this service request */
  assignee?: Maybe<AgencyUser>;
  /** The business policy associated with the service request, if any */
  businessPolicy?: Maybe<BusinessPolicy>;
  /** The calls that this service request was created from, if any */
  calls: Array<Call>;
  /** Details specific to policy cancellation requests */
  cancelPolicy?: Maybe<CancelPolicyRequest>;
  /** The email of the client that this service request is associated with, if not associated with an account */
  clientEmail?: Maybe<Scalars['String']['output']>;
  /** The name of the client that this service request is associated with, if not associated with an account */
  clientName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the client that this service request is associated with, if not associated with an account */
  clientPhone?: Maybe<Scalars['String']['output']>;
  /** When the request was closed, if applicable */
  closedAt?: Maybe<Scalars['Time']['output']>;
  /** The comments associated with this service request */
  comments: Array<ServiceRequestComment>;
  /** Details specific to Certificate of Insurance requests */
  createCertificate?: Maybe<CreateCertificateRequest>;
  /** When the request was created */
  createdAt: Scalars['Time']['output'];
  /** Additional details about the request */
  details: Scalars['String']['output'];
  /** Details specific to document requests */
  documentRequest?: Maybe<DocumentRequest>;
  /** The date and time that this service request is due, if any */
  dueAt?: Maybe<Scalars['Time']['output']>;
  /** The email thread that this service request was created from, if any */
  emailThreads: Array<EmailThread>;
  /** Details specific to policy endorsement requests */
  endorsePolicy?: Maybe<EndorsePolicyRequest>;
  /** Unique identifier for the service request */
  id: Scalars['ID']['output'];
  /** Details specific to question requests */
  question?: Maybe<QuestionRequest>;
  /** Resolution of the service request, if applicable */
  resolution?: Maybe<ServiceRequestResolution>;
  /** Files attached to the service request's resolution */
  resolutionFiles: Array<File>;
  /** Current state of the request */
  state: ServiceRequestState;
  /** Type of service request */
  type: ServiceRequestType;
  /** When the request was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this policy */
  version: Scalars['Int64']['output'];
  /** The previous versions of this policy. The first version in this list will be this version (i.e. identical to the current policy), followed by the version before that, and so-forth. */
  versionHistory?: Maybe<Array<ServiceRequestVersion>>;
};

export type ServiceRequestComment = {
  __typename?: 'ServiceRequestComment';
  /** The agency user that created the comment */
  agencyUser: AgencyUser;
  /** The content of the comment */
  content: Scalars['String']['output'];
  /** The date and time that the comment was created */
  createdAt: Scalars['Time']['output'];
  /** The ID of the comment */
  id: Scalars['ID']['output'];
  /** The date and time that the comment was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Describes the resolution of a service request */
export type ServiceRequestResolution = {
  __typename?: 'ServiceRequestResolution';
  /** Internal notes about the resolution */
  notes: Scalars['String']['output'];
};

/** Current state of a service request */
export enum ServiceRequestState {
  /** Request has been completed */
  Closed = 'CLOSED',
  /** Request is still being processed */
  Open = 'OPEN'
}

/** Type of service request that can be created */
export enum ServiceRequestType {
  /** Request to add an additional insured to a policy */
  AddAdditionalInsured = 'ADD_ADDITIONAL_INSURED',
  /** Request to cancel an existing policy */
  CancelPolicy = 'CANCEL_POLICY',
  /** Request to create a Certificate of Insurance */
  CreateCertificate = 'CREATE_CERTIFICATE',
  /** Request for policy-related documents */
  DocumentRequest = 'DOCUMENT_REQUEST',
  /** Request to modify/endorse an existing policy */
  EndorsePolicy = 'ENDORSE_POLICY',
  /** Other miscellaneous requests */
  Other = 'OTHER',
  /** Question about policies, account, or billing, etc. */
  Question = 'QUESTION',
  /** Request to get a new quote for insurance */
  QuoteRequest = 'QUOTE_REQUEST'
}

/** Describes the reason why an application was updated */
export enum ServiceRequestUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a policy */
export enum ServiceRequestUpdateType {
  /** A comment was added to the service request */
  AddServiceRequestComment = 'ADD_SERVICE_REQUEST_COMMENT',
  /** The service request was assigned to an agency user */
  AssignServiceRequest = 'ASSIGN_SERVICE_REQUEST',
  /** The service request was closed */
  CloseServiceRequest = 'CLOSE_SERVICE_REQUEST',
  /** The service request was created */
  CreateServiceRequest = 'CREATE_SERVICE_REQUEST',
  /** The service request was enriched */
  EnrichServiceRequest = 'ENRICH_SERVICE_REQUEST',
  /** The service request was updated */
  UpdateServiceRequest = 'UPDATE_SERVICE_REQUEST',
  /** The due date of the service request was updated */
  UpdateServiceRequestDueAt = 'UPDATE_SERVICE_REQUEST_DUE_AT'
}

/** Describes a particular version of a service request */
export type ServiceRequestVersion = {
  __typename?: 'ServiceRequestVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another service request version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous service request version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<ServiceRequestVersion>;
  /** The full service request object that includes all of the updates made in this version and all previous versions */
  serviceRequest: ServiceRequest;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<ServiceRequestUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<ServiceRequestUpdateType>;
  /** The version number of this service request version */
  version: Scalars['Int64']['output'];
};

/**
 * A revisioned entity-tree document: entities own scalar properties and child
 * entities, and repeated children with the same relation are separate records.
 * The document shape is validated server side; see smartfill.BucketDocument.
 */
export type SmartFillBucket = {
  __typename?: 'SmartFillBucket';
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  document: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operationId: Scalars['ID']['output'];
  origin: SmartFillBucketOrigin;
  revision: Scalars['Int64']['output'];
  updatedAt: Scalars['Time']['output'];
  visibility: SmartFillBucketVisibility;
};

export enum SmartFillBucketOrigin {
  Copy = 'COPY',
  Manual = 'MANUAL',
  Workspace = 'WORKSPACE'
}

export enum SmartFillBucketVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum SmartFillDecisionSource {
  Model = 'MODEL',
  User = 'USER'
}

export enum SmartFillDecisionStatus {
  /** No auto-write; reason explains why and a suggestion may be attached. */
  Review = 'REVIEW',
  /** A user rule says to always leave this destination blank. */
  Skip = 'SKIP',
  /** The value is safe to write automatically. */
  Write = 'WRITE'
}

/** One immutable observability record; metadata never contains values. */
export type SmartFillEvent = {
  __typename?: 'SmartFillEvent';
  action: SmartFillEventAction;
  bucketId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  formFingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  operationId: Scalars['ID']['output'];
  promptVersion?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['ID']['output']>;
};

export enum SmartFillEventAction {
  Copy = 'COPY',
  Correction = 'CORRECTION',
  Fill = 'FILL'
}

export type SmartFillFieldDecision = {
  __typename?: 'SmartFillFieldDecision';
  confidence: Scalars['Float']['output'];
  fieldId: Scalars['String']['output'];
  fieldKey: Scalars['String']['output'];
  propertyId?: Maybe<Scalars['ID']['output']>;
  /** Populated for REVIEW decisions, e.g. NO_MATCH or OPTION_MISMATCH. */
  reason?: Maybe<Scalars['String']['output']>;
  source: SmartFillDecisionSource;
  status: SmartFillDecisionStatus;
  value?: Maybe<Scalars['String']['output']>;
};

/** The generalizable meaning a HINT teaches, derived from a chosen property. */
export type SmartFillFieldIntent = {
  __typename?: 'SmartFillFieldIntent';
  entityKind?: Maybe<Scalars['String']['output']>;
  entityRole?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
};

/** The type of a form field detected by the Smart Fill extension. */
export enum SmartFillFieldType {
  /**
   * A clickable mutually-exclusive choice group (segmented control, pill row).
   * SELECT-shaped: options carry opaque values the extension maps to elements.
   */
  Button = 'BUTTON',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Email = 'EMAIL',
  Number = 'NUMBER',
  Phone = 'PHONE',
  Radio = 'RADIO',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

/** One validated destination-group-to-source-entity binding. */
export type SmartFillGroupBinding = {
  __typename?: 'SmartFillGroupBinding';
  entityId: Scalars['ID']['output'];
  groupId: Scalars['String']['output'];
};

/** One structural section of the live form; repeated rows share a repeatSetId. */
export type SmartFillGroupInput = {
  groupId: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  repeatSetId?: InputMaybe<Scalars['String']['input']>;
};

/** One select or radio choice with its submitted value and human label. */
export type SmartFillOptionInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

/** One current correction rule owned by the calling user, keyed to a form. */
export type SmartFillOverride = {
  __typename?: 'SmartFillOverride';
  action: SmartFillOverrideAction;
  createdAt: Scalars['Time']['output'];
  fieldKey: Scalars['String']['output'];
  fingerprintVersion: Scalars['Int']['output'];
  formFingerprint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Present for HINT rules; describes the taught field meaning. */
  intent?: Maybe<SmartFillFieldIntent>;
  updatedAt: Scalars['Time']['output'];
};

export enum SmartFillOverrideAction {
  /**
   * Teach what this field means so the model matches it confidently against any
   * bucket. Bucket-independent; injected into the match prompt as a strong prior.
   */
  Hint = 'HINT',
  /** Always leave this destination blank, regardless of bucket. */
  Skip = 'SKIP'
}

/** One fillable control of the live form. */
export type SmartFillResolveFieldInput = {
  autocomplete?: InputMaybe<Scalars['String']['input']>;
  /** Page-lifetime DOM identity used to apply the returned decisions. */
  fieldId: Scalars['String']['input'];
  /** Durable occurrence-aware structural key used for correction rules. */
  fieldKey: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<SmartFillOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: SmartFillFieldType;
};

export type SmartFillResolveResult = {
  __typename?: 'SmartFillResolveResult';
  /**
   * The repeated-entity bindings that survived validation, so continuous-fill
   * sessions can record which source records are now placed.
   */
  bindings: Array<SmartFillGroupBinding>;
  bucketId: Scalars['ID']['output'];
  bucketRevision: Scalars['Int64']['output'];
  decisions: Array<SmartFillFieldDecision>;
  formSnapshotHash: Scalars['String']['output'];
  /** Null when every destination was decided by user rules without the model. */
  modelId?: Maybe<Scalars['String']['output']>;
  promptVersion: Scalars['String']['output'];
  requestId: Scalars['ID']['output'];
};

/**
 * Ephemeral continuous-fill session memory, held client side and echoed here so
 * one session never places the same repeated record on two rows.
 */
export type SmartFillSessionContextInput = {
  /**
   * Repeated source entity IDs already bound to rows earlier in this session.
   * The resolver refuses to bind them again; stale IDs are ignored.
   */
  placedEntityIds: Array<Scalars['ID']['input']>;
};

/** One asynchronous workspace conversion. */
export type SmartFillWorkspaceConversion = {
  __typename?: 'SmartFillWorkspaceConversion';
  bucketIds: Array<Scalars['ID']['output']>;
  completed: Scalars['Boolean']['output'];
  operationId: Scalars['ID']['output'];
  workflowId: Scalars['ID']['output'];
};

/** Sort direction */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/**
 * A single observation within a trace (span, generation, tool call, embedding, rerank,
 * sandbox execution, HTTP exchange, or database query).
 *
 * Detail loading is lazy, keyed off the entry point used to fetch the span — not off the
 * selection set. The heavy detail payloads are hydrated ONLY when a span is fetched via
 * the `span(id)` query. On the trace waterfall path (`trace`/`searchTraces` -> rootSpans
 * -> children) the resolver loads a lightweight summary instead, so it does not read
 * every span's payload up front:
 *   - generation, toolCall, embedding, and rerank carry their summary fields, but their
 *     heavy subfields are null: generation.input/output, toolCall.arguments/result,
 *     embedding.inputs, rerank.results.
 *   - sandbox, http, and dbQuery are null entirely.
 * Selecting one of those fields on the waterfall path returns null — the field still
 * resolves, it is simply not hydrated there. To show a span's full detail, fetch
 * `span(id)`. (This contract is enforced by the resolver wiring, not by the type system:
 * the fields are nullable and always selectable.)
 */
export type Span = {
  __typename?: 'Span';
  /** Additional span attributes */
  attributes: Scalars['JSON']['output'];
  /**
   * Child spans, ordered by startedAt. Loaded as lightweight summaries (like
   * Trace.rootSpans); the heavy detail payloads are null here — fetch `span(id)` for a
   * span's full detail. See Span.
   */
  children: Array<Span>;
  /** Database query details when kind is DATABASE. */
  dbQuery?: Maybe<DbQuery>;
  /** Duration in milliseconds, if complete. */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Embedding details when kind is EMBEDDING. */
  embedding?: Maybe<Embedding>;
  /** When the span ended, if complete. */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** Human-readable error message when status is ERROR. */
  error?: Maybe<Scalars['String']['output']>;
  /** error.type from OTel semantic conventions. */
  errorType?: Maybe<Scalars['String']['output']>;
  /** LLM details when kind is GENERATION. */
  generation?: Maybe<Generation>;
  /**
   * True when this span has at least one child in the database. Useful for
   * lazy-loading UIs that need to show an expand toggle without fetching
   * the full child subtree.
   */
  hasChildren: Scalars['Boolean']['output'];
  /** HTTP details when kind is HTTP. */
  http?: Maybe<HttpRequestResponse>;
  /** OTel span ID. */
  id: Scalars['ID']['output'];
  /** Observation kind for viewer grouping. */
  kind: SpanKind;
  /** Log records emitted during this span. */
  logs: Array<LogRecord>;
  /** Human-readable span name (e.g. chat claude-sonnet-4-6, execute_tool search_file). */
  name: Scalars['String']['output'];
  /** gen_ai.operation.name when applicable. */
  operationName?: Maybe<Scalars['String']['output']>;
  /** Rerank details when kind is RERANK. */
  rerank?: Maybe<Rerank>;
  /** Sandbox execution details when kind is SANDBOX. */
  sandbox?: Maybe<Sandbox>;
  /** When the span started. */
  startedAt: Scalars['Time']['output'];
  /**
   * Derived: IN_PROGRESS when endedAt is null; ERROR when endedAt is set and error
   * is present; otherwise OK.
   */
  status: SpanStatus;
  /** Tool details when kind is TOOL. */
  toolCall?: Maybe<TraceToolCall>;
};

/** Kind of observation within a trace. Supplements gen_ai.operation.name for viewer grouping. */
export enum SpanKind {
  /** A database query (OTel database client span). */
  Database = 'DATABASE',
  /** An embedding (text/content → vectors) call. */
  Embedding = 'EMBEDDING',
  /** An LLM generation (sync or streaming). */
  Generation = 'GENERATION',
  /** An outbound or inbound HTTP request (OTel HTTP client/server span). */
  Http = 'HTTP',
  /** A rerank call (query + candidates → scored reordering). */
  Rerank = 'RERANK',
  /** An isolated code execution in a sandbox (e.g. Modal). */
  Sandbox = 'SANDBOX',
  /** Generic nested work unit (retrieval, orchestration, etc.). */
  Span = 'SPAN',
  /** A tool invocation. */
  Tool = 'TOOL'
}

/** Status of a span, derived at read time from endedAt and error. */
export enum SpanStatus {
  /** Span ended with an error (OTel status Error). */
  Error = 'ERROR',
  /** Span has not ended yet (endedAt is null). */
  InProgress = 'IN_PROGRESS',
  /** Span ended without an error (OTel status Ok). */
  Ok = 'OK'
}

/**
 * Input for startPresetGeneration: the source workspaces plus the wizard choices
 * that shape the generated preset.
 */
export type StartPresetGenerationInput = {
  /** Optional override of the auto-detected base preset. */
  basePresetOverride?: InputMaybe<CaraWorkspacePreset>;
  /** Optional custom forms the resulting preset should default to. */
  customFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional IDs of files to supply as additional context for generation. */
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional HTML document templates the resulting preset should default to. */
  htmlDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional free-text description of the desired output formats. */
  outputFormatsText?: InputMaybe<Scalars['String']['input']>;
  /** Optional answers to clarifying questions from a prior wizard turn. */
  qaAnswers?: InputMaybe<Array<PresetGenerationQaAnswerInput>>;
  /** The workspaces to generate the preset from. At least one is required. */
  sourceWorkspaceIds: Array<Scalars['String']['input']>;
  /** Optional Word document templates the resulting preset should default to. */
  wordDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for submitting call rating */
export type SubmitCallRatingInput = {
  /** Call ID */
  callId: Scalars['String']['input'];
  /**
   * Custom comment for additional details (optional, but required when OTHER is selected as a reason)
   * Can be provided with any reason for additional context
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Rating: up or down */
  rating: MessageRating;
  /**
   * Predefined reasons (multiple selection allowed, optional for thumbs up)
   * - For DOWN rating: select reasons for what went wrong
   * - For UP rating: optional, can leave blank for quick feedback
   */
  reasons?: InputMaybe<Array<CallQualityFeedbackNegativeReason>>;
};

/** Input for submitting message rating (thumbs up/down) */
export type SubmitMessageRatingInput = {
  /**
   * Custom comment for additional details (optional, but required when OTHER is selected as a reason)
   * Can be provided with any reason for additional context
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Message being rated */
  messageId: Scalars['String']['input'];
  /** Rating: up or down */
  rating: MessageRating;
  /**
   * Predefined reasons (multiple selection allowed, optional for thumbs up)
   * - For DOWN rating: select reasons for what went wrong
   * - For UP rating: optional, can leave blank for quick feedback
   */
  reasons?: InputMaybe<Array<MessageFeedbackNegativeReason>>;
  /** Workspace containing the message */
  workspaceId: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to Cara workspace updates */
  watchCaraWorkspace: CaraWorkspace;
  /**
   * Subscribe to real-time updates for a workflow execution, including task
   * state changes and new events. Scoped via WORKFLOW_EXECUTION so the
   * directive denies cross-agency subscriptions.
   */
  watchWorkflowExecution: WorkflowExecution;
  /**
   * Subscribe to real-time task events for a specific task. Scoped via
   * WORKFLOW_TASK so the directive denies cross-agency subscriptions.
   */
  watchWorkflowTaskEvents: WorkflowTaskEvent;
};


export type SubscriptionWatchCaraWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionWatchWorkflowExecutionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['Int64']['input'];
};


export type SubscriptionWatchWorkflowTaskEventsArgs = {
  taskId: Scalars['ID']['input'];
};

/** Entitlements for the subscription */
export enum SubscriptionEntitlement {
  /** The entitlement to use advanced voice customization */
  AdvancedVoiceCustomization = 'ADVANCED_VOICE_CUSTOMIZATION',
  /**
   * The entitlement to author agency profiles that set the home screen, sidebar,
   * and permission policy for groups of agency users
   */
  AgencyProfileManagement = 'AGENCY_PROFILE_MANAGEMENT',
  /** The entitlement to connect AMS and CRM integrations (not available on Basic) */
  AmsCrmIntegrations = 'AMS_CRM_INTEGRATIONS',
  /** The entitlement to use the PDF Editor tool */
  CopilotPdfEditor = 'COPILOT_PDF_EDITOR',
  /** The entitlement to use Pro-tier Copilot presets (Underwriting Analysis, SOV & COPE, Claims Review, Loss Run Analysis) */
  CopilotProPresets = 'COPILOT_PRO_PRESETS',
  /** The entitlement to enable creation of and federate billing for sub agencies */
  FederatedBilling = 'FEDERATED_BILLING',
  /** The entitlement to manage teams (groups of agency users) used to scope shared visibility */
  TeamManagement = 'TEAM_MANAGEMENT',
  /**
   * The entitlement to set visibility (PRIVATE / SHARED) on workspaces, presets,
   * templates, and forms. Without this, all objects remain PUBLIC.
   */
  VisibilityControl = 'VISIBILITY_CONTROL',
  /** The entitlement to enable voice agent account lookup (Account Policy Question tool; Pro and Enterprise only) */
  VoiceAccountLookup = 'VOICE_ACCOUNT_LOOKUP'
}

export type SubscriptionManagementLinks = {
  __typename?: 'SubscriptionManagementLinks';
  /** The link to the update subscription page for the agency */
  previewUpdateSubscription: PreviewUpdateSubscriptionResult;
  /** The link to the update payment method page for the agency */
  updatePaymentMethodUrl: Scalars['String']['output'];
};


export type SubscriptionManagementLinksPreviewUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};

/** The period of the subscription */
export enum SubscriptionPeriod {
  /** The subscription is yearly */
  Annual = 'ANNUAL',
  /** The subscription is monthly */
  Monthly = 'MONTHLY'
}

/** The plan that the agency is subscribed to */
export enum SubscriptionPlan {
  /** The basic subscription plan */
  Basic = 'BASIC',
  /** The premium subscription plan */
  Enterprise = 'ENTERPRISE',
  /** The pro subscription plan */
  Pro = 'PRO',
  /**
   * The standard subscription plan
   * @deprecated This plan is no longer available for new accounts.
   */
  Standard = 'STANDARD'
}

/** The state of the subscription for the agency */
export enum SubscriptionState {
  /** The subscription is active and paid */
  Active = 'ACTIVE',
  /** The subscription has expired due to cancellation or nonpayment */
  Expired = 'EXPIRED',
  /** The subscription is active but unpaid */
  Overdue = 'OVERDUE',
  /** The subscription is currently paused */
  Paused = 'PAUSED',
  /** The subscription is currently in a trial period and active */
  Trial = 'TRIAL'
}

export type SuperCopyBlockInput = {
  id: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum SuperCopyBoundaryKind {
  Region = 'REGION',
  WholePage = 'WHOLE_PAGE'
}

export type SuperCopyDraft = {
  __typename?: 'SuperCopyDraft';
  clients: Array<SuperCopyDraftClient>;
  modelId: Scalars['String']['output'];
  source: SuperCopySource;
};

export type SuperCopyDraftClient = {
  __typename?: 'SuperCopyDraftClient';
  groups: Array<SuperCopyGroup>;
  id: Scalars['ID']['output'];
  suggestedName: Scalars['String']['output'];
};

export type SuperCopyEvidence = {
  __typename?: 'SuperCopyEvidence';
  blockIds: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type SuperCopyGroup = {
  __typename?: 'SuperCopyGroup';
  id: Scalars['ID']['output'];
  kind: SuperCopyGroupKind;
  label: Scalars['String']['output'];
  values: Array<SuperCopyValue>;
};

export enum SuperCopyGroupKind {
  Address = 'ADDRESS',
  Agency = 'AGENCY',
  Business = 'BUSINESS',
  Contact = 'CONTACT',
  Custom = 'CUSTOM',
  Policy = 'POLICY'
}

export enum SuperCopyReviewState {
  Accepted = 'ACCEPTED',
  Custom = 'CUSTOM',
  Edited = 'EDITED',
  Unknown = 'UNKNOWN'
}

export type SuperCopySource = {
  __typename?: 'SuperCopySource';
  boundaryFingerprint: Scalars['String']['output'];
  boundaryKind: SuperCopyBoundaryKind;
  boundaryLabel: Scalars['String']['output'];
  screenshotCoverage: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SuperCopySourceInput = {
  boundaryFingerprint: Scalars['String']['input'];
  boundaryKind: SuperCopyBoundaryKind;
  boundaryLabel: Scalars['String']['input'];
  screenshotCoverage: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SuperCopyValue = {
  __typename?: 'SuperCopyValue';
  confidence: Scalars['Float']['output'];
  evidence: SuperCopyEvidence;
  extractedValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  reviewState: SuperCopyReviewState;
  semanticKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Table style */
export type TableStyle = {
  __typename?: 'TableStyle';
  /** Border collapse setting (e.g. 'collapse') */
  borderCollapse?: Maybe<Scalars['String']['output']>;
  /** Cell border style (e.g. '1px solid #cbd5e1') */
  cellBorder?: Maybe<Scalars['String']['output']>;
  /** Cell padding in em units (e.g. 0.4) */
  cellPaddingEm?: Maybe<Scalars['Float']['output']>;
  /** Font size in points (e.g. 10.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Header background color in hex format (e.g. '#e2e8f0') */
  headerBackgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Header text color in hex format (e.g. '#0f172a') */
  headerColorHex?: Maybe<Scalars['String']['output']>;
  /** Header font weight as a number (e.g. 600) */
  headerFontWeight?: Maybe<Scalars['Int']['output']>;
  /** Top margin in em units (e.g. 1.0) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
  /** When true, table header rows repeat on each page when the table spans multiple pages */
  repeatHeaders?: Maybe<Scalars['Boolean']['output']>;
  /** Width as a percentage (e.g. 100.0) */
  widthPct?: Maybe<Scalars['Float']['output']>;
  /** Background color for zebra-striped even rows in hex format (e.g. '#f8fafc'). When set, alternating rows are styled. */
  zebraStripeColorHex?: Maybe<Scalars['String']['output']>;
};

/** Input for table style */
export type TableStyleInput = {
  /** CSS border-collapse style ('collapse', 'separate') */
  borderCollapse?: InputMaybe<Scalars['String']['input']>;
  /** CSS border property for cells (e.g. '1px solid #ccc') */
  cellBorder?: InputMaybe<Scalars['String']['input']>;
  /** Cell padding in em units */
  cellPaddingEm?: InputMaybe<Scalars['Float']['input']>;
  /** Font size in points for table text */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Header background color as a hex string */
  headerBackgroundColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Header text color as a hex string */
  headerColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font weight of table header text */
  headerFontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Top margin in em units */
  marginTopEm?: InputMaybe<Scalars['Float']['input']>;
  /** If true, table headers are repeated on each page */
  repeatHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Table width as a percentage of the page width (0-100) */
  widthPct?: InputMaybe<Scalars['Float']['input']>;
  /** Background color for zebra striped rows as a hex string */
  zebraStripeColorHex?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A team is a grouping of agency users used to scope SHARED visibility on
 * workspaces, presets, templates, and forms. Teams do not grant or restrict
 * permissions on their own — they only affect what objects a user can see when
 * those objects are set to SHARED visibility with the team in the access list.
 *
 * Team management is gated behind the TEAM_MANAGEMENT subscription entitlement
 * (Enterprise plan). Without the entitlement, teams cannot be created or used
 * to scope visibility.
 */
export type Team = {
  __typename?: 'Team';
  /** Agency the team belongs to */
  agency: Agency;
  /** Timestamp when the team was archived (soft delete). Null for active teams. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** Timestamp when the team was created */
  createdAt: Scalars['Time']['output'];
  /** Agency user that created this team */
  createdBy: AgencyUser;
  /** Optional description of the team */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the team */
  id: Scalars['ID']['output'];
  /** Number of members in the team */
  memberCount: Scalars['Int']['output'];
  /** Members of the team */
  members: Array<TeamMember>;
  /** Name of the team. Unique within an agency (case-insensitive). */
  name: Scalars['String']['output'];
  /** Timestamp when the team was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Input for creating or updating a team. */
export type TeamInput = {
  /** Optional description of the team */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Initial set of agency user IDs to add as members.
   * For updateTeam, this replaces the full member list.
   */
  memberUserIds: Array<Scalars['String']['input']>;
  /** Name of the team. Must be unique within the agency (case-insensitive). */
  name: Scalars['String']['input'];
};

/** A user's membership in a team. */
export type TeamMember = {
  __typename?: 'TeamMember';
  /** Timestamp when the user was added to the team */
  addedAt: Scalars['Time']['output'];
  /** The agency user that is a member of the team */
  user: AgencyUser;
};

/** Represents a reference to text content stored in the cache */
export type TextReference = {
  __typename?: 'TextReference';
  /** The cache key for the text content */
  cacheKey: Scalars['String']['output'];
  /** The size of the text content in bytes */
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  /** Whether the content was truncated */
  truncated: Scalars['Boolean']['output'];
};

/**
 * Represents a tool that allows the LLM to think through a problem or task.
 * This tool is used when the LLM needs to process information or make decisions.
 */
export type ThinkTool = {
  __typename?: 'ThinkTool';
  /** The input arguments for the think operation */
  input: ThinkToolInput;
  /** The result of the thinking operation */
  output: ThinkToolOutput;
};

/**
 * Input arguments for the ThinkTool.
 * Used to provide context and purpose for the thinking operation.
 */
export type ThinkToolInput = {
  __typename?: 'ThinkToolInput';
  /** The detailed thought process */
  thought: Scalars['String']['output'];
  /** A brief title describing the thinking task */
  title: Scalars['String']['output'];
};

/**
 * Result of a ThinkTool operation.
 * Indicates whether the thinking process was successful.
 */
export type ThinkToolOutput = {
  __typename?: 'ThinkToolOutput';
  /** Whether the thinking operation completed successfully */
  success: Scalars['Boolean']['output'];
};

/**
 * Token usage for an LLM generation.
 * Maps to gen_ai.usage.* attributes.
 */
export type TokenUsage = {
  __typename?: 'TokenUsage';
  /** gen_ai.usage.cache_creation.input_tokens */
  cacheCreationInputTokens: Scalars['Int']['output'];
  /** gen_ai.usage.cache_read.input_tokens */
  cacheReadInputTokens: Scalars['Int']['output'];
  /** gen_ai.usage.input_tokens */
  inputTokens: Scalars['Int']['output'];
  /** gen_ai.usage.output_tokens */
  outputTokens: Scalars['Int']['output'];
};

/** Represents a tool call that was made in the context of an email conversation */
export type ToolCall = {
  __typename?: 'ToolCall';
  /** The arguments passed to the tool in JSON format */
  argumentsJson: Scalars['String']['output'];
  /** The ID of the tool call */
  id: Scalars['String']['output'];
  /** The name of the tool being called */
  name: Scalars['String']['output'];
  /** The result of the tool call */
  result: Scalars['String']['output'];
  /** Timestamp when this tool call was made */
  timestamp: Scalars['Time']['output'];
};

/** A top-level trace representing one agent run or user request. */
export type Trace = {
  __typename?: 'Trace';
  /** Analysis state and results for this trace. */
  analysis?: Maybe<TraceAnalysis>;
  /** Set when the associated Temporal workflow was cancelled. Drives CANCELLED status. */
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  /** Duration in milliseconds, if complete. */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** When the trace ended. */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** Human-readable error message if status is ERROR. */
  error?: Maybe<Scalars['String']['output']>;
  /** error.type from OTel semantic conventions. */
  errorType?: Maybe<Scalars['String']['output']>;
  /** OTel trace ID. */
  id: Scalars['ID']['output'];
  /**
   * High-level trace input (e.g. user message, task prompt).
   * May be truncated for storage.
   */
  input?: Maybe<Scalars['JSON']['output']>;
  /** All log records in this trace, ordered by timestamp. */
  logs: Array<LogRecord>;
  /** Additional trace-level metadata and tags. */
  metadata: Scalars['JSON']['output'];
  /** Human-readable trace name (e.g. cara.workspace.execute_task_step). */
  name: Scalars['String']['output'];
  /**
   * High-level trace output (e.g. final agent response).
   * May be truncated for storage.
   */
  output?: Maybe<Scalars['JSON']['output']>;
  /**
   * Root spans (parentSpanId is null), ordered by startedAt. Loaded as lightweight
   * summaries — the heavy detail payloads are null here; fetch `span(id)` for a span's
   * full detail. See Span.
   */
  rootSpans: Array<Span>;
  /** Total number of spans in this trace. */
  spanCount: Scalars['Int']['output'];
  /** When the trace started. */
  startedAt: Scalars['Time']['output'];
  /**
   * Derived: CANCELLED when cancelledAt is set; IN_PROGRESS when endedAt is null;
   * ERROR when the trace or any span recorded an error; otherwise OK.
   */
  status: TraceStatus;
  /** Aggregate cost in dollars across all generations in this trace. */
  totalCostDollars: Scalars['Decimal']['output'];
  /** Aggregate token usage across all generations in this trace. */
  totalUsage: TokenUsage;
  /** Associated workspace, if any. */
  workspace?: Maybe<CaraWorkspace>;
};

/**
 * Trace analysis job and results for a single trace. The analysis agent produces
 * markdown (analysis) for human-readable narrative and structured output (result)
 * for filtering and triage. Only populate result when state is COMPLETED.
 */
export type TraceAnalysis = {
  __typename?: 'TraceAnalysis';
  /**
   * Full narrative in Markdown for the trace detail view: timeline, context,
   * and explanation. May elaborate beyond result.summary but must not contradict
   * result.outcome, category, or primaryIssue. Populated when state is COMPLETED.
   */
  analysis?: Maybe<Scalars['String']['output']>;
  /** When the analysis job was enqueued. */
  createdAt: Scalars['Time']['output'];
  /** The ID of the Cursor agent that ran the analysis (to open in the UI) */
  cursorAgentId?: Maybe<Scalars['String']['output']>;
  /** The ID of the Cursor run that ran the analysis (to open in the UI) */
  cursorRunId?: Maybe<Scalars['String']['output']>;
  /**
   * When the analysis agent finished (success or failure). Null while QUEUED or
   * RUNNING.
   */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Error message if the analysis job itself failed (agent crash, timeout, invalid
   * output). Not the trace's error — that belongs in result.rootCauseSummary.
   * Populated when state is FAILED.
   */
  error?: Maybe<Scalars['String']['output']>;
  /** Unique ID of this analysis run. */
  id: Scalars['ID']['output'];
  /**
   * Structured triage output for search, dashboards, and alerts. Populated when
   * state is COMPLETED. The analysis agent must set every required field; see
   * field descriptions on TraceAnalysisResult for how to choose values.
   */
  result?: Maybe<TraceAnalysisResult>;
  /** When the analysis agent began processing the trace. Null while QUEUED. */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Lifecycle state of the analysis job. Set by the orchestrator, not the
   * analysis agent.
   */
  state: TraceAnalysisState;
  /** The trace this analysis belongs to. */
  trace: Trace;
  /** When the analysis record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type TraceAnalysisConnection = {
  __typename?: 'TraceAnalysisConnection';
  edges: Array<TraceAnalysisEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TraceAnalysisEdge = {
  __typename?: 'TraceAnalysisEdge';
  cursor: Scalars['String']['output'];
  node: TraceAnalysis;
};

/**
 * Supporting evidence for a trace analysis issue: an interpretive claim linked to
 * spans and logs. Do not restate raw span names without interpretation.
 */
export type TraceAnalysisEvidence = {
  __typename?: 'TraceAnalysisEvidence';
  /**
   * A single interpretive claim (not a span name or raw error string). Example:
   * "KB rerank top score was 0.28, below the usual adequate threshold."
   */
  claim: Scalars['String']['output'];
  /**
   * Correlated log IDs when the claim depends on log context not captured on the
   * span (workflow warnings, stuck-loop detector messages). Omit when span data
   * alone is sufficient.
   */
  logIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * OTel span IDs that directly support the claim. Use the earliest span that
   * establishes the fact (e.g. the failing TOOL span, the RERANK span with low
   * topScore). At least one span is required per evidence entry.
   */
  spanIds: Array<Scalars['String']['output']>;
};

/** A distinct issue identified during trace analysis. */
export type TraceAnalysisIssue = {
  __typename?: 'TraceAnalysisIssue';
  /** One or more categories classifying this issue. */
  categories: Array<TraceAnalysisIssueCategory>;
  /**
   * Supporting interpretive claims with span and log IDs. At least one entry per
   * issue when the issue is non-obvious.
   */
  evidence: Array<TraceAnalysisEvidence>;
  /**
   * 2-4 sentences explaining what happened, why it matters, and how it relates
   * to the run outcome.
   */
  summary: Scalars['String']['output'];
  /** Short title, 4-10 words. */
  title: Scalars['String']['output'];
};

/**
 * Top-level issue category for filtering and dashboards. Every primaryIssue
 * belongs to exactly one category; finer detail (tool name, loop type, etc.)
 * belongs in rootCauseSummary and issues.
 */
export enum TraceAnalysisIssueCategory {
  /**
   * Agent loop did not complete normally: stuck loops, iteration cap, or no
   * COMPLETE_TASK.
   */
  AgentOrchestration = 'AGENT_ORCHESTRATION',
  /**
   * Producing user-facing deliverables: documents, forms, templates, sandbox
   * code outputs.
   */
  Artifact = 'ARTIFACT',
  /**
   * Third-party services outside the agency corpus: web search and AMS/CRM
   * integrations.
   */
  ExternalService = 'EXTERNAL_SERVICE',
  /** File or attachment access and parsing (PEEK_FILE, ingest, Reducto). */
  File = 'FILE',
  /** Timeouts, cancellation, or Cara platform infrastructure. */
  Infrastructure = 'INFRASTRUCTURE',
  /** LLM provider calls and output quality (GENERATION spans). */
  Llm = 'LLM',
  /** Cost, latency, or other quality concerns without a functional failure. */
  Operational = 'OPERATIONAL',
  /**
   * Could not find or rank relevant context (file/KB/KG/memory search;
   * embedding and rerank spans).
   */
  Retrieval = 'RETRIEVAL',
  /** Tool input validation or execution not better explained by a category above. */
  ToolCall = 'TOOL_CALL',
  /** Root cause could not be determined. */
  Unknown = 'UNKNOWN',
  /**
   * User-side cause: ambiguous or missing input, misuse of the product, or
   * agency misconfiguration the user could have resolved. Use when the primary
   * root cause is not a Cara bug or infra failure — e.g. required attachment
   * not uploaded, unclear instructions the agent could not disambiguate, or
   * incorrect expectations about what Cara can do. Pair with outcome USER_ERROR
   * when the user did not get an acceptable result for this reason.
   */
  UserError = 'USER_ERROR'
}

/**
 * High-level outcome of a completed trace analysis. Describes the user-visible
 * result of the agent run. May differ from Trace.status (e.g. Trace.status OK
 * with outcome DEGRADED when retrieval was weak). Set from the trace's final
 * deliverable and error spans, not from infrastructure health alone. Use
 * category and primaryIssue for the technical root cause.
 */
export enum TraceAnalysisOutcome {
  /**
   * Trace.cancelledAt is set or the workflow/activity was cancelled before the
   * task finished.
   */
  Cancelled = 'CANCELLED',
  /**
   * The user received a usable result but quality was compromised: weak rerank
   * scores, rerank fallback, minor truncation, elevated cost/latency, or
   * recoverable tool errors that the agent worked around. Prefer this over
   * FAILURE when the workspace output still addresses the user's request.
   */
  Degraded = 'DEGRADED',
  /**
   * The task failed for any other functional reason: agent stuck or incomplete,
   * retrieval miss, artifact/form failure, integration API error, LLM error, etc.
   * Pick the most specific category; use FAILURE when the user did not get an
   * acceptable result and USER_ERROR does not apply.
   */
  Failure = 'FAILURE',
  /**
   * Failed due to Cara platform or provider infrastructure: internal database
   * errors, unrecoverable HTTP failures to LLM/embedding providers, Modal/sandbox
   * platform errors, or integration endpoints that are down. Do not use for
   * agency misconfiguration (INTEGRATION_NOT_CONFIGURED) or tool argument errors.
   */
  InfrastructureError = 'INFRASTRUCTURE_ERROR',
  /**
   * The user received a satisfactory result: COMPLETE_TASK was called (or the
   * trace output answers the prompt) with no significant quality concerns in
   * retrieval, cost, or latency. Trace.status may be OK or ERROR if a non-fatal
   * span errored but the task still completed.
   */
  Success = 'SUCCESS',
  /**
   * The trace or a dominant activity exceeded its timeout (Temporal
   * start-to-close, sandbox ~60s, Reducto poll timeout, etc.) before completing.
   */
  Timeout = 'TIMEOUT',
  /**
   * The user did not get an acceptable result primarily because of user-side
   * input or behavior: ambiguous or contradictory instructions, missing required
   * attachments or data, misuse of the product, or agency misconfiguration the
   * user could have resolved. Cara may have behaved reasonably given what it had.
   * Pair with category USER_ERROR. Prefer over FAILURE when engineering changes
   * would not have fixed the run without different user input.
   */
  UserError = 'USER_ERROR'
}

/**
 * An actionable recommendation from the analysis. Each item should be something
 * a developer or operator can do — not a restatement of what went wrong.
 */
export type TraceAnalysisRecommendation = {
  __typename?: 'TraceAnalysisRecommendation';
  /**
   * Imperative next step. Example: "Review prompt version copilot_contextual v2.3
   * — generation truncated on turn 4." Be specific; avoid vague "investigate
   * further" without a target.
   */
  action: Scalars['String']['output'];
  /**
   * How urgently to act on this recommendation relative to others in the same
   * analysis.
   */
  priority: TraceAnalysisRecommendationPriority;
  /**
   * Brief justification tied to trace evidence. Explain why this action addresses
   * the root cause.
   */
  rationale: Scalars['String']['output'];
  /**
   * The single span most relevant to this recommendation, if any. Use the span
   * a reviewer should open first in the trace viewer.
   */
  spanId?: Maybe<Scalars['String']['output']>;
};

/**
 * Priority of a trace analysis recommendation. Guides ordering in review UIs;
 * independent of severity (a LOW-severity trace can still have a HIGH-priority
 * fix for a recurring misconfiguration).
 */
export enum TraceAnalysisRecommendationPriority {
  /** Immediate action required (e.g. stop a runaway loop, fix a broken integration). */
  Critical = 'CRITICAL',
  /** Likely fix for the reported issue; do this before closing the investigation. */
  High = 'HIGH',
  /** Nice-to-have improvement or preventive suggestion. */
  Low = 'LOW',
  /** Should be addressed when investigating this class of trace. */
  Medium = 'MEDIUM'
}

/**
 * Structured output from a completed trace analysis. Populated by the analysis
 * agent when TraceAnalysis.state is COMPLETED. All fields are required except
 * rootCauseSpanId (set when a single span is clearly responsible; omit when the
 * cause is distributed or inconclusive).
 */
export type TraceAnalysisResult = {
  __typename?: 'TraceAnalysisResult';
  /**
   * Union of categories across issues, for filtering and dashboards. Populated
   * from issues at write time.
   */
  categories?: Maybe<Array<TraceAnalysisIssueCategory>>;
  /**
   * Distinct issues identified during analysis. Every HIGH/CRITICAL severity
   * analysis should include at least one issue. Prefer fewer, stronger issues
   * over exhaustive span listing.
   */
  issues?: Maybe<Array<TraceAnalysisIssue>>;
  /**
   * User-visible result of the run. Judge from trace input/output, whether
   * COMPLETE_TASK was reached, and whether the final response satisfies the
   * prompt — not from Trace.status alone.
   */
  outcome: TraceAnalysisOutcome;
  /**
   * Ordered actionable next steps for an engineer reviewing this trace. Include
   * at least one when outcome is not SUCCESS; may be empty for clean SUCCESS
   * runs. Do not duplicate issue summaries verbatim.
   */
  recommendations?: Maybe<Array<TraceAnalysisRecommendation>>;
  /**
   * OTel span ID of the root-cause span — typically the first ERROR span on the
   * critical path, or the RERANK/GENERATION/TOOL span that best explains the
   * failure. Null when cause is workflow-level (e.g. distributed stuck loop)
   * or indeterminate.
   */
  rootCauseSpanId?: Maybe<Scalars['String']['output']>;
  /**
   * One sentence naming what failed, where, and why. Include tool name,
   * integration, model, or loop type here (not as enum values). Example: "Turn 6
   * SEARCH_KNOWLEDGE_BASE rerank topScore 0.19; agent synthesized from weak
   * matches."
   */
  rootCauseSummary: Scalars['String']['output'];
  /**
   * Urgency for human triage. CRITICAL for runaway loops, hard failures, or
   * clearly wrong customer-facing output; LOW for successful runs with minor
   * anomalies. Should correlate with but not duplicate outcome (a DEGRADED run
   * can be LOW if the issue is minor).
   */
  severity: TraceAnalysisSeverity;
  /**
   * One or two sentences for a trace list or alert. State what the user asked
   * for, what happened, and the bottom line. Do not include span IDs (those
   * belong in issues).
   */
  summary: Scalars['String']['output'];
};

/**
 * Triage priority for a completed trace analysis. Reflects urgency for human
 * review, not the technical severity of the underlying span error.
 */
export enum TraceAnalysisSeverity {
  /** Clear failure, data loss risk, or runaway cost/loop; needs prompt attention. */
  Critical = 'CRITICAL',
  /** Likely customer-impacting or materially wrong output; should be reviewed. */
  High = 'HIGH',
  /**
   * Informational: successful run worth noting (e.g. slightly elevated cost) but
   * no action required.
   */
  Low = 'LOW',
  /**
   * Worth reviewing when debugging similar workspaces, but not blocking or
   * customer-impacting on its own.
   */
  Medium = 'MEDIUM'
}

/** Sort fields for searchTraceAnalysis. */
export enum TraceAnalysisSortField {
  CreatedAt = 'CREATED_AT',
  EndedAt = 'ENDED_AT',
  Outcome = 'OUTCOME',
  Severity = 'SEVERITY',
  StartedAt = 'STARTED_AT',
  TraceDuration = 'TRACE_DURATION',
  TraceStartedAt = 'TRACE_STARTED_AT',
  TraceTotalCost = 'TRACE_TOTAL_COST'
}

export type TraceAnalysisSortInput = {
  direction: SortDirection;
  field: TraceAnalysisSortField;
};

/** State of a trace analysis job. */
export enum TraceAnalysisState {
  /** Analysis was cancelled before completion. */
  Cancelled = 'CANCELLED',
  /** Analysis finished successfully. analysis and result are populated. */
  Completed = 'COMPLETED',
  /**
   * Analysis failed before producing results. error is populated; analysis and
   * result are null.
   */
  Failed = 'FAILED',
  /** Analysis is queued and has not started. */
  Queued = 'QUEUED',
  /** Analysis is in progress. */
  Running = 'RUNNING'
}

export type TraceConnection = {
  __typename?: 'TraceConnection';
  edges: Array<TraceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TraceEdge = {
  __typename?: 'TraceEdge';
  cursor: Scalars['String']['output'];
  node: Trace;
};

/** Filter input for traceLogs. */
export type TraceLogsFilterInput = {
  /** Minimum log severity (inclusive). */
  minSeverity?: InputMaybe<LogSeverity>;
  /** Case-insensitive search against log message and attributes. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to logs under this span. */
  spanId?: InputMaybe<Scalars['ID']['input']>;
  /** Only logs emitted strictly after this timestamp. */
  timestampAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only logs emitted strictly before this timestamp. */
  timestampBefore?: InputMaybe<Scalars['Time']['input']>;
};

/** Sort fields for searchTraces. */
export enum TraceSortField {
  Duration = 'DURATION',
  InputTokens = 'INPUT_TOKENS',
  OutputTokens = 'OUTPUT_TOKENS',
  StartedAt = 'STARTED_AT',
  TotalCost = 'TOTAL_COST'
}

export type TraceSortInput = {
  direction: SortDirection;
  field: TraceSortField;
};

/**
 * The resolved object behind a rerank candidate or embedding input. Exactly one field is
 * populated, selected by the parent's sourceType + id; the rest are null. Resolved on
 * demand so trace reads don't eagerly load every referenced object.
 */
export type TraceSource = {
  __typename?: 'TraceSource';
  file?: Maybe<File>;
  knowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  memory?: Maybe<Memory>;
};

/**
 * The kind of object a rerank candidate or embedding input refers to. Drives which field
 * of TraceSource is populated. KG property-field reranks have no resolvable object and
 * carry a null sourceType.
 */
export enum TraceSourceType {
  File = 'FILE',
  KnowledgeBaseDocument = 'KNOWLEDGE_BASE_DOCUMENT',
  Memory = 'MEMORY'
}

/**
 * Execution status of a trace, derived at read time from the trace's endedAt,
 * cancelledAt, and span errors.
 */
export enum TraceStatus {
  /** Cancelled before completion. */
  Cancelled = 'CANCELLED',
  /** Completed with an error. */
  Error = 'ERROR',
  /**
   * Trace is still running (endedAt is null and not cancelled). Spans are exported
   * end-only, so in-progress is determined by the trace's own endedAt, not spans.
   */
  InProgress = 'IN_PROGRESS',
  /** Completed successfully. */
  Ok = 'OK'
}

/**
 * Tool-specific details attached to a TOOL span.
 * Named TraceToolCall to avoid collision with email.graphqls ToolCall.
 */
export type TraceToolCall = {
  __typename?: 'TraceToolCall';
  /** gen_ai.tool.call.arguments (serialized text). */
  arguments: Scalars['String']['output'];
  /** gen_ai.tool.call.id */
  callId?: Maybe<Scalars['String']['output']>;
  /** Error message if the tool call failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the tool call failed. */
  failed: Scalars['Boolean']['output'];
  /** gen_ai.tool.name */
  name: Scalars['String']['output'];
  /** gen_ai.tool.call.result (serialized text). May be truncated for storage. */
  result?: Maybe<Scalars['String']['output']>;
};

/** Typography settings */
export type TypographyStyle = {
  __typename?: 'TypographyStyle';
  /** Text color in hex format (e.g. '#334155') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Base font family name (e.g. 'Charter ITC TT', 'Inter', 'Source Serif Pro') */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Base font size in points (e.g. 11.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Font weight as a number (e.g. 400 for normal, 600 for semi-bold, 700 for bold) */
  fontWeight?: Maybe<Scalars['Int']['output']>;
  /** Line height as a unitless multiplier (e.g. 1.6) */
  lineHeight?: Maybe<Scalars['Float']['output']>;
};

/** Input for typography settings */
export type TypographyStyleInput = {
  /** Base text color, as a CSS hex string (e.g. '#222222') */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font family for base document text (e.g. 'Arial', 'Helvetica Neue', etc.) */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Font size in points for base text */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Font weight for base text (e.g. 400 for normal, 700 for bold) */
  fontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Line height for base text (unitless multiplier, e.g. 1.4) */
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
};

/** What initiated the sync operation */
export enum UrlDocumentSyncInitiator {
  /** Sync was triggered on document creation */
  Initial = 'INITIAL',
  /** Sync was triggered manually by a user */
  Manual = 'MANUAL',
  /** Sync was triggered by the scheduled cron job */
  Scheduled = 'SCHEDULED'
}

/** A record of a sync operation for a URL-sourced document */
export type UrlDocumentSyncLog = {
  __typename?: 'URLDocumentSyncLog';
  /** Timestamp of when the sync operation completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** Whether the content changed from the previous version */
  contentChanged?: Maybe<Scalars['Boolean']['output']>;
  /** The content hash of the fetched content (for detecting changes) */
  contentHash?: Maybe<Scalars['String']['output']>;
  /** Size of the fetched content in bytes */
  contentSize?: Maybe<Scalars['Int']['output']>;
  /** Error message if the sync failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the sync log */
  id: Scalars['ID']['output'];
  /** What initiated this sync operation */
  initiator: UrlDocumentSyncInitiator;
  /** The ID of the new document version created (if content changed) */
  newVersionID?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the sync operation started */
  startedAt: Scalars['Time']['output'];
  /** Current state of the sync operation */
  state: UrlDocumentSyncState;
};

/** The state of a URL document sync operation */
export enum UrlDocumentSyncState {
  /** Sync operation completed successfully */
  Completed = 'COMPLETED',
  /** Sync operation failed */
  Failed = 'FAILED',
  /** Sync operation is in progress */
  InProgress = 'IN_PROGRESS'
}

/** How often the URL should be synced */
export enum UrlMonitorFrequency {
  /** Sync once per day */
  Daily = 'DAILY',
  /** Sync once per month */
  Monthly = 'MONTHLY',
  /** Sync once per week */
  Weekly = 'WEEKLY'
}

/** The type of URL source - determines how content is fetched */
export enum UrlSourceType {
  /** Direct file download (PDF) */
  Download = 'DOWNLOAD',
  /** Webpage screenshot capture */
  Webpage = 'WEBPAGE'
}

/** UpdateAMS360IntegrationInput contains the input for updating an AMS360 integration */
export type UpdateAms360IntegrationInput = {
  /** AMS360 Agency Number */
  agencyNo?: InputMaybe<Scalars['String']['input']>;
  /** AMS360 App Access to Agency Key for authentication */
  appAccessToAgencyKey?: InputMaybe<Scalars['String']['input']>;
  /** AMS360 App Key for authentication */
  appKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * When a synced task has no due date, the suspense due date is this many business days
   * after the sync time (weekends skipped). Defaults to 3 when unset.
   */
  defaultTaskDueBusinessDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If enabled, will sync accounts from Cara to AMS360. When disabled, Cara will not create
   * tasks or notes for clients that don't already exist in AMS360.
   */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync calls from Cara to AMS360 as activities. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to AMS360 as suspenses. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Determines who suspenses (tasks) created from calls are assigned to. Defaults to
   * ACCOUNT_EXECUTIVE (the historical behavior) when unset.
   */
  taskAssignmentMethod?: InputMaybe<Ams360TaskAssignmentMethod>;
};

/** Input for updating an existing account record */
export type UpdateAccountInput = {
  /** Business account details to update, if the account is a business */
  business?: InputMaybe<CreateBusinessAccountInput>;
  /** Individual account details to update, if the account is an individual */
  individual?: InputMaybe<CreateIndividualAccountInput>;
};

/** Input for updating an existing agency */
export type UpdateAgencyInput = {
  /**
   * Set the agency's ACORD COI/EOI configuration overrides (DOO mode, PDF append
   * rules, ID-card logo, number formatting, and the section-scoped rules list).
   * Omit to leave the configuration unchanged. When present, the override is
   * replaced wholesale: any field left null reverts that setting to the Cara
   * default (see ACORDFormConfigurationInput).
   */
  acordFormConfiguration?: InputMaybe<AcordFormConfigurationInput>;
  /** Display name of the agency */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Extra entitlements to set for the agency */
  extraEntitlements?: InputMaybe<Array<SubscriptionEntitlement>>;
  /**
   * Agency-wide Florida producer license number.
   * Used only as a backup when the selected default Producer Information has none.
   * Printed onto ACORD forms when the risk is in Florida (or the form is Florida-specific).
   */
  floridaLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Mailing address of the agency */
  mailingAddress?: InputMaybe<AddressInput>;
  /** Legal name of the agency */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Agency-wide National Producer Number (NPN).
   * Used only as a backup when the selected default Producer Information has none.
   */
  nationalProducerNumber?: InputMaybe<Scalars['String']['input']>;
  /** The onboarding date for the agency */
  onboardingDate?: InputMaybe<Scalars['Time']['input']>;
  /** Phone number of the agency */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Agency-wide visibility policy. Currently only `disallowPrivate` is supported,
   * which (when true) prevents members from creating or updating objects with
   * PRIVATE visibility — they must choose at least SHARED. Existing PRIVATE rows
   * are not retroactively coerced; the gate only applies on the next mutation
   * per object.
   */
  visibility?: InputMaybe<AgencyVisibilityPolicyInput>;
};

/** Input for updating an agency user */
export type UpdateAgencyUserInput = {
  /** The attributes of the agency user */
  attributes?: InputMaybe<AgencyUserAttributesInput>;
  /** The email address of the agency user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The name of the agency user */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The access profile to assign the user to. Null removes the direct assignment,
   * which drops the user back to whatever their teams or the agency default
   * provide; omitting the field leaves the assignment untouched. Rejected for a
   * user whose roles include ADMIN, since no profile governs an admin.
   */
  profileId?: InputMaybe<Scalars['String']['input']>;
  /** The roles of the agency user */
  roles?: InputMaybe<Array<Role>>;
};

/** UpdateAgencyZoomIntegrationInput contains the input for updating an Agency Zoom integration */
export type UpdateAgencyZoomIntegrationInput = {
  /** If enabled, will sync accounts from Cara to Agency Zoom. */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to Agency Zoom. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update whether the Agency Zoom integration uses Vertafore SSO login. */
  isSSOLogin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the Agency Zoom integration to use a new password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Update the Agency Zoom integration to use a new username. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAppliedEpicIntegrationInput contains the input for updating an Applied Epic integration.
 * Provide the credential set matching the integration type to rotate stored credentials.
 */
export type UpdateAppliedEpicIntegrationInput = {
  /** Updated API credentials for the Applied Epic integration. All fields must be provided together. */
  apiCredentials?: InputMaybe<AppliedEpicApiCredentialsInput>;
  /** Updated SDK credentials for the Applied Epic integration. All fields must be provided together. */
  sdkCredentials?: InputMaybe<AppliedEpicSdkCredentialsInput>;
  /**
   * Type of Applied Epic integration. If omitted the existing type is kept.
   * Provide the credential set matching the type when switching.
   */
  type?: InputMaybe<AppliedEpicIntegrationType>;
};

/** Input for updating an existing business policy */
export type UpdateBusinessPolicyInput = {
  /** Additional fees collected by the agency as revenue. */
  agencyFees?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the agency user who sourced the policy */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** Fees collected by the wholesale broker */
  brokerFees?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the broker */
  brokerId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the insurance carrier */
  carrierId?: InputMaybe<Scalars['String']['input']>;
  /** Estimated commission percentage */
  estimatedCommission?: InputMaybe<Scalars['Float']['input']>;
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy goes into effect */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Insurance market the policy is written in */
  market?: InputMaybe<InsuranceMarket>;
  /** Minimum earned premium for the policy */
  minimumEarnedPremium?: InputMaybe<Scalars['Float']['input']>;
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees?: InputMaybe<Scalars['Float']['input']>;
  /** Fees collected by the carrier to administer the policy or program */
  policyFees?: InputMaybe<Scalars['Float']['input']>;
  /** Policy number once issued */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium?: InputMaybe<Scalars['Float']['input']>;
  /** Quote number from carrier */
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  /** Current state of the policy */
  state?: InputMaybe<PolicyState>;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes?: InputMaybe<Scalars['Float']['input']>;
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total?: InputMaybe<Scalars['Float']['input']>;
  /** Type of insurance policy */
  type?: InputMaybe<InsuranceType>;
  /** Reason for updating the policy */
  updateReason: Scalars['String']['input'];
};

/** Input for updating calls */
export type UpdateCallInput = {
  /** Whether to archive the call */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the call as seen/reviewed (sets seenAt timestamp and seenByUserId) */
  markSeen?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Input for updating a Cara workspace artifact
 * # TODO: Some way to enforce having one or the other type of input, but not both?
 */
export type UpdateCaraWorkspaceArtifactInput = {
  /** The application file details to update */
  applicationFile?: InputMaybe<CaraWorkspaceArtifactApplicationFileInput>;
  /** The document details to update */
  document?: InputMaybe<CaraWorkspaceArtifactDocumentInput>;
  /** The email details to update */
  email?: InputMaybe<CaraWorkspaceArtifactEmailInput>;
  /**
   * When set, replaces the artifact's visibility configuration. Subject to the
   * same plan-entitlement and admin-disallow-private gates as workspace
   * visibility. Omitting leaves the existing artifact visibility unchanged.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/**
 * Input for updating several Cara workspace artifacts at once, such as archiving
 * a selection from the documents view.
 */
export type UpdateCaraWorkspaceArtifactsInput = {
  /**
   * True archives the artifacts, false restores them. See
   * `CaraWorkspaceArtifactSummary.archivedAt` for what archiving does and does
   * not change.
   */
  archived: Scalars['Boolean']['input'];
};

/** Input for updating a Cara workspace */
export type UpdateCaraWorkspaceInput = {
  /** Whether to archive the Cara workspace */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The title of the Cara workspace */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Updated visibility. Omit to leave the existing visibility unchanged. */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/**
 * Every field is optional and an omitted one is left alone, so a partial save
 * cannot clobber what the backfill enriched. Clearing a field is not expressible,
 * matching the other patch-style updates in this schema.
 */
export type UpdateClientInput = {
  address?: InputMaybe<AddressInput>;
  agencyUserOwnerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isCommercial?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomFormInput = {
  /** Archive the form. Archive-only updates are allowed even while processing. */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A replacement PDF file. If provided, the form will be reprocessed. */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** Updated fill-time instructions for Cara, if changing. */
  fillPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Updated ingestion guidance. If changed, may trigger reprocessing. */
  ingestionGuidance?: InputMaybe<Scalars['String']['input']>;
  /** New title for the form, if changing. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Updated visibility. Omit to leave the existing visibility unchanged. */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Input for updating custom presets (e.g. archiving) */
export type UpdateCustomPresetsInput = {
  /** Whether to archive the custom presets */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the custom presets. Existing
   * workspaces created from them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Represents a tool for revising an email draft already saved in the workspace. */
export type UpdateEmailDraftTool = {
  __typename?: 'UpdateEmailDraftTool';
  /** The input arguments for the revision */
  input: UpdateEmailDraftToolInput;
  /** The result of the revision */
  output: DraftEmailToolOutput;
};

/**
 * Input arguments for the UpdateEmailDraftTool.
 *
 * Every editable field is optional because the call is a patch: an absent field
 * keeps its current value and an empty list clears one.
 */
export type UpdateEmailDraftToolInput = {
  __typename?: 'UpdateEmailDraftToolInput';
  /** The email artifact being revised */
  artifactId: Scalars['String']['output'];
  /** Replacement list of attached workspace artifact IDs */
  attachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Replacement BCC list */
  bcc?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  /** Replacement body, as HTML */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** Replacement CC list */
  cc?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  /** Replacement subject line */
  subject?: Maybe<Scalars['String']['output']>;
  /** Replacement list of primary recipients */
  to?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
};

/** Input for bulk-updating Excel spreadsheet templates */
export type UpdateExcelSpreadsheetTemplatesInput = {
  /** Whether to archive the Excel spreadsheet templates */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the Excel spreadsheet templates.
   * Existing workbooks generated from them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** UpdateEzLynxIntegrationInput contains the input for updating an EZLynx integration */
export type UpdateEzLynxIntegrationInput = {
  /** EZLynx app secret for authentication. Optional. */
  appSecret?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx client ID for authentication. Optional - required only for API mode. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx client secret for authentication. Optional - required only for API mode. */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, explicitly marks this as CSV import-only integration.
   * Defaults to false.
   * When credentials are provided, this should be false to allow both CSV import and API usage.
   */
  csvImportOnly: Scalars['Boolean']['input'];
  /** EZLynx integration group ID. Optional - required only for API mode. */
  integrationGroupId?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx password for authentication. Optional. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx username for authentication. Optional - required only for API mode. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateHawksoftIntegrationInput contains the input for updating a Hawksoft integration */
export type UpdateHawksoftIntegrationInput = {
  /** If enabled, will sync call notes to the appropriate contact based on the caller's number. */
  enableSyncCallNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync service requests as tasks to the agent. */
  enableSyncServiceRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating HTML document templates (e.g. archiving) */
export type UpdateHtmlDocumentTemplatesInput = {
  /** Whether to archive the HTML document templates */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the HTML document templates.
   * Existing documents that reference them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** UpdateHubSpotIntegrationInput contains the input for updating a HubSpot integration */
export type UpdateHubSpotIntegrationInput = {
  /** Field mappings for call syncing. Required fields depend on callSyncType. */
  callFieldMappings?: InputMaybe<HubSpotCallFieldMappingsInput>;
  /** The pipeline ID to use when syncing calls as tickets or deals. Required when callSyncType is TICKET or DEAL. */
  callPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing calls as tickets or deals. Required when callSyncType is TICKET or DEAL. */
  callStageId?: InputMaybe<Scalars['String']['input']>;
  /** How calls should be synced to HubSpot. When set to TICKET or DEAL, corresponding field mappings must be provided. */
  callSyncType?: InputMaybe<HubSpotCallSyncType>;
  /** If enabled, will sync accounts from Cara to HubSpot. */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync calls from Cara to HubSpot. When enabled, callSyncType and appropriate field mappings must be provided. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to HubSpot. When enabled, taskSyncType and appropriate field mappings must be provided. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field mappings for task syncing. Required fields depend on taskSyncType. */
  taskFieldMappings?: InputMaybe<HubSpotTaskFieldMappingsInput>;
  /** The pipeline ID to use when syncing tasks as tickets or deals. Required when taskSyncType is TICKET or DEAL. */
  taskPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing tasks as tickets or deals. Required when taskSyncType is TICKET or DEAL. */
  taskStageId?: InputMaybe<Scalars['String']['input']>;
  /** How tasks should be synced to HubSpot. When set to TICKET or DEAL, corresponding field mappings must be provided. */
  taskSyncType?: InputMaybe<HubSpotTaskSyncType>;
};

/** UpdateImageRightIntegrationInput contains the input for updating an ImageRight integration */
export type UpdateImageRightIntegrationInput = {
  /** Update the ImageRight integration to use a new password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Update the ImageRight integration to use a new server URL. */
  serverUrl?: InputMaybe<Scalars['String']['input']>;
  /** Update the ImageRight integration to use a new username. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Describes the type of entity that initiated an update */
export enum UpdateInitiatorType {
  /** Agency client indicates an authenticated agency client */
  AgencyClient = 'AGENCY_CLIENT',
  /** Agency user indicates an authenticated agency user */
  AgencyUser = 'AGENCY_USER',
  /** Anonymous indicates an unauthenticated external user */
  Anonymous = 'ANONYMOUS',
  /** Cronjob indicates a scheduled automated job */
  Cronjob = 'CRONJOB',
  /** Oyster indicates an internal employee at Oyster */
  Oyster = 'OYSTER',
  /** Workflow indicates a Temporal workflow */
  Workflow = 'WORKFLOW'
}

/** UpdateIntegrationInput contains the input for updating an integration */
export type UpdateIntegrationInput = {
  /** Configuration for the Agency Zoom integration */
  agencyZoom?: InputMaybe<UpdateAgencyZoomIntegrationInput>;
  /** Configuration for the AMS360 integration */
  ams360?: InputMaybe<UpdateAms360IntegrationInput>;
  /** Configuration for the Applied Epic integration */
  appliedEpic?: InputMaybe<UpdateAppliedEpicIntegrationInput>;
  /** Configuration for the EZLynx integration */
  ezlynx?: InputMaybe<UpdateEzLynxIntegrationInput>;
  /** Configuration for the Hawksoft integration */
  hawksoft?: InputMaybe<UpdateHawksoftIntegrationInput>;
  /** Configuration for the HubSpot integration */
  hubspot?: InputMaybe<UpdateHubSpotIntegrationInput>;
  /** Configuration for the ImageRight integration */
  imageRight?: InputMaybe<UpdateImageRightIntegrationInput>;
  /** Configuration for the NowCerts integration */
  nowcerts?: InputMaybe<UpdateNowCertsIntegrationInput>;
  /** Current state of the integration */
  state?: InputMaybe<IntegrationState>;
};

/** Input for updating a document in the knowledge base */
export type UpdateKnowledgeBaseDocumentInput = {
  /** The content of the document, if this is a text document */
  content?: InputMaybe<Scalars['String']['input']>;
  /**
   * Instructions for how the information in this document should be used when
   * answering questions (max 500 characters). Shown to the AI alongside the
   * document content.
   */
  contextNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * Preferred user-facing name for FILE documents in the knowledge base UI and
   * when Cara refers to the document. Does not alter indexed content, embeddings,
   * or semantic content retrieval. Only accepted for FILE documents. Max 100
   * characters. Pass an empty string or whitespace to clear.
   */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Example user questions that should cause Cara to include this document as
   * priority content (max 500 characters).
   */
  exampleQuestions?: InputMaybe<Scalars['String']['input']>;
  /** The title of the document */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a knowledge base */
export type UpdateKnowledgeBaseInput = {
  /**
   * Enables owner-configured priority content matching for documents in this
   * knowledge base.
   */
  guidedRetrievalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateKnowledgeBaseTool = {
  __typename?: 'UpdateKnowledgeBaseTool';
  /** The input arguments for the knowledge base update */
  input: UpdateKnowledgeBaseToolInput;
  /** The result of the knowledge base update operation */
  output: UpdateKnowledgeBaseToolOutput;
};

/**
 * Input arguments for the UpdateKnowledgeBaseTool. Adds a file that is attached to
 * the workspace to the knowledge base, either as a new document or as a new version
 * of an existing one. On the first call, provide only fileId (and optionally
 * knowledgeBaseId/title); the tool decides whether it is a new document or an edit.
 * If the tool responds asking for confirmation, call it again with either
 * replaceDocumentId (to replace) or forceNew (to add as new).
 */
export type UpdateKnowledgeBaseToolInput = {
  __typename?: 'UpdateKnowledgeBaseToolInput';
  fileId: Scalars['String']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  forceNew?: Maybe<Scalars['Boolean']['output']>;
  knowledgeBaseId?: Maybe<Scalars['String']['output']>;
  replaceDocumentId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Result of an UpdateKnowledgeBaseTool operation. */
export type UpdateKnowledgeBaseToolOutput = {
  __typename?: 'UpdateKnowledgeBaseToolOutput';
  /** When the file looks like a possible edit, the ID of the best-matching existing document. */
  bestMatchDocumentId?: Maybe<Scalars['String']['output']>;
  /**
   * When the file looks like a possible edit, the user-facing name of the
   * best-matching existing document (display name when set, otherwise indexed
   * metadata title, otherwise persisted title).
   */
  bestMatchTitle?: Maybe<Scalars['String']['output']>;
  /** A human-readable question to ask the user when requiresClarification is true. */
  clarificationMessage?: Maybe<Scalars['String']['output']>;
  /** The ID of the created/updated document. Empty when requiresClarification is true. */
  documentId: Scalars['String']['output'];
  /** Whether indexing of the document was started. */
  indexingStarted: Scalars['Boolean']['output'];
  /** The ID of the knowledge base written to. Empty when requiresClarification is true. */
  knowledgeBaseId: Scalars['String']['output'];
  /**
   * True when the tool needs the user to confirm a decision (new vs. edit, or which
   * knowledge base) before writing. When true, no write occurred; ask the user the
   * question in clarificationMessage and then call the tool again with the answer.
   */
  requiresClarification: Scalars['Boolean']['output'];
  /** The similarity (0-100) between the incoming file and the best-matching existing document. */
  similarityPercent?: Maybe<Scalars['Int']['output']>;
  /**
   * The user-facing name of the resulting document: display name when set,
   * otherwise the indexed metadata title, otherwise the persisted title
   * (typically the upload filename for FILE documents).
   */
  title: Scalars['String']['output'];
  /** The version number of the resulting document (1 for a new document). */
  versionNumber: Scalars['Int']['output'];
};

/** Input for updating a URL-sourced document's settings */
export type UpdateKnowledgeBaseUrlDocumentInput = {
  /** Update the sync frequency */
  frequency?: InputMaybe<UrlMonitorFrequency>;
  /** Pause or resume automatic syncing */
  isPaused?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMemoryInput = {
  category?: InputMaybe<MemoryCategory>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  surface?: InputMaybe<MemorySurface>;
  type?: InputMaybe<MemoryType>;
};

/** UpdateNowCertsIntegrationInput contains the input for updating a NowCerts integration */
export type UpdateNowCertsIntegrationInput = {
  /** If enabled, will sync accounts from Cara to NowCerts. */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the NowCerts integration to use a new password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * The referral source value to set when creating a prospect in NowCerts.
   * Pass an empty string to clear an existing value. If omitted (null), the current value is unchanged.
   */
  prospectReferralSource?: InputMaybe<Scalars['String']['input']>;
  /** Update the NowCerts integration to use a new username. */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutboundCallInput = {
  callConfig?: InputMaybe<OutboundCallConfigInput>;
  customer?: InputMaybe<OutboundCallCustomerInput>;
  retryPolicy?: InputMaybe<OutboundCallRetryPolicyInput>;
  schedule?: InputMaybe<OutboundCallScheduleInput>;
  visibility?: InputMaybe<VisibilityConfigInput>;
  voiceAgentId?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a service request */
export type UpdateServiceRequestInput = {
  /** Details specific to additional insured requests */
  addAdditionalInsured?: InputMaybe<AddAdditionalInsuredRequestInput>;
  /** The ID of the agency user that is assigned to this service request */
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  /** Details specific to policy cancellation requests */
  cancelPolicy?: InputMaybe<CancelPolicyRequestInput>;
  /** The email of the client that this service request is associated with */
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the client that this service request is associated with */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the client that this service request is associated with */
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  /** Details specific to Certificate of Insurance requests */
  createCertificate?: InputMaybe<CreateCertificateRequestInput>;
  /** Additional details about the request */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Details specific to document requests */
  documentRequest?: InputMaybe<DocumentRequestInput>;
  /** The date and time that this service request is due */
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  /** Details specific to question requests */
  question?: InputMaybe<QuestionRequestInput>;
};

export type UpdateSmartFillBucketInput = {
  /**
   * A complete replacement document. Existing node IDs must be preserved for
   * nodes that keep their place; new nodes omit IDs and are minted server side.
   */
  document?: InputMaybe<Scalars['JSON']['input']>;
  expectedRevision: Scalars['Int64']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<SmartFillBucketVisibility>;
};

/** Input for previewing an update to the subscription */
export type UpdateSubscriptionInput = {
  /** The agency ID to update the subscription for */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** The period to update the subscription to */
  period?: InputMaybe<SubscriptionPeriod>;
  /** The plan to update the subscription to */
  plan?: InputMaybe<SubscriptionPlan>;
  /** The number of seats to update the subscription to */
  seats?: InputMaybe<Scalars['Int']['input']>;
  /** The number of voice agents to update the subscription to */
  voiceAgents?: InputMaybe<Scalars['Int']['input']>;
};

/** Preview of the invoice that would be generated for the subscription update */
export type UpdateSubscriptionInvoicePreview = {
  __typename?: 'UpdateSubscriptionInvoicePreview';
  /** The amount due for the invoice */
  amountDue: Scalars['Float']['output'];
  /** The amount paid for the invoice */
  amountPaid: Scalars['Float']['output'];
  /** The discount total of the invoice */
  discountTotal: Scalars['Float']['output'];
  /** Whether the invoice is a recurring invoice (false) or whether this is the next invoice (true) */
  isNextInvoice: Scalars['Boolean']['output'];
  /** The line items that would be included in the invoice */
  lineItems: Array<UpdateSubscriptionInvoicePreviewLineItem>;
  /** The subtotal of the invoice */
  subTotal: Scalars['Float']['output'];
  /** The tax total of the invoice */
  taxTotal: Scalars['Float']['output'];
  /** The total of the invoice */
  total: Scalars['Float']['output'];
};

/** Line item for the invoice */
export type UpdateSubscriptionInvoicePreviewLineItem = {
  __typename?: 'UpdateSubscriptionInvoicePreviewLineItem';
  /** The name of the line item */
  name: Scalars['String']['output'];
  /** The quantity of the line item */
  quantity: Scalars['Int']['output'];
  /** The total amount of the line item */
  totalAmount: Scalars['Float']['output'];
  /** The unit amount of the line item */
  unitAmount: Scalars['Float']['output'];
};

/** Input for bulk-updating Word document templates */
export type UpdateWordDocumentTemplatesInput = {
  /** Whether to archive the Word document templates */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the Word document templates.
   * Existing documents generated from them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Input for updating an existing workflow definition */
export type UpdateWorkflowDefinitionInput = {
  /** Updated description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the definition to update */
  id: Scalars['ID']['input'];
  /** Updated input slots (replaces all slots) */
  inputs?: InputMaybe<Array<WorkflowDefinitionInputSlotInput>>;
  /** Updated label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Updated tasks and bindings (replaces all nodes) */
  nodes?: InputMaybe<Array<WorkflowDefinitionNodeInput>>;
  /** The current version (for optimistic concurrency) */
  version: Scalars['Int64']['input'];
};

export type UploadCustomFormInput = {
  file: Scalars['Upload']['input'];
  ingestionGuidance?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /** Optional visibility configuration. Defaults to PUBLIC when omitted. */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** UploadFileInput represents a file upload request */
export type UploadFileInput = {
  /** The file to upload */
  file: Scalars['Upload']['input'];
  /** The notes associated with the file */
  notes: Scalars['String']['input'];
  /** The type of the file */
  type: FileType;
  /** Whether the file is visible to the user */
  visible: Scalars['Boolean']['input'];
};

/** Input for uploading a new file document in the knowledge base */
export type UploadKnowledgeBaseFileDocumentInput = {
  /** The files to upload */
  files: Array<Scalars['Upload']['input']>;
  /** The cosmetic folder to upload the documents into. Null means root. */
  folderId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertSmartFillOverrideInput = {
  action: SmartFillOverrideAction;
  /**
   * For HINT, the bucket property the user picked; the server derives the
   * generalizable intent from it and keeps it only as provenance.
   */
  bucketId?: InputMaybe<Scalars['ID']['input']>;
  fieldKey: Scalars['String']['input'];
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
  propertyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Per-agency override of included usage amounts for platform (contract) plans. */
export type UsageAllotmentOverrides = {
  __typename?: 'UsageAllotmentOverrides';
  kbPages?: Maybe<Scalars['Int']['output']>;
  platformUnits?: Maybe<Scalars['Int']['output']>;
  voiceMinutes?: Maybe<Scalars['Int']['output']>;
};

/**
 * Usage metering cadence for included allotments. May differ from how often the
 * base subscription is invoiced when usageCycle is set explicitly as an override.
 */
export enum UsageCycle {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

/** Included allowance for a single meter in the current billing period. */
export type UsageMeterAllowance = {
  __typename?: 'UsageMeterAllowance';
  included: Scalars['Int']['output'];
  meterCode: ConsumptionMeterCode;
  /** Overage unit price in USD. Zero when overage billing is not configured. */
  overageRatePerUnit: Scalars['Float']['output'];
  unitLabel: Scalars['String']['output'];
};

/** Consumed amount for a single meter in the current billing period. */
export type UsageMeterAmount = {
  __typename?: 'UsageMeterAmount';
  /**
   * Per-day BILLABLE totals for the current period, zero-filled for missing days.
   * Length matches the number of local calendar days spanned by the billing
   * period in AgencyUsageReport.timezone.
   */
  daily: Array<UsageMeterDailyAmount>;
  meterCode: ConsumptionMeterCode;
  used: Scalars['Decimal']['output'];
};

/**
 * Billable quantity for one calendar day within the current usage period,
 * in AgencyUsageReport.timezone.
 */
export type UsageMeterDailyAmount = {
  __typename?: 'UsageMeterDailyAmount';
  /**
   * Calendar day this bucket covers, encoded as UTC midnight of that local
   * Y-M-D in AgencyUsageReport.timezone (date components only; not a UTC instant).
   */
  date: Scalars['Time']['output'];
  /** BILLABLE quantity_billable summed for this day. */
  used: Scalars['Decimal']['output'];
};

/** Settled overage invoice for one closed usage period. */
export type UsageOverageInvoice = {
  __typename?: 'UsageOverageInvoice';
  createdAt: Scalars['Time']['output'];
  deliveryMethod: OverageDeliveryMethod;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItems: Array<OverageBillLineItem>;
  paidAt?: Maybe<Scalars['Time']['output']>;
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  status: UsageOverageInvoiceStatus;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  subtotalDollars: Scalars['Float']['output'];
  totalDollars: Scalars['Float']['output'];
};

export type UsageOverageInvoiceConnection = {
  __typename?: 'UsageOverageInvoiceConnection';
  edges: Array<UsageOverageInvoiceEdge>;
  pageInfo: PageInfo;
};

export type UsageOverageInvoiceEdge = {
  __typename?: 'UsageOverageInvoiceEdge';
  cursor: Scalars['String']['output'];
  node: UsageOverageInvoice;
};

/** Settlement status for a closed usage period's overage invoice. */
export enum UsageOverageInvoiceStatus {
  Failed = 'FAILED',
  Paid = 'PAID',
  /** Stripe delivery complete; charge not yet collected. Shown as "Scheduled". */
  Pending = 'PENDING',
  /**
   * Period claimed; Stripe delivery in progress. Internal only — not shown in
   * customer billing history until promoted to PENDING.
   */
  Processing = 'PROCESSING',
  /** Period processed with $0 overage. */
  Skipped = 'SKIPPED'
}

/**
 * Visibility levels that govern who can see and interact with a visibility-bearing
 * object (workspace, custom preset, document template, custom form, etc.).
 *
 * Default for all objects is PUBLIC, preserving the historical behaviour where
 * every member of an agency could see every object.
 *
 * * PRIVATE — only the creator may read or modify the object. Agency admins
 *             retain read access for compliance.
 * * SHARED  — the creator plus the explicit user/team access list may read or
 *             modify. Useful for limiting visibility to a project group without
 *             making the object visible to the entire agency.
 * * PUBLIC  — the entire agency may read and use the object.
 */
export enum Visibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Shared = 'SHARED'
}

/**
 * The materialized visibility configuration on an object. The `userIds` and
 * `teamIds` lists are only meaningful when `level == SHARED`; for PRIVATE/PUBLIC
 * they are empty. The `users` and `teams` fields resolve those references for the
 * current viewer; entries the viewer cannot otherwise see are still surfaced by
 * ID so the access-list editor can show them. Resolution lives at the resolver
 * layer in a follow-up phase.
 */
export type VisibilityConfig = {
  __typename?: 'VisibilityConfig';
  level: Visibility;
  teamIds: Array<Scalars['String']['output']>;
  userIds: Array<Scalars['String']['output']>;
};

/**
 * Input type used by mutations that accept a visibility configuration.
 * When omitted on create, the object is created PUBLIC. `userIds` and `teamIds`
 * are ignored unless `level == SHARED`.
 */
export type VisibilityConfigInput = {
  level: Visibility;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Optional per-list filter that narrows by visibility membership on top of
 * the always-on per-principal visibility filter. All fields are optional and
 * combine via AND.
 */
export type VisibilityListFilterInput = {
  /**
   * When true, restrict to SHARED rows the caller is a target of but did not
   * create themselves — the "Shared with me" view.
   */
  sharedWithMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to SHARED rows that include this team in their access list. */
  sharedWithTeamId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to a specific visibility level (PRIVATE / SHARED / PUBLIC). */
  visibilityLevel?: InputMaybe<Visibility>;
};

/** Represents a voice agent */
export type VoiceAgent = {
  __typename?: 'VoiceAgent';
  /** The agency associated with this voice agent configuration */
  agency: Agency;
  /** The voice agent configuration */
  configuration: VoiceAgentConfiguration;
  /** Timestamp of when the voice agent was created */
  createdAt: Scalars['Time']['output'];
  /** Whether this agent receives inbound calls or places outbound calls */
  direction: VoiceAgentDirection;
  /** The ID of the voice agent */
  id: Scalars['ID']['output'];
  /** The name of the voice agent */
  name: Scalars['String']['output'];
  /**
   * Locked AI/recording disclosure appended after the outbound intro at dial time.
   * Null for inbound agents. Not editable from Cara settings.
   */
  outboundIntroComplianceDisclosure?: Maybe<Scalars['String']['output']>;
  /** The phone number of the voice agent */
  phoneNumber: Scalars['String']['output'];
  /** The state of the voice agent */
  state: VoiceAgentState;
  /** Timestamp of when the voice agent was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this voice agent. Incremented on each configuration update. */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this voice agent. The first version in this list will be this version
   * (i.e. identical to the current voice agent), followed by the version before that, and so-forth.
   */
  versionHistory?: Maybe<Array<VoiceAgentVersion>>;
};

/**
 * Types of customer information the APQ (Account / Policy / Quote) lookup tool is allowed to
 * surface to Cara during a call. Each value gates a distinct block of the lookup_customer
 * response served by the Retell webhook.
 */
export enum VoiceAgentAccountLookupDataType {
  /** Basic account records (name, ID) discovered for the caller. */
  AccountDetails = 'ACCOUNT_DETAILS',
  /**
   * Client notes (subject and body text) associated with the caller's integration
   * accounts via the same knowledge-graph lookup as policy details. May contain
   * sensitive or confidential information about the caller.
   */
  ClientNotes = 'CLIENT_NOTES',
  /**
   * Business policy details (carrier, premium, dates) from synced AMS integrations.
   * When enabled, Cara also receives related integration account and contact context
   * for the caller (no separate toggle required).
   */
  PolicyDetails = 'POLICY_DETAILS',
  /**
   * Summaries of the caller's most recent phone interactions, including inbound calls
   * and outbound jobs Cara placed to this number (objective, context, and attempt summary).
   */
  PreviousCalls = 'PREVIOUS_CALLS',
  /** Open and recently-closed service requests / tickets on the caller's accounts. */
  ServiceRequests = 'SERVICE_REQUESTS'
}

/** Represents a voice agent configuration */
export type VoiceAgentConfiguration = {
  __typename?: 'VoiceAgentConfiguration';
  /**
   * The APQ (Account / Policy / Quote) lookup tool configuration. Controls whether
   * Cara can call lookup_customer during the call and which categories of customer
   * data it is allowed to receive in the response.
   */
  accountLookup: VoiceAgentConfigurationAccountLookup;
  /** The agency configuration that Cara should use */
  agency: VoiceAgentConfigurationAgency;
  /** The name of the voice agent that Cara should use, if it should override the default voice agent name (which is Cara) */
  agentName?: Maybe<Scalars['String']['output']>;
  /** The behavior of how Cara should handle the caller's request */
  callBehavior: VoiceAgentConfigurationCallBehavior;
  /** The global custom instructions that Cara should use, if any */
  globalCustomInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * The intro phrase that Cara should use, if it should override the default intro phrase.
   * Stored per voice agent — inbound and outbound agents each have their own phrase.
   * Inbound out-of-office (time-off) custom intros are separate and do not apply to outbound.
   */
  introPhrase?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated single-language projection for cached clients. Returns the first
   * entry of languages.
   * @deprecated Use languages instead. Returns the first selected language.
   */
  language: VoiceAgentLanguage;
  /** The languages that Cara should understand and speak */
  languages: Array<VoiceAgentLanguage>;
  /** The model configuration that Cara should use */
  model: VoiceAgentConfigurationModel;
  /** The notifications that Cara should use */
  notifications: VoiceAgentConfigurationNotifications;
  /**
   * Default outbound call behavior for agents that place outbound calls.
   * Null for inbound agents; required for outbound agents (enforced in validation).
   */
  outboundCallBehavior?: Maybe<VoiceAgentConfigurationOutboundCallBehavior>;
  /** The behavior of how Cara should handle the caller's request */
  taskBehavior: VoiceAgentConfigurationTaskBehavior;
  /** The transfer configuration for the voice agent */
  transfer: VoiceAgentConfigurationTransfer;
};

/**
 * Configuration for the APQ (Account / Policy / Quote) lookup tool that Cara uses to
 * read context about the caller during a live call.
 */
export type VoiceAgentConfigurationAccountLookup = {
  __typename?: 'VoiceAgentConfigurationAccountLookup';
  /**
   * Whether Cara is allowed to call the lookup_customer tool at all. When false, the
   * webhook returns a single disabled-message response and no account, policy, service
   * request, call, or knowledge graph data is shared with the model.
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * The categories of information the lookup tool is allowed to return when enabled
   * is true. Categories not listed here are stripped from the response before it
   * reaches Cara.
   */
  includedDataTypes: Array<VoiceAgentAccountLookupDataType>;
};

/** Input type for configuring the APQ (Account / Policy / Quote) lookup tool. */
export type VoiceAgentConfigurationAccountLookupInput = {
  /** Whether Cara is allowed to call the lookup_customer tool at all. */
  enabled: Scalars['Boolean']['input'];
  /** The categories of customer information the lookup tool may return when enabled. */
  includedDataTypes: Array<VoiceAgentAccountLookupDataType>;
};

/** Agency configuration overrides for the voice agent */
export type VoiceAgentConfigurationAgency = {
  __typename?: 'VoiceAgentConfigurationAgency';
  /** The address of the agency that Cara should use, if it is different from the agency address in the agency configuration */
  address?: Maybe<Scalars['String']['output']>;
  /** The business hours of the agency that Cara, if specified. Otherwise, Cara will not present any information about business hours. */
  businessHours?: Maybe<Scalars['String']['output']>;
  /** The email of the agency that Cara should use, if it is different from the agency contact email in the agency configuration */
  email?: Maybe<Scalars['String']['output']>;
  /** The name of the agency that Cara should use, if it is different from the agency name in the agency configuration */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the agency that Cara should use, if it is different from the agency contact phone number in the agency configuration */
  phone?: Maybe<Scalars['String']['output']>;
  /** The website of the agency that Cara should use, if it is different from the agency website in the agency configuration */
  website?: Maybe<Scalars['String']['output']>;
};

/** Input type for agency configuration overrides for the voice agent */
export type VoiceAgentConfigurationAgencyInput = {
  /** The address of the agency that Cara should use, if it is different from the agency address in the agency configuration */
  address?: InputMaybe<Scalars['String']['input']>;
  /** The business hours of the agency that Cara, if specified. Otherwise, Cara will not present any information about business hours. */
  businessHours?: InputMaybe<Scalars['String']['input']>;
  /** The email of the agency that Cara should use, if it is different from the agency contact email in the agency configuration */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The name of the agency that Cara should use, if it is different from the agency name in the agency configuration */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the agency that Cara should use, if it is different from the agency contact phone number in the agency configuration */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The website of the agency that Cara should use, if it is different from the agency website in the agency configuration */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type VoiceAgentConfigurationCallBehavior = {
  __typename?: 'VoiceAgentConfigurationCallBehavior';
  /** If set and startSpeaker is USER, the AI will begin the conversation after waiting for the user for the duration (in milliseconds) specified. If not set, the agent will wait indefinitely for the user to speak. */
  beginAfterUserSilenceMs?: Maybe<Scalars['Int']['output']>;
  /**
   * Additional contact information fields Cara must collect from every caller.
   * One field per line, e.g. policy type, policy number.
   */
  customRequiredContactInfo: Array<Scalars['String']['output']>;
  /** The rapport building strategy that Cara should use */
  rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding;
  /** Whether Cara should reference policy information when handling the caller's request */
  referencePolicyInfo: Scalars['Boolean']['output'];
  /** Whether Cara should repeat critical information to the caller */
  repeatCriticalInfo: Scalars['Boolean']['output'];
  /** The required contact information that Cara should collect from the caller */
  requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>;
  /** Who starts the conversation - the AI agent or the user */
  startSpeaker: VoiceAgentStartSpeaker;
};

/** Input type for configuring call behavior settings for the voice agent */
export type VoiceAgentConfigurationCallBehaviorInput = {
  /** If set and startSpeaker is USER, the AI will begin the conversation after waiting for the user for the duration (in milliseconds) specified. If not set, the agent will wait indefinitely for the user to speak. */
  beginAfterUserSilenceMs?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Additional contact information fields Cara must collect from every caller.
   * One field per line, e.g. policy type, policy number.
   */
  customRequiredContactInfo: Array<Scalars['String']['input']>;
  /** The rapport building strategy that Cara should use */
  rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding;
  /** Whether Cara should reference policy information when handling the caller's request */
  referencePolicyInfo: Scalars['Boolean']['input'];
  /** The critical information that Cara should repeat to the caller */
  repeatCriticalInfo: Scalars['Boolean']['input'];
  /** The required contact information that Cara should collect from the caller */
  requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>;
  /** Who starts the conversation - the AI agent or the user */
  startSpeaker: VoiceAgentStartSpeaker;
};

/** The rapport building strategy that Cara should use with callers */
export enum VoiceAgentConfigurationCallBehaviorRapportBuilding {
  /** Cara should converse with the caller */
  BuildRapport = 'BUILD_RAPPORT',
  /** Cara maintains professional warmth with natural, varied responses */
  Cordial = 'CORDIAL',
  /** Cara should not try to build rapport, but will engage in conversation if needed */
  Neutral = 'NEUTRAL',
  /** Cara will more strictly adhere to the task at hand */
  TaskFocused = 'TASK_FOCUSED'
}

/** Types of critical information that Cara should repeat back to the caller */
export enum VoiceAgentConfigurationCallBehaviorRepeatCriticalInfoType {
  /** The caller's business name */
  BusinessName = 'BUSINESS_NAME',
  /** The caller's date of birth */
  DateOfBirth = 'DATE_OF_BIRTH',
  /** The caller's email */
  Email = 'EMAIL',
  /** The caller's FEIN or social security number */
  FeinOrSocialSecurityNumber = 'FEIN_OR_SOCIAL_SECURITY_NUMBER',
  /** The caller's license number */
  LicenseNumber = 'LICENSE_NUMBER',
  /** The caller's name */
  Name = 'NAME',
  /** The caller's phone number */
  Phone = 'PHONE',
  /** The caller's policy numbers */
  PolicyNumber = 'POLICY_NUMBER'
}

/**
 * Types of required contact information that Cara should collect from the caller
 * Clients must tolerate new enum values because capabilities are added over time.
 */
export enum VoiceAgentConfigurationCallBehaviorRequiredContactInfoType {
  /** The caller's email */
  Email = 'EMAIL',
  /** The insurance line of business used for Voice 3.5 transfer routing */
  LineOfBusiness = 'LINE_OF_BUSINESS',
  /** The caller's phone number */
  Phone = 'PHONE'
}

export type VoiceAgentConfigurationInput = {
  /**
   * The APQ lookup tool configuration. Required so that the mutation explicitly
   * encodes whether the lookup tool is enabled and which data categories Cara may
   * receive.
   */
  accountLookup: VoiceAgentConfigurationAccountLookupInput;
  /** The agency configuration that Cara should use */
  agency: VoiceAgentConfigurationAgencyInput;
  /** The name of the voice agent that Cara should use, if it should override the default voice agent name (which is Cara) */
  agentName?: InputMaybe<Scalars['String']['input']>;
  /** The behavior of how Cara should handle the caller's request */
  callBehavior: VoiceAgentConfigurationCallBehaviorInput;
  /** The global custom instructions that Cara should use, if any */
  globalCustomInstructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * The intro phrase that Cara should use, if it should override the default intro phrase.
   * Stored per voice agent — inbound and outbound agents each have their own phrase.
   * Inbound out-of-office (time-off) custom intros are separate and do not apply to outbound.
   */
  introPhrase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Deprecated single-language input for cached clients. Ignored when languages is
   * provided. MULTI preserves the agent's existing languages list; a concrete
   * scalar replaces it.
   * @deprecated Use languages instead. Accepted during the migration window for cached clients.
   */
  language?: InputMaybe<VoiceAgentLanguage>;
  /**
   * The languages that Cara should understand and speak. Nullable during the
   * compatibility window so cached clients can omit it and send legacy language.
   */
  languages?: InputMaybe<Array<VoiceAgentLanguage>>;
  /** The model configuration that Cara should use */
  model: VoiceAgentConfigurationModelInput;
  /** The notifications that Cara should use */
  notifications: VoiceAgentConfigurationNotificationsInput;
  /**
   * Default outbound call behavior for agents that place outbound calls.
   * Omit or null for inbound agents; required for outbound agents (enforced in validation).
   */
  outboundCallBehavior?: InputMaybe<VoiceAgentConfigurationOutboundCallBehaviorInput>;
  /** The behavior of how Cara should handle the caller's request */
  taskBehavior: VoiceAgentConfigurationTaskBehaviorInput;
  /** The transfer configuration for the voice agent */
  transfer: VoiceAgentConfigurationTransferInput;
};

/** The voice model configuration that Cara should use */
export type VoiceAgentConfigurationModel = {
  __typename?: 'VoiceAgentConfigurationModel';
  /** If set to true, the agent will dynamically adjust how quickly it responds based on the user's speech rate and past turn-taking behavior in the call */
  enableDynamicResponsiveness: Scalars['Boolean']['output'];
  /** If set to true, will enable dynamic voice speed adjustment based on the user's speech rate and conversation context */
  enableDynamicVoiceSpeed: Scalars['Boolean']['output'];
  /** The responsiveness of the model that Cara should use ([0,1] default 0.9, higher is more responsive less latency) */
  responsiveness: Scalars['Float']['output'];
  /** The voice that Cara should use */
  voice: VoiceAgentConfigurationModelVoice;
  /** The voice speed that Cara should use ([0.5, 2]default 1.06) */
  voiceSpeed: Scalars['Float']['output'];
  /** The voice speed that Cara should use ([0,2] default 1) */
  voiceTemperature: Scalars['Float']['output'];
  /** The voice volume that Cara should use ([0,2] default 1) */
  voiceVolume: Scalars['Float']['output'];
};

/** Input type for configuring model settings for the voice agent */
export type VoiceAgentConfigurationModelInput = {
  /** If set to true, the agent will dynamically adjust how quickly it responds based on the user's speech rate and past turn-taking behavior in the call */
  enableDynamicResponsiveness: Scalars['Boolean']['input'];
  /** If set to true, will enable dynamic voice speed adjustment based on the user's speech rate and conversation context */
  enableDynamicVoiceSpeed: Scalars['Boolean']['input'];
  /** The responsiveness of the model that Cara should use ([0,1] default 0.9, higher is more responsive less latency) */
  responsiveness: Scalars['Float']['input'];
  /** The voice that Cara should use */
  voice: VoiceAgentConfigurationModelVoice;
  /** The voice speed that Cara should use ([0.5, 2]default 1.06) */
  voiceSpeed: Scalars['Float']['input'];
  /** The voice speed that Cara should use ([0,2] default 1) */
  voiceTemperature: Scalars['Float']['input'];
  /** The voice volume that Cara should use ([0,2] default 1) */
  voiceVolume: Scalars['Float']['input'];
};

/** The voice that Cara should use */
export enum VoiceAgentConfigurationModelVoice {
  Andrea = 'ANDREA',
  Ashley = 'ASHLEY',
  Charlotte = 'CHARLOTTE',
  Chloe = 'CHLOE',
  Cimo = 'CIMO',
  Crystal = 'CRYSTAL',
  Eleanor = 'ELEANOR',
  Evie = 'EVIE',
  Grace = 'GRACE',
  Hailey = 'HAILEY',
  HaileyBrazilian = 'HAILEY_BRAZILIAN',
  Isabel = 'ISABEL',
  Kate = 'KATE',
  Marissa = 'MARISSA',
  May = 'MAY',
  MinimaxGrace = 'MINIMAX_GRACE',
  Nia = 'NIA',
  Rita = 'RITA',
  Sophie = 'SOPHIE',
  Susan = 'SUSAN',
  Zuri = 'ZURI'
}

/** The notifications that Cara should use */
export type VoiceAgentConfigurationNotifications = {
  __typename?: 'VoiceAgentConfigurationNotifications';
  /** Custom routing instructions to determine how to route call notifications */
  dynamicEmailRoutingCustomInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * Whether to dynamically route call notifications automatically to the mentioned
   * or transferred agent.
   */
  enableDynamicEmailRoutingToAgencyUsers: Scalars['Boolean']['output'];
  /** The static email addresses that Cara should use to send notifications */
  staticEmails: Array<Scalars['String']['output']>;
};

export type VoiceAgentConfigurationNotificationsInput = {
  /** Custom routing instructions to determine how to route call notifications */
  dynamicEmailRoutingCustomInstructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether to dynamically route call notifications automatically to the mentioned
   * or transferred agent.
   */
  enableDynamicEmailRoutingToAgencyUsers: Scalars['Boolean']['input'];
  /** The static email addresses that Cara should use to send notifications */
  staticEmails: Array<Scalars['String']['input']>;
};

/** Default outbound call behavior for outbound voice agents */
export type VoiceAgentConfigurationOutboundCallBehavior = {
  __typename?: 'VoiceAgentConfigurationOutboundCallBehavior';
  /** Whether Cara should leave a voicemail when the customer does not answer */
  leaveVoicemail: Scalars['Boolean']['output'];
  /**
   * Whether Cara should verify the customer's identity at the start of the call.
   * Defaults to false.
   */
  verifyIdentity: Scalars['Boolean']['output'];
  /** The message Cara should leave when voicemail is reached */
  voicemailMessage: Scalars['String']['output'];
};

export type VoiceAgentConfigurationOutboundCallBehaviorInput = {
  /** Whether Cara should leave a voicemail when the customer does not answer */
  leaveVoicemail: Scalars['Boolean']['input'];
  /**
   * Whether Cara should verify the customer's identity at the start of the call.
   * Defaults to false.
   */
  verifyIdentity: Scalars['Boolean']['input'];
  /** The message Cara should leave when voicemail is reached */
  voicemailMessage: Scalars['String']['input'];
};

export type VoiceAgentConfigurationQuestionsAuto = {
  __typename?: 'VoiceAgentConfigurationQuestionsAuto';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The auto insurance questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsAutoType>;
};

export type VoiceAgentConfigurationQuestionsAutoInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The auto insurance questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsAutoType>;
};

export enum VoiceAgentConfigurationQuestionsAutoType {
  /** Whether the client would like comprehensive and collision coverage on the vehicle */
  ComprehensiveAndCollisionCoverage = 'COMPREHENSIVE_AND_COLLISION_COVERAGE',
  /** Confirm if this is a business auto or personal auto quote if not already known */
  ConfirmBusinessOrPersonalAuto = 'CONFIRM_BUSINESS_OR_PERSONAL_AUTO',
  /** Collect the drivers license number for EACH driver if available */
  DriversLicenseNumbers = 'DRIVERS_LICENSE_NUMBERS',
  /** Count of drivers to be listed on the policy */
  DriverCount = 'DRIVER_COUNT',
  /** List of all drivers including first and last name, their respective gender, and birth date */
  DriverDetails = 'DRIVER_DETAILS',
  /** The estimated annual mileage */
  EstimatedAnnualMileage = 'ESTIMATED_ANNUAL_MILEAGE',
  /** The current estimated value of the vehicle if known */
  EstimatedVehicleValue = 'ESTIMATED_VEHICLE_VALUE',
  /** Garaging address including the street address, city or town, state, and zip code */
  GaragingAddress = 'GARAGING_ADDRESS',
  /** Any prior accidents or violations in the past five years for any driver */
  PriorAccidentsOrViolations = 'PRIOR_ACCIDENTS_OR_VIOLATIONS',
  /** When the vehicle was acquired (purchase date) */
  VehicleAcquisitionDate = 'VEHICLE_ACQUISITION_DATE',
  /** How many vehicles are they looking to insure on this quote */
  VehicleCount = 'VEHICLE_COUNT',
  /** Vehicle use: pleasure, business, or both */
  VehicleUse = 'VEHICLE_USE',
  /** V.I.N. (vehicle identification number) or the year, make, model, and trim of each vehicle */
  VinOrVehicleDetails = 'VIN_OR_VEHICLE_DETAILS'
}

export type VoiceAgentConfigurationQuestionsCommercialCommon = {
  __typename?: 'VoiceAgentConfigurationQuestionsCommercialCommon';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>;
};

export type VoiceAgentConfigurationQuestionsCommercialCommonInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>;
};

export enum VoiceAgentConfigurationQuestionsCommercialCommonType {
  /** Ask for the business legal name and DBA (doing business as) name */
  BusinessLegalNameAndDba = 'BUSINESS_LEGAL_NAME_AND_DBA',
  /** Ask about the business operations to understand what kind of business they are in */
  BusinessOperations = 'BUSINESS_OPERATIONS',
  /** Ask when the business was started or acquired */
  BusinessStartDate = 'BUSINESS_START_DATE',
  /** Ask for the estimated revenue for the next twelve months */
  EstimatedAnnualRevenue = 'ESTIMATED_ANNUAL_REVENUE'
}

export type VoiceAgentConfigurationQuestionsCommercialLiability = {
  __typename?: 'VoiceAgentConfigurationQuestionsCommercialLiability';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The commercial liability questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>;
};

export type VoiceAgentConfigurationQuestionsCommercialLiabilityInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The commercial liability questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>;
};

export enum VoiceAgentConfigurationQuestionsCommercialLiabilityType {
  /** The coverage limits if the customer knows what coverage limits they want */
  CoverageLimits = 'COVERAGE_LIMITS',
  /** If the business sells goods then understand if they import the goods, manufacture the goods, or sell the goods under their own label */
  ImportManufactureOrSellUnderOwnLabel = 'IMPORT_MANUFACTURE_OR_SELL_UNDER_OWN_LABEL',
  /** Addresses for all locations to be insured with at least one address to mail the policy to */
  LocationAddresses = 'LOCATION_ADDRESSES',
  /** The business's estimated revenue from each type of operation split by location */
  RevenueByOperationAndLocation = 'REVENUE_BY_OPERATION_AND_LOCATION',
  /** Ask at least two additional underwriting questions sequentially based on the business type */
  UnderwritingQuestions = 'UNDERWRITING_QUESTIONS'
}

export type VoiceAgentConfigurationQuestionsCommercialProperty = {
  __typename?: 'VoiceAgentConfigurationQuestionsCommercialProperty';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The commercial property questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>;
};

export type VoiceAgentConfigurationQuestionsCommercialPropertyInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The commercial property questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>;
};

export enum VoiceAgentConfigurationQuestionsCommercialPropertyType {
  /** Address of the building including the street address, town or city, state, and zip code */
  BuildingAddress = 'BUILDING_ADDRESS',
  /** How much coverage do they need: building coverage, contents coverage, and tenants betterments and improvements coverage if applicable */
  CoverageAmounts = 'COVERAGE_AMOUNTS',
  /** Collect the exterior wall type: masonry like cement block or brick, or something else like stucco, vinyl, etc. */
  ExteriorWallType = 'EXTERIOR_WALL_TYPE',
  /** If fire or burglar alarms are present and if they sound locally or are monitored by a third party */
  FireOrBurglarAlarms = 'FIRE_OR_BURGLAR_ALARMS',
  /** Collect the framing type: the building will either have wood or metal framing */
  FramingType = 'FRAMING_TYPE',
  /** Any other locations to insure */
  OtherLocations = 'OTHER_LOCATIONS',
  /** If the customer owns or rents the building */
  OwnershipStatus = 'OWNERSHIP_STATUS',
  /** The address for their primary home if this is not the primary home */
  PrimaryHomeAddress = 'PRIMARY_HOME_ADDRESS',
  /** If this is their primary or secondary home */
  PrimaryOrSecondaryHome = 'PRIMARY_OR_SECONDARY_HOME',
  /** If there are prior losses in the last five years */
  PriorLosses = 'PRIOR_LOSSES',
  /** If it is for residential or personal like homeowners, condo, or tenant */
  ResidentialOrPersonalType = 'RESIDENTIAL_OR_PERSONAL_TYPE',
  /** For business customers ask if they have a sprinkler system in the ceiling */
  SprinklerSystem = 'SPRINKLER_SYSTEM',
  /** Square footage for each location */
  SquareFootage = 'SQUARE_FOOTAGE',
  /** Year built, including the year updated for roofing, plumbing, electrical, and HVAC */
  YearBuiltAndUpdates = 'YEAR_BUILT_AND_UPDATES'
}

/** The custom questions that Cara should ask the caller based on the line of business */
export type VoiceAgentConfigurationQuestionsCustomQuote = {
  __typename?: 'VoiceAgentConfigurationQuestionsCustomQuote';
  /** The line of business that the custom questions should be based on */
  lineOfBusiness: Scalars['String']['output'];
  /** The quote questions that Cara should ask the caller */
  questions: Array<Scalars['String']['output']>;
};

/** The custom questions that Cara should ask the caller based on the line of business */
export type VoiceAgentConfigurationQuestionsCustomQuoteInput = {
  /** The line of business that the custom questions should be based on */
  lineOfBusiness: Scalars['String']['input'];
  /** The quote questions that Cara should ask the caller */
  questions: Array<Scalars['String']['input']>;
};

/** The qualification questions that Cara should ask the caller */
export type VoiceAgentConfigurationQuestionsQualification = {
  __typename?: 'VoiceAgentConfigurationQuestionsQualification';
  /** The custom qualification questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The qualification questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsQualificationType>;
};

/** Input type for configuring qualification questions for the voice agent */
export type VoiceAgentConfigurationQuestionsQualificationInput = {
  /** The custom qualification questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The qualification questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsQualificationType>;
};

export enum VoiceAgentConfigurationQuestionsQualificationType {
  /** Ask if they have a prior policy and are looking to switch */
  HavePriorPolicy = 'HAVE_PRIOR_POLICY',
  /** Ask the reason why they are requesting a quote */
  ReasonForQuote = 'REASON_FOR_QUOTE'
}

export type VoiceAgentConfigurationQuestionsWorkersCompensation = {
  __typename?: 'VoiceAgentConfigurationQuestionsWorkersCompensation';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The workers compensation questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>;
};

export type VoiceAgentConfigurationQuestionsWorkersCompensationInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The workers compensation questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>;
};

export enum VoiceAgentConfigurationQuestionsWorkersCompensationType {
  /** If the company uses 1099s that do not carry workers compensation then collect the annual 1099 payments */
  Contractor_1099Payments = 'CONTRACTOR_1099_PAYMENTS',
  /** Collect the count of full time and part time W2 workers per location with a split between full time vs part time */
  EmployeeCountByTypeAndLocation = 'EMPLOYEE_COUNT_BY_TYPE_AND_LOCATION',
  /** FEIN (federal employer identification number) */
  Fein = 'FEIN',
  /** Address for each location with employees to be covered */
  LocationAddressesWithEmployees = 'LOCATION_ADDRESSES_WITH_EMPLOYEES',
  /** If they would like to cover owners and officers in the workers compensation, collect the full name and ownership percentage for each */
  OwnerOfficerCoverage = 'OWNER_OFFICER_COVERAGE',
  /** Collect the payroll of full time and part time W2 workers per location with a split between full time vs part time payroll */
  PayrollByTypeAndLocation = 'PAYROLL_BY_TYPE_AND_LOCATION',
  /** Ask two additional underwriting questions sequentially based on the business type */
  UnderwritingQuestions = 'UNDERWRITING_QUESTIONS'
}

/** The task behavior configuration that Cara should use */
export type VoiceAgentConfigurationTaskBehavior = {
  __typename?: 'VoiceAgentConfigurationTaskBehavior';
  /** The business lines that Cara should handle */
  businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine;
  /** How Cara should handle coi tasks */
  coi: VoiceAgentConfigurationTaskBehaviorCoi;
  /** How Cara should handle fnol tasks */
  fnol: VoiceAgentConfigurationTaskBehaviorFnol;
  /** How Cara should handle lpr tasks */
  lpr: VoiceAgentConfigurationTaskBehaviorLpr;
  /** The general instructions that Cara should use when handling other business lines */
  otherBusinessLinesGeneralInstructions: Scalars['String']['output'];
  /** The task instructions that Cara should use when handling other business lines */
  otherBusinessLinesTaskInstructions: Scalars['String']['output'];
  /** How Cara should handle quote tasks */
  quote: VoiceAgentConfigurationTaskBehaviorQuote;
  /** How Cara should handle service tasks */
  service: VoiceAgentConfigurationTaskBehaviorService;
};

/** The business line that Cara should handle */
export enum VoiceAgentConfigurationTaskBehaviorBusinessLine {
  /** Handle all business lines */
  All = 'ALL',
  /** Handle commercial business lines */
  Commercial = 'COMMERCIAL',
  /** Handle other business lines */
  Other = 'OTHER',
  /** Handle personal business lines */
  Personal = 'PERSONAL'
}

export type VoiceAgentConfigurationTaskBehaviorCoi = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorCOI';
  /** The custom instructions that Cara should use when taking COI information over the phone */
  customInstructions: Scalars['String']['output'];
  /** Whether Cara should handle taking COI information over the phone */
  enabled: Scalars['Boolean']['output'];
};

export type VoiceAgentConfigurationTaskBehaviorCoiInput = {
  /** The custom instructions that Cara should use when taking COI information over the phone */
  customInstructions: Scalars['String']['input'];
  /** Whether Cara should handle taking COI information over the phone */
  enabled: Scalars['Boolean']['input'];
};

export type VoiceAgentConfigurationTaskBehaviorFnol = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOL';
  /** The auto insurance FNOL questions that Cara should ask the caller */
  auto: VoiceAgentConfigurationTaskBehaviorFnolAuto;
  /** The commercial liability FNOL questions that Cara should ask the caller */
  commercialLiability: VoiceAgentConfigurationTaskBehaviorFnolCommercialLiability;
  /** The commercial property FNOL questions that Cara should ask the caller */
  commercialProperty: VoiceAgentConfigurationTaskBehaviorFnolCommercialProperty;
  /** The custom instructions that Cara should use when taking FNOL information over the phone */
  customInstructions: Scalars['String']['output'];
  /** Whether Cara should handle taking FNOL information over the phone */
  enabled: Scalars['Boolean']['output'];
  /** The workers compensation FNOL questions that Cara should ask the caller */
  workersCompensation: VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensation;
};

export type VoiceAgentConfigurationTaskBehaviorFnolAuto = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLAuto';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The auto FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>;
};

export type VoiceAgentConfigurationTaskBehaviorFnolAutoInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The auto FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>;
};

export enum VoiceAgentConfigurationTaskBehaviorFnolAutoType {
  /** Identify the drivers of the vehicles involved. Get the drivers first and last name as well as any contact info */
  DriverIdentification = 'DRIVER_IDENTIFICATION',
  /** Identify if anyone was hurt and if so who. Collect the first and last name of all those injured and any contact information */
  InjuryIdentification = 'INJURY_IDENTIFICATION',
  /** Collect the date the loss occurred */
  LossDate = 'LOSS_DATE',
  /** Take a description of the loss meaning what happened and what caused the loss */
  LossDescription = 'LOSS_DESCRIPTION',
  /** Collect the location the loss occurred including the street address, town, state, and zip if available */
  LossLocation = 'LOSS_LOCATION',
  /** Ask for a police report number and for them to send a copy in via email if possible */
  PoliceReportRequest = 'POLICE_REPORT_REQUEST',
  /** Identify how many cars or other pieces of property were damaged. Collect the VINs for damaged vehicles if possible */
  VehicleDamageAssessment = 'VEHICLE_DAMAGE_ASSESSMENT',
  /** Collect the make, model, plate number, and year of the vehicles if VIN is not available */
  VehicleDetailsIfNoVin = 'VEHICLE_DETAILS_IF_NO_VIN'
}

export type VoiceAgentConfigurationTaskBehaviorFnolCommercialLiability = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialLiability';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The commercial liability FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>;
};

export type VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The commercial liability FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>;
};

export enum VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType {
  /** Collect the name and available contact information of the injured parties */
  InjuredPartiesInfo = 'INJURED_PARTIES_INFO',
  /** Collect the date the loss occurred */
  LossDate = 'LOSS_DATE',
  /** Take a description of the loss meaning what happened and who was injured or what property was damaged */
  LossDescription = 'LOSS_DESCRIPTION',
  /** Location that the loss occurred including the street address, city or town, state, and zip */
  LossLocation = 'LOSS_LOCATION',
  /** For other liability types, confirm what material or action from the insured is involved */
  OtherLiabilityMaterialOrAction = 'OTHER_LIABILITY_MATERIAL_OR_ACTION',
  /** If there is a police report, collect the report number if available */
  PoliceReportNumber = 'POLICE_REPORT_NUMBER',
  /** Determine if the loss was premise liability and confirm ownership/tenant status */
  PremiseLiabilityOwnership = 'PREMISE_LIABILITY_OWNERSHIP',
  /** For product liability, collect the products involved in the incident */
  ProductLiabilityProducts = 'PRODUCT_LIABILITY_PRODUCTS',
  /** For product liability, confirm if the insured is the manufacturer, importer, brand owner, or vendor */
  ProductLiabilityRole = 'PRODUCT_LIABILITY_ROLE',
  /** Collect the name and available contact info for any witnesses */
  WitnessesInfo = 'WITNESSES_INFO'
}

export type VoiceAgentConfigurationTaskBehaviorFnolCommercialProperty = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialProperty';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The commercial property FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>;
};

export type VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The commercial property FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>;
};

export enum VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType {
  /** Collect the date the loss occurred */
  LossDate = 'LOSS_DATE',
  /** Take a description of the loss meaning what happened and what caused the loss. The cause of loss includes: fire, theft, lightning, hail, water, or wind */
  LossDescriptionAndCause = 'LOSS_DESCRIPTION_AND_CAUSE',
  /** Collect the location the loss occurred including the street address, town, state, and zip */
  LossLocation = 'LOSS_LOCATION',
  /** Ask for a police report number if available and for them to send a copy in via email */
  PoliceReportRequest = 'POLICE_REPORT_REQUEST',
  /** If there was damage to a structure, confirm if they are still able to use the property or if they need to temporarily move offsite */
  PropertyUsability = 'PROPERTY_USABILITY'
}

export type VoiceAgentConfigurationTaskBehaviorFnolInput = {
  /** The auto insurance FNOL questions that Cara should ask the caller */
  auto: VoiceAgentConfigurationTaskBehaviorFnolAutoInput;
  /** The commercial liability FNOL questions that Cara should ask the caller */
  commercialLiability: VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityInput;
  /** The commercial property FNOL questions that Cara should ask the caller */
  commercialProperty: VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyInput;
  /** The custom instructions that Cara should use when taking FNOL information over the phone */
  customInstructions: Scalars['String']['input'];
  /** Whether Cara should handle taking FNOL information over the phone */
  enabled: Scalars['Boolean']['input'];
  /** The workers compensation FNOL questions that Cara should ask the caller */
  workersCompensation: VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationInput;
};

export type VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensation = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLWorkersCompensation';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The workers compensation FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>;
};

export type VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The workers compensation FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>;
};

export enum VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType {
  /** Confirm employer federal employer identification number (FEIN). This is also known as the business tax ID. */
  ConfirmFein = 'CONFIRM_FEIN',
  /** Employee address, phone, and email if available */
  EmployeeContactInfo = 'EMPLOYEE_CONTACT_INFO',
  /** Employee date of birth */
  EmployeeDateOfBirth = 'EMPLOYEE_DATE_OF_BIRTH',
  /** Employee number of dependents if available */
  EmployeeDependents = 'EMPLOYEE_DEPENDENTS',
  /** Employee date of hire and if they are still employed by the business */
  EmployeeHireDateAndStatus = 'EMPLOYEE_HIRE_DATE_AND_STATUS',
  /** Employee job title or occupation in the business */
  EmployeeJobTitle = 'EMPLOYEE_JOB_TITLE',
  /** Employee marital status if available */
  EmployeeMaritalStatus = 'EMPLOYEE_MARITAL_STATUS',
  /** Employee first name and last name */
  EmployeeName = 'EMPLOYEE_NAME',
  /** Average weekly wages for the employee */
  EmployeeWeeklyWages = 'EMPLOYEE_WEEKLY_WAGES',
  /** Collect a description of how the injury occurred. Ask clarifying questions to completely understand the situation. Ask at least two clarifying questions. */
  InjuryDescription = 'INJURY_DESCRIPTION',
  /** If available, collect OSHA case number or injury reporting number */
  OshaCaseNumber = 'OSHA_CASE_NUMBER'
}

export type VoiceAgentConfigurationTaskBehaviorInput = {
  /** The business lines that Cara should handle */
  businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine;
  /** How Cara should handle coi tasks */
  coi: VoiceAgentConfigurationTaskBehaviorCoiInput;
  /** How Cara should handle fnol tasks */
  fnol: VoiceAgentConfigurationTaskBehaviorFnolInput;
  /** How Cara should handle lpr tasks */
  lpr: VoiceAgentConfigurationTaskBehaviorLprInput;
  /** How Cara should handle quote tasks */
  quote: VoiceAgentConfigurationTaskBehaviorQuoteInput;
  /** How Cara should handle service tasks */
  service: VoiceAgentConfigurationTaskBehaviorServiceInput;
};

export type VoiceAgentConfigurationTaskBehaviorLpr = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorLPR';
  /** The custom instructions that Cara should use when taking LPR information over the phone */
  customInstructions: Scalars['String']['output'];
  /** Whether Cara should handle taking LPR (Loss Prevention Review) information over the phone */
  enabled: Scalars['Boolean']['output'];
};

export type VoiceAgentConfigurationTaskBehaviorLprInput = {
  /** The custom instructions that Cara should use when taking LPR information over the phone */
  customInstructions: Scalars['String']['input'];
  /** Whether Cara should handle taking LPR (Loss Prevention Review) information over the phone */
  enabled: Scalars['Boolean']['input'];
};

export type VoiceAgentConfigurationTaskBehaviorQuote = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorQuote';
  /** The common non-commercial questions that Cara should ask the caller */
  auto: VoiceAgentConfigurationQuestionsAuto;
  /** The common commercial questions that Cara should ask the caller */
  commercialCommon: VoiceAgentConfigurationQuestionsCommercialCommon;
  /** The commercial liability questions that Cara should ask the caller */
  commercialLiability: VoiceAgentConfigurationQuestionsCommercialLiability;
  /** The commercial property questions that Cara should ask the caller */
  commercialProperty: VoiceAgentConfigurationQuestionsCommercialProperty;
  /** The custom questions that Cara should ask the caller */
  custom: Array<VoiceAgentConfigurationQuestionsCustomQuote>;
  /** Whether Cara should handle quote tasks */
  enabled: Scalars['Boolean']['output'];
  /** The qualification questions that Cara should ask the caller */
  qualification: VoiceAgentConfigurationQuestionsQualification;
  /** The common non-commercial questions that Cara should ask the caller */
  workersCompensation: VoiceAgentConfigurationQuestionsWorkersCompensation;
};

export type VoiceAgentConfigurationTaskBehaviorQuoteInput = {
  /** The common non-commercial questions that Cara should ask the caller */
  auto: VoiceAgentConfigurationQuestionsAutoInput;
  /** The common commercial questions that Cara should ask the caller */
  commercialCommon: VoiceAgentConfigurationQuestionsCommercialCommonInput;
  /** The commercial liability questions that Cara should ask the caller */
  commercialLiability: VoiceAgentConfigurationQuestionsCommercialLiabilityInput;
  /** The commercial property questions that Cara should ask the caller */
  commercialProperty: VoiceAgentConfigurationQuestionsCommercialPropertyInput;
  /** The custom questions that Cara should ask the caller */
  custom: Array<VoiceAgentConfigurationQuestionsCustomQuoteInput>;
  /** Whether Cara should handle quote tasks */
  enabled: Scalars['Boolean']['input'];
  /** The qualification questions that Cara should ask the caller */
  qualification: VoiceAgentConfigurationQuestionsQualificationInput;
  /** The common non-commercial questions that Cara should ask the caller */
  workersCompensation: VoiceAgentConfigurationQuestionsWorkersCompensationInput;
};

export type VoiceAgentConfigurationTaskBehaviorService = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorService';
  /** Whether Cara should handle add driver tasks */
  addDriver: VoiceAgentConfigurationTaskBehaviorServiceAddDriver;
  /** Whether Cara should handle add location tasks */
  addLocation: VoiceAgentConfigurationTaskBehaviorServiceAddLocation;
  /** Whether Cara should handle add vehicle tasks */
  addVehicle: VoiceAgentConfigurationTaskBehaviorServiceAddVehicle;
  /** Whether Cara should handle service tasks */
  enabled: Scalars['Boolean']['output'];
  /** The custom service requests that Cara should handle */
  other: Scalars['String']['output'];
};

export type VoiceAgentConfigurationTaskBehaviorServiceAddDriver = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddDriver';
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The add-driver service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>;
};

export type VoiceAgentConfigurationTaskBehaviorServiceAddDriverInput = {
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The add-driver service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>;
};

/** The questions Cara should ask when adding a driver to a policy */
export enum VoiceAgentConfigurationTaskBehaviorServiceAddDriverType {
  /** New driver's date of birth */
  DriverDateOfBirth = 'DRIVER_DATE_OF_BIRTH',
  /** New driver's gender */
  DriverGender = 'DRIVER_GENDER',
  /** The driver's license number for each new driver if available. If collected, repeat back the number to confirm understanding and do not ask another question until the caller responds */
  DriverLicenseNumber = 'DRIVER_LICENSE_NUMBER',
  /** New driver's first and last name */
  DriverName = 'DRIVER_NAME'
}

export type VoiceAgentConfigurationTaskBehaviorServiceAddLocation = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddLocation';
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The add-location service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>;
};

export type VoiceAgentConfigurationTaskBehaviorServiceAddLocationInput = {
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The add-location service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>;
};

/** The questions Cara should ask when adding a location to a policy */
export enum VoiceAgentConfigurationTaskBehaviorServiceAddLocationType {
  /** For commercial liability policies, the associated revenue for this new address (if any) */
  ClRevenueForLocation = 'CL_REVENUE_FOR_LOCATION',
  /** Coverage limits requested for this location */
  CoverageLimitsRequested = 'COVERAGE_LIMITS_REQUESTED',
  /** Any addresses to be removed, if any */
  LocationsToRemove = 'LOCATIONS_TO_REMOVE',
  /** Confirm whether the new location is owned or leased/rented */
  LocationOwnershipStatus = 'LOCATION_OWNERSHIP_STATUS',
  /** Full street address of the new location */
  NewLocationAddress = 'NEW_LOCATION_ADDRESS',
  /** Requested effective date for this change */
  RequestedEffectiveDate = 'REQUESTED_EFFECTIVE_DATE',
  /** For workers compensation policies, the associated payroll and employee count for this location */
  WcPayrollAndEmployeeCountForLocation = 'WC_PAYROLL_AND_EMPLOYEE_COUNT_FOR_LOCATION'
}

export type VoiceAgentConfigurationTaskBehaviorServiceAddVehicle = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddVehicle';
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The add-vehicle service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>;
};

export type VoiceAgentConfigurationTaskBehaviorServiceAddVehicleInput = {
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The add-vehicle service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>;
};

/** The questions Cara should ask when adding a vehicle to a policy */
export enum VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType {
  /** Whether comprehensive and collision coverage is desired in addition to liability coverage */
  DesiredCoveragesComprehensiveAndCollision = 'DESIRED_COVERAGES_COMPREHENSIVE_AND_COLLISION',
  /** Any driver or vehicle changes related to this request (e.g., new drivers to add or vehicles to remove). If adding a new driver, collect the appropriate information for that as well */
  DriverOrVehicleChanges = 'DRIVER_OR_VEHICLE_CHANGES',
  /** The estimated annual mileage for this vehicle */
  EstimatedAnnualMileage = 'ESTIMATED_ANNUAL_MILEAGE',
  /** The VIN (vehicle identification number) or the year, make, model, and trim of the vehicle */
  VinOrVehicleDetails = 'VIN_OR_VEHICLE_DETAILS'
}

export type VoiceAgentConfigurationTaskBehaviorServiceInput = {
  /** Whether Cara should handle add driver tasks */
  addDriver: VoiceAgentConfigurationTaskBehaviorServiceAddDriverInput;
  /** Whether Cara should handle add location tasks */
  addLocation: VoiceAgentConfigurationTaskBehaviorServiceAddLocationInput;
  /** Whether Cara should handle add vehicle tasks */
  addVehicle: VoiceAgentConfigurationTaskBehaviorServiceAddVehicleInput;
  /** Whether Cara should handle service tasks */
  enabled: Scalars['Boolean']['input'];
  /** The custom service requests that Cara should handle */
  other: Scalars['String']['input'];
};

/** The transfer configuration for the voice agent */
export type VoiceAgentConfigurationTransfer = {
  __typename?: 'VoiceAgentConfigurationTransfer';
  /** The behavior of how Cara transfers calls, if different from the default behavior (default IMMEDIATE) */
  behavior: VoiceAgentTransferBehavior;
  /** Whether to collect the purpose of the call from the caller prior to transferring the call */
  collectPurpose: Scalars['Boolean']['output'];
  /** The directory of phone numbers to transfer the call to */
  directory: Array<VoiceAgentConfigurationTransferDirectoryEntry>;
  /**
   * Whether Cara is allowed to transfer calls to external parties (carriers, lenders, etc.).
   * When false, external directory entries are ignored.
   */
  enableExternalTransfer: Scalars['Boolean']['output'];
  /** Whether to allow Cara to transfer calls to other numbers */
  enabled: Scalars['Boolean']['output'];
  /** Deprecated: mirrored from externalTransferBehavior on save. Use externalTransferBehavior instead. */
  externalTransferAllowInternalFallback: Scalars['Boolean']['output'];
  /**
   * How Cara routes between internal and external transfer directories when external
   * transfer is enabled. Unset stored values resolve to EXTERNAL_FIRST_INTERNAL_FALLBACK.
   */
  externalTransferBehavior: VoiceAgentExternalTransferBehavior;
  /**
   * Deprecated: use per-entry callTypes on external directory entries instead.
   * Retained for backward compatibility; no longer read by the transfer resolver or UI.
   */
  externalTransferCallTypes?: Maybe<Array<VoiceAgentTransferCallType>>;
  /** The number of times Cara should attempt to transfer the call to other numbers if the first attempt fails */
  fallbackAttempts: Scalars['Int']['output'];
  /** The transfer hours of the agency that Cara should use */
  hours: VoiceAgentConfigurationTransferHours;
  /** Built-in and agency-defined line-of-business values available for Voice 3.5 transfer routing. */
  lineOfBusinessCatalog: Array<VoiceAgentTransferLineOfBusiness>;
  /** How long to ring before hanging up in milliseconds ([5000, 30000] default 15000) */
  ringDurationMs: Scalars['Int']['output'];
  /** SIP mode for cold transfers only (default INVITE; REFER optional). Warm transfer always uses REFER and ignores this field. */
  sipTransferMode?: Maybe<VoiceAgentSipTransferMode>;
  /** Scheduled time off periods when transfers should be disabled */
  timeOffSchedules: Array<VoiceAgentConfigurationTransferTimeOffSchedule>;
  /**
   * How Cara should time transfers for cancellation / lost policy release calls (CANCELLATION).
   * Emitted to Retell as LPR_FIRST_TRANSFER.
   */
  transferBehaviorCancellation: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for certificate of insurance calls (COI). */
  transferBehaviorCoi: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for FNOL and claims calls (CLAIMS). */
  transferBehaviorFnol: VoiceAgentTransferBehavior;
  /**
   * How Cara should time transfers for new quote calls (Retell requested_call_type NEW_BUSINESS).
   * Applies when the new cold transfer flow is on, in addition to the global Transfer Behavior setting.
   */
  transferBehaviorQuote: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for billing and policy service calls (BILLING, OTHER_SERVICING). */
  transferBehaviorService: VoiceAgentTransferBehavior;
  /** Message Cara speaks before transferring the call. Empty uses the product default. */
  transferMessage: Scalars['String']['output'];
  /**
   * How Cara performs transfers (COLD, WARM, or AGENTIC). Maps to Retell TRANSFER_TYPE at runtime.
   * Default COLD.
   */
  transferType: VoiceAgentTransferType;
  /**
   * When transfers are enabled and warm transfer is off, use the newer Retell cold-transfer conversation flow
   * (round-robin and updated transfer tooling). When false, use the legacy cold-transfer flow. Ignored when warm transfer is on.
   */
  useNewColdTransferConversationFlow: Scalars['Boolean']['output'];
  /**
   * Whether to introduce the caller and the purpose of the call to the human agent when transferring the call.
   * Deprecated: prefer transferType. Kept in sync on save for backward compatibility.
   */
  warmTransfer: Scalars['Boolean']['output'];
};

/** A directory entry for the voice agent's transfer configuration */
export type VoiceAgentConfigurationTransferDirectoryEntry = {
  __typename?: 'VoiceAgentConfigurationTransferDirectoryEntry';
  /**
   * Known alternate names, nicknames, or common mispronunciations for this entry.
   * Used to improve name matching accuracy.
   */
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  /** The call types this entry is eligible for. An empty list means eligible for all call types. */
  callTypes?: Maybe<Array<VoiceAgentTransferCallType>>;
  /**
   * The department for this entry (e.g. "Liability", "Claims").
   * When set, all entries sharing the same department token score equally, enabling round-robin.
   * At least one of name or department must be set for new entries; legacy entries use label only.
   */
  department?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this entry is an internal agency contact or an external party.
   * External entries are excluded from call types that restrict external routing (e.g. new business quotes).
   */
  entryType?: Maybe<VoiceAgentTransferDirectoryEntryType>;
  /** The extension to dial after connecting (optional) */
  extension?: Maybe<Scalars['String']['output']>;
  /** The label of the directory entry (name, department, etc.) */
  label: Scalars['String']['output'];
  /** Lines of business this entry handles. An empty list means eligible for every line of business. */
  lineOfBusinessIds: Array<Scalars['String']['output']>;
  /**
   * The person's name for this entry (e.g. "Joe Becker" for internal, "State Farm" for external).
   * When set, used for person-specific matching. At least one of name or department must be set
   * for new entries; legacy entries use label only. For external entries, use the carrier or vendor
   * name as shown in the AMS (often surfaced by lookup_customer at call start).
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number to transfer the call to */
  number: Scalars['String']['output'];
  /**
   * Servicing-person code for this directory entry (e.g. CSR in AMS360, agent code in HawkSoft).
   * When provided, an exact match against the caller's servicing code from lookup_customer
   * (or phone-based KG lookup) takes highest priority for transfer routing.
   */
  servicingCode?: Maybe<Scalars['String']['output']>;
  /** The criteria to give Cara to decide if she should transfer the call to this directory entry */
  transferCriteria: Scalars['String']['output'];
};

export type VoiceAgentConfigurationTransferDirectoryEntryInput = {
  /**
   * Known alternate names, nicknames, or common mispronunciations for this entry.
   * Used to improve name matching accuracy.
   */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The call types this entry is eligible for. An empty list means eligible for all call types. */
  callTypes?: InputMaybe<Array<VoiceAgentTransferCallType>>;
  /**
   * The department for this entry (e.g. "Liability", "Claims").
   * When set, all entries sharing the same department token score equally, enabling round-robin.
   * At least one of name or department must be set for new entries; legacy entries use label only.
   */
  department?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether this entry is an internal agency contact or an external party.
   * External entries are excluded from call types that restrict external routing (e.g. new business quotes).
   */
  entryType?: InputMaybe<VoiceAgentTransferDirectoryEntryType>;
  /** The extension to dial after connecting (optional) */
  extension?: InputMaybe<Scalars['String']['input']>;
  /** The label of the directory entry (name, department, etc.) */
  label: Scalars['String']['input'];
  /**
   * Lines of business this entry handles. Omit during an update to preserve existing selections;
   * an empty list clears restrictions and makes the entry eligible for every line of business.
   */
  lineOfBusinessIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The person's name for this entry (e.g. "Joe Becker" for internal, "State Farm" for external).
   * When set, used for person-specific matching. At least one of name or department must be set
   * for new entries; legacy entries use label only. For external entries, use the carrier or vendor
   * name as shown in the AMS (often surfaced by lookup_customer at call start).
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The phone number to transfer the call to */
  number: Scalars['String']['input'];
  /**
   * Servicing-person code for this directory entry (e.g. CSR in AMS360, agent code in HawkSoft).
   * When provided, an exact match against the caller's servicing code from lookup_customer
   * (or phone-based KG lookup) takes highest priority for transfer routing.
   */
  servicingCode?: InputMaybe<Scalars['String']['input']>;
  /** The criteria to give Cara to decide if she should transfer the call to this directory entry */
  transferCriteria: Scalars['String']['input'];
};

export type VoiceAgentConfigurationTransferHours = {
  __typename?: 'VoiceAgentConfigurationTransferHours';
  friday: VoiceAgentConfigurationTransferHoursDay;
  /** The hours to enable tranfer for each day of the week */
  monday: VoiceAgentConfigurationTransferHoursDay;
  saturday: VoiceAgentConfigurationTransferHoursDay;
  sunday: VoiceAgentConfigurationTransferHoursDay;
  thursday: VoiceAgentConfigurationTransferHoursDay;
  /** The timezone that Cara should use to calculate transfer hours */
  timezone: Scalars['String']['output'];
  tuesday: VoiceAgentConfigurationTransferHoursDay;
  wednesday: VoiceAgentConfigurationTransferHoursDay;
};

export type VoiceAgentConfigurationTransferHoursDay = {
  __typename?: 'VoiceAgentConfigurationTransferHoursDay';
  /** Whether transfer is enabled for this day */
  enabled: Scalars['Boolean']['output'];
  /** The end hour of the business day */
  endHour: Scalars['Int']['output'];
  /** The end minute of the business day */
  endMinute: Scalars['Int']['output'];
  /** The start time of the business day */
  startHour: Scalars['Int']['output'];
  /** The start minute of the business day */
  startMinute: Scalars['Int']['output'];
};

export type VoiceAgentConfigurationTransferHoursDayInput = {
  /** Whether transfer is enabled for this day */
  enabled: Scalars['Boolean']['input'];
  /** The end hour of the business day */
  endHour: Scalars['Int']['input'];
  /** The end minute of the business day */
  endMinute: Scalars['Int']['input'];
  /** The start time of the business day */
  startHour: Scalars['Int']['input'];
  /** The start minute of the business day */
  startMinute: Scalars['Int']['input'];
};

export type VoiceAgentConfigurationTransferHoursInput = {
  friday: VoiceAgentConfigurationTransferHoursDayInput;
  /** The hours to enable tranfer for each day of the week */
  monday: VoiceAgentConfigurationTransferHoursDayInput;
  saturday: VoiceAgentConfigurationTransferHoursDayInput;
  sunday: VoiceAgentConfigurationTransferHoursDayInput;
  thursday: VoiceAgentConfigurationTransferHoursDayInput;
  /** The timezone that Cara should use to calculate transfer hours */
  timezone: Scalars['String']['input'];
  tuesday: VoiceAgentConfigurationTransferHoursDayInput;
  wednesday: VoiceAgentConfigurationTransferHoursDayInput;
};

export type VoiceAgentConfigurationTransferInput = {
  /** The behavior of how Cara transfers calls, if different from the default behavior (default IMMEDIATE) */
  behavior: VoiceAgentTransferBehavior;
  /** Whether to collect the purpose of the call from the caller prior to transferring the call */
  collectPurpose: Scalars['Boolean']['input'];
  /** The directory of phone numbers to transfer the call to */
  directory: Array<VoiceAgentConfigurationTransferDirectoryEntryInput>;
  /**
   * Whether Cara is allowed to transfer calls to external parties (carriers, lenders, etc.).
   * When false, external directory entries are ignored.
   */
  enableExternalTransfer: Scalars['Boolean']['input'];
  /** Whether to allow Cara to transfer calls to other numbers */
  enabled: Scalars['Boolean']['input'];
  /** Deprecated: omitted on save; mirrored from externalTransferBehavior by the API. */
  externalTransferAllowInternalFallback?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * How Cara routes between internal and external transfer directories when external
   * transfer is enabled. When omitted on save, the server keeps the existing value or
   * defaults to EXTERNAL_FIRST_INTERNAL_FALLBACK for new agents.
   */
  externalTransferBehavior?: InputMaybe<VoiceAgentExternalTransferBehavior>;
  /**
   * Deprecated: use per-entry callTypes on external directory entries instead.
   * Retained for backward compatibility; no longer read by the transfer resolver or UI.
   */
  externalTransferCallTypes?: InputMaybe<Array<VoiceAgentTransferCallType>>;
  /** The number of times Cara should attempt to transfer the call to other numbers if the first attempt fails */
  fallbackAttempts: Scalars['Int']['input'];
  /** The transfer hours of the agency that Cara should use */
  hours: VoiceAgentConfigurationTransferHoursInput;
  /**
   * Built-in and agency-defined line-of-business values available for Voice 3.5 transfer routing.
   * Omit during an update to preserve the existing catalog. For Voice 3.5, an empty list resets
   * the catalog to the built-in values.
   */
  lineOfBusinessCatalog?: InputMaybe<Array<VoiceAgentTransferLineOfBusinessInput>>;
  /** How long to ring before hanging up in milliseconds ([5000, 30000] default 15000) */
  ringDurationMs: Scalars['Int']['input'];
  /** SIP mode for cold transfers only (default INVITE; REFER optional). Warm transfer always uses REFER and ignores this field. */
  sipTransferMode?: InputMaybe<VoiceAgentSipTransferMode>;
  /** Scheduled time off periods when transfers should be disabled */
  timeOffSchedules?: InputMaybe<Array<VoiceAgentConfigurationTransferTimeOffScheduleInput>>;
  /**
   * How Cara should time transfers for cancellation / lost policy release calls (CANCELLATION).
   * Emitted to Retell as LPR_FIRST_TRANSFER.
   */
  transferBehaviorCancellation: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for certificate of insurance calls (COI). */
  transferBehaviorCoi: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for FNOL and claims calls (CLAIMS). */
  transferBehaviorFnol: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for new quote calls (Retell requested_call_type NEW_BUSINESS). */
  transferBehaviorQuote: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for billing and policy service calls (BILLING, OTHER_SERVICING). */
  transferBehaviorService: VoiceAgentTransferBehavior;
  /** Message Cara speaks before transferring the call. Empty uses the product default. */
  transferMessage: Scalars['String']['input'];
  /** How Cara performs transfers (COLD, WARM, or AGENTIC). Maps to Retell TRANSFER_TYPE at runtime. */
  transferType: VoiceAgentTransferType;
  /**
   * When transfers are enabled and warm transfer is off, use the newer Retell cold-transfer conversation flow
   * (round-robin and updated transfer tooling). When false, use the legacy cold-transfer flow. Ignored when warm transfer is on.
   * Omit to leave the saved value unchanged on update (backward compatible for older API clients).
   */
  useNewColdTransferConversationFlow?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether to introduce the caller and the purpose of the call to the human agent when transferring the call.
   * Deprecated: prefer transferType. Kept in sync on save for backward compatibility.
   */
  warmTransfer: Scalars['Boolean']['input'];
};

/** Configuration for a DAILY_BREAKS schedule (recurring weekly - pick days of the week, e.g., every Monday) */
export type VoiceAgentConfigurationTransferTimeOffDailyBreak = {
  __typename?: 'VoiceAgentConfigurationTransferTimeOffDailyBreak';
  /** Days of the week for DAILY_BREAKS schedules. Allows multiple days. Recurring weekly (e.g., every Monday, every Tuesday). */
  daysOfWeek: Array<DayOfWeek>;
  /** The end hour of the time off period (0-23) */
  endHour: Scalars['Int']['output'];
  /** The end minute of the time off period (0-59) */
  endMinute: Scalars['Int']['output'];
  /** The start hour of the time off period (0-23) */
  startHour: Scalars['Int']['output'];
  /** The start minute of the time off period (0-59) */
  startMinute: Scalars['Int']['output'];
};

/** Input for a DAILY_BREAKS schedule configuration (recurring weekly - pick days) */
export type VoiceAgentConfigurationTransferTimeOffDailyBreakInput = {
  /** Days of the week for DAILY_BREAKS schedules. Allows multiple days. Recurring weekly (e.g., every Monday, every Tuesday). */
  daysOfWeek: Array<DayOfWeek>;
  /** The end hour of the time off period (0-23) */
  endHour: Scalars['Int']['input'];
  /** The end minute of the time off period (0-59) */
  endMinute: Scalars['Int']['input'];
  /** The start hour of the time off period (0-23) */
  startHour: Scalars['Int']['input'];
  /** The start minute of the time off period (0-59) */
  startMinute: Scalars['Int']['input'];
};

/** A time off schedule for disabling transfers during specific times or dates */
export type VoiceAgentConfigurationTransferTimeOffSchedule = {
  __typename?: 'VoiceAgentConfigurationTransferTimeOffSchedule';
  /** Additional instructions to append to global custom instructions during this scheduled time off period */
  additionalInstructions?: Maybe<Scalars['String']['output']>;
  /** Custom introduction phrase to use during this scheduled time off period */
  customIntro?: Maybe<Scalars['String']['output']>;
  /** Configuration for DAILY_BREAKS schedules. Only populated when type is DAILY_BREAKS. */
  dailyBreak?: Maybe<VoiceAgentConfigurationTransferTimeOffDailyBreak>;
  /** Unique identifier for this schedule */
  id: Scalars['String']['output'];
  /** Optional name/description for the schedule (e.g., "Lunch Break", "Christmas Holiday") */
  name?: Maybe<Scalars['String']['output']>;
  /** Configuration for SCHEDULED_CLOSURES schedules. Only populated when type is SCHEDULED_CLOSURES. */
  scheduledClosure?: Maybe<VoiceAgentConfigurationTransferTimeOffScheduledClosure>;
  /** The type of schedule: DAILY_BREAKS for recurring weekly schedules (pick days, e.g., every Monday), SCHEDULED_CLOSURES for specific dates */
  type: VoiceAgentTransferTimeOffScheduleType;
};

/** Input for a time off schedule */
export type VoiceAgentConfigurationTransferTimeOffScheduleInput = {
  /** Additional instructions to append to global custom instructions during this scheduled time off period */
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Custom introduction phrase to use during this scheduled time off period */
  customIntro?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for DAILY_BREAKS schedules. Only used when type is DAILY_BREAKS. */
  dailyBreak?: InputMaybe<VoiceAgentConfigurationTransferTimeOffDailyBreakInput>;
  /** Unique identifier for this schedule. If not provided, a new schedule will be created. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Optional name/description for this schedule */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for SCHEDULED_CLOSURES schedules. Only used when type is SCHEDULED_CLOSURES. */
  scheduledClosure?: InputMaybe<VoiceAgentConfigurationTransferTimeOffScheduledClosureInput>;
  /** The type of schedule: DAILY_BREAKS for recurring weekly schedules (pick days, e.g., every Monday), SCHEDULED_CLOSURES for specific dates. Optional - if not provided, schedule fields will be hidden. */
  type?: InputMaybe<VoiceAgentTransferTimeOffScheduleType>;
};

/** Configuration for a SCHEDULED_CLOSURES schedule (specific date or date range) */
export type VoiceAgentConfigurationTransferTimeOffScheduledClosure = {
  __typename?: 'VoiceAgentConfigurationTransferTimeOffScheduledClosure';
  /** Start date for the closure (YYYY-MM-DD format) */
  date: Scalars['String']['output'];
  /** End date for the closure (YYYY-MM-DD format). Optional for single-day schedules. */
  endDate?: Maybe<Scalars['String']['output']>;
};

/** Input for a SCHEDULED_CLOSURES schedule configuration */
export type VoiceAgentConfigurationTransferTimeOffScheduledClosureInput = {
  /** Start date for the closure (YYYY-MM-DD format) */
  date: Scalars['String']['input'];
  /** End date for the closure (YYYY-MM-DD format). Optional for single-day schedules. */
  endDate?: InputMaybe<Scalars['String']['input']>;
};

/** The call direction handled by a voice agent */
export enum VoiceAgentDirection {
  /** The agent receives inbound calls on its phone number */
  Inbound = 'INBOUND',
  /** The agent places outbound notification calls to customers */
  Outbound = 'OUTBOUND'
}

/** How Cara routes between internal and external transfer directories. */
export enum VoiceAgentExternalTransferBehavior {
  /**
   * Score internal and external entries together; try external at lower confidence from
   * KG carrier data before internal round-robin.
   */
  BestMatch = 'BEST_MATCH',
  /**
   * Try external directory first when routing_scope is EXTERNAL; fall back to internal
   * when external matching fails or the external number does not answer.
   */
  ExternalFirstInternalFallback = 'EXTERNAL_FIRST_INTERNAL_FALLBACK',
  /** Only route to external directory entries; return NONE when no confident external match. */
  ExternalOnly = 'EXTERNAL_ONLY'
}

export type VoiceAgentInput = {
  /** The voice agent configuration */
  configuration: VoiceAgentConfigurationInput;
  /** The name of the voice agent */
  name: Scalars['String']['input'];
};

/** The language of a voice agent */
export enum VoiceAgentLanguage {
  /** Afrikaans (South Africa) */
  AfZa = 'AF_ZA',
  /** Arabic (Saudi Arabia) */
  ArSa = 'AR_SA',
  /** Bulgarian (Bulgaria) */
  BgBg = 'BG_BG',
  /** Catalan (Spain) */
  CaEs = 'CA_ES',
  /** Czech (Czech Republic) */
  CsCz = 'CS_CZ',
  /** Danish (Denmark) */
  DaDk = 'DA_DK',
  /** German (Germany) */
  DeDe = 'DE_DE',
  /** Greek (Greece) */
  ElGr = 'EL_GR',
  /** English (Australia) */
  EnAu = 'EN_AU',
  /** English (United Kingdom) */
  EnGb = 'EN_GB',
  /** English (India) */
  EnIn = 'EN_IN',
  /** English (New Zealand) */
  EnNz = 'EN_NZ',
  /** English (United States) */
  EnUs = 'EN_US',
  /** Spanish (Latin America) */
  Es_419 = 'ES_419',
  /** Spanish (Spain) */
  EsEs = 'ES_ES',
  /** Persian (Iran) */
  FaIr = 'FA_IR',
  /** Filipino (Philippines) */
  FilPh = 'FIL_PH',
  /** Finnish (Finland) */
  FiFi = 'FI_FI',
  /** French (Canada) */
  FrCa = 'FR_CA',
  /** French (France) */
  FrFr = 'FR_FR',
  /** Hebrew (Israel) */
  HeIl = 'HE_IL',
  /** Hindi (India) */
  HiIn = 'HI_IN',
  /** Croatian (Croatia) */
  HrHr = 'HR_HR',
  /** Hungarian (Hungary) */
  HuHu = 'HU_HU',
  /** Indonesian (Indonesia) */
  IdId = 'ID_ID',
  /** Italian (Italy) */
  ItIt = 'IT_IT',
  /** Japanese (Japan) */
  JaJp = 'JA_JP',
  /** Kannada (India) */
  KnIn = 'KN_IN',
  /** Korean (Korea) */
  KoKr = 'KO_KR',
  /** Marathi (India) */
  MrIn = 'MR_IN',
  /** Malay (Malaysia) */
  MsMy = 'MS_MY',
  /**
   * Legacy multi-language token (Spanish and English). Wire-only for cached
   * clients; never stored and never sent to Retell.
   * @deprecated Use an explicit languages list instead. MULTI is accepted on legacy language input only during the migration window.
   */
  Multi = 'MULTI',
  /** Dutch (Belgium) */
  NlBe = 'NL_BE',
  /** Dutch (Netherlands) */
  NlNl = 'NL_NL',
  /** Norwegian (Norway) */
  NoNo = 'NO_NO',
  /** Polish (Poland) */
  PlPl = 'PL_PL',
  /** Portuguese (Brazil) */
  PtBr = 'PT_BR',
  /** Portuguese (Portugal) */
  PtPt = 'PT_PT',
  /** Romanian (Romania) */
  RoRo = 'RO_RO',
  /** Russian (Russia) */
  RuRu = 'RU_RU',
  /** Slovak (Slovakia) */
  SkSk = 'SK_SK',
  /** Slovenian (Slovenia) */
  SlSi = 'SL_SI',
  /** Swedish (Sweden) */
  SvSe = 'SV_SE',
  /** Tamil (India) */
  TaIn = 'TA_IN',
  /** Thai (Thailand) */
  ThTh = 'TH_TH',
  /** Turkish (Turkey) */
  TrTr = 'TR_TR',
  /** Ukrainian (Ukraine) */
  UkUa = 'UK_UA',
  /** Vietnamese (Vietnam) */
  ViVn = 'VI_VN',
  /** Cantonese (China) */
  YueCn = 'YUE_CN',
  /** Chinese (China) */
  ZhCn = 'ZH_CN'
}

/** Provider and language capabilities used to keep voice-agent settings valid. */
export type VoiceAgentLanguageSupport = {
  __typename?: 'VoiceAgentLanguageSupport';
  /**
   * English locales. Selecting only these does not yet narrow the language picker;
   * the agent still routes to Cartesia.
   */
  englishLanguages: Array<VoiceAgentLanguage>;
  providers: Array<VoiceProviderLanguageSupport>;
  voices: Array<VoiceAgentVoiceProviderSupport>;
};

/** SIP signaling for cold transfers. INVITE (default) or REFER. Warm transfers always use REFER. */
export enum VoiceAgentSipTransferMode {
  /** SIP INVITE (most common) */
  Invite = 'INVITE',
  /** SIP REFER */
  Refer = 'REFER'
}

/** Who starts the conversation - the AI agent or the user */
export enum VoiceAgentStartSpeaker {
  /** The AI agent speaks first */
  Agent = 'AGENT',
  /** The AI agent waits for the user to speak first */
  User = 'USER'
}

/** The state of a voice agent */
export enum VoiceAgentState {
  /** The voice agent is online and ready to receive calls */
  Active = 'ACTIVE'
}

/** The behavior of how Cara transfers calls */
export enum VoiceAgentTransferBehavior {
  /** Cara will transfer the call after attempting to handle the caller's request */
  AttemptHandling = 'ATTEMPT_HANDLING',
  /** Cara will transfer the call immediately */
  Immediate = 'IMMEDIATE'
}

/** The call types that a transfer directory entry can handle */
export enum VoiceAgentTransferCallType {
  Billing = 'BILLING',
  Cancellation = 'CANCELLATION',
  Claims = 'CLAIMS',
  Coi = 'COI',
  NewBusiness = 'NEW_BUSINESS',
  OtherServicing = 'OTHER_SERVICING'
}

/** Whether a transfer directory entry is an internal agency contact or an external party */
export enum VoiceAgentTransferDirectoryEntryType {
  /** An external party (e.g., carrier, vendor) */
  External = 'EXTERNAL',
  /** An internal agency staff member (e.g., agent, CSR) */
  Internal = 'INTERNAL'
}

/** An agency-defined line of business used to classify and route Voice 3.5 transfers. */
export type VoiceAgentTransferLineOfBusiness = {
  __typename?: 'VoiceAgentTransferLineOfBusiness';
  /** Short semantic definition used by the Retell classifier. */
  description: Scalars['String']['output'];
  /** Example caller phrases that identify this line of business. */
  examples: Array<Scalars['String']['output']>;
  /** Stable identifier used by directory entries and round-robin pools. */
  id: Scalars['String']['output'];
  /** User-facing name shown in settings and supplied to the Retell classifier. */
  label: Scalars['String']['output'];
};

/** Input for an agency-defined Voice 3.5 transfer line of business. */
export type VoiceAgentTransferLineOfBusinessInput = {
  /** Short semantic definition used by the Retell classifier. */
  description: Scalars['String']['input'];
  /** Example caller phrases that identify this line of business. */
  examples: Array<Scalars['String']['input']>;
  /** Stable identifier used by directory entries and round-robin pools. */
  id: Scalars['String']['input'];
  /** User-facing name shown in settings and supplied to the Retell classifier. */
  label: Scalars['String']['input'];
};

export enum VoiceAgentTransferTimeOffScheduleType {
  /** Recurring weekly schedule - pick days of the week (e.g., every Monday, every Tuesday-Wednesday) */
  DailyBreaks = 'DAILY_BREAKS',
  /** Specific date or date range (e.g., holiday, one-time closure) */
  ScheduledClosures = 'SCHEDULED_CLOSURES'
}

/** How Cara performs call transfers (maps to Retell TRANSFER_TYPE at runtime). */
export enum VoiceAgentTransferType {
  Agentic = 'AGENTIC',
  Cold = 'COLD',
  Warm = 'WARM'
}

/** Describes the reason why a voice agent was updated */
export enum VoiceAgentUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occurred to a voice agent */
export enum VoiceAgentUpdateType {
  /** The voice agent was created */
  CreateVoiceAgent = 'CREATE_VOICE_AGENT',
  /** The voice agent was updated */
  UpdateVoiceAgent = 'UPDATE_VOICE_AGENT'
}

/** Describes a particular version of a voice agent */
export type VoiceAgentVersion = {
  __typename?: 'VoiceAgentVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another voice agent version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous voice agent version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<VoiceAgentVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<VoiceAgentUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<VoiceAgentUpdateType>;
  /** The version number of this voice agent version */
  version: Scalars['Int64']['output'];
  /** The full voice agent object that includes all of the updates made in this version and all previous versions */
  voiceAgent: VoiceAgent;
};

/** The primary provider and custom-voice flag for a selectable Cara voice. */
export type VoiceAgentVoiceProviderSupport = {
  __typename?: 'VoiceAgentVoiceProviderSupport';
  custom: Scalars['Boolean']['output'];
  provider: VoiceProvider;
  voice: VoiceAgentConfigurationModelVoice;
};

/** Filter for the voiceAgents list query */
export type VoiceAgentsFilterInput = {
  /** Restrict results to agents with this call direction */
  direction?: InputMaybe<VoiceAgentDirection>;
};

/** A Retell text-to-speech provider used by voice agents. */
export enum VoiceProvider {
  Cartesia = 'CARTESIA',
  ElevenLabs = 'ELEVEN_LABS',
  Minimax = 'MINIMAX',
  Platform = 'PLATFORM'
}

/**
 * The languages available to a text-to-speech provider, plus preference metadata
 * used by the language picker and voice router.
 */
export type VoiceProviderLanguageSupport = {
  __typename?: 'VoiceProviderLanguageSupport';
  /**
   * Default voice to coerce to when the selected voice is not offered by this
   * provider (Grace for Cartesia, MiniMax Grace for MiniMax, Grace for ElevenLabs).
   */
  defaultVoice: VoiceAgentConfigurationModelVoice;
  languages: Array<VoiceAgentLanguage>;
  /**
   * Languages that prefer this provider when the full selection is covered by it.
   * Empty for providers that are not preferred for any language.
   */
  preferredLanguages: Array<VoiceAgentLanguage>;
  provider: VoiceProvider;
};

/**
 * A Word (.docx) document template stored for the agency. Separate from HTML document templates:
 * metadata and the template file only (no HTML body, styles, or headers/footers).
 */
export type WordDocumentTemplate = {
  __typename?: 'WordDocumentTemplate';
  /** The agency this Word document template is associated with */
  agency: Agency;
  /** The timestamp when this Word document template was archived (soft deleted) */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when this Word document template was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this Word document template */
  createdBy: AgencyUser;
  /** The description of the Word document template */
  description: Scalars['String']['output'];
  /** An error message describing why the template processing failed. Only set when state is FAILED. */
  error?: Maybe<Scalars['String']['output']>;
  /** Optional guidance for Cara when filling this template (included in workspace tool output for the model). */
  fillGuidance?: Maybe<Scalars['String']['output']>;
  /** The ID of the Word document template */
  id: Scalars['ID']['output'];
  /** The sections of the Word document template */
  sections: Array<WordDocumentTemplateSection>;
  /** The processing status of the Word document template. */
  state?: Maybe<WordDocumentTemplateState>;
  /** The Word (DOCX) template file */
  templateFile?: Maybe<File>;
  /** The title of the Word document template */
  title: Scalars['String']['output'];
  /** The timestamp when this Word document template was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this Word document template */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this Word document template. The first version in this list will be this version
   * (i.e. identical to the current Word document template), followed by the version before that, and so-forth.
   */
  versionHistory?: Maybe<Array<WordDocumentTemplateVersion>>;
  /**
   * The visibility configuration for this template (PRIVATE / SHARED / PUBLIC).
   * Lives on the parent row only — visibility is metadata, not part of the
   * versioned content. Defaults to PUBLIC for all rows on migration.
   */
  visibility: VisibilityConfig;
};

/**
 * Word document template info for agency library templates.
 * GET_CONTENT includes the DOCX file id and, when inspection succeeds, docxInspection (omitted on LIST).
 */
export type WordDocumentTemplateInfo = {
  __typename?: 'WordDocumentTemplateInfo';
  /** The timestamp when the template was created */
  createdAt: Scalars['Time']['output'];
  /** The user who created the template */
  createdBy: Scalars['String']['output'];
  /** The description of the template */
  description: Scalars['String']['output'];
  /** Optional operator guidance for filling this template (follow when present). */
  fillGuidance?: Maybe<Scalars['String']['output']>;
  /** The ID of the template */
  id: Scalars['String']['output'];
  /** The name of the template */
  name: Scalars['String']['output'];
  /** The sections of the template */
  sections: Array<WordDocumentTemplateSection>;
};

/** Input for creating or updating a Word document template */
export type WordDocumentTemplateInput = {
  /** The description of the Word document template */
  description: Scalars['String']['input'];
  /** Optional guidance for Cara when filling this template (shown when listing templates in workspace tools). */
  fillGuidance?: InputMaybe<Scalars['String']['input']>;
  /** The sections of the Word document template */
  sections: Array<WordDocumentTemplateSectionInput>;
  /**
   * The ID of the existing template file to keep on update. Omit when uploading a new file.
   * @deprecated Use the sections instead
   */
  templateFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the Word document template */
  title: Scalars['String']['input'];
  /**
   * The DOCX file to upload (create, or replace on update)
   * @deprecated Use the sections instead
   */
  uploadTemplate?: InputMaybe<Scalars['Upload']['input']>;
  /**
   * Optional visibility configuration. When omitted on create, the template
   * defaults to PUBLIC. When omitted on update, the existing visibility is
   * preserved.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

export type WordDocumentTemplateSection = {
  __typename?: 'WordDocumentTemplateSection';
  /** The data fields required to fill the section. These are extracted by the LLM in a pre-processing step. */
  fields: Array<WordDocumentTemplateSectionField>;
  /**
   * Description of the section's purpose and content, and any fill instructions to provide to the LLM. This is
   * extracted by the LLM in a pre-processing step.
   */
  fillGuidance: Scalars['String']['output'];
  /** The ID of the Word document template section */
  id: Scalars['ID']['output'];
  /** Indicates whether this section can be generated multiple times for the same document. */
  repeatable: Scalars['Boolean']['output'];
  /**
   * Indicates whether this section is required (i.e. must be included in every document generated
   * from this template). Optional sections may be omitted by the LLM based on the request context.
   */
  required: Scalars['Boolean']['output'];
  /**
   * Optional user-provided guidance supplied when the template is created/edited. It is fed to the LLM at
   * ingestion time to help it produce a more accurate fillGuidance for this section (e.g. clarifying which
   * placeholders matter, how rows repeat, or what boilerplate must be preserved).
   */
  setupGuidance?: Maybe<Scalars['String']['output']>;
  /** Indicates whether this section is static (i.e. not a dynamic section that is filled by the LLM) */
  static: Scalars['Boolean']['output'];
  /** The Word (DOCX) template file */
  templateFile: File;
  /** The title of this section */
  title: Scalars['String']['output'];
};

/** A data field present in a section to fill */
export type WordDocumentTemplateSectionField = {
  __typename?: 'WordDocumentTemplateSectionField';
  /** The fill guidance for the field */
  fillGuidance: Scalars['String']['output'];
  /** The name of the field */
  name: Scalars['String']['output'];
  /** The placeholder text for the corresponding fields */
  placeholder: Scalars['String']['output'];
};

/** Input for a section of a Word document template */
export type WordDocumentTemplateSectionInput = {
  /**
   * The ID of an existing section to update. Omit for newly added sections. When provided on
   * update, the backend matches this entry to the existing section with the same ID so that
   * pre-extracted metadata (fill guidance, fields) is preserved across reorders.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this section can be generated multiple times for the same document. */
  repeatable: Scalars['Boolean']['input'];
  /**
   * Indicates whether this section is required (i.e. must be included in every document generated
   * from this template). Optional sections may be omitted by the LLM based on the request context.
   */
  required: Scalars['Boolean']['input'];
  /**
   * Optional user-provided guidance fed to the LLM at ingestion time to help it produce a more accurate
   * fillGuidance for this section. Trimmed server-side; blank values are stored as null.
   */
  setupGuidance?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this section is static (i.e. not a dynamic section that is filled by the LLM) */
  static: Scalars['Boolean']['input'];
  /** The ID of the existing template file to keep on update. Omit when uploading a new file. */
  templateFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the section */
  title: Scalars['String']['input'];
  /** The DOCX file to upload (create, or replace on update) */
  uploadTemplate?: InputMaybe<Scalars['Upload']['input']>;
};

/** The processing status of a Word document template. */
export enum WordDocumentTemplateState {
  /** The template processing failed. See the error field for details. */
  Failed = 'FAILED',
  /** The template is being processed. */
  Processing = 'PROCESSING',
  /** The template is queued for processing. */
  Queued = 'QUEUED',
  /** The template has been processed and is ready to fill. */
  Ready = 'READY'
}

/** Describes the reason why a Word document template was updated */
export enum WordDocumentTemplateUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a Word document template */
export enum WordDocumentTemplateUpdateType {
  /** The Word document template was archived */
  ArchiveWordDocumentTemplate = 'ARCHIVE_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template was created */
  CreateWordDocumentTemplate = 'CREATE_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template processing finished */
  FinishProcessingWordDocumentTemplate = 'FINISH_PROCESSING_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template processing was started */
  StartProcessingWordDocumentTemplate = 'START_PROCESSING_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template was unarchived */
  UnarchiveWordDocumentTemplate = 'UNARCHIVE_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template was updated */
  UpdateWordDocumentTemplate = 'UPDATE_WORD_DOCUMENT_TEMPLATE'
}

/** Describes a particular version of a Word document template */
export type WordDocumentTemplateVersion = {
  __typename?: 'WordDocumentTemplateVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another Word document template version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous Word document template version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<WordDocumentTemplateVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<WordDocumentTemplateUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<WordDocumentTemplateUpdateType>;
  /** The version number of this Word document template version */
  version: Scalars['Int64']['output'];
  /** The full Word document template object that includes all of the updates made in this version and all previous versions */
  wordDocumentTemplate: WordDocumentTemplate;
};

/**
 * Filter for the wordDocumentTemplates list query. Wraps visibility filters
 * today; future filter dimensions (search, archived inclusion, etc.) can be
 * added here without breaking the query signature.
 */
export type WordDocumentTemplatesFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/**
 * An artifact produced by a task. Exactly one of `file` or `markdown` is
 * populated, matching the `type` discriminator.
 */
export type WorkflowArtifact = {
  __typename?: 'WorkflowArtifact';
  /** Populated when type is FILE */
  file?: Maybe<WorkflowArtifactFile>;
  /** Populated when type is MARKDOWN */
  markdown?: Maybe<WorkflowArtifactMarkdown>;
  /** The artifact name */
  name: Scalars['String']['output'];
  /** The type of this artifact */
  type: WorkflowArtifactType;
};

/** A file-based artifact stored in the file storage system */
export type WorkflowArtifactFile = {
  __typename?: 'WorkflowArtifactFile';
  /** The file ID in the file storage system */
  fileId: Scalars['String']['output'];
  /** The MIME type of the file */
  mimeType: Scalars['String']['output'];
  /** A download URL for the file */
  url?: Maybe<Scalars['String']['output']>;
};

/** Inline Markdown content produced by a task */
export type WorkflowArtifactMarkdown = {
  __typename?: 'WorkflowArtifactMarkdown';
  /** The Markdown content */
  content: Scalars['String']['output'];
};

/** The type of an artifact produced by a task */
export enum WorkflowArtifactType {
  /** A file stored in the file storage system */
  File = 'FILE',
  /** Markdown content stored inline */
  Markdown = 'MARKDOWN'
}

/** Describes the origin of a binding value within a workflow definition */
export type WorkflowBindingSource = {
  __typename?: 'WorkflowBindingSource';
  /** Optional dotted path to extract a sub-field from the resolved value */
  path?: Maybe<Scalars['String']['output']>;
  /** The output key from the upstream task (when type is TASK_OUTPUT) */
  sourceOutputKey?: Maybe<Scalars['String']['output']>;
  /** The upstream task's definition key (when type is TASK_OUTPUT) */
  sourceTaskKey?: Maybe<Scalars['String']['output']>;
  /** A literal JSON value (when type is STATIC) */
  staticValue?: Maybe<Scalars['JSON']['output']>;
  /** The source kind */
  type: WorkflowBindingSourceType;
  /** The schema key of the workflow-level input (when type is WORKFLOW_INPUT) */
  workflowInputKey?: Maybe<Scalars['String']['output']>;
};

/** Input for specifying a binding source when creating or updating a definition */
export type WorkflowBindingSourceInput = {
  /** Optional dotted path to extract a sub-field from the resolved value */
  path?: InputMaybe<Scalars['String']['input']>;
  /** The output key from the upstream task (required when type is TASK_OUTPUT) */
  sourceOutputKey?: InputMaybe<Scalars['String']['input']>;
  /** The upstream task's definition key (required when type is TASK_OUTPUT) */
  sourceTaskKey?: InputMaybe<Scalars['String']['input']>;
  /** A literal JSON value (required when type is STATIC) */
  staticValue?: InputMaybe<Scalars['JSON']['input']>;
  /** The source kind */
  type: WorkflowBindingSourceType;
  /** The schema key of the workflow-level input (required when type is WORKFLOW_INPUT) */
  workflowInputKey?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies where a task input value comes from in a workflow definition */
export enum WorkflowBindingSourceType {
  /** The value is a literal JSON value baked into the definition */
  Static = 'STATIC',
  /** The value comes from a specific upstream task's output */
  TaskOutput = 'TASK_OUTPUT',
  /** The value comes from a workflow-level input (e.g. uploaded documents) */
  WorkflowInput = 'WORKFLOW_INPUT'
}

/** A citation linking a claim in a task output to source evidence */
export type WorkflowCitation = {
  __typename?: 'WorkflowCitation';
  /** The excerpt from the source file */
  excerpt: Scalars['String']['output'];
  /** Unique identifier for the citation */
  id: Scalars['ID']['output'];
  /** The page number in the source file */
  pageNumber: Scalars['Int']['output'];
  /** The title of the section containing the citation */
  sectionTitle: Scalars['String']['output'];
  /** The source file that contains the cited evidence */
  sourceFileId: Scalars['String']['output'];
};

/**
 * A workflow definition is a reusable blueprint that declares which tasks
 * to run and how their inputs are wired. The UI builds these; at execution
 * time the definition is materialized into concrete tasks and dependency edges.
 */
export type WorkflowDefinition = {
  __typename?: 'WorkflowDefinition';
  /** When the definition was created */
  createdAt: Scalars['Time']['output'];
  /** Explains what this workflow does */
  description: Scalars['String']['output'];
  /** Unique identifier for the definition */
  id: Scalars['ID']['output'];
  /** The input slots this workflow expects at execution time */
  inputs: Array<WorkflowDefinitionInputSlot>;
  /** A human-readable name (e.g. 'Policy Comparison', 'Forms Audit') */
  label: Scalars['String']['output'];
  /** The tasks in this workflow and their input bindings */
  nodes: Array<WorkflowDefinitionNode>;
  /** When the definition was last updated */
  updatedAt: Scalars['Time']['output'];
  /** Monotonically increasing version number */
  version: Scalars['Int64']['output'];
};

/**
 * Declares a named input slot on a workflow definition. Slots describe the
 * values the workflow expects at execution time, how many of each kind are
 * allowed, and whether the slot fans out over multiple values.
 */
export type WorkflowDefinitionInputSlot = {
  __typename?: 'WorkflowDefinitionInputSlot';
  /** For FILE slots, the list of accepted MIME types (empty = any) */
  acceptedMimeTypes: Array<Scalars['String']['output']>;
  /** Explains what the slot is for */
  description: Scalars['String']['output'];
  /** Whether consumers can iterate (fan out) over this slot's values */
  enumerable: Scalars['Boolean']['output'];
  /** The schema key used to reference this slot from bindings */
  key: Scalars['String']['output'];
  /** The kind of value this slot accepts */
  kind: WorkflowInputSlotKind;
  /** A human-readable label for this slot */
  label: Scalars['String']['output'];
  /** Maximum number of values allowed (0 for unbounded) */
  maxCount: Scalars['Int']['output'];
  /** Minimum number of values required (defaults to 1) */
  minCount: Scalars['Int']['output'];
};

/** Input for declaring a workflow definition input slot in create/update mutations */
export type WorkflowDefinitionInputSlotInput = {
  /** For FILE slots, the list of accepted MIME types (empty = any) */
  acceptedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Explains what the slot is for */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether consumers can iterate (fan out) over this slot's values */
  enumerable?: Scalars['Boolean']['input'];
  /** The schema key used to reference this slot from bindings */
  key: Scalars['String']['input'];
  /** The kind of value this slot accepts */
  kind: WorkflowInputSlotKind;
  /** A human-readable label for this slot */
  label: Scalars['String']['input'];
  /** Maximum number of values allowed (0 for unbounded) */
  maxCount?: Scalars['Int']['input'];
  /** Minimum number of values required (defaults to 1) */
  minCount?: Scalars['Int']['input'];
};

/** A node in a workflow definition, representing one task and its input bindings */
export type WorkflowDefinitionNode = {
  __typename?: 'WorkflowDefinitionNode';
  /** How each input field is wired to a source */
  bindings: Array<WorkflowInputBinding>;
  /**
   * Static per-node configuration. Keys match the task's configSchema field keys.
   * Stored at definition-authoring time and materialized into the task at execution
   * time; not resolved through the binding system.
   */
  config?: Maybe<Scalars['JSON']['output']>;
  /** If set, this node runs once per element in the specified upstream list output */
  forEach?: Maybe<WorkflowForEach>;
  /** Which task definition this node runs */
  taskDefinitionKey: WorkflowTaskDefinitionKey;
};

/** Input for specifying a node when creating or updating a definition */
export type WorkflowDefinitionNodeInput = {
  /** How each input field is wired to a source */
  bindings: Array<WorkflowInputBindingInput>;
  /** Static per-node configuration (keys match the task's configSchema field keys) */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** If set, this node runs once per element in the specified upstream list output */
  forEach?: InputMaybe<WorkflowForEachInput>;
  /** Which task definition this node runs */
  taskDefinitionKey: WorkflowTaskDefinitionKey;
};

/**
 * A workflow execution represents a single run of a workflow definition.
 * Each execution contains a DAG of tasks, inputs, and outputs.
 */
export type WorkflowExecution = {
  __typename?: 'WorkflowExecution';
  /** Child workflow executions spawned from this one */
  childExecutions: Array<WorkflowExecution>;
  /** When the execution completed, failed, or was cancelled */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** When the execution was created */
  createdAt: Scalars['Time']['output'];
  /** The error that caused this execution to fail, if any */
  error?: Maybe<WorkflowExecutionError>;
  /** Unique identifier for the execution */
  id: Scalars['ID']['output'];
  /** The inputs provided to this execution */
  inputs: Array<WorkflowInput>;
  /** The final outputs produced by this execution */
  outputs: Array<WorkflowOutput>;
  /** The parent workflow execution that spawned this one, if any */
  parentExecution?: Maybe<WorkflowExecution>;
  /** The previous version number, if this execution was versioned from a prior run */
  prevVersion?: Maybe<Scalars['Int64']['output']>;
  /** When the execution started running */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The current state of the execution */
  state: WorkflowExecutionState;
  /** The tasks in this execution's DAG */
  tasks: Array<WorkflowTask>;
  /** When the execution was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version number of this execution */
  version: Scalars['Int64']['output'];
};

/** An error that occurred during workflow execution or task execution */
export type WorkflowExecutionError = {
  __typename?: 'WorkflowExecutionError';
  /** A machine-readable error code, if available */
  code?: Maybe<Scalars['String']['output']>;
  /** A human-readable error message */
  message: Scalars['String']['output'];
};

/** The state of a workflow execution */
export enum WorkflowExecutionState {
  /** The execution was cancelled */
  Cancelled = 'CANCELLED',
  /** The execution completed successfully */
  Completed = 'COMPLETED',
  /** The execution failed */
  Failed = 'FAILED',
  /** The execution is queued and has not yet started */
  Queued = 'QUEUED',
  /** The execution is currently running */
  Running = 'RUNNING'
}

/** A file provided as workflow input */
export type WorkflowFileInput = {
  __typename?: 'WorkflowFileInput';
  /** The file ID in the file storage system */
  fileId: Scalars['String']['output'];
  /** The MIME type of the file */
  mimeType: Scalars['String']['output'];
  /** The original file name */
  name: Scalars['String']['output'];
};

/**
 * Declares that a definition node iterates over an upstream list, creating N
 * task instances at runtime (one per element).
 *
 * The iteration source is exactly one of:
 *   - a task output (set `sourceTaskKey` + `sourceOutputKey`), or
 *   - a workflow input slot (set `sourceWorkflowInputKey`), which iterates over
 *     the N `WorkflowInput` records that share that schema key.
 */
export type WorkflowForEach = {
  __typename?: 'WorkflowForEach';
  /** The input key on this task that receives the individual element */
  inputKey: Scalars['String']['output'];
  /** The output key on the upstream task that contains the list (task-output source) */
  sourceOutputKey?: Maybe<Scalars['String']['output']>;
  /** The upstream task whose output drives the iteration (task-output source) */
  sourceTaskKey?: Maybe<Scalars['String']['output']>;
  /**
   * The workflow input slot whose records drive the iteration (workflow-input
   * source). The slot must be declared enumerable at authoring time.
   */
  sourceWorkflowInputKey?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for specifying a forEach iteration when creating or updating a definition.
 *
 * Exactly one of {sourceTaskKey+sourceOutputKey, sourceWorkflowInputKey} must be set.
 */
export type WorkflowForEachInput = {
  /** The input key on this task that receives the individual element */
  inputKey: Scalars['String']['input'];
  /** The output key on the upstream task that contains the list (task-output source) */
  sourceOutputKey?: InputMaybe<Scalars['String']['input']>;
  /** The upstream task whose output drives the iteration (task-output source) */
  sourceTaskKey?: InputMaybe<Scalars['String']['input']>;
  /** The workflow input slot whose records drive the iteration (workflow-input source) */
  sourceWorkflowInputKey?: InputMaybe<Scalars['String']['input']>;
};

/** A workflow input represents a value provided to a workflow execution at runtime */
export type WorkflowInput = {
  __typename?: 'WorkflowInput';
  /** When the input was created */
  createdAt: Scalars['Time']['output'];
  /** Whether this input represents an enumerable collection */
  enumerable: Scalars['Boolean']['output'];
  /** File input details, populated when type is FILE */
  file?: Maybe<WorkflowFileInput>;
  /** Unique identifier for the input */
  id: Scalars['ID']['output'];
  /** JSON input details, populated when type is JSON */
  json?: Maybe<WorkflowJsonInput>;
  /** A human-readable label for this input */
  label?: Maybe<Scalars['String']['output']>;
  /** The key used to reference this input in the workflow definition */
  schemaKey: Scalars['String']['output'];
  /** Text input details, populated when type is TEXT */
  text?: Maybe<WorkflowTextInput>;
  /** The type of this input */
  type: WorkflowInputType;
};

/**
 * Declares how one task input field gets its value in a workflow definition.
 * The workflow builder UI creates these; at execution time they are resolved
 * against the concrete workflow state.
 */
export type WorkflowInputBinding = {
  __typename?: 'WorkflowInputBinding';
  /** The task input field key this binding satisfies */
  inputKey: Scalars['String']['output'];
  /** Where the value comes from */
  source: WorkflowBindingSource;
};

/** Input for specifying an input binding when creating or updating a definition */
export type WorkflowInputBindingInput = {
  /** The task input field key this binding satisfies */
  inputKey: Scalars['String']['input'];
  /** Where the value comes from */
  source: WorkflowBindingSourceInput;
};

/** Classifies what kind of values a workflow input slot accepts */
export enum WorkflowInputSlotKind {
  /** A selection from an AMS/CRM integration (e.g. a specific account/policy) */
  AmsSelection = 'AMS_SELECTION',
  /** A file upload slot (documents, spreadsheets, images, etc.) */
  File = 'FILE',
  /** A structured JSON slot */
  Json = 'JSON',
  /** A text slot (single string) */
  Text = 'TEXT'
}

/** The type of a workflow input */
export enum WorkflowInputType {
  /** A file upload */
  File = 'FILE',
  /** A structured JSON value */
  Json = 'JSON',
  /** A text value */
  Text = 'TEXT'
}

/**
 * Classifies the runtime value kind that flows through a wf.Input slot.
 * Used by the binding picker to filter compatible sources.
 */
export enum WorkflowInputValueKind {
  /** A boolean */
  Bool = 'BOOL',
  /** A file reference (wf.FileRef) */
  File = 'FILE',
  /** A structured JSON object */
  Json = 'JSON',
  /** A list of values */
  List = 'LIST',
  /** A number */
  Number = 'NUMBER',
  /** A map/record (string keys → any values) */
  Record = 'RECORD',
  /** A text string */
  Text = 'TEXT'
}

/** A structured JSON value provided as workflow input */
export type WorkflowJsonInput = {
  __typename?: 'WorkflowJSONInput';
  /** The JSON data */
  data: Scalars['JSON']['output'];
  /** The JSON schema describing the shape of the data, if available */
  schema?: Maybe<Scalars['JSON']['output']>;
};

/** A structured JSON output with its schema */
export type WorkflowJsonOutput = {
  __typename?: 'WorkflowJSONOutput';
  /** The JSON data */
  data: Scalars['JSON']['output'];
  /** The JSON schema describing the shape of the data */
  schema?: Maybe<Scalars['JSON']['output']>;
};

/** A message event from a task */
export type WorkflowMessageEvent = {
  __typename?: 'WorkflowMessageEvent';
  /** The message content */
  content: Scalars['String']['output'];
  /** The message level */
  level: WorkflowMessageLevel;
};

/** The level of a message event */
export enum WorkflowMessageLevel {
  /** A debug message (non-user-facing) */
  Debug = 'DEBUG',
  /** An info message (user-facing) */
  Info = 'INFO'
}

/** A final output produced by a workflow execution */
export type WorkflowOutput = {
  __typename?: 'WorkflowOutput';
  /** File artifact, populated when type is ARTIFACT */
  artifact?: Maybe<WorkflowArtifact>;
  /** When the output was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the output */
  id: Scalars['ID']['output'];
  /** Structured JSON output, populated when type is JSON */
  json?: Maybe<WorkflowJsonOutput>;
  /** A human-readable label for this output */
  label: Scalars['String']['output'];
  /** The task outputs that contributed to this workflow output */
  sourceTaskOutputs: Array<WorkflowTaskOutput>;
  /** The task that produced this output */
  task?: Maybe<WorkflowTask>;
  /** Text content, populated when type is TEXT */
  text?: Maybe<Scalars['String']['output']>;
  /** The type of this output */
  type: WorkflowOutputType;
};

/** The type of a workflow output */
export enum WorkflowOutputType {
  /** A file artifact */
  Artifact = 'ARTIFACT',
  /** A structured JSON output */
  Json = 'JSON',
  /** A text output */
  Text = 'TEXT'
}

/** A progress update event from a task */
export type WorkflowProgressEvent = {
  __typename?: 'WorkflowProgressEvent';
  /** A description of the current progress */
  message: Scalars['String']['output'];
  /** Progress percentage, if available (0.0-1.0) */
  percent: Scalars['Float']['output'];
};

/** A retrieval event from a task */
export type WorkflowRetrievalEvent = {
  __typename?: 'WorkflowRetrievalEvent';
  /** The query used for retrieval */
  query: Scalars['String']['output'];
  /** The number of results retrieved */
  resultCount: Scalars['Int']['output'];
};

/** An event indicating a sub-agent was spawned */
export type WorkflowSpawnEvent = {
  __typename?: 'WorkflowSpawnEvent';
  /** A description of what the spawned agent will do */
  description: Scalars['String']['output'];
  /** The ID of the spawned agent or task */
  spawnedTaskId: Scalars['String']['output'];
};

/** A workflow task is a runtime instance of a task in the execution DAG */
export type WorkflowTask = {
  __typename?: 'WorkflowTask';
  /** When the task completed, failed, or was skipped */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** The configuration for the task */
  config: Scalars['JSON']['output'];
  /** When the task was created */
  createdAt: Scalars['Time']['output'];
  /** The definition key identifying which kind of task this is (used for registry lookup) */
  definitionKey: WorkflowTaskDefinitionKey;
  /** The tasks that this task depends on */
  dependencies: Array<WorkflowTask>;
  /** The tasks that depend on this task */
  dependents: Array<WorkflowTask>;
  /** The error that caused this task to fail, if any */
  error?: Maybe<WorkflowExecutionError>;
  /** The event stream for this task */
  events: Array<WorkflowTaskEvent>;
  /** The input key that receives per-element values in iterated tasks (null for non-iterated tasks) */
  forEachInputKey?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the task */
  id: Scalars['ID']['output'];
  /** The resolved inputs for this task */
  inputs: Array<WorkflowTaskInput>;
  /** The total number of iterations in this task's group (null for non-iterated tasks) */
  iterationCount?: Maybe<Scalars['Int']['output']>;
  /** Groups iterated instances by definition node key (null for non-iterated tasks) */
  iterationGroupKey?: Maybe<Scalars['String']['output']>;
  /** The iteration index within an iteration group (null for non-iterated tasks) */
  iterationIndex?: Maybe<Scalars['Int']['output']>;
  /** The latest attempt number for this task */
  latestAttempt: Scalars['Int']['output'];
  /** The outputs produced by this task */
  outputs: Array<WorkflowTaskOutput>;
  /** When the task started running */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The current state of the task */
  state: WorkflowTaskState;
  /** When the task was last updated */
  updatedAt: Scalars['Time']['output'];
};


/** A workflow task is a runtime instance of a task in the execution DAG */
export type WorkflowTaskEventsArgs = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Describes one configuration field of a task definition. Config fields are
 * resolved from the per-node config blob at execution time, not from bindings.
 */
export type WorkflowTaskConfigFieldDescriptor = {
  __typename?: 'WorkflowTaskConfigFieldDescriptor';
  /** An optional default value as JSON */
  default?: Maybe<Scalars['JSON']['output']>;
  /** Explains what this config field does */
  description: Scalars['String']['output'];
  /** Whether this config field accepts a list value */
  isList: Scalars['Boolean']['output'];
  /** The field key (matches the Go struct json tag) */
  key: Scalars['String']['output'];
  /** A human-readable name for this config field */
  label: Scalars['String']['output'];
  /** Whether this config field is required */
  required: Scalars['Boolean']['output'];
};

/**
 * A task definition describes an available task kind in the workflow system.
 * This is read-only metadata from the task registry, used by the UI to
 * build workflow definitions.
 */
export type WorkflowTaskDefinition = {
  __typename?: 'WorkflowTaskDefinition';
  /** The configuration fields this task accepts (stored at design time, not bound) */
  configSchema: Array<WorkflowTaskConfigFieldDescriptor>;
  /** Explains what this task does */
  description: Scalars['String']['output'];
  /** The input fields this task expects (data-flow slots; wired via bindings) */
  inputSchema: Array<WorkflowTaskInputFieldDescriptor>;
  /** The definition key (matches WorkflowTaskDefinitionKey enum) */
  key: WorkflowTaskDefinitionKey;
  /** A human-readable name for this task kind */
  label: Scalars['String']['output'];
  /** The output fields this task produces */
  outputSchema: Array<WorkflowTaskOutputFieldDescriptor>;
};

/**
 * The definition key identifying which kind of workflow task this is (e.g. document_classification, forms_analysis).
 * Used to look up metadata and executor in the task definition registry.
 */
export enum WorkflowTaskDefinitionKey {
  /** Aggregate upstream values (deterministic or LLM-driven) */
  Aggregate = 'AGGREGATE',
  /** Claims analysis */
  ClaimsAnalysis = 'CLAIMS_ANALYSIS',
  /** Compare two upstream values and report semantic differences */
  Compare = 'COMPARE',
  /** Coverage analysis */
  CoverageAnalysis = 'COVERAGE_ANALYSIS',
  /** Coverage enumeration */
  CoverageEnumeration = 'COVERAGE_ENUMERATION',
  /** Document classification (input processing) */
  DocumentClassification = 'DOCUMENT_CLASSIFICATION',
  /** Extract structured entities from input (config-driven) */
  Extract = 'EXTRACT',
  /** Forms analysis */
  FormsAnalysis = 'FORMS_ANALYSIS',
  /** Read records from an AMS/CRM integration */
  InputAmsRead = 'INPUT_AMS_READ',
  /** Document input processing (OCR, page splitting) */
  InputDocument = 'INPUT_DOCUMENT',
  /** JSON input processing (validation, passthrough) */
  InputJson = 'INPUT_JSON',
  /** Spreadsheet input processing (parses rows into structured objects) */
  InputSpreadsheet = 'INPUT_SPREADSHEET',
  /** Text input processing (passthrough, optional splitting) */
  InputText = 'INPUT_TEXT',
  /** Perform a web lookup / external search */
  InputWebLookup = 'INPUT_WEB_LOOKUP',
  /** Generate an output document (PDF, Word, Excel, CSV) */
  OutputDocument = 'OUTPUT_DOCUMENT',
  /** Output generation */
  OutputGeneration = 'OUTPUT_GENERATION',
  /** Write results into an external integration (AMS/CRM/etc.) */
  OutputIntegration = 'OUTPUT_INTEGRATION',
  /** Risk profile analysis */
  RiskProfile = 'RISK_PROFILE',
  /** Search space determination */
  SearchSpaceDetermination = 'SEARCH_SPACE_DETERMINATION',
  /** Verify an upstream value against a reference */
  Verify = 'VERIFY',
  /** WRS research */
  WrsResearch = 'WRS_RESEARCH'
}

/** An event emitted by a task during execution */
export type WorkflowTaskEvent = {
  __typename?: 'WorkflowTaskEvent';
  /** The attempt number this event was emitted during */
  attempt: Scalars['Int']['output'];
  /** When the event was emitted */
  createdAt: Scalars['Time']['output'];
  /** Error details, populated for ERROR events */
  error?: Maybe<WorkflowExecutionError>;
  /** Unique identifier for the event */
  id: Scalars['ID']['output'];
  /** Message content, populated for MESSAGE events */
  message?: Maybe<WorkflowMessageEvent>;
  /** Progress details, populated for PROGRESS events */
  progress?: Maybe<WorkflowProgressEvent>;
  /** Retrieval details, populated for RETRIEVAL events */
  retrieval?: Maybe<WorkflowRetrievalEvent>;
  /** The ordering of this event within its attempt */
  sequence: Scalars['Int']['output'];
  /** Spawn details, populated for AGENT_SPAWNED events */
  spawnEvent?: Maybe<WorkflowSpawnEvent>;
  /** Thinking content, populated for THINKING events */
  thinking?: Maybe<WorkflowThinkingEvent>;
  /** A human-readable summary of the event */
  title: Scalars['String']['output'];
  /** Tool call details, populated for TOOL_CALL events */
  toolCall?: Maybe<WorkflowToolCallEvent>;
  /** The type of event */
  type: WorkflowTaskEventType;
};

/** The type of a task event */
export enum WorkflowTaskEventType {
  /** A sub-agent completed */
  AgentCompleted = 'AGENT_COMPLETED',
  /** A sub-agent was spawned */
  AgentSpawned = 'AGENT_SPAWNED',
  /** An error occurred */
  Error = 'ERROR',
  /** A message from the task */
  Message = 'MESSAGE',
  /** An output is ready */
  OutputReady = 'OUTPUT_READY',
  /** A progress update */
  Progress = 'PROGRESS',
  /** The task is retrieving information */
  Retrieval = 'RETRIEVAL',
  /** The task is thinking or reasoning */
  Thinking = 'THINKING',
  /** The task is calling a tool */
  ToolCall = 'TOOL_CALL',
  /** A non-fatal warning */
  Warning = 'WARNING'
}

/** A resolved input for a workflow task, recording where the value came from */
export type WorkflowTaskInput = {
  __typename?: 'WorkflowTaskInput';
  /** When the task input was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the task input */
  id: Scalars['ID']['output'];
  /** The input key this binding satisfies (matches a struct field json tag) */
  key: Scalars['String']['output'];
  /** The task output that provided this value, if type is TASK_OUTPUT */
  taskOutput?: Maybe<WorkflowTaskOutput>;
  /** The source type of this input */
  type: WorkflowTaskInputSourceType;
  /** The workflow input that provided this value, if type is WORKFLOW_INPUT */
  workflowInput?: Maybe<WorkflowInput>;
};

/**
 * Describes one input field of a task definition. Used by the workflow builder
 * UI to show what a task needs and how each input should be wired.
 */
export type WorkflowTaskInputFieldDescriptor = {
  __typename?: 'WorkflowTaskInputFieldDescriptor';
  /**
   * The value kinds this input slot can accept. Empty means any kind is acceptable.
   * Only relevant for INPUT-kind fields; ignored for DATA, CONFIG, and FILE fields.
   */
  acceptedKinds: Array<WorkflowInputValueKind>;
  /**
   * Whether this input slot accepts multiple bindings (fan-in). When true, the
   * task receives a list even if only one binding is wired.
   * Only relevant for INPUT-kind fields that are declared as list slots.
   */
  acceptsMany: Scalars['Boolean']['output'];
  /** An optional default value as JSON */
  default?: Maybe<Scalars['JSON']['output']>;
  /** Explains what this input is for */
  description: Scalars['String']['output'];
  /** Classifies the input as data flow, configuration, or file */
  fieldKind: WorkflowTaskInputFieldKind;
  /** Whether the field accepts multiple values (list input) */
  isList: Scalars['Boolean']['output'];
  /** The field key (matches the Go struct json tag) */
  key: Scalars['String']['output'];
  /** A human-readable name for this input */
  label: Scalars['String']['output'];
  /** Whether this input must be bound for the task to run */
  required: Scalars['Boolean']['output'];
};

/** Classifies how a task input field gets its value */
export enum WorkflowTaskInputFieldKind {
  /** A workflow-level configuration value (e.g. output format, audience) */
  Config = 'CONFIG',
  /** An input that flows from an upstream task's output (data dependency) */
  Data = 'DATA',
  /** A file reference provided as workflow input */
  File = 'FILE',
  /** A polymorphic input slot that can accept any compatible kind (file, text, JSON, etc.) */
  Input = 'INPUT'
}

/** The source type of a task input */
export enum WorkflowTaskInputSourceType {
  /** The input came from an upstream task's output */
  TaskOutput = 'TASK_OUTPUT',
  /** The input came from a workflow-level input */
  WorkflowInput = 'WORKFLOW_INPUT'
}

/** An output produced by a workflow task */
export type WorkflowTaskOutput = {
  __typename?: 'WorkflowTaskOutput';
  /** File artifact, populated when type is ARTIFACT */
  artifact?: Maybe<WorkflowArtifact>;
  /** Citations supporting this output */
  citations: Array<WorkflowCitation>;
  /** When the output was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the task output */
  id: Scalars['ID']['output'];
  /** Structured JSON output, populated when type is JSON */
  json?: Maybe<WorkflowJsonOutput>;
  /** The output key under which this is stored in state (task-scoped: taskID:key) */
  key: Scalars['String']['output'];
  /** The ordering of this output within the task */
  sequence: Scalars['Int']['output'];
  /** Text content, populated when type is TEXT */
  text?: Maybe<Scalars['String']['output']>;
  /** The type of this output */
  type: WorkflowTaskOutputType;
};

/**
 * Describes one output field of a task definition. Used by the workflow builder
 * to show what outputs are available for downstream binding.
 */
export type WorkflowTaskOutputFieldDescriptor = {
  __typename?: 'WorkflowTaskOutputFieldDescriptor';
  /** If set, this list output has 1:1 correspondence with the named input field */
  correlatesWithInput?: Maybe<Scalars['String']['output']>;
  /** Explains what this output contains */
  description: Scalars['String']['output'];
  /** Whether this output is a workflow-level artifact (e.g. a generated report) */
  isArtifact: Scalars['Boolean']['output'];
  /** Whether this output field is a list */
  isList: Scalars['Boolean']['output'];
  /** The field key (matches the Go struct json tag) */
  key: Scalars['String']['output'];
  /** A human-readable name for this output */
  label: Scalars['String']['output'];
};

/** The type of a task output */
export enum WorkflowTaskOutputType {
  /** A file artifact */
  Artifact = 'ARTIFACT',
  /** A structured JSON output */
  Json = 'JSON',
  /** A text output */
  Text = 'TEXT'
}

/** The state of a workflow task */
export enum WorkflowTaskState {
  /** The task completed successfully */
  Completed = 'COMPLETED',
  /** The task failed */
  Failed = 'FAILED',
  /** The task is waiting for its dependencies to complete */
  Pending = 'PENDING',
  /** The task is currently running */
  Running = 'RUNNING',
  /** The task was skipped because a dependency failed or a condition was not met */
  Skipped = 'SKIPPED',
  /** The task is a placeholder waiting for fan-out expansion */
  WaitingForFanout = 'WAITING_FOR_FANOUT'
}

/** A text value provided as workflow input */
export type WorkflowTextInput = {
  __typename?: 'WorkflowTextInput';
  /** The text content */
  data: Scalars['String']['output'];
};

/** A thinking/reasoning event from a task */
export type WorkflowThinkingEvent = {
  __typename?: 'WorkflowThinkingEvent';
  /** The thinking content */
  content: Scalars['String']['output'];
};

/** A tool call event from a task */
export type WorkflowToolCallEvent = {
  __typename?: 'WorkflowToolCallEvent';
  /** The input to the tool */
  input?: Maybe<Scalars['JSON']['output']>;
  /** The output from the tool, if completed */
  output?: Maybe<Scalars['JSON']['output']>;
  /** The name of the tool being called */
  toolName: Scalars['String']['output'];
};

/** Workspace success and error counts for a single calendar day */
export type WorkspaceDailyCount = {
  __typename?: 'WorkspaceDailyCount';
  /** The calendar date these counts apply to (UTC midnight) */
  date: Scalars['Time']['output'];
  /** Number of workspaces that ended in an error state on this date */
  errorCount: Scalars['Int']['output'];
  /** Number of workspaces that completed successfully on this date */
  successCount: Scalars['Int']['output'];
};

/** Performance metrics for a single workspace preset within a filter window */
export type WorkspacePresetStat = {
  __typename?: 'WorkspacePresetStat';
  /** Total number of workspaces using this preset in the filter window */
  count: Scalars['Int']['output'];
  /** Fraction of workspaces using this preset that ended in an error state (0.0–1.0) */
  errorRate: Scalars['Float']['output'];
  /** Median (p50) workspace duration in milliseconds */
  medianDurationMs: Scalars['Int']['output'];
  /** 95th-percentile workspace duration in milliseconds */
  p95DurationMs: Scalars['Int']['output'];
  /** The preset these metrics apply to */
  preset: CaraWorkspacePreset;
};

/** Aggregated analytics for workspaces matching a given filter window */
export type WorkspaceReport = {
  __typename?: 'WorkspaceReport';
  /** Number of workspaces currently in an active (non-terminal) state */
  activeCount: Scalars['Int']['output'];
  /** Number of workspaces that reached a terminal state today */
  completedTodayCount: Scalars['Int']['output'];
  /** Workspace success and error counts grouped by day for the filter window */
  dailyCounts: Array<WorkspaceDailyCount>;
  /** Fraction of workspaces that ended in an error state (0.0–1.0) */
  errorRate: Scalars['Float']['output'];
  /** Per-preset performance breakdown for the filter window */
  presetStats: Array<WorkspacePresetStat>;
  /** Aggregated tool call failures across all workspaces in the filter window */
  toolCallFailures: Array<WorkspaceToolCallFailure>;
  /** Total number of workspaces created in the filter window */
  totalCount: Scalars['Int']['output'];
};

/** Filter parameters for workspace analytics reports */
export type WorkspaceReportFilter = {
  /** Restrict results to a single agency; omit to aggregate across all agencies */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** End of the reporting window (inclusive); defaults to now when omitted */
  endDate?: InputMaybe<Scalars['Time']['input']>;
  /** Restrict results to workspaces using this preset */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** Start of the reporting window (inclusive); defaults to 30 days ago when omitted */
  startDate?: InputMaybe<Scalars['Time']['input']>;
};

/** Aggregated failure statistics for a single tool across all workspaces in the filter window */
export type WorkspaceToolCallFailure = {
  __typename?: 'WorkspaceToolCallFailure';
  /** Absolute number of failed calls to this tool in the filter window */
  failureCount: Scalars['Int']['output'];
  /** Fraction of all calls to this tool that failed (0.0–1.0) */
  failureRate: Scalars['Float']['output'];
  /** The most frequently occurring error message for this tool, truncated to 80 characters */
  mostCommonError: Scalars['String']['output'];
  /** The name of the tool that failed, as recorded in the plan stage event data */
  toolName: Scalars['String']['output'];
};

/**
 * Represents a tool for writing to an integration.
 * Used when the LLM needs to write to an integration.
 */
export type WriteIntegrationTool = {
  __typename?: 'WriteIntegrationTool';
  /** The input arguments for the integration write */
  input: WriteIntegrationToolInput;
  /** The result of the integration write operation */
  output: WriteIntegrationToolOutput;
};

export type WriteIntegrationToolAccount = {
  __typename?: 'WriteIntegrationToolAccount';
  accountType: Scalars['String']['output'];
  address: Address;
  businessName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type WriteIntegrationToolCreateNoteInput = {
  __typename?: 'WriteIntegrationToolCreateNoteInput';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WriteIntegrationToolCreateTaskInput = {
  __typename?: 'WriteIntegrationToolCreateTaskInput';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Input arguments for the WriteIntegrationTool. */
export type WriteIntegrationToolInput = {
  __typename?: 'WriteIntegrationToolInput';
  account: WriteIntegrationToolAccount;
  /**
   * The type of entity to write. This must be one of the following values:
   * - CREATE_NOTE
   * - CREATE_TASK
   * - UPLOAD_DOCUMENT
   * - UPSERT_ACCOUNT
   */
  action: Scalars['String']['output'];
  agentName: Scalars['String']['output'];
  createNote?: Maybe<WriteIntegrationToolCreateNoteInput>;
  createTask?: Maybe<WriteIntegrationToolCreateTaskInput>;
  uploadDocument?: Maybe<WriteIntegrationToolUploadDocumentInput>;
};

export type WriteIntegrationToolOutput = {
  __typename?: 'WriteIntegrationToolOutput';
  /** The ID of the entity that was created or updated */
  id: Scalars['String']['output'];
  /** The message from the integration write operation */
  message: Scalars['String']['output'];
  /** The result of the integration write operation */
  success: Scalars['Boolean']['output'];
};

export type WriteIntegrationToolUploadDocumentInput = {
  __typename?: 'WriteIntegrationToolUploadDocumentInput';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

/**
 * Represents a tool for creating, editing, and filling Excel (.xlsx) workbooks —
 * ad-hoc from scratch, from a user-uploaded file, or from an agency spreadsheet template.
 */
export type XlsxEditorTool = {
  __typename?: 'XlsxEditorTool';
  /** The input arguments for the workbook create, edit, fill, or inspect */
  input: XlsxEditorToolInput;
  /** The result of the workbook operation */
  output: XlsxEditorToolOutput;
};

/**
 * Input arguments for the ADD_TAB operation of the XlsxEditorTool.
 * Restores one previously-omitted or deleted optional template tab into the delivered workbook.
 */
export type XlsxEditorToolAddTabInput = {
  __typename?: 'XlsxEditorToolAddTabInput';
  /** The ID of the workbook artifact */
  artifactId: Scalars['String']['output'];
  /** Optional requirements when filling or re-editing the restored tab */
  requirements?: Maybe<Scalars['String']['output']>;
  /** The template tab ID to restore */
  tabId: Scalars['String']['output'];
};

/** Input arguments for the CREATE_FROM_TEMPLATE operation of the XlsxEditorTool. */
export type XlsxEditorToolCreateFromTemplateInput = {
  __typename?: 'XlsxEditorToolCreateFromTemplateInput';
  /** The requirements for each tab to fill */
  tabs: Array<XlsxEditorToolTabInput>;
  /** The template ID */
  templateId: Scalars['String']['output'];
};

/**
 * Input arguments for the CREATE operation of the XlsxEditorTool.
 * Creates a new ad-hoc Excel workbook from scratch.
 */
export type XlsxEditorToolCreateInput = {
  __typename?: 'XlsxEditorToolCreateInput';
  /** The requirements for the workbook */
  requirements: Scalars['String']['output'];
};

/**
 * Input arguments for the DELETE_TAB operation of the XlsxEditorTool.
 * Removes one optional template tab from the delivered workbook while retaining it in the working workbook for later restoration.
 */
export type XlsxEditorToolDeleteTabInput = {
  __typename?: 'XlsxEditorToolDeleteTabInput';
  /** The ID of the workbook artifact */
  artifactId: Scalars['String']['output'];
  /** The template tab ID to remove from delivery */
  tabId: Scalars['String']['output'];
};

/**
 * Input arguments for the EDIT operation of the XlsxEditorTool.
 * Edits an existing ad-hoc or upload-derived workbook artifact. Template-provenance artifacts must use EDIT_TAB instead.
 */
export type XlsxEditorToolEditInput = {
  __typename?: 'XlsxEditorToolEditInput';
  /** The ID of the artifact to edit */
  artifactId: Scalars['String']['output'];
  /** The requirements for the edit */
  requirements: Scalars['String']['output'];
  /** Optional override of the source file used as the edit base */
  sourceFileId?: Maybe<Scalars['String']['output']>;
};

/** Input arguments for the EDIT_TAB operation of the XlsxEditorTool. */
export type XlsxEditorToolEditTabInput = {
  __typename?: 'XlsxEditorToolEditTabInput';
  /** The ID of the workbook artifact to edit */
  artifactId: Scalars['String']['output'];
  /** The tabs to edit */
  tabs: Array<XlsxEditorToolTabInput>;
};

/**
 * Input arguments for the EDIT_UPLOADED operation of the XlsxEditorTool.
 * Creates a new artifact by editing a user-uploaded XLSX; the uploaded source file is not modified.
 */
export type XlsxEditorToolEditUploadedInput = {
  __typename?: 'XlsxEditorToolEditUploadedInput';
  /** The requirements for the edit */
  requirements: Scalars['String']['output'];
  /** The ID of the uploaded source file */
  sourceFileId: Scalars['String']['output'];
};

/**
 * Input arguments for the XlsxEditorTool.
 * Carries the operation plus exactly one operation-specific payload.
 */
export type XlsxEditorToolInput = {
  __typename?: 'XlsxEditorToolInput';
  /** The input for the ADD_TAB operation */
  addTab?: Maybe<XlsxEditorToolAddTabInput>;
  /** The input for the CREATE operation */
  create?: Maybe<XlsxEditorToolCreateInput>;
  /** The input for the CREATE_FROM_TEMPLATE operation */
  createFromTemplate?: Maybe<XlsxEditorToolCreateFromTemplateInput>;
  /** The input for the DELETE_TAB operation */
  deleteTab?: Maybe<XlsxEditorToolDeleteTabInput>;
  /** The input for the EDIT operation */
  edit?: Maybe<XlsxEditorToolEditInput>;
  /** The input for the EDIT_TAB operation */
  editTab?: Maybe<XlsxEditorToolEditTabInput>;
  /** The input for the EDIT_UPLOADED operation */
  editUploaded?: Maybe<XlsxEditorToolEditUploadedInput>;
  /** The input for the INSPECT_ARTIFACT operation */
  inspectArtifact?: Maybe<XlsxEditorToolInspectArtifactInput>;
  /** The operation to perform */
  operation: Scalars['String']['output'];
  /** Short human-readable label for this operation shown in the workspace timeline and artifact cards. */
  title: Scalars['String']['output'];
};

/** Input arguments for the INSPECT_ARTIFACT operation of the XlsxEditorTool. */
export type XlsxEditorToolInspectArtifactInput = {
  __typename?: 'XlsxEditorToolInspectArtifactInput';
  /** The ID of the artifact to inspect */
  artifactId: Scalars['String']['output'];
};

/** Result of an XlsxEditorTool operation. */
export type XlsxEditorToolOutput = {
  __typename?: 'XlsxEditorToolOutput';
  /** The ID of the workbook artifact that was created or updated */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** Any remarks or instructions for subsequent operations on this file */
  remarks?: Maybe<Scalars['String']['output']>;
  /** The standard error from the Python script execution */
  stderr?: Maybe<Scalars['String']['output']>;
  /** The standard output from the Python script execution */
  stdout?: Maybe<Scalars['String']['output']>;
  /** Whether the Python script executed successfully. Present for whole-workbook CREATE / EDIT / EDIT_UPLOADED. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** A description of the tabs that were filled or edited. Present for template operations. */
  tabs?: Maybe<Array<XlsxEditorToolTabOutput>>;
  /** Any validation warnings or errors */
  validationMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the generated file passed validation */
  validationPassed?: Maybe<Scalars['Boolean']['output']>;
  /** The version of the artifact */
  version?: Maybe<Scalars['Int']['output']>;
  /**
   * Recoverable validation notes. A tab named here was skipped (unknown, static,
   * empty requirements) or a required tab was omitted — the workbook was still
   * produced from the tabs that were filled. Follow up with EDIT_TAB when a
   * required tab is listed here. Also used for idempotent ADD_TAB / DELETE_TAB no-ops.
   */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
  /** Structured XLSX inspection of the workbook when requested by INSPECT_ARTIFACT. */
  xlsxInspection?: Maybe<Scalars['String']['output']>;
};

/** One tab's fill or edit instructions within an XlsxEditorTool call. */
export type XlsxEditorToolTabInput = {
  __typename?: 'XlsxEditorToolTabInput';
  /** The requirements for this tab */
  requirements: Scalars['String']['output'];
  /** The template tab ID */
  tabId: Scalars['String']['output'];
};

/** Output for one tab of an XlsxEditorTool operation. */
export type XlsxEditorToolTabOutput = {
  __typename?: 'XlsxEditorToolTabOutput';
  /** A summary of what was written to the worksheet, produced by the fill step */
  description?: Maybe<Scalars['String']['output']>;
  /** The worksheet name */
  name: Scalars['String']['output'];
  /**
   * Anything the fill program reported it could not place on this worksheet. Empty when the
   * program placed every value it was given.
   */
  notes?: Maybe<Scalars['String']['output']>;
  /** The ID of the template tab this worksheet was filled from */
  templateTabId: Scalars['String']['output'];
};

export type ZapierAccountFields = {
  __typename?: 'ZapierAccountFields';
  address?: Maybe<ZapierAddressFields>;
  businessName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ZapierAddressFields = {
  __typename?: 'ZapierAddressFields';
  city?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** ZapierConfiguration contains configuration for the Zapier integration */
export type ZapierConfiguration = {
  __typename?: 'ZapierConfiguration';
  /** API key for Zapier integration */
  apiKey: Scalars['String']['output'];
  /** Subscriptions to Zapier webhooks */
  subscriptions: Array<ZapierSubscription>;
};

export type ZapierDocumentFields = {
  __typename?: 'ZapierDocumentFields';
  email?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** ZapierEventType defines the types of events that can trigger a Zapier webhook. */
export enum ZapierEventType {
  /** Triggered when an account is created or updated. */
  AccountCreateOrUpdate = 'ACCOUNT_CREATE_OR_UPDATE',
  /** Triggered when a call is created. */
  CallCreate = 'CALL_CREATE',
  /** Triggered when a document is uploaded. */
  DocumentUpload = 'DOCUMENT_UPLOAD',
  /** Triggered when a note is created. */
  NoteCreate = 'NOTE_CREATE',
  /** Triggered when a task is created. */
  TaskCreate = 'TASK_CREATE'
}

export type ZapierNoteFields = {
  __typename?: 'ZapierNoteFields';
  body?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** ZapierSubscription defines a subscription to a Zapier webhook. */
export type ZapierSubscription = {
  __typename?: 'ZapierSubscription';
  /** Zapier event type */
  eventType: ZapierEventType;
  /** Zapier hook URL */
  hookUrl: Scalars['String']['output'];
};

export type ZapierTaskFields = {
  __typename?: 'ZapierTaskFields';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a tool for pushing data to Zapier webhooks (notes/tasks/accounts/documents). */
export type ZapierWriteTool = {
  __typename?: 'ZapierWriteTool';
  input: ZapierWriteToolInput;
  output: ZapierWriteToolOutput;
};

export type ZapierWriteToolInput = {
  __typename?: 'ZapierWriteToolInput';
  account?: Maybe<ZapierAccountFields>;
  document?: Maybe<ZapierDocumentFields>;
  note?: Maybe<ZapierNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  task?: Maybe<ZapierTaskFields>;
};

export type ZapierWriteToolOutput = {
  __typename?: 'ZapierWriteToolOutput';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AccountUserFieldsFragment = { __typename?: 'AccountUser', id: string, email: string, name: string, accounts: Array<{ __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } }> };

export type GetAccountUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountUserQuery = { __typename?: 'Query', accountUser?: { __typename?: 'AccountUser', id: string, email: string, name: string, accounts: Array<{ __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } }> } | null | undefined };

export type AccountFieldsFragment = { __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } };

export type AccountAgencyFieldsFragment = { __typename?: 'Account', agency: { __typename?: 'Agency', name: string } };

export type AccountBusinessPolicyFieldsFragment = { __typename?: 'Account', businessPolicies: Array<{ __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, market: InsuranceMarket, policyNumber: string, quoteNumber: string, state: PolicyState, type: InsuranceType, broker?: { __typename?: 'InsuranceCarrier', id: string, name: string } | null | undefined, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string }, pricing: { __typename?: 'BusinessPolicyPricing', billingType: BusinessPolicyBillingType, premium: number, agencyFees: number, brokerFees: number, policyFees: number, otherFees: number, taxes: number, total: number, intervalType?: PaymentIntervalType | null | undefined, estimatedCommission: number } }> };

export type AccountBusinessPolicyDetailFieldsFragment = { __typename?: 'Account', businessPolicies: Array<{ __typename?: 'BusinessPolicy', details?: { __typename?: 'BusinessPolicyExtractedDetails', deductible?: number | null | undefined, policyNumber?: string | null | undefined, summary?: string | null | undefined, blanketAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyBlanketAdditionalInsured', type: string, description: string }>, carrier?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, coverageDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, exclusionDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, extraLimits: Array<{ __typename?: 'BusinessPolicyExtraInsuranceLimit', limit: number, name: string }>, insured?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined }, locations: Array<{ __typename?: 'BusinessPolicyLocation', address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string }, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined } }>, namedAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyNamedAdditionalInsured', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }> } | null | undefined }> };

export type AccountCertificateOfLiabilityInsuranceFieldsFragment = { __typename?: 'Account', certificatesOfLiabilityInsurance: Array<{ __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } }> };

export type AccountServiceRequestFieldsFragment = { __typename?: 'Account', serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, details: string, closedAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined }> };

export type GetAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } }> };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }, agency: { __typename?: 'Agency', name: string }, businessPolicies: Array<{ __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, market: InsuranceMarket, policyNumber: string, quoteNumber: string, state: PolicyState, type: InsuranceType, broker?: { __typename?: 'InsuranceCarrier', id: string, name: string } | null | undefined, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string }, pricing: { __typename?: 'BusinessPolicyPricing', billingType: BusinessPolicyBillingType, premium: number, agencyFees: number, brokerFees: number, policyFees: number, otherFees: number, taxes: number, total: number, intervalType?: PaymentIntervalType | null | undefined, estimatedCommission: number }, details?: { __typename?: 'BusinessPolicyExtractedDetails', deductible?: number | null | undefined, policyNumber?: string | null | undefined, summary?: string | null | undefined, blanketAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyBlanketAdditionalInsured', type: string, description: string }>, carrier?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, coverageDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, exclusionDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, extraLimits: Array<{ __typename?: 'BusinessPolicyExtraInsuranceLimit', limit: number, name: string }>, insured?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined }, locations: Array<{ __typename?: 'BusinessPolicyLocation', address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string }, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined } }>, namedAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyNamedAdditionalInsured', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }> } | null | undefined }>, certificatesOfLiabilityInsurance: Array<{ __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } }>, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, details: string, closedAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined }> } | null | undefined };

export type AccountUserSignInFieldsFragment = { __typename?: 'AccountUserSignInResponse', accountUser: { __typename?: 'AccountUser', id: string, email: string, name: string } };

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SignInMutation = { __typename?: 'Mutation', accountUserSignIn?: { __typename?: 'AccountUserSignInResponse', accountUser: { __typename?: 'AccountUser', id: string, email: string, name: string } } | null | undefined };

export type SignInCompleteMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type SignInCompleteMutation = { __typename?: 'Mutation', accountUserSignIn?: { __typename?: 'AccountUserSignInResponse', accountUser: { __typename?: 'AccountUser', id: string, email: string, name: string } } | null | undefined };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', accountUserSignOut: boolean };

export type BusinessPolicyDetailFieldsFragment = { __typename?: 'BusinessPolicy', details?: { __typename?: 'BusinessPolicyExtractedDetails', deductible?: number | null | undefined, policyNumber?: string | null | undefined, summary?: string | null | undefined, blanketAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyBlanketAdditionalInsured', type: string, description: string }>, carrier?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, coverageDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, exclusionDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, extraLimits: Array<{ __typename?: 'BusinessPolicyExtraInsuranceLimit', limit: number, name: string }>, insured?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined }, locations: Array<{ __typename?: 'BusinessPolicyLocation', address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string }, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined } }>, namedAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyNamedAdditionalInsured', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }> } | null | undefined };

export type BusinessPolicyFileFieldsFragment = { __typename?: 'BusinessPolicy', files: Array<{ __typename?: 'File', createdAt: Date, id: string, mimeType: string, name: string, notes: string, type: FileType, url?: string | null | undefined }> };

export type BusinessPolicyFieldsFragment = { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, market: InsuranceMarket, policyNumber: string, quoteNumber: string, state: PolicyState, type: InsuranceType, broker?: { __typename?: 'InsuranceCarrier', id: string, name: string } | null | undefined, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string }, pricing: { __typename?: 'BusinessPolicyPricing', billingType: BusinessPolicyBillingType, premium: number, agencyFees: number, brokerFees: number, policyFees: number, otherFees: number, taxes: number, total: number, intervalType?: PaymentIntervalType | null | undefined, estimatedCommission: number } };

export type GetBusinessPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessPoliciesQuery = { __typename?: 'Query', businessPolicies: Array<{ __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, market: InsuranceMarket, policyNumber: string, quoteNumber: string, state: PolicyState, type: InsuranceType, broker?: { __typename?: 'InsuranceCarrier', id: string, name: string } | null | undefined, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string }, pricing: { __typename?: 'BusinessPolicyPricing', billingType: BusinessPolicyBillingType, premium: number, agencyFees: number, brokerFees: number, policyFees: number, otherFees: number, taxes: number, total: number, intervalType?: PaymentIntervalType | null | undefined, estimatedCommission: number } }> };

export type GetBusinessPolicyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBusinessPolicyQuery = { __typename?: 'Query', businessPolicy?: { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, market: InsuranceMarket, policyNumber: string, quoteNumber: string, state: PolicyState, type: InsuranceType, broker?: { __typename?: 'InsuranceCarrier', id: string, name: string } | null | undefined, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string }, pricing: { __typename?: 'BusinessPolicyPricing', billingType: BusinessPolicyBillingType, premium: number, agencyFees: number, brokerFees: number, policyFees: number, otherFees: number, taxes: number, total: number, intervalType?: PaymentIntervalType | null | undefined, estimatedCommission: number }, details?: { __typename?: 'BusinessPolicyExtractedDetails', deductible?: number | null | undefined, policyNumber?: string | null | undefined, summary?: string | null | undefined, blanketAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyBlanketAdditionalInsured', type: string, description: string }>, carrier?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, coverageDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, exclusionDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, extraLimits: Array<{ __typename?: 'BusinessPolicyExtraInsuranceLimit', limit: number, name: string }>, insured?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined }, locations: Array<{ __typename?: 'BusinessPolicyLocation', address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string }, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined } }>, namedAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyNamedAdditionalInsured', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }> } | null | undefined, files: Array<{ __typename?: 'File', createdAt: Date, id: string, mimeType: string, name: string, notes: string, type: FileType, url?: string | null | undefined }> } | null | undefined };

export type CertificateOfLiabilityInsuranceFieldsFragment = { __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } };

export type CreateCertificateOptionsFieldsFragment = { __typename?: 'CreateCertificateOptions', allowedBlanketAdditionalInsureds: Array<{ __typename?: 'BlanketAdditionalInsuredCertificateOption', id: string, type: string, description: string, policy: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } }>, allowedNamedAdditionalInsureds: Array<{ __typename?: 'NamedAdditionalInsuredCertificateOption', id: string, name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string }, policy: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } }> };

export type GetCertificateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCertificateQuery = { __typename?: 'Query', certificate?: { __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } } | null | undefined };

export type GetCreateCertificateOptionsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetCreateCertificateOptionsQuery = { __typename?: 'Query', createCertificateOptions?: { __typename?: 'CreateCertificateOptions', allowedBlanketAdditionalInsureds: Array<{ __typename?: 'BlanketAdditionalInsuredCertificateOption', id: string, type: string, description: string, policy: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } }>, allowedNamedAdditionalInsureds: Array<{ __typename?: 'NamedAdditionalInsuredCertificateOption', id: string, name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string }, policy: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } }> } | null | undefined };

export type ClientCreateCertificateMutationVariables = Exact<{
  input: ClientCreateCertificateInput;
  accountId: Scalars['ID']['input'];
}>;


export type ClientCreateCertificateMutation = { __typename?: 'Mutation', clientCreateCertificate?: { __typename?: 'ClientCreateCertificateResult', code: ClientCreateCertificateResultCode, certificate?: { __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } } | null | undefined, serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, details: string, closedAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined } | null | undefined } | null | undefined };

export type FileFieldsFragment = { __typename?: 'File', createdAt: Date, id: string, mimeType: string, name: string, notes: string, type: FileType, url?: string | null | undefined };

export type ServiceRequestFieldsFragment = { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, details: string, closedAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined };

export type GetServiceRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetServiceRequestQuery = { __typename?: 'Query', serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, details: string, closedAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined } | null | undefined };

export type CreateServiceRequestMutationVariables = Exact<{
  input: CreateServiceRequestInput;
}>;


export type CreateServiceRequestMutation = { __typename?: 'Mutation', createServiceRequest: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, details: string, closedAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined } };

export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on Account {
  account {
    email
    mailingAddress {
      line1
      line2
      city
      zone
      postalCode
    }
    name
    phone
    ... on BusinessAccount {
      dba
      website
    }
  }
  createdAt
  id
  type
}
    `;
export const AccountUserFieldsFragmentDoc = gql`
    fragment AccountUserFields on AccountUser {
  id
  email
  name
  accounts {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;
export const AccountAgencyFieldsFragmentDoc = gql`
    fragment AccountAgencyFields on Account {
  agency {
    name
  }
}
    `;
export const BusinessPolicyFieldsFragmentDoc = gql`
    fragment BusinessPolicyFields on BusinessPolicy {
  broker {
    id
    name
  }
  carrier {
    id
    name
  }
  expiresAt
  id
  inforceAt
  issuedAt
  market
  policyNumber
  pricing {
    billingType
    premium
    agencyFees
    brokerFees
    policyFees
    otherFees
    taxes
    total
    intervalType
    estimatedCommission
  }
  quoteNumber
  state
  type
}
    `;
export const AccountBusinessPolicyFieldsFragmentDoc = gql`
    fragment AccountBusinessPolicyFields on Account {
  businessPolicies {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;
export const BusinessPolicyDetailFieldsFragmentDoc = gql`
    fragment BusinessPolicyDetailFields on BusinessPolicy {
  details {
    blanketAdditionalInsureds {
      type
      description
    }
    carrier {
      name
      address {
        line1
        line2
        city
        zone
        postalCode
      }
    }
    coverageDescriptions {
      description
      policyQuotes
      title
    }
    deductible
    exclusionDescriptions {
      description
      policyQuotes
      title
    }
    extraLimits {
      limit
      name
    }
    insured {
      name
      address {
        line1
        line2
        city
        zone
        postalCode
      }
    }
    limits {
      cyberAggregateLimit
      cyberRetentionLimit
      glAggregateLimit
      glMedicalPerOccurrenceLimit
      glMedicalPerPersonLimit
      glPerOccurrenceLimit
      glPersonalAndAdvertisingInjuryLimit
      glProductsAndCompletedOperationsLimit
      glRentedPremisesDamageLimit
      propertyBuildingLimit
      propertyContentsLimit
      umbrellaOrExcessAggregateLimit
      umbrellaOrExcessPerOccurrenceLimit
      wcPerAccidentLimit
      wcPerDiseaseEmployeeLimit
      wcPerDiseasePolicyLimit
    }
    locations {
      address {
        line1
        line2
        city
        zone
        postalCode
      }
      limits {
        cyberAggregateLimit
        cyberRetentionLimit
        glAggregateLimit
        glMedicalPerOccurrenceLimit
        glMedicalPerPersonLimit
        glPerOccurrenceLimit
        glPersonalAndAdvertisingInjuryLimit
        glProductsAndCompletedOperationsLimit
        glRentedPremisesDamageLimit
        propertyBuildingLimit
        propertyContentsLimit
        umbrellaOrExcessAggregateLimit
        umbrellaOrExcessPerOccurrenceLimit
        wcPerAccidentLimit
        wcPerDiseaseEmployeeLimit
        wcPerDiseasePolicyLimit
      }
    }
    namedAdditionalInsureds {
      name
      address {
        line1
        line2
        city
        zone
        postalCode
      }
    }
    policyNumber
    summary
  }
}
    `;
export const AccountBusinessPolicyDetailFieldsFragmentDoc = gql`
    fragment AccountBusinessPolicyDetailFields on Account {
  businessPolicies {
    ...BusinessPolicyDetailFields
  }
}
    ${BusinessPolicyDetailFieldsFragmentDoc}`;
export const CertificateOfLiabilityInsuranceFieldsFragmentDoc = gql`
    fragment CertificateOfLiabilityInsuranceFields on CertificateOfLiabilityInsurance {
  id
  certificateNumber
  holder {
    name
    address {
      line1
      city
      zone
      postalCode
    }
  }
  viewUrl
  downloadUrl
  createdAt
}
    `;
export const AccountCertificateOfLiabilityInsuranceFieldsFragmentDoc = gql`
    fragment AccountCertificateOfLiabilityInsuranceFields on Account {
  certificatesOfLiabilityInsurance {
    ...CertificateOfLiabilityInsuranceFields
  }
}
    ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}`;
export const ServiceRequestFieldsFragmentDoc = gql`
    fragment ServiceRequestFields on ServiceRequest {
  id
  type
  state
  details
  addAdditionalInsured {
    address {
      line1
    }
    name
    relationship
  }
  cancelPolicy {
    policyId
    reason
  }
  createCertificate {
    name
    address {
      line1
    }
    additionalInsured
    additionalInsuredRelationship
    additionalInsuredRelationshipDescription
  }
  documentRequest {
    type
  }
  question {
    policyId
    question
    type
  }
  closedAt
  createdAt
  updatedAt
}
    `;
export const AccountServiceRequestFieldsFragmentDoc = gql`
    fragment AccountServiceRequestFields on Account {
  serviceRequests {
    ...ServiceRequestFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;
export const AccountUserSignInFieldsFragmentDoc = gql`
    fragment AccountUserSignInFields on AccountUserSignInResponse {
  accountUser {
    id
    email
    name
  }
}
    `;
export const FileFieldsFragmentDoc = gql`
    fragment FileFields on File {
  createdAt
  id
  mimeType
  name
  notes
  type
  url
}
    `;
export const BusinessPolicyFileFieldsFragmentDoc = gql`
    fragment BusinessPolicyFileFields on BusinessPolicy {
  files {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const CreateCertificateOptionsFieldsFragmentDoc = gql`
    fragment CreateCertificateOptionsFields on CreateCertificateOptions {
  allowedBlanketAdditionalInsureds {
    id
    type
    description
    policy {
      id
      type
      carrier {
        name
      }
    }
  }
  allowedNamedAdditionalInsureds {
    id
    name
    address {
      line1
      city
      zone
      postalCode
    }
    policy {
      id
      type
      carrier {
        name
      }
    }
  }
}
    `;
export const GetAccountUserDocument = gql`
    query GetAccountUser {
  accountUser {
    ...AccountUserFields
  }
}
    ${AccountUserFieldsFragmentDoc}`;

/**
 * __useGetAccountUserQuery__
 *
 * To run a query within a React component, call `useGetAccountUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountUserQuery, GetAccountUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountUserQuery, GetAccountUserQueryVariables>(GetAccountUserDocument, options);
      }
export function useGetAccountUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountUserQuery, GetAccountUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountUserQuery, GetAccountUserQueryVariables>(GetAccountUserDocument, options);
        }
// @ts-ignore
export function useGetAccountUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountUserQuery, GetAccountUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountUserQuery, GetAccountUserQueryVariables>;
export function useGetAccountUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountUserQuery, GetAccountUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountUserQuery | undefined, GetAccountUserQueryVariables>;
export function useGetAccountUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountUserQuery, GetAccountUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountUserQuery, GetAccountUserQueryVariables>(GetAccountUserDocument, options);
        }
export type GetAccountUserQueryHookResult = ReturnType<typeof useGetAccountUserQuery>;
export type GetAccountUserLazyQueryHookResult = ReturnType<typeof useGetAccountUserLazyQuery>;
export type GetAccountUserSuspenseQueryHookResult = ReturnType<typeof useGetAccountUserSuspenseQuery>;
export type GetAccountUserQueryResult = Apollo.QueryResult<GetAccountUserQuery, GetAccountUserQueryVariables>;
export const GetAccountsDocument = gql`
    query GetAccounts {
  accounts {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
// @ts-ignore
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountsQuery | undefined, GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export const GetAccountDocument = gql`
    query GetAccount($id: ID!) {
  account(id: $id) {
    ...AccountFields
    ...AccountAgencyFields
    ...AccountBusinessPolicyFields
    ...AccountBusinessPolicyDetailFields
    ...AccountCertificateOfLiabilityInsuranceFields
    ...AccountServiceRequestFields
  }
}
    ${AccountFieldsFragmentDoc}
${AccountAgencyFieldsFragmentDoc}
${AccountBusinessPolicyFieldsFragmentDoc}
${AccountBusinessPolicyDetailFieldsFragmentDoc}
${AccountCertificateOfLiabilityInsuranceFieldsFragmentDoc}
${AccountServiceRequestFieldsFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables> & ({ variables: GetAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
// @ts-ignore
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountQuery, GetAccountQueryVariables>;
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountQuery | undefined, GetAccountQueryVariables>;
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!) {
  accountUserSignIn(email: $email) {
    ...AccountUserSignInFields
  }
}
    ${AccountUserSignInFieldsFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignInCompleteDocument = gql`
    mutation SignInComplete($email: String!, $code: String!) {
  accountUserSignIn(email: $email, code: $code) {
    ...AccountUserSignInFields
  }
}
    ${AccountUserSignInFieldsFragmentDoc}`;
export type SignInCompleteMutationFn = Apollo.MutationFunction<SignInCompleteMutation, SignInCompleteMutationVariables>;

/**
 * __useSignInCompleteMutation__
 *
 * To run a mutation, you first call `useSignInCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInCompleteMutation, { data, loading, error }] = useSignInCompleteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSignInCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SignInCompleteMutation, SignInCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInCompleteMutation, SignInCompleteMutationVariables>(SignInCompleteDocument, options);
      }
export type SignInCompleteMutationHookResult = ReturnType<typeof useSignInCompleteMutation>;
export type SignInCompleteMutationResult = Apollo.MutationResult<SignInCompleteMutation>;
export type SignInCompleteMutationOptions = Apollo.BaseMutationOptions<SignInCompleteMutation, SignInCompleteMutationVariables>;
export const SignOutDocument = gql`
    mutation SignOut {
  accountUserSignOut
}
    `;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
      }
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<SignOutMutation, SignOutMutationVariables>;
export const GetBusinessPoliciesDocument = gql`
    query GetBusinessPolicies {
  businessPolicies {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;

/**
 * __useGetBusinessPoliciesQuery__
 *
 * To run a query within a React component, call `useGetBusinessPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessPoliciesQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(GetBusinessPoliciesDocument, options);
      }
export function useGetBusinessPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(GetBusinessPoliciesDocument, options);
        }
// @ts-ignore
export function useGetBusinessPoliciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>;
export function useGetBusinessPoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessPoliciesQuery | undefined, GetBusinessPoliciesQueryVariables>;
export function useGetBusinessPoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(GetBusinessPoliciesDocument, options);
        }
export type GetBusinessPoliciesQueryHookResult = ReturnType<typeof useGetBusinessPoliciesQuery>;
export type GetBusinessPoliciesLazyQueryHookResult = ReturnType<typeof useGetBusinessPoliciesLazyQuery>;
export type GetBusinessPoliciesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessPoliciesSuspenseQuery>;
export type GetBusinessPoliciesQueryResult = Apollo.QueryResult<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>;
export const GetBusinessPolicyDocument = gql`
    query GetBusinessPolicy($id: ID!) {
  businessPolicy(id: $id) {
    ...BusinessPolicyFields
    ...BusinessPolicyDetailFields
    ...BusinessPolicyFileFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}
${BusinessPolicyDetailFieldsFragmentDoc}
${BusinessPolicyFileFieldsFragmentDoc}`;

/**
 * __useGetBusinessPolicyQuery__
 *
 * To run a query within a React component, call `useGetBusinessPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessPolicyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBusinessPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables> & ({ variables: GetBusinessPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(GetBusinessPolicyDocument, options);
      }
export function useGetBusinessPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(GetBusinessPolicyDocument, options);
        }
// @ts-ignore
export function useGetBusinessPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>;
export function useGetBusinessPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessPolicyQuery | undefined, GetBusinessPolicyQueryVariables>;
export function useGetBusinessPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(GetBusinessPolicyDocument, options);
        }
export type GetBusinessPolicyQueryHookResult = ReturnType<typeof useGetBusinessPolicyQuery>;
export type GetBusinessPolicyLazyQueryHookResult = ReturnType<typeof useGetBusinessPolicyLazyQuery>;
export type GetBusinessPolicySuspenseQueryHookResult = ReturnType<typeof useGetBusinessPolicySuspenseQuery>;
export type GetBusinessPolicyQueryResult = Apollo.QueryResult<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>;
export const GetCertificateDocument = gql`
    query GetCertificate($id: ID!) {
  certificate(id: $id) {
    ...CertificateOfLiabilityInsuranceFields
  }
}
    ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}`;

/**
 * __useGetCertificateQuery__
 *
 * To run a query within a React component, call `useGetCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCertificateQuery(baseOptions: Apollo.QueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables> & ({ variables: GetCertificateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertificateQuery, GetCertificateQueryVariables>(GetCertificateDocument, options);
      }
export function useGetCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertificateQuery, GetCertificateQueryVariables>(GetCertificateDocument, options);
        }
// @ts-ignore
export function useGetCertificateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>): Apollo.UseSuspenseQueryResult<GetCertificateQuery, GetCertificateQueryVariables>;
export function useGetCertificateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>): Apollo.UseSuspenseQueryResult<GetCertificateQuery | undefined, GetCertificateQueryVariables>;
export function useGetCertificateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCertificateQuery, GetCertificateQueryVariables>(GetCertificateDocument, options);
        }
export type GetCertificateQueryHookResult = ReturnType<typeof useGetCertificateQuery>;
export type GetCertificateLazyQueryHookResult = ReturnType<typeof useGetCertificateLazyQuery>;
export type GetCertificateSuspenseQueryHookResult = ReturnType<typeof useGetCertificateSuspenseQuery>;
export type GetCertificateQueryResult = Apollo.QueryResult<GetCertificateQuery, GetCertificateQueryVariables>;
export const GetCreateCertificateOptionsDocument = gql`
    query GetCreateCertificateOptions($accountId: ID!) {
  createCertificateOptions(accountId: $accountId) {
    ...CreateCertificateOptionsFields
  }
}
    ${CreateCertificateOptionsFieldsFragmentDoc}`;

/**
 * __useGetCreateCertificateOptionsQuery__
 *
 * To run a query within a React component, call `useGetCreateCertificateOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateCertificateOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateCertificateOptionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetCreateCertificateOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables> & ({ variables: GetCreateCertificateOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>(GetCreateCertificateOptionsDocument, options);
      }
export function useGetCreateCertificateOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>(GetCreateCertificateOptionsDocument, options);
        }
// @ts-ignore
export function useGetCreateCertificateOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>;
export function useGetCreateCertificateOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreateCertificateOptionsQuery | undefined, GetCreateCertificateOptionsQueryVariables>;
export function useGetCreateCertificateOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>(GetCreateCertificateOptionsDocument, options);
        }
export type GetCreateCertificateOptionsQueryHookResult = ReturnType<typeof useGetCreateCertificateOptionsQuery>;
export type GetCreateCertificateOptionsLazyQueryHookResult = ReturnType<typeof useGetCreateCertificateOptionsLazyQuery>;
export type GetCreateCertificateOptionsSuspenseQueryHookResult = ReturnType<typeof useGetCreateCertificateOptionsSuspenseQuery>;
export type GetCreateCertificateOptionsQueryResult = Apollo.QueryResult<GetCreateCertificateOptionsQuery, GetCreateCertificateOptionsQueryVariables>;
export const ClientCreateCertificateDocument = gql`
    mutation ClientCreateCertificate($input: ClientCreateCertificateInput!, $accountId: ID!) {
  clientCreateCertificate(input: $input, accountId: $accountId) {
    code
    certificate {
      ...CertificateOfLiabilityInsuranceFields
    }
    serviceRequest {
      ...ServiceRequestFields
    }
  }
}
    ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}
${ServiceRequestFieldsFragmentDoc}`;
export type ClientCreateCertificateMutationFn = Apollo.MutationFunction<ClientCreateCertificateMutation, ClientCreateCertificateMutationVariables>;

/**
 * __useClientCreateCertificateMutation__
 *
 * To run a mutation, you first call `useClientCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientCreateCertificateMutation, { data, loading, error }] = useClientCreateCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useClientCreateCertificateMutation(baseOptions?: Apollo.MutationHookOptions<ClientCreateCertificateMutation, ClientCreateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientCreateCertificateMutation, ClientCreateCertificateMutationVariables>(ClientCreateCertificateDocument, options);
      }
export type ClientCreateCertificateMutationHookResult = ReturnType<typeof useClientCreateCertificateMutation>;
export type ClientCreateCertificateMutationResult = Apollo.MutationResult<ClientCreateCertificateMutation>;
export type ClientCreateCertificateMutationOptions = Apollo.BaseMutationOptions<ClientCreateCertificateMutation, ClientCreateCertificateMutationVariables>;
export const GetServiceRequestDocument = gql`
    query GetServiceRequest($id: ID!) {
  serviceRequest(id: $id) {
    ...ServiceRequestFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;

/**
 * __useGetServiceRequestQuery__
 *
 * To run a query within a React component, call `useGetServiceRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceRequestQuery(baseOptions: Apollo.QueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables> & ({ variables: GetServiceRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(GetServiceRequestDocument, options);
      }
export function useGetServiceRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(GetServiceRequestDocument, options);
        }
// @ts-ignore
export function useGetServiceRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRequestQuery, GetServiceRequestQueryVariables>;
export function useGetServiceRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRequestQuery | undefined, GetServiceRequestQueryVariables>;
export function useGetServiceRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(GetServiceRequestDocument, options);
        }
export type GetServiceRequestQueryHookResult = ReturnType<typeof useGetServiceRequestQuery>;
export type GetServiceRequestLazyQueryHookResult = ReturnType<typeof useGetServiceRequestLazyQuery>;
export type GetServiceRequestSuspenseQueryHookResult = ReturnType<typeof useGetServiceRequestSuspenseQuery>;
export type GetServiceRequestQueryResult = Apollo.QueryResult<GetServiceRequestQuery, GetServiceRequestQueryVariables>;
export const CreateServiceRequestDocument = gql`
    mutation CreateServiceRequest($input: CreateServiceRequestInput!) {
  createServiceRequest(input: $input) {
    ...ServiceRequestFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;
export type CreateServiceRequestMutationFn = Apollo.MutationFunction<CreateServiceRequestMutation, CreateServiceRequestMutationVariables>;

/**
 * __useCreateServiceRequestMutation__
 *
 * To run a mutation, you first call `useCreateServiceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceRequestMutation, { data, loading, error }] = useCreateServiceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceRequestMutation, CreateServiceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceRequestMutation, CreateServiceRequestMutationVariables>(CreateServiceRequestDocument, options);
      }
export type CreateServiceRequestMutationHookResult = ReturnType<typeof useCreateServiceRequestMutation>;
export type CreateServiceRequestMutationResult = Apollo.MutationResult<CreateServiceRequestMutation>;
export type CreateServiceRequestMutationOptions = Apollo.BaseMutationOptions<CreateServiceRequestMutation, CreateServiceRequestMutationVariables>;